// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2300f2c3%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%2332325d%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ff8d72%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ff8d72%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23ffffff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23ffffff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml %21default;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%2834, 42, 66, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ffffff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ffffff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27><path fill=%27#ffffff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27><circle r=%273%27 fill=%27#ffffff%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/bg.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/asc.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/desc.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBfAAAAC8AAAAYGNtYXAXVtKNAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZgYydxIAAAF4AAAFNGhlYWQUJ7cIAAAGrAAAADZoaGVhB20DzAAABuQAAAAkaG10eCIABhQAAAcIAAAALGxvY2ED4AU6AAAHNAAAABhtYXhwAA8AjAAAB0wAAAAgbmFtZXsr690AAAdsAAABhnBvc3QAAwAAAAAI9AAAACAAAwPAAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADpBgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6Qb//f//AAAAAAAg6QD//f//AAH/4xcEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAWIAjQKeAskAEwAAJSc3NjQnJiIHAQYUFwEWMjc2NCcCnuLiDQ0MJAz/AA0NAQAMJAwNDcni4gwjDQwM/wANIwz/AA0NDCMNAAAAAQFiAI0CngLJABMAACUBNjQnASYiBwYUHwEHBhQXFjI3AZ4BAA0N/wAMJAwNDeLiDQ0MJAyNAQAMIw0BAAwMDSMM4uINIwwNDQAAAAIA4gC3Ax4CngATACcAACUnNzY0JyYiDwEGFB8BFjI3NjQnISc3NjQnJiIPAQYUHwEWMjc2NCcB87e3DQ0MIw3VDQ3VDSMMDQ0BK7e3DQ0MJAzVDQ3VDCQMDQ3zuLcMJAwNDdUNIwzWDAwNIwy4twwkDA0N1Q0jDNYMDA0jDAAAAgDiALcDHgKeABMAJwAAJTc2NC8BJiIHBhQfAQcGFBcWMjchNzY0LwEmIgcGFB8BBwYUFxYyNwJJ1Q0N1Q0jDA0Nt7cNDQwjDf7V1Q0N1QwkDA0Nt7cNDQwkDLfWDCMN1Q0NDCQMt7gMIw0MDNYMIw3VDQ0MJAy3uAwjDQwMAAADAFUAAAOrA1UAMwBoAHcAABMiBgcOAQcOAQcOARURFBYXHgEXHgEXHgEzITI2Nz4BNz4BNz4BNRE0JicuAScuAScuASMFITIWFx4BFx4BFx4BFREUBgcOAQcOAQcOASMhIiYnLgEnLgEnLgE1ETQ2Nz4BNz4BNz4BMxMhMjY1NCYjISIGFRQWM9UNGAwLFQkJDgUFBQUFBQ4JCRULDBgNAlYNGAwLFQkJDgUFBQUFBQ4JCRULDBgN/aoCVgQIBAQHAwMFAQIBAQIBBQMDBwQECAT9qgQIBAQHAwMFAQIBAQIBBQMDBwQECASAAVYRGRkR/qoRGRkRA1UFBAUOCQkVDAsZDf2rDRkLDBUJCA4FBQUFBQUOCQgVDAsZDQJVDRkLDBUJCQ4FBAVVAgECBQMCBwQECAX9qwQJAwQHAwMFAQICAgIBBQMDBwQDCQQCVQUIBAQHAgMFAgEC/oAZEhEZGRESGQAAAAADAFUAAAOrA1UAMwBoAIkAABMiBgcOAQcOAQcOARURFBYXHgEXHgEXHgEzITI2Nz4BNz4BNz4BNRE0JicuAScuAScuASMFITIWFx4BFx4BFx4BFREUBgcOAQcOAQcOASMhIiYnLgEnLgEnLgE1ETQ2Nz4BNz4BNz4BMxMzFRQWMzI2PQEzMjY1NCYrATU0JiMiBh0BIyIGFRQWM9UNGAwLFQkJDgUFBQUFBQ4JCRULDBgNAlYNGAwLFQkJDgUFBQUFBQ4JCRULDBgN/aoCVgQIBAQHAwMFAQIBAQIBBQMDBwQECAT9qgQIBAQHAwMFAQIBAQIBBQMDBwQECASAgBkSEhmAERkZEYAZEhIZgBEZGREDVQUEBQ4JCRUMCxkN/asNGQsMFQkIDgUFBQUFBQ4JCBUMCxkNAlUNGQsMFQkJDgUEBVUCAQIFAwIHBAQIBf2rBAkDBAcDAwUBAgICAgEFAwMHBAMJBAJVBQgEBAcCAwUCAQL+gIASGRkSgBkSERmAEhkZEoAZERIZAAABAOIAjQMeAskAIAAAExcHBhQXFjI/ARcWMjc2NC8BNzY0JyYiDwEnJiIHBhQX4uLiDQ0MJAzi4gwkDA0N4uINDQwkDOLiDCQMDQ0CjeLiDSMMDQ3h4Q0NDCMN4uIMIw0MDOLiDAwNIwwAAAABAAAAAQAAa5n0y18PPPUACwQAAAAAANivOVsAAAAA2K85WwAAAAADqwNVAAAACAACAAAAAAAAAAEAAAPA/8AAAAQAAAAAAAOrAAEAAAAAAAAAAAAAAAAAAAALBAAAAAAAAAAAAAAAAgAAAAQAAWIEAAFiBAAA4gQAAOIEAABVBAAAVQQAAOIAAAAAAAoAFAAeAEQAagCqAOoBngJkApoAAQAAAAsAigADAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAA4ArgABAAAAAAABAAcAAAABAAAAAAACAAcAYAABAAAAAAADAAcANgABAAAAAAAEAAcAdQABAAAAAAAFAAsAFQABAAAAAAAGAAcASwABAAAAAAAKABoAigADAAEECQABAA4ABwADAAEECQACAA4AZwADAAEECQADAA4APQADAAEECQAEAA4AfAADAAEECQAFABYAIAADAAEECQAGAA4AUgADAAEECQAKADQApGZjaWNvbnMAZgBjAGkAYwBvAG4Ac1ZlcnNpb24gMS4wAFYAZQByAHMAaQBvAG4AIAAxAC4AMGZjaWNvbnMAZgBjAGkAYwBvAG4Ac2ZjaWNvbnMAZgBjAGkAYwBvAG4Ac1JlZ3VsYXIAUgBlAGcAdQBsAGEAcmZjaWNvbnMAZgBjAGkAYwBvAG4Ac0ZvbnQgZ2VuZXJhdGVkIGJ5IEljb01vb24uAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/darken-night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*     brand Colors              */
/* navbar color */
.input-group .input-group-prepend .input-group-text {
  padding: 8px 0 10px 18px !important;
}

.input-group .input-group-prepend .input-group-text i {
  color: #e59b12;
}

:root {
  --blue: #5e72e4;
  --indigo: #5603ad;
  --purple: #8965e0;
  --pink: #f3a4b5;
  --red: #f5365c;
  --orange: #fb6340;
  --yellow: #ffd600;
  --green: #2dce89;
  --teal: #11cdef;
  --cyan: #2bffc6;
  --white: #ffffff;
  --gray: #6c757d;
  --gray-dark: #32325d;
  --light: #ced4da;
  --lighter: #e9ecef;
  --primary: #e14eca;
  --secondary: #f4f5f7;
  --success: #00f2c3;
  --info: #1d8cf8;
  --warning: #ff8d72;
  --danger: #fd5d93;
  --light: #adb5bd;
  --dark: #212529;
  --default: #344675;
  --white: #ffffff;
  --neutral: #ffffff;
  --darker: black;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(34, 42, 66, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #525f7f;
  text-align: left;
  background-color: #1e1e2f;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #e14eca;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #c221a9;
  text-decoration: none;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.2;
  color: #32325d;
}

h1, .h1 {
  font-size: 2.0624999938rem;
}

h2, .h2 {
  font-size: 1.687499975rem;
}

h3, .h3 {
  font-size: 1.437499875rem;
}

h4, .h4 {
  font-size: 1.0624999875rem;
}

h5, .h5 {
  font-size: 0.812499975rem;
}

h6, .h6 {
  font-size: 0.74999995rem;
}

.lead {
  font-size: 0.78125rem;
  font-weight: 300;
}

.display-1 {
  font-size: 3.3rem;
  font-weight: 600;
  line-height: 1.2;
}

.display-2 {
  font-size: 2.75rem;
  font-weight: 600;
  line-height: 1.2;
}

.display-3 {
  font-size: 2.1875rem;
  font-weight: 600;
  line-height: 1.2;
}

.display-4 {
  font-size: 1.6275rem;
  font-weight: 600;
  line-height: 1.2;
}

hr {
  margin-top: 2rem;
  margin-bottom: 2rem;
  border: 0;
  border-top: 0.0625rem solid rgba(34, 42, 66, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.9625rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #1e1e2f;
  border: 0.0625rem solid #e3e3e3;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(34, 42, 66, 0.075);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #f3a4b5;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #ffffff;
  background-color: #212529;
  border-radius: 0.2857rem;
  box-shadow: inset 0 -0.1rem 0 rgba(34, 42, 66, 0.25);
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 600;
  box-shadow: none;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #525f7f;
  background-color: transparent;
}
.table th,
.table td {
  padding: 1rem;
  vertical-align: top;
  border-top: 0.0625rem solid #e3e3e3;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 0.125rem solid #e3e3e3;
}
.table tbody + tbody {
  border-top: 0.125rem solid #e3e3e3;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 0.0625rem solid #e3e3e3;
}
.table-bordered th,
.table-bordered td {
  border: 0.0625rem solid #e3e3e3;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 0.125rem;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(34, 42, 66, 0.05);
}

.table-hover tbody tr:hover {
  color: #525f7f;
  background-color: rgba(34, 42, 66, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #f7cdf0;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #efa3e3;
}

.table-hover .table-primary:hover {
  background-color: #f3b7e9;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #f3b7e9;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #fcfcfd;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #f9fafb;
}

.table-hover .table-secondary:hover {
  background-color: #ededf3;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #ededf3;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #b8fbee;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #7af8e0;
}

.table-hover .table-success:hover {
  background-color: #a0fae8;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #a0fae8;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #c0dffd;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #89c3fb;
}

.table-hover .table-info:hover {
  background-color: #a7d2fc;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #a7d2fc;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffdfd8;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #ffc4b6;
}

.table-hover .table-warning:hover {
  background-color: #ffcabf;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #ffcabf;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #fed2e1;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #feabc7;
}

.table-hover .table-danger:hover {
  background-color: #fdb9d0;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #fdb9d0;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #e8eaed;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #d4d9dd;
}

.table-hover .table-light:hover {
  background-color: #dadde2;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #dadde2;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c1c2c3;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #8c8e90;
}

.table-hover .table-dark:hover {
  background-color: #b4b5b6;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b4b5b6;
}

.table-default,
.table-default > th,
.table-default > td {
  background-color: #c6cbd8;
}
.table-default th,
.table-default td,
.table-default thead th,
.table-default tbody + tbody {
  border-color: #959fb7;
}

.table-hover .table-default:hover {
  background-color: #b7bdce;
}
.table-hover .table-default:hover > td,
.table-hover .table-default:hover > th {
  background-color: #b7bdce;
}

.table-white,
.table-white > th,
.table-white > td {
  background-color: white;
}
.table-white th,
.table-white td,
.table-white thead th,
.table-white tbody + tbody {
  border-color: white;
}

.table-hover .table-white:hover {
  background-color: #f2f2f2;
}
.table-hover .table-white:hover > td,
.table-hover .table-white:hover > th {
  background-color: #f2f2f2;
}

.table-neutral,
.table-neutral > th,
.table-neutral > td {
  background-color: white;
}
.table-neutral th,
.table-neutral td,
.table-neutral thead th,
.table-neutral tbody + tbody {
  border-color: white;
}

.table-hover .table-neutral:hover {
  background-color: #f2f2f2;
}
.table-hover .table-neutral:hover > td,
.table-hover .table-neutral:hover > th {
  background-color: #f2f2f2;
}

.table-darker,
.table-darker > th,
.table-darker > td {
  background-color: #b8b8b8;
}
.table-darker th,
.table-darker td,
.table-darker thead th,
.table-darker tbody + tbody {
  border-color: #7a7a7a;
}

.table-hover .table-darker:hover {
  background-color: #ababab;
}
.table-hover .table-darker:hover > td,
.table-hover .table-darker:hover > th {
  background-color: #ababab;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(34, 42, 66, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(25, 31, 49, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(25, 31, 49, 0.075);
}

.table .thead-dark th {
  color: #1e1e2f;
  background-color: #212529;
  border-color: #32383e;
}
.table .thead-light th {
  color: #525f7f;
  background-color: #e9ecef;
  border-color: #e3e3e3;
}

.table-dark {
  color: #1e1e2f;
  background-color: #212529;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #32383e;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #1e1e2f;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(2.249999625rem + 2px);
  padding: 0.5rem 0.7rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  background-clip: padding-box;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: rgba(255, 255, 255, 0.8);
  background-color: #ffffff;
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
}
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 rgba(255, 255, 255, 0.8);
}
select.form-control:focus::-ms-value {
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.428571;
}

.col-form-label-lg {
  padding-top: calc(0.875rem + 1px);
  padding-bottom: calc(0.875rem + 1px);
  font-size: 0.875rem;
  line-height: 1.35;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem;
  line-height: 1.35;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.428571;
  color: #525f7f;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.35em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.35;
  border-radius: 0.2857rem;
}

.form-control-lg {
  height: calc(1.35em + 1.75rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.35;
  border-radius: 0.4285rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #00f2c3;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7500000025rem;
  line-height: 1.5;
  color: #ffffff;
  background-color: rgba(0, 242, 195, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #00f2c3;
  padding-right: 2.249999625rem !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.35714275em + 0.25rem) center;
  background-size: calc(0.7142855em + 0.5rem) calc(0.7142855em + 0.5rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #00f2c3;
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.25);
}

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 2.8rem !important;
  background-position: right 1.4rem center;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: 2.249999625rem;
  background-position: top calc(0.35714275em + 0.25rem) right calc(0.35714275em + 0.25rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #00f2c3;
  padding-right: calc(0.75em + 2.45rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.7rem center/8px 10px no-repeat, transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 1.7rem/calc(0.7142855em + 0.5rem) calc(0.7142855em + 0.5rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #00f2c3;
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #00f2c3;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #00f2c3;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #00f2c3;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #26ffd5;
  background-color: #26ffd5;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #00f2c3;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #00f2c3;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #00f2c3;
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #ff8d72;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7500000025rem;
  line-height: 1.5;
  color: #ffffff;
  background-color: rgba(255, 141, 114, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #ff8d72;
  padding-right: 2.249999625rem !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.35714275em + 0.25rem) center;
  background-size: calc(0.7142855em + 0.5rem) calc(0.7142855em + 0.5rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #ff8d72;
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.25);
}

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 2.8rem !important;
  background-position: right 1.4rem center;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: 2.249999625rem;
  background-position: top calc(0.35714275em + 0.25rem) right calc(0.35714275em + 0.25rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #ff8d72;
  padding-right: calc(0.75em + 2.45rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.7rem center/8px 10px no-repeat, transparent url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 1.7rem/calc(0.7142855em + 0.5rem) calc(0.7142855em + 0.5rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #ff8d72;
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #ff8d72;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #ff8d72;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #ff8d72;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #ffb6a5;
  background-color: #ffb6a5;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #ff8d72;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #ff8d72;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #ff8d72;
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
.form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 600;
  color: #525f7f;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 11px 40px;
  font-size: 0.875rem;
  line-height: 1.35em;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #525f7f;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-primary:hover {
  color: #ffffff;
  background-color: #db2dc0;
  border-color: #d725bb;
}
.btn-primary:focus, .btn-primary.focus {
  color: #ffffff;
  background-color: #db2dc0;
  border-color: #d725bb;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(230, 105, 210, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #ffffff;
  background-color: #d725bb;
  border-color: #cd23b2;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(230, 105, 210, 0.5);
}

.btn-secondary {
  color: #212529;
  background-color: #f4f5f7;
  border-color: #f4f5f7;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-secondary:hover {
  color: #212529;
  background-color: #dee1e7;
  border-color: #d6dae2;
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #212529;
  background-color: #dee1e7;
  border-color: #d6dae2;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(212, 214, 216, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #212529;
  background-color: #f4f5f7;
  border-color: #f4f5f7;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #212529;
  background-color: #d6dae2;
  border-color: #cfd3dc;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(212, 214, 216, 0.5);
}

.btn-success {
  color: #ffffff;
  background-color: #00f2c3;
  border-color: #00f2c3;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-success:hover {
  color: #ffffff;
  background-color: #00cca4;
  border-color: #00bf9a;
}
.btn-success:focus, .btn-success.focus {
  color: #ffffff;
  background-color: #00cca4;
  border-color: #00bf9a;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(38, 244, 204, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #ffffff;
  background-color: #00f2c3;
  border-color: #00f2c3;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #ffffff;
  background-color: #00bf9a;
  border-color: #00b290;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(38, 244, 204, 0.5);
}

.btn-info {
  color: #ffffff;
  background-color: #1d8cf8;
  border-color: #1d8cf8;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-info:hover {
  color: #ffffff;
  background-color: #0779e8;
  border-color: #0772db;
}
.btn-info:focus, .btn-info.focus {
  color: #ffffff;
  background-color: #0779e8;
  border-color: #0772db;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(63, 157, 249, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #ffffff;
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #ffffff;
  background-color: #0772db;
  border-color: #066ccf;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(63, 157, 249, 0.5);
}

.btn-warning {
  color: #ffffff;
  background-color: #ff8d72;
  border-color: #ff8d72;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-warning:hover {
  color: #ffffff;
  background-color: #ff6e4c;
  border-color: #ff643f;
}
.btn-warning:focus, .btn-warning.focus {
  color: #ffffff;
  background-color: #ff6e4c;
  border-color: #ff643f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 158, 135, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #ffffff;
  background-color: #ff8d72;
  border-color: #ff8d72;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #ffffff;
  background-color: #ff643f;
  border-color: #ff5932;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 158, 135, 0.5);
}

.btn-danger {
  color: #ffffff;
  background-color: #fd5d93;
  border-color: #fd5d93;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-danger:hover {
  color: #ffffff;
  background-color: #fd377a;
  border-color: #fc2b71;
}
.btn-danger:focus, .btn-danger.focus {
  color: #ffffff;
  background-color: #fd377a;
  border-color: #fc2b71;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(253, 117, 163, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #ffffff;
  background-color: #fd5d93;
  border-color: #fd5d93;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #ffffff;
  background-color: #fc2b71;
  border-color: #fc1e69;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(253, 117, 163, 0.5);
}

.btn-light {
  color: #ffffff;
  background-color: #adb5bd;
  border-color: #adb5bd;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-light:hover {
  color: #ffffff;
  background-color: #98a2ac;
  border-color: #919ca6;
}
.btn-light:focus, .btn-light.focus {
  color: #ffffff;
  background-color: #98a2ac;
  border-color: #919ca6;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(185, 192, 199, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #ffffff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #ffffff;
  background-color: #919ca6;
  border-color: #8a95a1;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(185, 192, 199, 0.5);
}

.btn-dark {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dark:hover {
  color: #ffffff;
  background-color: #101214;
  border-color: #0a0c0d;
}
.btn-dark:focus, .btn-dark.focus {
  color: #ffffff;
  background-color: #101214;
  border-color: #0a0c0d;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(66, 70, 73, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #ffffff;
  background-color: #0a0c0d;
  border-color: #050506;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(66, 70, 73, 0.5);
}

.btn-default {
  color: #ffffff;
  background-color: #344675;
  border-color: #344675;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-default:hover {
  color: #ffffff;
  background-color: #28365b;
  border-color: #243152;
}
.btn-default:focus, .btn-default.focus {
  color: #ffffff;
  background-color: #28365b;
  border-color: #243152;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(82, 98, 138, 0.5);
}
.btn-default.disabled, .btn-default:disabled {
  color: #ffffff;
  background-color: #344675;
  border-color: #344675;
}
.btn-default:not(:disabled):not(.disabled):active, .btn-default:not(:disabled):not(.disabled).active, .show > .btn-default.dropdown-toggle {
  color: #ffffff;
  background-color: #243152;
  border-color: #202c49;
}
.btn-default:not(:disabled):not(.disabled):active:focus, .btn-default:not(:disabled):not(.disabled).active:focus, .show > .btn-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82, 98, 138, 0.5);
}

.btn-white {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-white:hover {
  color: #212529;
  background-color: #ececec;
  border-color: #e6e6e6;
}
.btn-white:focus, .btn-white.focus {
  color: #212529;
  background-color: #ececec;
  border-color: #e6e6e6;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(222, 222, 223, 0.5);
}
.btn-white.disabled, .btn-white:disabled {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-white:not(:disabled):not(.disabled):active, .btn-white:not(:disabled):not(.disabled).active, .show > .btn-white.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: #dfdfdf;
}
.btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .show > .btn-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(222, 222, 223, 0.5);
}

.btn-neutral {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-neutral:hover {
  color: #212529;
  background-color: #ececec;
  border-color: #e6e6e6;
}
.btn-neutral:focus, .btn-neutral.focus {
  color: #212529;
  background-color: #ececec;
  border-color: #e6e6e6;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(222, 222, 223, 0.5);
}
.btn-neutral.disabled, .btn-neutral:disabled {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .show > .btn-neutral.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: #dfdfdf;
}
.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(222, 222, 223, 0.5);
}

.btn-darker {
  color: #ffffff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-darker:hover {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-darker:focus, .btn-darker.focus {
  color: #ffffff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(38, 38, 38, 0.5);
}
.btn-darker.disabled, .btn-darker:disabled {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active, .btn-darker:not(:disabled):not(.disabled).active, .show > .btn-darker.dropdown-toggle {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active:focus, .btn-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-darker.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(38, 38, 38, 0.5);
}

.btn-outline-primary {
  color: #e14eca;
  border-color: #e14eca;
}
.btn-outline-primary:hover {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(225, 78, 202, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #e14eca;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(225, 78, 202, 0.5);
}

.btn-outline-secondary {
  color: #f4f5f7;
  border-color: #f4f5f7;
}
.btn-outline-secondary:hover {
  color: #212529;
  background-color: #f4f5f7;
  border-color: #f4f5f7;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(244, 245, 247, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #f4f5f7;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #212529;
  background-color: #f4f5f7;
  border-color: #f4f5f7;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(244, 245, 247, 0.5);
}

.btn-outline-success {
  color: #00f2c3;
  border-color: #00f2c3;
}
.btn-outline-success:hover {
  color: #ffffff;
  background-color: #00f2c3;
  border-color: #00f2c3;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #00f2c3;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #ffffff;
  background-color: #00f2c3;
  border-color: #00f2c3;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.5);
}

.btn-outline-info {
  color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-outline-info:hover {
  color: #ffffff;
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(29, 140, 248, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #1d8cf8;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #ffffff;
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(29, 140, 248, 0.5);
}

.btn-outline-warning {
  color: #ff8d72;
  border-color: #ff8d72;
}
.btn-outline-warning:hover {
  color: #ffffff;
  background-color: #ff8d72;
  border-color: #ff8d72;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ff8d72;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #ffffff;
  background-color: #ff8d72;
  border-color: #ff8d72;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.5);
}

.btn-outline-danger {
  color: #fd5d93;
  border-color: #fd5d93;
}
.btn-outline-danger:hover {
  color: #ffffff;
  background-color: #fd5d93;
  border-color: #fd5d93;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(253, 93, 147, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #fd5d93;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #ffffff;
  background-color: #fd5d93;
  border-color: #fd5d93;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(253, 93, 147, 0.5);
}

.btn-outline-light {
  color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:hover {
  color: #ffffff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #adb5bd;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #ffffff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-outline-dark {
  color: #212529;
  border-color: #212529;
}
.btn-outline-dark:hover {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #212529;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-outline-default {
  color: #344675;
  border-color: #344675;
}
.btn-outline-default:hover {
  color: #ffffff;
  background-color: #344675;
  border-color: #344675;
}
.btn-outline-default:focus, .btn-outline-default.focus {
  box-shadow: 0 0 0 0 rgba(52, 70, 117, 0.5);
}
.btn-outline-default.disabled, .btn-outline-default:disabled {
  color: #344675;
  background-color: transparent;
}
.btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .show > .btn-outline-default.dropdown-toggle {
  color: #ffffff;
  background-color: #344675;
  border-color: #344675;
}
.btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(52, 70, 117, 0.5);
}

.btn-outline-white {
  color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-white:hover {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-white:focus, .btn-outline-white.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-white.disabled, .btn-outline-white:disabled {
  color: #ffffff;
  background-color: transparent;
}
.btn-outline-white:not(:disabled):not(.disabled):active, .btn-outline-white:not(:disabled):not(.disabled).active, .show > .btn-outline-white.dropdown-toggle {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-white:not(:disabled):not(.disabled):active:focus, .btn-outline-white:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-neutral {
  color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-neutral:hover {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-neutral:focus, .btn-outline-neutral.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-neutral.disabled, .btn-outline-neutral:disabled {
  color: #ffffff;
  background-color: transparent;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active, .btn-outline-neutral:not(:disabled):not(.disabled).active, .show > .btn-outline-neutral.dropdown-toggle {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active:focus, .btn-outline-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-neutral.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-darker {
  color: black;
  border-color: black;
}
.btn-outline-darker:hover {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:focus, .btn-outline-darker.focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-outline-darker.disabled, .btn-outline-darker:disabled {
  color: black;
  background-color: transparent;
}
.btn-outline-darker:not(:disabled):not(.disabled):active, .btn-outline-darker:not(:disabled):not(.disabled).active, .show > .btn-outline-darker.dropdown-toggle {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:not(:disabled):not(.disabled):active:focus, .btn-outline-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-darker.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #e14eca;
  text-decoration: none;
}
.btn-link:hover {
  color: #c221a9;
  text-decoration: none;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 15px 48px;
  font-size: 1em;
  line-height: 1.35;
  border-radius: 0.4285rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 5px 15px;
  font-size: 0.75rem;
  line-height: 1.35;
  border-radius: 0.25rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0 solid rgba(34, 42, 66, 0.15);
  border-radius: 0.1428rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #ffffff;
  text-decoration: none;
  background-color: #e14eca;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.7500000025rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 30px;
  padding-left: 30px;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 11.25px;
  padding-left: 11.25px;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 36px;
  padding-left: 36px;
}

.btn-group.show .dropdown-toggle {
  box-shadow: none;
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.7rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.428571;
  color: #adb5bd;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.35em + 1.75rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.35;
  border-radius: 0.4285rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.35em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.35;
  border-radius: 0.2857rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.7rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.3125rem;
  padding-left: 3rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1.25rem;
  height: 1.28125rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #ffffff;
  border-color: #e14eca;
  background-color: #e14eca;
  box-shadow: none;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none, none;
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgba(50, 151, 211, 0.25);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
  box-shadow: none;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.03125rem;
  left: -3rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  pointer-events: none;
  content: "";
  background-color: transparent;
  border: 1px solid #cad1d7;
  box-shadow: none;
}
.custom-control-label::after {
  position: absolute;
  top: 0.03125rem;
  left: -3rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.2857rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #e14eca;
  background-color: #e14eca;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(225, 78, 202, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(225, 78, 202, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(225, 78, 202, 0.5);
}

.custom-switch {
  padding-left: 3.9375rem;
}
.custom-switch .custom-control-label::before {
  left: -3.9375rem;
  width: 2.1875rem;
  pointer-events: all;
  border-radius: 0.625rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.03125rem + 2px);
  left: calc(-3.9375rem + 2px);
  width: calc(1.25rem - 4px);
  height: calc(1.25rem - 4px);
  background-color: #cad1d7;
  border-radius: 0.625rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: transparent;
  transform: translateX(0.9375rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(225, 78, 202, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(2.249999625rem + 2px);
  padding: 0.5rem 1.7rem 0.5rem 0.7rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  vertical-align: middle;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.7rem center/8px 10px no-repeat;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 2px rgba(34, 42, 66, 0.075);
  appearance: none;
}
.custom-select:focus {
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(34, 42, 66, 0.075), 0 0 0 0 #e14eca;
}
.custom-select:focus::-ms-value {
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.7rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 rgba(255, 255, 255, 0.8);
}

.custom-select-sm {
  height: calc(1.35em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.75rem;
}

.custom-select-lg {
  height: calc(1.35em + 1.75rem + 2px);
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 1rem;
  font-size: 0.875rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(2.249999625rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(2.249999625rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgba(50, 151, 211, 0.25);
  box-shadow: none;
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(2.249999625rem + 2px);
  padding: 0.5rem 0.7rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  box-shadow: none;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: 2.249999625rem;
  padding: 0.5rem 0.7rem;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  content: "Browse";
  background-color: transparent;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #1e1e2f, none;
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #1e1e2f, none;
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #1e1e2f, none;
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #e14eca;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(34, 42, 66, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #fbe7f8;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e3e3e3;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(34, 42, 66, 0.1);
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #e14eca;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(34, 42, 66, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #fbe7f8;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e3e3e3;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(34, 42, 66, 0.1);
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0;
  margin-left: 0;
  background-color: #e14eca;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(34, 42, 66, 0.1);
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #fbe7f8;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(34, 42, 66, 0.1);
}
.custom-range::-ms-fill-lower {
  background-color: #e3e3e3;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #e3e3e3;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
.custom-file-label,
.custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 0.0625rem solid #e3e3e3;
}
.nav-tabs .nav-link {
  margin-bottom: -0.0625rem;
  background-color: transparent;
  border: 0.0625rem solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #e3e3e3;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #525f7f;
  background-color: #1e1e2f;
  border-color: #e3e3e3 #e3e3e3 #1e1e2f;
}
.nav-tabs .dropdown-menu {
  margin-top: -0.0625rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #ffffff;
  background-color: #e14eca;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 0.9375rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.4068125rem;
  padding-bottom: 0.4068125rem;
  margin-right: 0.9375rem;
  font-size: 0.99925rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 0.99925rem;
  line-height: 1;
  background-color: transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
.navbar-expand-sm > .container-fluid,
.navbar-expand-sm > .container-sm,
.navbar-expand-sm > .container-md,
.navbar-expand-sm > .container-lg,
.navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-sm > .container,
.navbar-expand-sm > .container-fluid,
.navbar-expand-sm > .container-sm,
.navbar-expand-sm > .container-md,
.navbar-expand-sm > .container-lg,
.navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
.navbar-expand-md > .container-fluid,
.navbar-expand-md > .container-sm,
.navbar-expand-md > .container-md,
.navbar-expand-md > .container-lg,
.navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-md > .container,
.navbar-expand-md > .container-fluid,
.navbar-expand-md > .container-sm,
.navbar-expand-md > .container-md,
.navbar-expand-md > .container-lg,
.navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
.navbar-expand-lg > .container-fluid,
.navbar-expand-lg > .container-sm,
.navbar-expand-lg > .container-md,
.navbar-expand-lg > .container-lg,
.navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-lg > .container,
.navbar-expand-lg > .container-fluid,
.navbar-expand-lg > .container-sm,
.navbar-expand-lg > .container-md,
.navbar-expand-lg > .container-lg,
.navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
.navbar-expand-xl > .container-fluid,
.navbar-expand-xl > .container-sm,
.navbar-expand-xl > .container-md,
.navbar-expand-xl > .container-lg,
.navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-xl > .container,
.navbar-expand-xl > .container-fluid,
.navbar-expand-xl > .container-sm,
.navbar-expand-xl > .container-md,
.navbar-expand-xl > .container-lg,
.navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 1rem;
  padding-left: 1rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(34, 42, 66, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(34, 42, 66, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(34, 42, 66, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(34, 42, 66, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(34, 42, 66, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(34, 42, 66, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(34, 42, 66, 0.5);
  border-color: transparent;
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.navbar-light .navbar-text {
  color: rgba(34, 42, 66, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(34, 42, 66, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(34, 42, 66, 0.9);
}

.navbar-dark .navbar-brand {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.95);
  border-color: transparent;
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-text a {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: rgba(255, 255, 255, 0.65);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 0.0625rem solid rgba(34, 42, 66, 0.05);
  border-radius: 0.2857rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.2857rem - 0.0625rem);
  border-top-right-radius: calc(0.2857rem - 0.0625rem);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.2857rem - 0.0625rem);
  border-bottom-left-radius: calc(0.2857rem - 0.0625rem);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.5rem;
}

.card-title {
  margin-bottom: 1.25rem;
}

.card-subtitle {
  margin-top: -0.625rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 1.25rem 1.5rem;
  margin-bottom: 0;
  background-color: #f6f9fc;
  border-bottom: 0.0625rem solid rgba(34, 42, 66, 0.05);
}
.card-header:first-child {
  border-radius: calc(0.2857rem - 0.0625rem) calc(0.2857rem - 0.0625rem) 0 0;
}

.card-footer {
  padding: 1.25rem 1.5rem;
  background-color: #f6f9fc;
  border-top: 0.0625rem solid rgba(34, 42, 66, 0.05);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.2857rem - 0.0625rem) calc(0.2857rem - 0.0625rem);
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -1.25rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.2857rem - 0.0625rem);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.2857rem - 0.0625rem);
  border-top-right-radius: calc(0.2857rem - 0.0625rem);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.2857rem - 0.0625rem);
  border-bottom-left-radius: calc(0.2857rem - 0.0625rem);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
.card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
.card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
.card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
.card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 1.25rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -0.0625rem;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #1d253b;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #ffffff;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #ffffff;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0 0.6875rem;
  margin-left: -0.0625rem;
  line-height: 1.25;
  color: #ffffff;
  background-color: transparent;
  border: 0.0625rem solid #e3e3e3;
}
.page-link:hover {
  z-index: 2;
  color: #6c757d;
  text-decoration: none;
  background-color: #e3e3e3;
  border-color: #e3e3e3;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: none;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: transparent;
  border-color: #e3e3e3;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 0.99925rem;
  line-height: 1.625rem;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.4285rem;
  border-bottom-left-radius: 0.4285rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.4285rem;
  border-bottom-right-radius: 0.4285rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.7500000025rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2857rem;
  border-bottom-left-radius: 0.2857rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2857rem;
  border-bottom-right-radius: 0.2857rem;
}

.badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.62475rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.875em;
  padding-left: 0.875em;
  border-radius: 0.875rem;
}

.badge-primary {
  color: #ffffff;
  background-color: #e14eca;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #ffffff;
  background-color: #d725bb;
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(225, 78, 202, 0.5);
}

.badge-secondary {
  color: #212529;
  background-color: #f4f5f7;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #212529;
  background-color: #d6dae2;
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(244, 245, 247, 0.5);
}

.badge-success {
  color: #ffffff;
  background-color: #00f2c3;
}
a.badge-success:hover, a.badge-success:focus {
  color: #ffffff;
  background-color: #00bf9a;
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.5);
}

.badge-info {
  color: #ffffff;
  background-color: #1d8cf8;
}
a.badge-info:hover, a.badge-info:focus {
  color: #ffffff;
  background-color: #0772db;
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(29, 140, 248, 0.5);
}

.badge-warning {
  color: #ffffff;
  background-color: #ff8d72;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #ffffff;
  background-color: #ff643f;
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.5);
}

.badge-danger {
  color: #ffffff;
  background-color: #fd5d93;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #ffffff;
  background-color: #fc2b71;
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(253, 93, 147, 0.5);
}

.badge-light {
  color: #ffffff;
  background-color: #adb5bd;
}
a.badge-light:hover, a.badge-light:focus {
  color: #ffffff;
  background-color: #919ca6;
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.badge-dark {
  color: #ffffff;
  background-color: #212529;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #ffffff;
  background-color: #0a0c0d;
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.badge-default {
  color: #ffffff;
  background-color: #344675;
}
a.badge-default:hover, a.badge-default:focus {
  color: #ffffff;
  background-color: #243152;
}
a.badge-default:focus, a.badge-default.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(52, 70, 117, 0.5);
}

.badge-white {
  color: #212529;
  background-color: #ffffff;
}
a.badge-white:hover, a.badge-white:focus {
  color: #212529;
  background-color: #e6e6e6;
}
a.badge-white:focus, a.badge-white.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.badge-neutral {
  color: #212529;
  background-color: #ffffff;
}
a.badge-neutral:hover, a.badge-neutral:focus {
  color: #212529;
  background-color: #e6e6e6;
}
a.badge-neutral:focus, a.badge-neutral.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.badge-darker {
  color: #ffffff;
  background-color: black;
}
a.badge-darker:hover, a.badge-darker:focus {
  color: #ffffff;
  background-color: black;
}
a.badge-darker:focus, a.badge-darker.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.4285rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.9rem 1.25rem;
  margin-bottom: 1rem;
  border: 0.0625rem solid transparent;
  border-radius: 0.2857rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 3.8125rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #e14eca;
  background-color: #e66ad2;
  border-color: #e66ad2;
}
.alert-primary hr {
  border-top-color: #e254cb;
}
.alert-primary .alert-link {
  color: #d725bb;
}

.alert-secondary {
  color: #f4f5f7;
  background-color: #f6f7f8;
  border-color: #f6f7f8;
}
.alert-secondary hr {
  border-top-color: #e8eaed;
}
.alert-secondary .alert-link {
  color: #d6dae2;
}

.alert-success {
  color: #00f2c3;
  background-color: #29f4cd;
  border-color: #29f4cd;
}
.alert-success hr {
  border-top-color: #11f3c7;
}
.alert-success .alert-link {
  color: #00bf9a;
}

.alert-info {
  color: #1d8cf8;
  background-color: #419ef9;
  border-color: #419ef9;
}
.alert-info hr {
  border-top-color: #2891f8;
}
.alert-info .alert-link {
  color: #0772db;
}

.alert-warning {
  color: #ff8d72;
  background-color: #ff9f89;
  border-color: #ff9f89;
}
.alert-warning hr {
  border-top-color: #ff8a70;
}
.alert-warning .alert-link {
  color: #ff643f;
}

.alert-danger {
  color: #fd5d93;
  background-color: #fd77a4;
  border-color: #fd77a4;
}
.alert-danger hr {
  border-top-color: #fd5e93;
}
.alert-danger .alert-link {
  color: #fc2b71;
}

.alert-light {
  color: #adb5bd;
  background-color: #bac1c8;
  border-color: #bac1c8;
}
.alert-light hr {
  border-top-color: #acb4bd;
}
.alert-light .alert-link {
  color: #919ca6;
}

.alert-dark {
  color: #212529;
  background-color: #45484b;
  border-color: #45484b;
}
.alert-dark hr {
  border-top-color: #393b3e;
}
.alert-dark .alert-link {
  color: #0a0c0d;
}

.alert-default {
  color: #344675;
  background-color: #54648b;
  border-color: #54648b;
}
.alert-default hr {
  border-top-color: #4a597b;
}
.alert-default .alert-link {
  color: #243152;
}

.alert-white {
  color: white;
  background-color: white;
  border-color: white;
}
.alert-white hr {
  border-top-color: #f2f2f2;
}
.alert-white .alert-link {
  color: #e6e6e6;
}

.alert-neutral {
  color: white;
  background-color: white;
  border-color: white;
}
.alert-neutral hr {
  border-top-color: #f2f2f2;
}
.alert-neutral .alert-link {
  color: #e6e6e6;
}

.alert-darker {
  color: black;
  background-color: #292929;
  border-color: #292929;
}
.alert-darker hr {
  border-top-color: #1c1c1c;
}
.alert-darker .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 0.5rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 0.5rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.65625rem;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0.875rem;
  box-shadow: 0px 0px 0px 3px rgba(0, 0, 0, 0.3);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  background-color: #e14eca;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 0.5rem 0.5rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-item-action {
  width: 100%;
  color: #525f7f;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #525f7f;
  text-decoration: none;
  background-color: #f6f9fc;
}
.list-group-item-action:active {
  color: #525f7f;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 1rem 1rem;
  background-color: #ffffff;
  border: 0.0625rem solid #e9ecef;
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #ffffff;
}
.list-group-item.active {
  z-index: 2;
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -0.0625rem;
  border-top-width: 0.0625rem;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 0.0625rem;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -0.0625rem;
  border-left-width: 0.0625rem;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 0.0625rem;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #853d89;
  background-color: #f7cdf0;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #853d89;
  background-color: #f3b7e9;
}
.list-group-item-primary.list-group-item-action.active {
  color: #ffffff;
  background-color: #853d89;
  border-color: #853d89;
}

.list-group-item-secondary {
  color: #8f94a0;
  background-color: #fcfcfd;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #8f94a0;
  background-color: #ededf3;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #ffffff;
  background-color: #8f94a0;
  border-color: #8f94a0;
}

.list-group-item-success {
  color: #109285;
  background-color: #b8fbee;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #109285;
  background-color: #a0fae8;
}
.list-group-item-success.list-group-item-action.active {
  color: #ffffff;
  background-color: #109285;
  border-color: #109285;
}

.list-group-item-info {
  color: #1f5da1;
  background-color: #c0dffd;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #1f5da1;
  background-color: #a7d2fc;
}
.list-group-item-info.list-group-item-action.active {
  color: #ffffff;
  background-color: #1f5da1;
  border-color: #1f5da1;
}

.list-group-item-warning {
  color: #955d5b;
  background-color: #ffdfd8;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #955d5b;
  background-color: #ffcabf;
}
.list-group-item-warning.list-group-item-action.active {
  color: #ffffff;
  background-color: #955d5b;
  border-color: #955d5b;
}

.list-group-item-danger {
  color: #94456c;
  background-color: #fed2e1;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #94456c;
  background-color: #fdb9d0;
}
.list-group-item-danger.list-group-item-action.active {
  color: #ffffff;
  background-color: #94456c;
  border-color: #94456c;
}

.list-group-item-light {
  color: #6a7282;
  background-color: #e8eaed;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #6a7282;
  background-color: #dadde2;
}
.list-group-item-light.list-group-item-action.active {
  color: #ffffff;
  background-color: #6a7282;
  border-color: #6a7282;
}

.list-group-item-dark {
  color: #212735;
  background-color: #c1c2c3;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #212735;
  background-color: #b4b5b6;
}
.list-group-item-dark.list-group-item-action.active {
  color: #ffffff;
  background-color: #212735;
  border-color: #212735;
}

.list-group-item-default {
  color: #2b395d;
  background-color: #c6cbd8;
}
.list-group-item-default.list-group-item-action:hover, .list-group-item-default.list-group-item-action:focus {
  color: #2b395d;
  background-color: #b7bdce;
}
.list-group-item-default.list-group-item-action.active {
  color: #ffffff;
  background-color: #2b395d;
  border-color: #2b395d;
}

.list-group-item-white {
  color: #9599a4;
  background-color: white;
}
.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {
  color: #9599a4;
  background-color: #f2f2f2;
}
.list-group-item-white.list-group-item-action.active {
  color: #ffffff;
  background-color: #9599a4;
  border-color: #9599a4;
}

.list-group-item-neutral {
  color: #9599a4;
  background-color: white;
}
.list-group-item-neutral.list-group-item-action:hover, .list-group-item-neutral.list-group-item-action:focus {
  color: #9599a4;
  background-color: #f2f2f2;
}
.list-group-item-neutral.list-group-item-action.active {
  color: #ffffff;
  background-color: #9599a4;
  border-color: #9599a4;
}

.list-group-item-darker {
  color: #101420;
  background-color: #b8b8b8;
}
.list-group-item-darker.list-group-item-action:hover, .list-group-item-darker.list-group-item-action:focus {
  color: #101420;
  background-color: #ababab;
}
.list-group-item-darker.list-group-item-action.active {
  color: #ffffff;
  background-color: #101420;
  border-color: #101420;
}

.close {
  float: right;
  font-size: 1.3125rem;
  font-weight: 600;
  line-height: 1;
  color: rgba(0, 0, 0, 0.6);
  text-shadow: none;
  opacity: 0.5;
}
.close:hover {
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(34, 42, 66, 0.2);
  border-radius: 0.2857rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.5);
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #222a42;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.16;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: calc(0.2857rem - 1px);
  border-top-right-radius: calc(0.2857rem - 1px);
}
.modal-header .close {
  padding: 24px 24px 0 24px;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.1;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 24px 24px 16px 24px;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 24px 16px 24px-0.25rem;
  border-top: 1px solid #e9ecef;
  border-bottom-right-radius: calc(0.2857rem - 1px);
  border-bottom-left-radius: calc(0.2857rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-content {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  }
  .modal-sm {
    max-width: 380px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
.modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.7500000025rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #ffffff;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #ffffff;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #ffffff;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #ffffff;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #222a42;
  text-align: center;
  background-color: #ffffff;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.7500000025rem;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(34, 42, 66, 0.05);
  border-radius: 0.4285rem;
  box-shadow: 0px 0.5rem 2rem 0px rgba(34, 42, 66, 0.2);
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1.5rem;
  height: 0.75rem;
  margin: 0 0.4285rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.75rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.75rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: transparent;
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: #ffffff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.75rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4285rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: transparent;
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: #ffffff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.75rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.75rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: transparent;
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: #ffffff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1.5rem;
  margin-left: -0.75rem;
  content: "";
  border-bottom: 1px solid #ffffff;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.75rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4285rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: transparent;
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: #ffffff;
}

.popover-header {
  padding: 0.75rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #32325d;
  background-color: #ffffff;
  border-bottom: 1px solid #f2f2f2;
  border-top-left-radius: calc(0.4285rem - 1px);
  border-top-right-radius: calc(0.4285rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.75rem 0.75rem;
  color: #525f7f;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #ffffff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
.carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ffffff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #ffffff;
  text-align: center;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #e14eca !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #d725bb !important;
}

.bg-secondary {
  background-color: #f4f5f7 !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #d6dae2 !important;
}

.bg-success {
  background-color: #00f2c3 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #00bf9a !important;
}

.bg-info {
  background-color: #1d8cf8 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #0772db !important;
}

.bg-warning {
  background-color: #ff8d72 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #ff643f !important;
}

.bg-danger {
  background-color: #fd5d93 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #fc2b71 !important;
}

.bg-light {
  background-color: #adb5bd !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #919ca6 !important;
}

.bg-dark {
  background-color: #212529 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #0a0c0d !important;
}

.bg-default {
  background-color: #344675 !important;
}

a.bg-default:hover, a.bg-default:focus,
button.bg-default:hover,
button.bg-default:focus {
  background-color: #243152 !important;
}

.bg-white {
  background-color: #ffffff !important;
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: #e6e6e6 !important;
}

.bg-neutral {
  background-color: #ffffff !important;
}

a.bg-neutral:hover, a.bg-neutral:focus,
button.bg-neutral:hover,
button.bg-neutral:focus {
  background-color: #e6e6e6 !important;
}

.bg-darker {
  background-color: black !important;
}

a.bg-darker:hover, a.bg-darker:focus,
button.bg-darker:hover,
button.bg-darker:focus {
  background-color: black !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 0.0625rem solid #e9ecef !important;
}

.border-top {
  border-top: 0.0625rem solid #e9ecef !important;
}

.border-right {
  border-right: 0.0625rem solid #e9ecef !important;
}

.border-bottom {
  border-bottom: 0.0625rem solid #e9ecef !important;
}

.border-left {
  border-left: 0.0625rem solid #e9ecef !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #e14eca !important;
}

.border-secondary {
  border-color: #f4f5f7 !important;
}

.border-success {
  border-color: #00f2c3 !important;
}

.border-info {
  border-color: #1d8cf8 !important;
}

.border-warning {
  border-color: #ff8d72 !important;
}

.border-danger {
  border-color: #fd5d93 !important;
}

.border-light {
  border-color: #adb5bd !important;
}

.border-dark {
  border-color: #212529 !important;
}

.border-default {
  border-color: #344675 !important;
}

.border-white {
  border-color: #ffffff !important;
}

.border-neutral {
  border-color: #ffffff !important;
}

.border-darker {
  border-color: black !important;
}

.border-white {
  border-color: #ffffff !important;
}

.rounded-sm {
  border-radius: 0.2857rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.4285rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(34, 42, 66, 0.075) !important;
}

.shadow {
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(34, 42, 66, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.m-sm {
  margin: 2rem !important;
}

.mt-sm,
.my-sm {
  margin-top: 2rem !important;
}

.mr-sm,
.mx-sm {
  margin-right: 2rem !important;
}

.mb-sm,
.my-sm {
  margin-bottom: 2rem !important;
}

.ml-sm,
.mx-sm {
  margin-left: 2rem !important;
}

.m-md {
  margin: 4rem !important;
}

.mt-md,
.my-md {
  margin-top: 4rem !important;
}

.mr-md,
.mx-md {
  margin-right: 4rem !important;
}

.mb-md,
.my-md {
  margin-bottom: 4rem !important;
}

.ml-md,
.mx-md {
  margin-left: 4rem !important;
}

.m-lg {
  margin: 6rem !important;
}

.mt-lg,
.my-lg {
  margin-top: 6rem !important;
}

.mr-lg,
.mx-lg {
  margin-right: 6rem !important;
}

.mb-lg,
.my-lg {
  margin-bottom: 6rem !important;
}

.ml-lg,
.mx-lg {
  margin-left: 6rem !important;
}

.m-xl {
  margin: 8rem !important;
}

.mt-xl,
.my-xl {
  margin-top: 8rem !important;
}

.mr-xl,
.mx-xl {
  margin-right: 8rem !important;
}

.mb-xl,
.my-xl {
  margin-bottom: 8rem !important;
}

.ml-xl,
.mx-xl {
  margin-left: 8rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.p-sm {
  padding: 2rem !important;
}

.pt-sm,
.py-sm {
  padding-top: 2rem !important;
}

.pr-sm,
.px-sm {
  padding-right: 2rem !important;
}

.pb-sm,
.py-sm {
  padding-bottom: 2rem !important;
}

.pl-sm,
.px-sm {
  padding-left: 2rem !important;
}

.p-md {
  padding: 4rem !important;
}

.pt-md,
.py-md {
  padding-top: 4rem !important;
}

.pr-md,
.px-md {
  padding-right: 4rem !important;
}

.pb-md,
.py-md {
  padding-bottom: 4rem !important;
}

.pl-md,
.px-md {
  padding-left: 4rem !important;
}

.p-lg {
  padding: 6rem !important;
}

.pt-lg,
.py-lg {
  padding-top: 6rem !important;
}

.pr-lg,
.px-lg {
  padding-right: 6rem !important;
}

.pb-lg,
.py-lg {
  padding-bottom: 6rem !important;
}

.pl-lg,
.px-lg {
  padding-left: 6rem !important;
}

.p-xl {
  padding: 8rem !important;
}

.pt-xl,
.py-xl {
  padding-top: 8rem !important;
}

.pr-xl,
.px-xl {
  padding-right: 8rem !important;
}

.pb-xl,
.py-xl {
  padding-bottom: 8rem !important;
}

.pl-xl,
.px-xl {
  padding-left: 8rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-nsm {
  margin: -2rem !important;
}

.mt-nsm,
.my-nsm {
  margin-top: -2rem !important;
}

.mr-nsm,
.mx-nsm {
  margin-right: -2rem !important;
}

.mb-nsm,
.my-nsm {
  margin-bottom: -2rem !important;
}

.ml-nsm,
.mx-nsm {
  margin-left: -2rem !important;
}

.m-nmd {
  margin: -4rem !important;
}

.mt-nmd,
.my-nmd {
  margin-top: -4rem !important;
}

.mr-nmd,
.mx-nmd {
  margin-right: -4rem !important;
}

.mb-nmd,
.my-nmd {
  margin-bottom: -4rem !important;
}

.ml-nmd,
.mx-nmd {
  margin-left: -4rem !important;
}

.m-nlg {
  margin: -6rem !important;
}

.mt-nlg,
.my-nlg {
  margin-top: -6rem !important;
}

.mr-nlg,
.mx-nlg {
  margin-right: -6rem !important;
}

.mb-nlg,
.my-nlg {
  margin-bottom: -6rem !important;
}

.ml-nlg,
.mx-nlg {
  margin-left: -6rem !important;
}

.m-nxl {
  margin: -8rem !important;
}

.mt-nxl,
.my-nxl {
  margin-top: -8rem !important;
}

.mr-nxl,
.mx-nxl {
  margin-right: -8rem !important;
}

.mb-nxl,
.my-nxl {
  margin-bottom: -8rem !important;
}

.ml-nxl,
.mx-nxl {
  margin-left: -8rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
.my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
.mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
.my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
.mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
.my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
.mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
.my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
.mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
.my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
.mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
.my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
.mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
.my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
.mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
.my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
.mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
.my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
.mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
.my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
.mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
.my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
.mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
.my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
.mx-sm-5 {
    margin-left: 3rem !important;
  }
  .m-sm-sm {
    margin: 2rem !important;
  }
  .mt-sm-sm,
.my-sm-sm {
    margin-top: 2rem !important;
  }
  .mr-sm-sm,
.mx-sm-sm {
    margin-right: 2rem !important;
  }
  .mb-sm-sm,
.my-sm-sm {
    margin-bottom: 2rem !important;
  }
  .ml-sm-sm,
.mx-sm-sm {
    margin-left: 2rem !important;
  }
  .m-sm-md {
    margin: 4rem !important;
  }
  .mt-sm-md,
.my-sm-md {
    margin-top: 4rem !important;
  }
  .mr-sm-md,
.mx-sm-md {
    margin-right: 4rem !important;
  }
  .mb-sm-md,
.my-sm-md {
    margin-bottom: 4rem !important;
  }
  .ml-sm-md,
.mx-sm-md {
    margin-left: 4rem !important;
  }
  .m-sm-lg {
    margin: 6rem !important;
  }
  .mt-sm-lg,
.my-sm-lg {
    margin-top: 6rem !important;
  }
  .mr-sm-lg,
.mx-sm-lg {
    margin-right: 6rem !important;
  }
  .mb-sm-lg,
.my-sm-lg {
    margin-bottom: 6rem !important;
  }
  .ml-sm-lg,
.mx-sm-lg {
    margin-left: 6rem !important;
  }
  .m-sm-xl {
    margin: 8rem !important;
  }
  .mt-sm-xl,
.my-sm-xl {
    margin-top: 8rem !important;
  }
  .mr-sm-xl,
.mx-sm-xl {
    margin-right: 8rem !important;
  }
  .mb-sm-xl,
.my-sm-xl {
    margin-bottom: 8rem !important;
  }
  .ml-sm-xl,
.mx-sm-xl {
    margin-left: 8rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
.py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
.px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
.py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
.px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
.py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
.px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
.py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
.px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
.py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
.px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
.py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
.px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
.py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
.px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
.py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
.px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
.py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
.px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
.py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
.px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
.py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
.px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
.py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
.px-sm-5 {
    padding-left: 3rem !important;
  }
  .p-sm-sm {
    padding: 2rem !important;
  }
  .pt-sm-sm,
.py-sm-sm {
    padding-top: 2rem !important;
  }
  .pr-sm-sm,
.px-sm-sm {
    padding-right: 2rem !important;
  }
  .pb-sm-sm,
.py-sm-sm {
    padding-bottom: 2rem !important;
  }
  .pl-sm-sm,
.px-sm-sm {
    padding-left: 2rem !important;
  }
  .p-sm-md {
    padding: 4rem !important;
  }
  .pt-sm-md,
.py-sm-md {
    padding-top: 4rem !important;
  }
  .pr-sm-md,
.px-sm-md {
    padding-right: 4rem !important;
  }
  .pb-sm-md,
.py-sm-md {
    padding-bottom: 4rem !important;
  }
  .pl-sm-md,
.px-sm-md {
    padding-left: 4rem !important;
  }
  .p-sm-lg {
    padding: 6rem !important;
  }
  .pt-sm-lg,
.py-sm-lg {
    padding-top: 6rem !important;
  }
  .pr-sm-lg,
.px-sm-lg {
    padding-right: 6rem !important;
  }
  .pb-sm-lg,
.py-sm-lg {
    padding-bottom: 6rem !important;
  }
  .pl-sm-lg,
.px-sm-lg {
    padding-left: 6rem !important;
  }
  .p-sm-xl {
    padding: 8rem !important;
  }
  .pt-sm-xl,
.py-sm-xl {
    padding-top: 8rem !important;
  }
  .pr-sm-xl,
.px-sm-xl {
    padding-right: 8rem !important;
  }
  .pb-sm-xl,
.py-sm-xl {
    padding-bottom: 8rem !important;
  }
  .pl-sm-xl,
.px-sm-xl {
    padding-left: 8rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
.my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
.mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
.my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
.mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
.my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
.mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
.my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
.mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
.my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
.mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
.my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
.mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
.my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
.mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
.my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
.mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
.my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
.mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
.my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
.mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-nsm {
    margin: -2rem !important;
  }
  .mt-sm-nsm,
.my-sm-nsm {
    margin-top: -2rem !important;
  }
  .mr-sm-nsm,
.mx-sm-nsm {
    margin-right: -2rem !important;
  }
  .mb-sm-nsm,
.my-sm-nsm {
    margin-bottom: -2rem !important;
  }
  .ml-sm-nsm,
.mx-sm-nsm {
    margin-left: -2rem !important;
  }
  .m-sm-nmd {
    margin: -4rem !important;
  }
  .mt-sm-nmd,
.my-sm-nmd {
    margin-top: -4rem !important;
  }
  .mr-sm-nmd,
.mx-sm-nmd {
    margin-right: -4rem !important;
  }
  .mb-sm-nmd,
.my-sm-nmd {
    margin-bottom: -4rem !important;
  }
  .ml-sm-nmd,
.mx-sm-nmd {
    margin-left: -4rem !important;
  }
  .m-sm-nlg {
    margin: -6rem !important;
  }
  .mt-sm-nlg,
.my-sm-nlg {
    margin-top: -6rem !important;
  }
  .mr-sm-nlg,
.mx-sm-nlg {
    margin-right: -6rem !important;
  }
  .mb-sm-nlg,
.my-sm-nlg {
    margin-bottom: -6rem !important;
  }
  .ml-sm-nlg,
.mx-sm-nlg {
    margin-left: -6rem !important;
  }
  .m-sm-nxl {
    margin: -8rem !important;
  }
  .mt-sm-nxl,
.my-sm-nxl {
    margin-top: -8rem !important;
  }
  .mr-sm-nxl,
.mx-sm-nxl {
    margin-right: -8rem !important;
  }
  .mb-sm-nxl,
.my-sm-nxl {
    margin-bottom: -8rem !important;
  }
  .ml-sm-nxl,
.mx-sm-nxl {
    margin-left: -8rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
.my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
.mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
.my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
.mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
.my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
.mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
.my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
.mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
.my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
.mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
.my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
.mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
.my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
.mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
.my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
.mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
.my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
.mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
.my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
.mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
.my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
.mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
.my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
.mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
.my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
.mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
.my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
.mx-md-5 {
    margin-left: 3rem !important;
  }
  .m-md-sm {
    margin: 2rem !important;
  }
  .mt-md-sm,
.my-md-sm {
    margin-top: 2rem !important;
  }
  .mr-md-sm,
.mx-md-sm {
    margin-right: 2rem !important;
  }
  .mb-md-sm,
.my-md-sm {
    margin-bottom: 2rem !important;
  }
  .ml-md-sm,
.mx-md-sm {
    margin-left: 2rem !important;
  }
  .m-md-md {
    margin: 4rem !important;
  }
  .mt-md-md,
.my-md-md {
    margin-top: 4rem !important;
  }
  .mr-md-md,
.mx-md-md {
    margin-right: 4rem !important;
  }
  .mb-md-md,
.my-md-md {
    margin-bottom: 4rem !important;
  }
  .ml-md-md,
.mx-md-md {
    margin-left: 4rem !important;
  }
  .m-md-lg {
    margin: 6rem !important;
  }
  .mt-md-lg,
.my-md-lg {
    margin-top: 6rem !important;
  }
  .mr-md-lg,
.mx-md-lg {
    margin-right: 6rem !important;
  }
  .mb-md-lg,
.my-md-lg {
    margin-bottom: 6rem !important;
  }
  .ml-md-lg,
.mx-md-lg {
    margin-left: 6rem !important;
  }
  .m-md-xl {
    margin: 8rem !important;
  }
  .mt-md-xl,
.my-md-xl {
    margin-top: 8rem !important;
  }
  .mr-md-xl,
.mx-md-xl {
    margin-right: 8rem !important;
  }
  .mb-md-xl,
.my-md-xl {
    margin-bottom: 8rem !important;
  }
  .ml-md-xl,
.mx-md-xl {
    margin-left: 8rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
.py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
.px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
.py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
.px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
.py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
.px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
.py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
.px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
.py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
.px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
.py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
.px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
.py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
.px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
.py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
.px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
.py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
.px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
.py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
.px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
.py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
.px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
.py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
.px-md-5 {
    padding-left: 3rem !important;
  }
  .p-md-sm {
    padding: 2rem !important;
  }
  .pt-md-sm,
.py-md-sm {
    padding-top: 2rem !important;
  }
  .pr-md-sm,
.px-md-sm {
    padding-right: 2rem !important;
  }
  .pb-md-sm,
.py-md-sm {
    padding-bottom: 2rem !important;
  }
  .pl-md-sm,
.px-md-sm {
    padding-left: 2rem !important;
  }
  .p-md-md {
    padding: 4rem !important;
  }
  .pt-md-md,
.py-md-md {
    padding-top: 4rem !important;
  }
  .pr-md-md,
.px-md-md {
    padding-right: 4rem !important;
  }
  .pb-md-md,
.py-md-md {
    padding-bottom: 4rem !important;
  }
  .pl-md-md,
.px-md-md {
    padding-left: 4rem !important;
  }
  .p-md-lg {
    padding: 6rem !important;
  }
  .pt-md-lg,
.py-md-lg {
    padding-top: 6rem !important;
  }
  .pr-md-lg,
.px-md-lg {
    padding-right: 6rem !important;
  }
  .pb-md-lg,
.py-md-lg {
    padding-bottom: 6rem !important;
  }
  .pl-md-lg,
.px-md-lg {
    padding-left: 6rem !important;
  }
  .p-md-xl {
    padding: 8rem !important;
  }
  .pt-md-xl,
.py-md-xl {
    padding-top: 8rem !important;
  }
  .pr-md-xl,
.px-md-xl {
    padding-right: 8rem !important;
  }
  .pb-md-xl,
.py-md-xl {
    padding-bottom: 8rem !important;
  }
  .pl-md-xl,
.px-md-xl {
    padding-left: 8rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
.my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
.mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
.my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
.mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
.my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
.mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
.my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
.mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
.my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
.mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
.my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
.mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
.my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
.mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
.my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
.mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
.my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
.mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
.my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
.mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-nsm {
    margin: -2rem !important;
  }
  .mt-md-nsm,
.my-md-nsm {
    margin-top: -2rem !important;
  }
  .mr-md-nsm,
.mx-md-nsm {
    margin-right: -2rem !important;
  }
  .mb-md-nsm,
.my-md-nsm {
    margin-bottom: -2rem !important;
  }
  .ml-md-nsm,
.mx-md-nsm {
    margin-left: -2rem !important;
  }
  .m-md-nmd {
    margin: -4rem !important;
  }
  .mt-md-nmd,
.my-md-nmd {
    margin-top: -4rem !important;
  }
  .mr-md-nmd,
.mx-md-nmd {
    margin-right: -4rem !important;
  }
  .mb-md-nmd,
.my-md-nmd {
    margin-bottom: -4rem !important;
  }
  .ml-md-nmd,
.mx-md-nmd {
    margin-left: -4rem !important;
  }
  .m-md-nlg {
    margin: -6rem !important;
  }
  .mt-md-nlg,
.my-md-nlg {
    margin-top: -6rem !important;
  }
  .mr-md-nlg,
.mx-md-nlg {
    margin-right: -6rem !important;
  }
  .mb-md-nlg,
.my-md-nlg {
    margin-bottom: -6rem !important;
  }
  .ml-md-nlg,
.mx-md-nlg {
    margin-left: -6rem !important;
  }
  .m-md-nxl {
    margin: -8rem !important;
  }
  .mt-md-nxl,
.my-md-nxl {
    margin-top: -8rem !important;
  }
  .mr-md-nxl,
.mx-md-nxl {
    margin-right: -8rem !important;
  }
  .mb-md-nxl,
.my-md-nxl {
    margin-bottom: -8rem !important;
  }
  .ml-md-nxl,
.mx-md-nxl {
    margin-left: -8rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
.my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
.mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
.my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
.mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
.my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
.mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
.my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
.mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
.my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
.mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
.my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
.mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
.my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
.mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
.my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
.mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
.my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
.mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
.my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
.mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
.my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
.mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
.my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
.mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
.my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
.mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
.my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
.mx-lg-5 {
    margin-left: 3rem !important;
  }
  .m-lg-sm {
    margin: 2rem !important;
  }
  .mt-lg-sm,
.my-lg-sm {
    margin-top: 2rem !important;
  }
  .mr-lg-sm,
.mx-lg-sm {
    margin-right: 2rem !important;
  }
  .mb-lg-sm,
.my-lg-sm {
    margin-bottom: 2rem !important;
  }
  .ml-lg-sm,
.mx-lg-sm {
    margin-left: 2rem !important;
  }
  .m-lg-md {
    margin: 4rem !important;
  }
  .mt-lg-md,
.my-lg-md {
    margin-top: 4rem !important;
  }
  .mr-lg-md,
.mx-lg-md {
    margin-right: 4rem !important;
  }
  .mb-lg-md,
.my-lg-md {
    margin-bottom: 4rem !important;
  }
  .ml-lg-md,
.mx-lg-md {
    margin-left: 4rem !important;
  }
  .m-lg-lg {
    margin: 6rem !important;
  }
  .mt-lg-lg,
.my-lg-lg {
    margin-top: 6rem !important;
  }
  .mr-lg-lg,
.mx-lg-lg {
    margin-right: 6rem !important;
  }
  .mb-lg-lg,
.my-lg-lg {
    margin-bottom: 6rem !important;
  }
  .ml-lg-lg,
.mx-lg-lg {
    margin-left: 6rem !important;
  }
  .m-lg-xl {
    margin: 8rem !important;
  }
  .mt-lg-xl,
.my-lg-xl {
    margin-top: 8rem !important;
  }
  .mr-lg-xl,
.mx-lg-xl {
    margin-right: 8rem !important;
  }
  .mb-lg-xl,
.my-lg-xl {
    margin-bottom: 8rem !important;
  }
  .ml-lg-xl,
.mx-lg-xl {
    margin-left: 8rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
.py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
.px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
.py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
.px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
.py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
.px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
.py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
.px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
.py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
.px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
.py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
.px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
.py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
.px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
.py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
.px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
.py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
.px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
.py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
.px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
.py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
.px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
.py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
.px-lg-5 {
    padding-left: 3rem !important;
  }
  .p-lg-sm {
    padding: 2rem !important;
  }
  .pt-lg-sm,
.py-lg-sm {
    padding-top: 2rem !important;
  }
  .pr-lg-sm,
.px-lg-sm {
    padding-right: 2rem !important;
  }
  .pb-lg-sm,
.py-lg-sm {
    padding-bottom: 2rem !important;
  }
  .pl-lg-sm,
.px-lg-sm {
    padding-left: 2rem !important;
  }
  .p-lg-md {
    padding: 4rem !important;
  }
  .pt-lg-md,
.py-lg-md {
    padding-top: 4rem !important;
  }
  .pr-lg-md,
.px-lg-md {
    padding-right: 4rem !important;
  }
  .pb-lg-md,
.py-lg-md {
    padding-bottom: 4rem !important;
  }
  .pl-lg-md,
.px-lg-md {
    padding-left: 4rem !important;
  }
  .p-lg-lg {
    padding: 6rem !important;
  }
  .pt-lg-lg,
.py-lg-lg {
    padding-top: 6rem !important;
  }
  .pr-lg-lg,
.px-lg-lg {
    padding-right: 6rem !important;
  }
  .pb-lg-lg,
.py-lg-lg {
    padding-bottom: 6rem !important;
  }
  .pl-lg-lg,
.px-lg-lg {
    padding-left: 6rem !important;
  }
  .p-lg-xl {
    padding: 8rem !important;
  }
  .pt-lg-xl,
.py-lg-xl {
    padding-top: 8rem !important;
  }
  .pr-lg-xl,
.px-lg-xl {
    padding-right: 8rem !important;
  }
  .pb-lg-xl,
.py-lg-xl {
    padding-bottom: 8rem !important;
  }
  .pl-lg-xl,
.px-lg-xl {
    padding-left: 8rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
.my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
.mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
.my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
.mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
.my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
.mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
.my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
.mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
.my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
.mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
.my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
.mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
.my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
.mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
.my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
.mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
.my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
.mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
.my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
.mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-nsm {
    margin: -2rem !important;
  }
  .mt-lg-nsm,
.my-lg-nsm {
    margin-top: -2rem !important;
  }
  .mr-lg-nsm,
.mx-lg-nsm {
    margin-right: -2rem !important;
  }
  .mb-lg-nsm,
.my-lg-nsm {
    margin-bottom: -2rem !important;
  }
  .ml-lg-nsm,
.mx-lg-nsm {
    margin-left: -2rem !important;
  }
  .m-lg-nmd {
    margin: -4rem !important;
  }
  .mt-lg-nmd,
.my-lg-nmd {
    margin-top: -4rem !important;
  }
  .mr-lg-nmd,
.mx-lg-nmd {
    margin-right: -4rem !important;
  }
  .mb-lg-nmd,
.my-lg-nmd {
    margin-bottom: -4rem !important;
  }
  .ml-lg-nmd,
.mx-lg-nmd {
    margin-left: -4rem !important;
  }
  .m-lg-nlg {
    margin: -6rem !important;
  }
  .mt-lg-nlg,
.my-lg-nlg {
    margin-top: -6rem !important;
  }
  .mr-lg-nlg,
.mx-lg-nlg {
    margin-right: -6rem !important;
  }
  .mb-lg-nlg,
.my-lg-nlg {
    margin-bottom: -6rem !important;
  }
  .ml-lg-nlg,
.mx-lg-nlg {
    margin-left: -6rem !important;
  }
  .m-lg-nxl {
    margin: -8rem !important;
  }
  .mt-lg-nxl,
.my-lg-nxl {
    margin-top: -8rem !important;
  }
  .mr-lg-nxl,
.mx-lg-nxl {
    margin-right: -8rem !important;
  }
  .mb-lg-nxl,
.my-lg-nxl {
    margin-bottom: -8rem !important;
  }
  .ml-lg-nxl,
.mx-lg-nxl {
    margin-left: -8rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
.my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
.mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
.my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
.mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
.my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
.mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
.my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
.mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
.my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
.mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
.my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
.mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
.my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
.mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
.my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
.mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
.my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
.mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
.my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
.mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
.my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
.mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
.my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
.mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
.my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
.mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
.my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
.mx-xl-5 {
    margin-left: 3rem !important;
  }
  .m-xl-sm {
    margin: 2rem !important;
  }
  .mt-xl-sm,
.my-xl-sm {
    margin-top: 2rem !important;
  }
  .mr-xl-sm,
.mx-xl-sm {
    margin-right: 2rem !important;
  }
  .mb-xl-sm,
.my-xl-sm {
    margin-bottom: 2rem !important;
  }
  .ml-xl-sm,
.mx-xl-sm {
    margin-left: 2rem !important;
  }
  .m-xl-md {
    margin: 4rem !important;
  }
  .mt-xl-md,
.my-xl-md {
    margin-top: 4rem !important;
  }
  .mr-xl-md,
.mx-xl-md {
    margin-right: 4rem !important;
  }
  .mb-xl-md,
.my-xl-md {
    margin-bottom: 4rem !important;
  }
  .ml-xl-md,
.mx-xl-md {
    margin-left: 4rem !important;
  }
  .m-xl-lg {
    margin: 6rem !important;
  }
  .mt-xl-lg,
.my-xl-lg {
    margin-top: 6rem !important;
  }
  .mr-xl-lg,
.mx-xl-lg {
    margin-right: 6rem !important;
  }
  .mb-xl-lg,
.my-xl-lg {
    margin-bottom: 6rem !important;
  }
  .ml-xl-lg,
.mx-xl-lg {
    margin-left: 6rem !important;
  }
  .m-xl-xl {
    margin: 8rem !important;
  }
  .mt-xl-xl,
.my-xl-xl {
    margin-top: 8rem !important;
  }
  .mr-xl-xl,
.mx-xl-xl {
    margin-right: 8rem !important;
  }
  .mb-xl-xl,
.my-xl-xl {
    margin-bottom: 8rem !important;
  }
  .ml-xl-xl,
.mx-xl-xl {
    margin-left: 8rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
.py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
.px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
.py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
.px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
.py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
.px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
.py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
.px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
.py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
.px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
.py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
.px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
.py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
.px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
.py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
.px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
.py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
.px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
.py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
.px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
.py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
.px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
.py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
.px-xl-5 {
    padding-left: 3rem !important;
  }
  .p-xl-sm {
    padding: 2rem !important;
  }
  .pt-xl-sm,
.py-xl-sm {
    padding-top: 2rem !important;
  }
  .pr-xl-sm,
.px-xl-sm {
    padding-right: 2rem !important;
  }
  .pb-xl-sm,
.py-xl-sm {
    padding-bottom: 2rem !important;
  }
  .pl-xl-sm,
.px-xl-sm {
    padding-left: 2rem !important;
  }
  .p-xl-md {
    padding: 4rem !important;
  }
  .pt-xl-md,
.py-xl-md {
    padding-top: 4rem !important;
  }
  .pr-xl-md,
.px-xl-md {
    padding-right: 4rem !important;
  }
  .pb-xl-md,
.py-xl-md {
    padding-bottom: 4rem !important;
  }
  .pl-xl-md,
.px-xl-md {
    padding-left: 4rem !important;
  }
  .p-xl-lg {
    padding: 6rem !important;
  }
  .pt-xl-lg,
.py-xl-lg {
    padding-top: 6rem !important;
  }
  .pr-xl-lg,
.px-xl-lg {
    padding-right: 6rem !important;
  }
  .pb-xl-lg,
.py-xl-lg {
    padding-bottom: 6rem !important;
  }
  .pl-xl-lg,
.px-xl-lg {
    padding-left: 6rem !important;
  }
  .p-xl-xl {
    padding: 8rem !important;
  }
  .pt-xl-xl,
.py-xl-xl {
    padding-top: 8rem !important;
  }
  .pr-xl-xl,
.px-xl-xl {
    padding-right: 8rem !important;
  }
  .pb-xl-xl,
.py-xl-xl {
    padding-bottom: 8rem !important;
  }
  .pl-xl-xl,
.px-xl-xl {
    padding-left: 8rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
.my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
.mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
.my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
.mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
.my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
.mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
.my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
.mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
.my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
.mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
.my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
.mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
.my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
.mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
.my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
.mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
.my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
.mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
.my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
.mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-nsm {
    margin: -2rem !important;
  }
  .mt-xl-nsm,
.my-xl-nsm {
    margin-top: -2rem !important;
  }
  .mr-xl-nsm,
.mx-xl-nsm {
    margin-right: -2rem !important;
  }
  .mb-xl-nsm,
.my-xl-nsm {
    margin-bottom: -2rem !important;
  }
  .ml-xl-nsm,
.mx-xl-nsm {
    margin-left: -2rem !important;
  }
  .m-xl-nmd {
    margin: -4rem !important;
  }
  .mt-xl-nmd,
.my-xl-nmd {
    margin-top: -4rem !important;
  }
  .mr-xl-nmd,
.mx-xl-nmd {
    margin-right: -4rem !important;
  }
  .mb-xl-nmd,
.my-xl-nmd {
    margin-bottom: -4rem !important;
  }
  .ml-xl-nmd,
.mx-xl-nmd {
    margin-left: -4rem !important;
  }
  .m-xl-nlg {
    margin: -6rem !important;
  }
  .mt-xl-nlg,
.my-xl-nlg {
    margin-top: -6rem !important;
  }
  .mr-xl-nlg,
.mx-xl-nlg {
    margin-right: -6rem !important;
  }
  .mb-xl-nlg,
.my-xl-nlg {
    margin-bottom: -6rem !important;
  }
  .ml-xl-nlg,
.mx-xl-nlg {
    margin-left: -6rem !important;
  }
  .m-xl-nxl {
    margin: -8rem !important;
  }
  .mt-xl-nxl,
.my-xl-nxl {
    margin-top: -8rem !important;
  }
  .mr-xl-nxl,
.mx-xl-nxl {
    margin-right: -8rem !important;
  }
  .mb-xl-nxl,
.my-xl-nxl {
    margin-bottom: -8rem !important;
  }
  .ml-xl-nxl,
.mx-xl-nxl {
    margin-left: -8rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
.my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
.mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
.my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
.mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 600 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #ffffff !important;
}

.text-primary {
  color: #e14eca !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #c221a9 !important;
}

.text-secondary {
  color: #f4f5f7 !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #c8cdd7 !important;
}

.text-success {
  color: #00f2c3 !important;
}

a.text-success:hover, a.text-success:focus {
  color: #00a685 !important;
}

.text-info {
  color: #1d8cf8 !important;
}

a.text-info:hover, a.text-info:focus {
  color: #0666c2 !important;
}

.text-warning {
  color: #ff8d72 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #ff4f26 !important;
}

.text-danger {
  color: #fd5d93 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #fc1161 !important;
}

.text-light {
  color: #adb5bd !important;
}

a.text-light:hover, a.text-light:focus {
  color: #838f9b !important;
}

.text-dark {
  color: #212529 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: black !important;
}

.text-default {
  color: #344675 !important;
}

a.text-default:hover, a.text-default:focus {
  color: #1c2640 !important;
}

.text-white {
  color: #ffffff !important;
}

a.text-white:hover, a.text-white:focus {
  color: #d9d9d9 !important;
}

.text-neutral {
  color: #ffffff !important;
}

a.text-neutral:hover, a.text-neutral:focus {
  color: #d9d9d9 !important;
}

.text-darker {
  color: black !important;
}

a.text-darker:hover, a.text-darker:focus {
  color: black !important;
}

.text-body {
  color: #525f7f !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(34, 42, 66, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
*::before,
*::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
blockquote {
    border: 0.0625rem solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
img {
    page-break-inside: avoid;
  }
  p,
h2,
h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 0.0625rem solid #222a42;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
.table th {
    background-color: #ffffff !important;
  }
  .table-bordered th,
.table-bordered td {
    border: 1px solid #e3e3e3 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
    border-color: #e3e3e3;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #e3e3e3;
  }
}
body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

iframe {
  border: 0;
}

figcaption,
figure,
main {
  display: block;
}

main {
  overflow: hidden;
}

.section-nucleo-icons .icons-container {
  position: relative;
  max-width: 100%;
  height: 360px;
  margin: 0 auto;
  z-index: 1;
}

.section-nucleo-icons {
  --icon-size: 5rem;
  --icon-sm-size: 3.75rem;
  --gutter: 7rem;
}
.section-nucleo-icons .icons-container i {
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ffffff;
  z-index: 1;
  transform: translate(-50%, -50%);
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.2s cubic-bezier(0.25, 0.65, 0.9, 0.75);
}
.section-nucleo-icons .icons-container i.icon {
  width: var(--icon-size);
  height: var(--icon-size);
  font-size: 1.7em;
}
.section-nucleo-icons .icons-container i.icon-sm {
  width: var(--icon-sm-size);
  height: var(--icon-sm-size);
  font-size: 1.5em;
}
.section-nucleo-icons .icons-container i:nth-child(1) {
  font-size: 42px;
  color: #ff8d72;
  z-index: 2;
}
.section-nucleo-icons .icons-container:not(.on-screen) i {
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
.section-nucleo-icons .icons-container:not(.on-screen) i:not(:nth-child(1)) {
  opacity: 0;
}
.section-nucleo-icons .icons-container.on-screen i {
  opacity: 1;
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(1) {
  left: 50%;
  top: 50%;
  font-size: 42px;
  color: #ff8d72;
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(2) {
  left: calc(50% + var(--gutter) * 1.7);
  top: 50%;
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(3) {
  left: calc(50% + var(--gutter));
  top: calc(50% + var(--gutter));
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(4) {
  left: calc(50% + var(--gutter));
  top: calc(50% - var(--gutter));
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(5) {
  left: calc(50% + var(--gutter) * 4);
  top: 50%;
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(6) {
  left: calc(50% + var(--gutter) * 2.7);
  top: calc(50% + var(--gutter) * 1.5);
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(7) {
  left: calc(50% + var(--gutter) * 2.7);
  top: calc(50% - var(--gutter) * 1.5);
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(8) {
  left: calc(50% - var(--gutter) * 1.7);
  top: 50%;
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(9) {
  left: calc(50% - var(--gutter));
  top: calc(50% + var(--gutter));
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(10) {
  left: calc(50% - var(--gutter));
  top: calc(50% - var(--gutter));
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(11) {
  left: calc(50% - var(--gutter) * 4);
  top: 50%;
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(12) {
  left: calc(50% - var(--gutter) * 2.7);
  top: calc(50% + var(--gutter) * 1.5);
}
.section-nucleo-icons .icons-container.on-screen i:nth-child(13) {
  left: calc(50% - var(--gutter) * 2.7);
  top: calc(50% - var(--gutter) * 1.5);
}

.blur--hover {
  position: relative;
}
.blur--hover .blur-item {
  transition: 1s cubic-bezier(0.19, 1, 0.22, 1);
  will-change: transform;
  filter: blur(0);
  opacity: 1;
}
.blur--hover .blur-hidden {
  position: absolute;
  top: calc(50% + 7px);
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.15s ease;
  z-index: 100;
}
.blur--hover:hover .blur-item {
  opacity: 0.8;
  filter: blur(10px);
  transform: scale(0.95);
  z-index: 1;
}
.blur--hover:hover .blur-hidden {
  opacity: 1;
  top: 50%;
}

.bg-blue {
  background-color: #5e72e4 !important;
}

a.bg-blue:hover, a.bg-blue:focus,
button.bg-blue:hover,
button.bg-blue:focus {
  background-color: #324cdd !important;
}

.bg-indigo {
  background-color: #5603ad !important;
}

a.bg-indigo:hover, a.bg-indigo:focus,
button.bg-indigo:hover,
button.bg-indigo:focus {
  background-color: #3d027b !important;
}

.bg-purple {
  background-color: #8965e0 !important;
}

a.bg-purple:hover, a.bg-purple:focus,
button.bg-purple:hover,
button.bg-purple:focus {
  background-color: #683bd7 !important;
}

.bg-pink {
  background-color: #f3a4b5 !important;
}

a.bg-pink:hover, a.bg-pink:focus,
button.bg-pink:hover,
button.bg-pink:focus {
  background-color: #ed7790 !important;
}

.bg-red {
  background-color: #f5365c !important;
}

a.bg-red:hover, a.bg-red:focus,
button.bg-red:hover,
button.bg-red:focus {
  background-color: #ec0c38 !important;
}

.bg-orange {
  background-color: #fb6340 !important;
}

a.bg-orange:hover, a.bg-orange:focus,
button.bg-orange:hover,
button.bg-orange:focus {
  background-color: #fa3a0e !important;
}

.bg-yellow {
  background-color: #ffd600 !important;
}

a.bg-yellow:hover, a.bg-yellow:focus,
button.bg-yellow:hover,
button.bg-yellow:focus {
  background-color: #ccab00 !important;
}

.bg-green {
  background-color: #2dce89 !important;
}

a.bg-green:hover, a.bg-green:focus,
button.bg-green:hover,
button.bg-green:focus {
  background-color: #24a46d !important;
}

.bg-teal {
  background-color: #11cdef !important;
}

a.bg-teal:hover, a.bg-teal:focus,
button.bg-teal:hover,
button.bg-teal:focus {
  background-color: #0da5c0 !important;
}

.bg-cyan {
  background-color: #2bffc6 !important;
}

a.bg-cyan:hover, a.bg-cyan:focus,
button.bg-cyan:hover,
button.bg-cyan:focus {
  background-color: #00f7b5 !important;
}

.bg-white {
  background-color: #ffffff !important;
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: #e6e6e6 !important;
}

.bg-gray {
  background-color: #6c757d !important;
}

a.bg-gray:hover, a.bg-gray:focus,
button.bg-gray:hover,
button.bg-gray:focus {
  background-color: #545b62 !important;
}

.bg-gray-dark {
  background-color: #32325d !important;
}

a.bg-gray-dark:hover, a.bg-gray-dark:focus,
button.bg-gray-dark:hover,
button.bg-gray-dark:focus {
  background-color: #20203c !important;
}

.bg-light {
  background-color: #ced4da !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #b1bbc4 !important;
}

.bg-lighter {
  background-color: #e9ecef !important;
}

a.bg-lighter:hover, a.bg-lighter:focus,
button.bg-lighter:hover,
button.bg-lighter:focus {
  background-color: #cbd3da !important;
}

.bg-gradient-primary {
  background: #e14eca linear-gradient(180deg, #c447b3, #e14eca) repeat-x !important;
}

.bg-gradient-secondary {
  background: #f4f5f7 linear-gradient(180deg, #d4d5d9, #f4f5f7) repeat-x !important;
}

.bg-gradient-success {
  background: #00f2c3 linear-gradient(180deg, #05d2ad, #00f2c3) repeat-x !important;
}

.bg-gradient-info {
  background: #1d8cf8 linear-gradient(180deg, #1d7cda, #1d8cf8) repeat-x !important;
}

.bg-gradient-warning {
  background: #ff8d72 linear-gradient(180deg, #dd7c68, #ff8d72) repeat-x !important;
}

.bg-gradient-danger {
  background: #fd5d93 linear-gradient(180deg, #dc5484, #fd5d93) repeat-x !important;
}

.bg-gradient-light {
  background: #adb5bd linear-gradient(180deg, #989ea8, #adb5bd) repeat-x !important;
}

.bg-gradient-dark {
  background: #212529 linear-gradient(180deg, #21242a, #212529) repeat-x !important;
}

.bg-gradient-default {
  background: #344675 linear-gradient(180deg, #31406b, #344675) repeat-x !important;
}

.bg-gradient-white {
  background: #ffffff linear-gradient(180deg, #dddde0, #ffffff) repeat-x !important;
}

.bg-gradient-neutral {
  background: #ffffff linear-gradient(180deg, #dddde0, #ffffff) repeat-x !important;
}

.bg-gradient-darker {
  background: black linear-gradient(180deg, #050507, black) repeat-x !important;
}

.bg-gradient-blue {
  background: #5e72e4 linear-gradient(180deg, #5465c9, #5e72e4) repeat-x !important;
}

.bg-gradient-indigo {
  background: #5603ad linear-gradient(180deg, #4e079a, #5603ad) repeat-x !important;
}

.bg-gradient-purple {
  background: #8965e0 linear-gradient(180deg, #795ac5, #8965e0) repeat-x !important;
}

.bg-gradient-pink {
  background: #f3a4b5 linear-gradient(180deg, #d390a1, #f3a4b5) repeat-x !important;
}

.bg-gradient-red {
  background: #f5365c linear-gradient(180deg, #d53255, #f5365c) repeat-x !important;
}

.bg-gradient-orange {
  background: #fb6340 linear-gradient(180deg, #da593d, #fb6340) repeat-x !important;
}

.bg-gradient-yellow {
  background: #ffd600 linear-gradient(180deg, #ddba07, #ffd600) repeat-x !important;
}

.bg-gradient-green {
  background: #2dce89 linear-gradient(180deg, #2bb47c, #2dce89) repeat-x !important;
}

.bg-gradient-teal {
  background: #11cdef linear-gradient(180deg, #13b3d2, #11cdef) repeat-x !important;
}

.bg-gradient-cyan {
  background: #2bffc6 linear-gradient(180deg, #29ddaf, #2bffc6) repeat-x !important;
}

.bg-gradient-white {
  background: #ffffff linear-gradient(180deg, #dddde0, #ffffff) repeat-x !important;
}

.bg-gradient-gray {
  background: #6c757d linear-gradient(180deg, #606871, #6c757d) repeat-x !important;
}

.bg-gradient-gray-dark {
  background: #32325d linear-gradient(180deg, #2f2f56, #32325d) repeat-x !important;
}

.bg-gradient-light {
  background: #ced4da linear-gradient(180deg, #b4b9c0, #ced4da) repeat-x !important;
}

.bg-gradient-lighter {
  background: #e9ecef linear-gradient(180deg, #cbcdd2, #e9ecef) repeat-x !important;
}

.section-primary {
  background-color: #1e1e2f !important;
}

a.section-primary:hover, a.section-primary:focus,
button.section-primary:hover,
button.section-primary:focus {
  background-color: #0a0a10 !important;
}

.section-secondary {
  background-color: #f4f5f7 !important;
}

a.section-secondary:hover, a.section-secondary:focus,
button.section-secondary:hover,
button.section-secondary:focus {
  background-color: #d6dae2 !important;
}

.section-light {
  background-color: #ced4da !important;
}

a.section-light:hover, a.section-light:focus,
button.section-light:hover,
button.section-light:focus {
  background-color: #b1bbc4 !important;
}

.section-dark {
  background-color: #212529 !important;
}

a.section-dark:hover, a.section-dark:focus,
button.section-dark:hover,
button.section-dark:focus {
  background-color: #0a0c0d !important;
}

.section-darker {
  background-color: black !important;
}

a.section-darker:hover, a.section-darker:focus,
button.section-darker:hover,
button.section-darker:focus {
  background-color: black !important;
}

.bg-gradient-primary {
  background: #e14eca linear-gradient(180deg, #c447b3, #e14eca) repeat-x !important;
}

.bg-gradient-secondary {
  background: #f4f5f7 linear-gradient(180deg, #d4d5d9, #f4f5f7) repeat-x !important;
}

.bg-gradient-success {
  background: #00f2c3 linear-gradient(180deg, #05d2ad, #00f2c3) repeat-x !important;
}

.bg-gradient-info {
  background: #1d8cf8 linear-gradient(180deg, #1d7cda, #1d8cf8) repeat-x !important;
}

.bg-gradient-warning {
  background: #ff8d72 linear-gradient(180deg, #dd7c68, #ff8d72) repeat-x !important;
}

.bg-gradient-danger {
  background: #fd5d93 linear-gradient(180deg, #dc5484, #fd5d93) repeat-x !important;
}

.bg-gradient-light {
  background: #adb5bd linear-gradient(180deg, #989ea8, #adb5bd) repeat-x !important;
}

.bg-gradient-dark {
  background: #212529 linear-gradient(180deg, #21242a, #212529) repeat-x !important;
}

.bg-gradient-default {
  background: #344675 linear-gradient(180deg, #31406b, #344675) repeat-x !important;
}

.bg-gradient-white {
  background: #ffffff linear-gradient(180deg, #dddde0, #ffffff) repeat-x !important;
}

.bg-gradient-neutral {
  background: #ffffff linear-gradient(180deg, #dddde0, #ffffff) repeat-x !important;
}

.bg-gradient-darker {
  background: black linear-gradient(180deg, #050507, black) repeat-x !important;
}

.fill-primary {
  fill: #e14eca;
}

.stroke-primary {
  stroke: #e14eca;
}

.fill-secondary {
  fill: #f4f5f7;
}

.stroke-secondary {
  stroke: #f4f5f7;
}

.fill-success {
  fill: #00f2c3;
}

.stroke-success {
  stroke: #00f2c3;
}

.fill-info {
  fill: #1d8cf8;
}

.stroke-info {
  stroke: #1d8cf8;
}

.fill-warning {
  fill: #ff8d72;
}

.stroke-warning {
  stroke: #ff8d72;
}

.fill-danger {
  fill: #fd5d93;
}

.stroke-danger {
  stroke: #fd5d93;
}

.fill-light {
  fill: #adb5bd;
}

.stroke-light {
  stroke: #adb5bd;
}

.fill-dark {
  fill: #212529;
}

.stroke-dark {
  stroke: #212529;
}

.fill-default {
  fill: #344675;
}

.stroke-default {
  stroke: #344675;
}

.fill-white {
  fill: #ffffff;
}

.stroke-white {
  stroke: #ffffff;
}

.fill-neutral {
  fill: #ffffff;
}

.stroke-neutral {
  stroke: #ffffff;
}

.fill-darker {
  fill: black;
}

.stroke-darker {
  stroke: black;
}

.fill-opacity-8 {
  fill-opacity: 0.8;
}

.floating {
  animation: floating 3s ease infinite;
  will-change: transform;
}
.floating:hover {
  animation-play-state: paused;
}

.floating-lg {
  animation: floating-lg 3s ease infinite;
}

.floating-sm {
  animation: floating-sm 3s ease infinite;
}

@keyframes floating-lg {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(15px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes floating {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes floating-sm {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0px);
  }
}
.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.floatfix:before, .floatfix:after {
  content: "";
  display: table;
}
.floatfix:after {
  clear: both;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-8 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.top-0 {
  top: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

.left-0 {
  left: 0;
}

.top-1 {
  top: 0.25rem;
}

.right-1 {
  right: 0.25rem;
}

.bottom-1 {
  bottom: 0.25rem;
}

.left-1 {
  left: 0.25rem;
}

.top-2 {
  top: 0.5rem;
}

.right-2 {
  right: 0.5rem;
}

.bottom-2 {
  bottom: 0.5rem;
}

.left-2 {
  left: 0.5rem;
}

.top-3 {
  top: 1rem;
}

.right-3 {
  right: 1rem;
}

.bottom-3 {
  bottom: 1rem;
}

.left-3 {
  left: 1rem;
}

.top-4 {
  top: 1.5rem;
}

.right-4 {
  right: 1.5rem;
}

.bottom-4 {
  bottom: 1.5rem;
}

.left-4 {
  left: 1.5rem;
}

.top-5 {
  top: 3rem;
}

.right-5 {
  right: 3rem;
}

.bottom-5 {
  bottom: 3rem;
}

.left-5 {
  left: 3rem;
}

.top-sm {
  top: 2rem;
}

.right-sm {
  right: 2rem;
}

.bottom-sm {
  bottom: 2rem;
}

.left-sm {
  left: 2rem;
}

.top-md {
  top: 4rem;
}

.right-md {
  right: 4rem;
}

.bottom-md {
  bottom: 4rem;
}

.left-md {
  left: 4rem;
}

.top-lg {
  top: 6rem;
}

.right-lg {
  right: 6rem;
}

.bottom-lg {
  bottom: 6rem;
}

.left-lg {
  left: 6rem;
}

.top-xl {
  top: 8rem;
}

.right-xl {
  right: 8rem;
}

.bottom-xl {
  bottom: 8rem;
}

.left-xl {
  left: 8rem;
}

.center {
  left: 50%;
  transform: translateX(-50%);
}

.h-100vh {
  height: 100vh !important;
}

.row.row-grid > [class*=col-] + [class*=col-] {
  margin-top: 3rem;
}

@media (min-width: 1200px) {
  .row.row-grid > [class*=col-lg-] + [class*=col-lg-] {
    margin-top: 0;
  }
}
@media (min-width: 992px) {
  .row.row-grid > [class*=col-md-] + [class*=col-md-] {
    margin-top: 0;
  }
}
@media (min-width: 768px) {
  .row.row-grid > [class*=col-sm-] + [class*=col-sm-] {
    margin-top: 0;
  }
}
.row-grid + .row-grid {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  [class*=mt--],
[class*=mr--],
[class*=mb--],
[class*=ml--] {
    position: relative;
    z-index: 5;
  }
  .mt--100 {
    margin-top: -100px !important;
  }
  .mr--100 {
    margin-right: -100px !important;
  }
  .mb--100 {
    margin-bottom: -100px !important;
  }
  .ml--100 {
    margin-left: -100px !important;
  }
  .mt--150 {
    margin-top: -150px !important;
  }
  .mb--150 {
    margin-bottom: -150px !important;
  }
  .mt--200 {
    margin-top: -200px !important;
  }
  .mb--200 {
    margin-bottom: -200px !important;
  }
  .mt--300 {
    margin-top: -300px !important;
  }
  .mb--300 {
    margin-bottom: -300px !important;
  }
  .pt-100 {
    padding-top: 100px !important;
  }
  .pb-100 {
    padding-bottom: 100px !important;
  }
  .pt-150 {
    padding-top: 150px !important;
  }
  .pb-150 {
    padding-bottom: 150px !important;
  }
  .pt-200 {
    padding-top: 200px !important;
  }
  .pb-200 {
    padding-bottom: 200px !important;
  }
  .pt-250 {
    padding-top: 250px !important;
  }
  .pb-250 {
    padding-bottom: 250px !important;
  }
  .pt-300 {
    padding-top: 300px !important;
  }
  .pb-300 {
    padding-bottom: 300px !important;
  }
}
[class*=shadow] {
  transition: all 0.15s ease;
}

.shadow-sm--hover:hover {
  box-shadow: 0 0.125rem 0.25rem rgba(34, 42, 66, 0.075) !important;
}

.shadow--hover:hover {
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1) !important;
}

.shadow-lg--hover:hover {
  box-shadow: 0 1rem 3rem rgba(34, 42, 66, 0.175) !important;
}

.shadow-none--hover:hover {
  box-shadow: none !important;
}

.font-weight-300 {
  font-weight: 300 !important;
}

.font-weight-400 {
  font-weight: 400 !important;
}

.font-weight-500 {
  font-weight: 500 !important;
}

.font-weight-600 {
  font-weight: 600 !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-weight-800 {
  font-weight: 800 !important;
}

.font-weight-900 {
  font-weight: 900 !important;
}

.text-underline {
  text-decoration: underline;
}

.text-through {
  text-decoration: line-through;
}

.lh-100 {
  line-height: 1;
}

.lh-110 {
  line-height: 1.1;
}

.lh-120 {
  line-height: 1.2;
}

.lh-130 {
  line-height: 1.3;
}

.lh-140 {
  line-height: 1.4;
}

.lh-150 {
  line-height: 1.5;
}

.lh-160 {
  line-height: 1.6;
}

.lh-170 {
  line-height: 1.7;
}

.lh-180 {
  line-height: 1.8;
}

.text-muted {
  color: #6c757d !important;
}

.ls-1 {
  letter-spacing: 0.0625rem;
}

.ls-15 {
  letter-spacing: 0.09375rem;
}

.ls-2 {
  letter-spacing: 0.125rem;
}

@media (min-width: 1200px) {
  .transform-perspective-right {
    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);
  }
  .transform-perspective-left {
    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg);
  }
}
.alert {
  border: 0;
  color: #ffffff;
}
.alert .alert-link {
  color: #ffffff;
}
.alert.alert-success {
  background-color: #00bf9a;
}
.alert i.fa,
.alert i.tim-icons {
  font-size: 1rem;
}
.alert .close {
  color: #ffffff;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
}
.alert span[data-notify=icon] {
  font-size: 22px;
  display: block;
  left: 19px;
  position: absolute;
  top: 50%;
  margin-top: -11px;
}
.alert button.close {
  position: absolute;
  right: 15px;
  top: 50%;
  margin-top: -13px;
  width: 25px;
  height: 25px;
  padding: 3px;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

.alert-dismissible .close {
  top: 50%;
  right: 1.25rem;
  padding: 0;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.6);
  opacity: 1;
}
.alert-dismissible .close:hover, .alert-dismissible .close:focus {
  color: rgba(255, 255, 255, 0.9);
  opacity: 1 !important;
}
@media (max-width: 575.98px) {
  .alert-dismissible .close {
    top: 1rem;
    right: 0.5rem;
  }
}
.alert-dismissible .close > span:not(.sr-only) {
  font-size: 1.5rem;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.6);
}
.alert-dismissible .close:hover > span:not(.sr-only), .alert-dismissible .close:focus > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.9);
}

.avatar {
  color: #ffffff;
  background-color: #adb5bd;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  border-radius: 50%;
  height: 48px;
  width: 48px;
}

.avatar img {
  width: 100%;
  border-radius: 50%;
}

.avatar + .avatar-content {
  display: inline-block;
  margin-left: 0.75rem;
}

.avatar-lg {
  width: 58px;
  height: 58px;
  font-size: 0.7500000025rem;
}

.avatar-sm {
  width: 38px;
  height: 38px;
  font-size: 0.7500000025rem;
}

.avatar-group .avatar {
  position: relative;
  z-index: 2;
  border: 2px solid #ffffff;
}
.avatar-group .avatar:hover {
  z-index: 3;
}
.avatar-group .avatar + .avatar {
  margin-left: -1rem;
}

/*           badges             */
.badge {
  text-transform: uppercase;
  line-height: 12px;
  border: none;
  text-decoration: none;
  margin-bottom: 5px;
}
.badge:hover, .badge:focus {
  text-decoration: none;
}

.badge-icon {
  padding: 0.4em 0.55em;
}
.badge-icon i {
  font-size: 0.8em;
}

.badge-success {
  color: #ffffff;
  background-color: #00bf9a;
}
a.badge-success:hover, a.badge-success:focus {
  color: #ffffff;
  background-color: #008c71;
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(0, 191, 154, 0.5);
}

.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  border: none;
  position: relative;
  overflow: hidden;
  margin: 4px 1px;
  border-radius: 0.4285rem;
  cursor: pointer;
  background: #344675;
  background-image: linear-gradient(to bottom left, #344675, #263148, #344675);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #344675;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn.animation-on-hover:hover,
.navbar .navbar-nav > a.btn.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .btn:active:focus, .btn:active:hover, .btn.active:focus, .btn.active:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.navbar .navbar-nav > a.btn:active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:focus,
.navbar .navbar-nav > a.btn.active:hover {
  background-color: #263148 !important;
  background-image: linear-gradient(to bottom left, #344675, #263148, #344675) !important;
  background-image: -moz-linear-gradient(to bottom left, #344675, #263148, #344675) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn:active,
.navbar .navbar-nav > a.btn:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn:not([data-action]):hover,
.navbar .navbar-nav > a.btn:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
  background-color: #344675;
  border-color: #344675;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
  color: #344675;
  border-color: #344675;
  background: transparent;
}
.btn.btn-simple:hover, .btn.btn-simple:focus, .btn.btn-simple:active, .btn.btn-simple:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-simple:hover,
.navbar .navbar-nav > a.btn.btn-simple:focus,
.navbar .navbar-nav > a.btn.btn-simple:active,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled):active {
  color: #344675;
  border-color: #344675;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn.btn-simple.active,
.navbar .navbar-nav > a.btn.btn-simple.active {
  border-color: #344675 !important;
}
.btn.btn-simple.active:hover, .btn.btn-simple.active:focus, .btn.btn-simple.active:active, .btn.btn-simple.active:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-simple.active:hover,
.navbar .navbar-nav > a.btn.btn-simple.active:focus,
.navbar .navbar-nav > a.btn.btn-simple.active:active,
.navbar .navbar-nav > a.btn.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #344675;
  background-image: linear-gradient(to bottom left, #344675, #263148, #344675) !important;
  background-image: -moz-linear-gradient(to bottom left, #344675, #263148, #344675) !important;
  background-color: #263148 !important;
  box-shadow: none;
}
.btn.btn-link,
.navbar .navbar-nav > a.btn.btn-link {
  color: #344675;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:active,
.navbar .navbar-nav > a.btn.btn-link:hover,
.navbar .navbar-nav > a.btn.btn-link:focus,
.navbar .navbar-nav > a.btn.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}
.btn:hover, .btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn .badge,
.navbar .navbar-nav > a.btn .badge {
  margin: 0;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
  height: 2.375rem;
  min-width: 2.375rem;
  width: 2.375rem;
  padding: 0;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
.btn.btn-icon.btn-simple,
.navbar .navbar-nav > a.btn.btn-icon.btn-simple {
  padding: 0;
}
.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm,
.navbar .btn-group-sm.navbar-nav > a.btn.btn-icon {
  height: 1.875rem;
  min-width: 1.875rem;
  width: 1.875rem;
}
.btn.btn-icon.btn-sm .fa, .btn-group-sm > .btn.btn-icon .fa,
.btn.btn-icon.btn-sm .far,
.btn-group-sm > .btn.btn-icon .far,
.btn.btn-icon.btn-sm .fas,
.btn-group-sm > .btn.btn-icon .fas,
.btn.btn-icon.btn-sm .tim-icons,
.btn-group-sm > .btn.btn-icon .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .tim-icons {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg,
.navbar .btn-group-lg.navbar-nav > a.btn.btn-icon {
  height: 3.6rem;
  min-width: 3.6rem;
  width: 3.6rem;
}
.btn.btn-icon.btn-lg .fa, .btn-group-lg > .btn.btn-icon .fa,
.btn.btn-icon.btn-lg .far,
.btn-group-lg > .btn.btn-icon .far,
.btn.btn-icon.btn-lg .fas,
.btn-group-lg > .btn.btn-icon .fas,
.btn.btn-icon.btn-lg .tim-icons,
.btn-group-lg > .btn.btn-icon .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .tim-icons {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) .tim-icons, .btn.btn-icon:not(.btn-footer) .fa, .btn.btn-icon:not(.btn-footer) .far, .btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {
  position: absolute;
  font-size: 1em;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 24px;
}
.btn:not(.btn-icon) .tim-icons,
.navbar .navbar-nav > a.btn:not(.btn-icon) .tim-icons {
  position: relative;
  top: 1px;
}
.btn span,
.navbar .navbar-nav > a.btn span {
  position: relative;
  display: block;
}
.btn.btn-link.dropdown-toggle,
.navbar .navbar-nav > a.btn.btn-link.dropdown-toggle {
  color: #9A9A9A;
}
.btn.dropdown-toggle:after,
.navbar .navbar-nav > a.btn.dropdown-toggle:after {
  margin-left: 30px !important;
}

.btn-primary {
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #e14eca;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-primary.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary:active:focus, .btn-primary:active:hover, .btn-primary.active:focus, .btn-primary.active:hover {
  background-color: #ba54f5 !important;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  background-image: -moz-linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-primary:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-primary:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #e14eca;
  border-color: #e14eca;
}
.btn-primary.btn-simple {
  color: #e14eca;
  border-color: #e14eca;
  background: transparent;
}
.btn-primary.btn-simple:hover, .btn-primary.btn-simple:focus, .btn-primary.btn-simple:active, .btn-primary.btn-simple:not(:disabled):not(.disabled):active {
  color: #e14eca;
  border-color: #e14eca;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-primary.btn-simple.active {
  border-color: #e14eca !important;
}
.btn-primary.btn-simple.active:hover, .btn-primary.btn-simple.active:focus, .btn-primary.btn-simple.active:active, .btn-primary.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  background-image: -moz-linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  background-color: #ba54f5 !important;
  box-shadow: none;
}
.btn-primary.btn-link {
  color: #e14eca;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-success {
  background: #00f2c3;
  background-image: linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #00f2c3;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-success.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .btn-success:active:focus, .btn-success:active:hover, .btn-success.active:focus, .btn-success.active:hover {
  background-color: #0098f0 !important;
  background-image: linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3) !important;
  background-image: -moz-linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-success:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-success:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #00f2c3;
  border-color: #00f2c3;
}
.btn-success.btn-simple {
  color: #00f2c3;
  border-color: #00f2c3;
  background: transparent;
}
.btn-success.btn-simple:hover, .btn-success.btn-simple:focus, .btn-success.btn-simple:active, .btn-success.btn-simple:not(:disabled):not(.disabled):active {
  color: #00f2c3;
  border-color: #00f2c3;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-success.btn-simple.active {
  border-color: #00f2c3 !important;
}
.btn-success.btn-simple.active:hover, .btn-success.btn-simple.active:focus, .btn-success.btn-simple.active:active, .btn-success.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #00f2c3;
  background-image: linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3) !important;
  background-image: -moz-linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3) !important;
  background-color: #0098f0 !important;
  box-shadow: none;
}
.btn-success.btn-link {
  color: #00f2c3;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-info {
  background: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #1d8cf8;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-info.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .btn-info:active:focus, .btn-info:active:hover, .btn-info.active:focus, .btn-info.active:hover {
  background-color: #3358f4 !important;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-image: -moz-linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-info:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-info:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-info.btn-simple {
  color: #1d8cf8;
  border-color: #1d8cf8;
  background: transparent;
}
.btn-info.btn-simple:hover, .btn-info.btn-simple:focus, .btn-info.btn-simple:active, .btn-info.btn-simple:not(:disabled):not(.disabled):active {
  color: #1d8cf8;
  border-color: #1d8cf8;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-info.btn-simple.active {
  border-color: #1d8cf8 !important;
}
.btn-info.btn-simple.active:hover, .btn-info.btn-simple.active:focus, .btn-info.btn-simple.active:active, .btn-info.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-image: -moz-linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-color: #3358f4 !important;
  box-shadow: none;
}
.btn-info.btn-link {
  color: #1d8cf8;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-warning {
  background: #ff8d72;
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #ff8d72;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-warning.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .btn-warning:active:focus, .btn-warning:active:hover, .btn-warning.active:focus, .btn-warning.active:hover {
  background-color: #ff6491 !important;
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72) !important;
  background-image: -moz-linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-warning:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-warning:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #ff8d72;
  border-color: #ff8d72;
}
.btn-warning.btn-simple {
  color: #ff8d72;
  border-color: #ff8d72;
  background: transparent;
}
.btn-warning.btn-simple:hover, .btn-warning.btn-simple:focus, .btn-warning.btn-simple:active, .btn-warning.btn-simple:not(:disabled):not(.disabled):active {
  color: #ff8d72;
  border-color: #ff8d72;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-warning.btn-simple.active {
  border-color: #ff8d72 !important;
}
.btn-warning.btn-simple.active:hover, .btn-warning.btn-simple.active:focus, .btn-warning.btn-simple.active:active, .btn-warning.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #ff8d72;
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72) !important;
  background-image: -moz-linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72) !important;
  background-color: #ff6491 !important;
  box-shadow: none;
}
.btn-warning.btn-link {
  color: #ff8d72;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}
.btn-warning:not(:disabled):not(.disabled):active {
  color: #ffffff;
}

.btn-danger {
  background: #fd5d93;
  background-image: linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #fd5d93;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-danger.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .btn-danger:active:focus, .btn-danger:active:hover, .btn-danger.active:focus, .btn-danger.active:hover {
  background-color: #ec250d !important;
  background-image: linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93) !important;
  background-image: -moz-linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-danger:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-danger:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #fd5d93;
  border-color: #fd5d93;
}
.btn-danger.btn-simple {
  color: #fd5d93;
  border-color: #fd5d93;
  background: transparent;
}
.btn-danger.btn-simple:hover, .btn-danger.btn-simple:focus, .btn-danger.btn-simple:active, .btn-danger.btn-simple:not(:disabled):not(.disabled):active {
  color: #fd5d93;
  border-color: #fd5d93;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-danger.btn-simple.active {
  border-color: #fd5d93 !important;
}
.btn-danger.btn-simple.active:hover, .btn-danger.btn-simple.active:focus, .btn-danger.btn-simple.active:active, .btn-danger.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #fd5d93;
  background-image: linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93) !important;
  background-image: -moz-linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93) !important;
  background-color: #ec250d !important;
  box-shadow: none;
}
.btn-danger.btn-link {
  color: #fd5d93;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-neutral {
  background: #ffffff;
  background-image: linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #ffffff;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #e14eca;
}
.btn-neutral.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover {
  background-color: #ffffff !important;
  background-image: linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  background-image: -moz-linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-neutral:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-neutral:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-neutral.btn-danger {
  color: #fd5d93;
}
.btn-neutral.btn-danger:hover, .btn-neutral.btn-danger:focus, .btn-neutral.btn-danger:active, .btn-neutral.btn-danger:active:focus {
  color: #ec250d;
}
.btn-neutral.btn-info {
  color: #1d8cf8;
}
.btn-neutral.btn-info:hover, .btn-neutral.btn-info:focus, .btn-neutral.btn-info:active, .btn-neutral.btn-info:active:focus {
  color: #3358f4;
}
.btn-neutral.btn-warning {
  color: #ff8d72;
}
.btn-neutral.btn-warning:hover, .btn-neutral.btn-warning:focus, .btn-neutral.btn-warning:active, .btn-neutral.btn-warning:active:focus {
  color: #ff6491;
}
.btn-neutral.btn-success {
  color: #00f2c3;
}
.btn-neutral.btn-success:hover, .btn-neutral.btn-success:focus, .btn-neutral.btn-success:active, .btn-neutral.btn-success:active:focus {
  color: #0098f0;
}
.btn-neutral.btn-default {
  color: #344675;
}
.btn-neutral.btn-default:hover, .btn-neutral.btn-default:focus, .btn-neutral.btn-default:active, .btn-neutral.btn-default:active:focus {
  color: #263148;
}
.btn-neutral.active, .btn-neutral:active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #ffffff;
  color: #ba54f5;
  box-shadow: none;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #ba54f5;
}
.btn-neutral:hover:not(.nav-link), .btn-neutral:focus:not(.nav-link) {
  box-shadow: none;
}
.btn-neutral.btn-simple {
  color: #ffffff;
  border-color: #ffffff;
  background: transparent;
}
.btn-neutral.btn-simple:hover, .btn-neutral.btn-simple:focus, .btn-neutral.btn-simple:active, .btn-neutral.btn-simple:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #ffffff;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-neutral.btn-simple.active {
  border-color: #ffffff !important;
}
.btn-neutral.btn-simple.active:hover, .btn-neutral.btn-simple.active:focus, .btn-neutral.btn-simple.active:active, .btn-neutral.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #ffffff;
  background-image: linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  background-image: -moz-linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  background-color: #ffffff !important;
  box-shadow: none;
}
.btn-neutral.btn-link {
  color: #ffffff;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
}

.btn-simple {
  border: 1px solid;
  border-color: #344675;
  box-shadow: none;
  padding: 10px 22px;
  background-color: transparent;
}

.btn-simple.disabled, .btn-simple.disabled:hover, .btn-simple.disabled:focus, .btn-simple.disabled.focus, .btn-simple.disabled:active, .btn-simple.disabled.active, .btn-simple:disabled, .btn-simple:disabled:hover, .btn-simple:disabled:focus, .btn-simple:disabled.focus, .btn-simple:disabled:active, .btn-simple:disabled.active, .btn-simple[disabled], .btn-simple[disabled]:hover, .btn-simple[disabled]:focus, .btn-simple[disabled].focus, .btn-simple[disabled]:active, .btn-simple[disabled].active, fieldset[disabled] .btn-simple, fieldset[disabled] .btn-simple:hover, fieldset[disabled] .btn-simple:focus, fieldset[disabled] .btn-simple.focus, fieldset[disabled] .btn-simple:active, fieldset[disabled] .btn-simple.active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
  background: transparent;
}

.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
}

.btn-link {
  border: 0;
  box-shadow: none;
  padding: 0.5rem 0.7rem;
  background: transparent;
  color: #e3e3e3;
  font-weight: 600;
}
.btn-link:hover {
  box-shadow: none !important;
  transform: none !important;
}

.btn-lg, .btn-group-lg > .btn {
  font-size: 0.875rem;
  border-radius: 0.4285rem;
  padding: 15px 48px;
}
.btn-lg.btn-simple, .btn-group-lg > .btn-simple.btn {
  padding: 14px 47px;
}

.btn-sm, .btn-group-sm > .btn {
  font-size: 0.875rem;
  border-radius: 0.2857rem;
  padding: 5px 15px;
}
.btn-sm.btn-simple, .btn-group-sm > .btn-simple.btn {
  padding: 4px 14px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group .btn.active {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-group label.btn.active {
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-round {
  border-width: 1px;
  border-radius: 30px;
}
.btn-round.btn-simple {
  padding: 10px 22px;
}

.no-caret.dropdown-toggle::after {
  display: none;
}

.btn.btn-facebook {
  background: #3b5998;
  background-image: linear-gradient(to bottom left, #3b5998, #1e2e4f, #3b5998);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-facebook:focus, .btn.btn-facebook:active, .btn.btn-facebook:hover {
  background-color: #344e86;
  background-image: linear-gradient(to bottom left, #3b5998, #1e2e4f, #3b5998) !important;
  background-image: -moz-linear-gradient(to bottom left, #3b5998, #1e2e4f, #3b5998) !important;
  color: #ffffff;
}
.btn.btn-facebook.btn-simple {
  color: #344e86;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #344e86;
}
.btn.btn-facebook.btn-simple:hover, .btn.btn-facebook.btn-simple:focus, .btn.btn-facebook.btn-simple:active {
  color: #344e86;
  border-color: #344e86;
}
.btn.btn-facebook.btn-neutral {
  color: #3b5998;
  background-color: #ffffff;
}
.btn.btn-facebook.btn-neutral:hover, .btn.btn-facebook.btn-neutral:focus, .btn.btn-facebook.btn-neutral:active {
  color: #344e86;
}
.btn.btn-twitter {
  background: #55acee;
  background-image: linear-gradient(to bottom left, #55acee, #147bc9, #55acee);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-twitter:focus, .btn.btn-twitter:active, .btn.btn-twitter:hover {
  background-color: #3ea1ec;
  background-image: linear-gradient(to bottom left, #55acee, #147bc9, #55acee) !important;
  background-image: -moz-linear-gradient(to bottom left, #55acee, #147bc9, #55acee) !important;
  color: #ffffff;
}
.btn.btn-twitter.btn-simple {
  color: #3ea1ec;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #3ea1ec;
}
.btn.btn-twitter.btn-simple:hover, .btn.btn-twitter.btn-simple:focus, .btn.btn-twitter.btn-simple:active {
  color: #3ea1ec;
  border-color: #3ea1ec;
}
.btn.btn-twitter.btn-neutral {
  color: #55acee;
  background-color: #ffffff;
}
.btn.btn-twitter.btn-neutral:hover, .btn.btn-twitter.btn-neutral:focus, .btn.btn-twitter.btn-neutral:active {
  color: #3ea1ec;
}
.btn.btn-pinterest {
  background: #cc2127;
  background-image: linear-gradient(to bottom left, #cc2127, #741316, #cc2127);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-pinterest:focus, .btn.btn-pinterest:active, .btn.btn-pinterest:hover {
  background-color: #dd2e34;
  background-image: linear-gradient(to bottom left, #cc2127, #741316, #cc2127) !important;
  background-image: -moz-linear-gradient(to bottom left, #cc2127, #741316, #cc2127) !important;
  color: #ffffff;
}
.btn.btn-pinterest.btn-simple {
  color: #dd2e34;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #dd2e34;
}
.btn.btn-pinterest.btn-simple:hover, .btn.btn-pinterest.btn-simple:focus, .btn.btn-pinterest.btn-simple:active {
  color: #dd2e34;
  border-color: #dd2e34;
}
.btn.btn-pinterest.btn-neutral {
  color: #cc2127;
  background-color: #ffffff;
}
.btn.btn-pinterest.btn-neutral:hover, .btn.btn-pinterest.btn-neutral:focus, .btn.btn-pinterest.btn-neutral:active {
  color: #dd2e34;
}
.btn.btn-google {
  background: #dd4b39;
  background-image: linear-gradient(to bottom left, #dd4b39, #96271a, #dd4b39);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-google:focus, .btn.btn-google:active, .btn.btn-google:hover {
  background-color: #d73925;
  background-image: linear-gradient(to bottom left, #dd4b39, #96271a, #dd4b39) !important;
  background-image: -moz-linear-gradient(to bottom left, #dd4b39, #96271a, #dd4b39) !important;
  color: #ffffff;
}
.btn.btn-google.btn-simple {
  color: #d73925;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #d73925;
}
.btn.btn-google.btn-simple:hover, .btn.btn-google.btn-simple:focus, .btn.btn-google.btn-simple:active {
  color: #d73925;
  border-color: #d73925;
}
.btn.btn-google.btn-neutral {
  color: #dd4b39;
  background-color: #ffffff;
}
.btn.btn-google.btn-neutral:hover, .btn.btn-google.btn-neutral:focus, .btn.btn-google.btn-neutral:active {
  color: #d73925;
}
.btn.btn-linkedin {
  background: #0077B5;
  background-image: linear-gradient(to bottom left, #0077B5, #00344f, #0077B5);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-linkedin:focus, .btn.btn-linkedin:active, .btn.btn-linkedin:hover {
  background-color: #00669c;
  background-image: linear-gradient(to bottom left, #0077B5, #00344f, #0077B5) !important;
  background-image: -moz-linear-gradient(to bottom left, #0077B5, #00344f, #0077B5) !important;
  color: #ffffff;
}
.btn.btn-linkedin.btn-simple {
  color: #00669c;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #00669c;
}
.btn.btn-linkedin.btn-simple:hover, .btn.btn-linkedin.btn-simple:focus, .btn.btn-linkedin.btn-simple:active {
  color: #00669c;
  border-color: #00669c;
}
.btn.btn-linkedin.btn-neutral {
  color: #0077B5;
  background-color: #ffffff;
}
.btn.btn-linkedin.btn-neutral:hover, .btn.btn-linkedin.btn-neutral:focus, .btn.btn-linkedin.btn-neutral:active {
  color: #00669c;
}
.btn.btn-dribbble {
  background: #ea4c89;
  background-image: linear-gradient(to bottom left, #ea4c89, #ba1655, #ea4c89);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-dribbble:focus, .btn.btn-dribbble:active, .btn.btn-dribbble:hover {
  background-color: #ed679b;
  background-image: linear-gradient(to bottom left, #ea4c89, #ba1655, #ea4c89) !important;
  background-image: -moz-linear-gradient(to bottom left, #ea4c89, #ba1655, #ea4c89) !important;
  color: #ffffff;
}
.btn.btn-dribbble.btn-simple {
  color: #ed679b;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #ed679b;
}
.btn.btn-dribbble.btn-simple:hover, .btn.btn-dribbble.btn-simple:focus, .btn.btn-dribbble.btn-simple:active {
  color: #ed679b;
  border-color: #ed679b;
}
.btn.btn-dribbble.btn-neutral {
  color: #ea4c89;
  background-color: #ffffff;
}
.btn.btn-dribbble.btn-neutral:hover, .btn.btn-dribbble.btn-neutral:focus, .btn.btn-dribbble.btn-neutral:active {
  color: #ed679b;
}
.btn.btn-github {
  background: #333333;
  background-image: linear-gradient(to bottom left, #333333, black, #333333);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-github:focus, .btn.btn-github:active, .btn.btn-github:hover {
  background-color: #ccc;
  background-image: linear-gradient(to bottom left, #333333, black, #333333) !important;
  background-image: -moz-linear-gradient(to bottom left, #333333, black, #333333) !important;
  color: #ffffff;
}
.btn.btn-github.btn-simple {
  color: #ccc;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #ccc;
}
.btn.btn-github.btn-simple:hover, .btn.btn-github.btn-simple:focus, .btn.btn-github.btn-simple:active {
  color: #ccc;
  border-color: #ccc;
}
.btn.btn-github.btn-neutral {
  color: #333333;
  background-color: #ffffff;
}
.btn.btn-github.btn-neutral:hover, .btn.btn-github.btn-neutral:focus, .btn.btn-github.btn-neutral:active {
  color: #ccc;
}
.btn.btn-youtube {
  background: #e52d27;
  background-image: linear-gradient(to bottom left, #e52d27, #941612, #e52d27);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-youtube:focus, .btn.btn-youtube:active, .btn.btn-youtube:hover {
  background-color: #e84842;
  background-image: linear-gradient(to bottom left, #e52d27, #941612, #e52d27) !important;
  background-image: -moz-linear-gradient(to bottom left, #e52d27, #941612, #e52d27) !important;
  color: #ffffff;
}
.btn.btn-youtube.btn-simple {
  color: #e84842;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #e84842;
}
.btn.btn-youtube.btn-simple:hover, .btn.btn-youtube.btn-simple:focus, .btn.btn-youtube.btn-simple:active {
  color: #e84842;
  border-color: #e84842;
}
.btn.btn-youtube.btn-neutral {
  color: #e52d27;
  background-color: #ffffff;
}
.btn.btn-youtube.btn-neutral:hover, .btn.btn-youtube.btn-neutral:focus, .btn.btn-youtube.btn-neutral:active {
  color: #e84842;
}
.btn.btn-instagram {
  background: #125688;
  background-image: linear-gradient(to bottom left, #125688, #061d2e, #125688);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-instagram:focus, .btn.btn-instagram:active, .btn.btn-instagram:hover {
  background-color: #1667a3;
  background-image: linear-gradient(to bottom left, #125688, #061d2e, #125688) !important;
  background-image: -moz-linear-gradient(to bottom left, #125688, #061d2e, #125688) !important;
  color: #ffffff;
}
.btn.btn-instagram.btn-simple {
  color: #1667a3;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #1667a3;
}
.btn.btn-instagram.btn-simple:hover, .btn.btn-instagram.btn-simple:focus, .btn.btn-instagram.btn-simple:active {
  color: #1667a3;
  border-color: #1667a3;
}
.btn.btn-instagram.btn-neutral {
  color: #125688;
  background-color: #ffffff;
}
.btn.btn-instagram.btn-neutral:hover, .btn.btn-instagram.btn-neutral:focus, .btn.btn-instagram.btn-neutral:active {
  color: #1667a3;
}
.btn.btn-reddit {
  background: #ff4500;
  background-image: linear-gradient(to bottom left, #ff4500, #992900, #ff4500);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-reddit:focus, .btn.btn-reddit:active, .btn.btn-reddit:hover {
  background-color: #ff5b1f;
  background-image: linear-gradient(to bottom left, #ff4500, #992900, #ff4500) !important;
  background-image: -moz-linear-gradient(to bottom left, #ff4500, #992900, #ff4500) !important;
  color: #ffffff;
}
.btn.btn-reddit.btn-simple {
  color: #ff5b1f;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #ff5b1f;
}
.btn.btn-reddit.btn-simple:hover, .btn.btn-reddit.btn-simple:focus, .btn.btn-reddit.btn-simple:active {
  color: #ff5b1f;
  border-color: #ff5b1f;
}
.btn.btn-reddit.btn-neutral {
  color: #ff4500;
  background-color: #ffffff;
}
.btn.btn-reddit.btn-neutral:hover, .btn.btn-reddit.btn-neutral:focus, .btn.btn-reddit.btn-neutral:active {
  color: #ff5b1f;
}
.btn.btn-tumblr {
  background: #35465c;
  background-image: linear-gradient(to bottom left, #35465c, #10151b, #35465c);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-tumblr:focus, .btn.btn-tumblr:active, .btn.btn-tumblr:hover {
  background-color: #40556f;
  background-image: linear-gradient(to bottom left, #35465c, #10151b, #35465c) !important;
  background-image: -moz-linear-gradient(to bottom left, #35465c, #10151b, #35465c) !important;
  color: #ffffff;
}
.btn.btn-tumblr.btn-simple {
  color: #40556f;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #40556f;
}
.btn.btn-tumblr.btn-simple:hover, .btn.btn-tumblr.btn-simple:focus, .btn.btn-tumblr.btn-simple:active {
  color: #40556f;
  border-color: #40556f;
}
.btn.btn-tumblr.btn-neutral {
  color: #35465c;
  background-color: #ffffff;
}
.btn.btn-tumblr.btn-neutral:hover, .btn.btn-tumblr.btn-neutral:focus, .btn.btn-tumblr.btn-neutral:active {
  color: #40556f;
}
.btn.btn-behance {
  background: #1769ff;
  background-image: linear-gradient(to bottom left, #1769ff, #003eb0, #1769ff);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
  background-size: 210% 210%;
  background-position: top right;
  background-repeat: space;
}
.btn.btn-behance:focus, .btn.btn-behance:active, .btn.btn-behance:hover {
  background-color: #367dff;
  background-image: linear-gradient(to bottom left, #1769ff, #003eb0, #1769ff) !important;
  background-image: -moz-linear-gradient(to bottom left, #1769ff, #003eb0, #1769ff) !important;
  color: #ffffff;
}
.btn.btn-behance.btn-simple {
  color: #367dff;
  background-color: transparent;
  background-image: none !important;
  box-shadow: none;
  border-color: #367dff;
}
.btn.btn-behance.btn-simple:hover, .btn.btn-behance.btn-simple:focus, .btn.btn-behance.btn-simple:active {
  color: #367dff;
  border-color: #367dff;
}
.btn.btn-behance.btn-neutral {
  color: #1769ff;
  background-color: #ffffff;
}
.btn.btn-behance.btn-neutral:hover, .btn.btn-behance.btn-neutral:focus, .btn.btn-behance.btn-neutral:active {
  color: #367dff;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #ffffff;
}

@media (max-width: 991.98px) {
  .btn-group .btn {
    padding-left: 23px;
    padding-right: 23px;
  }
}
.close {
  transition: all 0.15s ease;
}
.close > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.6);
  line-height: 17px;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 50%;
  font-size: 1.25rem;
  display: block;
  transition: all 0.15s ease;
}
.close:hover, .close:focus {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.9);
  outline: none;
}
.close:hover span:not(.sr-only), .close:focus span:not(.sr-only) {
  background-color: transparent;
}

.custom-control-label::before {
  border: 1px solid #cad1d7;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.custom-control-label span {
  position: relative;
  top: 2px;
}

.custom-control-label {
  margin-bottom: 0;
}

.custom-control-input:active ~ .custom-control-label::before {
  border-color: #e14eca;
}

.custom-control-alternative .custom-control-label::before {
  border: 0;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}
.custom-control-alternative .custom-control-input:checked ~ .custom-control-label::before {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.custom-control-alternative .custom-control-input:active ~ .custom-control-label::before, .custom-control-alternative .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}

.custom-checkbox .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.7500000025rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #e14eca;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(225, 78, 202, 0.5);
}

.custom-radio .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.7500000025rem;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #e14eca;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.custom-radio .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-radio .custom-control-input:disabled:checked::before {
  border-color: rgba(225, 78, 202, 0.5);
}

.custom-toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 1.5rem;
}
.custom-toggle input {
  display: none;
}
.custom-toggle input:checked + .custom-toggle-slider {
  border: 1px solid #e14eca;
}
.custom-toggle input:checked + .custom-toggle-slider:before {
  background: #e14eca;
  transform: translateX(1.625rem);
}
.custom-toggle input:disabled + .custom-toggle-slider {
  border: 1px solid #e9ecef;
}
.custom-toggle input:disabled:checked + .custom-toggle-slider {
  border: 1px solid #e9ecef;
}
.custom-toggle input:disabled:checked + .custom-toggle-slider:before {
  background-color: #e87ad7;
}

.custom-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #cad1d7;
  border-radius: 34px !important;
  background-color: transparent;
}
.custom-toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  border-radius: 50% !important;
  background-color: #ddd;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.dropdown-menu {
  border: 0;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0.1428rem;
  transition: all 150ms linear;
}
.dropdown-menu.dropdown-menu-right:before, .dropdown-menu.dropdown-menu-right:after {
  left: auto;
  right: 10px;
}
.dropdown-menu.dropdown-black {
  background: linear-gradient(to bottom, #222a42 0%, #1d253b 100%);
  border: 1px solid #344675;
}
.dropdown-menu.dropdown-black .dropdown-item {
  color: rgba(255, 255, 255, 0.7);
}
.dropdown-menu.dropdown-black .dropdown-divider {
  border-color: #344675;
}
.dropdown-menu.dropdown-black:before {
  color: #222a42;
  z-index: 2;
}
.dropdown-menu.dropdown-black:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  z-index: 1;
  vertical-align: middle;
  content: "";
  top: -6px;
  left: 10px;
  right: auto;
  color: #344675;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropdown-menu.dropdown-black.dropdown-menu-right:after {
  left: auto;
  right: 10px;
}
.dropup .dropdown-menu.dropdown-black:after {
  color: #1d253b;
  z-index: 2;
}
.dropup .dropdown-menu.dropdown-black:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -6px;
  right: auto;
  left: 10px;
  color: #555555;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  border-bottom: none;
  z-index: 1;
}
.dropdown-menu i {
  margin-right: 5px;
  position: relative;
  top: 1px;
}
.dropdown-menu .tim-icons {
  margin-right: 10px;
  position: relative;
  top: 4px;
  font-size: 18px;
  margin-top: -5px;
  opacity: 0.5;
}
.dropdown-menu .dropdown-item.active, .dropdown-menu .dropdown-item:active {
  color: inherit;
}
.dropup .dropdown-menu:before {
  display: none;
}
.dropup .dropdown-menu:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -5px;
  right: auto;
  left: 10px;
  color: #ffffff;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  border-bottom: none;
}
.dropup .dropdown-menu.dropdown-menu-right:after, .dropup .dropdown-menu.dropdown-menu-right:before {
  right: 10px;
  left: auto;
}
.dropdown-menu:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
}
.dropdown-menu .dropdown-item, .bootstrap-select .dropdown-menu.inner li a {
  font-size: 0.7500000025rem;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
}
.dropdown-menu .dropdown-item:hover, .dropdown-menu .dropdown-item:focus, .bootstrap-select .dropdown-menu.inner li a:hover, .bootstrap-select .dropdown-menu.inner li a:focus {
  background-color: rgba(222, 222, 222, 0.3);
}
.dropdown-menu .dropdown-item.disabled, .dropdown-menu .dropdown-item:disabled, .bootstrap-select .dropdown-menu.inner li a.disabled, .bootstrap-select .dropdown-menu.inner li a:disabled {
  color: rgba(182, 182, 182, 0.6);
}
.dropdown-menu .dropdown-item.disabled:hover, .dropdown-menu .dropdown-item.disabled:focus, .dropdown-menu .dropdown-item:disabled:hover, .dropdown-menu .dropdown-item:disabled:focus, .bootstrap-select .dropdown-menu.inner li a.disabled:hover, .bootstrap-select .dropdown-menu.inner li a.disabled:focus, .bootstrap-select .dropdown-menu.inner li a:disabled:hover, .bootstrap-select .dropdown-menu.inner li a:disabled:focus {
  background-color: transparent;
  box-shadow: none;
}
.dropdown-menu .dropdown-divider {
  background-color: rgba(222, 222, 222, 0.5);
}
.dropdown-menu .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(182, 182, 182, 0.6);
  font-size: 0.62475rem;
  text-transform: uppercase;
  font-weight: 600;
}
.dropdown-menu.dropdown-primary {
  background-color: #df41c6;
}
.dropdown-menu.dropdown-primary:before {
  color: #df41c6;
}
.dropdown-menu.dropdown-primary .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-primary .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover, .dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-primary .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info {
  background-color: #0e84f8;
}
.dropdown-menu.dropdown-info:before {
  color: #0e84f8;
}
.dropdown-menu.dropdown-info .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-info .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-info .dropdown-item:hover, .dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger {
  background-color: #fd4e89;
}
.dropdown-menu.dropdown-danger:before {
  color: #fd4e89;
}
.dropdown-menu.dropdown-danger .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-danger .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover, .dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success {
  background-color: #00e3b7;
}
.dropdown-menu.dropdown-success:before {
  color: #00e3b7;
}
.dropdown-menu.dropdown-success .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-success .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-success .dropdown-item:hover, .dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning {
  background-color: #ff8163;
}
.dropdown-menu.dropdown-warning:before {
  color: #ff8163;
}
.dropdown-menu.dropdown-warning .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-warning .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover, .dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown .dropdown-menu, .dropup:not(.bootstrap-select) .dropdown-menu, .bootstrap-select .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.bottom {
  transform: translate3d(0, -20px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 100% !important;
}
.dropdown-menu.bootstrap-datetimepicker-widget.top {
  transform: translate3d(0, -20px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
}
.dropdown-menu.bootstrap-datetimepicker-widget.top, .dropdown-menu.bootstrap-datetimepicker-widget.bottom {
  transform: translate3d(0, -20px, 0) !important;
}
.bootstrap-select.dropup .dropdown-menu:not(.inner) {
  transform: translate3d(0, 25px, 0) !important;
}
.dropup:not(.bootstrap-select) .dropdown-menu {
  transform: translate3d(0, 20px, 0) !important;
  top: auto !important;
  bottom: 100%;
}
.dropdown.show .dropdown-menu, .bootstrap-select.show .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.top.open, .dropdown-menu.bootstrap-datetimepicker-widget.bottom.open, .dropup.show:not(.bootstrap-select) .dropdown-menu, .navbar .dropdown.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
  transform: translate3d(0, 1px, 0) !important;
}
.dropdown-menu.bootstrap-datetimepicker-widget.top.open, .dropdown-menu.bootstrap-datetimepicker-widget.bottom.open {
  transform: translate3d(0, 0px, 0) !important;
}
.dropup.show:not(.bootstrap-select) .dropdown-menu {
  transform: translate3d(0, -2px, 0) !important;
}
.dropdown-menu.dropdown-navbar {
  left: -80px;
}
.dropdown-menu.dropdown-navbar:before, .dropdown-menu.dropdown-navbar:after {
  left: auto;
  right: 17px;
}

.btn {
  cursor: pointer;
}
.btn.dropdown-toggle[data-toggle=dropdown] {
  padding: 10px;
  margin: 0;
  margin-bottom: 5px;
}
.btn.dropdown-toggle[data-toggle=dropdown]:after {
  content: "";
  margin-left: 5px;
}
.btn span.bs-caret {
  display: none;
}
.btn.btn-link.dropdown-toggle {
  height: 22px;
  padding: 0;
  margin-right: 5px;
}

.dropdown-toggle:after {
  content: normal;
  content: initial;
}

.btn:not(:disabled):not(.disabled).active:focus,
.btn:not(:disabled):not(.disabled):active:focus,
.show > .btn.dropdown-toggle:focus {
  box-shadow: none;
}

.dropdown-menu-sm {
  min-width: 100px;
  border: 0.4285rem;
}

.dropdown-menu-lg {
  min-width: 260px;
  border-radius: 0.4285rem;
}

.dropdown-menu-xl {
  min-width: 450px;
  border-radius: 0.4285rem;
}

@media (max-width: 991.98px) {
  .button-dropdown {
    display: none;
  }
  .dropdown-toggle:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
}
@media (min-width: 992px) {
  .dropdown-menu .dropdown-item {
    color: #9A9A9A;
  }
}
.footer {
  padding: 24px 30px;
}
.footer [class*=container-] {
  padding: 0;
}
.footer .nav {
  display: inline-block;
  float: left;
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}
.footer .nav-item {
  display: inline-block;
}
.footer .nav-item:first-child a {
  padding-left: 0;
}
.footer .nav-link {
  color: #ffffff;
  padding: 0.5rem;
  font-size: 0.7500000025rem;
  text-transform: uppercase;
  text-decoration: none;
}
.footer .nav-link:hover {
  text-decoration: none;
}
.footer .copyright {
  font-size: 0.7500000025rem;
  line-height: 1.8;
  color: #ffffff;
}
.footer:after {
  display: table;
  clear: both;
  content: " ";
}

@media (max-width: 991.98px) {
  .footer {
    padding-left: 30px;
    text-align: center;
  }
  .footer .copyright {
    text-align: right;
  }
}
@media (min-width: 1200px) {
  .footer .copyright {
    float: right;
    margin-top: 5px;
  }
}
@media (max-width: 767.98px) {
  .footer {
    text-align: center;
  }
  .footer nav {
    display: block;
    margin-bottom: 5px;
    float: none;
  }
  .footer .copyright {
    text-align: center;
  }
}
@media (max-width: 767.98px) {
  .footer .copyright {
    text-align: center;
  }
  .footer .nav {
    float: none;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .footer {
    padding-left: 30px !important;
    text-align: center;
  }
  .footer .copyright {
    float: right;
    margin-top: 5px;
  }
}
/* Form controls */
.form-control::-moz-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-moz-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control::-webkit-input-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-ms-input-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control {
  border-color: #2b3553;
  border-radius: 0.4285rem;
  font-size: 0.7500000025rem;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.form-control:focus {
  border-color: #e14eca;
  background-color: transparent;
  box-shadow: none;
}
.form-control:focus + .input-group-append .input-group-text, .form-control:focus ~ .input-group-append .input-group-text, .form-control:focus + .input-group-prepend .input-group-text, .form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #e14eca;
  border-left: none;
  background-color: transparent;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  box-shadow: none;
}
.has-danger .form-control.form-control-success, .has-danger .form-control.form-control-danger, .has-success .form-control.form-control-success, .has-success .form-control.form-control-danger {
  background-image: none;
}
.form-control + .form-control-feedback {
  border-radius: 0.4285rem;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 0.4285rem 0.4285rem 0 0;
  border-bottom-color: transparent;
}
.form-control + .input-group-append .input-group-text, .form-control + .input-group-prepend .input-group-text {
  background-color: #ffffff;
}

.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text,
.has-success .form-control {
  border-color: #2b3553;
}

.has-success .form-control:focus,
.has-success.input-group-focus .input-group-append .input-group-text,
.has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #00bf9a;
}

.has-danger .form-control,
.has-danger .input-group-append .input-group-text,
.has-danger .input-group-prepend .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text,
.has-danger.input-group-focus .input-group-append .input-group-text {
  border-color: #f33620;
  color: #ec250d;
  background-color: rgba(222, 222, 222, 0.1);
}
.has-danger .form-control:focus,
.has-danger .input-group-append .input-group-text:focus,
.has-danger .input-group-prepend .input-group-text:focus,
.has-danger.input-group-focus .input-group-prepend .input-group-text:focus,
.has-danger.input-group-focus .input-group-append .input-group-text:focus {
  background-color: transparent;
}

.has-success:after,
.has-danger:after {
  font-family: "nucleo";
  content: "\\ea1b";
  display: inline-block;
  position: absolute;
  right: 20px;
  top: 13px;
  color: #00f2c3;
  font-size: 11px;
}
.has-success.form-control-lg:after,
.has-danger.form-control-lg:after {
  font-size: 13px;
  top: 24px;
}
.has-success.has-label:after,
.has-danger.has-label:after {
  top: 37px;
}
.has-success.form-check:after,
.has-danger.form-check:after {
  display: none !important;
}
.has-success.form-check .form-check-label,
.has-danger.form-check .form-check-label {
  color: #00f2c3;
}

.has-danger:after {
  content: "\\ea48";
  color: #ec250d;
}
.has-danger.form-check .form-check-label {
  color: #ec250d;
}
.has-danger.input-group-focus .input-group-text {
  border-color: #ec250d !important;
}

@media (max-width: 575.98px) {
  .form-horizontal .col-form-label,
.form-horizontal .label-on-right {
    text-align: inherit;
    padding-top: 0;
  }
  .form-horizontal .col-form-label code,
.form-horizontal .label-on-right code {
    padding: 0 10px;
  }
}
@media (min-width: 1200px) {
  .container-lg {
    max-width: 1160px;
  }
}
.icon {
  width: 2.375rem;
  height: 2.375rem;
}
.icon i, .icon svg {
  font-size: 1.625rem;
}

.icon + .icon-text {
  padding-left: 1rem;
  width: calc(100% - 2.375rem - 1);
}

.icon-xl {
  width: 5rem;
  height: 5rem;
}
.icon-xl i, .icon-xl svg {
  font-size: 4.25rem;
}

.icon-xl + .icon-text {
  width: calc(100% - 5rem - 1);
}

.icon-lg {
  width: 3.6rem;
  height: 3.6rem;
}
.icon-lg i, .icon-lg svg {
  font-size: 2.85rem;
}

.icon-sm {
  width: 1.875rem;
  height: 1.875rem;
}
.icon-sm i, .icon-sm svg {
  font-size: 1.125rem;
}

.icon-shape {
  padding: 12px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.icon-shape i, .icon-shape svg {
  font-size: 1.25rem;
}
.icon-shape.icon-lg i, .icon-shape.icon-lg svg {
  font-size: 1.625rem;
}
.icon-shape.icon-sm i, .icon-shape.icon-sm svg {
  font-size: 0.875rem;
}
.icon-shape svg {
  width: 30px;
  height: 30px;
}

.icon-shape-primary {
  color: #e418c4;
  background-color: rgba(232, 122, 215, 0.5);
}

.icon-shape-secondary {
  color: #d3d9e5;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-success {
  color: #00bf9a;
  background-color: rgba(38, 255, 213, 0.5);
}

.icon-shape-info {
  color: #0073e2;
  background-color: rgba(78, 165, 250, 0.5);
}

.icon-shape-warning {
  color: #ff643f;
  background-color: rgba(255, 182, 165, 0.5);
}

.icon-shape-danger {
  color: #ff2871;
  background-color: rgba(254, 143, 181, 0.5);
}

.icon-shape-light {
  color: #879cb0;
  background-color: rgba(201, 207, 212, 0.5);
}

.icon-shape-dark {
  color: #090c0e;
  background-color: rgba(56, 63, 69, 0.5);
}

.icon-shape-default {
  color: #1e2e58;
  background-color: rgba(68, 91, 152, 0.5);
}

.icon-shape-white {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-neutral {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-darker {
  color: black;
  background-color: rgba(23, 26, 28, 0.5);
}

img {
  max-width: 100%;
  border-radius: 0.2857rem;
}

.img-raised {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.form-group.has-danger .error,
.input-group.has-danger .error {
  color: #ec250d;
}

.form-group.has-success .error,
.input-group.has-success .error {
  color: #00f2c3;
}

.form-group.no-border.form-control-lg .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .input-group-append .input-group-text {
  padding: 15px 0 15px 19px;
}
.form-group.no-border.form-control-lg .form-control,
.input-group.no-border.form-control-lg .form-control {
  padding: 15px 19px;
}
.form-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 15px 19px 15px 0;
}

.form-group.form-control-lg .form-control,
.input-group.form-control-lg .form-control {
  padding: 14px 18px;
  height: 100%;
}
.form-group.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 14px 18px 14px 0;
}
.form-group.form-control-lg .input-group-prepend .input-group-text,
.form-group.form-control-lg .input-group-append .input-group-text,
.input-group.form-control-lg .input-group-prepend .input-group-text,
.input-group.form-control-lg .input-group-append .input-group-text {
  padding: 14px 0 15px 18px;
}
.form-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.form-group.form-control-lg .input-group-append .input-group-text + .form-control,
.input-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.input-group.form-control-lg .input-group-append .input-group-text + .form-control {
  padding: 15px 18px 15px 16px;
}

.form-group.no-border .form-control,
.input-group.no-border .form-control {
  padding: 11px 19px;
}
.form-group.no-border .form-control + .input-group-prepend .input-group-text, .form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  padding: 11px 19px 11px 0;
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  padding: 11px 0 11px 19px;
}

.form-group .form-control,
.input-group .form-control {
  padding: 10px 18px 10px 18px;
}
.form-group .form-control + .input-group-prepend .input-group-text, .form-group .form-control + .input-group-append .input-group-text,
.input-group .form-control + .input-group-prepend .input-group-text,
.input-group .form-control + .input-group-append .input-group-text {
  padding: 10px 18px 10px 0;
}
.form-group .input-group-prepend .input-group-text,
.form-group .input-group-append .input-group-text,
.input-group .input-group-prepend .input-group-text,
.input-group .input-group-append .input-group-text {
  padding: 10px 0 10px 18px;
}
.form-group .input-group-prepend .input-group-text + .form-control, .form-group .input-group-prepend .input-group-text ~ .form-control,
.form-group .input-group-append .input-group-text + .form-control,
.form-group .input-group-append .input-group-text ~ .form-control,
.input-group .input-group-prepend .input-group-text + .form-control,
.input-group .input-group-prepend .input-group-text ~ .form-control,
.input-group .input-group-append .input-group-text + .form-control,
.input-group .input-group-append .input-group-text ~ .form-control {
  padding: 10px 19px 11px 16px;
}

.form-group.no-border .form-control,
.form-group.no-border .form-control + .input-group-prepend .input-group-text,
.form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: #242c45;
  border: medium none;
}
.form-group.no-border .form-control:focus, .form-group.no-border .form-control:active, .form-group.no-border .form-control:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control:focus,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.input-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:active {
  border: medium none;
  background-color: #252e49;
}
.form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: #252e49;
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  background-color: #242c45;
  border: none;
}

.has-error .form-control-feedback, .has-error .control-label {
  color: #ec250d;
}

.has-success .form-control-feedback, .has-success .control-label {
  color: #00f2c3;
}

.input-group-append .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
  color: #ffffff;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  opacity: 0.5;
}
.has-danger.input-group-focus .input-group-append .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text {
  background-color: transparent;
}
.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text {
  background-color: transparent;
}
.has-danger .form-control:focus + .input-group-append .input-group-text,
.has-danger .form-control:focus + .input-group-prepend .input-group-text {
  color: #ec250d;
}
.has-success .form-control:focus + .input-group-append .input-group-text,
.has-success .form-control:focus + .input-group-prepend .input-group-text {
  color: #00f2c3;
}
.input-group-append .input-group-text + .form-control, .input-group-append .input-group-text ~ .form-control,
.input-group-prepend .input-group-text + .form-control,
.input-group-prepend .input-group-text ~ .form-control {
  padding: -0.5rem 0.7rem;
  padding-left: 18px;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  width: 17px;
}

.input-group-append,
.input-group-prepend .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
  color: #ffffff;
  margin: 0;
}

.input-group-append .input-group-text {
  border-left: none;
}

.input-group-prepend .input-group-text {
  border-right: none;
}

.input-group-focus .input-group-prepend .input-group-text,
.input-group-focus .input-group-append .input-group-text {
  background-color: #ffffff;
  border-color: #e14eca;
  background-color: transparent;
  border-color: #e14eca;
}
.input-group-focus.no-border .input-group-prepend .input-group-text,
.input-group-focus.no-border .input-group-append .input-group-text {
  background-color: #252e49;
}

.input-group,
.form-group {
  margin-bottom: 10px;
  position: relative;
}
.input-group .form-control-static,
.form-group .form-control-static {
  margin-top: 9px;
}

.input-group[disabled] .input-group-prepend .input-group-text,
.input-group[disabled] .input-group-append .input-group-text {
  background-color: #E3E3E3;
}

.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child) {
  border-radius: 0.4285rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0 none;
}

.input-group .form-control:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #1d253b;
  color: #344675;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 11px 0.7rem;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #DDDDDD;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

textarea.form-control {
  max-width: 100%;
  max-height: 80px;
  padding: 10px 10px 0 0;
  resize: none;
  border: none;
  border-bottom: 1px solid #2b3553;
  border-radius: 0;
  line-height: 2;
}
textarea.form-control:focus, textarea.form-control:active {
  border-left: none;
  border-top: none;
  border-right: none;
}

.has-success.form-group .form-control, .has-success.form-group.no-border .form-control,
.has-danger.form-group .form-control,
.has-danger.form-group.no-border .form-control {
  padding-right: 40px;
}

.form.form-newsletter .form-group {
  float: left;
  width: 78%;
  margin-right: 2%;
  margin-top: 9px;
}

.input-group .input-group-btn {
  padding: 0 12px;
}

.form-group input[type=file] {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.form-text {
  font-size: 0.7500000025rem;
  color: rgba(255, 255, 255, 0.8);
}

.form-control-lg {
  padding: 0;
  font-size: inherit;
  line-height: 0;
  border-radius: 0;
}
.form-control-lg .form-control {
  height: calc(2.875rem + 2px);
}

.form-horizontal .col-form-label,
.form-horizontal .label-on-right {
  padding: 10px 5px 0 15px;
  text-align: right;
  max-width: 180px;
}
.form-horizontal .checkbox-radios {
  margin-bottom: 15px;
}
.form-horizontal .checkbox-radios .form-check:first-child {
  margin-top: 8px;
}
.form-horizontal .label-on-right {
  text-align: left;
  padding: 10px 15px 0 5px;
}
.form-horizontal .form-check-inline {
  margin-top: 6px;
}
.form-horizontal .form-check-inline .form-check-label {
  margin-right: 1.5rem;
}

.search-bar {
  margin-left: 30px;
}
.search-bar .btn {
  margin: 0;
}
.search-bar.input-group {
  border-radius: 25px;
  z-index: 4;
  margin-bottom: 0;
  height: 43px;
}
.search-bar.input-group .input-group-addon {
  padding: 10px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
}
.search-bar.input-group i {
  font-size: 20px;
  color: white;
  margin-top: 0 !important;
}
.search-bar.input-group input {
  background: transparent;
  border: none !important;
  border-radius: 0;
  padding: 12px !important;
  font-size: 12px;
  opacity: 0.5;
}
.search-bar.input-group input:focus {
  background: transparent;
}
.search-bar.input-group .form-control {
  opacity: 1;
  color: #ffffff;
}
.search-bar.input-group .form-control::placeholder {
  color: #ffffff;
}

.modal-search .modal-dialog {
  max-width: 1000px;
  margin: 20px auto;
}
.modal-search .modal-dialog .form-control {
  border: none;
  color: #222a42;
}
.modal-search .modal-dialog .form-control::placeholder {
  color: #222a42;
}

.input-group-prepend {
  margin-right: 0;
}

.input-group-prepend .tim-icons,
.input-group-append .tim-icons {
  font-size: 1rem;
}

.info.info-hover .info-title {
  transition: color 0.4s;
}
.info.info-hover:hover .icon {
  transform: translate3d(0, -0.5rem, 0);
}
.info.info-hover:hover .icon.icon-primary.icon-circle {
  box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.3);
}
.info.info-hover:hover .icon.icon-info.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.3);
}
.info.info-hover:hover .icon.icon-success.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.3);
}
.info.info-hover:hover .icon.icon-warning.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.3);
}
.info.info-hover:hover .icon.icon-danger.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.3);
}
.info.info-hover:hover .icon.icon-info + .info-title {
  color: #1d8cf8;
}
.info.info-hover:hover .icon.icon-warning + .info-title {
  color: #ff8d72;
}
.info.info-hover:hover .icon.icon-danger + .info-title {
  color: #fd5d93;
}
.info.info-hover:hover .icon.icon-primary + .info-title {
  color: #e14eca;
}
.info.info-hover:hover .icon.icon-success + .info-title {
  color: #00f2c3;
}
.info .icon {
  color: #344675;
  transition: transform 0.4s, box-shadow 0.4s;
}
.info .icon > i {
  font-size: 2.3em;
}
.info .icon.icon-circle {
  max-width: 70px;
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border-radius: 50%;
  box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);
  font-size: 0.62475rem;
  background-color: #ffffff;
  position: relative;
}
.info .icon.icon-circle i {
  line-height: 2.6em;
}
.info .info-title {
  margin: 15px 0 5px;
  padding: 0 15px;
  color: #222a42;
  font-weight: 600;
}
.info p {
  color: #344675;
  padding: 0 15px;
  font-size: 1.1em;
}

.info-horizontal {
  text-align: left !important;
}
.info-horizontal .icon {
  float: left;
  margin-top: 23px;
  margin-right: 10px;
}
.info-horizontal .icon > i {
  font-size: 2em;
}
.info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.info-horizontal .description {
  overflow: hidden;
}

.icon.icon-primary {
  color: #e14eca;
}
.icon.icon-primary.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(225, 78, 202, 0.5);
}
.icon.icon-info {
  color: #1d8cf8;
}
.icon.icon-info.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(29, 140, 248, 0.5);
}
.icon.icon-success {
  color: #00f2c3;
}
.icon.icon-success.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(0, 242, 195, 0.5);
}
.icon.icon-warning {
  color: #ff8d72;
}
.icon.icon-warning.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(255, 141, 114, 0.5);
}
.icon.icon-danger {
  color: #fd5d93;
}
.icon.icon-danger.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(253, 93, 147, 0.5);
}
.icon.icon-white {
  color: #ffffff;
}

.modal-content {
  border: 0;
}
.modal-content .modal-header {
  border-bottom: none;
}
.modal-content .modal-header button {
  position: absolute;
  right: 27px;
  top: 24px;
  outline: 0;
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
}
.modal-content .modal-header .title {
  color: #222a42;
  margin-top: 5px;
  margin-bottom: 0;
}
.modal-content .modal-header .modal-title {
  color: #222a42;
}
.modal-content .modal-header i.tim-icons {
  font-size: 16px;
}
.modal-content .modal-body {
  line-height: 1.9;
}
.modal-content .modal-body p {
  color: #222a42;
}
.modal-content .modal-footer {
  border-top: 0; /* Safari 6.1+ */
  justify-content: space-between;
}
.modal-content .modal-footer button {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}
.modal-content .modal-footer button.pull-left {
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  left: -5px;
}
.modal-content .modal-body + .modal-footer {
  padding-top: 0;
}

.modal-backdrop {
  background: rgba(0, 0, 0, 0.3);
}

.modal .modal-login {
  max-width: 320px;
}
.modal .modal-login .card-login .logo-container {
  width: 65px;
  margin-bottom: 38px;
  margin-top: 27px;
}
.modal.modal-mini p {
  text-align: center;
}
.modal.modal-mini .modal-dialog {
  max-width: 255px;
  margin: 0 auto;
}
.modal.modal-mini.show .modal-dialog {
  transform: translate(0, 30%);
}
.modal.modal-mini .modal-footer button {
  text-transform: uppercase;
  color: #ffffff;
}
.modal.modal-mini .modal-footer button:first-child {
  opacity: 0.5;
}
.modal .modal-profile {
  width: 70px;
  height: 70px;
  background-color: #ffffff;
  border-radius: 50%;
  text-align: center;
  line-height: 5.7;
  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.3);
}
.modal .modal-profile i {
  color: #e14eca;
  font-size: 21px;
  margin-top: -10px;
}
.modal .modal-profile[class*=modal-profile-] i {
  color: #ffffff;
}
.modal .modal-profile.modal-profile-primary {
  background-color: #e14eca;
}
.modal .modal-profile.modal-profile-danger {
  background-color: #fd5d93;
}
.modal .modal-profile.modal-profile-warning {
  background-color: #ff8d72;
}
.modal .modal-profile.modal-profile-success {
  background-color: #00f2c3;
}
.modal .modal-profile.modal-profile-info {
  background-color: #1d8cf8;
}
.modal.modal-default .modal-content {
  background-color: #ffffff;
  color: #222a42;
}
.modal.modal-default .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-default .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-default .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-default .has-success:after,
.modal.modal-default .has-danger:after {
  color: #ffffff;
}
.modal.modal-default .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-default .input-group-prepend {
  margin-right: 0;
}
.modal.modal-default .input-group-prepend .input-group-text,
.modal.modal-default .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-default .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control,
.modal.modal-default .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control:focus, .modal.modal-default .form-group.no-border .form-control:active, .modal.modal-default .form-group.no-border .form-control:active,
.modal.modal-default .input-group.no-border .form-control:focus,
.modal.modal-default .input-group.no-border .form-control:active,
.modal.modal-default .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-default .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-default .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-primary .modal-content {
  background-color: #e14eca;
  color: #ffffff;
}
.modal.modal-primary .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-primary .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-primary .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-primary .has-success:after,
.modal.modal-primary .has-danger:after {
  color: #ffffff;
}
.modal.modal-primary .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-primary .input-group-prepend {
  margin-right: 0;
}
.modal.modal-primary .input-group-prepend .input-group-text,
.modal.modal-primary .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-primary .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control,
.modal.modal-primary .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control:focus, .modal.modal-primary .form-group.no-border .form-control:active, .modal.modal-primary .form-group.no-border .form-control:active,
.modal.modal-primary .input-group.no-border .form-control:focus,
.modal.modal-primary .input-group.no-border .form-control:active,
.modal.modal-primary .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-primary .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-danger .modal-content {
  background-color: #fd5d93;
  color: #ffffff;
}
.modal.modal-danger .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-danger .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-danger .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-danger .has-success:after,
.modal.modal-danger .has-danger:after {
  color: #ffffff;
}
.modal.modal-danger .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-danger .input-group-prepend {
  margin-right: 0;
}
.modal.modal-danger .input-group-prepend .input-group-text,
.modal.modal-danger .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-danger .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control,
.modal.modal-danger .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control:focus, .modal.modal-danger .form-group.no-border .form-control:active, .modal.modal-danger .form-group.no-border .form-control:active,
.modal.modal-danger .input-group.no-border .form-control:focus,
.modal.modal-danger .input-group.no-border .form-control:active,
.modal.modal-danger .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-danger .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-warning .modal-content {
  background-color: #ff8d72;
  color: #ffffff;
}
.modal.modal-warning .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-warning .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-warning .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-warning .has-success:after,
.modal.modal-warning .has-danger:after {
  color: #ffffff;
}
.modal.modal-warning .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-warning .input-group-prepend {
  margin-right: 0;
}
.modal.modal-warning .input-group-prepend .input-group-text,
.modal.modal-warning .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-warning .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control,
.modal.modal-warning .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control:focus, .modal.modal-warning .form-group.no-border .form-control:active, .modal.modal-warning .form-group.no-border .form-control:active,
.modal.modal-warning .input-group.no-border .form-control:focus,
.modal.modal-warning .input-group.no-border .form-control:active,
.modal.modal-warning .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-warning .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-success .modal-content {
  background-color: #00f2c3;
  color: #ffffff;
}
.modal.modal-success .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-success .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-success .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-success .has-success:after,
.modal.modal-success .has-danger:after {
  color: #ffffff;
}
.modal.modal-success .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-success .input-group-prepend {
  margin-right: 0;
}
.modal.modal-success .input-group-prepend .input-group-text,
.modal.modal-success .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-success .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control,
.modal.modal-success .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control:focus, .modal.modal-success .form-group.no-border .form-control:active, .modal.modal-success .form-group.no-border .form-control:active,
.modal.modal-success .input-group.no-border .form-control:focus,
.modal.modal-success .input-group.no-border .form-control:active,
.modal.modal-success .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-success .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-success .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-info .modal-content {
  background-color: #1d8cf8;
  color: #ffffff;
}
.modal.modal-info .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-info .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-info .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-info .has-success:after,
.modal.modal-info .has-danger:after {
  color: #ffffff;
}
.modal.modal-info .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-info .input-group-prepend {
  margin-right: 0;
}
.modal.modal-info .input-group-prepend .input-group-text,
.modal.modal-info .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-info .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control,
.modal.modal-info .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control:focus, .modal.modal-info .form-group.no-border .form-control:active, .modal.modal-info .form-group.no-border .form-control:active,
.modal.modal-info .input-group.no-border .form-control:focus,
.modal.modal-info .input-group.no-border .form-control:active,
.modal.modal-info .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-info .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-info .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal .modal-header .close {
  color: #fd5d93;
  text-shadow: none;
}
.modal .modal-header .close:hover, .modal .modal-header .close:focus {
  opacity: 1;
}
.modal.modal-black .modal-content {
  background: linear-gradient(to bottom, #222a42 0%, #1d253b 100%);
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-black .modal-content .modal-header .modal-title, .modal.modal-black .modal-content .modal-header .title {
  color: rgba(255, 255, 255, 0.9);
}
.modal.modal-black .modal-content .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-black h1, .modal.modal-black h2, .modal.modal-black h3, .modal.modal-black h4, .modal.modal-black h5, .modal.modal-black h6, .modal.modal-black p {
  color: #ffffff;
}

.modal-search .modal-dialog {
  margin: 20px auto;
  max-width: 650px;
}
.modal-search .modal-dialog input {
  border: none;
  font-size: 17px;
  font-weight: 100;
}
.modal-search .modal-dialog span {
  font-size: 35px;
  color: #b7b7b7;
}
.modal-search .modal-content .modal-header {
  padding: 24px;
}
.modal-search .modal-header .close {
  color: #555555;
  top: 30px !important;
}
.modal-search .modal-footer {
  border-top: 2px solid #f9f9f9;
  margin: 0px 25px 20px;
}

@media (max-width: 575.98px) {
  .modal.show .modal-dialog {
    transform: translateY(10%);
  }
  .modal.show .modal-dialog.modal-notice {
    transform: translateY(3%);
  }
}
.nav-link {
  color: #525f7f;
}
.nav-link:hover {
  color: #e14eca;
}

.nav-pills .nav-link {
  padding: 0.75rem 1rem;
  color: #e14eca;
  font-weight: 500;
  background-color: #ffffff;
  transition: all 0.15s ease;
}
.nav-pills .nav-link:hover {
  color: #dd38c3;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #ffffff;
  background-color: #e14eca;
}

@media (max-width: 767.98px) {
  .nav-pills:not(.nav-pills-circle) .nav-item {
    padding-right: 0;
  }
}
.nav-pills-circle .nav-link {
  text-align: center;
  height: 60px;
  width: 60px;
  padding: 0;
  line-height: 60px;
  border-radius: 50%;
}
.nav-pills-circle .nav-link-icon i, .nav-pills-circle .nav-link-icon svg {
  font-size: 1rem;
}

.nav-wrapper {
  padding: 1rem 0;
  border-top-left-radius: 0.2857rem;
  border-top-right-radius: 0.2857rem;
}
.nav-wrapper + .card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.2857rem;
  border-bottom-left-radius: 0.2857rem;
}

@media (max-width: 767.98px) {
  .nav-tabs {
    display: inline-block;
    width: 100%;
    padding-left: 100px;
    padding-right: 100px;
    text-align: center;
  }
  .nav-tabs .nav-item > .nav-link {
    margin-bottom: 5px;
  }
}
.navbar {
  width: 100%;
  z-index: 1050;
  background: #1a1e34;
}
.navbar .photo {
  display: inline-block;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  vertical-align: middle;
  overflow: hidden;
}
.navbar .photo img {
  width: 100%;
}
.navbar .navbar-wrapper {
  display: flex;
  align-items: center;
}
.navbar .navbar-text {
  color: #ffffff;
}
.navbar .btn {
  margin: 0 5px 0 10px;
}
.navbar.navbar-absolute {
  position: absolute;
  z-index: 1050;
}
.navbar.navbar-transparent {
  background: transparent !important;
}
.navbar.bg-white .navbar-nav .search-bar.input-group i {
  color: #222a42;
}
.navbar.bg-white .navbar-nav .search-bar.input-group .form-control {
  background: rgba(34, 42, 66, 0.1);
  border-radius: 4px;
}
.navbar.bg-white .navbar-nav a.nav-link {
  color: #222a42 !important;
}
.navbar.bg-white .navbar-nav a.nav-link p {
  color: #222a42;
}
.navbar.bg-white .navbar-text, .navbar.bg-white .navbar-brand {
  color: #222a42;
}
.navbar.bg-white .form-control {
  color: #222a42 !important;
}
.navbar.bg-white .form-control::placeholder {
  color: #9A9A9A !important;
}
.navbar.bg-dark {
  background: #222a42 !important;
}
.navbar.bg-primary {
  background-color: #e14eca !important;
}
.navbar.bg-warning {
  background-color: #ff8d72 !important;
}
.navbar.bg-info {
  background-color: #1d8cf8 !important;
}
.navbar.bg-success {
  background-color: #00bf9a !important;
}
.navbar.bg-danger {
  background-color: #fd5d93 !important;
}
.navbar .navbar-brand {
  position: relative;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  color: #ffffff;
  margin-left: 17px;
  text-transform: uppercase;
  font-size: 1rem;
}
.navbar .navbar-toggle button:focus, .navbar .navbar-toggler {
  outline: none;
}

.navbar-minimize-fixed {
  position: fixed;
  margin-left: 40px;
  margin-top: 14px;
  transition: 0.3s ease;
  color: white;
  z-index: 20;
  opacity: 0;
  transition: 0.2s ease;
}
.navbar-minimize-fixed button i {
  font-size: 20px;
}

.notification {
  background: #fd5d93;
  color: #ffffff;
  border-radius: 0.875rem;
  height: 6px;
  width: 6px;
  position: absolute;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
  top: 10px;
  right: 10px;
  border: 1px solid #fd5d93;
}

.navbar-nav li {
  padding: 0 10px;
}
.navbar-nav li a {
  color: #ffffff;
}
.navbar-nav li i {
  vertical-align: middle;
  font-size: 20px;
}

@media (max-width: 991.98px) {
  .navbar {
    top: -70px;
  }
  .navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar .navbar-collapse .input-group {
    margin: 0;
    margin-top: 5px;
  }
  .navbar .navbar-nav .btn {
    margin-left: -3px;
    display: flex;
  }
  .navbar .navbar-nav .btn i {
    margin-right: 12px;
  }
  .navbar .navbar-nav .btn span {
    margin: 0;
    text-transform: uppercase;
    font-weight: 300;
  }
  .navbar .navbar-nav .btn span, .navbar .navbar-nav .btn span:hover, .navbar .navbar-nav .btn span:focus, .navbar .navbar-nav .btn span:active, .navbar .navbar-nav .btn span:active:focus {
    color: #222a42 !important;
  }
  .navbar .navbar-nav a.nav-link i {
    opacity: 1;
    margin-left: 4px;
    margin-right: 5px;
  }
  .navbar .navbar-nav a.nav-link p {
    display: inline-block;
    text-transform: uppercase;
    margin-left: 7px;
  }
  .navbar .navbar-nav .modal-search .modal-dialog {
    padding: 0 40px;
  }
  .navbar .navbar-nav .dropdown {
    margin: 5px 0;
  }
  .navbar .navbar-nav .dropdown .nav-link {
    padding-bottom: 0;
  }
  .navbar .navbar-nav .dropdown .dropdown-menu .dropdown-item {
    margin-top: 0;
    padding-left: 24px;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown .dropdown-menu li a {
    color: #222a42;
  }
  .navbar .dropdown.show .dropdown-menu,
.navbar .dropdown .dropdown-menu {
    background-color: transparent;
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    margin: 0px 1rem;
    padding-top: 0;
    margin-top: 0px;
  }
  .navbar .dropdown.show .dropdown-menu:before,
.navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
.navbar .dropdown-menu .dropdown-item:hover {
    color: #ffffff;
  }
  .navbar.bg-white .dropdown-menu .dropdown-item:focus, .navbar.bg-white .dropdown-menu .dropdown-item:hover {
    color: #344675;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #ffffff;
  }
  .navbar .navbar-toggler-bar.navbar-kebab {
    height: 4px;
    width: 4px;
    margin-bottom: 3px;
    border-radius: 50%;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
    margin-top: 0px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background-color: #344675;
  }
  .navbar .toggled .navbar-toggler-bar {
    width: 24px;
  }
  .bar1,
.bar2,
.bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 9px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .navbar-nav .nav-link i.fa,
.navbar-nav .nav-link i.tim-icons {
    opacity: 0.5;
  }
}
@media (min-width: 992px) {
  .navbar-collapse {
    background: none !important;
  }
  .navbar .navbar-toggle {
    display: none;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .navbar .caret {
    position: absolute;
    left: 80%;
    top: 55%;
    margin-left: 0;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}
@media (max-width: 575.98px) {
  .navbar[class*=navbar-toggleable-] .container {
    margin-left: 0;
    margin-right: 0;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .bar1,
.bar2,
.bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 7px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 9px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative !important;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #ffffff;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggle .navbar-toggler {
    display: block;
  }
  .navbar-minimize-fixed {
    display: none;
  }
}
.pagination .page-item .page-link {
  border: 0;
  border-radius: 30px !important;
  transition: all 0.3s;
  margin: 0 3px;
  min-width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-transform: uppercase;
  outline: none;
}
.pagination .page-item .page-link:hover, .pagination .page-item .page-link:focus {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: none;
  box-shadow: none;
}
.pagination .arrow-margin-left,
.pagination .arrow-margin-right {
  position: absolute;
}
.pagination .arrow-margin-right {
  right: 0;
}
.pagination .arrow-margin-left {
  left: 0;
}
.pagination .page-item.active > .page-link {
  color: #ffffff;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.pagination .page-item.active > .page-link, .pagination .page-item.active > .page-link:focus, .pagination .page-item.active > .page-link:hover {
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
}
.pagination .page-item.disabled > .page-link {
  opacity: 0.5;
}
.pagination.pagination-info .page-item.active > .page-link, .pagination.pagination-info .page-item.active > .page-link:focus, .pagination.pagination-info .page-item.active > .page-link:hover {
  background: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: top right;
}
.pagination.pagination-success .page-item.active > .page-link, .pagination.pagination-success .page-item.active > .page-link:focus, .pagination.pagination-success .page-item.active > .page-link:hover {
  background: #00f2c3;
  background-image: linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3);
  background-size: 210% 210%;
  background-position: top right;
}
.pagination.pagination-primary .page-item.active > .page-link, .pagination.pagination-primary .page-item.active > .page-link:focus, .pagination.pagination-primary .page-item.active > .page-link:hover {
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
}
.pagination.pagination-warning .page-item.active > .page-link, .pagination.pagination-warning .page-item.active > .page-link:focus, .pagination.pagination-warning .page-item.active > .page-link:hover {
  background: #ff8d72;
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72);
  background-size: 210% 210%;
  background-position: top right;
}
.pagination.pagination-danger .page-item.active > .page-link, .pagination.pagination-danger .page-item.active > .page-link:focus, .pagination.pagination-danger .page-item.active > .page-link:hover {
  background: #fd5d93;
  background-image: linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93);
  background-size: 210% 210%;
  background-position: top right;
}
.pagination.pagination-neutral .page-item > .page-link {
  color: #ffffff;
}
.pagination.pagination-neutral .page-item > .page-link:focus, .pagination.pagination-neutral .page-item > .page-link:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.pagination.pagination-neutral .page-item.active > .page-link, .pagination.pagination-neutral .page-item.active > .page-link:focus, .pagination.pagination-neutral .page-item.active > .page-link:hover {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #e14eca;
}

@media (max-width: 767.98px) {
  div.dataTables_paginate ul.pagination .page-item:first-of-type,
div.dataTables_paginate ul.pagination .page-item:nth-of-type(2),
div.dataTables_paginate ul.pagination .page-item:nth-of-type(8),
div.dataTables_paginate ul.pagination .page-item:last-of-type {
    display: none !important;
  }
}
.nav-tabs {
  border: 0;
  padding: 0.5rem 0.7rem;
}
.nav-tabs > .nav-item > .nav-link {
  color: #ffffff;
  margin: 0;
  margin-right: 5px;
  background-color: transparent;
  border-radius: 30px;
  padding: 11px 23px;
  line-height: 1.5;
}
.nav-tabs > .nav-item > .nav-link:hover {
  background-color: transparent;
  border: 1px solid #191f31;
  color: rgba(255, 255, 255, 0.8);
}
.nav-tabs > .nav-item > .nav-link.active {
  border: 1px solid #ffffff;
  border-radius: 30px;
}
.nav-tabs > .nav-item > .nav-link i.tim-icons {
  font-size: 14px;
  position: relative;
  top: 1px;
  margin-right: 3px;
}
.nav-tabs > .nav-item.disabled > .nav-link, .nav-tabs > .nav-item.disabled > .nav-link:hover {
  color: rgba(255, 255, 255, 0.5);
}
.nav-tabs.nav-tabs-neutral > .nav-item > .nav-link {
  color: #ffffff;
}
.nav-tabs.nav-tabs-neutral > .nav-item > .nav-link.active {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.nav-tabs.nav-tabs-primary > .nav-item > .nav-link.active {
  border-color: #e14eca;
  color: #e14eca;
}
.nav-tabs.nav-tabs-info > .nav-item > .nav-link.active {
  border-color: #1d8cf8;
  color: #1d8cf8;
}
.nav-tabs.nav-tabs-danger > .nav-item > .nav-link.active {
  border-color: #fd5d93;
  color: #fd5d93;
}
.nav-tabs.nav-tabs-warning > .nav-item > .nav-link.active {
  border-color: #ff8d72;
  color: #ff8d72;
}
.nav-tabs.nav-tabs-success > .nav-item > .nav-link.active {
  border-color: #00f2c3;
  color: #00f2c3;
}

.nav-pills.flex-column li > a {
  margin-bottom: 15px;
}
.nav-pills.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
  margin-right: 10px;
  margin-bottom: 5px;
}
.nav-pills:not(.nav-pills-icons):not(.nav-pills-just-icons) .nav-item .nav-link {
  border-radius: 30px;
}
.nav-pills.nav-pills-just-icons .nav-item .nav-link {
  border-radius: 50%;
  height: 80px;
  max-width: 80px;
  min-width: auto;
  padding: 0;
  width: 80px;
}
.nav-pills.nav-pills-just-icons .nav-item .nav-link .tim-icons {
  font-size: 24px;
  line-height: 80px;
}
.nav-pills .nav-item .nav-link {
  padding: 0 15.5px;
  text-align: center;
  padding: 11px 23px;
  min-width: 100px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  background-color: #191f31;
}
.nav-pills .nav-item .nav-link:hover {
  background-color: #111520;
}
.nav-pills .nav-item .nav-link.active, .nav-pills .nav-item .nav-link.active:focus, .nav-pills .nav-item .nav-link.active:hover {
  background-color: #9A9A9A;
  color: #ffffff;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
}
.nav-pills .nav-item .nav-link.disabled, .nav-pills .nav-item .nav-link:disabled, .nav-pills .nav-item .nav-link[disabled] {
  opacity: 0.5;
}
.nav-pills .nav-item i {
  display: block;
  font-size: 24px;
  line-height: 60px;
}
.nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.nav-pills.nav-pills-neutral .nav-item .nav-link.active, .nav-pills.nav-pills-neutral .nav-item .nav-link.active:focus, .nav-pills.nav-pills-neutral .nav-item .nav-link.active:hover {
  background-color: #ffffff;
  color: #e14eca;
}
.nav-pills.nav-pills-primary .nav-item .nav-link.active, .nav-pills.nav-pills-primary .nav-item .nav-link.active:focus, .nav-pills.nav-pills-primary .nav-item .nav-link.active:hover {
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
}
.nav-pills.nav-pills-info .nav-item .nav-link.active, .nav-pills.nav-pills-info .nav-item .nav-link.active:focus, .nav-pills.nav-pills-info .nav-item .nav-link.active:hover {
  background: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: top right;
}
.nav-pills.nav-pills-success .nav-item .nav-link.active, .nav-pills.nav-pills-success .nav-item .nav-link.active:focus, .nav-pills.nav-pills-success .nav-item .nav-link.active:hover {
  background: #00f2c3;
  background-image: linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3);
  background-size: 210% 210%;
  background-position: top right;
}
.nav-pills.nav-pills-warning .nav-item .nav-link.active, .nav-pills.nav-pills-warning .nav-item .nav-link.active:focus, .nav-pills.nav-pills-warning .nav-item .nav-link.active:hover {
  background: #ff8d72;
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72);
  background-size: 210% 210%;
  background-position: top right;
}
.nav-pills.nav-pills-danger .nav-item .nav-link.active, .nav-pills.nav-pills-danger .nav-item .nav-link.active:focus, .nav-pills.nav-pills-danger .nav-item .nav-link.active:hover {
  background: #fd5d93;
  background-image: linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93);
  background-size: 210% 210%;
  background-position: top right;
}

.tab-space {
  padding: 20px 0 50px 0px;
}

.tab-content.tab-subcategories {
  margin-top: 20px;
  background-color: transparent;
  padding-left: 15px;
  padding-right: 15px;
}
.tab-content .tab-pane {
  color: rgba(255, 255, 255, 0.5);
}

.nav-align-center {
  text-align: center;
}
.nav-align-center .nav-pills {
  display: inline-flex;
}

.popover {
  border: 0;
}

.popover-header {
  font-weight: 600;
}

.popover-primary {
  background-color: #e14eca;
}
.popover-primary .popover-header {
  background-color: #e14eca;
  color: #ffffff;
  opacity: 0.6;
}
.popover-primary .popover-body {
  color: #ffffff;
}
.popover-primary .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-primary.bs-popover-top .arrow::after, .popover-primary.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #e14eca;
}
.popover-primary.bs-popover-right .arrow::after, .popover-primary.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #e14eca;
}
.popover-primary.bs-popover-bottom .arrow::after, .popover-primary.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #e14eca;
}
.popover-primary.bs-popover-left .arrow::after, .popover-primary.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #e14eca;
}

.popover-secondary {
  background-color: #f4f5f7;
}
.popover-secondary .popover-header {
  background-color: #f4f5f7;
  color: #212529;
  opacity: 0.6;
}
.popover-secondary .popover-body {
  color: #212529;
}
.popover-secondary .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-secondary.bs-popover-top .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #f4f5f7;
}
.popover-secondary.bs-popover-right .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #f4f5f7;
}
.popover-secondary.bs-popover-bottom .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #f4f5f7;
}
.popover-secondary.bs-popover-left .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #f4f5f7;
}

.popover-success {
  background-color: #00f2c3;
}
.popover-success .popover-header {
  background-color: #00f2c3;
  color: #ffffff;
  opacity: 0.6;
}
.popover-success .popover-body {
  color: #ffffff;
}
.popover-success .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-success.bs-popover-top .arrow::after, .popover-success.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #00f2c3;
}
.popover-success.bs-popover-right .arrow::after, .popover-success.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #00f2c3;
}
.popover-success.bs-popover-bottom .arrow::after, .popover-success.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #00f2c3;
}
.popover-success.bs-popover-left .arrow::after, .popover-success.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #00f2c3;
}

.popover-info {
  background-color: #1d8cf8;
}
.popover-info .popover-header {
  background-color: #1d8cf8;
  color: #ffffff;
  opacity: 0.6;
}
.popover-info .popover-body {
  color: #ffffff;
}
.popover-info .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-info.bs-popover-top .arrow::after, .popover-info.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #1d8cf8;
}
.popover-info.bs-popover-right .arrow::after, .popover-info.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #1d8cf8;
}
.popover-info.bs-popover-bottom .arrow::after, .popover-info.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #1d8cf8;
}
.popover-info.bs-popover-left .arrow::after, .popover-info.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #1d8cf8;
}

.popover-warning {
  background-color: #ff8d72;
}
.popover-warning .popover-header {
  background-color: #ff8d72;
  color: #ffffff;
  opacity: 0.6;
}
.popover-warning .popover-body {
  color: #ffffff;
}
.popover-warning .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-warning.bs-popover-top .arrow::after, .popover-warning.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #ff8d72;
}
.popover-warning.bs-popover-right .arrow::after, .popover-warning.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #ff8d72;
}
.popover-warning.bs-popover-bottom .arrow::after, .popover-warning.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #ff8d72;
}
.popover-warning.bs-popover-left .arrow::after, .popover-warning.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #ff8d72;
}

.popover-danger {
  background-color: #fd5d93;
}
.popover-danger .popover-header {
  background-color: #fd5d93;
  color: #ffffff;
  opacity: 0.6;
}
.popover-danger .popover-body {
  color: #ffffff;
}
.popover-danger .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-danger.bs-popover-top .arrow::after, .popover-danger.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fd5d93;
}
.popover-danger.bs-popover-right .arrow::after, .popover-danger.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fd5d93;
}
.popover-danger.bs-popover-bottom .arrow::after, .popover-danger.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fd5d93;
}
.popover-danger.bs-popover-left .arrow::after, .popover-danger.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fd5d93;
}

.popover-light {
  background-color: #adb5bd;
}
.popover-light .popover-header {
  background-color: #adb5bd;
  color: #ffffff;
  opacity: 0.6;
}
.popover-light .popover-body {
  color: #ffffff;
}
.popover-light .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-light.bs-popover-top .arrow::after, .popover-light.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #adb5bd;
}
.popover-light.bs-popover-right .arrow::after, .popover-light.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #adb5bd;
}
.popover-light.bs-popover-bottom .arrow::after, .popover-light.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #adb5bd;
}
.popover-light.bs-popover-left .arrow::after, .popover-light.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #adb5bd;
}

.popover-dark {
  background-color: #212529;
}
.popover-dark .popover-header {
  background-color: #212529;
  color: #ffffff;
  opacity: 0.6;
}
.popover-dark .popover-body {
  color: #ffffff;
}
.popover-dark .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-dark.bs-popover-top .arrow::after, .popover-dark.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #212529;
}
.popover-dark.bs-popover-right .arrow::after, .popover-dark.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #212529;
}
.popover-dark.bs-popover-bottom .arrow::after, .popover-dark.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #212529;
}
.popover-dark.bs-popover-left .arrow::after, .popover-dark.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #212529;
}

.popover-default {
  background-color: #344675;
}
.popover-default .popover-header {
  background-color: #344675;
  color: #ffffff;
  opacity: 0.6;
}
.popover-default .popover-body {
  color: #ffffff;
}
.popover-default .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-default.bs-popover-top .arrow::after, .popover-default.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #344675;
}
.popover-default.bs-popover-right .arrow::after, .popover-default.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #344675;
}
.popover-default.bs-popover-bottom .arrow::after, .popover-default.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #344675;
}
.popover-default.bs-popover-left .arrow::after, .popover-default.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #344675;
}

.popover-white {
  background-color: #ffffff;
}
.popover-white .popover-header {
  background-color: #ffffff;
  color: #212529;
  opacity: 0.6;
}
.popover-white .popover-body {
  color: #212529;
}
.popover-white .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-white.bs-popover-top .arrow::after, .popover-white.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #ffffff;
}
.popover-white.bs-popover-right .arrow::after, .popover-white.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #ffffff;
}
.popover-white.bs-popover-bottom .arrow::after, .popover-white.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #ffffff;
}
.popover-white.bs-popover-left .arrow::after, .popover-white.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #ffffff;
}

.popover-neutral {
  background-color: #ffffff;
}
.popover-neutral .popover-header {
  background-color: #ffffff;
  color: #212529;
  opacity: 0.6;
}
.popover-neutral .popover-body {
  color: #212529;
}
.popover-neutral .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-neutral.bs-popover-top .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #ffffff;
}
.popover-neutral.bs-popover-right .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #ffffff;
}
.popover-neutral.bs-popover-bottom .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #ffffff;
}
.popover-neutral.bs-popover-left .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #ffffff;
}

.popover-darker {
  background-color: black;
}
.popover-darker .popover-header {
  background-color: black;
  color: #ffffff;
  opacity: 0.6;
}
.popover-darker .popover-body {
  color: #ffffff;
}
.popover-darker .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-darker.bs-popover-top .arrow::after, .popover-darker.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: black;
}
.popover-darker.bs-popover-right .arrow::after, .popover-darker.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: black;
}
.popover-darker.bs-popover-bottom .arrow::after, .popover-darker.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: black;
}
.popover-darker.bs-popover-left .arrow::after, .popover-darker.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: black;
}

.progress-container {
  position: relative;
}
.progress-container.progress-sm {
  margin-top: 10px;
}
.progress-container.progress-sm .progress .progress-value {
  position: absolute;
  top: -3px;
  left: -27px;
  color: #ffffff;
  font-size: 0.62475rem;
}
.progress-container + .progress-container, .progress-container ~ .progress-container {
  margin-top: 15px;
}
.progress-container .progress-badge {
  color: #ffffff;
  font-size: 0.7500000025rem;
  text-transform: uppercase;
}
.progress-container .progress-badge.float-left {
  margin-right: 20px;
}
.progress-container .progress {
  margin-bottom: 10px;
  box-shadow: 0px 0px 0px 3px rgba(0, 0, 0, 0.3);
}
.progress-container .progress .progress-bar {
  border-radius: 0.875rem;
  box-shadow: none;
  background: #344675;
}
.progress-container .progress .progress-bar .progress-value {
  position: absolute;
  top: 2px;
  right: 0;
  color: #ffffff;
  font-size: 0.62475rem;
}
.progress-container .progress.progress-bar-sm {
  height: 3px;
}
.progress-container.progress-neutral .progress {
  background: rgba(255, 255, 255, 0.3);
}
.progress-container.progress-neutral .progress-bar {
  background: #ffffff;
}
.progress-container.progress-primary .progress-bar {
  background: #ba54f5;
  background-image: linear-gradient(to bottom left, #ba54f5, #e14eca, #ba54f5);
  background-size: 210% 210%;
  background-position: top right;
}
.progress-container.progress-info .progress-bar {
  background: #3358f4;
  background-image: linear-gradient(to bottom left, #3358f4, #1d8cf8, #3358f4);
  background-size: 210% 210%;
  background-position: top right;
}
.progress-container.progress-success .progress-bar {
  background: #0098f0;
  background-image: linear-gradient(to bottom left, #0098f0, #00f2c3, #0098f0);
  background-size: 210% 210%;
  background-position: top right;
}
.progress-container.progress-warning .progress-bar {
  background: #ff6491;
  background-image: linear-gradient(to bottom left, #ff6491, #ff8d72, #ff6491);
  background-size: 210% 210%;
  background-position: top right;
}
.progress-container.progress-danger .progress-bar {
  background: #ec250d;
  background-image: linear-gradient(to bottom left, #ec250d, #fd5d93, #ec250d);
  background-size: 210% 210%;
  background-position: top right;
}

.card-chart .progress-container + .progress-container,
.card-chart .progress-container ~ .progress-container {
  margin-top: 25px;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  line-height: 1.2;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Poppins", sans-serif;
}

.card h1, .card h2, .card h3, .card h4, .card h5, .card h6, .card p {
  color: rgba(255, 255, 255, 0.8);
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

a {
  color: #ba54f5;
  font-weight: 300;
}
a:hover, a:focus {
  color: #e14eca;
}

h1, .h1 {
  line-height: 1.05;
  margin-bottom: 30px;
}
h1 small, .h1 small {
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.8;
}

h2, .h2 {
  margin-bottom: 30px;
  line-height: 1.2;
}

h3, .h3 {
  margin-bottom: 30px;
  line-height: 1.4em;
}

h4, .h4 {
  line-height: 1.45em;
  margin-bottom: 15px;
}
h4 + .category, h4.title + .category, .h4 + .category, .h4.title + .category {
  margin-top: -10px;
}

h5, .h5 {
  line-height: 1.4em;
  margin-bottom: 15px;
}

h6, .h6 {
  text-transform: uppercase;
  font-weight: 600;
}

p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 5px;
}
p.description {
  font-size: 1.14em;
}

.title {
  font-weight: 600;
}
.title.title-up {
  text-transform: uppercase;
}
.title.title-up a {
  color: #222a42;
  text-decoration: none;
}
.title + .category {
  margin-top: -10px;
}

.description,
.card-description,
.footer-big p,
.card .footer .stats {
  color: #9A9A9A;
  font-weight: 300;
}

.category,
.card-category {
  text-transform: capitalize;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.7500000025rem;
}

.card-category {
  font-size: 0.7500000025rem;
}

.blockquote {
  border-left: none;
  border: 1px solid #344675;
  padding: 20px;
  font-size: 0.9625rem;
  line-height: 1.8;
}
.blockquote small {
  color: #344675;
  font-size: 0.7500000025rem;
  text-transform: uppercase;
}
.blockquote.blockquote-primary {
  border-color: #e14eca;
  color: #e14eca;
}
.blockquote.blockquote-primary small {
  color: #e14eca;
}
.blockquote.blockquote-danger {
  border-color: #fd5d93;
  color: #fd5d93;
}
.blockquote.blockquote-danger small {
  color: #fd5d93;
}
.blockquote.blockquote-white {
  border-color: rgba(255, 255, 255, 0.8);
  color: #ffffff;
}
.blockquote.blockquote-white small {
  color: rgba(255, 255, 255, 0.8);
}

ul li, ol li {
  color: #ffffff;
}

pre {
  color: rgba(255, 255, 255, 0.8);
}

hr {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.table > tbody > tr > td {
  color: rgba(255, 255, 255, 0.7) !important;
}
.table > tbody > tr > td .photo {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.table > tbody > tr > td .photo img {
  width: 100%;
}
.table > tbody > tr.table-success > td {
  background-color: #00bf9a;
}
.table > tbody > tr.table-info > td {
  background-color: #1d8cf8;
}
.table > tbody > tr.table-primary > td {
  background-color: #e14eca;
}
.table > tbody > tr.table-warning > td {
  background-color: #ff8d72;
}
.table > tbody > tr.table-danger > td {
  background-color: #fd5d93;
}
.table .img-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.table .img-row {
  max-width: 60px;
  width: 60px;
}
.table .form-check {
  margin: 0;
  margin-top: 5px;
}
.table .form-check label .form-check-sign::before, .table .form-check label .form-check-sign::after {
  top: -17px;
  left: 4px;
}
.table .btn {
  margin: 0;
}
.table small, .table .small {
  font-weight: 300;
}
.card-tasks .card-body .table {
  margin-bottom: 0;
}
.card-tasks .card-body .table > thead > tr > th,
.card-tasks .card-body .table > tbody > tr > th,
.card-tasks .card-body .table > tfoot > tr > th,
.card-tasks .card-body .table > thead > tr > td,
.card-tasks .card-body .table > tbody > tr > td,
.card-tasks .card-body .table > tfoot > tr > td {
  padding-top: 5px;
  padding-bottom: 5px;
}
.table > thead > tr > th {
  border-bottom-width: 1px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  border: 0;
  color: rgba(255, 255, 255, 0.7);
}
.table .radio,
.table .checkbox {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  width: 15px;
}
.table .radio .icons,
.table .checkbox .icons {
  position: relative;
}
.table .radio label:after, .table .radio label:before,
.table .checkbox label:after,
.table .checkbox label:before {
  top: -17px;
  left: -3px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-color: rgba(255, 255, 255, 0.1);
  padding: 12px 7px;
  vertical-align: middle;
}
.table.table-shopping tbody tr:last-child td {
  border: none;
}
.table .th-description {
  max-width: 150px;
}
.table .td-price {
  font-size: 26px;
  font-weight: 300;
  margin-top: 5px;
  position: relative;
  top: 4px;
  text-align: right;
}
.table .td-total {
  font-weight: 600;
  font-size: 0.812499975rem;
  padding-top: 20px;
  text-align: right;
}
.table .td-actions .btn {
  margin: 0px;
}
.table > tbody > tr {
  position: relative;
}
.table > tfoot > tr {
  color: hsla(0deg, 0%, 100%, 0.7);
  text-transform: uppercase;
}

.table-shopping > thead > tr > th {
  text-transform: uppercase;
}
.table-shopping > tbody > tr > td {
  font-size: 1rem;
}
.table-shopping > tbody > tr > td b {
  display: block;
  margin-bottom: 5px;
}
.table-shopping .td-name {
  font-weight: 400;
  font-size: 1.5em;
}
.table-shopping .td-name small {
  color: #9A9A9A;
  font-size: 0.75em;
  font-weight: 300;
}
.table-shopping .td-number {
  font-weight: 300;
}
.table-shopping .td-number .btn-group {
  padding-right: 15px;
}
.table-shopping .td-name {
  min-width: 200px;
}
.table-shopping .td-number {
  text-align: right;
  min-width: 170px;
}
.table-shopping .td-number small {
  margin-right: 3px;
}
.table-shopping .img-container {
  width: 120px;
  max-height: 160px;
  overflow: hidden;
  display: block;
}
.table-shopping .img-container img {
  width: 100%;
}

.table-responsive {
  padding-bottom: 10px;
}

#tables .table-responsive {
  margin-bottom: 30px;
}

table.tablesorter thead tr .header {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-position: center right;
  cursor: pointer;
}

table.tablesorter thead tr .headerSortUp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

table.tablesorter thead tr .headerSortDown {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.dataTables_wrapper .form-control-sm {
  font-size: 10px;
}

.form-check {
  margin-top: 0.5rem;
  padding-left: 0;
}

.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 25px;
  line-height: 18px;
  margin-bottom: 0;
  transition: color 0.3s linear;
}

.radio .form-check-sign {
  padding-left: 28px;
}

.form-check-radio.form-check-inline .form-check-label {
  padding-left: 5px;
  margin-right: 10px;
}

.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 17px;
  height: 17px;
  left: 0;
  cursor: pointer;
  border-radius: 3px;
  top: 0;
  border: 1px solid #818181;
  transition: opacity 0.3s linear;
}

.form-check input[type=checkbox]:checked + .form-check-sign::before,
.form-check input[type=checkbox]:checked + .form-check-sign::before {
  border: none;
  background-color: #e14eca;
}

.form-check .form-check-sign::after {
  font-family: "nucleo";
  content: "\\ea1b";
  top: 0px;
  text-align: center;
  font-size: 14px;
  opacity: 0;
  color: #ffffff;
  font-weight: 600;
  border: 0;
  background-color: inherit;
}

.form-check.disabled .form-check-label,
.form-check.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
  font-size: 10px;
  margin-top: 0;
}

.form-check input[type=checkbox] + .form-check-sign::after {
  opacity: 0;
  font-size: 10px;
  margin-top: 0;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check input[type=checkbox]:disabled + .form-check-sign,
.form-check input[type=radio]:disabled + .form-check-sign {
  pointer-events: none;
}

.form-check-radio .form-check-label {
  padding-top: 3px;
}

.form-check-radio .form-check-sign::before,
.form-check-radio .form-check-sign::after {
  content: " ";
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #818181;
  display: inline-block;
  position: absolute;
  left: 0px;
  top: 3px;
  padding: 1px;
  transition: opacity 0.3s linear;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  width: 6px;
  height: 6px;
  background-color: #e14eca;
  border-color: #e14eca;
  top: 9px;
  left: 6px;
  opacity: 1;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::before {
  border-color: #e14eca;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign {
  color: #9A9A9A;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9A9A9A;
}

.fixed-plugin {
  position: fixed;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 130px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
  color: #ffffff;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}
.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto !important;
  top: -52px !important;
  width: 290px;
  border-radius: 0.1875rem;
  padding: 0 10px;
  background: linear-gradient(#222a42, #1d253b);
}
.fixed-plugin .dropdown .dropdown-menu .tim-icons {
  top: 5px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}
.fixed-plugin .fa-circle-thin {
  color: #ffffff;
}
.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}
.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 2px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #1d253b;
}
.fixed-plugin .light-badge, .fixed-plugin .dark-badge {
  margin: 0;
  border: 1px solid #1d8cf8;
}
.fixed-plugin .light-badge:hover, .fixed-plugin .dark-badge:hover {
  border: 1px solid #1d8cf8;
}
.fixed-plugin .light-badge {
  background: #ffffff;
}
.fixed-plugin .light-badge:hover {
  background: #ffffff;
}
.fixed-plugin .dark-badge {
  background: #222a42;
}
.fixed-plugin .dark-badge:hover {
  background: #222a42;
}
.fixed-plugin h5 {
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 18px 2px;
  width: 25%;
  float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 50px;
  min-height: inherit;
}
.fixed-plugin li.button-container {
  height: auto;
}
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}
.fixed-plugin li.header-title {
  color: #ffffff;
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.fixed-plugin .adjustments-line a {
  color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
  text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
  position: relative;
  left: -10px;
  font-size: 0.62475rem;
  color: #ffffff;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
  left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}
.fixed-plugin .adjustments-line .color-label {
  position: relative;
  top: -7px;
  font-size: 0.62475rem;
  color: #ffffff;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 1rem;
  text-align: center;
  border-radius: 10px;
  background-color: #ffffff;
  border: 3px solid #ffffff;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover, .fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder, .fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #ffffff;
}
.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}
.fixed-plugin .btn-social i {
  margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform: translateY(-15%);
  top: 27px;
  opacity: 0;
  transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 0.4em solid rgba(0, 0, 0, 0);
  border-left: 0.4em solid rgba(0, 0, 0, 0.2);
  border-top: 0.4em solid rgba(0, 0, 0, 0);
  right: -16px;
  top: 46px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 0.4em solid rgba(0, 0, 0, 0);
  border-left: 0.4em solid #222a42;
  border-top: 0.4em solid rgba(0, 0, 0, 0);
  right: -16px;
}
.fixed-plugin .dropdown .dropdown-menu:before, .fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 74px;
  width: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}
.fixed-plugin .dropdown.show .dropdown-menu {
  opacity: 1;
  transform: translateY(-13%);
  transform-origin: 0 0;
}
.fixed-plugin .bootstrap-switch {
  margin: 0;
}

@media (max-width: 575.98px) {
  .fixed-plugin {
    top: 100px;
  }
  .fixed-plugin .dropdown-menu {
    width: 225px;
    top: -65px !important;
  }
}
.wrapper {
  position: relative;
  top: 0;
}
.wrapper.wrapper-full-page {
  min-height: 100vh;
  height: auto;
}

.sidebar-wrapper ul li div.collapse ul li div.collapse ul li a,
.sidebar-wrapper ul li div.collapse ul li div.collapsing ul li a,
.sidebar-wrapper ul li div.collapsing ul li div.collapse ul li a {
  margin-left: 10px;
}

.sidebar,
.off-canvas-sidebar {
  background: #ba54f5;
  background: linear-gradient(0deg, #ba54f5 0%, #e14eca 100%);
  height: calc(100vh - 90px);
  width: 230px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background-size: cover;
  background-position: center center;
  display: block;
  box-shadow: 0px 0px 45px 0px rgba(0, 0, 0, 0.6);
  margin-top: 62px;
  margin-left: 2px;
  border-radius: 5px;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  width: 100%;
  min-height: 100%;
  max-height: calc(100vh - 705px);
  z-index: 4;
  position: relative;
  overflow: auto;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
  display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
  border: none;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span {
  display: inline-block;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: block;
  line-height: 23px;
  z-index: 1;
  color: rgba(255, 255, 255, 0.8);
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  text-transform: uppercase;
  width: 34px;
  margin-right: 10px;
  margin-left: 0px;
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  position: relative;
  float: left;
  z-index: 1;
  display: inherit;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i {
  font-size: 17px;
  line-height: 20px;
  width: 26px;
}
.sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-mini-icon, .sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-normal {
  color: #ffffff;
}
.sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  opacity: 0;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  position: absolute;
  right: 20px;
  top: 2px;
  opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
  margin-top: 20px;
  display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
  top: 14px;
  position: absolute;
  right: 10px;
}
.sidebar .nav li > a + div .nav,
.off-canvas-sidebar .nav li > a + div .nav {
  margin-top: 5px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
  margin-top: 0px;
  padding: 8px 8px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  margin: 10px 15px 0;
  border-radius: 30px;
  color: #ffffff;
  display: block;
  text-decoration: none;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 8px;
  line-height: 1.625rem;
}
.sidebar .nav li:first-child > a,
.off-canvas-sidebar .nav li:first-child > a {
  margin: 0 15px;
}
.sidebar .nav li:hover:not(.active) > a p, .sidebar .nav li:hover:not(.active) > a i, .sidebar .nav li:focus:not(.active) > a p, .sidebar .nav li:focus:not(.active) > a i,
.off-canvas-sidebar .nav li:hover:not(.active) > a p,
.off-canvas-sidebar .nav li:hover:not(.active) > a i,
.off-canvas-sidebar .nav li:focus:not(.active) > a p,
.off-canvas-sidebar .nav li:focus:not(.active) > a i {
  color: #2c2a2a !important;
  font-weight: 600 !important;
}
.sidebar .nav li:hover:not(.active) > a i, .sidebar .nav li:focus:not(.active) > a i,
.off-canvas-sidebar .nav li:hover:not(.active) > a i,
.off-canvas-sidebar .nav li:focus:not(.active) > a i {
  color: #2c2a2a !important;
  font-weight: 600 !important;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]),
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) {
  background: transparent;
  font-weight: 700 !important;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]) i, .sidebar .nav li.active > a:not([data-toggle=collapse]) p,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) i,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) p {
  color: #419ef9 !important;
  font-weight: 700 !important;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]):before,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]):before {
  content: " ";
  position: absolute;
  height: 29px;
  width: 4px;
  top: 9px;
  left: -16px;
  background: #419ef9 !important;
}
.sidebar .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] {
  background: transparent;
  box-shadow: none;
  color: #ffffff;
}
.sidebar .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i {
  color: #ffffff;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a {
  box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a .sidebar-mini-icon, .sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a .sidebar-normal, .sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a p,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a .sidebar-mini-icon,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a .sidebar-normal,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a p {
  color: #ffffff;
  font-weight: 400;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a:before,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav li.active a:before {
  content: " ";
  position: absolute;
  height: 25px;
  width: 4px;
  top: 4px;
  left: -16px;
  background: #419ef9 !important;
}
.sidebar .nav li.active > a[data-toggle=collapse]:before,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse]:before {
  content: " ";
  position: absolute;
  height: 26px;
  width: 4px;
  top: 9px;
  left: -16px;
  background: #419ef9 !important;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  margin: 0;
  line-height: 30px;
  position: relative;
  display: block;
  height: auto;
  white-space: nowrap;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
  font-size: 20px;
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  position: relative;
}
.sidebar .nav img,
.off-canvas-sidebar .nav img {
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 26px;
  height: 26px;
  text-align: center;
  position: relative;
}
.sidebar .sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-normal,
.off-canvas-sidebar .sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-normal {
  color: blue !important;
  font-weight: 700 !important;
}
.sidebar .sidebar-background,
.off-canvas-sidebar .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .sidebar-background:after,
.off-canvas-sidebar .sidebar-background:after {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  content: "";
  display: block;
  background: transparent;
  opacity: 1;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
  position: relative;
  padding: 0.5rem 0.7rem 1rem;
  z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  opacity: 1;
  float: left;
  width: 34px;
  text-align: center;
  margin-left: 10px;
  margin-right: 12px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #ffffff;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 0.5rem 0;
  display: block;
  white-space: nowrap;
  font-size: 0.875rem;
  text-decoration: none;
  font-weight: 400;
  line-height: 30px;
  overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar[data=white],
.off-canvas-sidebar[data=white] {
  background: #ffffff;
  background: linear-gradient(0deg, #ffffff 0%, #ffffff 100%);
}
.sidebar[data=white] p,
.off-canvas-sidebar[data=white] p {
  color: #111 !important;
}
.sidebar[data=white] .sidebar-normal,
.off-canvas-sidebar[data=white] .sidebar-normal {
  color: #111 !important;
}
.sidebar[data=white]:before,
.off-canvas-sidebar[data=white]:before {
  border-bottom-color: #ffffff;
}
.sidebar[data=blue],
.off-canvas-sidebar[data=blue] {
  background: #3358f4;
  background: linear-gradient(0deg, #3358f4 0%, #1d8cf8 100%);
}
.sidebar[data=blue]:before,
.off-canvas-sidebar[data=blue]:before {
  border-bottom-color: #1d8cf8;
}
.sidebar[data=green],
.off-canvas-sidebar[data=green] {
  background: #0098f0;
  background: linear-gradient(0deg, #0098f0 0%, #00f2c3 100%);
}
.sidebar[data=green]:before,
.off-canvas-sidebar[data=green]:before {
  border-bottom-color: #00f2c3;
}
.sidebar[data=orange],
.off-canvas-sidebar[data=orange] {
  background: #ff6491;
  background: linear-gradient(0deg, #ff6491 0%, #ff8d72 100%);
}
.sidebar[data=orange]:before,
.off-canvas-sidebar[data=orange]:before {
  border-bottom-color: #ff8d72;
}
.sidebar[data=red],
.off-canvas-sidebar[data=red] {
  background: #ec250d;
  background: linear-gradient(0deg, #ec250d 0%, #fd5d93 100%);
}
.sidebar[data=red]:before,
.off-canvas-sidebar[data=red]:before {
  border-bottom-color: #fd5d93;
}
.sidebar .user,
.off-canvas-sidebar .user {
  padding-bottom: 20px;
  margin: 20px auto 0;
  position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background: rgba(255, 255, 255, 0.5);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 10px;
  border-radius: 50%;
  margin-left: 23px;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
  width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
  color: #ffffff;
  text-decoration: none;
  padding: 0.5rem 15px;
  white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
  display: block;
  line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
  display: block;
  position: relative;
  opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
  position: absolute;
  top: 8px;
  right: 18px;
}
.sidebar:before,
.off-canvas-sidebar:before {
  content: "";
  position: absolute;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #e14eca;
  top: -5px;
  left: 57px;
  transform: translate(-50%);
}

.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
  color: #ffffff;
}
.off-canvas-sidebar .nav > li > a:focus {
  background: rgba(200, 200, 200, 0.2);
}

.main-panel {
  position: relative;
  float: right;
  width: 100%;
  min-height: 100vh;
  border-top: 2px solid #e14eca;
  background: linear-gradient(#1e1e2f, #1e1e24);
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel[data=white] {
  border-top: 2px solid #ffffff;
}
.main-panel[data=blue] {
  border-top: 2px solid #1d8cf8;
}
.main-panel[data=green] {
  border-top: 2px solid #00f2c3;
}
.main-panel[data=orange] {
  border-top: 2px solid #ff8d72;
}
.main-panel[data=red] {
  border-top: 2px solid #fd5d93;
}
.main-panel[data=primary] {
  border-top: 2px solid #e14eca;
}
.main-panel > .content {
  padding: 60px 10px 15px 235px;
  min-height: calc(100vh - 70px);
}
.main-panel > .navbar {
  margin-bottom: 0;
}
.main-panel .header {
  margin-bottom: 50px;
}

.perfect-scrollbar-on .sidebar,
.perfect-scrollbar-on .main-panel {
  height: 100%;
  max-height: 100%;
}

.panel-header {
  height: 260px;
  padding-top: 80px;
  padding-bottom: 45px;
  background: #141E30; /* fallback for old browsers */
  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
  position: relative;
  overflow: hidden;
}
.panel-header .header .title {
  color: #ffffff;
}
.panel-header .header .category {
  max-width: 600px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 auto;
  font-size: 13px;
}
.panel-header .header .category a {
  color: #ffffff;
}

.panel-header-sm {
  height: 135px;
}

.panel-header-lg {
  height: 380px;
}

@media (max-width: 991.98px) {
  .sidebar {
    position: fixed;
    display: block;
    top: 0;
    height: 100vh;
    width: 260px;
    right: auto;
    left: 0;
    margin: 0;
    border-radius: 0;
    z-index: 1032;
    visibility: visible;
    overflow-y: visible;
    padding: 0;
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-wrapper {
    height: 100vh;
  }
}
@media (max-width: 991.98px) {
  .minimize-sidebar {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(0px, 0, 0);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .nav-open .sidebar {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .nav-open .sidebar:before {
    content: normal;
    content: initial;
  }
}
@media (max-width: 991.98px) {
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
}
@media (max-width: 991.98px) {
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
.nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right .bodyClick {
    right: 260px;
    left: auto;
  }
}
@media (max-width: 991.98px) {
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
}
@media (max-width: 991.98px) {
  .bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    left: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
}
@media (max-width: 991.98px) {
  .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
}
@media (max-width: 991.98px) {
  .main-panel {
    width: 100%;
  }
  .main-panel .content {
    padding-left: 30px;
  }
}
@media (min-width: 992px) {
  .sidebar,
.main-panel,
.sidebar-wrapper {
    transition-property: top, bottom, width;
    transition-duration: 0.2s, 0.2s, 0.35s;
    transition-timing-function: linear, linear, ease;
    -webkit-overflow-scrolling: touch;
  }
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar {
    width: 80px;
  }
  .sidebar-mini .sidebar .sidebar-wrapper {
    width: 100% !important;
  }
  .sidebar-mini .sidebar {
    display: block;
    z-index: 1030;
    box-shadow: 0px 2px 22px 0 rgba(0, 0, 0, 0.2), 0px 2px 30px 0 rgba(0, 0, 0, 0.35);
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
.sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .sidebar-mini .sidebar:hover .navbar-minimize {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
.sidebar-mini .sidebar:hover .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
    opacity: 0;
  }
  .sidebar-mini .main-panel > .content {
    padding-left: 100px;
  }
  .sidebar-mini footer {
    padding-left: 130px;
  }
  .navbar-minimize button {
    margin-left: 10px;
  }
  .navbar-minimize button i {
    color: #ffffff;
    font-size: 20px;
  }
}
@media (max-width: 767.98px) {
  .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .sidebar {
    position: fixed;
    display: block;
    top: 0;
    height: 100vh;
    width: 260px !important;
    right: auto;
    left: 0;
    margin: 0;
    border-radius: 0;
    z-index: 1032;
    visibility: visible;
    overflow-y: visible;
    padding: 0;
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .sidebar .sidebar-wrapper {
    height: 100vh;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .main-panel {
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .main-panel {
    transition: none;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(0px, 0, 0);
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .nav-open .sidebar {
    transition: none;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .nav-open .sidebar:before {
    content: normal;
    content: initial;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
.nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right .bodyClick {
    right: 260px;
    left: auto;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    left: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .main-panel .content {
    padding-left: 30px !important;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0px, 0, 0);
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    opacity: 1;
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .sidebar-mini .sidebar .sidebar-wrapper .nav li a p {
    opacity: 1 !important;
    transform: translate3d(0px, 0, 0);
  }
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .minimize-sidebar {
    display: none;
  }
}
.sidebar .logo:after {
  background: #dddddd !important;
}

.fixed-plugin {
  display: none;
}

.collapse.show {
  margin-left: 14px;
}

.label-headding {
  font-size: 14px !important;
  font-weight: 700;
}

.label-title {
  font-size: 14px !important;
  font-weight: 500;
}

.textmessage-count {
  background: #ddd;
  padding: 0px;
  width: 150px;
  text-align: center;
  border-radius: 15px;
}

.textmessage-count h1 {
  margin-bottom: 0px;
  padding: 7px 0px;
}

.textmessage-count p {
  background: #222121;
  margin-bottom: 0px;
  color: #fff !important;
  border-radius: 0px 0px 15px 15px;
  padding: 14px 0px;
}

.summary-text {
  background: #ddd;
  padding: 20px 30px;
  border-radius: 12px;
}

.summary-text .label-headding {
  width: 170px;
}

.summary-text .label-title {
  width: 220px;
}

.card-wizard .wizard-navigation {
  position: relative;
  margin: 20px auto 60px !important;
}

.reports_smsstyles {
  background: #ddd;
}

.reports_smsstyles p {
  font-size: 14px;
  font-weight: 500;
}
.reports_smsstyles p span {
  display: block;
  font-weight: 700;
}

.smscard div {
  background: #e1e1e1;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
}
.smscard p {
  font-weight: 700;
}
.smscard p span {
  float: right;
  font-weight: 700;
}
.smscard .country-list {
  margin-left: 25px;
}
.smscard .country-list p {
  font-weight: 300;
}
.smscard .country-list span {
  float: right;
  font-weight: 500;
}

.reports_smsstyles .btn-styles {
  border: solid 1px #eee;
  padding: 20px 30px;
  background: #eee;
}

.campaignhistory-styles .card {
  border: solid 1px #ddd !important;
  box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.05) !important;
}
.campaignhistory-styles .card .bottom-part {
  border-top: solid 1px #f7f7f7;
  padding-top: 10px;
}
.campaignhistory-styles .card .bottom-part p {
  font-weight: 500;
  text-align: center;
}
.campaignhistory-styles .card .bottom-part span {
  display: block;
  font-weight: 600;
}

.navbar.navbar-transparent {
  background: #fff !important;
  position: fixed;
  padding: 2px 5px !important;
}

.tab-space {
  padding: 20px 0 50px 0px;
  overflow-x: auto;
  height: 69vh;
}

.footer {
  padding: 0px 30px !important;
}

.div1, .div2, .div3 {
  overflow-y: scroll;
  height: 267px;
}

.scroll-height-350 {
  overflow-y: scroll;
  height: 337px;
}

.scroll-height-380 {
  overflow-y: scroll;
  height: 367px;
}

.scroll-height-400 {
  overflow-y: scroll;
  height: 420px;
}

.scroll-height-450, .wizard-container {
  overflow-y: scroll;
  height: 469px;
}

.wizard-container .card-wizard {
  margin-bottom: 0px;
}

.menu-list-icons img {
  width: 28px;
  height: 28px;
  margin-left: 5px;
}

.modelbody Label {
  margin-bottom: 0px !important;
}

.modal-dialog {
  transform: translate(0, 0%) !important;
}

.roles-popup .table .form-check label .form-check-sign::before, .roles-popup .table .form-check label .form-check-sign::after {
  top: 5px;
  left: 10px;
}

.multicolortext {
  background-image: linear-gradient(to left, #4285f4, #ea4335, purple, #34a853, #fbbc05, #ea4335, #4285f4);
  -webkit-background-clip: text;
  -moz-background-clip: text !important;
  background-clip: text !important;
  color: transparent !important;
  font-weight: 700;
}

.navbar-brand .multicolortext {
  font-size: 14px !important;
  font-weight: 500 !important;
}

@media (min-width: 786px) {
  .modal-dialog {
    max-width: 700px !important;
    margin: 1.75rem auto;
  }
  .roles-popup {
    max-width: 1100px !important;
    margin: 0.75rem auto;
  }
}
.main-panel[data=white] {
  position: fixed;
  border-top: none;
}

.notification_alert {
  padding: 0.5rem;
  font-size: 20px;
  position: relative;
  cursor: pointer;
}

.sidenavk {
  height: 100%;
  width: 350px;
  position: fixed;
  z-index: 1;
  top: 0;
  right: -80%;
  background-color: #111;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenavk .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

.notification_alert_fullbox {
  height: 96%;
  overflow-y: scroll;
}

.notification_alert_box {
  background: #1d253b !important;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  overflow: hidden;
}

.box-img {
  float: left;
  width: 30%;
}

.box-content {
  float: right;
  width: 68%;
  margin-left: 2%;
}

.box-content h4 {
  font-weight: 600;
  margin-bottom: 2px;
  color: #f7f7f7 !important;
}

.box-content p {
  color: #fff !important;
  font-size: 11px;
}

ul.searchScroll {
  position: absolute;
  background: #fff;
  width: 89%;
  box-shadow: 0px 0px 10px grey;
  z-index: 9999;
  list-style: none;
  padding: 0px;
}

ul.searchScroll li {
  padding: 10px;
}

ul.searchScroll:nth-child(odd) {
  background: #fff;
}

ul.searchScroll:nth-child(even) {
  background: #eee;
}

ul.searchScroll li:hover {
  background: #ddd;
  cursor: pointer;
}

input[type=number].no-spinner::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.showPassword {
  padding: 8px;
  border: 1px solid rgba(29, 37, 59, 0.2);
  border-radius: 0px 5px 5px 0px;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
  background: #93a8e3;
  color: #fff !important;
}

.rdtDays tr .rdtDay {
  color: #2c2a2a !important;
}

.dropdown-menu > li:last-child, .dropdown-menu > li:last-child .dropdown-item {
  color: #185da1 !important;
  font-weight: 700 !important;
}

.box-count {
  text-align: center;
}

.box-1 {
  border-left: solid 3px #419ef9 !important;
}

.box-2 {
  border-left: solid 3px #00bf9a !important;
}

.box-3 {
  border-left: solid 3px #ff9f89 !important;
}

.box-4 {
  border-left: solid 3px #fd77a4 !important;
}

.form-group input[type=file] {
  border: 1px solid rgb(189, 189, 189) !important;
  padding: 4px !important;
  border-radius: 5px !important;
}

.card-category {
  font-size: 0.8500000025rem;
}

.white-content .table > thead > tr > th, .white-content .table > tbody > tr > th, .white-content .table > tfoot > tr > th, .white-content .table > thead > tr > td, .white-content .table > tbody > tr > td, .white-content .table > tfoot > tr > td {
  font-size: 0.8500000025rem !important;
}

.submit-btn i {
  color: rgb(47, 202, 125) !important;
}

.submit-btn:focus i {
  color: grey !important;
}

.btn-link-add {
  background: #eee;
  color: rgb(47, 202, 125);
}

.btn-link-add:hover {
  background: transparent !important;
  color: rgb(47, 202, 125);
}

.add-content {
  margin-bottom: 10px;
  display: inline-block;
  width: 150px;
  border: solid 2px #fff;
  transition: 0.2;
  text-transform: uppercase;
}

.add-content:hover .btn-link-add {
  background: transparent;
  transition: 0.5;
  font-weight: 600;
}

.add-content:hover {
  cursor: pointer;
  background: #ffffff !important;
  color: rgb(89, 91, 92) !important;
  border: solid 2px #eee;
  border-radius: 8px;
  transition: 0.5;
}

.btn-remove-style {
  background: transparent;
  color: rgb(206, 66, 66) !important;
  border: solid 1px rgb(206, 66, 66);
}

.btn-remove-style:hover {
  background: rgb(206, 66, 66) !important;
  color: #fff !important;
  border: solid 1px rgb(206, 66, 66);
}

.btn-add-style {
  background: transparent;
  color: rgb(47, 202, 125);
  border: solid 1px rgb(47, 202, 125);
}

.btn-add-style:hover {
  background: rgb(47, 202, 125) !important;
  color: #fff !important;
  border: solid 1px rgb(47, 202, 125);
}

.pagination .page-item .page-link:hover, .pagination .page-item .page-link:focus {
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
  color: #ffffff;
}

.graph {
  height: 60vh;
}

.tableheight {
  height: 60vh;
}

.tablemenu {
  height: 90vh;
}

.pagecount .pagination {
  float: right !important;
}

.sidebar[data=white] .sidebar-normal, .off-canvas-sidebar[data=white] .sidebar-normal {
  color: #111 !important;
  text-transform: capitalize !important;
}

@media screen and (min-width: 1320px) and (max-width: 2880px) {
  .graph {
    height: 60vh;
  }
  .tableheight {
    height: 50vh;
    padding-bottom: 15px;
    overflow-y: scroll;
  }
  .tableheight_nopagi {
    height: 60vh;
    padding-bottom: 15px;
    overflow-y: scroll;
  }
  .tableheight_nosearch {
    height: 65vh;
    padding-bottom: 15px;
    overflow-y: scroll;
  }
  .tableheightwf {
    height: 75vh;
    padding-bottom: 15px;
    overflow-y: scroll;
  }
  .listing .card {
    height: 80vh;
  }
  .card label {
    font-size: 0.7500000025rem !important;
  }
  .category {
    font-size: 0.7500000025rem !important;
  }
}
.company-brand {
  position: fixed;
  top: 50%;
  right: 0px;
  padding: 10px 10px;
  z-index: 999999;
  writing-mode: vertical-lr;
  background: #eee;
  height: 178px;
  text-align: center;
  border-radius: 20px 0px 0px 20px;
  box-shadow: 0px 0px 10px grey;
}

.company-brand:hover {
  cursor: pointer;
}

.company-brand a {
  font-weight: 700;
}

.login-page .card-login.card-white .form-control:focus {
  border: transparent !important;
}

.input-group .input-group-prepend .input-group-text i {
  font-weight: 700;
}

.navbar .navbar-brand {
  margin-left: 0px !important;
}

.table .form-check label .form-check-sign::before, .table .form-check label .form-check-sign::after {
  top: 0px !important;
}

.detailedReport {
  max-width: 95% !important;
}

.detailedReport .table-responsive {
  max-height: 450px !important;
}

.login-form {
  background: rgba(255, 255, 255, 0.1) !important;
  border: solid rgba(255, 255, 255, 0.4117647059) 5px !important;
}

.card-stats.mb-1.card {
  min-height: 185px;
}

/* Animations */
.nav-pills .nav-link,
.navbar,
.nav-tabs .nav-link,
.sidebar .nav a,
.sidebar .nav a i,
.sidebar .nav p,
.navbar-collapse .navbar-nav .nav-link,
.animation-transition-general,
.card-collapse .card .card-header a[data-toggle=collapse] i,
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize,
.sidebar .nav p,
.off-canvas-sidebar .nav p,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span,
.tag,
.tag [data-role=remove],
.animation-transition-general,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize,
.sidebar .nav p,
.off-canvas-sidebar .nav p,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
  transition: all 300ms ease 0s;
}

.bootstrap-switch-label:before,
.caret {
  transition: all 150ms ease 0s;
}

.dropdown-toggle[aria-expanded=true]:after,
a[data-toggle=collapse][aria-expanded=true] .caret,
.card-collapse .card a[data-toggle=collapse][aria-expanded=true] i,
.card-collapse .card a[data-toggle=collapse].expanded i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.caret {
  width: 0;
  height: 0;
  vertical-align: middle;
  border-top: 4px dashed;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-top: -5px;
  position: absolute;
  top: 30px;
  margin-left: 5px;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.card form label + .form-control {
  margin-bottom: 20px;
}

.offline-doc .page-header:before {
  background: rgba(0, 0, 0, 0.75);
}
.offline-doc .navbar {
  border: none;
}
.offline-doc .footer {
  position: absolute;
  width: 100%;
  background: transparent;
  bottom: 0;
  color: #ffffff;
  padding: 0.9375rem 0;
}

.card .map-title {
  color: #ffffff;
}
.card .table tr td p.title {
  padding-top: 7px;
  margin-bottom: 0;
}
.card.card-chart .gmnoprint,
.card.card-chart .gm-style-cc {
  display: none !important;
}

.bd-docs h1, .bd-docs h2, .bd-docs h3, .bd-docs h4, .bd-docs h5, .bd-docs h6, .bd-docs p, .bd-docs ul li, .bd-docs ol li {
  color: #2c2c2c;
}
.bd-docs .bd-content > table > thead > tr > th {
  color: #222a42;
}
.bd-docs .blockquote, .bd-docs .blockquote p, .bd-docs .card p {
  color: rgba(255, 255, 255, 0.8);
}
.bd-docs .bd-example {
  background: linear-gradient(#1e1e2f, #1e1e24);
}
.bd-docs .navbar {
  border-top: none;
}
.bd-docs .navbar .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.8) !important;
}
.bd-docs .bd-example .btn {
  margin: 4px 0;
}
.bd-docs .bd-example .btn .badge {
  display: inline-block;
}
.bd-docs .bd-example .tim-icons {
  color: #ffffff;
}
.bd-docs .bd-example .popover .popover-header {
  color: hsla(0deg, 0%, 71%, 0.6);
}
.bd-docs .bd-example .popover-body p {
  color: #212529;
}
.bd-docs .bd-example.tooltip-demo p {
  color: rgba(255, 255, 255, 0.8);
}
.bd-docs .card.card-body,
.bd-docs .card .card-body {
  color: hsla(0deg, 0%, 100%, 0.8);
}
.bd-docs label,
.bd-docs .form-check {
  color: hsla(0deg, 0%, 100%, 0.8);
}
.bd-docs .form-check + .btn {
  margin-top: 20px;
}
.bd-docs .bd-example thead th,
.bd-docs table thead th {
  color: hsla(0deg, 0%, 100%, 0.8);
}
.bd-docs .bd-example h1, .bd-docs .bd-example h2, .bd-docs .bd-example h3, .bd-docs .bd-example h4, .bd-docs .bd-example h5, .bd-docs .bd-example h6,
.bd-docs .bd-example .h1, .bd-docs .bd-example .h2, .bd-docs .bd-example .h3, .bd-docs .bd-example .h4, .bd-docs .bd-example .h5, .bd-docs .bd-example .h6,
.bd-docs table h1,
.bd-docs table h2,
.bd-docs table h3,
.bd-docs table h4,
.bd-docs table h5,
.bd-docs table h6,
.bd-docs table .h1,
.bd-docs table .h2,
.bd-docs table .h3,
.bd-docs table .h4,
.bd-docs table .h5,
.bd-docs table .h6 {
  color: hsla(0deg, 0%, 100%, 0.8);
}
.bd-docs .bd-example .datepicker thead th, .bd-docs .bd-example .datepicker table thead th, .bd-docs .bd-example .datepicker .tim-icons,
.bd-docs table .datepicker thead th,
.bd-docs table .datepicker table thead th,
.bd-docs table .datepicker .tim-icons {
  color: #e14eca;
}
.bd-docs .bd-example .picker-switch .tim-icons,
.bd-docs table .picker-switch .tim-icons {
  color: #e14eca;
}
.bd-docs .footer .container-fluid > nav, .bd-docs .footer .container-sm > nav, .bd-docs .footer .container-md > nav, .bd-docs .footer .container-lg > nav, .bd-docs .footer .container-xl > nav {
  display: inline-block;
}
.bd-docs #exampleModalLong.modal.show .modal-dialog {
  transform: translateY(5%);
}

.modal.show .modal-dialog {
  transform: translate(0, 30%);
}

code {
  color: #f3a4b5;
}

.rtl .sidebar,
.rtl .bootstrap-navbar {
  right: 0;
  left: auto;
  margin-right: 20px;
  margin-left: 0;
}
.rtl .sidebar .nav i,
.rtl .bootstrap-navbar .nav i {
  float: right;
  margin-left: 15px;
  margin-right: 0;
}
.rtl .sidebar .nav p,
.rtl .bootstrap-navbar .nav p {
  margin-right: 45px;
  text-align: right;
}
.rtl .sidebar .nav .caret,
.rtl .bootstrap-navbar .nav .caret {
  left: 11px;
  right: auto;
}
.rtl .sidebar .nav li.active a:before,
.rtl .bootstrap-navbar .nav li.active a:before {
  left: auto !important;
  right: -4px;
}
.rtl .sidebar .logo a.logo-mini,
.rtl .bootstrap-navbar .logo a.logo-mini {
  float: right;
  margin-right: 20px;
  margin-left: 10px;
}
.rtl .sidebar .logo .simple-text,
.rtl .bootstrap-navbar .logo .simple-text {
  text-align: right;
}
.rtl .sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .bootstrap-navbar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .bootstrap-navbar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  float: right;
  margin-left: 15px;
  margin-right: 0;
}
.rtl .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .bootstrap-navbar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .bootstrap-navbar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  text-align: right;
}
.rtl .sidebar:before,
.rtl .bootstrap-navbar:before {
  right: 30px;
  left: auto;
}
.rtl .main-panel {
  position: fixed;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.rtl .main-panel .content {
  padding: 110px 300px 20px 50px;
}
.rtl .dropdown-toggle:after {
  margin-right: 0.255em;
  margin-left: 0;
}
.rtl .dropdown-menu.dropdown-menu-right.dropdown-navbar {
  right: -220px !important;
  left: auto;
}
.rtl .dropdown-menu.dropdown-menu-right.dropdown-navbar:before {
  right: auto;
  left: 35px;
}
.rtl .notification {
  left: 40px;
  right: auto;
}
.rtl .dropdown-menu {
  right: auto;
  left: 0;
}
.rtl .card-timeline .timeline .timeline-footer .btn {
  margin-left: 0;
  margin-right: auto;
}
.rtl .navbar-minimize-fixed {
  margin-right: 38px;
  margin-left: auto;
}
.rtl .minimize-sidebar {
  float: right;
}
.rtl .alert {
  left: 0;
  margin-left: 0;
  margin-right: 0;
}
.rtl .alert button.close {
  left: 10px !important;
  right: auto !important;
}
.rtl .alert span[data-notify=icon] {
  right: 15px;
  left: auto;
}
.rtl .alert.alert-with-icon {
  padding-right: 65px;
  padding-left: 15px;
}
.rtl .alert.alert-with-icon i[data-notify=icon] {
  right: 15px;
  left: auto;
}
.rtl .search-bar {
  margin-left: 0;
}
.rtl .modal-search .modal-header .close {
  margin-right: auto;
  left: 10px;
}
.rtl .rtl .footer {
  padding: 24px 30px !important;
}
.rtl .ps__rail-y {
  right: auto !important;
  left: 0;
}
.rtl .card.card-timeline .timeline .timeline-footer .btn.dropdown-toggle i {
  left: 0 !important;
}
.rtl .card.card-timeline .timeline .timeline-footer .btn.dropdown-toggle:after {
  margin-left: 5px !important;
}
.rtl .fixed-plugin .dropdown-menu {
  right: 80px;
}

@media (min-width: 1200px) {
  .rtl.sidebar-mini .main-panel .content {
    padding-right: 130px;
    padding-left: 50px;
  }
  .rtl.sidebar-mini footer {
    padding-right: 130px;
    padding-left: 50px;
  }
  .rtl .navbar-minimize button {
    margin-right: -5px;
  }
  .rtl .footer {
    padding: 24px 300px 24px 0;
  }
}
@media (max-width: 1199.98px) {
  .rtl .sidebar {
    transform: translate3d(260px, 0, 0);
  }
  .rtl .main-panel {
    float: right;
    right: 0;
    left: auto;
    transform: translate3d(0px, 0, 0);
  }
  .rtl .sidebar {
    margin-right: 0;
  }
  .rtl .main-panel .content {
    padding-right: 50px;
  }
}
@media (max-width: 991.98px) {
  .rtl .main-panel .content {
    padding-right: 50px;
  }
  .rtl #bodyClick {
    right: 260px;
    left: auto;
  }
  .rtl .navbar .navbar-toggle .navbar-toggler {
    display: block;
    margin-right: 20px;
  }
  .rtl .navbar .navbar-nav {
    padding-right: 0;
  }
  .rtl .navbar .navbar-nav a.nav-link {
    text-align: right;
  }
  .rtl .navbar .navbar-nav a.nav-link p {
    margin-right: 7px;
  }
  .rtl .navbar .navbar-nav .btn {
    margin-right: 0;
    padding: 0;
  }
  .rtl .navbar .navbar-nav .btn i {
    margin-left: 4px;
    margin-right: 5px;
  }
  .rtl .navbar .navbar-nav .search-bar span {
    margin-right: 10px;
  }
  .nav-open body {
    position: fixed;
  }
}
@media (max-width: 767.98px) {
  .rtl .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media (max-width: 575.98px) {
  .rtl .navbar .dropdown-menu {
    width: 200px !important;
  }
}
.card.card-timeline .card-body {
  padding-left: 0;
  padding-right: 0;
}
.card.card-timeline .timeline {
  list-style: none;
  padding: 20px 0 20px;
  position: relative;
}
.card.card-timeline .timeline:before {
  top: 0;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 3px;
  background-color: #222a42;
  left: 50%;
  margin-left: -1.5px;
}
.card.card-timeline .timeline .timeline-footer .btn {
  margin: 0;
}
.card.card-timeline .timeline .timeline-footer .btn.dropdown-toggle i {
  top: -1px;
  left: 10px;
}
.card.card-timeline .timeline .timeline-footer .btn.dropdown-toggle:after {
  margin-left: 20px !important;
}
.card.card-timeline .timeline h6 {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  margin: 10px 0px 0px;
}
.card.card-timeline .timeline.timeline-simple:before {
  left: 5%;
}
.card.card-timeline .timeline.timeline-simple > li > .timeline-panel {
  width: 86%;
}
.card.card-timeline .timeline.timeline-simple > li > .timeline-badge {
  left: 5%;
}
.card.card-timeline .timeline > li {
  margin-bottom: 20px;
  position: relative;
}
.card.card-timeline .timeline > li:before, .card.card-timeline .timeline > li:after {
  content: " ";
  display: table;
}
.card.card-timeline .timeline > li:after {
  clear: both;
}
.card.card-timeline .timeline > li > .timeline-panel {
  background: #27293d;
  width: 45%;
  float: left;
  padding: 20px;
  border-radius: 0.2857rem;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
  color: #222a42;
  margin-bottom: 20px;
  position: relative;
}
.card.card-timeline .timeline > li > .timeline-panel:before {
  position: absolute;
  top: 26px;
  right: -15px;
  display: inline-block;
  border-top: 15px solid transparent;
  border-left: 15px solid #222a42;
  border-right: 0 solid #222a42;
  border-bottom: 15px solid transparent;
  content: " ";
}
.card.card-timeline .timeline > li > .timeline-panel:after {
  position: absolute;
  top: 27px;
  right: -14px;
  display: inline-block;
  border-top: 14px solid transparent;
  border-left: 14px solid #27293d;
  border-right: 0 solid #27293d;
  border-bottom: 14px solid transparent;
  content: " ";
}
.card.card-timeline .timeline > li > .timeline-panel.timeline-panel-white {
  background: #ffffff;
}
.card.card-timeline .timeline > li > .timeline-panel.timeline-panel-white .timeline-body p {
  color: #1d253b;
}
.card.card-timeline .timeline > li > .timeline-panel.timeline-panel-white:after, .card.card-timeline .timeline > li > .timeline-panel.timeline-panel-white:before {
  border-right-color: #ffffff;
  border-left-color: #ffffff;
}
.card.card-timeline .timeline > li > .timeline-badge {
  color: #ffffff;
  width: 50px;
  height: 50px;
  line-height: 51px;
  font-size: 1.4em;
  text-align: center;
  position: absolute;
  top: 16px;
  left: 50%;
  margin-left: -25px;
  background-color: #9A9A9A;
  z-index: 100;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
}
.card.card-timeline .timeline > li > .timeline-badge [class^=ti-],
.card.card-timeline .timeline > li > .timeline-badge [class*=" ti-"] {
  line-height: inherit;
}
.card.card-timeline .timeline > li > .timeline-badge .tim-icons {
  width: 25px;
  height: 21px;
  text-align: center;
}
.card.card-timeline .timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}
.card.card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {
  border-left-width: 0;
  border-right-width: 15px;
  left: -15px;
  right: auto;
}
.card.card-timeline .timeline > li.timeline-inverted > .timeline-panel:after {
  border-left-width: 0;
  border-right-width: 14px;
  left: -14px;
  right: auto;
}
.card.card-timeline .timeline-heading {
  margin-bottom: 15px;
}
.card.card-timeline .timeline-badge.primary {
  background-color: #1d8cf8 !important;
}
.card.card-timeline .timeline-badge.info {
  background-color: #1d8cf8 !important;
}
.card.card-timeline .timeline-badge.success {
  background-color: #00bf9a !important;
}
.card.card-timeline .timeline-badge.warning {
  background-color: #ff8d72 !important;
}
.card.card-timeline .timeline-badge.danger {
  background-color: #fd5d93 !important;
}
.card.card-timeline .timeline-title {
  margin-top: 0;
  color: inherit;
}
.card.card-timeline .timeline-body > p,
.card.card-timeline .timeline-body > ul {
  margin-bottom: 0;
  color: #ffffff;
}
.card.card-timeline .timeline-body > p + p {
  margin-top: 5px;
}

@media (max-width: 767.98px) {
  .card.card-timeline .timeline:before {
    left: 5%;
  }
  .card.card-timeline .timeline > li > .timeline-badge {
    left: 5%;
  }
  .card.card-timeline .timeline > li > .timeline-panel {
    float: right;
    width: 83% !important;
  }
  .card.card-timeline .timeline > li > .timeline-panel:before {
    border-left-width: 0;
    border-right-width: 15px;
    left: -15px;
    right: auto;
  }
  .card.card-timeline .timeline > li > .timeline-panel:after {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }
}
.sr-only,
.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after,
.bootstrap-datetimepicker-widget .btn[data-action=clear]::after,
.bootstrap-datetimepicker-widget .btn[data-action=today]::after,
.bootstrap-datetimepicker-widget .picker-switch::after,
.bootstrap-datetimepicker-widget table th.prev::after,
.bootstrap-datetimepicker-widget table th.next::after {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.bootstrap-datetimepicker-widget {
  list-style: none;
}

.bootstrap-datetimepicker-widget a .btn:hover {
  background-color: transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu {
  padding: 8px 6px;
  width: 254px;
  max-width: 254px;
}
.bootstrap-datetimepicker-widget.dropdown-menu .tim-icons {
  opacity: 1;
}
.bootstrap-datetimepicker-widget.dropdown-menu .picker-switch .table-condensed:hover {
  background: #eee;
  border-radius: 3px;
}
.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed {
  margin-top: 10px;
  margin-bottom: 5px;
}
.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed .btn[data-action=togglePeriod]:hover,
.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed .separator {
  color: #9A9A9A !important;
}
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .month,
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .year,
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .decade {
  color: #9A9A9A;
}
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .month.active,
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .year.active,
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .decade.active {
  color: #ffffff;
}

@media (min-width: 768px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 992px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 1200px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  right: auto;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top:before {
  display: none;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -6px;
  right: auto;
  left: 10px;
  color: #ffffff;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top {
  margin-top: auto;
  margin-bottom: -20px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top.open {
  margin-top: auto;
  margin-bottom: 3px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}

.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}

.bootstrap-datetimepicker-widget a[data-action] {
  padding: 0;
  border-width: 0;
  color: #fff;
  background-color: transparent;
}

.bootstrap-datetimepicker-widget a[data-action=togglePicker],
.bootstrap-datetimepicker-widget a[data-action=togglePicker]:hover {
  color: #e14eca;
}

.bootstrap-datetimepicker-widget a[data-action]:hover {
  background-color: transparent;
}

.bootstrap-datetimepicker-widget a[data-action]:active {
  box-shadow: none;
}

.bootstrap-datetimepicker-widget .timepicker-hour,
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-weight: 300;
  font-size: 1.5em;
  margin: 3px;
  border-radius: 50%;
  color: #9A9A9A;
}

.bootstrap-datetimepicker-widget button[data-action] {
  width: 38px;
  height: 38px;
  padding: 0;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}

.bootstrap-datetimepicker-widget .btn {
  margin: 0 !important;
}

.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after {
  content: "Increment Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after {
  content: "Increment Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after {
  content: "Decrement Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after {
  content: "Decrement Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after {
  content: "Show Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after {
  content: "Show Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after {
  content: "Toggle AM/PM";
}

.bootstrap-datetimepicker-widget .btn[data-action=clear]::after {
  content: "Clear the picker";
}

.bootstrap-datetimepicker-widget .btn[data-action=today]::after {
  content: "Set the date to today";
}

.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
  border-radius: 3px;
  color: #e14eca;
}

.bootstrap-datetimepicker-widget .picker-switch::after {
  content: "Toggle Date and Time Screens";
}

.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}

.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
  border-radius: 3px;
  margin: 2px 0px !important;
}

.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {
  text-align: center;
}

.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
  font-weight: 300;
}

.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}

.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {
  border-radius: 4px;
  height: 27px;
  width: 27px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
  color: #e14eca;
}

.bootstrap-datetimepicker-widget table th.prev::after {
  content: "Previous Month";
}

.bootstrap-datetimepicker-widget table th.next::after {
  content: "Next Month";
}

.bootstrap-datetimepicker-widget table th.dow {
  text-align: center;
  color: #e14eca;
  padding-bottom: 5px;
  padding-top: 10px;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background: #eee;
}

.bootstrap-datetimepicker-widget table td.cw > div {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.day > div,
.bootstrap-datetimepicker-widget table td.minute > div,
.bootstrap-datetimepicker-widget table td.hour > div {
  height: 30px;
  line-height: 2.2;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
  margin: 0 auto;
  z-index: -1;
  color: #9A9A9A;
  position: relative;
  font-weight: 300;
  font-size: 14px;
  border: none;
  cursor: pointer;
  transition: all 300ms ease 0s;
}

.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {
  background: #eee;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {
  color: #344675;
}

.bootstrap-datetimepicker-widget table td.today > div:before {
  content: "";
  display: inline-block;
  border: 0 0 7px 7px solid transparent;
  border-bottom-color: #68B3C8;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
}

.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #e14eca;
  color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}

.bootstrap-datetimepicker-widget table td.active.today:before > div {
  border-bottom-color: #ffffff;
}

.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 0 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td span.active {
  background-color: #e14eca;
  color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td span.old {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
  border-radius: 50% !important;
}

.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-addon {
  cursor: pointer;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
  padding: 1px;
  text-align: center;
  z-index: 1;
  cursor: pointer;
}

input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget .picker-switch,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table th.prev span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table th.next span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.day > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget a[data-action=togglePicker],
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget a[data-action=togglePicker]:hover,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget .timepicker-hours span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget .timepicker-minutes span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget .separator,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.minute > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.hour > div {
  color: #9A9A9A;
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table th.dow {
  color: rgba(255, 255, 255, 0.8);
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.old > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.new > div {
  color: rgba(255, 255, 255, 0.4);
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget button[data-action] {
  background-color: #ffffff;
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #ffffff;
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td:not(.active).day:hover > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.hour:hover > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.minute:hover > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.second:hover > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td span:hover {
  background: rgba(255, 255, 255, 0.2);
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget {
  background-color: #e14eca;
}
input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #e14eca;
}

input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget {
  background-color: #1d8cf8;
}
input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #1d8cf8;
}

input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget {
  background-color: #00f2c3;
}
input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #00f2c3;
}

input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget {
  background-color: #fd5d93;
}
input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #fd5d93;
}

input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget {
  background-color: #ff8d72;
}
input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #ff8d72;
}

.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .day, .bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .minute {
  color: rgba(255, 255, 255, 0.7);
}
.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .day:hover, .bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .minute:hover {
  color: #212529;
}
.bootstrap-datetimepicker-widget.dropdown-black table td span, .bootstrap-datetimepicker-widget.dropdown-black table td.minute, .bootstrap-datetimepicker-widget.dropdown-black table td.hour {
  color: rgba(255, 255, 255, 0.7);
}
.bootstrap-datetimepicker-widget.dropdown-black table td span:hover, .bootstrap-datetimepicker-widget.dropdown-black table td.minute:hover, .bootstrap-datetimepicker-widget.dropdown-black table td.hour:hover {
  background: transparent;
  color: rgba(255, 255, 255, 0.4);
}
.bootstrap-datetimepicker-widget.dropdown-black table td span:hover div, .bootstrap-datetimepicker-widget.dropdown-black table td.minute:hover div, .bootstrap-datetimepicker-widget.dropdown-black table td.hour:hover div {
  background: transparent;
}
.bootstrap-datetimepicker-widget.dropdown-black table td .btn[data-action] {
  color: #ffffff;
}
.bootstrap-datetimepicker-widget.dropdown-black table td .btn[data-action=togglePeriod] {
  background: transparent;
}

/*! nouislider - 11.1.0 - 2018-04-02 11:18:13 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 1px;
}

.noUi-horizontal .noUi-handle {
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-left: -10px;
  margin-top: -7px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -15px;
  left: auto;
  outline: none;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #344675;
  border-radius: 3px;
  transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #ffffff;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
  -webkit-transition: 300ms ease 0s;
  -moz-transition: 300ms ease 0s;
  -ms-transition: 300ms ease 0s;
  -o-transform: 300ms ease 0s;
  transition: 300ms ease 0s;
}

.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%, 0);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate3d(0, 50%, 0);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #ffffff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.slider.slider-neutral .noUi-connect, .slider.slider-neutral.noUi-connect {
  background-color: #ffffff;
}
.slider.slider-neutral.noUi-target {
  background-color: rgba(255, 255, 255, 0.3);
}
.slider.slider-neutral .noUi-handle {
  background-color: #ffffff;
}
.slider.slider-primary .noUi-connect, .slider.slider-primary.noUi-connect {
  background-color: #e14eca;
}
.slider.slider-primary.noUi-target {
  background-color: rgba(249, 99, 50, 0.3);
}
.slider.slider-primary .noUi-handle {
  background-color: #e14eca;
  box-shadow: 0px 0px 10px 0px #e14eca;
}
.slider.slider-info .noUi-connect, .slider.slider-info.noUi-connect {
  background-color: #1d8cf8;
}
.slider.slider-info.noUi-target {
  background-color: rgba(44, 168, 255, 0.3);
}
.slider.slider-info .noUi-handle {
  background-color: #1d8cf8;
  box-shadow: 0px 0px 10px 0px #1d8cf8;
}
.slider.slider-success .noUi-connect, .slider.slider-success.noUi-connect {
  background-color: #00f2c3;
}
.slider.slider-success.noUi-target {
  background-color: rgba(24, 206, 15, 0.3);
}
.slider.slider-success .noUi-handle {
  background-color: #00f2c3;
  box-shadow: 0px 0px 10px 0px #00f2c3;
}
.slider.slider-warning .noUi-connect, .slider.slider-warning.noUi-connect {
  background-color: #ff8d72;
}
.slider.slider-warning.noUi-target {
  background-color: rgba(255, 178, 54, 0.3);
}
.slider.slider-warning .noUi-handle {
  background-color: #ff8d72;
  box-shadow: 0px 0px 10px 0px #ff8d72;
}
.slider.slider-danger .noUi-connect, .slider.slider-danger.noUi-connect {
  background-color: #fd5d93;
}
.slider.slider-danger.noUi-target {
  background-color: rgba(255, 54, 54, 0.3);
}
.slider.slider-danger .noUi-handle {
  background-color: #fd5d93;
  box-shadow: 0px 0px 10px 0px #fd5d93;
}

.fc {
  direction: ltr;
  text-align: left;
}

.fc-rtl {
  text-align: right;
}

body .fc {
  /* extra precedence to overcome jqui */
  font-size: 1em;
}

/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-highlight {
  /* when user is selecting cells */
  background: #bce8f1;
  opacity: 0.3;
}

.fc-bgevent {
  /* default look for background events */
  background: #8fdf82;
  opacity: 0.3;
}

.fc-nonbusiness {
  /* default look for non-business-hours areas */
  /* will inherit .fc-bgevent's styles */
  background: #d7d7d7;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-popover {
  position: absolute;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.fc-popover .fc-header {
  /* TODO: be more consistent with fc-head/fc-body */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2px 4px;
}

.fc-rtl .fc-popover .fc-header {
  flex-direction: row-reverse;
}

.fc-popover .fc-header .fc-title {
  margin: 0 2px;
}

.fc-popover .fc-header .fc-close {
  cursor: pointer;
  opacity: 0.65;
  font-size: 1.1em;
}

/* Misc Reusable Components
--------------------------------------------------------------------------------------------------*/
.fc-divider {
  border-style: solid;
  border-width: 1px;
}

hr.fc-divider {
  height: 0;
  margin: 0;
  padding: 0 0 2px;
  /* height is unreliable across browsers, so use padding */
  border-width: 1px 0;
}

.fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-mirror-skeleton {
  /* these element should always cling to top-left/right corners */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-bg {
  bottom: 0;
  /* strech bg to bottom edge */
}

.fc-bg table {
  height: 100%;
  /* strech bg to bottom edge */
}

/* Tables
--------------------------------------------------------------------------------------------------*/
.fc table {
  width: 100%;
  box-sizing: border-box;
  /* fix scrollbar issue in firefox */
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em;
  /* normalize cross-browser */
}

.fc th {
  text-align: center;
}

.fc th,
.fc td {
  border-style: solid;
  border-width: 1px;
  padding: 0;
  vertical-align: top;
}

.fc td.fc-today {
  border-style: double;
  /* overcome neighboring borders */
}

/* Internal Nav Links
--------------------------------------------------------------------------------------------------*/
a[data-goto] {
  cursor: pointer;
}

a[data-goto]:hover {
  text-decoration: underline;
}

/* Fake Table Rows
--------------------------------------------------------------------------------------------------*/
.fc .fc-row {
  /* extra precedence to overcome themes forcing a 1px border */
  /* no visible border by default. but make available if need be (scrollbar width compensation) */
  border-style: solid;
  border-width: 0;
}

.fc-row table {
  /* don't put left/right border on anything within a fake row.
     the outer tbody will worry about this */
  border-left: 0 hidden transparent;
  border-right: 0 hidden transparent;
  /* no bottom borders on rows */
  border-bottom: 0 hidden transparent;
}

.fc-row:first-child table {
  border-top: 0 hidden transparent;
  /* no top border on first row */
}

/* Day Row (used within the header and the DayGrid)
--------------------------------------------------------------------------------------------------*/
.fc-row {
  position: relative;
}

.fc-row .fc-bg {
  z-index: 1;
}

/* highlighting cells & background event skeleton */
.fc-row .fc-bgevent-skeleton,
.fc-row .fc-highlight-skeleton {
  bottom: 0;
  /* stretch skeleton to bottom of row */
}

.fc-row .fc-bgevent-skeleton table,
.fc-row .fc-highlight-skeleton table {
  height: 100%;
  /* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton td,
.fc-row .fc-bgevent-skeleton td {
  border-color: transparent;
}

.fc-row .fc-bgevent-skeleton {
  z-index: 2;
}

.fc-row .fc-highlight-skeleton {
  z-index: 3;
}

/*
row content (which contains day/week numbers and events) as well as "mirror" (which contains
temporary rendered events).
*/
.fc-row .fc-content-skeleton {
  position: relative;
  z-index: 4;
  padding-bottom: 2px;
  /* matches the space above the events */
}

.fc-row .fc-mirror-skeleton {
  z-index: 5;
}

.fc .fc-row .fc-content-skeleton table,
.fc .fc-row .fc-content-skeleton td,
.fc .fc-row .fc-mirror-skeleton td {
  /* see-through to the background below */
  /* extra precedence to prevent theme-provided backgrounds */
  background: none;
  /* in case <td>s are globally styled */
  border-color: transparent;
}

.fc-row .fc-content-skeleton td,
.fc-row .fc-mirror-skeleton td {
  /* don't put a border between events and/or the day number */
  border-bottom: 0;
}

.fc-row .fc-content-skeleton tbody td,
.fc-row .fc-mirror-skeleton tbody td {
  /* don't put a border between event cells */
  border-top: 0;
}

/* Scrolling Container
--------------------------------------------------------------------------------------------------*/
.fc-scroller {
  -webkit-overflow-scrolling: touch;
}

/* TODO: move to timegrid/daygrid */
.fc-scroller > .fc-day-grid,
.fc-scroller > .fc-time-grid {
  position: relative;
  /* re-scope all positions */
  width: 100%;
  /* hack to force re-sizing this inner element when scrollbars appear/disappear */
}

/* Global Event Styles
--------------------------------------------------------------------------------------------------*/
.fc-event {
  position: relative; /* for resize handle and other inner positioning */
  display: block; /* make the <a> tag block */
  font-size: 0.85em;
  line-height: 1.3;
  border-radius: 2px;
  background-color: #00f2c3; /* default BACKGROUND color */
  font-weight: normal; /* undo jqui's ui-widget-header bold */
}
.fc-event.event-azure {
  background-color: #1d8cf8;
}
.fc-event.event-green {
  background-color: #00bf9a;
}
.fc-event.event-orange {
  background-color: #ff8d72;
}
.fc-event.event-red {
  background-color: #fd5d93;
}
.fc-event.event-default {
  background-color: #344675;
}

.fc-event-dot {
  background-color: #3a87ad; /* default BACKGROUND color */
}

.fc-event,
.fc-event:hover,
.ui-widget .fc-event {
  color: #ffffff; /* default TEXT color */
  text-decoration: none; /* if <a> has an href */
}

.fc-event[href],
.fc-event.fc-draggable {
  cursor: pointer;
  /* give events with links and draggable events a hand mouse pointer */
}

.fc-not-allowed,
.fc-not-allowed .fc-event {
  /* to override an event's custom cursor */
  cursor: not-allowed;
}

.fc-event .fc-bg { /* the generic .fc-bg already does position */
  z-index: 1;
  background: #ffffff;
  opacity: 0.25;
}

.fc-event .fc-content {
  position: relative;
  z-index: 2;
}

/* resizer (cursor AND touch devices) */
.fc-event .fc-resizer {
  position: absolute;
  z-index: 4;
}

/* resizer (touch devices) */
.fc-event .fc-resizer {
  display: none;
}

.fc-event.fc-allow-mouse-resize .fc-resizer,
.fc-event.fc-selected .fc-resizer {
  /* only show when hovering or selected (with touch) */
  display: block;
}

/* hit area */
.fc-event.fc-selected .fc-resizer:before {
  /* 40x40 touch area */
  content: "";
  position: absolute;
  z-index: 9999;
  /* user of this util can scope within a lower z-index */
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  margin-left: -20px;
  margin-top: -20px;
}

/* Event Selection (only for touch devices)
--------------------------------------------------------------------------------------------------*/
.fc-event.fc-selected {
  z-index: 9999 !important;
  /* overcomes inline z-index */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.fc-event.fc-selected:after {
  content: "";
  position: absolute;
  z-index: 1;
  /* same z-index as fc-bg, behind text */
  /* overcome the borders */
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  /* darkening effect */
  background: #000;
  opacity: 0.25;
}

/* Event Dragging
--------------------------------------------------------------------------------------------------*/
.fc-event.fc-dragging.fc-selected {
  z-index: 9999 !important; /* overcomes inline z-index */
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);
}

.fc-event.fc-selected.fc-dragging {
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);
}

.fc-event.fc-dragging:not(.fc-selected) {
  opacity: 0.75;
}

/* Horizontal Events
--------------------------------------------------------------------------------------------------*/
/* bigger touch area when selected */
.fc-h-event.fc-selected:before {
  content: "";
  position: absolute;
  z-index: 3;
  /* below resizers */
  top: -10px;
  bottom: -10px;
  left: 0;
  right: 0;
}

/* events that are continuing to/from another week. kill rounded corners and butt up against edge */
.fc-ltr .fc-h-event.fc-not-start,
.fc-rtl .fc-h-event.fc-not-end {
  margin-left: 0;
  border-left-width: 0;
  padding-left: 1px;
  /* replace the border with padding */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-ltr .fc-h-event.fc-not-end,
.fc-rtl .fc-h-event.fc-not-start {
  margin-right: 0;
  border-right-width: 0;
  padding-right: 1px;
  /* replace the border with padding */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* resizer (cursor AND touch devices) */
/* left resizer  */
.fc-ltr .fc-h-event .fc-start-resizer,
.fc-rtl .fc-h-event .fc-end-resizer {
  cursor: w-resize;
  left: -1px;
  /* overcome border */
}

/* right resizer */
.fc-ltr .fc-h-event .fc-end-resizer,
.fc-rtl .fc-h-event .fc-start-resizer {
  cursor: e-resize;
  right: -1px;
  /* overcome border */
}

/* resizer (mouse devices) */
.fc-h-event.fc-allow-mouse-resize .fc-resizer {
  width: 7px;
  top: -1px;
  /* overcome top border */
  bottom: -1px;
  /* overcome bottom border */
}

/* resizer (touch devices) */
.fc-h-event.fc-selected .fc-resizer {
  /* 8x8 little dot */
  border-radius: 4px;
  border-width: 1px;
  width: 6px;
  height: 6px;
  border-style: solid;
  border-color: inherit;
  background: #fff;
  /* vertically center */
  top: 50%;
  margin-top: -4px;
}

/* left resizer  */
.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,
.fc-rtl .fc-h-event.fc-selected .fc-end-resizer {
  margin-left: -4px;
  /* centers the 8x8 dot on the left edge */
}

/* right resizer */
.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,
.fc-rtl .fc-h-event.fc-selected .fc-start-resizer {
  margin-right: -4px;
  /* centers the 8x8 dot on the right edge */
}

/* DayGrid events
----------------------------------------------------------------------------------------------------
We use the full "fc-day-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-day-grid-event {
  margin: 1px 5px 0;
  /* spacing between events and edges */
  padding: 0 1px;
}

tr:first-child > td > .fc-day-grid-event {
  margin-top: 2px;
  /* a little bit more space before the first event */
}

.fc-day-grid-event.fc-selected:after {
  content: "";
  position: absolute;
  z-index: 1; /* same z-index as fc-bg, behind text */
  /* overcome the borders */
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  /* darkening effect */
  background: #000;
  opacity: 0.25;
}

.fc-day-grid-event .fc-content { /* force events to be one-line tall */
  white-space: nowrap;
  overflow: hidden;
  color: #ffffff;
  padding: 0 5px;
}

.fc-day-grid-event .fc-time {
  font-weight: bold;
}

/* resizer (cursor devices) */
/* left resizer  */
.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,
.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer {
  margin-left: -2px; /* to the day cell's edge */
}

/* right resizer */
.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,
.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer {
  margin-right: -2px; /* to the day cell's edge */
}

.fc-mirror-skeleton tr:first-child > td > .fc-day-grid-event {
  margin-top: 0;
  /* except for mirror skeleton */
}

.fc-day-grid-event .fc-content {
  /* force events to be one-line tall */
  white-space: nowrap;
  overflow: hidden;
}

.fc-day-grid-event .fc-time {
  font-weight: bold;
}

/* resizer (cursor devices) */
/* left resizer  */
.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,
.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer {
  margin-left: -2px;
  /* to the day cell's edge */
}

/* right resizer */
.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,
.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer {
  margin-right: -2px;
  /* to the day cell's edge */
}

/* Event Limiting
--------------------------------------------------------------------------------------------------*/
/* "more" link that represents hidden events */
a.fc-more {
  margin: 1px 3px;
  font-size: 0.85em;
  cursor: pointer;
  text-decoration: none;
}

a.fc-more:hover {
  text-decoration: underline;
}

.fc-limited {
  /* rows and cells that are hidden because of a "more" link */
  display: none;
}

/* popover that appears when "more" link is clicked */
.fc-day-grid .fc-row {
  z-index: 1;
  /* make the "more" popover one higher than this */
}

.fc-more-popover {
  z-index: 2;
  width: 220px;
}

.fc-more-popover .fc-event-container {
  padding: 10px;
}

/* Now Indicator
--------------------------------------------------------------------------------------------------*/
.fc-now-indicator {
  position: absolute;
  border: 0 solid red;
}

/* Utilities
--------------------------------------------------------------------------------------------------*/
.fc-unselectable {
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/*
TODO: more distinction between this file and common.css
*/
/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-content,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-list-heading td {
  border-color: #2b3553;
}

.fc-unthemed .fc-popover {
  background-color: #ffffff;
}

.fc-unthemed .fc-divider,
.fc-unthemed .fc-popover .fc-header,
.fc-unthemed .fc-list-heading td {
  background: #eee;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  color: #666666;
}

.fc-unthemed td.fc-today {
  background: #252e49;
  color: #ffffff;
}

.fc-unthemed .fc-disabled-day {
  background: #d7d7d7;
  opacity: 0.3;
}

/* Icons
--------------------------------------------------------------------------------------------------
from https://feathericons.com/ and built with IcoMoon
*/
@font-face {
  font-family: "fcicons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.fc-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "fcicons" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fc-icon-chevron-left:before {
  content: "\\e900";
}

.fc-icon-chevron-right:before {
  content: "\\e901";
}

.fc-icon-chevrons-left:before {
  content: "\\e902";
}

.fc-icon-chevrons-right:before {
  content: "\\e903";
}

.fc-icon-minus-square:before {
  content: "\\e904";
}

.fc-icon-plus-square:before {
  content: "\\e905";
}

.fc-icon-x:before {
  content: "\\e906";
}

.fc-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  text-align: center;
}

/* Buttons
--------------------------------------------------------------------------------------------------
Lots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css
*/
/* reset */
.fc-button {
  border-width: 2px;
  font-weight: 400;
  font-size: 0.7500000025rem;
  color: #ffffff;
  line-height: 1.35em;
  margin: 5px 1px;
  border: none;
  margin: 10px 1px;
  border-radius: 0.2857rem;
  padding: 8px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
}
.fc-button::-moz-focus-inner {
  border: 0;
}
.fc-button, .fc-button.btn-primary {
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #e14eca;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.fc-button.animation-on-hover:hover, .fc-button.btn-primary.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.fc-button:hover, .fc-button:focus, .fc-button:active, .fc-button.active, .fc-button:active:focus, .fc-button:active:hover, .fc-button.active:focus, .fc-button.active:hover, .fc-button.btn-primary:hover, .fc-button.btn-primary:focus, .fc-button.btn-primary:active, .fc-button.btn-primary.active, .fc-button.btn-primary:active:focus, .fc-button.btn-primary:active:hover, .fc-button.btn-primary.active:focus, .fc-button.btn-primary.active:hover {
  background-color: #ba54f5 !important;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  background-image: -moz-linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  color: #ffffff;
  box-shadow: none;
}
.fc-button:active, .fc-button.btn-primary:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.fc-button:not([data-action]):hover, .fc-button.btn-primary:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.fc-button.disabled, .fc-button.disabled:hover, .fc-button.disabled:focus, .fc-button.disabled.focus, .fc-button.disabled:active, .fc-button.disabled.active, .fc-button:disabled, .fc-button:disabled:hover, .fc-button:disabled:focus, .fc-button:disabled.focus, .fc-button:disabled:active, .fc-button:disabled.active, .fc-button[disabled], .fc-button[disabled]:hover, .fc-button[disabled]:focus, .fc-button[disabled].focus, .fc-button[disabled]:active, .fc-button[disabled].active, fieldset[disabled] .fc-button, fieldset[disabled] .fc-button:hover, fieldset[disabled] .fc-button:focus, fieldset[disabled] .fc-button.focus, fieldset[disabled] .fc-button:active, fieldset[disabled] .fc-button.active, .fc-button.btn-primary.disabled, .fc-button.btn-primary.disabled:hover, .fc-button.btn-primary.disabled:focus, .fc-button.btn-primary.disabled.focus, .fc-button.btn-primary.disabled:active, .fc-button.btn-primary.disabled.active, .fc-button.btn-primary:disabled, .fc-button.btn-primary:disabled:hover, .fc-button.btn-primary:disabled:focus, .fc-button.btn-primary:disabled.focus, .fc-button.btn-primary:disabled:active, .fc-button.btn-primary:disabled.active, .fc-button.btn-primary[disabled], .fc-button.btn-primary[disabled]:hover, .fc-button.btn-primary[disabled]:focus, .fc-button.btn-primary[disabled].focus, .fc-button.btn-primary[disabled]:active, .fc-button.btn-primary[disabled].active, fieldset[disabled] .fc-button.btn-primary, fieldset[disabled] .fc-button.btn-primary:hover, fieldset[disabled] .fc-button.btn-primary:focus, fieldset[disabled] .fc-button.btn-primary.focus, fieldset[disabled] .fc-button.btn-primary:active, fieldset[disabled] .fc-button.btn-primary.active {
  background-color: #e14eca;
  border-color: #e14eca;
}
.fc-button.btn-simple, .fc-button.btn-primary.btn-simple {
  color: #e14eca;
  border-color: #e14eca;
  background: transparent;
}
.fc-button.btn-simple:hover, .fc-button.btn-simple:focus, .fc-button.btn-simple:active, .fc-button.btn-simple:not(:disabled):not(.disabled):active, .fc-button.btn-primary.btn-simple:hover, .fc-button.btn-primary.btn-simple:focus, .fc-button.btn-primary.btn-simple:active, .fc-button.btn-primary.btn-simple:not(:disabled):not(.disabled):active {
  color: #e14eca;
  border-color: #e14eca;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.fc-button.btn-simple.active, .fc-button.btn-primary.btn-simple.active {
  border-color: #e14eca !important;
}
.fc-button.btn-simple.active:hover, .fc-button.btn-simple.active:focus, .fc-button.btn-simple.active:active, .fc-button.btn-simple.active:not(:disabled):not(.disabled):active, .fc-button.btn-primary.btn-simple.active:hover, .fc-button.btn-primary.btn-simple.active:focus, .fc-button.btn-primary.btn-simple.active:active, .fc-button.btn-primary.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  background-image: -moz-linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  background-color: #ba54f5 !important;
  box-shadow: none;
}
.fc-button.btn-link, .fc-button.btn-primary.btn-link {
  color: #e14eca;
}
.fc-button.btn-link:hover, .fc-button.btn-link:focus, .fc-button.btn-link:active, .fc-button.btn-primary.btn-link:hover, .fc-button.btn-primary.btn-link:focus, .fc-button.btn-primary.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}
.fc-button .fc button[disabled],
.fc-button .fc button[disabled]:focus,
.fc-button .fc button[disabled]:hover {
  cursor: default;
  opacity: 0.5;
  pointer-events: none;
}

.fc-button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

.fc-button {
  -webkit-appearance: button;
}

.fc-button:not(:disabled) {
  cursor: pointer;
}

.fc-button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

.fc-state-hover,
.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  color: #333333;
  background-color: #e6e6e6;
}

.fc-state-hover {
  color: #333333;
  text-decoration: none;
  background-position: 0 -15px;
  transition: background-position 0.1s linear;
}

.fc-state-down,
.fc-state-active {
  background-color: #cccccc;
  background-image: none;
}

.fc-state-disabled {
  cursor: default;
  background-image: none;
  opacity: 0.65;
  box-shadow: none;
}

/* theme */
.fc-button:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);
}

.fc-button:disabled {
  opacity: 0.65;
}

.fc-head-container,
.fc-day-header {
  border: 0 !important;
  text-align: right !important;
}

.card-calendar .fc .fc-day-header:last-child {
  padding-right: 15px;
}

tbody.fc-body tr > .fc-widget-content {
  border-left: 0 !important;
  border-bottom: 0 !important;
}

.card-calendar .fc td:last-child {
  border-right: 0 !important;
}

.fc .fc-button-group > * {
  float: left;
  margin: 0 0 0 2px;
}

tr:first-child > td > .fc-day-grid-event {
  margin-top: 2px;
}

.card-calendar table td {
  text-align: right;
}

/* icons within buttons */
.fc-button .fc-icon {
  vertical-align: middle;
  font-size: 1.5em;
}

/* Buttons Groups
--------------------------------------------------------------------------------------------------*/
.fc-button-group {
  display: inline-block;
}
.fc-button-group .fc-prev-button,
.fc-button-group .fc-next-button {
  opacity: 0.7;
  color: #ffffff;
  padding: 7px 20px;
  background: transparent;
  border: 1px solid #2b3553;
}
.fc-button-group .fc-prev-button:hover, .fc-button-group .fc-prev-button:focus, .fc-button-group .fc-prev-button:active:hover,
.fc-button-group .fc-next-button:hover,
.fc-button-group .fc-next-button:focus,
.fc-button-group .fc-next-button:active:hover {
  background-color: transparent !important;
  background-image: none !important;
  opacity: 1;
}

.fc-button-group > .fc-button {
  position: relative;
  flex: 1 1 auto;
}

.fc-button-group > .fc-button:hover {
  z-index: 1;
}

.fc-button-group .fc-button {
  border-radius: 0.2857rem !important;
  opacity: 0.5 !important;
}
.fc-button-group .fc-button.fc-button-active, .fc-button-group .fc-button:hover {
  opacity: 1 !important;
}

.fc-button-group > .fc-button:focus,
.fc-button-group > .fc-button:active,
.fc-button-group > .fc-button.fc-button-active {
  z-index: 1;
}

.fc-button-group > .fc-button:not(:first-child) {
  margin: 0 0 0 2px;
}

.fc-button-group > .fc-button:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-button-group > .fc-button:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-unthemed .fc-popover {
  position: absolute;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* List View
--------------------------------------------------------------------------------------------------*/
.fc-unthemed .fc-list-item:hover td {
  background-color: #f5f5f5;
}

/* Toolbar
--------------------------------------------------------------------------------------------------*/
.fc-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8em;
}

.fc-toolbar.fc-footer-toolbar {
  margin-top: 1.5em;
}

/* inner content */
.fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em;
}

.fc-toolbar h2 {
  margin: 0;
  margin-bottom: 10px;
  font-size: 1.8em;
}

/* View Structure
--------------------------------------------------------------------------------------------------*/
.fc-view-container {
  position: relative;
}

/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */
/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */
.fc-view-container *,
.fc-view-container *:before,
.fc-view-container *:after {
  box-sizing: content-box;
}

.fc-view,
.fc-view > table {
  /* so dragged elements can be above the view's main element */
  position: relative;
  z-index: 1;
}

@media print {
  .fc {
    max-width: 100% !important;
  }
  /* Global Event Restyling
  --------------------------------------------------------------------------------------------------*/
  .fc-event {
    background: #fff !important;
    color: #000 !important;
    page-break-inside: avoid;
  }
  .fc-event .fc-resizer {
    display: none;
  }
  /* Table & Day-Row Restyling
  --------------------------------------------------------------------------------------------------*/
  .fc th,
.fc td,
.fc hr,
.fc thead,
.fc tbody,
.fc-row {
    border-color: #ccc !important;
    background: #fff !important;
  }
  /* kill the overlaid, absolutely-positioned components */
  /* common... */
  .fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-mirror-skeleton,
.fc-bgevent-container,
.fc-business-container,
.fc-highlight-container,
.fc-mirror-container {
    display: none;
  }
  /* don't force a min-height on rows (for DayGrid) */
  .fc tbody .fc-row {
    height: auto !important;
    /* undo height that JS set in distributeHeight */
    min-height: 0 !important;
    /* undo the min-height from each view's specific stylesheet */
  }
  .fc tbody .fc-row .fc-content-skeleton {
    position: static;
    /* undo .fc-rigid */
    padding-bottom: 0 !important;
    /* use a more border-friendly method for this... */
  }
  .fc tbody .fc-row .fc-content-skeleton tbody tr:last-child td {
    /* only works in newer browsers */
    padding-bottom: 1em;
    /* ...gives space within the skeleton. also ensures min height in a way */
  }
  .fc tbody .fc-row .fc-content-skeleton table {
    /* provides a min-height for the row, but only effective for IE, which exaggerates this value,
       making it look more like 3em. for other browers, it will already be this tall */
    height: 1em;
  }
  /* Undo month-view event limiting. Display all events and hide the "more" links
  --------------------------------------------------------------------------------------------------*/
  .fc-more-cell,
.fc-more {
    display: none !important;
  }
  .fc tr.fc-limited {
    display: table-row !important;
  }
  .fc td.fc-limited {
    display: table-cell !important;
  }
  .fc-popover {
    display: none;
    /* never display the "more.." popover in print mode */
  }
  /* TimeGrid Restyling
  --------------------------------------------------------------------------------------------------*/
  /* undo the min-height 100% trick used to fill the container's height */
  .fc-time-grid {
    min-height: 0 !important;
  }
  /* don't display the side axis at all ("all-day" and time cells) */
  .fc-timeGrid-view .fc-axis {
    display: none;
  }
  /* don't display the horizontal lines */
  .fc-slats,
.fc-time-grid hr {
    /* this hr is used when height is underused and needs to be filled */
    display: none !important;
    /* important overrides inline declaration */
  }
  /* let the container that holds the events be naturally positioned and create real height */
  .fc-time-grid .fc-content-skeleton {
    position: static;
  }
  /* in case there are no events, we still want some height */
  .fc-time-grid .fc-content-skeleton table {
    height: 4em;
  }
  /* kill the horizontal spacing made by the event container. event margins will be done below */
  .fc-time-grid .fc-event-container {
    margin: 0 !important;
  }
  /* TimeGrid *Event* Restyling
  --------------------------------------------------------------------------------------------------*/
  /* naturally position events, vertically stacking them */
  .fc-time-grid .fc-event {
    position: static !important;
    margin: 3px 2px !important;
  }
  /* for events that continue to a future day, give the bottom border back */
  .fc-time-grid .fc-event.fc-not-end {
    border-bottom-width: 1px !important;
  }
  /* indicate the event continues via "..." text */
  .fc-time-grid .fc-event.fc-not-end:after {
    content: "...";
  }
  /* for events that are continuations from previous days, give the top border back */
  .fc-time-grid .fc-event.fc-not-start {
    border-top-width: 1px !important;
  }
  /* indicate the event is a continuation via "..." text */
  .fc-time-grid .fc-event.fc-not-start:before {
    content: "...";
  }
  /* time */
  /* undo a previous declaration and let the time text span to a second line */
  .fc-time-grid .fc-event .fc-time {
    white-space: normal !important;
  }
  /* hide the the time that is normally displayed... */
  .fc-time-grid .fc-event .fc-time span {
    display: none;
  }
  /* ...replace it with a more verbose version (includes AM/PM) stored in an html attribute */
  .fc-time-grid .fc-event .fc-time:after {
    content: attr(data-full);
  }
  /* Vertical Scroller & Containers
  --------------------------------------------------------------------------------------------------*/
  /* kill the scrollbars and allow natural height */
  .fc-scroller,
.fc-day-grid-container,
.fc-time-grid-container {
    /* */
    overflow: visible !important;
    height: auto !important;
  }
  /* kill the horizontal border/padding used to compensate for scrollbars */
  .fc-row {
    border: 0 !important;
    margin: 0 !important;
  }
  /* Button Controls
  --------------------------------------------------------------------------------------------------*/
  .fc-button-group,
.fc button {
    display: none;
    /* don't display any button-related controls */
  }
}
.fc-day-header span {
  color: hsla(0deg, 0%, 100%, 0.4);
}

.fc-day-top .fc-day-number {
  color: #ffffff;
}

/* DayGridView
--------------------------------------------------------------------------------------------------*/
/* day row structure */
.fc-dayGridWeek-view .fc-content-skeleton,
.fc-dayGridDay-view .fc-content-skeleton {
  /* there may be week numbers in these views, so no padding-top */
  padding-bottom: 1em;
  /* ensure a space at bottom of cell for user selecting/clicking */
}

.fc-dayGrid-view .fc-body .fc-row {
  min-height: 4em;
  /* ensure that all rows are at least this tall */
}

/* a "rigid" row will take up a constant amount of height because content-skeleton is absolute */
.fc-row.fc-rigid {
  overflow: hidden;
}

.fc-row.fc-rigid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

/* week and day number styling */
.fc-day-top.fc-other-month {
  opacity: 0.3;
}

.fc-dayGrid-view .fc-week-number,
.fc-dayGrid-view .fc-day-number {
  padding: 2px;
}

.fc-dayGrid-view th.fc-week-number,
.fc-dayGrid-view th.fc-day-number {
  padding: 0 2px;
  /* column headers can't have as much v space */
}

.fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {
  float: right;
}

.fc-rtl .fc-dayGrid-view .fc-day-top .fc-day-number {
  float: left;
}

.fc-ltr .fc-dayGrid-view .fc-day-top .fc-week-number {
  float: left;
  border-radius: 0 0 3px 0;
}

.fc-rtl .fc-dayGrid-view .fc-day-top .fc-week-number {
  float: right;
  border-radius: 0 0 0 3px;
}

.fc-dayGrid-view .fc-day-top .fc-week-number {
  min-width: 1.5em;
  text-align: center;
  background-color: #f2f2f2;
  color: #808080;
}

/* when week/day number have own column */
.fc-dayGrid-view td.fc-week-number {
  text-align: center;
}

.fc-dayGrid-view td.fc-week-number > * {
  /* work around the way we do column resizing and ensure a minimum width */
  display: inline-block;
  min-width: 1.25em;
}

/* TimeGridView all-day area
--------------------------------------------------------------------------------------------------*/
.fc-timeGrid-view .fc-day-grid {
  position: relative;
  z-index: 2;
  /* so the "more.." popover will be over the time grid */
}

.fc-timeGrid-view .fc-day-grid .fc-row {
  min-height: 3em;
  /* all-day section will never get shorter than this */
}

.fc-timeGrid-view .fc-day-grid .fc-row .fc-content-skeleton {
  padding-bottom: 1em;
  /* give space underneath events for clicking/selecting days */
}

/* TimeGrid axis running down the side (for both the all-day area and the slot area)
--------------------------------------------------------------------------------------------------*/
.fc .fc-axis {
  /* .fc to overcome default cell styles */
  vertical-align: middle;
  padding: 0 4px;
  white-space: nowrap;
}

.fc-ltr .fc-axis {
  text-align: right;
}

.fc-rtl .fc-axis {
  text-align: left;
}

/* TimeGrid Structure
--------------------------------------------------------------------------------------------------*/
.fc-time-grid-container,
.fc-time-grid {
  /* so slats/bg/content/etc positions get scoped within here */
  position: relative;
  z-index: 1;
}

.fc-time-grid {
  min-height: 100%;
  /* so if height setting is 'auto', .fc-bg stretches to fill height */
}

.fc-time-grid table {
  /* don't put outer borders on slats/bg/content/etc */
  border: 0 hidden transparent;
}

.fc-time-grid > .fc-bg {
  z-index: 1;
}

.fc-time-grid .fc-slats,
.fc-time-grid > hr {
  /* the <hr> TimeGridView injects when grid is shorter than scroller */
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-content-col {
  position: relative;
  /* because now-indicator lives directly inside */
}

.fc-time-grid .fc-content-skeleton {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
}

/* divs within a cell within the fc-content-skeleton */
.fc-time-grid .fc-business-container {
  position: relative;
  z-index: 1;
}

.fc-time-grid .fc-bgevent-container {
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-highlight-container {
  position: relative;
  z-index: 3;
}

.fc-time-grid .fc-event-container {
  position: relative;
  z-index: 4;
}

.fc-time-grid .fc-now-indicator-line {
  z-index: 5;
}

.fc-time-grid .fc-mirror-container {
  /* also is fc-event-container */
  position: relative;
  z-index: 6;
}

/* TimeGrid Slats (lines that run horizontally)
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-slats td {
  height: 1.5em;
  border-bottom: 0;
  /* each cell is responsible for its top border */
}

.fc-time-grid .fc-slats .fc-minor td {
  border-top-style: dotted;
}

/* TimeGrid Highlighting Slots
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-highlight-container {
  /* a div within a cell within the fc-highlight-skeleton */
  position: relative;
  /* scopes the left/right of the fc-highlight to be in the column */
}

.fc-time-grid .fc-highlight {
  position: absolute;
  left: 0;
  right: 0;
  /* top and bottom will be in by JS */
}

/* TimeGrid Event Containment
--------------------------------------------------------------------------------------------------*/
.fc-ltr .fc-time-grid .fc-event-container {
  /* space on the sides of events for LTR (default) */
  margin: 0 2.5% 0 2px;
}

.fc-rtl .fc-time-grid .fc-event-container {
  /* space on the sides of events for RTL */
  margin: 0 2px 0 2.5%;
}

.fc-time-grid .fc-event,
.fc-time-grid .fc-bgevent {
  position: absolute;
  z-index: 1;
  /* scope inner z-index's */
}

.fc-time-grid .fc-bgevent {
  /* background events always span full width */
  left: 0;
  right: 0;
}

/* TimeGrid Event Styling
----------------------------------------------------------------------------------------------------
We use the full "fc-time-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-time-grid-event {
  margin-bottom: 1px;
}

.fc-time-grid-event-inset {
  box-shadow: 0px 0px 0px 1px #fff;
}

.fc-time-grid-event.fc-not-start {
  /* events that are continuing from another day */
  /* replace space made by the top border with padding */
  border-top-width: 0;
  padding-top: 1px;
  /* remove top rounded corners */
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-time-grid-event.fc-not-end {
  /* replace space made by the top border with padding */
  border-bottom-width: 0;
  padding-bottom: 1px;
  /* remove bottom rounded corners */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-time-grid-event .fc-content {
  overflow: hidden;
  max-height: 100%;
}

.fc-time-grid-event .fc-time,
.fc-time-grid-event .fc-title {
  padding: 0 1px;
}

.fc-time-grid-event .fc-time {
  font-size: 0.85em;
  white-space: nowrap;
}

/* short mode, where time and title are on the same line */
.fc-time-grid-event.fc-short .fc-content {
  /* don't wrap to second line (now that contents will be inline) */
  white-space: nowrap;
}

.fc-time-grid-event.fc-short .fc-time,
.fc-time-grid-event.fc-short .fc-title {
  /* put the time and title on the same line */
  display: inline-block;
  vertical-align: top;
}

.fc-time-grid-event.fc-short .fc-time span {
  display: none;
  /* don't display the full time text... */
}

.fc-time-grid-event.fc-short .fc-time:before {
  content: attr(data-start);
  /* ...instead, display only the start time */
}

.fc-time-grid-event.fc-short .fc-time:after {
  content: " - ";
  /* seperate with a dash, wrapped in nbsp's */
}

.fc-time-grid-event.fc-short .fc-title {
  font-size: 0.85em;
  /* make the title text the same size as the time */
  padding: 0;
  /* undo padding from above */
}

/* resizer (cursor device) */
.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer {
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  overflow: hidden;
  line-height: 8px;
  font-size: 11px;
  font-family: monospace;
  text-align: center;
  cursor: s-resize;
}

.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after {
  content: "=";
}

/* resizer (touch device) */
.fc-time-grid-event.fc-selected .fc-resizer {
  /* 10x10 dot */
  border-radius: 5px;
  border-width: 1px;
  width: 8px;
  height: 8px;
  border-style: solid;
  border-color: inherit;
  background: #fff;
  /* horizontally center */
  left: 50%;
  margin-left: -5px;
  /* center on the bottom edge */
  bottom: -5px;
}

/* Now Indicator
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-now-indicator-line {
  border-top-width: 1px;
  left: 0;
  right: 0;
}

/* arrow on axis */
.fc-time-grid .fc-now-indicator-arrow {
  margin-top: -5px;
  /* vertically center on top coordinate */
}

.fc-ltr .fc-time-grid .fc-now-indicator-arrow {
  left: 0;
  /* triangle pointing right... */
  border-width: 5px 0 5px 6px;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

.fc-rtl .fc-time-grid .fc-now-indicator-arrow {
  right: 0;
  /* triangle pointing left... */
  border-width: 5px 6px 5px 0;
  border-top-color: transparent;
  border-bottom-color: transparent;
}
@keyframes swal2-show {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes swal2-hide {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}
@keyframes swal2-animate-success-line-tip {
  0% {
    top: 1.1875em;
    left: 0.0625em;
    width: 0;
  }
  54% {
    top: 1.0625em;
    left: 0.125em;
    width: 0;
  }
  70% {
    top: 2.1875em;
    left: -0.375em;
    width: 3.125em;
  }
  84% {
    top: 3em;
    left: 1.3125em;
    width: 1.0625em;
  }
  100% {
    top: 2.8125em;
    left: 0.875em;
    width: 1.5625em;
  }
}
@keyframes swal2-animate-success-line-long {
  0% {
    top: 3.375em;
    right: 2.875em;
    width: 0;
  }
  65% {
    top: 3.375em;
    right: 2.875em;
    width: 0;
  }
  84% {
    top: 2.1875em;
    right: 0;
    width: 3.4375em;
  }
  100% {
    top: 2.375em;
    right: 0.5em;
    width: 2.9375em;
  }
}
@keyframes swal2-rotate-success-circular-line {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
@keyframes swal2-animate-error-x-mark {
  0% {
    margin-top: 1.625em;
    transform: scale(0.4);
    opacity: 0;
  }
  50% {
    margin-top: 1.625em;
    transform: scale(0.4);
    opacity: 0;
  }
  80% {
    margin-top: -0.375em;
    transform: scale(1.15);
  }
  100% {
    margin-top: 0;
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes swal2-animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}
body.swal2-toast-shown .swal2-container {
  background-color: transparent;
}

body.swal2-toast-shown .swal2-container.swal2-shown {
  background-color: transparent;
}

body.swal2-toast-shown .swal2-container.swal2-top {
  top: 0;
  right: auto;
  bottom: auto;
  left: 50%;
  transform: translateX(-50%);
}

body.swal2-toast-shown .swal2-container.swal2-top-end, body.swal2-toast-shown .swal2-container.swal2-top-right {
  top: 0;
  right: 0;
  bottom: auto;
  left: auto;
}

body.swal2-toast-shown .swal2-container.swal2-top-start, body.swal2-toast-shown .swal2-container.swal2-top-left {
  top: 0;
  right: auto;
  bottom: auto;
  left: 0;
}

body.swal2-toast-shown .swal2-container.swal2-center-start, body.swal2-toast-shown .swal2-container.swal2-center-left {
  top: 50%;
  right: auto;
  bottom: auto;
  left: 0;
  transform: translateY(-50%);
}

body.swal2-toast-shown .swal2-container.swal2-center {
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  transform: translate(-50%, -50%);
}

body.swal2-toast-shown .swal2-container.swal2-center-end, body.swal2-toast-shown .swal2-container.swal2-center-right {
  top: 50%;
  right: 0;
  bottom: auto;
  left: auto;
  transform: translateY(-50%);
}

body.swal2-toast-shown .swal2-container.swal2-bottom-start, body.swal2-toast-shown .swal2-container.swal2-bottom-left {
  top: auto;
  right: auto;
  bottom: 0;
  left: 0;
}

body.swal2-toast-shown .swal2-container.swal2-bottom {
  top: auto;
  right: auto;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

body.swal2-toast-shown .swal2-container.swal2-bottom-end, body.swal2-toast-shown .swal2-container.swal2-bottom-right {
  top: auto;
  right: 0;
  bottom: 0;
  left: auto;
}

body.swal2-toast-column .swal2-toast {
  flex-direction: column;
  align-items: stretch;
}

body.swal2-toast-column .swal2-toast .swal2-actions {
  flex: 1 1;
  align-self: stretch;
  height: 2.2em;
  margin-top: 0.3125em;
}

body.swal2-toast-column .swal2-toast .swal2-loading {
  justify-content: center;
}

body.swal2-toast-column .swal2-toast .swal2-input {
  height: 2em;
  margin: 0.3125em auto;
  font-size: 1em;
}

body.swal2-toast-column .swal2-toast .swal2-validation-message {
  font-size: 1em;
}

.swal2-popup.swal2-toast {
  flex-direction: row;
  align-items: center;
  width: auto;
  padding: 0.625em;
  overflow-y: hidden;
  box-shadow: 0 0 0.625em #d9d9d9;
}

.swal2-popup.swal2-toast .swal2-header {
  flex-direction: row;
}

.swal2-popup.swal2-toast .swal2-title {
  flex-grow: 1;
  justify-content: flex-start;
  margin: 0 0.6em;
  font-size: 1em;
}

.swal2-popup.swal2-toast .swal2-footer {
  margin: 0.5em 0 0;
  padding: 0.5em 0 0;
  font-size: 0.8em;
}

.swal2-popup.swal2-toast .swal2-close {
  position: static;
  width: 0.8em;
  height: 0.8em;
  line-height: 0.8;
}

.swal2-popup.swal2-toast .swal2-content {
  justify-content: flex-start;
  font-size: 1em;
}

.swal2-popup.swal2-toast .swal2-icon {
  width: 2em;
  min-width: 2em;
  height: 2em;
  margin: 0;
}

.swal2-popup.swal2-toast .swal2-icon::before {
  display: flex;
  align-items: center;
  font-size: 2em;
  font-weight: bold;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-popup.swal2-toast .swal2-icon::before {
    font-size: 0.25em;
  }
}
.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {
  width: 2em;
  height: 2em;
}

.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  top: 0.875em;
  width: 1.375em;
}

.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=left] {
  left: 0.3125em;
}

.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=right] {
  right: 0.3125em;
}

.swal2-popup.swal2-toast .swal2-actions {
  flex-basis: auto !important;
  width: auto;
  height: auto;
  margin: 0 0.3125em;
}

.swal2-popup.swal2-toast .swal2-styled {
  margin: 0 0.3125em;
  padding: 0.3125em 0.625em;
  font-size: 1em;
}

.swal2-popup.swal2-toast .swal2-styled:focus {
  box-shadow: 0 0 0 0.0625em #fff, 0 0 0 0.125em rgba(50, 100, 150, 0.4);
}

.swal2-popup.swal2-toast .swal2-success {
  border-color: #a5dc86;
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line] {
  position: absolute;
  width: 1.6em;
  height: 3em;
  transform: rotate(45deg);
  border-radius: 50%;
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class\$=left] {
  top: -0.8em;
  left: -0.5em;
  transform: rotate(-45deg);
  transform-origin: 2em 2em;
  border-radius: 4em 0 0 4em;
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class\$=right] {
  top: -0.25em;
  left: 0.9375em;
  transform-origin: 0 1.5em;
  border-radius: 0 4em 4em 0;
}

.swal2-popup.swal2-toast .swal2-success .swal2-success-ring {
  width: 2em;
  height: 2em;
}

.swal2-popup.swal2-toast .swal2-success .swal2-success-fix {
  top: 0;
  left: 0.4375em;
  width: 0.4375em;
  height: 2.6875em;
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line] {
  height: 0.3125em;
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class\$=tip] {
  top: 1.125em;
  left: 0.1875em;
  width: 0.75em;
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class\$=long] {
  top: 0.9375em;
  right: 0.1875em;
  width: 1.375em;
}

.swal2-popup.swal2-toast.swal2-show {
  animation: swal2-toast-show 0.5s;
}

.swal2-popup.swal2-toast.swal2-hide {
  animation: swal2-toast-hide 0.1s forwards;
}

.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-tip {
  animation: swal2-toast-animate-success-line-tip 0.75s;
}

.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-long {
  animation: swal2-toast-animate-success-line-long 0.75s;
}
@keyframes swal2-toast-show {
  0% {
    transform: translateY(-0.625em) rotateZ(2deg);
  }
  33% {
    transform: translateY(0) rotateZ(-2deg);
  }
  66% {
    transform: translateY(0.3125em) rotateZ(2deg);
  }
  100% {
    transform: translateY(0) rotateZ(0deg);
  }
}
@keyframes swal2-toast-hide {
  100% {
    transform: rotateZ(1deg);
    opacity: 0;
  }
}
@keyframes swal2-toast-animate-success-line-tip {
  0% {
    top: 0.5625em;
    left: 0.0625em;
    width: 0;
  }
  54% {
    top: 0.125em;
    left: 0.125em;
    width: 0;
  }
  70% {
    top: 0.625em;
    left: -0.25em;
    width: 1.625em;
  }
  84% {
    top: 1.0625em;
    left: 0.75em;
    width: 0.5em;
  }
  100% {
    top: 1.125em;
    left: 0.1875em;
    width: 0.75em;
  }
}
@keyframes swal2-toast-animate-success-line-long {
  0% {
    top: 1.625em;
    right: 1.375em;
    width: 0;
  }
  65% {
    top: 1.25em;
    right: 0.9375em;
    width: 0;
  }
  84% {
    top: 0.9375em;
    right: 0;
    width: 1.125em;
  }
  100% {
    top: 0.9375em;
    right: 0.1875em;
    width: 1.375em;
  }
}
body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  overflow: hidden;
}

body.swal2-height-auto {
  height: auto !important;
}

body.swal2-no-backdrop .swal2-shown {
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  max-width: calc(100% - 1.25em);
  background-color: transparent;
}

body.swal2-no-backdrop .swal2-shown > .swal2-modal {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

body.swal2-no-backdrop .swal2-shown.swal2-top {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

body.swal2-no-backdrop .swal2-shown.swal2-top-start, body.swal2-no-backdrop .swal2-shown.swal2-top-left {
  top: 0;
  left: 0;
}

body.swal2-no-backdrop .swal2-shown.swal2-top-end, body.swal2-no-backdrop .swal2-shown.swal2-top-right {
  top: 0;
  right: 0;
}

body.swal2-no-backdrop .swal2-shown.swal2-center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

body.swal2-no-backdrop .swal2-shown.swal2-center-start, body.swal2-no-backdrop .swal2-shown.swal2-center-left {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

body.swal2-no-backdrop .swal2-shown.swal2-center-end, body.swal2-no-backdrop .swal2-shown.swal2-center-right {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

body.swal2-no-backdrop .swal2-shown.swal2-bottom {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

body.swal2-no-backdrop .swal2-shown.swal2-bottom-start, body.swal2-no-backdrop .swal2-shown.swal2-bottom-left {
  bottom: 0;
  left: 0;
}

body.swal2-no-backdrop .swal2-shown.swal2-bottom-end, body.swal2-no-backdrop .swal2-shown.swal2-bottom-right {
  right: 0;
  bottom: 0;
}

.swal2-container {
  display: flex;
  position: fixed;
  z-index: 1060;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.625em;
  overflow-x: hidden;
  background-color: transparent;
  -webkit-overflow-scrolling: touch;
}

.swal2-container.swal2-top {
  align-items: flex-start;
}

.swal2-container.swal2-top-start, .swal2-container.swal2-top-left {
  align-items: flex-start;
  justify-content: flex-start;
}

.swal2-container.swal2-top-end, .swal2-container.swal2-top-right {
  align-items: flex-start;
  justify-content: flex-end;
}

.swal2-container.swal2-center {
  align-items: center;
}

.swal2-container.swal2-center-start, .swal2-container.swal2-center-left {
  align-items: center;
  justify-content: flex-start;
}

.swal2-container.swal2-center-end, .swal2-container.swal2-center-right {
  align-items: center;
  justify-content: flex-end;
}

.swal2-container.swal2-bottom {
  align-items: flex-end;
}

.swal2-container.swal2-bottom-start, .swal2-container.swal2-bottom-left {
  align-items: flex-end;
  justify-content: flex-start;
}

.swal2-container.swal2-bottom-end, .swal2-container.swal2-bottom-right {
  align-items: flex-end;
  justify-content: flex-end;
}

.swal2-container.swal2-bottom > :first-child, .swal2-container.swal2-bottom-start > :first-child, .swal2-container.swal2-bottom-left > :first-child, .swal2-container.swal2-bottom-end > :first-child, .swal2-container.swal2-bottom-right > :first-child {
  margin-top: auto;
}

.swal2-container.swal2-grow-fullscreen > .swal2-modal {
  display: flex !important;
  flex: 1 1;
  align-self: stretch;
  justify-content: center;
}

.swal2-container.swal2-grow-row > .swal2-modal {
  display: flex !important;
  flex: 1 1;
  align-content: center;
  justify-content: center;
}

.swal2-container.swal2-grow-column {
  flex: 1 1;
  flex-direction: column;
}

.swal2-container.swal2-grow-column.swal2-top, .swal2-container.swal2-grow-column.swal2-center, .swal2-container.swal2-grow-column.swal2-bottom {
  align-items: center;
}

.swal2-container.swal2-grow-column.swal2-top-start, .swal2-container.swal2-grow-column.swal2-center-start, .swal2-container.swal2-grow-column.swal2-bottom-start, .swal2-container.swal2-grow-column.swal2-top-left, .swal2-container.swal2-grow-column.swal2-center-left, .swal2-container.swal2-grow-column.swal2-bottom-left {
  align-items: flex-start;
}

.swal2-container.swal2-grow-column.swal2-top-end, .swal2-container.swal2-grow-column.swal2-center-end, .swal2-container.swal2-grow-column.swal2-bottom-end, .swal2-container.swal2-grow-column.swal2-top-right, .swal2-container.swal2-grow-column.swal2-center-right, .swal2-container.swal2-grow-column.swal2-bottom-right {
  align-items: flex-end;
}

.swal2-container.swal2-grow-column > .swal2-modal {
  display: flex !important;
  flex: 1 1;
  align-content: center;
  justify-content: center;
}

.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen) > .swal2-modal {
  margin: auto;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-container .swal2-modal {
    margin: 0 !important;
  }
}
.swal2-container.swal2-fade {
  transition: background-color 0.1s;
}

.swal2-container.swal2-shown {
  background-color: rgba(0, 0, 0, 0.4);
}

.swal2-popup {
  display: none;
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  width: 32em;
  max-width: 100%;
  padding: 1.25em;
  border: none;
  border-radius: 0.3125em;
  background: #fff;
  font-family: inherit;
  font-size: 1rem;
}

.swal2-popup:focus {
  outline: none;
}

.swal2-popup.swal2-loading {
  overflow-y: hidden;
}

.swal2-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.swal2-title {
  position: relative;
  max-width: 100%;
  margin: 0 0 0.4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}

.swal2-actions {
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0;
}

.swal2-actions:not(.swal2-loading) .swal2-styled[disabled] {
  opacity: 0.4;
}

.swal2-actions:not(.swal2-loading) .swal2-styled:hover {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
}

.swal2-actions:not(.swal2-loading) .swal2-styled:active {
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
}

.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  box-sizing: border-box;
  width: 2.5em;
  height: 2.5em;
  margin: 0.46875em;
  padding: 0;
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  border: 0.25em solid transparent;
  border-radius: 100%;
  border-color: transparent;
  background-color: transparent !important;
  color: transparent;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
}

.swal2-actions.swal2-loading .swal2-styled.swal2-cancel {
  margin-right: 30px;
  margin-left: 30px;
}

.swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm::after {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-left: 5px;
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  border: 3px solid #999999;
  border-radius: 50%;
  border-right-color: transparent;
  box-shadow: 1px 1px 1px #fff;
}

.swal2-styled {
  margin: 0.3125em;
  padding: 0.625em 2em;
  box-shadow: none;
  font-weight: 500;
}

.swal2-styled:not([disabled]) {
  cursor: pointer;
}

.swal2-styled.swal2-confirm {
  border: 0;
  border-radius: 0.25em;
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  background-color: #3085d6;
  color: #fff;
  font-size: 1.0625em;
}

.swal2-styled.swal2-cancel {
  border: 0;
  border-radius: 0.25em;
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  background-color: #aaa;
  color: #fff;
  font-size: 1.0625em;
}

.swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);
}

.swal2-styled::-moz-focus-inner {
  border: 0;
}

.swal2-footer {
  justify-content: center;
  margin: 1.25em 0 0;
  padding: 1em 0 0;
  border-top: 1px solid #eee;
  color: #545454;
  font-size: 1em;
}

.swal2-image {
  max-width: 100%;
  margin: 1.25em auto;
}

.swal2-close {
  position: absolute;
  z-index: 2;
  /* 1617 */
  top: 0;
  right: 0;
  justify-content: center;
  width: 1.2em;
  height: 1.2em;
  padding: 0;
  overflow: hidden;
  transition: color 0.1s ease-out;
  border: none;
  border-radius: 0;
  outline: medium none invert;
  outline: initial;
  background: transparent;
  color: #cccccc;
  font-family: serif;
  font-size: 2.5em;
  line-height: 1.2;
  cursor: pointer;
}

.swal2-close:hover {
  transform: none;
  background: transparent;
  color: #f27474;
}

.swal2-content {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 1.125em;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
}

.swal2-input,
.swal2-file,
.swal2-textarea,
.swal2-select,
.swal2-radio,
.swal2-checkbox {
  margin: 1em auto;
}

.swal2-input,
.swal2-file,
.swal2-textarea {
  box-sizing: border-box;
  width: 100%;
  transition: border-color 0.3s, box-shadow 0.3s;
  border: 1px solid #d9d9d9;
  border-radius: 0.1875em;
  background: inherit;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);
  color: inherit;
  font-size: 1.125em;
}

.swal2-input.swal2-inputerror,
.swal2-file.swal2-inputerror,
.swal2-textarea.swal2-inputerror {
  border-color: #f27474 !important;
  box-shadow: 0 0 2px #f27474 !important;
}

.swal2-input:focus,
.swal2-file:focus,
.swal2-textarea:focus {
  border: 1px solid #b4dbed;
  outline: none;
  box-shadow: 0 0 3px #c4e6f5;
}

.swal2-input::placeholder,
.swal2-file::placeholder,
.swal2-textarea::placeholder {
  color: #cccccc;
}

.swal2-range {
  margin: 1em auto;
  background: inherit;
}

.swal2-range input {
  width: 80%;
}

.swal2-range output {
  width: 20%;
  color: inherit;
  font-weight: 600;
  text-align: center;
}

.swal2-range input,
.swal2-range output {
  height: 2.625em;
  padding: 0;
  font-size: 1.125em;
  line-height: 2.625em;
}

.swal2-input {
  height: 2.625em;
  padding: 0 0.75em;
}

.swal2-input[type=number] {
  max-width: 10em;
}

.swal2-file {
  background: inherit;
  font-size: 1.125em;
}

.swal2-textarea {
  height: 6.75em;
  padding: 0.75em;
}

.swal2-select {
  min-width: 50%;
  max-width: 100%;
  padding: 0.375em 0.625em;
  background: inherit;
  color: inherit;
  font-size: 1.125em;
}

.swal2-radio,
.swal2-checkbox {
  align-items: center;
  justify-content: center;
  background: inherit;
  color: inherit;
}

.swal2-radio label,
.swal2-checkbox label {
  margin: 0 0.6em;
  font-size: 1.125em;
}

.swal2-radio input,
.swal2-checkbox input {
  margin: 0 0.4em;
}

.swal2-validation-message {
  display: none;
  align-items: center;
  justify-content: center;
  padding: 0.625em;
  overflow: hidden;
  background: #f0f0f0;
  color: #666666;
  font-size: 1em;
  font-weight: 300;
}

.swal2-validation-message::before {
  content: "!";
  display: inline-block;
  width: 1.5em;
  min-width: 1.5em;
  height: 1.5em;
  margin: 0 0.625em;
  zoom: normal;
  border-radius: 50%;
  background-color: #f27474;
  color: #fff;
  font-weight: 600;
  line-height: 1.5em;
  text-align: center;
}

@supports (-ms-accelerator: true) {
  .swal2-range input {
    width: 100% !important;
  }
  .swal2-range output {
    display: none;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-range input {
    width: 100% !important;
  }
  .swal2-range output {
    display: none;
  }
}
@-moz-document url-prefix() {
  .swal2-close:focus {
    outline: 2px solid rgba(50, 100, 150, 0.4);
  }
}
.swal2-icon {
  position: relative;
  box-sizing: content-box;
  justify-content: center;
  width: 5em;
  height: 5em;
  margin: 1.25em auto 1.875em;
  zoom: normal;
  border: 0.25em solid transparent;
  border-radius: 50%;
  font-family: inherit;
  line-height: 5em;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
}

.swal2-icon::before {
  display: flex;
  align-items: center;
  height: 92%;
  font-size: 3.75em;
}

.swal2-icon.swal2-error {
  border-color: #f27474;
}

.swal2-icon.swal2-error .swal2-x-mark {
  position: relative;
  flex-grow: 1;
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  display: block;
  position: absolute;
  top: 2.3125em;
  width: 2.9375em;
  height: 0.3125em;
  border-radius: 0.125em;
  background-color: #f27474;
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=left] {
  left: 1.0625em;
  transform: rotate(45deg);
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=right] {
  right: 1em;
  transform: rotate(-45deg);
}

.swal2-icon.swal2-warning {
  border-color: #facea8;
  color: #f8bb86;
}

.swal2-icon.swal2-warning::before {
  content: "!";
}

.swal2-icon.swal2-info {
  border-color: #9de0f6;
  color: #3fc3ee;
}

.swal2-icon.swal2-info::before {
  content: "i";
}

.swal2-icon.swal2-question {
  border-color: #c9dae1;
  color: #87adbd;
}

.swal2-icon.swal2-question::before {
  content: "?";
}

.swal2-icon.swal2-question.swal2-arabic-question-mark::before {
  content: "؟";
}

.swal2-icon.swal2-success {
  border-color: #a5dc86;
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line] {
  position: absolute;
  width: 3.75em;
  height: 7.5em;
  transform: rotate(45deg);
  border-radius: 50%;
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=left] {
  top: -0.4375em;
  left: -2.0635em;
  transform: rotate(-45deg);
  transform-origin: 3.75em 3.75em;
  border-radius: 7.5em 0 0 7.5em;
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=right] {
  top: -0.6875em;
  left: 1.875em;
  transform: rotate(-45deg);
  transform-origin: 0 3.75em;
  border-radius: 0 7.5em 7.5em 0;
}

.swal2-icon.swal2-success .swal2-success-ring {
  position: absolute;
  z-index: 2;
  top: -0.25em;
  left: -0.25em;
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  border: 0.25em solid rgba(165, 220, 134, 0.3);
  border-radius: 50%;
}

.swal2-icon.swal2-success .swal2-success-fix {
  position: absolute;
  z-index: 1;
  top: 0.5em;
  left: 1.625em;
  width: 0.4375em;
  height: 5.625em;
  transform: rotate(-45deg);
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  display: block;
  position: absolute;
  z-index: 2;
  height: 0.3125em;
  border-radius: 0.125em;
  background-color: #a5dc86;
}

.swal2-icon.swal2-success [class^=swal2-success-line][class\$=tip] {
  top: 2.875em;
  left: 0.875em;
  width: 1.5625em;
  transform: rotate(45deg);
}

.swal2-icon.swal2-success [class^=swal2-success-line][class\$=long] {
  top: 2.375em;
  right: 0.5em;
  width: 2.9375em;
  transform: rotate(-45deg);
}

.swal2-progress-steps {
  align-items: center;
  margin: 0 0 1.25em;
  padding: 0;
  background: inherit;
  font-weight: 600;
}

.swal2-progress-steps li {
  display: inline-block;
  position: relative;
}

.swal2-progress-steps .swal2-progress-step {
  z-index: 20;
  width: 2em;
  height: 2em;
  border-radius: 2em;
  background: #3085d6;
  color: #fff;
  line-height: 2em;
  text-align: center;
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #3085d6;
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {
  background: #add8e6;
  color: #fff;
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: #add8e6;
}

.swal2-progress-steps .swal2-progress-step-line {
  z-index: 10;
  width: 2.5em;
  height: 0.4em;
  margin: 0 -1px;
  background: #3085d6;
}

[class^=swal2] {
  -webkit-tap-highlight-color: transparent;
}

.swal2-show {
  animation: swal2-show 0.3s;
}

.swal2-show.swal2-noanimation {
  animation: none;
}

.swal2-hide {
  animation: swal2-hide 0.15s forwards;
}

.swal2-hide.swal2-noanimation {
  animation: none;
}

.swal2-rtl .swal2-close {
  right: auto;
  left: 0;
}

.swal2-animate-success-icon .swal2-success-line-tip {
  animation: swal2-animate-success-line-tip 0.75s;
}

.swal2-animate-success-icon .swal2-success-line-long {
  animation: swal2-animate-success-line-long 0.75s;
}

.swal2-animate-success-icon .swal2-success-circular-line-right {
  animation: swal2-rotate-success-circular-line 4.25s ease-in;
}

.swal2-animate-error-icon {
  animation: swal2-animate-error-icon 0.5s;
}

.swal2-animate-error-icon .swal2-x-mark {
  animation: swal2-animate-error-x-mark 0.5s;
}
@keyframes swal2-rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media print {
  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
    overflow-y: scroll !important;
  }
  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) > [aria-hidden=true] {
    display: none;
  }
  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container {
    position: static !important;
  }
}
/**
  * bootstrap-switch - Turn checkboxes and radio buttons into toggle switches.
  *
  * @version v3.3.4
  * @homepage https://bttstrp.github.io/bootstrap-switch
  * @author Mattia Larentis <mattia@larentis.eu> (http://larentis.eu)
  * @license MIT
  */
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.13);
  margin-bottom: 10px;
  line-height: 8px;
  width: 59px !important;
  height: 22px;
  outline: none;
  z-index: 0;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  background: url("https://d2v9y0dukr6mq2.cloudfront.net/video/thumbnail/J9H9WF0/night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png");
  background-position: center center;
  background-size: cover;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 22px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  line-height: 11px;
  width: 50% !important;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-brown,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-brown {
  color: #fff;
  background: #e14eca;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-blue,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-blue {
  color: #fff;
  background: #1d8cf8;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-green,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-green {
  color: #fff;
  background: #00f2c3;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-orange,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-orange {
  background: #ff8d72;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-red,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-red {
  color: #fff;
  background: #fd5d93;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 18px !important;
  height: 18px !important;
  margin: 0px -11px;
  border-radius: 20px;
  position: absolute;
  float: left;
  top: 2px;
  left: 51%;
  padding: 0;
  box-shadow: 0 1px 11px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label {
  background-color: rgba(156, 156, 156, 0.9);
  left: 52%;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 27px !important;
  margin-left: -20px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 27px !important;
  margin-left: -11px;
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type=radio].form-control,
.bootstrap-switch input[type=checkbox].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -39px !important;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label:before {
  background-color: #FFFFFF;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-red ~ .bootstrap-switch-default {
  background-color: #fd5d93;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-orange ~ .bootstrap-switch-default {
  background-color: #ff8d72;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-green ~ .bootstrap-switch-default {
  background-color: #00f2c3;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-brown ~ .bootstrap-switch-default {
  background-color: #e14eca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-blue ~ .bootstrap-switch-default {
  background-color: #1d8cf8;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-red,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-brown,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-blue,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-orange,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-green {
  background-color: #E3E3E3;
}

.bootstrap-switch-on .bootstrap-switch-handle-off,
.bootstrap-switch-off .bootstrap-switch-handle-on {
  opacity: 0;
  visibility: hidden;
}

.bootstrap-switch-off:before {
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  background: rgba(16, 16, 16, 0.7);
}

/*!
 * Bootstrap-select v1.13.9 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2019 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */
select.bs-select-hidden,
.bootstrap-select > select.bs-select-hidden,
select.selectpicker {
  display: none !important;
}

.bootstrap-select {
  width: 100%;
  /*IE9 and below*/
  vertical-align: middle;
}
.bootstrap-select.show > .dropdown-menu {
  overflow: visible !important;
}

.bootstrap-select > .dropdown-toggle {
  position: relative;
  width: 100%;
  text-align: right;
  white-space: nowrap;
  background: transparent !important;
  background-image: none !important;
  border: 1px solid #2b3553;
  padding: 10px;
  margin: 0;
  margin-bottom: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
}
.bootstrap-select > .dropdown-toggle:hover {
  box-shadow: none !important;
  transform: none !important;
}
.bootstrap-select > .dropdown-toggle:focus {
  outline: none !important;
}
.bootstrap-select > .dropdown-toggle:focus:active {
  background: none !important;
}

.bootstrap-select > .dropdown-toggle:after {
  margin-top: -1px;
}

.bootstrap-select > .dropdown-toggle.bs-placeholder,
.bootstrap-select > .dropdown-toggle.bs-placeholder:hover,
.bootstrap-select > .dropdown-toggle.bs-placeholder:focus,
.bootstrap-select > .dropdown-toggle.bs-placeholder:active {
  color: #999;
}

.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:hover,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:hover,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:hover,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:hover,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:hover,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:hover,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:focus,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:focus,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:focus,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:focus,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:focus,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:focus,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:active,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:active,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:active,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:active,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:active,
.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:active {
  color: rgba(255, 255, 255, 0.5);
}

.bootstrap-select > select {
  position: absolute !important;
  bottom: 0;
  left: 50%;
  display: block !important;
  width: 0.5px !important;
  height: 100% !important;
  padding: 0 !important;
  opacity: 0 !important;
  border: none;
  z-index: 0 !important;
}

.bootstrap-select > select.mobile-device {
  top: 0;
  left: 0;
  display: block !important;
  width: 100% !important;
  z-index: 2 !important;
}

.has-error .bootstrap-select .dropdown-toggle,
.error .bootstrap-select .dropdown-toggle,
.bootstrap-select.is-invalid .dropdown-toggle,
.was-validated .bootstrap-select .selectpicker:invalid + .dropdown-toggle {
  border-color: #b94a48;
}

.bootstrap-select.is-valid .dropdown-toggle,
.was-validated .bootstrap-select .selectpicker:valid + .dropdown-toggle {
  border-color: #28a745;
}

.bootstrap-select.fit-width {
  width: auto !important;
}

.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {
  width: 100%;
}

.bootstrap-select.form-control {
  margin-bottom: 0;
  padding: 0;
  border: none;
}

:not(.input-group) > .bootstrap-select.form-control:not([class*=col-]) {
  width: 100%;
}

.bootstrap-select.form-control.input-group-btn {
  float: none;
  z-index: auto;
}

.form-inline .bootstrap-select,
.form-inline .bootstrap-select.form-control:not([class*=col-]) {
  width: auto;
}

.bootstrap-select:not(.input-group-btn),
.bootstrap-select[class*=col-] {
  float: none;
  display: inline-block;
  margin-left: 0;
}

.bootstrap-select.dropdown-menu-right,
.bootstrap-select[class*=col-].dropdown-menu-right,
.row .bootstrap-select[class*=col-].dropdown-menu-right {
  float: right;
}

.form-inline .bootstrap-select,
.form-horizontal .bootstrap-select,
.form-group .bootstrap-select {
  margin-bottom: 0;
}

.form-group-lg .bootstrap-select.form-control,
.form-group-sm .bootstrap-select.form-control {
  padding: 0;
}

.form-group-lg .bootstrap-select.form-control .dropdown-toggle,
.form-group-sm .bootstrap-select.form-control .dropdown-toggle {
  height: 100%;
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}

.bootstrap-select.form-control-sm .dropdown-toggle,
.bootstrap-select.form-control-lg .dropdown-toggle {
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}

.bootstrap-select.form-control-sm .dropdown-toggle {
  padding: 0.25rem 0.5rem;
}

.bootstrap-select.form-control-lg .dropdown-toggle {
  padding: 0.5rem 1rem;
}

.form-inline .bootstrap-select .form-control {
  width: 100%;
}

.bootstrap-select.disabled,
.bootstrap-select > .disabled {
  cursor: not-allowed;
}

.bootstrap-select.disabled:focus,
.bootstrap-select > .disabled:focus {
  outline: none !important;
}

.bootstrap-select.bs-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 0 !important;
  padding: 0 !important;
}

.bootstrap-select.bs-container .dropdown-menu {
  z-index: 1060;
}

.bootstrap-select .dropdown-toggle .filter-option {
  position: static;
  top: 0;
  left: 0;
  float: left;
  height: 100%;
  text-align: left;
  overflow: hidden;
  flex: 0 1 auto;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
  font-size: 0.75rem;
  color: hsla(0deg, 0%, 100%, 0.8);
  font-weight: 400;
  text-align: left;
}

.bs3.bootstrap-select .dropdown-toggle .filter-option {
  padding-right: inherit;
}

.input-group .bs3-has-addon.bootstrap-select .dropdown-toggle .filter-option {
  position: absolute;
  padding-top: inherit;
  padding-bottom: inherit;
  padding-left: inherit;
  float: none;
}

.input-group .bs3-has-addon.bootstrap-select .dropdown-toggle .filter-option .filter-option-inner {
  padding-right: inherit;
}

.bootstrap-select .dropdown-toggle .filter-option-inner-inner {
  overflow: hidden;
}

.bootstrap-select .dropdown-toggle .filter-expand {
  width: 0 !important;
  float: left;
  opacity: 0 !important;
  overflow: hidden;
}

.bootstrap-select .dropdown-toggle .caret {
  position: absolute;
  top: 50%;
  right: 12px;
  margin-top: -2px;
  vertical-align: middle;
}

.input-group .bootstrap-select.form-control .dropdown-toggle {
  border-radius: inherit;
}

.bootstrap-select[class*=col-] .dropdown-toggle {
  width: 100%;
}

.bootstrap-select .dropdown-menu {
  min-width: 100%;
  box-sizing: border-box;
}

.bootstrap-select .dropdown-menu > .inner:focus {
  outline: none !important;
}

.bootstrap-select .dropdown-menu.inner {
  position: static;
  float: none;
  border: 0;
  padding: 0;
  margin: 0;
  border-radius: 0;
  box-shadow: none;
}

.bootstrap-select .dropdown-menu li {
  position: relative;
}

.bootstrap-select .dropdown-menu li.active small {
  color: rgba(255, 255, 255, 0.5) !important;
}

.bootstrap-select .dropdown-menu li.disabled a {
  cursor: not-allowed;
}

.bootstrap-select .dropdown-menu li a {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.bootstrap-select .dropdown-menu li a.opt {
  position: relative;
  padding-left: 2.25em;
}

.bootstrap-select .dropdown-menu li a span.check-mark {
  display: none;
}

.bootstrap-select .dropdown-menu li a span.text {
  display: inline-block;
}

.bootstrap-select .dropdown-menu li small {
  padding-left: 0.5em;
}

.bootstrap-select .dropdown-menu .notify {
  position: absolute;
  bottom: 5px;
  width: 96%;
  margin: 0 2%;
  min-height: 26px;
  padding: 3px 5px;
  background: #f5f5f5;
  border: 1px solid #e3e3e3;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  pointer-events: none;
  opacity: 0.9;
  box-sizing: border-box;
}

.bootstrap-select .no-results {
  padding: 3px;
  background: #f5f5f5;
  margin: 0 5px;
  white-space: nowrap;
}

.bootstrap-select.fit-width .dropdown-toggle .filter-option {
  position: static;
  display: inline;
  padding: 0;
  width: auto;
}

.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner,
.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner-inner {
  display: inline;
}

.bootstrap-select.fit-width .dropdown-toggle .bs-caret:before {
  content: " ";
}

.bootstrap-select.fit-width .dropdown-toggle .caret {
  position: static;
  top: auto;
  margin-top: -1px;
}

.bootstrap-select.show-tick .dropdown-menu .selected span.check-mark {
  position: absolute;
  display: inline-block;
  right: 15px;
  top: 5px;
}

.bootstrap-select.show-tick .dropdown-menu li a span.text {
  margin-right: 34px;
}

.bootstrap-select .bs-ok-default:after {
  content: "";
  display: block;
  width: 0.5em;
  height: 1em;
  border-style: solid;
  border-width: 0 0.26em 0.26em 0;
  transform: rotate(45deg);
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle,
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {
  z-index: 1061;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:before {
  content: "";
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(204, 204, 204, 0.2);
  position: absolute;
  bottom: -4px;
  left: 9px;
  display: none;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:after {
  content: "";
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  position: absolute;
  bottom: -4px;
  left: 10px;
  display: none;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:before {
  bottom: auto;
  top: -4px;
  border-top: 7px solid rgba(204, 204, 204, 0.2);
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:after {
  bottom: auto;
  top: -4px;
  border-top: 6px solid white;
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:before {
  right: 12px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:after {
  right: 13px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle .filter-option:before,
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle .filter-option:before,
.bootstrap-select.show-menu-arrow.open > .dropdown-toggle .filter-option:after,
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle .filter-option:after {
  display: block;
}

.bs-searchbox,
.bs-actionsbox,
.bs-donebutton {
  padding: 4px 8px;
}

.bs-actionsbox {
  width: 100%;
  box-sizing: border-box;
}

.bs-actionsbox .btn-group button {
  width: 50%;
}

.bs-donebutton {
  float: left;
  width: 100%;
  box-sizing: border-box;
}

.bs-donebutton .btn-group button {
  width: 100%;
}

.bs-searchbox + .bs-actionsbox {
  padding: 0 8px 4px;
}

.bs-searchbox .form-control {
  margin-bottom: 0;
  width: 100%;
  float: none;
}

.bootstrap-select .dropdown-menu.inner li a {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: block;
  outline: none;
  color: #292b2c;
}
.bootstrap-select .dropdown-menu.inner li.disabled a {
  color: rgba(182, 182, 182, 0.6);
}
.bootstrap-select .dropdown-menu.inner li.disabled a:hover, .bootstrap-select .dropdown-menu.inner li.disabled a:focus {
  background-color: transparent;
}
.bootstrap-select .dropdown-menu.open {
  overflow: visible !important;
}
.bootstrap-select .dropdown-menu.dropdown-black {
  background: linear-gradient(to bottom, #222a42 0%, #1d253b 100%);
  border: 1px solid #555555;
}
.bootstrap-select .dropdown-menu.dropdown-black li > a {
  color: rgba(255, 255, 255, 0.7);
}

.btn-file {
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.btn-file > input {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 23px;
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  direction: ltr;
}

.fileinput {
  display: inline-block;
  margin-bottom: 9px;
}

.fileinput .form-control {
  display: inline-block;
  padding-top: 7px;
  padding-bottom: 5px;
  margin-bottom: 0;
  vertical-align: middle;
  cursor: text;
}

.fileinput .thumbnail {
  display: inline-block;
  margin-bottom: 10px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  max-width: 250px;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.fileinput .thumbnail.img-circle {
  border-radius: 50%;
  max-width: 100px;
}

.fileinput .thumbnail > img {
  max-height: 100%;
}

.fileinput .btn {
  vertical-align: middle;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
  display: none;
}

.fileinput-inline .fileinput-controls {
  display: inline;
}

.fileinput-filename {
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.form-control .fileinput-filename {
  vertical-align: bottom;
}

.fileinput.input-group {
  display: table;
}

.fileinput.input-group > * {
  position: relative;
  z-index: 2;
}

.fileinput.input-group > .btn-file {
  z-index: 1;
}

.fileinput-new.input-group .btn-file,
.fileinput-new .input-group .btn-file {
  border-radius: 0 4px 4px 0;
}

.fileinput-new.input-group .btn-file.btn-xs,
.fileinput-new .input-group .btn-file.btn-xs,
.fileinput-new.input-group .btn-file.btn-sm,
.fileinput-new.input-group .btn-group-sm > .btn-file.btn,
.fileinput-new .input-group .btn-file.btn-sm,
.fileinput-new .input-group .btn-group-sm > .btn-file.btn {
  border-radius: 0 3px 3px 0;
}

.fileinput-new.input-group .btn-file.btn-lg, .fileinput-new.input-group .btn-group-lg > .btn-file.btn,
.fileinput-new .input-group .btn-file.btn-lg,
.fileinput-new .input-group .btn-group-lg > .btn-file.btn {
  border-radius: 0 6px 6px 0;
}

.form-group.has-warning .fileinput .fileinput-preview {
  color: #ff8d72;
}

.form-group.has-warning .fileinput .thumbnail {
  border-color: #ff8d72;
}

.form-group.has-error .fileinput .fileinput-preview {
  color: #fd5d93;
}

.form-group.has-error .fileinput .thumbnail {
  border-color: #fd5d93;
}

.form-group.has-success .fileinput .fileinput-preview {
  color: #00f2c3;
}

.form-group.has-success .fileinput .thumbnail {
  border-color: #00f2c3;
}

.input-group-addon:not(:first-child) {
  border-left: 0;
}

.thumbnail {
  border: 0 none;
  border-radius: 3px;
  padding: 0;
}

/*
 * bootstrap-tagsinput v2.3.3
 *
 */
.bootstrap-tagsinput {
  display: inline-block;
  padding: 4px 6px;
  max-width: 100%;
  line-height: 22px;
  vertical-align: middle;
  cursor: text;
}
.bootstrap-tagsinput input {
  border: none;
  color: #9A9A9A;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 6px;
  margin: 0;
  width: auto;
  max-width: inherit;
}
.bootstrap-tagsinput input:focus {
  border: none;
  box-shadow: none;
}
.bootstrap-tagsinput.form-control input::-moz-placeholder {
  color: #777;
  opacity: 1;
}
.bootstrap-tagsinput.form-control input:-ms-input-placeholder, .bootstrap-tagsinput.form-control input::-webkit-input-placeholder {
  color: #777;
}
.bootstrap-tagsinput .tag {
  cursor: pointer;
  margin: 5px 3px 5px 0;
  position: relative;
  padding: 3px 8px;
  border-radius: 12px;
  font-weight: 500;
  font-size: 0.75em;
  text-transform: uppercase;
  display: inline-block;
  line-height: 1.5em;
  padding-left: 0.8em;
  color: #ffffff;
}
.bootstrap-tagsinput .tag:hover {
  padding-right: 22px;
}
.bootstrap-tagsinput .tag:hover [data-role=remove] {
  opacity: 1;
  padding-right: 4px;
}
.bootstrap-tagsinput .tag [data-role=remove] {
  cursor: pointer;
  position: absolute;
  top: 3px;
  right: 0px;
  opacity: 0;
  background-color: transparent;
}
.bootstrap-tagsinput .tag [data-role=remove]:after {
  font-family: "Nucleo";
  content: "\\ea48";
  padding: 0px 2px;
}

/*
 * Container style
 */
.ps {
  overflow: hidden !important;
  overflow-anchor: none;
  -ms-overflow-style: none;
  touch-action: auto;
  -ms-touch-action: auto;
}

/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: #eee;
  opacity: 0.9;
}

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__thumb-y {
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
  background-color: #999;
  height: 11px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #999;
  width: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  color: #344675;
  line-height: 1.5em;
  background: #ffffff;
  border: none;
  border-radius: 0.875rem;
  padding: 5px 10px;
  z-index: 1040;
}

.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin, .jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/*
 * This combined file was created by the DataTables downloader builder:
 *   https://datatables.net/download
 *
 * To rebuild or modify this file with the latest versions of the included
 * software please visit:
 *   https://datatables.net/download/#bs4/jszip-2.5.0/pdfmake-0.1.36/dt-1.10.18/af-2.3.0/b-1.5.2/b-colvis-1.5.1/b-flash-1.5.2/b-html5-1.5.2/b-print-1.5.2/cr-1.5.0/fc-3.2.5/fh-3.1.4/kt-2.4.0/r-2.2.2/rg-1.0.3/rr-1.2.4/sc-1.5.0/sl-1.2.6
 *
 * Included libraries:
 *   JSZip 2.5.0, pdfmake 0.1.36, DataTables 1.10.18, AutoFill 2.3.0, Buttons 1.5.2, Column visibility 1.5.1, Flash export 1.5.2, HTML5 export 1.5.2, Print view 1.5.2, ColReorder 1.5.0, FixedColumns 3.2.5, FixedHeader 3.1.4, KeyTable 2.4.0, Responsive 2.2.2, RowGroup 1.0.3, RowReorder 1.2.4, Scroller 1.5.0, Select 1.2.6
 */
table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
  border-collapse: separate !important;
  border-spacing: 0;
}

table.dataTable td, table.dataTable th {
  box-sizing: content-box;
}

table.dataTable td.dataTables_empty, table.dataTable th.dataTables_empty {
  text-align: center;
}

table.dataTable.nowrap th, table.dataTable.nowrap td {
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
  width: auto;
  display: inline-block;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}

div.dataTables_wrapper div.dataTables_filter label {
  font-weight: normal;
  white-space: nowrap;
  text-align: left;
}

div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 0.85em;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_paginate {
  margin: 0;
  white-space: nowrap;
  text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin: 2px 0;
  white-space: nowrap;
  justify-content: flex-end;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  margin-left: -100px;
  margin-top: -26px;
  text-align: center;
  padding: 1em 0;
}

table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting, table.dataTable thead > tr > td.sorting_asc, table.dataTable thead > tr > td.sorting_desc, table.dataTable thead > tr > td.sorting {
  padding-right: 30px;
}

table.dataTable thead > tr > th:active, table.dataTable thead > tr > td:active {
  outline: none;
}

table.dataTable thead .sorting, table.dataTable thead .sorting_asc, table.dataTable thead .sorting_desc, table.dataTable thead .sorting_asc_disabled, table.dataTable thead .sorting_desc_disabled {
  cursor: pointer;
  position: relative;
}

table.dataTable thead .sorting:before, table.dataTable thead .sorting:after, table.dataTable thead .sorting_asc:before, table.dataTable thead .sorting_asc:after, table.dataTable thead .sorting_desc:before, table.dataTable thead .sorting_desc:after, table.dataTable thead .sorting_asc_disabled:before, table.dataTable thead .sorting_asc_disabled:after, table.dataTable thead .sorting_desc_disabled:before, table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 0.9em;
  display: block;
  opacity: 0.3;
}

table.dataTable thead .sorting:before, table.dataTable thead .sorting_asc:before, table.dataTable thead .sorting_desc:before, table.dataTable thead .sorting_asc_disabled:before, table.dataTable thead .sorting_desc_disabled:before {
  right: 1em;
  content: "↑";
}

table.dataTable thead .sorting:after, table.dataTable thead .sorting_asc:after, table.dataTable thead .sorting_desc:after, table.dataTable thead .sorting_asc_disabled:after, table.dataTable thead .sorting_desc_disabled:after {
  right: 0.5em;
  content: "↓";
}

table.dataTable thead .sorting_asc:before, table.dataTable thead .sorting_desc:after {
  opacity: 1;
}

table.dataTable thead .sorting_asc_disabled:before, table.dataTable thead .sorting_desc_disabled:after {
  opacity: 0;
}

div.dataTables_scrollHead table.dataTable {
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
  border-top: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:before, div.dataTables_scrollBody table thead .sorting_asc:before, div.dataTables_scrollBody table thead .sorting_desc:before, div.dataTables_scrollBody table thead .sorting:after, div.dataTables_scrollBody table thead .sorting_asc:after, div.dataTables_scrollBody table thead .sorting_desc:after {
  display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th, div.dataTables_scrollBody table tbody tr:first-child td {
  border-top: none;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner {
  box-sizing: content-box;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner > table {
  margin-top: 0 !important;
  border-top: none;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_length, div.dataTables_wrapper div.dataTables_filter, div.dataTables_wrapper div.dataTables_info, div.dataTables_wrapper div.dataTables_paginate {
    text-align: center;
  }
}
table.dataTable.table-sm > thead > tr > th {
  padding-right: 20px;
}

table.dataTable.table-sm .sorting:before, table.dataTable.table-sm .sorting_asc:before, table.dataTable.table-sm .sorting_desc:before {
  top: 5px;
  right: 0.85em;
}

table.dataTable.table-sm .sorting:after, table.dataTable.table-sm .sorting_asc:after, table.dataTable.table-sm .sorting_desc:after {
  top: 5px;
}

table.table-bordered.dataTable th, table.table-bordered.dataTable td {
  border-left-width: 0;
}

table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable td:last-child, table.table-bordered.dataTable td:last-child {
  border-right-width: 0;
}

table.table-bordered.dataTable tbody th, table.table-bordered.dataTable tbody td {
  border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
  border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}

div.dt-autofill-handle {
  position: absolute;
  height: 8px;
  width: 8px;
  z-index: 102;
  box-sizing: border-box;
  border: 1px solid #0275d8;
  background: #0275d8;
}

div.dt-autofill-select {
  position: absolute;
  z-index: 1001;
  background-color: #0275d8;
  background-image: repeating-linear-gradient(45deg, transparent, transparent 5px, rgba(255, 255, 255, 0.5) 5px, rgba(255, 255, 255, 0.5) 10px);
}

div.dt-autofill-select.top, div.dt-autofill-select.bottom {
  height: 3px;
  margin-top: -1px;
}

div.dt-autofill-select.left, div.dt-autofill-select.right {
  width: 3px;
  margin-left: -1px;
}

div.dt-autofill-list {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 500px;
  margin-left: -250px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 0 5px #555;
  border: 2px solid #444;
  z-index: 11;
  box-sizing: border-box;
  padding: 1.5em 2em;
}

div.dt-autofill-list ul {
  display: table;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
}

div.dt-autofill-list ul li {
  display: table-row;
}

div.dt-autofill-list ul li:last-child div.dt-autofill-question, div.dt-autofill-list ul li:last-child div.dt-autofill-button {
  border-bottom: none;
}

div.dt-autofill-list ul li:hover {
  background-color: #f6f6f6;
}

div.dt-autofill-list div.dt-autofill-question {
  display: table-cell;
  padding: 0.5em 0;
  border-bottom: 1px solid #ccc;
}

div.dt-autofill-list div.dt-autofill-question input[type=number] {
  padding: 6px;
  width: 30px;
  margin: -2px 0;
}

div.dt-autofill-list div.dt-autofill-button {
  display: table-cell;
  padding: 0.5em 0;
  border-bottom: 1px solid #ccc;
}

div.dt-autofill-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  background: radial-gradient(ellipse farthest-corner at center, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.7) 100%);
  z-index: 10;
}

div.dt-autofill-list div.dt-autofill-question input[type=number] {
  padding: 6px;
  width: 60px;
  margin: -2px 0;
}

div.dataTables_info {
  color: hsla(0deg, 0%, 100%, 0.7);
}

@keyframes dtb-spinner {
  100% {
    transform: rotate(360deg);
  }
}
div.dt-button-info {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  margin-top: -100px;
  margin-left: -200px;
  background-color: white;
  border: 2px solid #111;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  text-align: center;
  z-index: 21;
}

div.dt-button-info h2 {
  padding: 0.5em;
  margin: 0;
  font-weight: normal;
  border-bottom: 1px solid #ddd;
  background-color: #f3f3f3;
}

div.dt-button-info > div {
  padding: 1em;
}

ul.dt-button-collection.dropdown-menu {
  display: block;
  z-index: 2002;
  -ms-column-gap: 8px;
  -o-column-gap: 8px;
  column-gap: 8px;
}

ul.dt-button-collection.dropdown-menu.fixed {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -75px;
  border-radius: 0;
}

ul.dt-button-collection.dropdown-menu.fixed.two-column {
  margin-left: -150px;
}

ul.dt-button-collection.dropdown-menu.fixed.three-column {
  margin-left: -225px;
}

ul.dt-button-collection.dropdown-menu.fixed.four-column {
  margin-left: -300px;
}

ul.dt-button-collection.dropdown-menu > * {
  page-break-inside: avoid;
  break-inside: avoid;
}

ul.dt-button-collection.dropdown-menu.two-column {
  width: 300px;
  padding-bottom: 1px;
  -ms-column-count: 2;
  -o-column-count: 2;
  column-count: 2;
}

ul.dt-button-collection.dropdown-menu.three-column {
  width: 450px;
  padding-bottom: 1px;
  -ms-column-count: 3;
  -o-column-count: 3;
  column-count: 3;
}

ul.dt-button-collection.dropdown-menu.four-column {
  width: 600px;
  padding-bottom: 1px;
  -ms-column-count: 4;
  -o-column-count: 4;
  column-count: 4;
}

ul.dt-button-collection.dropdown-menu .dt-button {
  border-radius: 0;
}

ul.dt-button-collection {
  -ms-column-gap: 8px;
  -o-column-gap: 8px;
  column-gap: 8px;
}

ul.dt-button-collection.fixed {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -75px;
  border-radius: 0;
}

ul.dt-button-collection.fixed.two-column {
  margin-left: -150px;
}

ul.dt-button-collection.fixed.three-column {
  margin-left: -225px;
}

ul.dt-button-collection.fixed.four-column {
  margin-left: -300px;
}

ul.dt-button-collection > * {
  page-break-inside: avoid;
  break-inside: avoid;
}

ul.dt-button-collection.two-column {
  width: 300px;
  padding-bottom: 1px;
  -ms-column-count: 2;
  -o-column-count: 2;
  column-count: 2;
}

ul.dt-button-collection.three-column {
  width: 450px;
  padding-bottom: 1px;
  -ms-column-count: 3;
  -o-column-count: 3;
  column-count: 3;
}

ul.dt-button-collection.four-column {
  width: 600px;
  padding-bottom: 1px;
  -ms-column-count: 4;
  -o-column-count: 4;
  column-count: 4;
}

ul.dt-button-collection .dt-button {
  border-radius: 0;
}

ul.dt-button-collection.fixed {
  max-width: none;
}

ul.dt-button-collection.fixed:before, ul.dt-button-collection.fixed:after {
  display: none;
}

div.dt-button-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

@media screen and (max-width: 767px) {
  div.dt-buttons {
    float: none;
    width: 100%;
    text-align: center;
    margin-bottom: 0.5em;
  }
  div.dt-buttons a.btn {
    float: none;
  }
}
div.dt-buttons button.btn.processing, div.dt-buttons div.btn.processing, div.dt-buttons a.btn.processing {
  color: rgba(0, 0, 0, 0.2);
}

div.dt-buttons button.btn.processing:after, div.dt-buttons div.btn.processing:after, div.dt-buttons a.btn.processing:after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  box-sizing: border-box;
  display: block;
  content: " ";
  border: 2px solid #282828;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: dtb-spinner 1500ms infinite linear;
  -o-animation: dtb-spinner 1500ms infinite linear;
  -ms-animation: dtb-spinner 1500ms infinite linear;
  -webkit-animation: dtb-spinner 1500ms infinite linear;
  -moz-animation: dtb-spinner 1500ms infinite linear;
}

table.DTCR_clonedTable.dataTable {
  position: absolute !important;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 202;
}

div.DTCR_pointer {
  width: 1px;
  background-color: #0275d8;
  z-index: 201;
}

table.DTFC_Cloned tr {
  background-color: white;
  margin-bottom: 0;
}

div.DTFC_LeftHeadWrapper table, div.DTFC_RightHeadWrapper table {
  border-bottom: none !important;
  margin-bottom: 0 !important;
  background-color: white;
}

div.DTFC_LeftBodyWrapper table, div.DTFC_RightBodyWrapper table {
  border-top: none;
  margin: 0 !important;
}

div.DTFC_LeftBodyWrapper table thead .sorting:after, div.DTFC_LeftBodyWrapper table thead .sorting_asc:after, div.DTFC_LeftBodyWrapper table thead .sorting_desc:after, div.DTFC_LeftBodyWrapper table thead .sorting:after, div.DTFC_LeftBodyWrapper table thead .sorting_asc:after, div.DTFC_LeftBodyWrapper table thead .sorting_desc:after, div.DTFC_RightBodyWrapper table thead .sorting:after, div.DTFC_RightBodyWrapper table thead .sorting_asc:after, div.DTFC_RightBodyWrapper table thead .sorting_desc:after, div.DTFC_RightBodyWrapper table thead .sorting:after, div.DTFC_RightBodyWrapper table thead .sorting_asc:after, div.DTFC_RightBodyWrapper table thead .sorting_desc:after {
  display: none;
}

div.DTFC_LeftBodyWrapper table tbody tr:first-child th, div.DTFC_LeftBodyWrapper table tbody tr:first-child td, div.DTFC_RightBodyWrapper table tbody tr:first-child th, div.DTFC_RightBodyWrapper table tbody tr:first-child td {
  border-top: none;
}

div.DTFC_LeftFootWrapper table, div.DTFC_RightFootWrapper table {
  border-top: none;
  margin-top: 0 !important;
  background-color: white;
}

div.DTFC_Blocker {
  background-color: white;
}

table.dataTable.table-striped.DTFC_Cloned tbody {
  background-color: white;
}

table.dataTable.fixedHeader-floating, table.dataTable.fixedHeader-locked {
  background-color: white;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

table.dataTable.fixedHeader-floating {
  position: fixed !important;
}

table.dataTable.fixedHeader-locked {
  position: absolute !important;
}

@media print {
  table.fixedHeader-floating {
    display: none;
  }
}
table.dataTable tbody th.focus, table.dataTable tbody td.focus {
  box-shadow: inset 0 0 1px 2px #0275d8;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child, table.dataTable.dtr-inline.collapsed > tbody > tr > th.child, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {
  cursor: default !important;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before, table.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {
  display: none !important;
}

table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child, table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}

table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before, table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before {
  top: 12px;
  left: 4px;
  height: 14px;
  width: 14px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  text-indent: 0 !important;
  font-family: "Courier New", Courier, monospace;
  line-height: 14px;
  content: "+";
  background-color: #0275d8;
}

table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before, table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child, table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {
  padding-left: 27px;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child:before, table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child:before {
  top: 5px;
  left: 4px;
  height: 14px;
  width: 14px;
  border-radius: 14px;
  line-height: 14px;
  text-indent: 3px;
}

table.dataTable.dtr-column > tbody > tr > td.control, table.dataTable.dtr-column > tbody > tr > th.control {
  position: relative;
  cursor: pointer;
}

table.dataTable.dtr-column > tbody > tr > td.control:before, table.dataTable.dtr-column > tbody > tr > th.control:before {
  top: 50%;
  left: 50%;
  height: 16px;
  width: 16px;
  margin-top: -10px;
  margin-left: -10px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  text-indent: 0 !important;
  font-family: "Courier New", Courier, monospace;
  line-height: 14px;
  content: "+";
  background-color: #0275d8;
}

table.dataTable.dtr-column > tbody > tr.parent td.control:before, table.dataTable.dtr-column > tbody > tr.parent th.control:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable > tbody > tr.child {
  padding: 0.5em 1em;
}

table.dataTable > tbody > tr.child:hover {
  background: transparent !important;
}

table.dataTable > tbody > tr.child ul.dtr-details {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

table.dataTable > tbody > tr.child ul.dtr-details > li {
  border-bottom: 1px solid #efefef;
  padding: 0.5em 0;
}

table.dataTable > tbody > tr.child ul.dtr-details > li:first-child {
  padding-top: 0;
}

table.dataTable > tbody > tr.child ul.dtr-details > li:last-child {
  border-bottom: none;
}

table.dataTable > tbody > tr.child span.dtr-title {
  display: inline-block;
  min-width: 75px;
  font-weight: bold;
}

div.dtr-modal {
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  padding: 10em 1em;
}

div.dtr-modal div.dtr-modal-display {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 50%;
  overflow: auto;
  margin: auto;
  z-index: 102;
  overflow: auto;
  background-color: #f5f5f7;
  border: 1px solid black;
  border-radius: 0.5em;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}

div.dtr-modal div.dtr-modal-content {
  position: relative;
  padding: 1em;
}

div.dtr-modal div.dtr-modal-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: 1px solid #eaeaea;
  background-color: #f9f9f9;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  z-index: 12;
}

div.dtr-modal div.dtr-modal-close:hover {
  background-color: #eaeaea;
}

div.dtr-modal div.dtr-modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 767px) {
  div.dtr-modal div.dtr-modal-display {
    width: 95%;
  }
}
div.dtr-bs-modal table.table tr:first-child td {
  border-top: none;
}

table.dataTable tr.group td {
  font-weight: bold;
  background-color: #e0e0e0;
}

table.dt-rowReorder-float {
  position: absolute !important;
  opacity: 0.8;
  table-layout: fixed;
  outline: 2px solid #0275d8;
  outline-offset: -2px;
  z-index: 2001;
}

tr.dt-rowReorder-moving {
  outline: 2px solid #888;
  outline-offset: -2px;
}

body.dt-rowReorder-noOverflow {
  overflow-x: hidden;
}

table.dataTable td.reorder {
  text-align: center;
  cursor: move;
}

div.DTS {
  display: block !important;
}

div.DTS tbody th, div.DTS tbody td {
  white-space: nowrap;
}

div.DTS div.DTS_Loading {
  z-index: 1;
}

div.DTS div.dataTables_scrollBody {
  background: repeating-linear-gradient(45deg, #edeeff, #edeeff 10px, #fff 10px, #fff 20px);
}

div.DTS div.dataTables_scrollBody table {
  z-index: 2;
}

div.DTS div.dataTables_paginate, div.DTS div.dataTables_length {
  display: none;
}

div.DTS div.dataTables_scrollBody table {
  background-color: white;
}

table.dataTable tbody > tr.selected, table.dataTable tbody > tr > .selected {
  background-color: #0275d8;
}

table.dataTable.stripe tbody > tr.odd.selected, table.dataTable.stripe tbody > tr.odd > .selected, table.dataTable.display tbody > tr.odd.selected, table.dataTable.display tbody > tr.odd > .selected {
  background-color: #0272d3;
}

table.dataTable.hover tbody > tr.selected:hover, table.dataTable.hover tbody > tr > .selected:hover, table.dataTable.display tbody > tr.selected:hover, table.dataTable.display tbody > tr > .selected:hover {
  background-color: #0271d0;
}

table.dataTable.order-column tbody > tr.selected > .sorting_1, table.dataTable.order-column tbody > tr.selected > .sorting_2, table.dataTable.order-column tbody > tr.selected > .sorting_3, table.dataTable.order-column tbody > tr > .selected, table.dataTable.display tbody > tr.selected > .sorting_1, table.dataTable.display tbody > tr.selected > .sorting_2, table.dataTable.display tbody > tr.selected > .sorting_3, table.dataTable.display tbody > tr > .selected {
  background-color: #0273d4;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_1, table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_1 {
  background-color: #026fcc;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_2, table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_2 {
  background-color: #0270ce;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_3, table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_3 {
  background-color: #0270d0;
}

table.dataTable.display tbody > tr.even.selected > .sorting_1, table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_1 {
  background-color: #0273d4;
}

table.dataTable.display tbody > tr.even.selected > .sorting_2, table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_2 {
  background-color: #0274d5;
}

table.dataTable.display tbody > tr.even.selected > .sorting_3, table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_3 {
  background-color: #0275d7;
}

table.dataTable.display tbody > tr.odd > .selected, table.dataTable.order-column.stripe tbody > tr.odd > .selected {
  background-color: #026fcc;
}

table.dataTable.display tbody > tr.even > .selected, table.dataTable.order-column.stripe tbody > tr.even > .selected {
  background-color: #0273d4;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_1, table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_1 {
  background-color: #026bc6;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_2, table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_2 {
  background-color: #026cc8;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_3, table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_3 {
  background-color: #026eca;
}

table.dataTable.display tbody > tr:hover > .selected, table.dataTable.display tbody > tr > .selected:hover, table.dataTable.order-column.hover tbody > tr:hover > .selected, table.dataTable.order-column.hover tbody > tr > .selected:hover {
  background-color: #026bc6;
}

table.dataTable tbody td.select-checkbox, table.dataTable tbody th.select-checkbox {
  position: relative;
}

table.dataTable tbody td.select-checkbox:before, table.dataTable tbody td.select-checkbox:after, table.dataTable tbody th.select-checkbox:before, table.dataTable tbody th.select-checkbox:after {
  display: block;
  position: absolute;
  top: 1.2em;
  left: 50%;
  width: 12px;
  height: 12px;
  box-sizing: border-box;
}

table.dataTable tbody td.select-checkbox:before, table.dataTable tbody th.select-checkbox:before {
  content: " ";
  margin-top: -6px;
  margin-left: -6px;
  border: 1px solid black;
  border-radius: 3px;
}

table.dataTable tr.selected td.select-checkbox:after, table.dataTable tr.selected th.select-checkbox:after {
  content: "✔";
  margin-top: -11px;
  margin-left: -4px;
  text-align: center;
  text-shadow: 1px 1px #B0BED9, -1px -1px #B0BED9, 1px -1px #B0BED9, -1px 1px #B0BED9;
}

div.dataTables_wrapper span.select-info, div.dataTables_wrapper span.select-item {
  margin-left: 0.5em;
}

@media screen and (max-width: 640px) {
  div.dataTables_wrapper span.select-info, div.dataTables_wrapper span.select-item {
    margin-left: 0;
    display: block;
  }
}
table.dataTable tbody tr.selected, table.dataTable tbody th.selected, table.dataTable tbody td.selected {
  color: white;
}

table.dataTable tbody tr.selected a, table.dataTable tbody th.selected a, table.dataTable tbody td.selected a {
  color: #a2d4ed;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2015 Daniel Eden
*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animated.infinite {
  animation-iteration-count: infinite;
}

.animated.hinge {
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
  animation-duration: 0.75s;
}

.animated.flipOutX,
.animated.flipOutY {
  animation-duration: 0.75s;
}
@keyframes shake {
  from, to {
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    transform: translate3d(10px, 0, 0);
  }
}
.shake {
  animation-name: shake;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
.fadeOutDown {
  animation-name: fadeOutDown;
}
@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.fadeOutUp {
  animation-name: fadeOutUp;
}

.card-wizard {
  min-height: 410px;
  background: transparent !important;
  box-shadow: none !important;
  opacity: 0;
  transition: all 300ms linear;
}
.card-wizard.active {
  opacity: 1;
}
.card-wizard .progress-with-circle .progress-bar {
  background: #e14eca;
}
.card-wizard .nav-pills .nav-item .nav-link {
  color: #e14eca;
}
.card-wizard .nav-pills .nav-item .nav-link.checked, .card-wizard .nav-pills .nav-item .nav-link.active {
  background: #e14eca;
  color: white;
}
.card-wizard .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  background: #e14eca;
}
.card-wizard[data-color=primary] .progress-with-circle .progress-bar {
  background: #e14eca;
}
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link {
  color: #e14eca;
}
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.active {
  background: #e14eca;
  color: white;
}
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.active:hover {
  background: #e14eca;
}
.card-wizard[data-color=green] .progress-with-circle .progress-bar {
  background: #00bf9a;
}
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link {
  color: #00bf9a;
}
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=green] .nav-pills .nav-item .nav-link.active {
  background: #00bf9a;
  color: white;
}
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.active:hover {
  background: #00bf9a;
}
.card-wizard[data-color=blue] .progress-with-circle .progress-bar {
  background: #1d8cf8;
}
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link {
  color: #1d8cf8;
}
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.active {
  background: #1d8cf8;
  color: white;
}
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.active:hover {
  background: #1d8cf8;
}
.card-wizard[data-color=red] .progress-with-circle .progress-bar {
  background: #fd5d93;
}
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link {
  color: #fd5d93;
}
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=red] .nav-pills .nav-item .nav-link.active {
  background: #fd5d93;
  color: white;
}
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.active:hover {
  background: #fd5d93;
}
.card-wizard[data-color=orange] .progress-with-circle .progress-bar {
  background: #ff8d72;
}
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link {
  color: #ff8d72;
}
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.active {
  background: #ff8d72;
  color: white;
}
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.active:hover {
  background: #ff8d72;
}
.card-wizard .nav-pills .nav-item {
  position: relative;
}
.card-wizard .nav-pills .nav-item .nav-link {
  height: 45px;
  width: 45px;
  min-width: 45px;
  border-radius: 50% !important;
  position: absolute;
  left: 50%;
  top: -20px;
  transform: translate(-50%);
  background-color: white;
}
.card-wizard .nav-pills .nav-item .nav-link p {
  position: absolute;
  top: 110%;
  left: 50%;
  transform: translate(-50%);
  font-weight: 400;
  color: #ffffff;
}
.card-wizard .nav-pills .nav-item .nav-link:hover, .card-wizard .nav-pills .nav-item .nav-link:focus {
  background-color: white;
}
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  box-shadow: none;
}
.card-wizard .picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.card-wizard .card-body {
  background: #222a42;
  border-top-left-radius: 0.4285rem;
  border-top-right-radius: 0.4285rem;
  margin-top: 20px;
}
.card-wizard .card-footer {
  background-color: #222a42 !important;
  border-bottom-left-radius: 0.4285rem;
  border-bottom-right-radius: 0.4285rem;
  padding-bottom: 20px;
}
.card-wizard .card-footer .pull-right {
  padding-right: 80px;
}
.card-wizard .card-footer .pull-left {
  padding-left: 80px;
}
.card-wizard .wizard-navigation {
  position: relative;
  margin: 80px auto 60px;
}
.card-wizard .wizard-navigation .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-wizard .wizard-navigation .progress-with-circle {
  position: relative;
  top: 5px;
  height: 5px;
  border-radius: 0.4285rem;
}
.card-wizard .wizard-navigation .progress-with-circle .progress-bar {
  height: 100%;
  border-radius: 0.4285rem;
  box-shadow: none;
  transition: width 0.3s ease;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
  display: inline-block;
  font-size: 19px;
  line-height: normal;
  line-height: initial;
  padding: 0;
  vertical-align: bottom;
}
.card-wizard .picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #E3E3E3;
  color: #FFFFFF;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
  border-color: #2ca8ff;
}
.card-wizard .picture input[type=file] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
.card-wizard .picture-src {
  width: 100%;
}
.card-wizard .tab-content {
  padding: 20px 0;
}
.card-wizard .wizard-footer {
  padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
  margin-top: 16px;
}
.card-wizard .disabled {
  display: none;
}
.card-wizard .wizard-header {
  text-align: center;
  padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
  margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
  text-align: center;
}
.card-wizard .btn {
  text-transform: uppercase;
}
.card-wizard .info-text {
  text-align: center;
  font-weight: 300;
  margin: 10px 0 30px;
}
.card-wizard .choice {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.card-wizard .choice[disabled] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.card-wizard .choice .icon {
  text-align: center;
  vertical-align: middle;
  height: 116px;
  width: 116px;
  border-radius: 50%;
  color: #344675;
  margin: 0 auto 20px;
  border: 1px solid #E3E3E3;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .choice i {
  font-size: 30px;
  line-height: 116px;
  position: absolute;
  left: 0;
  right: 0;
}
.card-wizard .choice:hover .icon, .card-wizard .choice.active .icon {
  border-color: #2ca8ff;
}
.card-wizard .choice input[type=radio],
.card-wizard .choice input[type=checkbox] {
  position: absolute;
  left: -10000px;
  z-index: -1;
}
.card-wizard .btn-finish {
  display: none;
}
.card-wizard .card-title + .description {
  font-size: 17px;
  margin-bottom: 32px;
}
.card-wizard .wizard-title {
  margin: 0;
}
.card-wizard .nav-pills {
  background-color: #ffffff;
  border-radius: 0.4285rem;
  height: 5px;
}
.card-wizard .nav-pills > li + li {
  margin-left: 0;
}
.card-wizard .nav-pills > li > a {
  border: 0 !important;
  border-radius: 0;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  min-width: 100px;
  text-align: center;
  color: #555555;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
  background-color: inherit;
  box-shadow: none;
}
.card-wizard .nav-pills > li i {
  display: block;
  font-size: 30px;
  padding: 15px 0;
}
.card-wizard .input-group.has-danger .error {
  display: block;
  width: 100%;
  margin-top: 3px;
}

/*
 * DOM element rendering detection
 * https://davidwalsh.name/detect-node-insertion
 */
@keyframes chartjs-render-animation {
  from {
    opacity: 0.99;
  }
  to {
    opacity: 1;
  }
}
.chartjs-render-monitor {
  animation: chartjs-render-animation 0.001s;
}

/*
 * DOM element resizing detection
 * https://github.com/marcj/css-element-queries
 */
.chartjs-size-monitor,
.chartjs-size-monitor-expand,
.chartjs-size-monitor-shrink {
  position: absolute;
  direction: ltr;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
  z-index: -1;
}

.chartjs-size-monitor-expand > div {
  position: absolute;
  width: 1000000px;
  height: 1000000px;
  left: 0;
  top: 0;
}

.chartjs-size-monitor-shrink > div {
  position: absolute;
  width: 200%;
  height: 200%;
  left: 0;
  top: 0;
}

.login-page .card-login {
  border-radius: 0.4285rem;
  padding-bottom: 0.7rem;
}
.login-page .card-login .card-header {
  padding: 0 0 100px;
  overflow: hidden;
}
.login-page .card-login .card-header img {
  position: absolute;
}
.login-page .card-login .card-header .card-title {
  position: relative;
  font-size: 5em;
  font-weight: 900;
  color: #222a42;
  text-transform: lowercase;
  margin-left: -5px;
  z-index: 1;
}
.login-page .card-login .btn-wd {
  min-width: 180px;
}
.login-page .card-login .logo-container {
  width: 65px;
  margin: 0 auto;
  margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
  width: 100%;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
  color: #ffffff;
}
.login-page .card-login.card-plain .has-danger .form-control {
  background-color: transparent;
}
.login-page .card-login.card-plain .input-group-prepend {
  margin-right: 0;
}
.login-page .card-login.card-plain .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.login-page .card-login.card-plain .input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus, .login-page .card-login.card-plain .form-group.no-border .form-control:active, .login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .login-page .card-login.card-plain .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.login-page .card-login.card-plain .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.login-page .card-login.card-plain .input-group-addon,
.login-page .card-login.card-plain .form-group.no-border .input-group-addon,
.login-page .card-login.card-plain .input-group.no-border .input-group-addon {
  color: rgba(255, 255, 255, 0.8);
}
.login-page .card-login.card-white {
  background: #ffffff;
}
.login-page .card-login.card-white .card-header .card-title {
  color: #ffffff;
}
.login-page .card-login.card-white .form-control::-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-white .form-control:-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-white .form-control::-webkit-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-white .form-control:-ms-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-white .has-danger .form-control, .login-page .card-login.card-white .has-danger .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.login-page .card-login.card-white .input-group-prepend .input-group-text {
  border-color: rgba(29, 37, 59, 0.2);
  color: #1d253b;
}
.login-page .card-login.card-white .form-control {
  color: #222a42;
  border-color: rgba(29, 37, 59, 0.2);
}
.login-page .card-login.card-white .form-control:focus {
  border-color: #e14eca;
}
.login-page .card-login.card-white .form-group.no-border .form-control,
.login-page .card-login.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.login-page .card-login.card-white .form-group.no-border .form-control + .input-group-append .input-group-text,
.login-page .card-login.card-white .form-group.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-white .form-group.no-border .input-group-append .input-group-text,
.login-page .card-login.card-white .input-group.no-border .form-control,
.login-page .card-login.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.login-page .card-login.card-white .input-group.no-border .form-control + .input-group-append .input-group-text,
.login-page .card-login.card-white .input-group.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-white .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
}
.login-page .card-login.card-white .form-group.no-border .form-control:focus, .login-page .card-login.card-white .form-group.no-border .form-control:active, .login-page .card-login.card-white .form-group.no-border .form-control:active,
.login-page .card-login.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.login-page .card-login.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.login-page .card-login.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-white .form-group.no-border .input-group-prepend .input-group-text:focus,
.login-page .card-login.card-white .form-group.no-border .input-group-prepend .input-group-text:active,
.login-page .card-login.card-white .form-group.no-border .input-group-prepend .input-group-text:active,
.login-page .card-login.card-white .form-group.no-border .input-group-append .input-group-text:focus,
.login-page .card-login.card-white .form-group.no-border .input-group-append .input-group-text:active,
.login-page .card-login.card-white .form-group.no-border .input-group-append .input-group-text:active,
.login-page .card-login.card-white .input-group.no-border .form-control:focus,
.login-page .card-login.card-white .input-group.no-border .form-control:active,
.login-page .card-login.card-white .input-group.no-border .form-control:active,
.login-page .card-login.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.login-page .card-login.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.login-page .card-login.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-white .input-group.no-border .input-group-prepend .input-group-text:focus,
.login-page .card-login.card-white .input-group.no-border .input-group-prepend .input-group-text:active,
.login-page .card-login.card-white .input-group.no-border .input-group-prepend .input-group-text:active,
.login-page .card-login.card-white .input-group.no-border .input-group-append .input-group-text:focus,
.login-page .card-login.card-white .input-group.no-border .input-group-append .input-group-text:active,
.login-page .card-login.card-white .input-group.no-border .input-group-append .input-group-text:active {
  background-color: rgba(222, 222, 222, 0.5);
}
.login-page .card-login.card-white .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .login-page .card-login.card-white .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.login-page .card-login.card-white .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.login-page .card-login.card-white .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: transparent;
}
.login-page .card-login.card-white .input-group[disabled] .input-group-prepend .input-group-text,
.login-page .card-login.card-white .input-group[disabled] .input-group-append .input-group-text {
  background-color: #222a42;
}
.login-page .card-login.card-white .form-control[disabled], .login-page .card-login.card-white .form-control[readonly], .login-page .card-login.card-white fieldset[disabled] .form-control {
  background: #E3E3E3;
  border-color: rgba(29, 37, 59, 0.3);
}
.login-page .card-login.card-white .input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-white .input-group-focus .input-group-append .input-group-text,
.login-page .card-login.card-white .input-group-focus .form-control {
  background-color: #ffffff;
  border-color: #e14eca;
}
.login-page .card-login.card-white .input-group-focus.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-white .input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.login-page .card-login.card-white .input-group-prepend .input-group-text {
  border-right: none;
}
.login-page .card-login.card-white .input-group-append .input-group-text {
  border-left: none;
}
.login-page .card-login.card-white .has-danger .form-control:focus, .login-page .card-login.card-white .has-success.input-group-focus .input-group-append .input-group-text, .login-page .card-login.card-white .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.login-page .card-login.card-white .has-success .form-control:focus, .login-page .card-login.card-white .has-success.input-group-focus .input-group-append .input-group-text, .login-page .card-login.card-white .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #00bf9a;
}
.login-page .link {
  font-size: 10px;
  text-decoration: none;
}
.login-page .card-black .link {
  color: #ffffff;
}

.full-page > .content, .full-page > .footer {
  position: relative;
  z-index: 4;
}
.full-page > .content {
  padding-bottom: 150px;
  padding-top: 150px;
}
.full-page .footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding-left: 48px;
  padding-right: 48px;
}
.full-page .footer .container {
  color: #ffffff;
}
.full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.full-page.pricing-page .description {
  margin-bottom: 65px;
  color: rgba(255, 255, 255, 0.7);
}
.full-page.register-page .info-horizontal {
  padding: 0px 0px 20px;
}
.full-page.register-page .info-horizontal {
  text-align: left !important;
}
.full-page.register-page .info-horizontal .icon {
  margin-top: 0;
}
.full-page.register-page .info-horizontal .icon > i {
  font-size: 2em;
}
.full-page.register-page .info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.full-page.register-page .info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.full-page.register-page .info-horizontal .description {
  overflow: hidden;
}
.full-page.register-page .info-horizontal .description .info-title {
  margin-bottom: 20px;
}
.full-page.pricing-page, .full-page.login-page, .full-page.lock-page, .full-page.register-page {
  min-height: 100vh;
  background: radial-gradient(#1e1e2f, #1e1e24);
}

@media (max-width: 767.98px) {
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
  .login-page .card-login .card-header img {
    width: 70%;
  }
}
@media (max-width: 575.98px) {
  .register-page .full-page > .content {
    padding-top: 50px;
  }
  .page-header .container h6.category-absolute {
    width: 90%;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .pricing-page .navbar .navbar-toggle .navbar-toggler,
.register-page .navbar .navbar-toggle .navbar-toggler,
.login-page .navbar .navbar-toggle .navbar-toggler,
.lock-page .navbar .navbar-toggle .navbar-toggler {
    display: none;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .register-page .full-page .content .card-register {
    margin-top: 3rem !important;
  }
}
@media (max-width: 991.98px) {
  .lock-page .navbar .navbar-wrapper .navbar-toggle,
.login-page .navbar .navbar-wrapper .navbar-toggle,
.pricing-page .navbar .navbar-wrapper .navbar-toggle,
.register-page .navbar .navbar-wrapper .navbar-toggle {
    display: none !important;
  }
}
.white-content {
  background: #fff;
}
.white-content .navbar.navbar-transparent .navbar-brand {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-toggler-bar {
  background: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item) {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item) i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-minimize button i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .search-bar.input-group i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .search-bar.input-group .form-control {
  color: #344675;
}
.white-content .navbar.navbar-transparent .search-bar.input-group .form-control::placeholder {
  color: #9A9A9A;
}
.white-content .sidebar {
  box-shadow: none !important;
}
.white-content .sidebar p {
  color: rgba(255, 255, 255, 0.8);
}
.white-content .main-panel {
  background: #f5f6fa;
}
.white-content h1, .white-content h2, .white-content h3, .white-content h4, .white-content h5, .white-content h6, .white-content p, .white-content ol li, .white-content ul li, .white-content pre {
  color: #1d253b;
}
.white-content .font-icon-detail i {
  color: #222a42;
}
.white-content .btn:not([data-action]):hover {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.white-content .btn-neutral.btn-link {
  color: rgba(34, 42, 66, 0.7);
}
.white-content .form-control::-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control:-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control::-webkit-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control:-ms-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .has-danger .form-control, .white-content .has-danger .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.white-content .input-group-prepend .input-group-text {
  border-color: rgba(29, 37, 59, 0.5);
  color: #1d253b;
}
.white-content .form-control {
  color: #222a42;
  border-color: rgba(29, 37, 59, 0.5);
}
.white-content .form-control:focus {
  border-color: #e14eca;
}
.white-content .form-group.no-border .form-control,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text,
.white-content .form-group.no-border .input-group-prepend .input-group-text,
.white-content .form-group.no-border .input-group-append .input-group-text,
.white-content .input-group.no-border .form-control,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text,
.white-content .input-group.no-border .input-group-prepend .input-group-text,
.white-content .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
}
.white-content .form-group.no-border .form-control:focus, .white-content .form-group.no-border .form-control:active, .white-content .form-group.no-border .form-control:active,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .form-group.no-border .input-group-prepend .input-group-text:focus,
.white-content .form-group.no-border .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .input-group-append .input-group-text:focus,
.white-content .form-group.no-border .input-group-append .input-group-text:active,
.white-content .form-group.no-border .input-group-append .input-group-text:active,
.white-content .input-group.no-border .form-control:focus,
.white-content .input-group.no-border .form-control:active,
.white-content .input-group.no-border .form-control:active,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .input-group.no-border .input-group-prepend .input-group-text:focus,
.white-content .input-group.no-border .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .input-group-append .input-group-text:focus,
.white-content .input-group.no-border .input-group-append .input-group-text:active,
.white-content .input-group.no-border .input-group-append .input-group-text:active {
  background-color: rgba(222, 222, 222, 0.5);
}
.white-content .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .white-content .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.white-content .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.white-content .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: transparent;
}
.white-content .input-group[disabled] .input-group-prepend .input-group-text,
.white-content .input-group[disabled] .input-group-append .input-group-text {
  background-color: #222a42;
}
.white-content .form-control[disabled], .white-content .form-control[readonly], .white-content fieldset[disabled] .form-control {
  background: #E3E3E3;
  border-color: rgba(29, 37, 59, 0.3);
}
.white-content .input-group-focus .input-group-prepend .input-group-text,
.white-content .input-group-focus .input-group-append .input-group-text,
.white-content .input-group-focus .form-control {
  border-color: #e14eca;
}
.white-content .input-group-focus.no-border .input-group-prepend .input-group-text,
.white-content .input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.white-content .input-group-prepend .input-group-text {
  border-right: none;
}
.white-content .input-group-append .input-group-text {
  border-left: none;
}
.white-content .has-danger .form-control:focus, .white-content .has-success.input-group-focus .input-group-append .input-group-text, .white-content .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.white-content .has-success .form-control:focus, .white-content .has-success.input-group-focus .input-group-append .input-group-text, .white-content .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #00bf9a;
}
.white-content .btn.btn-link:hover, .white-content .btn.btn-link:active, .white-content .btn.btn-link:focus {
  color: #9A9A9A !important;
}
.white-content .btn-group .btn.active {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.white-content .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label {
  background: #d3d7e9;
}
.white-content .bootstrap-switch-off:before {
  background: rgba(211, 215, 233, 0.5);
}
.white-content .card:not(.card-white).card-pricing, .white-content .card:not(.card-white).card-login, .white-content .card:not(.card-white).card-register {
  background: #27293d;
}
.white-content .card:not(.card-white).card-login .form-control::-moz-placeholder, .white-content .card:not(.card-white).card-register .form-control::-moz-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .card:not(.card-white).card-login .form-control:-moz-placeholder, .white-content .card:not(.card-white).card-register .form-control:-moz-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .card:not(.card-white).card-login .form-control::-webkit-input-placeholder, .white-content .card:not(.card-white).card-register .form-control::-webkit-input-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .card:not(.card-white).card-login .form-control:-ms-input-placeholder, .white-content .card:not(.card-white).card-register .form-control:-ms-input-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .card:not(.card-white).card-login .form-control, .white-content .card:not(.card-white).card-register .form-control {
  border-color: #2b3553;
}
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control,
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control + .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control + .input-group-append .input-group-text, .white-content .card:not(.card-white).card-register .form-group.no-border .form-control,
.white-content .card:not(.card-white).card-register .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-register .form-group.no-border .form-control + .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: #242c45;
}
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control:focus, .white-content .card:not(.card-white).card-login .form-group.no-border .form-control:active, .white-content .card:not(.card-white).card-login .form-group.no-border .form-control:active,
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control:focus,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control:active,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control:active,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control + .input-group-append .input-group-text:active, .white-content .card:not(.card-white).card-register .form-group.no-border .form-control:focus, .white-content .card:not(.card-white).card-register .form-group.no-border .form-control:active, .white-content .card:not(.card-white).card-register .form-group.no-border .form-control:active,
.white-content .card:not(.card-white).card-register .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .card:not(.card-white).card-register .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .card:not(.card-white).card-register .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .card:not(.card-white).card-register .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .card:not(.card-white).card-register .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .card:not(.card-white).card-register .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control:focus,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control:active,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control:active,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: #252e49;
}
.white-content .card:not(.card-white).card-login .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .white-content .card:not(.card-white).card-login .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-login .input-group.no-border .form-control:focus + .input-group-append .input-group-text, .white-content .card:not(.card-white).card-register .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .white-content .card:not(.card-white).card-register .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-register .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: #252e49;
}
.white-content .card:not(.card-white).card-login .form-group.no-border .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-login .form-group.no-border .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-login .input-group.no-border .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-login .input-group.no-border .input-group-append .input-group-text, .white-content .card:not(.card-white).card-register .form-group.no-border .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-register .form-group.no-border .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-register .input-group.no-border .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-register .input-group.no-border .input-group-append .input-group-text {
  background-color: #242c45;
}
.white-content .card:not(.card-white).card-login .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-login .input-group-prepend .input-group-text, .white-content .card:not(.card-white).card-register .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-register .input-group-prepend .input-group-text {
  border: 1px solid #2b3553;
  border-right: none;
  color: #ffffff;
}
.white-content .card:not(.card-white).card-login .input-group-focus .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-login .input-group-focus .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-login .input-group-focus .form-control, .white-content .card:not(.card-white).card-register .input-group-focus .input-group-prepend .input-group-text,
.white-content .card:not(.card-white).card-register .input-group-focus .input-group-append .input-group-text,
.white-content .card:not(.card-white).card-register .input-group-focus .form-control {
  border-color: #e14eca;
}
.white-content .card:not(.card-white).card-login .form-control, .white-content .card:not(.card-white).card-register .form-control {
  color: #ffffff;
}
.white-content .card:not(.card-white).card-login label, .white-content .card:not(.card-white).card-register label {
  color: rgba(255, 255, 255, 0.6);
}
.white-content .card:not(.card-white) {
  background-color: #ffffff;
  box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.05);
}
.white-content .card:not(.card-white) .card-header {
  color: #222a42;
}
.white-content .card:not(.card-white) .card-header a[data-toggle=collapse] {
  color: #222a42;
}
.white-content .card:not(.card-white) .card-header .card-title, .white-content .card:not(.card-white) .card-body .card-title {
  color: #1d253b;
}
.white-content .card:not(.card-white) .card-body .card-category, .white-content .card:not(.card-white) .card-body .card-description {
  color: #1d253b;
}
.white-content .card:not(.card-white) label:not(.btn) {
  color: #344675;
}
.white-content .card:not(.card-white) .pagination .page-item:not(.active) .page-link {
  color: #1d253b;
}
.white-content .card:not(.card-white) .pagination .page-item:not(.active) .page-link:hover {
  background: rgba(154, 154, 154, 0.1);
}
.white-content .card:not(.card-white):not(.card-wizard).nav-pills .nav-item .nav-link {
  color: #444444;
  background-color: hsla(0deg, 0%, 87%, 0.3);
}
.white-content .card:not(.card-white):not(.card-wizard).nav-pills .nav-item .nav-link:not(.active):hover {
  background: hsla(0deg, 0%, 87%, 0.5);
}
.white-content .card:not(.card-white):not(.card-wizard).nav-pills .nav-item .nav-link.active {
  color: #ffffff;
}
.white-content .card:not(.card-white) .tab-content .tab-pane {
  color: #444444;
}
.white-content .card:not(.card-white) .card {
  box-shadow: none;
}
.white-content .card:not(.card-white) .card-collapse .card .card-body {
  color: #9A9A9A;
}
.white-content .card:not(.card-white).card-contributions span {
  color: #9A9A9A;
}
.white-content .card:not(.card-white).card-contributions .bootstrap-switch-container span {
  color: #ffffff;
}
.white-content .card:not(.card-white).card-plain {
  background: transparent;
  box-shadow: none;
}
.white-content .card:not(.card-white).card-tasks .card-body i {
  color: rgba(34, 42, 66, 0.7);
}
.white-content .card:not(.card-white).card-tasks .card-body i:hover {
  color: #222a42;
}
.white-content .table > tbody > tr > td {
  color: rgba(34, 42, 66, 0.7) !important;
}
.white-content .table > thead > tr > th,
.white-content .table > tbody > tr > th,
.white-content .table > tfoot > tr > th,
.white-content .table > thead > tr > td,
.white-content .table > tbody > tr > td,
.white-content .table > tfoot > tr > td {
  border-color: rgba(34, 42, 66, 0.2);
  padding: 12px 7px;
  vertical-align: middle;
  border: solid 1px rgba(34, 42, 66, 0.2);
}
.white-content .table > thead > tr:hover, .white-content .table > tbody > tr:hover {
  background-color: #ddd;
}
.white-content .table > thead > tr > th, .white-content .table button.btn-neutral.btn-link {
  color: rgba(34, 42, 66, 0.7);
}
.white-content .footer ul li a {
  color: #1d253b;
}
.white-content .footer .copyright {
  color: #1d253b;
}
.white-content .progress-container .progress, .white-content .progress-container.progress.sm .progress {
  background: rgba(34, 42, 66, 0.1);
  box-shadow: 0 0 0 3px rgba(34, 42, 66, 0.1);
}
.white-content .progress-container .progress .progress-value, .white-content .progress-container.progress.sm .progress .progress-value {
  color: #344675;
}
.white-content .progress-container .progress-badge, .white-content .progress-container.progress.sm .progress-badge {
  color: #1d253b;
}
.white-content .bootstrap-select button.dropdown-toggle {
  border-color: rgba(29, 37, 59, 0.5);
}
.white-content .bootstrap-select button.dropdown-toggle .filter-option {
  color: #1d253b;
}
.white-content .bootstrap-select button.dropdown-toggle:after {
  color: #1d253b;
}
.white-content .fc-basic-view .fc-day-number, .white-content .fc-basic-view .fc-week-number {
  padding: 2px;
  color: #344675;
}
.white-content .fc-unthemed .fc-today {
  background: #d3d7e9;
}
.white-content .fc-unthemed .fc-content, .white-content .fc-unthemed .fc-divider, .white-content .fc-unthemed .fc-list-heading td, .white-content .fc-unthemed .fc-list-view, .white-content .fc-unthemed .fc-popover, .white-content .fc-unthemed .fc-row, .white-content .fc-unthemed tbody, .white-content .fc-unthemed td, .white-content .fc-unthemed th, .white-content .fc-unthemed thead {
  border-color: #9499a7;
}
.white-content .fc-prev-button, .white-content .fc-next-button {
  color: #344675;
}
.white-content .fc-prev-button:hover, .white-content .fc-next-button:hover {
  color: #344675;
}
.white-content .fc button.btn-primary:not([data-action]):hover, .white-content .fc button:not([data-action]):hover {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.white-content .full-page {
  background: #f5f6fa;
}
.white-content .full-page h1, .white-content .full-page h2, .white-content .full-page h3, .white-content .full-page h4, .white-content .full-page h5, .white-content .full-page h6, .white-content .full-page p, .white-content .full-page ol li, .white-content .full-page ul li, .white-content .full-page pre {
  color: #1d253b;
}
.white-content .full-page .description {
  color: #9A9A9A;
}
.white-content .full-page .footer ul li a {
  color: #1d253b;
}
.white-content .full-page .footer .copyright {
  color: #1d253b;
}
.white-content .nav-pills .nav-item .nav-link:not(.active) {
  background: #d3d7e9;
  color: #1d253b;
}
.white-content .nav-pills .nav-item .nav-link:not(.active):hover {
  background: #cccccc;
}
.white-content .card-pricing:not(.card-white) ul li {
  color: #ffffff;
}
.white-content .card:not(.card-pricing).card-wizard .card-body {
  background: #ffffff;
}
.white-content .card:not(.card-pricing).card-wizard .card-footer {
  background-color: #ffffff !important;
}
.white-content .card:not(.card-pricing).card-wizard .nav-pills .nav-item .nav-link p {
  color: #1d253b;
}
.white-content .card:not(.card-pricing).card-stats hr {
  border-color: rgba(29, 37, 59, 0.1);
}
.white-content .card:not(.card-pricing).card-stats .card-title {
  color: #1d253b;
}
.white-content .card:not(.card-pricing).card-stats .card-category, .white-content .card:not(.card-pricing).card-stats .stats {
  color: #808080;
}
.white-content .card-timeline .timeline > li.timeline-inverted > .timeline-panel {
  background: #ffffff;
}
.white-content .card-timeline .timeline > li.timeline-inverted > .timeline-panel .timeline-body p {
  color: #1d253b;
}
.white-content .card-timeline .timeline > li.timeline-inverted > .timeline-panel:after, .white-content .card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {
  border-right-color: #ffffff;
  border-left-color: #ffffff;
}
.white-content .card-timeline .timeline:before {
  background-color: #E3E3E3;
}

.card {
  background: #27293d;
  border: 0;
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.card label {
  color: rgba(255, 255, 255, 0.6);
}
.card .card-title {
  margin-bottom: 0.75rem;
}
.card .card-body {
  padding: 15px;
}
.card .card-body.table-full-width {
  padding-left: 0;
  padding-right: 0;
}
.card .card-body .card-title {
  color: #ffffff;
  text-transform: inherit;
  font-weight: 300;
  margin-bottom: 0.75rem;
}
.card .card-body .card-description, .card .card-body .card-category {
  color: rgba(255, 255, 255, 0.6);
}
.card .card-header {
  padding: 15px 15px 0;
  border: 0;
  color: rgba(255, 255, 255, 0.8);
}
.card .card-header:not([data-background-color]) {
  background-color: transparent;
}
.card .card-header .card-title {
  color: #ffffff;
  font-weight: 100;
}
.card .card-header .card-category {
  color: #9A9A9A;
  margin-bottom: 5px;
  font-weight: 300;
}
.card .map {
  border-radius: 0.2857rem;
}
.card .map.map-big {
  height: 420px;
}
.card.card-white {
  background: #ffffff;
}
.card.card-white .card-title {
  color: #222a42;
}
.card.card-white .card-category, .card.card-white .stats {
  color: #808080;
}
.card.card-white .form-control::-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control:-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control::-webkit-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control:-ms-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .has-danger .form-control, .card.card-white .has-danger .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.card.card-white .input-group-prepend .input-group-text {
  border-color: rgba(29, 37, 59, 0.2);
  color: #1d253b;
}
.card.card-white .form-control {
  color: #222a42;
  border-color: rgba(29, 37, 59, 0.2);
}
.card.card-white .form-control:focus {
  border-color: #e14eca;
}
.card.card-white label:not(.btn) {
  color: #344675;
}
.card.card-white .form-group.no-border .form-control,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text,
.card.card-white .form-group.no-border .input-group-append .input-group-text,
.card.card-white .input-group.no-border .form-control,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
}
.card.card-white .form-group.no-border .form-control:focus, .card.card-white .form-group.no-border .form-control:active, .card.card-white .form-group.no-border .form-control:active,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:focus,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .input-group-append .input-group-text:focus,
.card.card-white .form-group.no-border .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .form-control:focus,
.card.card-white .input-group.no-border .form-control:active,
.card.card-white .input-group.no-border .form-control:active,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:focus,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .input-group-append .input-group-text:focus,
.card.card-white .input-group.no-border .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .input-group-append .input-group-text:active {
  background-color: rgba(222, 222, 222, 0.5);
}
.card.card-white .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .card.card-white .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.card.card-white .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: transparent;
}
.card.card-white .input-group[disabled] .input-group-prepend .input-group-text,
.card.card-white .input-group[disabled] .input-group-append .input-group-text {
  background-color: #222a42;
}
.card.card-white .form-control[disabled], .card.card-white .form-control[readonly], .card.card-white fieldset[disabled] .form-control {
  background: #E3E3E3;
  border-color: rgba(29, 37, 59, 0.3);
}
.card.card-white .input-group-focus .input-group-prepend .input-group-text,
.card.card-white .input-group-focus .input-group-append .input-group-text,
.card.card-white .input-group-focus .form-control {
  background-color: #ffffff;
  border-color: #e14eca;
}
.card.card-white .input-group-focus.no-border .input-group-prepend .input-group-text,
.card.card-white .input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.card.card-white .input-group-prepend .input-group-text {
  border-right: none;
}
.card.card-white .input-group-append .input-group-text {
  border-left: none;
}
.card.card-white .has-danger .form-control:focus, .card.card-white .has-success.input-group-focus .input-group-append .input-group-text, .card.card-white .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.card.card-white .has-success .form-control:focus, .card.card-white .has-success.input-group-focus .input-group-append .input-group-text, .card.card-white .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #00bf9a;
}
.card.card-plain {
  background: transparent;
  box-shadow: none;
}
.card .image {
  overflow: hidden;
  height: 200px;
  position: relative;
}
.card .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
.card label {
  font-size: 0.7500000025rem;
  margin-bottom: 5px;
}
.card .card-footer {
  background-color: transparent;
  border: 0;
  padding: 15px;
}
.card .card-footer .stats i {
  margin-right: 5px;
  position: relative;
}
.card .card-footer h6 {
  margin-bottom: 0;
  padding: 7px 0;
}

.card-body {
  padding: 1.25rem;
}

.card-chart {
  overflow: hidden;
}
.card-chart .card-header .card-title i {
  font-size: 16px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.card-chart .card-header .card-category {
  margin-bottom: 5px;
}
.card-chart .card-body {
  padding-left: 5px;
  padding-right: 5px;
}
.card-chart .card-body .tab-space {
  padding: 0;
}
.card-chart .table {
  margin-bottom: 0;
}
.card-chart .table td {
  border-top: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.card-chart .card-progress {
  margin-top: 30px;
  padding: 0 10px;
}
.card-chart .chart-area {
  height: 220px;
  width: 100%;
}
.card-chart .card-footer {
  margin-top: 15px;
}
.card-chart .card-footer .stats {
  color: #9A9A9A;
}
.card-chart .dropdown {
  position: absolute;
  right: 20px;
  top: 20px;
}
.card-chart .dropdown .btn {
  margin: 0;
}
.card-chart.card-chart-pie .chart-area {
  padding: 10px 0 25px;
  height: auto;
}
.card-chart.card-chart-pie .card-title {
  margin-bottom: 10px;
}
.card-chart.card-chart-pie .card-title i {
  font-size: 1rem;
}

@media (max-width: 767.98px) {
  .card.card-chart .card-header .btn-group-toggle .tim-icons {
    font-size: 0.875rem;
    top: -1px;
  }
}
.map {
  height: 500px;
}

.card-user {
  overflow: hidden;
}
.card-user .image {
  height: 120px;
}
.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: 25px;
}
.card-user .author a + p.description {
  margin-top: -7px;
}
.card-user .author .block {
  position: absolute;
  height: 100px;
  width: 250px;
}
.card-user .author .block.block-one {
  background: rgba(225, 78, 202, 0.6);
  background: linear-gradient(to right, rgba(225, 78, 202, 0.6) 0%, rgba(225, 78, 202, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(150deg);
  margin-top: -90px;
  margin-left: -50px;
}
.card-user .author .block.block-two {
  background: rgba(225, 78, 202, 0.6);
  background: linear-gradient(to right, rgba(225, 78, 202, 0.6) 0%, rgba(225, 78, 202, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(30deg);
  margin-top: -40px;
  margin-left: -100px;
}
.card-user .author .block.block-three {
  background: rgba(225, 78, 202, 0.6);
  background: linear-gradient(to right, rgba(225, 78, 202, 0.6) 0%, rgba(225, 78, 202, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(170deg);
  margin-top: -70px;
  right: -45px;
}
.card-user .author .block.block-four {
  background: rgba(225, 78, 202, 0.6);
  background: linear-gradient(to right, rgba(225, 78, 202, 0.6) 0%, rgba(225, 78, 202, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(150deg);
  margin-top: -25px;
  right: -45px;
}
.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 5px solid #2b3553;
  border-bottom-color: transparent;
  background-color: transparent;
  position: relative;
}
.card-user .card-body {
  min-height: 240px;
}
.card-user hr {
  margin: 5px 15px;
}
.card-user .button-container {
  margin-bottom: 6px;
  text-align: center;
}
.card-user .card-description {
  margin-top: 30px;
}

.card-tasks {
  height: 473px;
}
.card-tasks .table-full-width {
  max-height: 410px;
  position: relative;
}
.card-tasks .card-header .title {
  margin-right: 20px;
  font-weight: 400;
}
.card-tasks .card-header .dropdown {
  float: right;
  color: #cccccc;
}
.card-tasks .card-body i {
  color: #9A9A9A;
  font-size: 1.4em;
}
.card-tasks .card-body i:hover {
  color: #ffffff;
}

.card-animation-on-hover {
  transition: all 0.3s cubic-bezier(0.34, 1.61, 0.7, 1);
}
.card-animation-on-hover:hover {
  transform: translate3d(0, -5px, 0);
}

.card-collapse .card {
  margin-bottom: 0px;
  background: transparent;
  box-shadow: none;
}
.card-collapse .card .card-header {
  position: relative;
  padding: 1rem 0.75rem;
}
.card-collapse .card .card-header a[data-toggle=collapse] {
  display: block;
  color: rgba(255, 255, 255, 0.6);
}
.card-collapse .card .card-header a[data-toggle=collapse] i {
  float: right;
  position: relative;
  color: #e14eca;
  top: 1px;
}
.card-collapse .card .card-header:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}
.card-collapse .card .card-body {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  color: rgba(255, 255, 255, 0.5);
}
.card-collapse .card:last-child .card-header:after {
  content: none;
}

.card-contributions .card-description {
  max-width: 350px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.card-contributions .card-title {
  padding-top: 35px;
}
.card-contributions .card-stats {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 11px;
}
.card-contributions .card-footer [class*=col-]:not(:first-child):before {
  content: "";
  position: absolute;
  left: 0;
  width: 1px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}
.card-contributions .bootstrap-switch {
  margin: 0;
}
.card-contributions span {
  padding-left: 15px;
  text-align: left;
  max-width: 125px;
  color: rgba(255, 255, 255, 0.6);
}

@media (max-width: 575.98px) {
  .card-contributions .card-stats {
    flex-direction: column;
  }
  .card-contributions .card-stats .bootstrap-switch {
    margin-bottom: 15px;
  }
}
.card-lock .card-header img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-top: -60px;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

@media (min-width: 576px) {
  .card.card-lock {
    margin-top: 13vh;
  }
}
.card-pricing {
  position: relative;
  z-index: 1;
  box-shadow: none;
  min-height: 400px;
}
.card-pricing .card-body {
  overflow: hidden;
  padding: 0;
}
.card-pricing .card-body .card-title {
  position: relative;
  font-size: 5em;
  font-weight: 900;
  color: #222a42;
  text-transform: lowercase;
  margin-left: -5px;
  z-index: 1;
}
.card-pricing .card-body .card-title.card-title-right {
  text-align: right;
  margin-right: -5px;
}
.card-pricing .card-body img {
  position: absolute;
  border-radius: 0.2857rem;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
}
.card-pricing .card-body .card-prices .text-on-front {
  position: relative;
  z-index: 2;
  color: rgba(255, 255, 255, 0.9);
  font-size: 3.6em;
  font-weight: 900;
  text-align: center;
}
.card-pricing .card-body .card-prices .text-on-front span {
  font-size: 0.7em;
}
.card-pricing .card-body .card-prices .text-on-back {
  position: relative;
  z-index: 1;
  font-size: 9.5em;
  text-align: center;
  margin-top: -160px;
  font-weight: 900;
  color: rgba(38, 49, 72, 0.1);
}
.card-pricing .card-body .card-prices .plan {
  font-weight: 600;
  font-size: 0.8em;
  margin-top: -80px;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
}
.card-pricing ul {
  list-style: none;
  padding: 0;
  max-width: 240px;
  margin: 80px auto 40px;
}
.card-pricing ul li {
  color: rgba(255, 255, 255, 0.9);
  background: transparent;
  text-align: center;
  font-size: 1.2em;
  font-weight: 600;
  padding: 5px 0;
  border: none;
}
.card-pricing.card-white {
  background: #ffffff;
}
.card-pricing.card-white .card-body .card-title {
  color: white;
}
.card-pricing.card-white .card-body .card-prices .text-on-front, .card-pricing.card-white .card-body .card-prices .plan {
  color: #263148;
}
.card-pricing.card-white .card-body .card-prices .text-on-front span, .card-pricing.card-white .card-body .card-prices .plan span {
  color: #263148;
}
.card-pricing.card-white ul li {
  color: #263148;
}
.card-pricing.card-white .list-group-item {
  background: transparent;
}
.card-pricing.card-primary .card-body .card-prices .text-on-back {
  color: rgba(225, 78, 202, 0.1);
}
.card-pricing.card-info .text-on-back {
  color: rgba(29, 140, 248, 0.1);
}
.card-pricing.card-success .card-body .card-prices .text-on-back {
  color: rgba(0, 242, 195, 0.1);
}
.card-pricing.card-warning .card-body .card-prices .text-on-back {
  color: rgba(255, 141, 114, 0.1);
}
.card-pricing.card-danger .card-body .card-prices .text-on-back {
  color: rgba(253, 93, 147, 0.1);
}
.card-pricing.card-raised {
  z-index: 3;
  box-shadow: 0px 0px 40px 15px rgba(38, 49, 72, 0.3);
  padding: 20px 0;
  margin-top: -20px;
  border-radius: 0.2857rem;
}
.card-pricing.card-raised img {
  border-radius: 0.2857rem;
}

@media (min-width: 768px) {
  .pricing-page [class*=col-]:first-child {
    padding-right: 0;
  }
  .pricing-page [class*=col-]:first-child .card:not(.card-raised) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .pricing-page [class*=col-]:not(:first-child):not(:last-child) {
    padding: 0;
  }
  .pricing-page [class*=col-]:not(:first-child):not(:last-child) .card:not(.card-raised) {
    border-radius: 0;
  }
  .pricing-page [class*=col-]:not(:first-child):not(:last-child) .card:not(.card-raised) img {
    border-radius: 0;
  }
  .pricing-page [class*=col-]:last-child {
    padding-left: 0;
  }
  .pricing-page [class*=col-]:last-child .card:not(.card-raised) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.card-testimonial, .card-profile {
  margin-top: 30px;
  text-align: center;
}
.card-testimonial .card-body .card-title, .card-profile .card-body .card-title {
  margin-top: 0;
}
.card-testimonial [class*=col-] .card-description, .card-profile [class*=col-] .card-description {
  margin-bottom: 0;
}
.card-testimonial [class*=col-] .card-description + .card-footer, .card-profile [class*=col-] .card-description + .card-footer {
  margin-top: 8px;
}
.card-testimonial .card-header-avatar, .card-profile .card-header-avatar {
  max-width: 130px;
  max-height: 130px;
  margin: -60px auto 0;
}
.card-testimonial .card-header-avatar img, .card-profile .card-header-avatar img {
  border-radius: 50% !important;
}
.card-testimonial .card-header-avatar + .card-body, .card-profile .card-header-avatar + .card-body {
  margin-top: 15px;
}
.card-plain.card-testimonial .card-header-avatar, .card-plain.card-profile .card-header-avatar {
  margin-top: 0;
}
.card-testimonial .card-body .card-avatar, .card-profile .card-body .card-avatar {
  margin: 0 auto 30px;
}

.card-plain {
  background: transparent;
  box-shadow: none;
}
.card-plain .card-header,
.card-plain .card-footer {
  margin-left: 0;
  margin-right: 0;
  background-color: transparent;
}
.card-plain:not(.card-subcategories).card-body {
  padding-left: 0;
  padding-right: 0;
}

.card-register {
  overflow: hidden;
}
.card-register .header {
  margin-left: 20px;
  margin-right: 20px;
  padding: 30px 0;
}
.card-register .text-divider {
  margin-top: 30px;
  margin-bottom: 0px;
  text-align: center;
}
.card-register .content {
  padding: 0px 30px;
}
.card-register .form-check {
  margin-top: 20px;
  margin-left: 20px;
}
.card-register .form-check label:not(.form-check-label) {
  padding-left: 38px;
}
.card-register .card-header {
  padding: 0 0 50px;
  overflow: hidden;
}
.card-register .card-header .card-title {
  position: relative;
  font-size: 5em;
  font-weight: 900;
  color: #222a42;
  text-transform: lowercase;
  margin-left: -5px;
  z-index: 1;
}
.card-register .card-img {
  position: absolute;
  left: 0;
  top: -15%;
  width: 70%;
}
.card-register .social-line {
  margin-top: 20px;
  text-align: center;
}
.card-register .social-line .btn.btn-icon,
.card-register .social-line .btn.btn-icon .btn-icon {
  margin-left: 5px;
  margin-right: 5px;
  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);
}
.card-register .card-footer {
  margin-bottom: 10px;
  margin-top: 24px;
}
.card-register.card-white .card-header .card-title {
  color: #ffffff;
}

@media (max-width: 991.98px) {
  .card.card-register .card-img {
    width: 95%;
  }
}
.card-stats hr, .card-contributions hr {
  margin: 5px 15px;
}

.card-stats .info-icon {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
}
.card-stats .info-icon i {
  color: #ffffff;
  font-size: 1.7em;
  padding: 14px 13px;
}
.card-stats .info-icon.icon-danger {
  background: #fd5d93;
  background-image: linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93);
  background-size: 210% 210%;
  background-position: top right;
}
.card-stats .info-icon.icon-warning {
  background: #ff8d72;
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72);
  background-size: 210% 210%;
  background-position: top right;
}
.card-stats .info-icon.icon-success {
  background: #00f2c3;
  background-image: linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3);
  background-size: 210% 210%;
  background-position: top right;
}
.card-stats .info-icon.icon-info {
  background: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: top right;
}
.card-stats .info-icon.icon-primary {
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
}
.card-stats .numbers {
  text-align: right;
}
.card-stats .numbers .card-title {
  margin-top: 0;
}
.card-stats .numbers .card-category {
  margin-bottom: 0;
  color: #9A9A9A;
}
.card-stats .card-footer {
  padding: 0;
}
.card-stats hr {
  border-color: #2b3553;
}
.card-stats .stats {
  color: rgba(255, 255, 255, 0.6);
  margin: 10px 15px;
  font-size: 0.9em;
}
.card-stats.card-white hr {
  border-color: rgba(43, 53, 83, 0.2);
}

@media (max-width: 767.98px) {
  .card-stats [class*=col-] .statistics::after {
    display: none;
  }
}
.card-subcategories .card-body {
  padding-bottom: 30px;
}

.card-testimonial .card-body {
  padding-top: 25px;
}
.card-testimonial .card-description + .card-title {
  margin-top: 20px;
}
.card-testimonial .card-footer {
  margin-top: 0;
  margin-bottom: 2.5rem;
}
.card-testimonial .card-description + .card-title {
  margin-top: 30px;
}
.card-testimonial .icon i {
  font-size: 32px;
}
.card-testimonial .icon.icon-primary i {
  color: #e14eca;
}
.card-testimonial .icon.icon-info i {
  color: #1d8cf8;
}
.card-testimonial .icon.icon-danger i {
  color: #fd5d93;
}
.card-testimonial .icon.icon-warning i {
  color: #ff8d72;
}
.card-testimonial .icon.icon-success i {
  color: #00f2c3;
}

.card-wizard .card-header {
  padding-bottom: 10px;
}

@media (max-width: 575.98px) {
  .card-wizard .card-footer .pull-left {
    padding-left: 0;
    float: none;
    text-align: center;
  }
  .card-wizard .card-footer .pull-right {
    padding-right: 0;
    float: none;
    text-align: center;
  }
}
.noUi-vertical {
  width: 1px;
  height: 100%;
}
.noUi-vertical .noUi-handle {
  outline: none;
  border-radius: 50%;
  height: 15px;
  width: 15px;
  cursor: pointer;
  left: -7px;
  top: -10px;
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full,
.rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis,
.rbc-event-label,
.rbc-row-segment .rbc-event-content,
.rbc-show-more {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: #333333;
  opacity: 0.3;
}

.rbc-header,
.rbc-header > a,
.rbc-header > a:active,
.rbc-header > a:visited,
.rbc-header > a:hover,
.rbc-time-gutter.rbc-time-column {
  overflow: hidden;
  flex: 1 0;
  text-overflow: ellipsis;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em;
  color: rgba(255, 255, 255, 0.4);
  box-sizing: content-box;
  text-align: right;
  font-weight: bold;
  line-height: 1.5;
  text-decoration: none;
}
.rbc-header:last-child span,
.rbc-header > a:last-child span,
.rbc-header > a:active:last-child span,
.rbc-header > a:visited:last-child span,
.rbc-header > a:hover:last-child span,
.rbc-time-gutter.rbc-time-column:last-child span {
  padding-right: 15px;
}
.rbc-header .rbc-time-slot,
.rbc-header > a .rbc-time-slot,
.rbc-header > a:active .rbc-time-slot,
.rbc-header > a:visited .rbc-time-slot,
.rbc-header > a:hover .rbc-time-slot,
.rbc-time-gutter.rbc-time-column .rbc-time-slot {
  font-weight: 400;
}

.rbc-row-content {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
  min-height: 173px;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  font-size: 16px;
}

.rbc-toolbar .rbc-toolbar-label {
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
  margin: 0;
  font-size: 1.8em;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  font-family: inherit;
  line-height: 1.2;
}

.rbc-toolbar button {
  border-width: 2px;
  font-weight: 400;
  font-size: 0.7500000025rem;
  line-height: 1.35em;
  margin: 5px 1px;
  border: none;
  margin: 10px 1px;
  border-radius: 0.2857rem;
  padding: 8px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
  text-transform: lowercase;
  background: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #1d8cf8;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.rbc-toolbar button::-moz-focus-inner {
  border: 0;
}
.rbc-toolbar button.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.rbc-toolbar button:hover, .rbc-toolbar button:focus, .rbc-toolbar button:active, .rbc-toolbar button.active, .rbc-toolbar button:active:focus, .rbc-toolbar button:active:hover, .rbc-toolbar button.active:focus, .rbc-toolbar button.active:hover {
  background-color: #3358f4 !important;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-image: -moz-linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  color: #ffffff;
  box-shadow: none;
}
.rbc-toolbar button:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.rbc-toolbar button:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.rbc-toolbar button.disabled, .rbc-toolbar button.disabled:hover, .rbc-toolbar button.disabled:focus, .rbc-toolbar button.disabled.focus, .rbc-toolbar button.disabled:active, .rbc-toolbar button.disabled.active, .rbc-toolbar button:disabled, .rbc-toolbar button:disabled:hover, .rbc-toolbar button:disabled:focus, .rbc-toolbar button:disabled.focus, .rbc-toolbar button:disabled:active, .rbc-toolbar button:disabled.active, .rbc-toolbar button[disabled], .rbc-toolbar button[disabled]:hover, .rbc-toolbar button[disabled]:focus, .rbc-toolbar button[disabled].focus, .rbc-toolbar button[disabled]:active, .rbc-toolbar button[disabled].active, fieldset[disabled] .rbc-toolbar button, fieldset[disabled] .rbc-toolbar button:hover, fieldset[disabled] .rbc-toolbar button:focus, fieldset[disabled] .rbc-toolbar button.focus, fieldset[disabled] .rbc-toolbar button:active, fieldset[disabled] .rbc-toolbar button.active {
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.rbc-toolbar button.btn-simple {
  color: #1d8cf8;
  border-color: #1d8cf8;
  background: transparent;
}
.rbc-toolbar button.btn-simple:hover, .rbc-toolbar button.btn-simple:focus, .rbc-toolbar button.btn-simple:active, .rbc-toolbar button.btn-simple:not(:disabled):not(.disabled):active {
  color: #1d8cf8;
  border-color: #1d8cf8;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.rbc-toolbar button.btn-simple.active {
  border-color: #1d8cf8 !important;
}
.rbc-toolbar button.btn-simple.active:hover, .rbc-toolbar button.btn-simple.active:focus, .rbc-toolbar button.btn-simple.active:active, .rbc-toolbar button.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-image: -moz-linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-color: #3358f4 !important;
  box-shadow: none;
}
.rbc-toolbar button.btn-link {
  color: #1d8cf8;
}
.rbc-toolbar button.btn-link:hover, .rbc-toolbar button.btn-link:focus, .rbc-toolbar button.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.rbc-toolbar button:focus {
  outline: none;
}

.rbc-btn-group {
  display: inline-block;
}
.rbc-btn-group:last-child button:not(.rbc-active):not(:hover) {
  opacity: 0.5;
}

.rbc-btn-group button {
  margin: 0 0 0 2px;
}

@media screen and (max-width: 526px) {
  .rbc-btn-group button {
    margin: 2px !important;
  }
}
.rbc-btn-group button + button {
  margin: 0 0 0 2px;
}

.rbc-btn-group + .rbc-btn-group,
.rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-slot-selecting .rbc-event {
  cursor: inherit;
  pointer-events: none;
}

.rbc-event.rbc-selected {
  background-color: #265985;
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-after {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-prior {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 2px 6px 1px;
}

.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
  border-left: none;
  border-right: none;
}

.rbc-month-view {
  border-top: none;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  -ms-flex-preferred-size: 0px;
  overflow: hidden;
  height: 100%;
}

.rbc-month-row {
  border-style: solid;
  border-width: 1px;
  padding: 0;
  vertical-align: top;
  border-color: #2b3553;
  border-bottom: 0;
  border-right: 0;
  border-left: 0;
}

.rbc-date-cell {
  flex: 1 1;
  min-width: 0;
  padding-right: 3px;
  padding-top: 1px;
  text-align: right;
}

.rbc-date-cell.rbc-now {
  font-weight: bold;
}

.rbc-date-cell > a,
.rbc-date-cell > a:active,
.rbc-date-cell > a:visited {
  color: white;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}

.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #2b3553;
}

.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #2b3553;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}

.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}

.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #2b3553;
  border-spacing: 0;
  border-collapse: collapse;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}

.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #2b3553;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #2b3553;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #2b3553;
}

.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #2b3553;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
  color: rgba(255, 255, 255, 0.6);
}

.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}

.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell {
  color: rgba(255, 255, 255, 0.8);
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
  color: rgba(255, 255, 255, 0.8);
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
  box-sizing: border-box;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #2b3553;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}

.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 10px;
  top: 0;
}

.rbc-day-slot .rbc-events-container.rbc-is-rtl {
  left: 10px;
  right: 0;
}

.rbc-day-slot .rbc-event {
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}

.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
  font-weight: bold;
  box-sizing: content-box;
  color: #fff;
  white-space: nowrap;
  text-align: end;
}

.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}

.rbc-day-slot .rbc-time-slot + .rbc-time-slot {
  border-top: 1px dotted #2b3553;
}

.rbc-time-slot {
  flex: 1 0;
}

.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 75%;
  width: 100%;
  padding: 3px;
}

.rbc-slot-selecting {
  cursor: move;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  min-height: 0;
  border-left: none;
  border-right: none;
  border-top: none;
}

.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}

.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  position: relative;
}

.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}

.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
}

.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #ddd;
}

.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #ddd;
}

.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #ddd;
}

.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #ddd;
}

.rbc-time-header-content {
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  border-left: 1px solid #2b3553;
}

.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
  border-right: 1px solid #2b3553;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 3px solid #344675;
  overflow-y: auto;
  position: relative;
}

.rbc-time-content > .rbc-time-gutter {
  flex: none;
}

.rbc-time-content > * + * > * {
  border-left: 1px solid #2b3553;
}

.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #2b3553;
}

.rbc-time-content > .rbc-day-slot {
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  height: 1px;
  background-color: #74ad31;
  pointer-events: none;
}

.rbc-event {
  width: 100%;
  position: relative; /* for resize handle and other inner positioning */
  display: block; /* make the <a> tag block */
  font-size: 0.85em;
  border-radius: 2px;
  padding: 0;
  background-color: #344675; /* default BACKGROUND color */
  font-weight: normal; /* undo jqui's ui-widget-header bold */
  text-align: left;
  border: none;
  padding-bottom: 1px;
  line-height: 1.2;
}
.rbc-event.event-azure {
  background-color: #1d8cf8;
}
.rbc-event.event-green {
  background-color: #00bf9a;
}
.rbc-event.event-orange {
  background-color: #ff8d72;
}
.rbc-event.event-red {
  background-color: #fd5d93;
}
.rbc-event .rbc-event-content {
  position: relative;
  z-index: 2;
  white-space: nowrap;
  overflow: hidden;
  color: white;
  padding: 0 5px;
  text-align: right;
}

.rbc-day-slot .rbc-event {
  display: block !important;
  max-height: none !important;
  max-height: initial !important;
}

.rbc-today {
  background-color: #252e49;
}

@media screen and (max-width: 1373px) {
  .rbc-toolbar {
    display: block;
  }
  .rbc-toolbar .rbc-btn-group {
    display: block;
    text-align: center;
  }
  .rbc-toolbar .rbc-toolbar-label {
    display: block;
    flex-grow: initial;
    padding: 0;
  }
}
.rbc-row.rbc-time-header-cell {
  border-bottom: 1px solid #2b3553;
}

.rbc-time-view .rbc-row-content {
  min-height: 0;
  min-height: initial;
}

.perfect-scrollbar-on .rbc-calendar .rbc-row-content {
  min-height: 115px;
}

@media (max-width: 767.98px) {
  .rbc-calendar .rbc-row-content {
    min-height: 45px;
  }
}
@media (max-width: 991.98px) {
  .rbc-calendar .rbc-row-content {
    min-height: 90px;
  }
}
.sweet-alert {
  padding: 40px 20px !important;
  margin: auto !important;
}
.sweet-alert h2,
.sweet-alert h2 * {
  color: #595959;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 0 0 0.4em;
  padding: 0;
  display: block;
  word-wrap: break-word;
}
.sweet-alert .lead {
  font-size: 18px;
  text-align: center;
  font-weight: 300;
  position: relative;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
  color: #545454 !important;
  word-wrap: break-word;
}
.sweet-alert input.form-control {
  color: black;
}

/* ========================================================================
 * bootstrap-switch - v3.3.4
 * http://www.bootstrap-switch.org
 * ========================================================================
 * Copyright 2012-2013 Mattia Larentis
 * http://www.apache.org/licenses/LICENSE-2.0
 */
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.13);
  margin-bottom: 10px;
  line-height: 8px;
  width: 59px !important;
  height: 22px;
  outline: none;
  z-index: 0;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  background: url("https://d2v9y0dukr6mq2.cloudfront.net/video/thumbnail/J9H9WF0/night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png");
  background-position: center center;
  background-size: cover;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 22px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  line-height: 11px;
  width: 50% !important;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-brown,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-brown {
  color: #fff;
  background: #e14eca;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-blue,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-blue {
  color: #fff;
  background: #1d8cf8;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-green,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-green {
  color: #fff;
  background: #00f2c3;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-orange,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-orange {
  background: #ff8d72;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-red,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-red {
  color: #fff;
  background: #fd5d93;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 18px !important;
  height: 18px !important;
  margin: 0px -11px;
  border-radius: 20px;
  position: absolute;
  float: left;
  top: 2px;
  left: 51%;
  padding: 0;
  box-shadow: 0 1px 11px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label {
  background-color: rgba(156, 156, 156, 0.9);
  left: 52%;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 27px !important;
  margin-left: -20px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 27px !important;
  margin-left: -11px;
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type=radio].form-control,
.bootstrap-switch input[type=checkbox].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -39px !important;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label:before {
  background-color: #ffffff;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-red ~ .bootstrap-switch-default {
  background-color: #fd5d93;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-orange ~ .bootstrap-switch-default {
  background-color: #ff8d72;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-green ~ .bootstrap-switch-default {
  background-color: #00f2c3;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-brown ~ .bootstrap-switch-default {
  background-color: #e14eca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-blue ~ .bootstrap-switch-default {
  background-color: #1d8cf8;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-red,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-brown,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-blue,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-orange,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-green {
  background-color: #E3E3E3;
}

.bootstrap-switch-on .bootstrap-switch-handle-off,
.bootstrap-switch-off .bootstrap-switch-handle-on {
  opacity: 0;
  visibility: hidden;
}

.bootstrap-switch-off:before {
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  background: rgba(16, 16, 16, 0.7);
}

.bootstrap-switch.wrapper {
  height: auto;
  height: initial;
}

.card-wizard {
  min-height: 410px;
  background: transparent !important;
  box-shadow: none !important;
  opacity: 0;
  transition: 300ms, linear;
}
@media (prefers-reduced-motion: reduce) {
  .card-wizard {
    transition: none;
  }
}
.card-wizard.active {
  opacity: 1;
}
.card-wizard .progress-with-circle .progress-bar {
  background: #e14eca;
}
.card-wizard .nav-pills .nav-item .nav-link {
  color: #e14eca;
}
.card-wizard .nav-pills .nav-item .nav-link.checked, .card-wizard .nav-pills .nav-item .nav-link.active {
  background: #e14eca;
  color: white;
}
.card-wizard .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  background: #e14eca;
}
.card-wizard .card-header {
  background-color: transparent;
  background-color: initial;
}
.card-wizard .input-group.has-danger .error {
  display: block;
  width: 100%;
  margin-top: 3px;
}
.card-wizard[data-color=primary] .progress-with-circle .progress-bar {
  background: #e14eca;
}
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link {
  color: #e14eca;
}
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.active {
  background: #e14eca;
  color: white;
}
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=primary] .nav-pills .nav-item .nav-link.active:hover {
  background: #e14eca;
}
.card-wizard[data-color=green] .progress-with-circle .progress-bar {
  background: #00bf9a;
}
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link {
  color: #00bf9a;
}
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=green] .nav-pills .nav-item .nav-link.active {
  background: #00bf9a;
  color: white;
}
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=green] .nav-pills .nav-item .nav-link.active:hover {
  background: #00bf9a;
}
.card-wizard[data-color=blue] .progress-with-circle .progress-bar {
  background: #1d8cf8;
}
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link {
  color: #1d8cf8;
}
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.active {
  background: #1d8cf8;
  color: white;
}
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=blue] .nav-pills .nav-item .nav-link.active:hover {
  background: #1d8cf8;
}
.card-wizard[data-color=red] .progress-with-circle .progress-bar {
  background: #fd5d93;
}
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link {
  color: #fd5d93;
}
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=red] .nav-pills .nav-item .nav-link.active {
  background: #fd5d93;
  color: white;
}
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=red] .nav-pills .nav-item .nav-link.active:hover {
  background: #fd5d93;
}
.card-wizard[data-color=orange] .progress-with-circle .progress-bar {
  background: #ff8d72;
}
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link {
  color: #ff8d72;
}
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.checked, .card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.active {
  background: #ff8d72;
  color: white;
}
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link:hover {
  background: #ffffff;
}
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.active,
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.checked:focus,
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.checked:hover,
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.active:focus,
.card-wizard[data-color=orange] .nav-pills .nav-item .nav-link.active:hover {
  background: #ff8d72;
}
.card-wizard .nav-pills .nav-item {
  position: relative;
}
.card-wizard .nav-pills .nav-item .nav-link {
  height: 45px;
  width: 45px;
  min-width: 45px;
  border-radius: 50% !important;
  position: absolute;
  left: 50%;
  top: -20px;
  transform: translate(-50%);
  background-color: white;
}
.card-wizard .nav-pills .nav-item .nav-link p {
  position: absolute;
  top: 110%;
  left: 50%;
  transform: translate(-50%);
  font-weight: 400;
  color: #ffffff;
}
.card-wizard .nav-pills .nav-item .nav-link:hover, .card-wizard .nav-pills .nav-item .nav-link:focus {
  background-color: white;
}
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  box-shadow: none;
}
.card-wizard .picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.card-wizard .card-body {
  background: #222a42;
  border-top-left-radius: 0.4285rem;
  border-top-right-radius: 0.4285rem;
  margin-top: 20px;
}
.card-wizard .card-footer {
  background-color: #222a42 !important;
  border-bottom-left-radius: 0.4285rem;
  border-bottom-right-radius: 0.4285rem;
}
.card-wizard .card-footer div:first-child {
  padding-right: 80px;
}
.card-wizard .card-footer div:nth-child(2) {
  padding-left: 80px;
}
.card-wizard .wizard-navigation {
  position: relative;
  margin: 80px auto 60px;
}
.card-wizard .wizard-navigation .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.card-wizard .wizard-navigation .progress-with-circle {
  position: relative;
  top: 5px;
  height: 5px;
  border-radius: 0.4285rem;
}
.card-wizard .wizard-navigation .progress-with-circle .progress-bar {
  height: 100%;
  border-radius: 0.4285rem;
  box-shadow: none;
  transition: width 0.3s ease;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
  display: inline-block;
  font-size: 19px;
  line-height: normal;
  line-height: initial;
  padding: 0;
  vertical-align: bottom;
}
.card-wizard .picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #E3E3E3;
  color: #ffffff;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
  border-color: #2ca8ff;
}
.card-wizard .picture input[type=file] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
.card-wizard .picture-src {
  width: 100%;
}
.card-wizard .tab-content {
  padding: 20px 0;
}
.card-wizard .wizard-footer {
  padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
  margin-top: 16px;
}
.card-wizard .disabled {
  display: none;
}
.card-wizard .wizard-header {
  text-align: center;
  padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
  margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
  text-align: center;
}
.card-wizard .btn {
  text-transform: uppercase;
}
.card-wizard .info-text {
  text-align: center;
  font-weight: 300;
  margin: 10px 0 30px;
}
.card-wizard .choice {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.card-wizard .choice[disabled] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.card-wizard .choice .icon {
  text-align: center;
  vertical-align: middle;
  height: 116px;
  width: 116px;
  border-radius: 50%;
  color: #344675;
  margin: 0 auto 20px;
  border: 1px solid #E3E3E3;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .choice i {
  font-size: 30px;
  line-height: 116px;
  position: absolute;
  left: 0;
  right: 0;
}
.card-wizard .choice:hover .icon, .card-wizard .choice.active .icon {
  border-color: #2ca8ff;
}
.card-wizard .choice input[type=radio],
.card-wizard .choice input[type=checkbox] {
  position: absolute;
  left: -10000px;
  z-index: -1;
}
.card-wizard .btn-finish {
  display: none;
}
.card-wizard .card-title + .description {
  font-size: 17px;
  margin-bottom: 32px;
}
.card-wizard .wizard-title {
  margin: 0;
}
.card-wizard .nav-pills {
  background-color: #ffffff;
  border-radius: 0.4285rem;
  height: 5px;
}
.card-wizard .nav-pills > li + li {
  margin-left: 0;
}
.card-wizard .nav-pills > li > a {
  border: 0 !important;
  border-radius: 0;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  min-width: 100px;
  text-align: center;
  color: #555555;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
  background-color: inherit;
  box-shadow: none;
}
.card-wizard .nav-pills > li i {
  display: block;
  font-size: 30px;
  padding: 15px 0;
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  width: 260px;
  padding: 4px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.125rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #ffffff;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 10px;
  border-radius: 4px;
  visibility: hidden;
  position: relative;
}
.rdtPicker .rdtTimeToggle:before {
  visibility: visible;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font: normal normal normal 1em/1 "Nucleo";
  font-size: 18px;
  content: "\\ea5e";
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #ffffff !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  height: 30px;
  line-height: 33px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover {
  background-color: #e14eca !important;
  color: #ffffff !important;
}

.rdtDays tr .dow {
  text-align: center;
  font-size: 12px;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
  font-weight: 300;
  font-size: 14px;
  width: 20px;
  height: 20px;
}
.rdtDays tr .rdtDay {
  color: #9A9A9A;
}
.rdtDays tr .rdtDay.rdtOld, .rdtDays tr .rdtDay.rdtNew {
  color: #344675;
  font-weight: 300;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover,
.rdtPicker .rdtTimeToggle:hover:before {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker .dow {
  width: 14.2857%;
  border-bottom: none;
}

.rdtPicker th.rdtSwitch {
  width: 50px;
  padding: 5px;
  border-radius: 3px;
  height: 20px;
  line-height: 20px;
  font-weight: 300;
  padding: 5px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  border-radius: 50%;
  height: 27px;
  width: 27px;
  display: block;
}
.rdtPicker th.rdtNext:before,
.rdtPicker th.rdtPrev:before {
  top: 2px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
  position: relative;
  display: inline-block;
  font: normal normal normal 1em/1 "Nucleo";
  vertical-align: middle;
  speak: none;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
}
.rdtPicker th.rdtNext span,
.rdtPicker th.rdtPrev span {
  display: none;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #e14eca;
}

.rdtPicker th.rdtNext:before {
  content: "\\ea35";
}

.rdtPicker th.rdtPrev:before {
  content: "\\ea34";
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #e14eca;
  border-radius: 50%;
  border: 1px solid #e14eca;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #DDDDDD;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
  background-color: #e14eca !important;
  color: #ffffff;
}

svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  color: #344675;
  line-height: 1.5em;
  background: #ffffff;
  border: none;
  border-radius: 0.875rem;
  padding: 5px 10px;
  z-index: 1040;
}

.jvectormap-zoomin,
.jvectormap-zoomout,
.jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin,
.jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/**
* React Select v1.0.0-rc.10
* ============
* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/
* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
* MIT License: https://github.com/JedWatson/react-select
*/
/*
This file was modified entirely by Creative Tim for React-Select v2.0.0
*/
.react-select .react-select__menu {
  top: 105%;
  max-width: 94%;
  width: 94%;
  right: 3%;
  border-radius: 12px;
  border: 0;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
  background-color: #ffffff;
  box-sizing: border-box;
  max-height: 200px;
  position: absolute;
  z-index: 2;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  margin-bottom: 0;
  margin-bottom: initial;
  margin-top: 0;
  margin-top: initial;
}
.react-select .react-select__menu:before {
  border-bottom: 11px solid #f1eae0;
  top: -11px;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
}
.react-select .react-select__menu:after {
  top: -10px;
  border-bottom: 11px solid #fffcf5;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
}
.react-select .react-select__menu-list {
  max-height: 198px;
  overflow-y: auto;
  padding-bottom: 0;
  padding-bottom: initial;
  padding-top: 0;
  padding-top: initial;
  position: relative;
}
.react-select .react-select__option {
  font-size: 0.8571em;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: block;
  outline: none;
  color: #292b2c;
}
.react-select .react-select__menu .react-select__option, .react-select .react-select__menu .react-select__option:active {
  background-color: transparent;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-selected, .react-select .react-select__menu .react-select__option.react-select__option--is-selected:active, .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused, .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused:active {
  background-color: #DDDDDD;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-focused, .react-select .react-select__menu .react-select__option.react-select__option--is-focused:active {
  background-color: #f5f5f5;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-disabled, .react-select .react-select__menu .react-select__option.react-select__option--is-disabled:active {
  color: #cccccc;
  cursor: default;
}
.react-select .react-select__control {
  border-radius: 4px;
  height: calc(2.25rem + 2px);
  box-sizing: border-box;
  border-collapse: separate;
  display: table;
  width: 100%;
}
.react-select .react-select__control, .react-select .react-select__control:hover {
  border: 1px solid #2b3553;
  box-shadow: none;
  background-color: transparent;
}
.react-select .react-select__control.react-select__control--is-focused .react-select__dropdown-indicator:after {
  transform: rotate(180deg);
  top: -4px;
}
.react-select .react-select__control.react-select__control--is-focused, .react-select .react-select__control.react-select__control--is-focused:hover {
  border: 1px solid #e14eca;
  box-shadow: none;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value {
  display: inline-flex;
  border-radius: 4px;
  background-color: transparent;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value + div:not(.react-select__multi-value) {
  display: inline-flex;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value .react-select__multi-value__label {
  font-size: 0.9em;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__single-value {
  top: 48%;
  color: #e14eca;
}
.react-select .react-select__control .react-select__placeholder {
  color: #9A9A9A;
  line-height: normal;
  font-size: 0.8571em;
  top: 48%;
}
.react-select .react-select__control .react-select__value-container,
.react-select .react-select__control .react-select__indicators {
  display: table-cell;
}
.react-select .react-select__control .react-select__indicators {
  width: 60px;
  padding-right: 10px;
  align-items: flex-end;
  vertical-align: middle;
  text-align: right;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator-separator {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
  display: inline-block;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:after {
  transition: all 150ms ease 0s;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  position: relative;
  content: "";
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:hover:after {
  border-top-color: #666666;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator > * {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator:before {
  content: "×";
  display: inline-block;
  font-size: 18px;
  line-height: 1;
  top: 2px;
  position: relative;
  margin-right: 3px;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator > * {
  display: none;
}
.react-select.primary .react-select__control.react-select__control--is-focused, .react-select.primary .react-select__control.react-select__control--is-focused:hover {
  border-color: #e14eca;
}
.react-select.primary .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.primary .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #e14eca;
}
.react-select.primary .react-select__multi-value {
  border: 1px solid #e14eca;
}
.react-select.primary .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(249, 99, 50, 0.3);
  border-left: 1px solid rgba(249, 99, 50, 0.3);
}
.react-select.primary .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #e14eca;
  background-color: transparent;
}
.react-select.success .react-select__control.react-select__control--is-focused, .react-select.success .react-select__control.react-select__control--is-focused:hover {
  border-color: #00f2c3;
}
.react-select.success .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.success .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #00f2c3;
}
.react-select.success .react-select__multi-value {
  border: 1px solid #00f2c3;
}
.react-select.success .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(24, 206, 15, 0.3);
  border-left: 1px solid rgba(24, 206, 15, 0.3);
}
.react-select.success .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #00f2c3;
  background-color: transparent;
}
.react-select.info .react-select__control.react-select__control--is-focused, .react-select.info .react-select__control.react-select__control--is-focused:hover {
  border-color: #1d8cf8;
}
.react-select.info .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.info .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #1d8cf8;
}
.react-select.info .react-select__multi-value {
  border: 1px solid #1d8cf8;
}
.react-select.info .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(44, 168, 255, 0.3);
  border-left: 1px solid rgba(44, 168, 255, 0.3);
}
.react-select.info .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #1d8cf8;
  background-color: transparent;
}
.react-select.warning .react-select__control.react-select__control--is-focused, .react-select.warning .react-select__control.react-select__control--is-focused:hover {
  border-color: #ff8d72;
}
.react-select.warning .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.warning .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #ff8d72;
}
.react-select.warning .react-select__multi-value {
  border: 1px solid #ff8d72;
}
.react-select.warning .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(255, 178, 54, 0.3);
  border-left: 1px solid rgba(255, 178, 54, 0.3);
}
.react-select.warning .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #ff8d72;
  background-color: transparent;
}
.react-select.danger .react-select__control.react-select__control--is-focused, .react-select.danger .react-select__control.react-select__control--is-focused:hover {
  border-color: #fd5d93;
}
.react-select.danger .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.danger .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #fd5d93;
}
.react-select.danger .react-select__multi-value {
  border: 1px solid #fd5d93;
}
.react-select.danger .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(255, 54, 54, 0.3);
  border-left: 1px solid rgba(255, 54, 54, 0.3);
}
.react-select.danger .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #fd5d93;
  background-color: transparent;
}
.react-select .react-select__multi-value {
  border: 1px solid #9A9A9A;
}
.react-select .react-select__multi-value .react-select__multi-value__remove {
  position: relative;
  color: rgba(222, 222, 222, 0.8);
  border-left: 1px solid rgba(222, 222, 222, 0.8);
}
.react-select .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #9A9A9A;
  background-color: transparent;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled .react-select__multi-value__remove {
  display: none;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled.react-select__multi-value {
  background-color: #fcfcfc;
  border: 1px solid #e3e3e3;
}
.react-select.react-select--is-disabled .react-select__control--is-disabled {
  background-color: #f9f9f9;
}
.react-select .react-select__menu-list {
  margin: 10px 0;
  max-height: 180px;
}

.input-group .react-select {
  flex: 1 1 auto;
}

.input-group .input-group-prepend + .react-select .react-select__control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}

.input-group .react-select:not(:last-child) .react-select__control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  right: -1px;
}

.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: transparent;
}

.ReactTable .actions-right {
  text-align: right;
}
.ReactTable .actions-left {
  text-align: left;
}
.ReactTable .actions-center {
  text-align: center;
}

.ReactTable * {
  box-sizing: border-box;
}

.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}

.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .-pagination input,
.ReactTable .-pagination select,
.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-color: #2b3553;
  background-color: transparent;
  border-radius: 0.4285rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: normal;
  font-size: 0.8571em;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  box-shadow: none;
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
  height: calc(1.8125rem + 2px);
  padding: 0.25rem 0.5rem;
}
.ReactTable .-pagination input:focus,
.ReactTable .-pagination select:focus,
.ReactTable .rt-thead.-filters input:focus,
.ReactTable .rt-thead.-filters select:focus {
  border-color: #1d8cf8;
  background: transparent;
  box-shadow: none;
  outline: 0 !important;
  color: rgba(255, 255, 255, 0.8);
}
.ReactTable .-pagination input option,
.ReactTable .-pagination select option,
.ReactTable .rt-thead.-filters input option,
.ReactTable .rt-thead.-filters select option {
  color: #32325d;
}

.ReactTable .rt-thead .rt-tr {
  text-align: center;
}

.ReactTable .rt-thead .rt-th:last-child {
  text-align: right;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after, .ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:before {
  position: absolute;
  display: block;
  opacity: 0.3;
}
.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:before {
  right: 1em;
  content: "↑";
}
.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after {
  right: 0.5em;
  content: "↓";
  top: 0.4em;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-desc > div:first-of-type:after {
  opacity: 1;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-asc > div:first-of-type:before {
  opacity: 1;
}

.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  font-size: 1.063rem;
  text-align: left;
  font-weight: 300;
  line-height: 2.5em !important;
  padding: 5px 5px;
  line-height: normal;
  position: relative;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}

.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}

.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}

.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-resizable-header-content:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}

.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}

.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}

.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}

.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
}

.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}

.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 7px 5px;
  overflow: hidden;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
  margin: auto;
}

.ReactTable .rt-tbody .rt-tr,
.ReactTable .rt-thead.-filters .rt-tr {
  border-top: 1px solid #dee2e6;
  border-color: rgba(255, 255, 255, 0.1);
}

.ReactTable .rt-td {
  padding: 12px 7px;
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.7) !important;
}

.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}

.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  margin: 0;
  color: transparent;
  margin: 0 10px;
}

.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}

.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}

.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}

.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}

.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: rgba(0, 0, 0, 0.05);
}

.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
}

.ReactTable .-pagination .-btn {
  border-width: 2px;
  font-weight: 600;
  font-size: 1em;
  line-height: 1.35em;
  border: none;
  position: relative;
  overflow: hidden;
  margin: 4px 1px;
  border-radius: 0.4285rem;
  padding: 11px 40px;
  cursor: pointer;
  background: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #1d8cf8;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
  width: 100%;
  outline: none !important;
}
.ReactTable .-pagination .-btn.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.ReactTable .-pagination .-btn:hover, .ReactTable .-pagination .-btn:focus, .ReactTable .-pagination .-btn:active, .ReactTable .-pagination .-btn.active, .ReactTable .-pagination .-btn:active:focus, .ReactTable .-pagination .-btn:active:hover, .ReactTable .-pagination .-btn.active:focus, .ReactTable .-pagination .-btn.active:hover {
  background-color: #3358f4 !important;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-image: -moz-linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  color: #ffffff;
  box-shadow: none;
}
.ReactTable .-pagination .-btn:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.ReactTable .-pagination .-btn:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.ReactTable .-pagination .-btn.disabled, .ReactTable .-pagination .-btn.disabled:hover, .ReactTable .-pagination .-btn.disabled:focus, .ReactTable .-pagination .-btn.disabled.focus, .ReactTable .-pagination .-btn.disabled:active, .ReactTable .-pagination .-btn.disabled.active, .ReactTable .-pagination .-btn:disabled, .ReactTable .-pagination .-btn:disabled:hover, .ReactTable .-pagination .-btn:disabled:focus, .ReactTable .-pagination .-btn:disabled.focus, .ReactTable .-pagination .-btn:disabled:active, .ReactTable .-pagination .-btn:disabled.active, .ReactTable .-pagination .-btn[disabled], .ReactTable .-pagination .-btn[disabled]:hover, .ReactTable .-pagination .-btn[disabled]:focus, .ReactTable .-pagination .-btn[disabled].focus, .ReactTable .-pagination .-btn[disabled]:active, .ReactTable .-pagination .-btn[disabled].active, fieldset[disabled] .ReactTable .-pagination .-btn, fieldset[disabled] .ReactTable .-pagination .-btn:hover, fieldset[disabled] .ReactTable .-pagination .-btn:focus, fieldset[disabled] .ReactTable .-pagination .-btn.focus, fieldset[disabled] .ReactTable .-pagination .-btn:active, fieldset[disabled] .ReactTable .-pagination .-btn.active {
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.ReactTable .-pagination .-btn.btn-simple {
  color: #1d8cf8;
  border-color: #1d8cf8;
  background: transparent;
}
.ReactTable .-pagination .-btn.btn-simple:hover, .ReactTable .-pagination .-btn.btn-simple:focus, .ReactTable .-pagination .-btn.btn-simple:active, .ReactTable .-pagination .-btn.btn-simple:not(:disabled):not(.disabled):active {
  color: #1d8cf8;
  border-color: #1d8cf8;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.ReactTable .-pagination .-btn.btn-simple.active {
  border-color: #1d8cf8 !important;
}
.ReactTable .-pagination .-btn.btn-simple.active:hover, .ReactTable .-pagination .-btn.btn-simple.active:focus, .ReactTable .-pagination .-btn.btn-simple.active:active, .ReactTable .-pagination .-btn.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-image: -moz-linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-color: #3358f4 !important;
  box-shadow: none;
}
.ReactTable .-pagination .-btn.btn-link {
  color: #1d8cf8;
}
.ReactTable .-pagination .-btn.btn-link:hover, .ReactTable .-pagination .-btn.btn-link:focus, .ReactTable .-pagination .-btn.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.ReactTable .-pagination .-btn:not([disabled]):hover {
  color: #fff;
}

.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}

.ReactTable .-pagination .-center {
  flex: 1.5 1;
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.ReactTable .-pagination .-pageInfo {
  display: inline-block;
  margin: 3px 10px;
}

.ReactTable .-pagination .-pageJump {
  display: inline-block;
}

.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}

.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}

.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}

.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}

.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}

.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead .rt-th:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-th {
  border-bottom-width: 1px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  border: 0;
  color: rgba(255, 255, 255, 0.7);
}

.react-tagsinput {
  display: inline-block;
  padding: 4px 6px;
  max-width: 100%;
  line-height: 22px;
}

.react-tagsinput-tag {
  cursor: pointer;
  margin: 5px 3px 5px 0;
  position: relative;
  padding: 3px 8px;
  border-radius: 12px;
  color: #ffffff;
  font-weight: 500;
  font-size: 0.75em;
  text-transform: uppercase;
  display: inline-block;
  line-height: 1.5em;
  padding-left: 0.8em;
}
.react-tagsinput-tag + .react-tagsinput-tag {
  margin-left: 3px;
}

.react-tagsinput-remove {
  cursor: pointer;
  font-weight: bold;
}

.react-tagsinput-tag a::before {
  font-family: "Nucleo";
  content: "\\ea48";
  padding: 0px 2px;
}

.react-tagsinput-tag a {
  cursor: pointer;
  position: absolute;
  top: 3px;
  right: 0px;
  opacity: 0;
  background-color: transparent;
}

.react-tagsinput-input {
  background: transparent;
  border: 0;
  color: #777;
  font-family: sans-serif;
  font-size: 13px;
  font-weight: 400;
  outline: none;
  padding-left: 5px;
  width: 80px;
}

.react-tagsinput .react-tagsinput-tag {
  transition: all 300ms ease 0s;
  color: #ffffff;
  background-color: #344675;
}
.react-tagsinput .react-tagsinput-tag:hover {
  padding-right: 22px;
}
.react-tagsinput .react-tagsinput-tag:hover a {
  opacity: 1;
  padding-right: 4px;
}
a.react-tagsinput .react-tagsinput-tag:hover, a.react-tagsinput .react-tagsinput-tag:focus {
  color: #ffffff;
  background-color: #243152;
}
a.react-tagsinput .react-tagsinput-tag:focus, a.react-tagsinput .react-tagsinput-tag.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(52, 70, 117, 0.5);
}

.react-tagsinput .react-tagsinput-tag.primary {
  color: #ffffff;
  background-color: #e14eca;
}
a.react-tagsinput .react-tagsinput-tag.primary:hover, a.react-tagsinput .react-tagsinput-tag.primary:focus {
  color: #ffffff;
  background-color: #d725bb;
}
a.react-tagsinput .react-tagsinput-tag.primary:focus, a.react-tagsinput .react-tagsinput-tag.primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(225, 78, 202, 0.5);
}

.react-tagsinput .react-tagsinput-tag.info {
  color: #ffffff;
  background-color: #1d8cf8;
}
a.react-tagsinput .react-tagsinput-tag.info:hover, a.react-tagsinput .react-tagsinput-tag.info:focus {
  color: #ffffff;
  background-color: #0772db;
}
a.react-tagsinput .react-tagsinput-tag.info:focus, a.react-tagsinput .react-tagsinput-tag.info.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(29, 140, 248, 0.5);
}

.react-tagsinput .react-tagsinput-tag.success {
  color: #ffffff;
  background-color: #00f2c3;
}
a.react-tagsinput .react-tagsinput-tag.success:hover, a.react-tagsinput .react-tagsinput-tag.success:focus {
  color: #ffffff;
  background-color: #00bf9a;
}
a.react-tagsinput .react-tagsinput-tag.success:focus, a.react-tagsinput .react-tagsinput-tag.success.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.5);
}

.react-tagsinput .react-tagsinput-tag.warning {
  color: #ffffff;
  background-color: #ff8d72;
}
a.react-tagsinput .react-tagsinput-tag.warning:hover, a.react-tagsinput .react-tagsinput-tag.warning:focus {
  color: #ffffff;
  background-color: #ff643f;
}
a.react-tagsinput .react-tagsinput-tag.warning:focus, a.react-tagsinput .react-tagsinput-tag.warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.5);
}

.react-tagsinput .react-tagsinput-tag.danger {
  color: #ffffff;
  background-color: #fd5d93;
}
a.react-tagsinput .react-tagsinput-tag.danger:hover, a.react-tagsinput .react-tagsinput-tag.danger:focus {
  color: #ffffff;
  background-color: #fc2b71;
}
a.react-tagsinput .react-tagsinput-tag.danger:focus, a.react-tagsinput .react-tagsinput-tag.danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(253, 93, 147, 0.5);
}

.react-tagsinput .react-tagsinput-tag.neutral {
  color: #212529;
  background-color: #ffffff;
  color: inherit;
}
a.react-tagsinput .react-tagsinput-tag.neutral:hover, a.react-tagsinput .react-tagsinput-tag.neutral:focus {
  color: #212529;
  background-color: #e6e6e6;
}
a.react-tagsinput .react-tagsinput-tag.neutral:focus, a.react-tagsinput .react-tagsinput-tag.neutral.focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.rna-container {
  z-index: 1051;
  position: fixed;
}

.alert button.close {
  margin-top: -1px;
  color: #ffffff;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
}
.alert button.close::after {
  display: inline-block;
  font: normal normal normal 1em/1 "Nucleo";
  vertical-align: middle;
  speak: none;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  font-size: 1rem;
  content: "\\ea48";
}
.alert button.close span {
  display: none !important;
}
.alert.alert-dismissible {
  padding-right: 1.25rem;
}

.badge + .badge {
  margin-left: 4px;
}

/*******************************************************************************
 *              bootstrap-rtl (version 3.3.4)
 *      Author: Morteza Ansarinia (http://github.com/morteza)
 *  Created on: August 13,2015
 *     Project: bootstrap-rtl
 *   Copyright: Unlicensed Public Domain
 *******************************************************************************/
/*******************************************************************************
  This file was modified by the Creative-Tim team
  *******************************************************************************/
.rtl-active {
  /*# sourceMappingURL=bootstrap-rtl.css.map */
}
.rtl-activehtml {
  direction: rtl;
}
.rtl-active body {
  direction: rtl;
}
.rtl-active .flip.text-left {
  text-align: right;
}
.rtl-active .flip.text-right {
  text-align: left;
}
.rtl-active .list-unstyled {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}
.rtl-active .list-inline {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
  margin-right: -5px;
  margin-left: 0;
}
.rtl-active dd {
  margin-right: 0;
  margin-left: 0;
  margin-left: initial;
}
@media (min-width: 768px) {
  .rtl-active .dl-horizontal dt {
    float: right;
    clear: right;
    text-align: left;
  }
  .rtl-active .dl-horizontal dd {
    margin-right: 180px;
    margin-left: 0;
  }
}
.rtl-active blockquote {
  border-right: 5px solid #eeeeee;
  border-left: 0;
}
.rtl-active .blockquote-reverse,
.rtl-active blockquote.pull-left {
  padding-left: 15px;
  padding-right: 0;
  border-left: 5px solid #eeeeee;
  border-right: 0;
  text-align: left;
}
.rtl-active .col-xs-1,
.rtl-active .col-sm-1,
.rtl-active .col-md-1,
.rtl-active .col-lg-1,
.rtl-active .col-xs-2,
.rtl-active .col-sm-2,
.rtl-active .col-md-2,
.rtl-active .col-lg-2,
.rtl-active .col-xs-3,
.rtl-active .col-sm-3,
.rtl-active .col-md-3,
.rtl-active .col-lg-3,
.rtl-active .col-xs-4,
.rtl-active .col-sm-4,
.rtl-active .col-md-4,
.rtl-active .col-lg-4,
.rtl-active .col-xs-5,
.rtl-active .col-sm-5,
.rtl-active .col-md-5,
.rtl-active .col-lg-5,
.rtl-active .col-xs-6,
.rtl-active .col-sm-6,
.rtl-active .col-md-6,
.rtl-active .col-lg-6,
.rtl-active .col-xs-7,
.rtl-active .col-sm-7,
.rtl-active .col-md-7,
.rtl-active .col-lg-7,
.rtl-active .col-xs-8,
.rtl-active .col-sm-8,
.rtl-active .col-md-8,
.rtl-active .col-lg-8,
.rtl-active .col-xs-9,
.rtl-active .col-sm-9,
.rtl-active .col-md-9,
.rtl-active .col-lg-9,
.rtl-active .col-xs-10,
.rtl-active .col-sm-10,
.rtl-active .col-md-10,
.rtl-active .col-lg-10,
.rtl-active .col-xs-11,
.rtl-active .col-sm-11,
.rtl-active .col-md-11,
.rtl-active .col-lg-11,
.rtl-active .col-xs-12,
.rtl-active .col-sm-12,
.rtl-active .col-md-12,
.rtl-active .col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  padding-right: 15px;
}
.rtl-active .col-xs-1,
.rtl-active .col-xs-2,
.rtl-active .col-xs-3,
.rtl-active .col-xs-4,
.rtl-active .col-xs-5,
.rtl-active .col-xs-6,
.rtl-active .col-xs-7,
.rtl-active .col-xs-8,
.rtl-active .col-xs-9,
.rtl-active .col-xs-10,
.rtl-active .col-xs-11,
.rtl-active .col-xs-12 {
  float: right;
}
.rtl-active .col-xs-12 {
  width: 100%;
}
.rtl-active .col-xs-11 {
  width: 91.66666667%;
}
.rtl-active .col-xs-10 {
  width: 83.33333333%;
}
.rtl-active .col-xs-9 {
  width: 75%;
}
.rtl-active .col-xs-8 {
  width: 66.66666667%;
}
.rtl-active .col-xs-7 {
  width: 58.33333333%;
}
.rtl-active .col-xs-6 {
  width: 50%;
}
.rtl-active .col-xs-5 {
  width: 41.66666667%;
}
.rtl-active .col-xs-4 {
  width: 33.33333333%;
}
.rtl-active .col-xs-3 {
  width: 25%;
}
.rtl-active .col-xs-2 {
  width: 16.66666667%;
}
.rtl-active .col-xs-1 {
  width: 8.33333333%;
}
.rtl-active .col-xs-pull-12 {
  left: 100%;
  right: auto;
}
.rtl-active .col-xs-pull-11 {
  left: 91.66666667%;
  right: auto;
}
.rtl-active .col-xs-pull-10 {
  left: 83.33333333%;
  right: auto;
}
.rtl-active .col-xs-pull-9 {
  left: 75%;
  right: auto;
}
.rtl-active .col-xs-pull-8 {
  left: 66.66666667%;
  right: auto;
}
.rtl-active .col-xs-pull-7 {
  left: 58.33333333%;
  right: auto;
}
.rtl-active .col-xs-pull-6 {
  left: 50%;
  right: auto;
}
.rtl-active .col-xs-pull-5 {
  left: 41.66666667%;
  right: auto;
}
.rtl-active .col-xs-pull-4 {
  left: 33.33333333%;
  right: auto;
}
.rtl-active .col-xs-pull-3 {
  left: 25%;
  right: auto;
}
.rtl-active .col-xs-pull-2 {
  left: 16.66666667%;
  right: auto;
}
.rtl-active .col-xs-pull-1 {
  left: 8.33333333%;
  right: auto;
}
.rtl-active .col-xs-pull-0 {
  left: auto;
  right: auto;
}
.rtl-active .col-xs-push-12 {
  right: 100%;
  left: 0;
}
.rtl-active .col-xs-push-11 {
  right: 91.66666667%;
  left: 0;
}
.rtl-active .col-xs-push-10 {
  right: 83.33333333%;
  left: 0;
}
.rtl-active .col-xs-push-9 {
  right: 75%;
  left: 0;
}
.rtl-active .col-xs-push-8 {
  right: 66.66666667%;
  left: 0;
}
.rtl-active .col-xs-push-7 {
  right: 58.33333333%;
  left: 0;
}
.rtl-active .col-xs-push-6 {
  right: 50%;
  left: 0;
}
.rtl-active .col-xs-push-5 {
  right: 41.66666667%;
  left: 0;
}
.rtl-active .col-xs-push-4 {
  right: 33.33333333%;
  left: 0;
}
.rtl-active .col-xs-push-3 {
  right: 25%;
  left: 0;
}
.rtl-active .col-xs-push-2 {
  right: 16.66666667%;
  left: 0;
}
.rtl-active .col-xs-push-1 {
  right: 8.33333333%;
  left: 0;
}
.rtl-active .col-xs-push-0 {
  right: auto;
  left: 0;
}
.rtl-active .col-xs-offset-12 {
  margin-right: 100%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-11 {
  margin-right: 91.66666667%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-10 {
  margin-right: 83.33333333%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-9 {
  margin-right: 75%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-8 {
  margin-right: 66.66666667%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-7 {
  margin-right: 58.33333333%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-6 {
  margin-right: 50%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-5 {
  margin-right: 41.66666667%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-4 {
  margin-right: 33.33333333%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-3 {
  margin-right: 25%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-2 {
  margin-right: 16.66666667%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-1 {
  margin-right: 8.33333333%;
  margin-left: 0;
}
.rtl-active .col-xs-offset-0 {
  margin-right: 0%;
  margin-left: 0;
}
@media (min-width: 768px) {
  .rtl-active .col-sm-1,
.rtl-active .col-sm-2,
.rtl-active .col-sm-3,
.rtl-active .col-sm-4,
.rtl-active .col-sm-5,
.rtl-active .col-sm-6,
.rtl-active .col-sm-7,
.rtl-active .col-sm-8,
.rtl-active .col-sm-9,
.rtl-active .col-sm-10,
.rtl-active .col-sm-11,
.rtl-active .col-sm-12 {
    float: right;
  }
  .rtl-active .col-sm-12 {
    width: 100%;
  }
  .rtl-active .col-sm-11 {
    width: 91.66666667%;
  }
  .rtl-active .col-sm-10 {
    width: 83.33333333%;
  }
  .rtl-active .col-sm-9 {
    width: 75%;
  }
  .rtl-active .col-sm-8 {
    width: 66.66666667%;
  }
  .rtl-active .col-sm-7 {
    width: 58.33333333%;
  }
  .rtl-active .col-sm-6 {
    width: 50%;
  }
  .rtl-active .col-sm-5 {
    width: 41.66666667%;
  }
  .rtl-active .col-sm-4 {
    width: 33.33333333%;
  }
  .rtl-active .col-sm-3 {
    width: 25%;
  }
  .rtl-active .col-sm-2 {
    width: 16.66666667%;
  }
  .rtl-active .col-sm-1 {
    width: 8.33333333%;
  }
  .rtl-active .col-sm-pull-12 {
    left: 100%;
    right: auto;
  }
  .rtl-active .col-sm-pull-11 {
    left: 91.66666667%;
    right: auto;
  }
  .rtl-active .col-sm-pull-10 {
    left: 83.33333333%;
    right: auto;
  }
  .rtl-active .col-sm-pull-9 {
    left: 75%;
    right: auto;
  }
  .rtl-active .col-sm-pull-8 {
    left: 66.66666667%;
    right: auto;
  }
  .rtl-active .col-sm-pull-7 {
    left: 58.33333333%;
    right: auto;
  }
  .rtl-active .col-sm-pull-6 {
    left: 50%;
    right: auto;
  }
  .rtl-active .col-sm-pull-5 {
    left: 41.66666667%;
    right: auto;
  }
  .rtl-active .col-sm-pull-4 {
    left: 33.33333333%;
    right: auto;
  }
  .rtl-active .col-sm-pull-3 {
    left: 25%;
    right: auto;
  }
  .rtl-active .col-sm-pull-2 {
    left: 16.66666667%;
    right: auto;
  }
  .rtl-active .col-sm-pull-1 {
    left: 8.33333333%;
    right: auto;
  }
  .rtl-active .col-sm-pull-0 {
    left: auto;
    right: auto;
  }
  .rtl-active .col-sm-push-12 {
    right: 100%;
    left: 0;
  }
  .rtl-active .col-sm-push-11 {
    right: 91.66666667%;
    left: 0;
  }
  .rtl-active .col-sm-push-10 {
    right: 83.33333333%;
    left: 0;
  }
  .rtl-active .col-sm-push-9 {
    right: 75%;
    left: 0;
  }
  .rtl-active .col-sm-push-8 {
    right: 66.66666667%;
    left: 0;
  }
  .rtl-active .col-sm-push-7 {
    right: 58.33333333%;
    left: 0;
  }
  .rtl-active .col-sm-push-6 {
    right: 50%;
    left: 0;
  }
  .rtl-active .col-sm-push-5 {
    right: 41.66666667%;
    left: 0;
  }
  .rtl-active .col-sm-push-4 {
    right: 33.33333333%;
    left: 0;
  }
  .rtl-active .col-sm-push-3 {
    right: 25%;
    left: 0;
  }
  .rtl-active .col-sm-push-2 {
    right: 16.66666667%;
    left: 0;
  }
  .rtl-active .col-sm-push-1 {
    right: 8.33333333%;
    left: 0;
  }
  .rtl-active .col-sm-push-0 {
    right: auto;
    left: 0;
  }
  .rtl-active .col-sm-offset-12 {
    margin-right: 100%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-11 {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-10 {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-9 {
    margin-right: 75%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-8 {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-7 {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-6 {
    margin-right: 50%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-5 {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-4 {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-3 {
    margin-right: 25%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-2 {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-1 {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-sm-offset-0 {
    margin-right: 0%;
    margin-left: 0;
  }
}
@media (min-width: 992px) {
  .rtl-active .col-md-1,
.rtl-active .col-md-2,
.rtl-active .col-md-3,
.rtl-active .col-md-4,
.rtl-active .col-md-5,
.rtl-active .col-md-6,
.rtl-active .col-md-7,
.rtl-active .col-md-8,
.rtl-active .col-md-9,
.rtl-active .col-md-10,
.rtl-active .col-md-11,
.rtl-active .col-md-12 {
    float: right;
  }
  .rtl-active .col-md-12 {
    width: 100%;
  }
  .rtl-active .col-md-11 {
    width: 91.66666667%;
  }
  .rtl-active .col-md-10 {
    width: 83.33333333%;
  }
  .rtl-active .col-md-9 {
    width: 75%;
  }
  .rtl-active .col-md-8 {
    width: 66.66666667%;
  }
  .rtl-active .col-md-7 {
    width: 58.33333333%;
  }
  .rtl-active .col-md-6 {
    width: 50%;
  }
  .rtl-active .col-md-5 {
    width: 41.66666667%;
  }
  .rtl-active .col-md-4 {
    width: 33.33333333%;
  }
  .rtl-active .col-md-3 {
    width: 25%;
  }
  .rtl-active .col-md-2 {
    width: 16.66666667%;
  }
  .rtl-active .col-md-1 {
    width: 8.33333333%;
  }
  .rtl-active .col-md-pull-12 {
    left: 100%;
    right: auto;
  }
  .rtl-active .col-md-pull-11 {
    left: 91.66666667%;
    right: auto;
  }
  .rtl-active .col-md-pull-10 {
    left: 83.33333333%;
    right: auto;
  }
  .rtl-active .col-md-pull-9 {
    left: 75%;
    right: auto;
  }
  .rtl-active .col-md-pull-8 {
    left: 66.66666667%;
    right: auto;
  }
  .rtl-active .col-md-pull-7 {
    left: 58.33333333%;
    right: auto;
  }
  .rtl-active .col-md-pull-6 {
    left: 50%;
    right: auto;
  }
  .rtl-active .col-md-pull-5 {
    left: 41.66666667%;
    right: auto;
  }
  .rtl-active .col-md-pull-4 {
    left: 33.33333333%;
    right: auto;
  }
  .rtl-active .col-md-pull-3 {
    left: 25%;
    right: auto;
  }
  .rtl-active .col-md-pull-2 {
    left: 16.66666667%;
    right: auto;
  }
  .rtl-active .col-md-pull-1 {
    left: 8.33333333%;
    right: auto;
  }
  .rtl-active .col-md-pull-0 {
    left: auto;
    right: auto;
  }
  .rtl-active .col-md-push-12 {
    right: 100%;
    left: 0;
  }
  .rtl-active .col-md-push-11 {
    right: 91.66666667%;
    left: 0;
  }
  .rtl-active .col-md-push-10 {
    right: 83.33333333%;
    left: 0;
  }
  .rtl-active .col-md-push-9 {
    right: 75%;
    left: 0;
  }
  .rtl-active .col-md-push-8 {
    right: 66.66666667%;
    left: 0;
  }
  .rtl-active .col-md-push-7 {
    right: 58.33333333%;
    left: 0;
  }
  .rtl-active .col-md-push-6 {
    right: 50%;
    left: 0;
  }
  .rtl-active .col-md-push-5 {
    right: 41.66666667%;
    left: 0;
  }
  .rtl-active .col-md-push-4 {
    right: 33.33333333%;
    left: 0;
  }
  .rtl-active .col-md-push-3 {
    right: 25%;
    left: 0;
  }
  .rtl-active .col-md-push-2 {
    right: 16.66666667%;
    left: 0;
  }
  .rtl-active .col-md-push-1 {
    right: 8.33333333%;
    left: 0;
  }
  .rtl-active .col-md-push-0 {
    right: auto;
    left: 0;
  }
  .rtl-active .col-md-offset-12 {
    margin-right: 100%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-11 {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-10 {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-9 {
    margin-right: 75%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-8 {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-7 {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-6 {
    margin-right: 50%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-5 {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-4 {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-3 {
    margin-right: 25%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-2 {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-1 {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-md-offset-0 {
    margin-right: 0%;
    margin-left: 0;
  }
}
@media (min-width: 1200px) {
  .rtl-active .col-lg-1,
.rtl-active .col-lg-2,
.rtl-active .col-lg-3,
.rtl-active .col-lg-4,
.rtl-active .col-lg-5,
.rtl-active .col-lg-6,
.rtl-active .col-lg-7,
.rtl-active .col-lg-8,
.rtl-active .col-lg-9,
.rtl-active .col-lg-10,
.rtl-active .col-lg-11,
.rtl-active .col-lg-12 {
    float: right;
  }
  .rtl-active .col-lg-12 {
    width: 100%;
  }
  .rtl-active .col-lg-11 {
    width: 91.66666667%;
  }
  .rtl-active .col-lg-10 {
    width: 83.33333333%;
  }
  .rtl-active .col-lg-9 {
    width: 75%;
  }
  .rtl-active .col-lg-8 {
    width: 66.66666667%;
  }
  .rtl-active .col-lg-7 {
    width: 58.33333333%;
  }
  .rtl-active .col-lg-6 {
    width: 50%;
  }
  .rtl-active .col-lg-5 {
    width: 41.66666667%;
  }
  .rtl-active .col-lg-4 {
    width: 33.33333333%;
  }
  .rtl-active .col-lg-3 {
    width: 25%;
  }
  .rtl-active .col-lg-2 {
    width: 16.66666667%;
  }
  .rtl-active .col-lg-1 {
    width: 8.33333333%;
  }
  .rtl-active .col-lg-pull-12 {
    left: 100%;
    right: auto;
  }
  .rtl-active .col-lg-pull-11 {
    left: 91.66666667%;
    right: auto;
  }
  .rtl-active .col-lg-pull-10 {
    left: 83.33333333%;
    right: auto;
  }
  .rtl-active .col-lg-pull-9 {
    left: 75%;
    right: auto;
  }
  .rtl-active .col-lg-pull-8 {
    left: 66.66666667%;
    right: auto;
  }
  .rtl-active .col-lg-pull-7 {
    left: 58.33333333%;
    right: auto;
  }
  .rtl-active .col-lg-pull-6 {
    left: 50%;
    right: auto;
  }
  .rtl-active .col-lg-pull-5 {
    left: 41.66666667%;
    right: auto;
  }
  .rtl-active .col-lg-pull-4 {
    left: 33.33333333%;
    right: auto;
  }
  .rtl-active .col-lg-pull-3 {
    left: 25%;
    right: auto;
  }
  .rtl-active .col-lg-pull-2 {
    left: 16.66666667%;
    right: auto;
  }
  .rtl-active .col-lg-pull-1 {
    left: 8.33333333%;
    right: auto;
  }
  .rtl-active .col-lg-pull-0 {
    left: auto;
    right: auto;
  }
  .rtl-active .col-lg-push-12 {
    right: 100%;
    left: 0;
  }
  .rtl-active .col-lg-push-11 {
    right: 91.66666667%;
    left: 0;
  }
  .rtl-active .col-lg-push-10 {
    right: 83.33333333%;
    left: 0;
  }
  .rtl-active .col-lg-push-9 {
    right: 75%;
    left: 0;
  }
  .rtl-active .col-lg-push-8 {
    right: 66.66666667%;
    left: 0;
  }
  .rtl-active .col-lg-push-7 {
    right: 58.33333333%;
    left: 0;
  }
  .rtl-active .col-lg-push-6 {
    right: 50%;
    left: 0;
  }
  .rtl-active .col-lg-push-5 {
    right: 41.66666667%;
    left: 0;
  }
  .rtl-active .col-lg-push-4 {
    right: 33.33333333%;
    left: 0;
  }
  .rtl-active .col-lg-push-3 {
    right: 25%;
    left: 0;
  }
  .rtl-active .col-lg-push-2 {
    right: 16.66666667%;
    left: 0;
  }
  .rtl-active .col-lg-push-1 {
    right: 8.33333333%;
    left: 0;
  }
  .rtl-active .col-lg-push-0 {
    right: auto;
    left: 0;
  }
  .rtl-active .col-lg-offset-12 {
    margin-right: 100%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-11 {
    margin-right: 91.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-10 {
    margin-right: 83.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-9 {
    margin-right: 75%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-8 {
    margin-right: 66.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-7 {
    margin-right: 58.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-6 {
    margin-right: 50%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-5 {
    margin-right: 41.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-4 {
    margin-right: 33.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-3 {
    margin-right: 25%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-2 {
    margin-right: 16.66666667%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-1 {
    margin-right: 8.33333333%;
    margin-left: 0;
  }
  .rtl-active .col-lg-offset-0 {
    margin-right: 0%;
    margin-left: 0;
  }
}
.rtl-active caption {
  text-align: right;
}
.rtl-active th {
  text-align: right;
}
@media screen and (max-width: 767px) {
  .rtl-active .table-responsive > .table-bordered {
    border: 0;
  }
  .rtl-active .table-responsive > .table-bordered > thead > tr > th:first-child,
.rtl-active .table-responsive > .table-bordered > tbody > tr > th:first-child,
.rtl-active .table-responsive > .table-bordered > tfoot > tr > th:first-child,
.rtl-active .table-responsive > .table-bordered > thead > tr > td:first-child,
.rtl-active .table-responsive > .table-bordered > tbody > tr > td:first-child,
.rtl-active .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-right: 0;
    border-left: 0;
    border-left: initial;
  }
  .rtl-active .table-responsive > .table-bordered > thead > tr > th:last-child,
.rtl-active .table-responsive > .table-bordered > tbody > tr > th:last-child,
.rtl-active .table-responsive > .table-bordered > tfoot > tr > th:last-child,
.rtl-active .table-responsive > .table-bordered > thead > tr > td:last-child,
.rtl-active .table-responsive > .table-bordered > tbody > tr > td:last-child,
.rtl-active .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-left: 0;
    border-right: 0;
    border-right: initial;
  }
}
.rtl-active .radio label,
.rtl-active .checkbox label {
  padding-right: 20px;
  padding-left: 0;
  padding-left: initial;
}
.rtl-active .radio input[type=radio],
.rtl-active .radio-inline input[type=radio],
.rtl-active .checkbox input[type=checkbox],
.rtl-active .checkbox-inline input[type=checkbox] {
  margin-right: -20px;
  margin-left: auto;
}
.rtl-active .radio-inline,
.rtl-active .checkbox-inline {
  padding-right: 20px;
  padding-left: 0;
}
.rtl-active .radio-inline + .radio-inline,
.rtl-active .checkbox-inline + .checkbox-inline {
  margin-right: 10px;
  margin-left: 0;
}
.rtl-active .has-feedback .form-control {
  padding-left: 42.5px;
  padding-right: 12px;
}
.rtl-active .form-control-feedback {
  left: 0;
  right: auto;
}
@media (min-width: 768px) {
  .rtl-active .form-inline label {
    padding-right: 0;
    padding-left: 0;
    padding-left: initial;
  }
  .rtl-active .form-inline .radio input[type=radio],
.rtl-active .form-inline .checkbox input[type=checkbox] {
    margin-right: 0;
    margin-left: auto;
  }
}
@media (min-width: 768px) {
  .rtl-active .form-horizontal .control-label {
    text-align: left;
  }
}
.rtl-active .form-horizontal .has-feedback .form-control-feedback {
  left: 15px;
  right: auto;
}
.rtl-active .caret {
  margin-right: 2px;
  margin-left: 0;
}
.rtl-active .dropdown-menu {
  right: 0;
  left: auto;
  float: left;
  text-align: right;
}
.rtl-active .dropdown-menu.pull-right {
  left: 0;
  right: auto;
  float: right;
}
.rtl-active .dropdown-menu-right {
  left: auto;
  right: 0;
}
.rtl-active .dropdown-menu-left {
  left: 0;
  right: auto;
}
@media (min-width: 768px) {
  .rtl-active .navbar-right .dropdown-menu {
    left: auto;
    right: 0;
  }
  .rtl-active .navbar-right .dropdown-menu-left {
    left: 0;
    right: auto;
  }
}
.rtl-active .btn-group > .btn,
.rtl-active .btn-group-vertical > .btn {
  float: right;
}
.rtl-active .btn-group .btn + .btn,
.rtl-active .btn-group .btn + .btn-group,
.rtl-active .btn-group .btn-group + .btn,
.rtl-active .btn-group .btn-group + .btn-group {
  margin-right: -1px;
  margin-left: 0px;
}
.rtl-active .btn-toolbar {
  margin-right: -5px;
  margin-left: 0px;
}
.rtl-active .btn-toolbar .btn-group,
.rtl-active .btn-toolbar .input-group {
  float: right;
}
.rtl-active .btn-toolbar > .btn,
.rtl-active .btn-toolbar > .btn-group,
.rtl-active .btn-toolbar > .input-group {
  margin-right: 5px;
  margin-left: 0px;
}
.rtl-active .btn-group > .btn:first-child {
  margin-right: 0;
}
.rtl-active .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.rtl-active .btn-group > .btn:last-child:not(:first-child),
.rtl-active .btn-group > .dropdown-toggle:not(:first-child) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.rtl-active .btn-group > .btn-group {
  float: right;
}
.rtl-active .btn-group.btn-group-justified > .btn,
.rtl-active .btn-group.btn-group-justified > .btn-group {
  float: none;
}
.rtl-active .btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}
.rtl-active .btn-group > .btn-group:first-child > .btn:last-child,
.rtl-active .btn-group > .btn-group:first-child > .dropdown-toggle {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.rtl-active .btn-group > .btn-group:last-child > .btn:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.rtl-active .btn .caret {
  margin-right: 0;
}
.rtl-active .btn-group-vertical > .btn + .btn,
.rtl-active .btn-group-vertical > .btn + .btn-group,
.rtl-active .btn-group-vertical > .btn-group + .btn,
.rtl-active .btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-right: 0;
}
.rtl-active .input-group .form-control {
  float: right;
}
.rtl-active .input-group .form-control:first-child,
.rtl-active .input-group-addon:first-child,
.rtl-active .input-group-btn:first-child > .btn,
.rtl-active .input-group-btn:first-child > .btn-group > .btn,
.rtl-active .input-group-btn:first-child > .dropdown-toggle,
.rtl-active .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.rtl-active .input-group-btn:last-child > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.rtl-active .input-group-addon:first-child {
  border-left: 0px;
  border-right: 1px solid;
}
.rtl-active .input-group .form-control:last-child,
.rtl-active .input-group-addon:last-child,
.rtl-active .input-group-btn:last-child > .btn,
.rtl-active .input-group-btn:last-child > .btn-group > .btn,
.rtl-active .input-group-btn:last-child > .dropdown-toggle,
.rtl-active .input-group-btn:first-child > .btn:not(:first-child),
.rtl-active .input-group-btn:first-child > .btn-group:not(:first-child) > .btn {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.rtl-active .input-group-addon:last-child {
  border-left-width: 1px;
  border-left-style: solid;
  border-right: 0px;
}
.rtl-active .input-group-btn > .btn + .btn {
  margin-right: -1px;
  margin-left: auto;
}
.rtl-active .input-group-btn:first-child > .btn,
.rtl-active .input-group-btn:first-child > .btn-group {
  margin-left: -1px;
  margin-right: auto;
}
.rtl-active .input-group-btn:last-child > .btn,
.rtl-active .input-group-btn:last-child > .btn-group {
  margin-right: -1px;
  margin-left: auto;
}
.rtl-active .nav {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}
.rtl-active .nav-tabs > li {
  float: right;
}
.rtl-active .nav-tabs > li > a {
  margin-left: auto;
  margin-right: -2px;
  border-radius: 4px 4px 0 0;
}
.rtl-active .nav-pills > li {
  float: right;
}
.rtl-active .nav-pills > li > a {
  border-radius: 4px;
}
.rtl-active .nav-pills > li + li {
  margin-right: 2px;
  margin-left: auto;
}
.rtl-active .nav-stacked > li {
  float: none;
}
.rtl-active .nav-stacked > li + li {
  margin-right: 0;
  margin-left: auto;
}
.rtl-active .nav-justified > .dropdown .dropdown-menu {
  right: auto;
}
.rtl-active .nav-tabs-justified > li > a {
  margin-left: 0;
  margin-right: auto;
}
@media (min-width: 768px) {
  .rtl-active .nav-tabs-justified > li > a {
    border-radius: 4px 4px 0 0;
  }
}
@media (min-width: 768px) {
  .rtl-active .navbar-header {
    float: right;
  }
}
.rtl-active .navbar-collapse {
  padding-right: 15px;
  padding-left: 15px;
}
.rtl-active .navbar-brand {
  float: right;
}
@media (min-width: 768px) {
  .rtl-active .navbar > .container .navbar-brand,
.rtl-active .navbar > .container-fluid .navbar-brand,
.rtl-active .navbar > .container-sm .navbar-brand,
.rtl-active .navbar > .container-md .navbar-brand,
.rtl-active .navbar > .container-lg .navbar-brand,
.rtl-active .navbar > .container-xl .navbar-brand {
    margin-right: -15px;
    margin-left: auto;
  }
}
.rtl-active .navbar-toggle {
  float: left;
  margin-left: 15px;
  margin-right: auto;
}
@media (max-width: 767px) {
  .rtl-active .navbar-nav .open .dropdown-menu > li > a,
.rtl-active .navbar-nav .open .dropdown-menu .dropdown-header {
    padding: 5px 25px 5px 15px;
  }
}
@media (min-width: 768px) {
  .rtl-active .navbar-nav {
    float: right;
  }
  .rtl-active .navbar-nav > li {
    float: right;
  }
}
@media (min-width: 768px) {
  .rtl-active .navbar-left.flip {
    float: right !important;
  }
  .rtl-active .navbar-right:last-child {
    margin-left: -15px;
    margin-right: auto;
  }
  .rtl-active .navbar-right.flip {
    float: left !important;
    margin-left: -15px;
    margin-right: auto;
  }
  .rtl-active .navbar-right .dropdown-menu {
    left: 0;
    right: auto;
  }
}
@media (min-width: 768px) {
  .rtl-active .navbar-text {
    float: right;
  }
  .rtl-active .navbar-text.navbar-right:last-child {
    margin-left: 0;
    margin-right: auto;
  }
}
.rtl-active .pagination {
  padding-right: 0;
}
.rtl-active .pagination > li > a,
.rtl-active .pagination > li > span {
  float: right;
  margin-right: -1px;
  margin-left: 0px;
}
.rtl-active .pagination > li:first-child > a,
.rtl-active .pagination > li:first-child > span {
  margin-left: 0;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.rtl-active .pagination > li:last-child > a,
.rtl-active .pagination > li:last-child > span {
  margin-right: -1px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.rtl-active .pager {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}
.rtl-active .pager .next > a,
.rtl-active .pager .next > span {
  float: left;
}
.rtl-active .pager .previous > a,
.rtl-active .pager .previous > span {
  float: right;
}
.rtl-active .nav-pills > li > a > .badge {
  margin-left: 0px;
  margin-right: 3px;
}
.rtl-active .list-group-item > .badge {
  float: left;
}
.rtl-active .list-group-item > .badge + .badge {
  margin-left: 5px;
  margin-right: auto;
}
.rtl-active .alert-dismissable,
.rtl-active .alert-dismissible {
  padding-left: 35px;
  padding-right: 15px;
}
.rtl-active .alert-dismissable .close,
.rtl-active .alert-dismissible .close {
  right: auto;
  left: -21px;
}
.rtl-active .progress-bar {
  float: right;
}
.rtl-active .media > .pull-left {
  margin-right: 10px;
}
.rtl-active .media > .pull-left.flip {
  margin-right: 0;
  margin-left: 10px;
}
.rtl-active .media > .pull-right {
  margin-left: 10px;
}
.rtl-active .media > .pull-right.flip {
  margin-left: 0;
  margin-right: 10px;
}
.rtl-active .media-right,
.rtl-active .media > .pull-right {
  padding-right: 10px;
  padding-left: 0;
  padding-left: initial;
}
.rtl-active .media-left,
.rtl-active .media > .pull-left {
  padding-left: 10px;
  padding-right: 0;
  padding-right: initial;
}
.rtl-active .media-list {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
  list-style: none;
}
.rtl-active .list-group {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}
.rtl-active .panel > .table:first-child > thead:first-child > tr:first-child td:first-child,
.rtl-active .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,
.rtl-active .panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,
.rtl-active .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,
.rtl-active .panel > .table:first-child > thead:first-child > tr:first-child th:first-child,
.rtl-active .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,
.rtl-active .panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,
.rtl-active .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {
  border-top-right-radius: 3px;
  border-top-left-radius: 0;
}
.rtl-active .panel > .table:first-child > thead:first-child > tr:first-child td:last-child,
.rtl-active .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,
.rtl-active .panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,
.rtl-active .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,
.rtl-active .panel > .table:first-child > thead:first-child > tr:first-child th:last-child,
.rtl-active .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,
.rtl-active .panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,
.rtl-active .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {
  border-top-left-radius: 3px;
  border-top-right-radius: 0;
}
.rtl-active .panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,
.rtl-active .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,
.rtl-active .panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
.rtl-active .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
.rtl-active .panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,
.rtl-active .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,
.rtl-active .panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,
.rtl-active .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {
  border-bottom-left-radius: 3px;
  border-top-right-radius: 0;
}
.rtl-active .panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,
.rtl-active .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,
.rtl-active .panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
.rtl-active .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
.rtl-active .panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,
.rtl-active .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,
.rtl-active .panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,
.rtl-active .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {
  border-bottom-right-radius: 3px;
  border-top-left-radius: 0;
}
.rtl-active .panel > .table-bordered > thead > tr > th:first-child,
.rtl-active .panel > .table-responsive > .table-bordered > thead > tr > th:first-child,
.rtl-active .panel > .table-bordered > tbody > tr > th:first-child,
.rtl-active .panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,
.rtl-active .panel > .table-bordered > tfoot > tr > th:first-child,
.rtl-active .panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,
.rtl-active .panel > .table-bordered > thead > tr > td:first-child,
.rtl-active .panel > .table-responsive > .table-bordered > thead > tr > td:first-child,
.rtl-active .panel > .table-bordered > tbody > tr > td:first-child,
.rtl-active .panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,
.rtl-active .panel > .table-bordered > tfoot > tr > td:first-child,
.rtl-active .panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {
  border-right: 0;
  border-left: none;
}
.rtl-active .panel > .table-bordered > thead > tr > th:last-child,
.rtl-active .panel > .table-responsive > .table-bordered > thead > tr > th:last-child,
.rtl-active .panel > .table-bordered > tbody > tr > th:last-child,
.rtl-active .panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,
.rtl-active .panel > .table-bordered > tfoot > tr > th:last-child,
.rtl-active .panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,
.rtl-active .panel > .table-bordered > thead > tr > td:last-child,
.rtl-active .panel > .table-responsive > .table-bordered > thead > tr > td:last-child,
.rtl-active .panel > .table-bordered > tbody > tr > td:last-child,
.rtl-active .panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,
.rtl-active .panel > .table-bordered > tfoot > tr > td:last-child,
.rtl-active .panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {
  border-right: none;
  border-left: 0;
}
.rtl-active .embed-responsive .embed-responsive-item,
.rtl-active .embed-responsive iframe,
.rtl-active .embed-responsive embed,
.rtl-active .embed-responsive object {
  right: 0;
  left: auto;
}
.rtl-active .close {
  float: left;
}
.rtl-active .modal-footer {
  text-align: left;
}
.rtl-active .modal-footer.flip {
  text-align: right;
}
.rtl-active .modal-footer .btn + .btn {
  margin-left: auto;
  margin-right: 5px;
}
.rtl-active .modal-footer .btn-group .btn + .btn {
  margin-right: -1px;
  margin-left: auto;
}
.rtl-active .modal-footer .btn-block + .btn-block {
  margin-right: 0;
  margin-left: auto;
}
.rtl-active .popover {
  left: auto;
  text-align: right;
}
.rtl-active .popover.top > .arrow {
  right: 50%;
  left: auto;
  margin-right: -11px;
  margin-left: auto;
}
.rtl-active .popover.top > .arrow:after {
  margin-right: -10px;
  margin-left: auto;
}
.rtl-active .popover.bottom > .arrow {
  right: 50%;
  left: auto;
  margin-right: -11px;
  margin-left: auto;
}
.rtl-active .popover.bottom > .arrow:after {
  margin-right: -10px;
  margin-left: auto;
}
.rtl-active .carousel-control {
  right: 0;
  bottom: 0;
}
.rtl-active .carousel-control.left {
  right: auto;
  left: 0;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#80000000", endColorstr="#00000000", GradientType=1 );
}
.rtl-active .carousel-control.right {
  left: auto;
  right: 0;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00000000", endColorstr="#80000000", GradientType=1 );
}
.rtl-active .carousel-control .icon-prev,
.rtl-active .carousel-control .glyphicon-chevron-left {
  left: 50%;
  right: auto;
  margin-right: -10px;
}
.rtl-active .carousel-control .icon-next,
.rtl-active .carousel-control .glyphicon-chevron-right {
  right: 50%;
  left: auto;
  margin-left: -10px;
}
.rtl-active .carousel-indicators {
  right: 50%;
  left: 0;
  margin-right: -30%;
  margin-left: 0;
  padding-left: 0;
}
@media screen and (min-width: 768px) {
  .rtl-active .carousel-control .glyphicon-chevron-left,
.rtl-active .carousel-control .icon-prev {
    margin-left: 0;
    margin-right: -15px;
  }
  .rtl-active .carousel-control .glyphicon-chevron-right,
.rtl-active .carousel-control .icon-next {
    margin-left: 0;
    margin-right: -15px;
  }
  .rtl-active .carousel-caption {
    left: 20%;
    right: 20%;
    padding-bottom: 30px;
  }
}
.rtl-active .pull-right.flip {
  float: left !important;
}
.rtl-active .pull-left.flip {
  float: right !important;
}

.btn + .btn {
  margin-left: 4px;
}

.btn-group + .btn-group {
  margin-left: 4px;
}

.card-tasks .card-header .title {
  margin-right: 24px;
}

.form-check.form-check-inline + .form-check.form-check-inline {
  margin-left: 4px;
}

.custom-switch .custom-control-label {
  margin-bottom: 0px;
  line-height: 22px;
  vertical-align: middle;
}
.custom-switch .custom-control-label::before {
  height: 22px;
  width: 45px;
  border: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-position: center center;
  background-size: cover;
}
.custom-switch .custom-control-label::after {
  height: 18px;
  width: 18px;
  background-color: rgba(156, 156, 156, 0.9);
  transition: all 0.25s ease-out;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #ffffff;
  transform: translateX(23px);
}
.custom-switch:hover .custom-control-label::after {
  width: 23px;
}
.custom-switch:hover .custom-control-input:checked ~ .custom-control-label::after {
  margin-left: -5px;
}

.dropdown-menu .dropdown-header:not([href]) {
  color: hsla(0deg, 0%, 71%, 0.6);
  font-size: 0.62475rem;
  text-transform: uppercase;
  font-weight: 600;
}

.fileinput > input[type=file] {
  display: none;
}

.fixed-plugin li.adjustments-line {
  height: auto;
  padding-top: 5px;
  padding-bottom: 5px;
}
.fixed-plugin li.adjustments-line .togglebutton .label-switch:last-child {
  left: auto;
  left: initial;
  right: -10px;
}
.fixed-plugin li.header-title {
  height: auto;
  padding-top: 5px;
  padding-bottom: 5px;
}
.fixed-plugin li.button-container {
  padding-top: 5px;
  padding-bottom: 5px;
}

.footer .footer-nav ul li + li {
  margin-left: 4px;
}

* textarea.form-control,
.login-page textarea.form-control,
.card-login.card-white textarea.form-control {
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
}
* textarea.form-control:focus, * textarea.form-control:active,
.login-page textarea.form-control:focus,
.login-page textarea.form-control:active,
.card-login.card-white textarea.form-control:focus,
.card-login.card-white textarea.form-control:active {
  border: 1px solid #e564d1;
}
* .form-group:not(.has-danger):not(.has-success) .input-group-prepend .input-group-text,
* .form-group:not(.has-danger):not(.has-success) .input-group-append .input-group-text,
* .input-group-focus:not(.has-danger):not(.has-success) .input-group-prepend .input-group-text,
* .input-group-focus:not(.has-danger):not(.has-success) .input-group-append .input-group-text,
.login-page .form-group:not(.has-danger):not(.has-success) .input-group-prepend .input-group-text,
.login-page .form-group:not(.has-danger):not(.has-success) .input-group-append .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .input-group-prepend .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .input-group-append .input-group-text,
.card-login.card-white .form-group:not(.has-danger):not(.has-success) .input-group-prepend .input-group-text,
.card-login.card-white .form-group:not(.has-danger):not(.has-success) .input-group-append .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .input-group-prepend .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .input-group-append .input-group-text {
  border-color: #1d8cf8;
}
* .form-group:not(.has-danger):not(.has-success) .form-control:focus,
* .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus,
.login-page .form-group:not(.has-danger):not(.has-success) .form-control:focus,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus,
.card-login.card-white .form-group:not(.has-danger):not(.has-success) .form-control:focus,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus {
  border-color: #1d8cf8;
}
* .form-group:not(.has-danger):not(.has-success) .form-control:focus + .input-group-append .input-group-text, * .form-group:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-append .input-group-text, * .form-group:not(.has-danger):not(.has-success) .form-control:focus + .input-group-prepend .input-group-text, * .form-group:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-prepend .input-group-text,
* .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus + .input-group-append .input-group-text,
* .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-append .input-group-text,
* .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus + .input-group-prepend .input-group-text,
* .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-prepend .input-group-text,
.login-page .form-group:not(.has-danger):not(.has-success) .form-control:focus + .input-group-append .input-group-text,
.login-page .form-group:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-append .input-group-text,
.login-page .form-group:not(.has-danger):not(.has-success) .form-control:focus + .input-group-prepend .input-group-text,
.login-page .form-group:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-prepend .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus + .input-group-append .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-append .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus + .input-group-prepend .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-prepend .input-group-text,
.card-login.card-white .form-group:not(.has-danger):not(.has-success) .form-control:focus + .input-group-append .input-group-text,
.card-login.card-white .form-group:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-append .input-group-text,
.card-login.card-white .form-group:not(.has-danger):not(.has-success) .form-control:focus + .input-group-prepend .input-group-text,
.card-login.card-white .form-group:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-prepend .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus + .input-group-append .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-append .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus + .input-group-prepend .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #1d8cf8;
}
* .input-group-focus:not(.has-danger):not(.has-success) .form-control,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control {
  border-color: #1d8cf8;
}
* .input-group-focus:not(.has-danger):not(.has-success) .form-control + .input-group-append .input-group-text, * .input-group-focus:not(.has-danger):not(.has-success) .form-control ~ .input-group-append .input-group-text, * .input-group-focus:not(.has-danger):not(.has-success) .form-control + .input-group-prepend .input-group-text, * .input-group-focus:not(.has-danger):not(.has-success) .form-control ~ .input-group-prepend .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control + .input-group-append .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control ~ .input-group-append .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control + .input-group-prepend .input-group-text,
.login-page .input-group-focus:not(.has-danger):not(.has-success) .form-control ~ .input-group-prepend .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control + .input-group-append .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control ~ .input-group-append .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control + .input-group-prepend .input-group-text,
.card-login.card-white .input-group-focus:not(.has-danger):not(.has-success) .form-control ~ .input-group-prepend .input-group-text {
  border: 1px solid #1d8cf8;
}

.sweet-alert input.form-control:focus {
  border-color: #1d8cf8;
}
.sweet-alert input.form-control:focus + .input-group-append .input-group-text, .sweet-alert input.form-control:focus ~ .input-group-append .input-group-text, .sweet-alert input.form-control:focus + .input-group-prepend .input-group-text, .sweet-alert input.form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #1d8cf8;
}

.form-group .input-group-append .input-group-text,
.input-group .input-group-append .input-group-text {
  padding: 10px 18px 10px 0;
}

.input-group-text {
  line-height: 1;
}

.form-control + .input-group-append .input-group-text,
.form-control + .input-group-prepend .input-group-text {
  background-color: transparent;
}

.input-group-append,
.input-group-prepend {
  border: 0;
}

.input-group-append:last-child .input-group-text {
  border-left: 0 !important;
}

.input-group .form-control:not(:first-child):not(:last-child),
.input-group-btn:not(:first-child):not(:last-child) {
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.modal.fade .modal-dialog {
  animation-duration: 0s;
  animation-duration: initial;
  animation-fill-mode: none;
  animation-fill-mode: initial;
  animation-name: none;
  animation-name: initial;
}
.modal.show.modal-long .modal-dialog {
  transform: translateY(10%);
}

.modal-content .modal-body + .modal-footer {
  padding: 24px 24px 16px;
}

@media (max-width: 991.98px) {
  .navbar .dropdown.show .dropdown-menu {
    position: static !important;
  }
  .navbar:not(.bg-white) .dropdown.show .dropdown-menu .dropdown-item {
    color: rgba(255, 255, 255, 0.8);
  }
  .navbar:not(.bg-white) .navbar-nav .btn span {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  nav.navbar {
    top: 0px;
  }
}
@media (max-width: 767.98px) {
  .navbar .navbar-wrapper .navbar-toggle {
    transition: all 1s;
  }
  .navbar .navbar-wrapper .navbar-toggle.toggled {
    left: -20px;
    position: relative;
    right: auto;
    right: initial;
    transition: all 1s;
  }
  .rtl .navbar .navbar-wrapper .navbar-toggle.toggled {
    right: -35px;
    position: relative;
    left: auto;
    left: initial;
    transition: all 1s;
  }
}
.nav-link:hover {
  color: #1d8cf8;
}

.rtl .sidebar .nav li.active > a[data-toggle=collapse]:before,
.rtl .sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:before {
  right: -4px;
  left: auto;
}
.rtl .sidebar .logo a.logo-mini {
  margin-right: 15px;
  margin-left: 15px;
}
.rtl .fixed-plugin {
  border-radius: 0 8px 8px 0;
  left: 0;
  right: auto;
  right: initial;
}
.rtl .fixed-plugin .dropdown-menu {
  left: 80px !important;
  right: auto !important;
}
.rtl .fixed-plugin .dropdown-menu:before, .rtl .fixed-plugin .dropdown-menu:after {
  left: 10px;
  margin-right: auto;
  right: auto;
}
.rtl .fixed-plugin .dropdown-menu:before {
  right: auto;
  right: initial;
  left: -16px;
  border-left: 0;
  border-left: initial;
  border-right: 0.4em solid rgba(0, 0, 0, 0.2);
}
.rtl .fixed-plugin .dropdown-menu:after {
  right: auto;
  right: initial;
  left: -16px;
  border-left: 0;
  border-left: initial;
  border-right: 0.4em solid #222a42;
}
.rtl .card-tasks .card-header .title {
  margin-right: 0;
  margin-left: 24px;
}
.rtl .main-panel {
  overflow-y: scroll; /* has to be scroll, not auto */
  -webkit-overflow-scrolling: touch;
}

.sidebar .logo .logo-mini .logo-img img {
  border-radius: 50%;
  width: 30px;
}

.perfect-scrollbar-on .sidebar {
  height: 84%;
}

@media (max-width: 767.98px) {
  .sidebar {
    height: 100%;
  }
}
@media (max-width: 991.98px) {
  .perfect-scrollbar-on .sidebar {
    height: 100%;
  }
  html.nav-open body {
    position: relative;
    overflow-x: hidden;
  }
  html.nav-open .main-panel {
    overflow: auto;
    min-height: 0;
    min-height: initial;
  }
  html.nav-open .wrapper {
    overflow: hidden;
  }
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav li:not(.active) a .sidebar-normal {
  color: rgba(255, 255, 255, 0.8);
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav li:not(.active) a::before {
  display: none;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow 0.75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.white-content .ReactTable .-pagination input,
.white-content .ReactTable .-pagination select,
.white-content .ReactTable .rt-thead.-filters input,
.white-content .ReactTable .rt-thead.-filters select {
  color: #222a42;
}
.white-content .ReactTable .rt-td,
.white-content .ReactTable .rt-thead .rt-th {
  color: rgba(34, 42, 66, 0.7) !important;
}
.white-content .ReactTable .rt-tbody .rt-tr,
.white-content .ReactTable .rt-thead.-filters .rt-tr {
  border-color: rgba(34, 42, 66, 0.2);
}
.white-content .ReactTable.-striped .rt-tr.-odd {
  background-color: rgba(0, 0, 0, 0.05);
}
.white-content .rbc-today {
  background: #d3d7e9;
}
.white-content .rbc-day-bg + .rbc-day-bg,
.white-content .rbc-month-row,
.white-content .rbc-time-content > * + * > *,
.white-content .rbc-timeslot-group,
.white-content .rbc-row.rbc-time-header-cell,
.white-content .rbc-time-header-content,
.white-content .rbc-day-slot .rbc-time-slot + .rbc-time-slot,
.white-content .rbc-agenda-view table.rbc-agenda-table,
.white-content .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td,
.white-content .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr,
.white-content .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  border-color: #9499a7;
}
.white-content .rbc-agenda-time-cell,
.white-content .rbc-agenda-date-cell,
.white-content .rbc-date-cell > a,
.white-content .rbc-date-cell > a:active,
.white-content .rbc-date-cell > a:visited,
.white-content .rbc-agenda-event-cell {
  color: #222a42;
}
.white-content .rbc-toolbar .rbc-toolbar-label {
  color: #1d253b;
}
.white-content .rbc-header,
.white-content .rbc-header > a,
.white-content .rbc-header > a:active,
.white-content .rbc-header > a:visited,
.white-content .rbc-header > a:hover,
.white-content .rbc-time-gutter.rbc-time-column {
  color: #344675;
}
.white-content .card .map-title {
  color: #1d253b;
}
.white-content .nav-pills .nav-item .nav-link:not(.active) {
  background: #d3d7e9;
  color: #1d253b;
}
.white-content .form-group:not(.has-danger):not(.has-success) .input-group-prepend .input-group-text,
.white-content .form-group:not(.has-danger):not(.has-success) .input-group-append .input-group-text,
.white-content .input-group-focus:not(.has-danger):not(.has-success) .input-group-prepend .input-group-text,
.white-content .input-group-focus:not(.has-danger):not(.has-success) .input-group-append .input-group-text {
  border-color: #1d8cf8;
}
.white-content .form-group:not(.has-danger):not(.has-success) .form-control:focus,
.white-content .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus {
  border-color: #1d8cf8;
}
.white-content .form-group:not(.has-danger):not(.has-success) .form-control:focus + .input-group-append .input-group-text, .white-content .form-group:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-append .input-group-text, .white-content .form-group:not(.has-danger):not(.has-success) .form-control:focus + .input-group-prepend .input-group-text, .white-content .form-group:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-prepend .input-group-text,
.white-content .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus + .input-group-append .input-group-text,
.white-content .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-append .input-group-text,
.white-content .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus + .input-group-prepend .input-group-text,
.white-content .input-group-focus:not(.has-danger):not(.has-success) .form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #1d8cf8;
}
.white-content .form-group.has-danger .input-group-prepend .input-group-text,
.white-content .form-group.has-danger .input-group-append .input-group-text,
.white-content .input-group-focus.has-danger .input-group-prepend .input-group-text,
.white-content .input-group-focus.has-danger .input-group-append .input-group-text {
  border-color: #fd5d93;
}
.white-content .form-group.has-danger .form-control:focus,
.white-content .input-group-focus.has-danger .form-control:focus {
  border-color: #fd5d93;
}
.white-content .form-group.has-danger .form-control:focus + .input-group-append .input-group-text, .white-content .form-group.has-danger .form-control:focus ~ .input-group-append .input-group-text, .white-content .form-group.has-danger .form-control:focus + .input-group-prepend .input-group-text, .white-content .form-group.has-danger .form-control:focus ~ .input-group-prepend .input-group-text,
.white-content .input-group-focus.has-danger .form-control:focus + .input-group-append .input-group-text,
.white-content .input-group-focus.has-danger .form-control:focus ~ .input-group-append .input-group-text,
.white-content .input-group-focus.has-danger .form-control:focus + .input-group-prepend .input-group-text,
.white-content .input-group-focus.has-danger .form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #fd5d93;
}

.footer-login .footer {
  padding: 24px 38px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/black-dashboard-pro-react.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_variables.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/_inputs.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_reboot.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_global.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_backgrounds.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_floating.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_helper.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_position.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_sizing.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_spacing.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_shadows.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_text.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/utilities/_transform.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_alerts.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_avatars.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_badge.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_buttons.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/_buttons.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/opacity.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_close.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_custom-forms.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_dropdown.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/_dropdown.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_footer.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_forms.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_grid.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_icons.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/_icon.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_images.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_input-group.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_info-areas.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_modal.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/_modals.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_nav.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_navbar.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_pagination.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_tabs.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_pills.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_popover.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/_popovers.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_progress.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_type.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_tables.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_checkboxes-radio.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_fixed-plugin.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_misc.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_rtl.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_timeline.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-datetimepicker.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-nouislider.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-fullcalendar.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-sweetalert2.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-bootstrap-switch.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-bootstrap-select.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-jasny-fileupload.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-tagsinput.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-perfect-scrollbar.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-jquery.jvectormap.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-datatables.net.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-animate-bootstrap-notify.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-card-wizard.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/mixins/_wizard.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/vendor/_plugin-chartjs.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_example-pages.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_white-content.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/_card.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-chart.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-map.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-user.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-task.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-animation-on-hover.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-collapse.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-contributions.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-lock.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-pricing.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-profile.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-plain.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-register.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-stats.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-subcategories.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-testimonials.scss","webpack://./src/assets/scss/black-dashboard-pro-react/custom/cards/_card-wizard.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-big-calendar.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-bootstrap-sweetalert.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-bootstrap-switch.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-bootstrap-wizard.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-jvectormap.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-select.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-table.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/plugins/_plugin-react-tagsinput.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_alerts.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_badges.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_bootstrap-rtl.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_buttons.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_cards.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_checkboxes-radio.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_custom-forms.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_dropdown.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_fileinput.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_fixed-plugin.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_footers.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_inputs.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_modals.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_navbar.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_rtl.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_spinners.scss","webpack://./src/assets/scss/black-dashboard-pro-react/react/_white-content.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC2MhB,kCAAA;AA2hBA,iBAAA;AC5fA;EACI,mCAAA;AFtOJ;;AEwOA;EACI,cAAA;AFrOJ;;AGTA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,kBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,kOAAA;EACA,6GAAA;AH6BF;;AI5BA;;;EAGE,sBAAA;AJ+BF;;AI5BA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gDAAA;AJ+BF;;AIzBA;EACE,cAAA;AJ4BF;;AIlBA;EACE,SAAA;EACA,kCH4U4B;EIvMxB,mBAAA;EDnIJ,gBH6V4B;EG5V5B,gBEmP4B;EFlP5B,cH9BS;EG+BT,gBAAA;EACA,yBHkE2B;AD7C7B;;AITA;EACE,qBAAA;AJYF;;AIHA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AJMF;;AIOA;EACE,aAAA;EACA,qBH0T4B;AD9T9B;;AIWA;EACE,aAAA;EACA,mBEoF0B;AN5F5B;;AImBA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;UAAA,8BAAA;AJhBF;;AImBA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJhBF;;AImBA;;;EAGE,aAAA;EACA,mBAAA;AJhBF;;AImBA;;;;EAIE,gBAAA;AJhBF;;AImBA;EACE,gBHgQ4B;ADhR9B;;AImBA;EACE,qBAAA;EACA,cAAA;AJhBF;;AImBA;EACE,gBAAA;AJhBF;;AImBA;;EAEE,mBEqI4B;ANrJ9B;;AImBA;ECII,cAAA;ALnBJ;;AIwBA;;EAEE,kBAAA;ECPE,cAAA;EDSF,cAAA;EACA,wBAAA;AJrBF;;AIwBA;EAAM,eAAA;AJpBN;;AIqBA;EAAM,WAAA;AJjBN;;AIwBA;EACE,cHvFc;EGwFd,qBHqE0B;EGpE1B,6BAAA;AJrBF;AO3JE;EHmLE,cHkEwB;EGjExB,qBHkEwB;ADvF5B;;AI8BA;EACE,cAAA;EACA,qBAAA;AJ3BF;AOpKE;EHkME,cAAA;EACA,qBAAA;AJ3BJ;;AIoCA;;;;EAIE,iGE0D4B;EDlH1B,cAAA;ALwBJ;;AIoCA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AJtCF;;AI8CA;EAEE,gBAAA;AJ5CF;;AIoDA;EACE,sBAAA;EACA,kBAAA;AJjDF;;AIoDA;EAGE,gBAAA;EACA,sBAAA;AJnDF;;AI2DA;EACE,yBAAA;AJxDF;;AI2DA;EACE,iBHgN4B;EG/M5B,oBH+M4B;EG9M5B,cH/PS;EGgQT,gBAAA;EACA,oBAAA;AJxDF;;AI+DA;EAEE,mBAAA;EACA,gCAAA;AJ7DF;;AIqEA;EAEE,qBAAA;EACA,qBE4JsC;AN/NxC;;AIyEA;EAEE,gBAAA;AJvEF;;AI+EA;EACE,UAAA;AJ5EF;;AI+EA;;;;;EAKE,SAAA;EACA,oBAAA;EChKE,kBAAA;EDkKF,oBAAA;AJ5EF;;AI+EA;;EAEE,iBAAA;AJ5EF;;AI+EA;;EAEE,oBAAA;AJ5EF;;AIkFA;EACE,eAAA;AJ/EF;;AIqFA;EACE,iBAAA;AJlFF;;AIyFA;;;;EAIE,0BAAA;AJtFF;;AI+FI;;;;EACE,eAAA;AJzFN;;AI+FA;;;;EAIE,UAAA;EACA,kBAAA;AJ5FF;;AI+FA;;EAEE,sBAAA;EACA,UAAA;AJ5FF;;AIgGA;EACE,cAAA;EAEA,gBAAA;AJ9FF;;AIiGA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AJpGF;;AIyGA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EC9OI,iBAAA;EDgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AJtGF;;AIyGA;EACE,wBAAA;AJtGF;;AI0GA;;EAEE,YAAA;AJvGF;;AI0GA;EAKE,oBAAA;EACA,wBAAA;AJ3GF;;AIkHA;EACE,wBAAA;AJ/GF;;AIuHA;EACE,aAAA;EACA,0BAAA;AJpHF;;AI2HA;EACE,qBAAA;AJxHF;;AI2HA;EACE,kBAAA;EACA,eAAA;AJxHF;;AI2HA;EACE,aAAA;AJxHF;;AI6HA;EACE,wBAAA;AJ1HF;;AQlWA;;EAEE,qBP+Y4B;EO9Y5B,oBP+Y4B;EO9Y5B,gBPoY4B;EOnY5B,gBP+Y4B;EO9Y5B,cPUS;AD2VX;;AQlWA;EHqKM,0BAAA;ALiMN;;AQrWA;EHoKM,yBAAA;ALqMN;;AQxWA;EHmKM,yBAAA;ALyMN;;AQ3WA;EHkKM,0BAAA;AL6MN;;AQ9WA;EHiKM,yBAAA;ALiNN;;AQjXA;EHgKM,wBAAA;ALqNN;;AQnXA;EH8JM,qBAAA;EG5JJ,gBPoa4B;AD9C9B;;AQlXA;EHwJM,iBAAA;EGtJJ,gBPiX4B;EOhX5B,gBP2X4B;ADN9B;;AQnXA;EHmJM,kBAAA;EGjJJ,gBP4W4B;EO3W5B,gBPsX4B;ADA9B;;AQpXA;EH8IM,oBAAA;EG5IJ,gBPuW4B;EOtW5B,gBPiX4B;ADM9B;;AQrXA;EHyIM,oBAAA;EGvIJ,gBPkW4B;EOjW5B,gBP4W4B;ADY9B;;AQhXA;EACE,gBPyZ4B;EOxZ5B,mBPwZ4B;EOvZ5B,SAAA;EACA,iDAAA;ARmXF;;AQ3WA;;EHkGI,cAAA;EG/FF,gBPyU4B;ADqC9B;;AQ3WA;;EAEE,cP8X4B;EO7X5B,yBPmY4B;ADrB9B;;AQtWA;EC/EE,eAAA;EACA,gBAAA;ATybF;;AQtWA;ECpFE,eAAA;EACA,gBAAA;AT8bF;;AQxWA;EACE,qBAAA;AR2WF;AQzWE;EACE,oBP6W0B;ADF9B;;AQjWA;EH2DI,cAAA;EGzDF,yBAAA;ARoWF;;AQhWA;EACE,mBPyKO;EIrGH,oBAAA;ALgSN;;AQhWA;EACE,cAAA;EH+CE,cAAA;EG7CF,cPnGS;ADscX;AQjWE;EACE,aAAA;ARmWJ;;AUtdA;ECIE,eAAA;EAGA,YAAA;AXodF;;AUrdA;EACE,gBJqgCkC;EIpgClC,yBTwG2B;ESvG3B,+BAAA;EEEE,sBAAA;ECFE,6CHEJ;ECPA,eAAA;EAGA,YAAA;AX8dF;;AUhdA;EAEE,qBAAA;AVkdF;;AU/cA;EACE,qBAAA;EACA,cAAA;AVkdF;;AU/cA;EL8HI,cAAA;EK5HF,cTpBS;ADseX;;AczfA;ETmKI,gBAAA;ESjKF,cb2CQ;Ea1CR,qBAAA;Ad4fF;AczfE;EACE,cAAA;Ad2fJ;;ActfA;EACE,sBAAA;ETsJE,gBAAA;ESpJF,cbFS;EaGT,yBbMS;EWLP,wBAAA;ECFE,oDCGJ;AdyfF;AcvfE;EACE,UAAA;ET8IA,eAAA;ES5IA,gBbuX0B;EY/XxB,gBCSF;AdyfJ;;AcpfA;EACE,cAAA;ETqIE,gBAAA;ESnIF,cbVS;ADigBX;AcpfE;ETgIE,kBAAA;ES9HA,cAAA;EACA,kBAAA;AdsfJ;;AcjfA;EACE,iBRikCkC;EQhkClC,kBAAA;AdofF;;Ae5hBE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AhBsiBF;;AiBnfI;EFzCE;IACE,gBT8Le;ENkWrB;AACF;AiBzfI;EFzCE;IACE,gBT8Le;ENuWrB;AACF;AiB9fI;EFzCE;IACE,gBT8Le;EN4WrB;AACF;AiBngBI;EFzCE;IACE,iBT8Le;ENiXrB;AACF;AephBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AhB0jBF;;AephBE;EACE,eAAA;EACA,cAAA;AfuhBJ;AerhBI;;EAEE,gBAAA;EACA,eAAA;AfuhBN;;AkB7kBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AlBqlBJ;;AkB/jBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AlBkkBR;;AgBtiBE;EACE,cAAA;EACA,eAAA;AhByiBJ;;AgB3iBE;EACE,aAAA;EACA,cAAA;AhB8iBJ;;AgBhjBE;EACE,wBAAA;EACA,yBAAA;AhBmjBJ;;AgBrjBE;EACE,aAAA;EACA,cAAA;AhBwjBJ;;AgB1jBE;EACE,aAAA;EACA,cAAA;AhB6jBJ;;AgB/jBE;EACE,wBAAA;EACA,yBAAA;AhBkkBJ;;AkBrlBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;AhBwlBF;;AkBrlBU;EFbR,qBAAA;EAIA,sBAAA;AhBmmBF;;AkB1lBU;EFbR,sBAAA;EAIA,uBAAA;AhBwmBF;;AkB/lBU;EFbR,aAAA;EAIA,cAAA;AhB6mBF;;AkBpmBU;EFbR,sBAAA;EAIA,uBAAA;AhBknBF;;AkBzmBU;EFbR,sBAAA;EAIA,uBAAA;AhBunBF;;AkB9mBU;EFbR,aAAA;EAIA,cAAA;AhB4nBF;;AkBnnBU;EFbR,sBAAA;EAIA,uBAAA;AhBioBF;;AkBxnBU;EFbR,sBAAA;EAIA,uBAAA;AhBsoBF;;AkB7nBU;EFbR,aAAA;EAIA,cAAA;AhB2oBF;;AkBloBU;EFbR,sBAAA;EAIA,uBAAA;AhBgpBF;;AkBvoBU;EFbR,sBAAA;EAIA,uBAAA;AhBqpBF;;AkB5oBU;EFbR,cAAA;EAIA,eAAA;AhB0pBF;;AkB3oBM;EAAwB,SAAA;AlB+oB9B;;AkB7oBM;EAAuB,SAAA;AlBipB7B;;AkB9oBQ;EAAwB,QADb;AlBmpBnB;;AkBlpBQ;EAAwB,QADb;AlBupBnB;;AkBtpBQ;EAAwB,QADb;AlB2pBnB;;AkB1pBQ;EAAwB,QADb;AlB+pBnB;;AkB9pBQ;EAAwB,QADb;AlBmqBnB;;AkBlqBQ;EAAwB,QADb;AlBuqBnB;;AkBtqBQ;EAAwB,QADb;AlB2qBnB;;AkB1qBQ;EAAwB,QADb;AlB+qBnB;;AkB9qBQ;EAAwB,QADb;AlBmrBnB;;AkBlrBQ;EAAwB,QADb;AlBurBnB;;AkBtrBQ;EAAwB,SADb;AlB2rBnB;;AkB1rBQ;EAAwB,SADb;AlB+rBnB;;AkB9rBQ;EAAwB,SADb;AlBmsBnB;;AkB3rBY;EFhBV,wBAAA;AhB+sBF;;AkB/rBY;EFhBV,yBAAA;AhBmtBF;;AkBnsBY;EFhBV,gBAAA;AhButBF;;AkBvsBY;EFhBV,yBAAA;AhB2tBF;;AkB3sBY;EFhBV,yBAAA;AhB+tBF;;AkB/sBY;EFhBV,gBAAA;AhBmuBF;;AkBntBY;EFhBV,yBAAA;AhBuuBF;;AkBvtBY;EFhBV,yBAAA;AhB2uBF;;AkB3tBY;EFhBV,gBAAA;AhB+uBF;;AkB/tBY;EFhBV,yBAAA;AhBmvBF;;AkBnuBY;EFhBV,yBAAA;AhBuvBF;;AiBlvBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBixBN;EgBrvBA;IACE,cAAA;IACA,eAAA;EhBuvBF;EgBzvBA;IACE,aAAA;IACA,cAAA;EhB2vBF;EgB7vBA;IACE,wBAAA;IACA,yBAAA;EhB+vBF;EgBjwBA;IACE,aAAA;IACA,cAAA;EhBmwBF;EgBrwBA;IACE,aAAA;IACA,cAAA;EhBuwBF;EgBzwBA;IACE,wBAAA;IACA,yBAAA;EhB2wBF;EkB9xBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhBgyBA;EkB7xBQ;IFbR,qBAAA;IAIA,sBAAA;EhB0yBA;EkBjyBQ;IFbR,sBAAA;IAIA,uBAAA;EhB8yBA;EkBryBQ;IFbR,aAAA;IAIA,cAAA;EhBkzBA;EkBzyBQ;IFbR,sBAAA;IAIA,uBAAA;EhBszBA;EkB7yBQ;IFbR,sBAAA;IAIA,uBAAA;EhB0zBA;EkBjzBQ;IFbR,aAAA;IAIA,cAAA;EhB8zBA;EkBrzBQ;IFbR,sBAAA;IAIA,uBAAA;EhBk0BA;EkBzzBQ;IFbR,sBAAA;IAIA,uBAAA;EhBs0BA;EkB7zBQ;IFbR,aAAA;IAIA,cAAA;EhB00BA;EkBj0BQ;IFbR,sBAAA;IAIA,uBAAA;EhB80BA;EkBr0BQ;IFbR,sBAAA;IAIA,uBAAA;EhBk1BA;EkBz0BQ;IFbR,cAAA;IAIA,eAAA;EhBs1BA;EkBv0BI;IAAwB,SAAA;ElB00B5B;EkBx0BI;IAAuB,SAAA;ElB20B3B;EkBx0BM;IAAwB,QADb;ElB40BjB;EkB30BM;IAAwB,QADb;ElB+0BjB;EkB90BM;IAAwB,QADb;ElBk1BjB;EkBj1BM;IAAwB,QADb;ElBq1BjB;EkBp1BM;IAAwB,QADb;ElBw1BjB;EkBv1BM;IAAwB,QADb;ElB21BjB;EkB11BM;IAAwB,QADb;ElB81BjB;EkB71BM;IAAwB,QADb;ElBi2BjB;EkBh2BM;IAAwB,QADb;ElBo2BjB;EkBn2BM;IAAwB,QADb;ElBu2BjB;EkBt2BM;IAAwB,SADb;ElB02BjB;EkBz2BM;IAAwB,SADb;ElB62BjB;EkB52BM;IAAwB,SADb;ElBg3BjB;EkBx2BU;IFhBV,cAAA;EhB23BA;EkB32BU;IFhBV,wBAAA;EhB83BA;EkB92BU;IFhBV,yBAAA;EhBi4BA;EkBj3BU;IFhBV,gBAAA;EhBo4BA;EkBp3BU;IFhBV,yBAAA;EhBu4BA;EkBv3BU;IFhBV,yBAAA;EhB04BA;EkB13BU;IFhBV,gBAAA;EhB64BA;EkB73BU;IFhBV,yBAAA;EhBg5BA;EkBh4BU;IFhBV,yBAAA;EhBm5BA;EkBn4BU;IFhBV,gBAAA;EhBs5BA;EkBt4BU;IFhBV,yBAAA;EhBy5BA;EkBz4BU;IFhBV,yBAAA;EhB45BA;AACF;AiBx5BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBs7BN;EgB15BA;IACE,cAAA;IACA,eAAA;EhB45BF;EgB95BA;IACE,aAAA;IACA,cAAA;EhBg6BF;EgBl6BA;IACE,wBAAA;IACA,yBAAA;EhBo6BF;EgBt6BA;IACE,aAAA;IACA,cAAA;EhBw6BF;EgB16BA;IACE,aAAA;IACA,cAAA;EhB46BF;EgB96BA;IACE,wBAAA;IACA,yBAAA;EhBg7BF;EkBn8BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhBq8BA;EkBl8BQ;IFbR,qBAAA;IAIA,sBAAA;EhB+8BA;EkBt8BQ;IFbR,sBAAA;IAIA,uBAAA;EhBm9BA;EkB18BQ;IFbR,aAAA;IAIA,cAAA;EhBu9BA;EkB98BQ;IFbR,sBAAA;IAIA,uBAAA;EhB29BA;EkBl9BQ;IFbR,sBAAA;IAIA,uBAAA;EhB+9BA;EkBt9BQ;IFbR,aAAA;IAIA,cAAA;EhBm+BA;EkB19BQ;IFbR,sBAAA;IAIA,uBAAA;EhBu+BA;EkB99BQ;IFbR,sBAAA;IAIA,uBAAA;EhB2+BA;EkBl+BQ;IFbR,aAAA;IAIA,cAAA;EhB++BA;EkBt+BQ;IFbR,sBAAA;IAIA,uBAAA;EhBm/BA;EkB1+BQ;IFbR,sBAAA;IAIA,uBAAA;EhBu/BA;EkB9+BQ;IFbR,cAAA;IAIA,eAAA;EhB2/BA;EkB5+BI;IAAwB,SAAA;ElB++B5B;EkB7+BI;IAAuB,SAAA;ElBg/B3B;EkB7+BM;IAAwB,QADb;ElBi/BjB;EkBh/BM;IAAwB,QADb;ElBo/BjB;EkBn/BM;IAAwB,QADb;ElBu/BjB;EkBt/BM;IAAwB,QADb;ElB0/BjB;EkBz/BM;IAAwB,QADb;ElB6/BjB;EkB5/BM;IAAwB,QADb;ElBggCjB;EkB//BM;IAAwB,QADb;ElBmgCjB;EkBlgCM;IAAwB,QADb;ElBsgCjB;EkBrgCM;IAAwB,QADb;ElBygCjB;EkBxgCM;IAAwB,QADb;ElB4gCjB;EkB3gCM;IAAwB,SADb;ElB+gCjB;EkB9gCM;IAAwB,SADb;ElBkhCjB;EkBjhCM;IAAwB,SADb;ElBqhCjB;EkB7gCU;IFhBV,cAAA;EhBgiCA;EkBhhCU;IFhBV,wBAAA;EhBmiCA;EkBnhCU;IFhBV,yBAAA;EhBsiCA;EkBthCU;IFhBV,gBAAA;EhByiCA;EkBzhCU;IFhBV,yBAAA;EhB4iCA;EkB5hCU;IFhBV,yBAAA;EhB+iCA;EkB/hCU;IFhBV,gBAAA;EhBkjCA;EkBliCU;IFhBV,yBAAA;EhBqjCA;EkBriCU;IFhBV,yBAAA;EhBwjCA;EkBxiCU;IFhBV,gBAAA;EhB2jCA;EkB3iCU;IFhBV,yBAAA;EhB8jCA;EkB9iCU;IFhBV,yBAAA;EhBikCA;AACF;AiB7jCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElB2lCN;EgB/jCA;IACE,cAAA;IACA,eAAA;EhBikCF;EgBnkCA;IACE,aAAA;IACA,cAAA;EhBqkCF;EgBvkCA;IACE,wBAAA;IACA,yBAAA;EhBykCF;EgB3kCA;IACE,aAAA;IACA,cAAA;EhB6kCF;EgB/kCA;IACE,aAAA;IACA,cAAA;EhBilCF;EgBnlCA;IACE,wBAAA;IACA,yBAAA;EhBqlCF;EkBxmCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhB0mCA;EkBvmCQ;IFbR,qBAAA;IAIA,sBAAA;EhBonCA;EkB3mCQ;IFbR,sBAAA;IAIA,uBAAA;EhBwnCA;EkB/mCQ;IFbR,aAAA;IAIA,cAAA;EhB4nCA;EkBnnCQ;IFbR,sBAAA;IAIA,uBAAA;EhBgoCA;EkBvnCQ;IFbR,sBAAA;IAIA,uBAAA;EhBooCA;EkB3nCQ;IFbR,aAAA;IAIA,cAAA;EhBwoCA;EkB/nCQ;IFbR,sBAAA;IAIA,uBAAA;EhB4oCA;EkBnoCQ;IFbR,sBAAA;IAIA,uBAAA;EhBgpCA;EkBvoCQ;IFbR,aAAA;IAIA,cAAA;EhBopCA;EkB3oCQ;IFbR,sBAAA;IAIA,uBAAA;EhBwpCA;EkB/oCQ;IFbR,sBAAA;IAIA,uBAAA;EhB4pCA;EkBnpCQ;IFbR,cAAA;IAIA,eAAA;EhBgqCA;EkBjpCI;IAAwB,SAAA;ElBopC5B;EkBlpCI;IAAuB,SAAA;ElBqpC3B;EkBlpCM;IAAwB,QADb;ElBspCjB;EkBrpCM;IAAwB,QADb;ElBypCjB;EkBxpCM;IAAwB,QADb;ElB4pCjB;EkB3pCM;IAAwB,QADb;ElB+pCjB;EkB9pCM;IAAwB,QADb;ElBkqCjB;EkBjqCM;IAAwB,QADb;ElBqqCjB;EkBpqCM;IAAwB,QADb;ElBwqCjB;EkBvqCM;IAAwB,QADb;ElB2qCjB;EkB1qCM;IAAwB,QADb;ElB8qCjB;EkB7qCM;IAAwB,QADb;ElBirCjB;EkBhrCM;IAAwB,SADb;ElBorCjB;EkBnrCM;IAAwB,SADb;ElBurCjB;EkBtrCM;IAAwB,SADb;ElB0rCjB;EkBlrCU;IFhBV,cAAA;EhBqsCA;EkBrrCU;IFhBV,wBAAA;EhBwsCA;EkBxrCU;IFhBV,yBAAA;EhB2sCA;EkB3rCU;IFhBV,gBAAA;EhB8sCA;EkB9rCU;IFhBV,yBAAA;EhBitCA;EkBjsCU;IFhBV,yBAAA;EhBotCA;EkBpsCU;IFhBV,gBAAA;EhButCA;EkBvsCU;IFhBV,yBAAA;EhB0tCA;EkB1sCU;IFhBV,yBAAA;EhB6tCA;EkB7sCU;IFhBV,gBAAA;EhBguCA;EkBhtCU;IFhBV,yBAAA;EhBmuCA;EkBntCU;IFhBV,yBAAA;EhBsuCA;AACF;AiBluCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBgwCN;EgBpuCA;IACE,cAAA;IACA,eAAA;EhBsuCF;EgBxuCA;IACE,aAAA;IACA,cAAA;EhB0uCF;EgB5uCA;IACE,wBAAA;IACA,yBAAA;EhB8uCF;EgBhvCA;IACE,aAAA;IACA,cAAA;EhBkvCF;EgBpvCA;IACE,aAAA;IACA,cAAA;EhBsvCF;EgBxvCA;IACE,wBAAA;IACA,yBAAA;EhB0vCF;EkB7wCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhB+wCA;EkB5wCQ;IFbR,qBAAA;IAIA,sBAAA;EhByxCA;EkBhxCQ;IFbR,sBAAA;IAIA,uBAAA;EhB6xCA;EkBpxCQ;IFbR,aAAA;IAIA,cAAA;EhBiyCA;EkBxxCQ;IFbR,sBAAA;IAIA,uBAAA;EhBqyCA;EkB5xCQ;IFbR,sBAAA;IAIA,uBAAA;EhByyCA;EkBhyCQ;IFbR,aAAA;IAIA,cAAA;EhB6yCA;EkBpyCQ;IFbR,sBAAA;IAIA,uBAAA;EhBizCA;EkBxyCQ;IFbR,sBAAA;IAIA,uBAAA;EhBqzCA;EkB5yCQ;IFbR,aAAA;IAIA,cAAA;EhByzCA;EkBhzCQ;IFbR,sBAAA;IAIA,uBAAA;EhB6zCA;EkBpzCQ;IFbR,sBAAA;IAIA,uBAAA;EhBi0CA;EkBxzCQ;IFbR,cAAA;IAIA,eAAA;EhBq0CA;EkBtzCI;IAAwB,SAAA;ElByzC5B;EkBvzCI;IAAuB,SAAA;ElB0zC3B;EkBvzCM;IAAwB,QADb;ElB2zCjB;EkB1zCM;IAAwB,QADb;ElB8zCjB;EkB7zCM;IAAwB,QADb;ElBi0CjB;EkBh0CM;IAAwB,QADb;ElBo0CjB;EkBn0CM;IAAwB,QADb;ElBu0CjB;EkBt0CM;IAAwB,QADb;ElB00CjB;EkBz0CM;IAAwB,QADb;ElB60CjB;EkB50CM;IAAwB,QADb;ElBg1CjB;EkB/0CM;IAAwB,QADb;ElBm1CjB;EkBl1CM;IAAwB,QADb;ElBs1CjB;EkBr1CM;IAAwB,SADb;ElBy1CjB;EkBx1CM;IAAwB,SADb;ElB41CjB;EkB31CM;IAAwB,SADb;ElB+1CjB;EkBv1CU;IFhBV,cAAA;EhB02CA;EkB11CU;IFhBV,wBAAA;EhB62CA;EkB71CU;IFhBV,yBAAA;EhBg3CA;EkBh2CU;IFhBV,gBAAA;EhBm3CA;EkBn2CU;IFhBV,yBAAA;EhBs3CA;EkBt2CU;IFhBV,yBAAA;EhBy3CA;EkBz2CU;IFhBV,gBAAA;EhB43CA;EkB52CU;IFhBV,yBAAA;EhB+3CA;EkB/2CU;IFhBV,yBAAA;EhBk4CA;EkBl3CU;IFhBV,gBAAA;EhBq4CA;EkBr3CU;IFhBV,yBAAA;EhBw4CA;EkBx3CU;IFhBV,yBAAA;EhB24CA;AACF;AmB/7CA;EACE,WAAA;EACA,mBlBmRO;EkBlRP,clBcS;EkBbT,6BlB4d4B;ADq+B9B;AmB/7CE;;EAEE,alBqd0B;EkBpd1B,mBAAA;EACA,mCAAA;AnBi8CJ;AmB97CE;EACE,sBAAA;EACA,qCAAA;AnBg8CJ;AmB77CE;EACE,kCAAA;AnB+7CJ;;AmBr7CE;;EAEE,elB+b0B;ADy/B9B;;AmB/6CA;EACE,+BAAA;AnBk7CF;AmBh7CE;;EAEE,+BAAA;AnBk7CJ;AmB96CI;;EAEE,6BAAA;AnBg7CN;;AmB16CE;;;;EAIE,SAAA;AnB66CJ;;AmBp6CE;EACE,wClB0Z0B;AD6gC9B;;AOt+CE;EY2EI,clBlEK;EkBmEL,yClB8YwB;ADihC9B;;AoBj/CI;;;EAGE,yBD2F+B;AnBy5CrC;AoBh/CM;;;;EAIE,qBDmFyE;AnB+5CjF;;AOv/CE;EaiBM,yBAJe;ApB8+CvB;AoBx+CQ;;EAEE,yBARa;ApBk/CvB;;AoBrgDI;;;EAGE,yBD2F+B;AnB66CrC;AoBpgDM;;;;EAIE,qBDmFyE;AnBm7CjF;;AO3gDE;EaiBM,yBAJe;ApBkgDvB;AoB5/CQ;;EAEE,yBARa;ApBsgDvB;;AoBzhDI;;;EAGE,yBD2F+B;AnBi8CrC;AoBxhDM;;;;EAIE,qBDmFyE;AnBu8CjF;;AO/hDE;EaiBM,yBAJe;ApBshDvB;AoBhhDQ;;EAEE,yBARa;ApB0hDvB;;AoB7iDI;;;EAGE,yBD2F+B;AnBq9CrC;AoB5iDM;;;;EAIE,qBDmFyE;AnB29CjF;;AOnjDE;EaiBM,yBAJe;ApB0iDvB;AoBpiDQ;;EAEE,yBARa;ApB8iDvB;;AoBjkDI;;;EAGE,yBD2F+B;AnBy+CrC;AoBhkDM;;;;EAIE,qBDmFyE;AnB++CjF;;AOvkDE;EaiBM,yBAJe;ApB8jDvB;AoBxjDQ;;EAEE,yBARa;ApBkkDvB;;AoBrlDI;;;EAGE,yBD2F+B;AnB6/CrC;AoBplDM;;;;EAIE,qBDmFyE;AnBmgDjF;;AO3lDE;EaiBM,yBAJe;ApBklDvB;AoB5kDQ;;EAEE,yBARa;ApBslDvB;;AoBzmDI;;;EAGE,yBD2F+B;AnBihDrC;AoBxmDM;;;;EAIE,qBDmFyE;AnBuhDjF;;AO/mDE;EaiBM,yBAJe;ApBsmDvB;AoBhmDQ;;EAEE,yBARa;ApB0mDvB;;AoB7nDI;;;EAGE,yBD2F+B;AnBqiDrC;AoB5nDM;;;;EAIE,qBDmFyE;AnB2iDjF;;AOnoDE;EaiBM,yBAJe;ApB0nDvB;AoBpnDQ;;EAEE,yBARa;ApB8nDvB;;AoBjpDI;;;EAGE,yBD2F+B;AnByjDrC;AoBhpDM;;;;EAIE,qBDmFyE;AnB+jDjF;;AOvpDE;EaiBM,yBAJe;ApB8oDvB;AoBxoDQ;;EAEE,yBARa;ApBkpDvB;;AoBrqDI;;;EAGE,uBD2F+B;AnB6kDrC;AoBpqDM;;;;EAIE,mBDmFyE;AnBmlDjF;;AO3qDE;EaiBM,yBAJe;ApBkqDvB;AoB5pDQ;;EAEE,yBARa;ApBsqDvB;;AoBzrDI;;;EAGE,uBD2F+B;AnBimDrC;AoBxrDM;;;;EAIE,mBDmFyE;AnBumDjF;;AO/rDE;EaiBM,yBAJe;ApBsrDvB;AoBhrDQ;;EAEE,yBARa;ApB0rDvB;;AoB7sDI;;;EAGE,yBD2F+B;AnBqnDrC;AoB5sDM;;;;EAIE,qBDmFyE;AnB2nDjF;;AOntDE;EaiBM,yBAJe;ApB0sDvB;AoBpsDQ;;EAEE,yBARa;ApB8sDvB;;AoBjuDI;;;EAGE,yCnB6dwB;ADuwC9B;;AOjuDE;EaiBM,yCAJe;ApBwtDvB;AoBltDQ;;EAEE,yCARa;ApB4tDvB;;AmBpoDI;EACE,clBKuB;EkBJvB,yBlB5FK;EkB6FL,qBlB8XwB;ADywC9B;AmBloDI;EACE,clBrGK;EkBsGL,yBlB3GK;EkB4GL,qBlB3GK;AD+uDX;;AmB/nDA;EACE,clBX2B;EkBY3B,yBlB5GS;AD8uDX;AmBhoDE;;;EAGE,qBlB0W0B;ADwxC9B;AmB/nDE;EACE,SAAA;AnBioDJ;AmB7nDI;EACE,2ClB+VwB;ADgyC9B;AOpwDE;EY4IM,clBjCqB;EkBkCrB,4ClBwVsB;ADmyC9B;;AiB3sDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnB6mDN;EmB1mDM;IACE,SAAA;EnB4mDR;AACF;AiBvtDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBwnDN;EmBrnDM;IACE,SAAA;EnBunDR;AACF;AiBluDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBmoDN;EmBhoDM;IACE,SAAA;EnBkoDR;AACF;AiB7uDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnB8oDN;EmB3oDM;IACE,SAAA;EnB6oDR;AACF;AmBvpDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AnBwpDR;AmBrpDQ;EACE,SAAA;AnBupDV;;AqBp0DA;EACE,cAAA;EACA,WAAA;EACA,kCpBmlBsC;EoBllBtC,sBAAA;EhB0KI,mBAAA;EgBvKJ,gBpBiY4B;EoBhY5B,qBpBuY6B;EoBtY7B,+BpBmD2B;EoBlD3B,6BpBS2B;EoBR3B,4BAAA;EACA,yBAAA;ETAE,sBAAA;ECFE,gBQOJ;ECPI,2DDQJ;ArBm0DF;AsBv0DM;EDdN;ICeQ,gBAAA;EtB00DN;AACF;AqBr0DE;EACE,6BAAA;EACA,SAAA;ArBu0DJ;AuBv1DE;EACE,+BtBoDyB;EsBnDzB,yBtBDO;EsBEP,sCtBkkBoC;EsBjkBpC,UAAA;AvBy1DJ;AqBt0DE;EACE,cpBlBO;EoBoBP,UAAA;ArBu0DJ;AqB/zDE;EAEE,yBpBjCO;EoBmCP,UAAA;ArB+zDJ;;AqBvzDE;;;;EACE,gBAAA;ArB6zDJ;;AqBvzDE;EACE,kBAAA;EACA,2CAAA;ArB0zDJ;AqBvzDE;EAME,+BpBXyB;EoBYzB,6BpBrDyB;ADy2D7B;;AqB/yDA;;EAEE,cAAA;EACA,WAAA;ArBkzDF;;AqBxyDA;EACE,+BAAA;EACA,kCAAA;EACA,gBAAA;EhBiEE,kBAAA;EgB/DF,qBpBgT6B;AD2/C/B;;AqBxyDA;EACE,iCAAA;EACA,oCAAA;EhB0EI,mBAAA;EgBxEJ,iBpB2Z4B;ADg5C9B;;AqBxyDA;EACE,gCAAA;EACA,mCAAA;EhBmEI,kBAAA;EgBjEJ,iBpBgZ4B;AD25C9B;;AqBlyDA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EhBoDI,mBAAA;EgBlDJ,qBpBmR6B;EoBlR7B,cpB9GS;EoB+GT,6BAAA;EACA,yBAAA;EACA,mBAAA;ArBqyDF;AqBnyDE;EAEE,gBAAA;EACA,eAAA;ArBoyDJ;;AqBxxDA;EACE,mCf6VsC;Ee5VtC,uBAAA;EhB2BI,kBAAA;EgBzBJ,iBpBwW4B;EWjf1B,wBAAA;AZq6DJ;;AqBxxDA;EACE,oCfsVsC;EerVtC,sBAAA;EhBmBI,mBAAA;EgBjBJ,iBpBoW4B;EWrf1B,wBAAA;AZ66DJ;;AqBtxDE;EAEE,YAAA;ArBwxDJ;;AqBpxDA;EACE,YAAA;ArBuxDF;;AqB/wDA;EACE,mBf2UsC;ANu8CxC;;AqB/wDA;EACE,cAAA;EACA,mBf4TsC;ANs9CxC;;AqB1wDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ArB6wDF;AqB3wDE;;EAEE,kBAAA;EACA,iBAAA;ArB6wDJ;;AqBpwDA;EACE,kBAAA;EACA,cAAA;EACA,qBfiSsC;ANs+CxC;;AqBpwDA;EACE,kBAAA;EACA,kBf6RsC;Ee5RtC,qBAAA;ArBuwDF;AqBpwDE;EAEE,cpBlNO;ADu9DX;;AqBjwDA;EACE,gBAAA;ArBowDF;;AqBjwDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf8QsC;ANs/CxC;AqBjwDE;EACE,gBAAA;EACA,aAAA;EACA,uBfyQoC;EexQpC,cAAA;ArBmwDJ;;AuBh9DE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;EDtVpC,cAAA;EkBnHA,cFqNqC;ArB8vDzC;;AuBh9DE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;ElBwHE,0BAAA;EkBtHF,gBjBuO0B;EiBtO1B,cAAA;EACA,wCAAA;EX9CA,sBAAA;AZkgEJ;AuB/8DI;EAEE,SAAA;AvBg9DN;;AuB38DI;;;;EAEE,cAAA;AvBg9DN;;AuB9/DI;EAoDE,qBFkLmC;EE/KjC,wCAAA;EACA,yDAAA;EACA,4BAAA;EACA,8DAAA;EACA,sEAAA;AvB48DR;AuBz8DM;EACE,qBFuKiC;EEtKjC,2CAAA;AvB28DR;;AuB3gEI;EAyEI,gCAAA;EACA,wCAAA;AvBs8DR;;AuBhhEI;EAmFI,6BtBwegC;EsBvehC,wFAAA;AvBi8DR;;AuBrhEI;EA2FE,qBF2ImC;EExIjC,gDAAA;EACA,mOAAA;AvB47DR;AuBz7DM;EACE,qBFmIiC;EElIjC,2CAAA;AvB27DR;;AuBp7DM;EACE,cF0HiC;ArB6zDzC;AuBp7DM;;;EAEE,cAAA;AvBu7DR;;AuBh7DM;EACE,cF6GiC;ArBs0DzC;AuBj7DQ;EACE,qBF0G+B;ArBy0DzC;AuB96DQ;EACE,qBAAA;EC5JN,yBD6J2B;AvBg7D/B;AuB36DQ;EACE,2CAAA;AvB66DV;AuB16DQ;EACE,qBFyF+B;ArBm1DzC;;AuBn6DM;EACE,qBF+EiC;ArBu1DzC;AuBl6DQ;EACE,qBF0E+B;EEzE/B,2CAAA;AvBo6DV;;AuBrjEE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;EDtVpC,cAAA;EkBnHA,cFqNqC;ArBm2DzC;;AuBrjEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;ElBwHE,0BAAA;EkBtHF,gBjBuO0B;EiBtO1B,cAAA;EACA,0CAAA;EX9CA,sBAAA;AZumEJ;AuBpjEI;EAEE,SAAA;AvBqjEN;;AuBhjEI;;;;EAEE,cAAA;AvBqjEN;;AuBnmEI;EAoDE,qBFkLmC;EE/KjC,wCAAA;EACA,yDAAA;EACA,4BAAA;EACA,8DAAA;EACA,sEAAA;AvBijER;AuB9iEM;EACE,qBFuKiC;EEtKjC,6CAAA;AvBgjER;;AuBhnEI;EAyEI,gCAAA;EACA,wCAAA;AvB2iER;;AuBrnEI;EAmFI,6BtBwegC;EsBvehC,wFAAA;AvBsiER;;AuB1nEI;EA2FE,qBF2ImC;EExIjC,gDAAA;EACA,mOAAA;AvBiiER;AuB9hEM;EACE,qBFmIiC;EElIjC,6CAAA;AvBgiER;;AuBzhEM;EACE,cF0HiC;ArBk6DzC;AuBzhEM;;;EAEE,cAAA;AvB4hER;;AuBrhEM;EACE,cF6GiC;ArB26DzC;AuBthEQ;EACE,qBF0G+B;ArB86DzC;AuBnhEQ;EACE,qBAAA;EC5JN,yBD6J2B;AvBqhE/B;AuBhhEQ;EACE,6CAAA;AvBkhEV;AuB/gEQ;EACE,qBFyF+B;ArBw7DzC;;AuBxgEM;EACE,qBF+EiC;ArB47DzC;AuBvgEQ;EACE,qBF0E+B;EEzE/B,6CAAA;AvBygEV;;AqBp7DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ArBu7DF;AqBl7DE;EACE,WAAA;ArBo7DJ;AiBnpEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;ErBk7DJ;EqB96DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;ErBg7DJ;EqB56DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;ErB86DJ;EqB16DE;IACE,qBAAA;ErB46DJ;EqBz6DE;;IAEE,WAAA;ErB26DJ;EqBt6DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;ErBw6DJ;EqBt6DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBfgLkC;Ie/KlC,cAAA;ErBw6DJ;EqBr6DE;IACE,mBAAA;IACA,uBAAA;ErBu6DJ;EqBr6DE;IACE,gBAAA;ErBu6DJ;AACF;;AyBzvEA;EACE,qBAAA;EAEA,gBxB0hB4B;EwBzhB5B,cxBWS;EwBVT,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,kBAAA;ErB4EI,mBAAA;EqB1EJ,mBzBlD4B;EWtC1B,sBAAA;EUFE,qIGGJ;AzB4vEF;AsB3vEM;EGdN;IHeQ,gBAAA;EtB8vEN;AACF;AOxwEE;EkBUE,cxBDO;EwBEP,qBAAA;AzBiwEJ;AyB9vEE;EAEE,UAAA;EACA,2ExB0gB0B;ADqvD9B;AyB3vEE;EAEE,anBkZ0B;EOraxB,gBYoBF;AzB4vEJ;AyBzvEE;EACE,eAAA;AzB2vEJ;AyBzvEI;EZ1BE,gBY4BA;AzB0vEN;AyBxvEM;EZ9BA,2EALa;Ab8xEnB;;AyBnvEA;;EAEE,oBAAA;AzBsvEF;;AyB7uEE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1B4yEF;AOzyEE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1BqzEzG;A0BzyEE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,6GALa;AbqzEnB;A0BjyEE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANyvEf;A0B3xEE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bq0E7L;A0BtxEI;EAKI,4CAAA;A1BoxER;;AyB5wEE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1B20EF;AOx0EE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bo1EzG;A0Bx0EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,6GALa;Abo1EnB;A0Bh0EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANwxEf;A0B1zEE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bo2E7L;A0BrzEI;EAKI,4CAAA;A1BmzER;;AyB3yEE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1B02EF;AOv2EE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bm3EzG;A0Bv2EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,4GALa;Abm3EnB;A0B/1EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANuzEf;A0Bz1EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bm4E7L;A0Bp1EI;EAKI,2CAAA;A1Bk1ER;;AyB10EE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1By4EF;AOt4EE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bk5EzG;A0Bt4EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,4GALa;Abk5EnB;A0B93EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANs1Ef;A0Bx3EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bk6E7L;A0Bn3EI;EAKI,2CAAA;A1Bi3ER;;AyBz2EE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1Bw6EF;AOr6EE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bi7EzG;A0Br6EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,6GALa;Abi7EnB;A0B75EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANq3Ef;A0Bv5EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bi8E7L;A0Bl5EI;EAKI,4CAAA;A1Bg5ER;;AyBx4EE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1Bu8EF;AOp8EE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bg9EzG;A0Bp8EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,6GALa;Abg9EnB;A0B57EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANo5Ef;A0Bt7EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bg+E7L;A0Bj7EI;EAKI,4CAAA;A1B+6ER;;AyBv6EE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1Bs+EF;AOn+EE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B++EzG;A0Bn+EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,6GALa;Ab++EnB;A0B39EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANm7Ef;A0Br9EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B+/E7L;A0Bh9EI;EAKI,4CAAA;A1B88ER;;AyBt8EE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1BqgFF;AOlgFE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B8gFzG;A0BlgFE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,0GALa;Ab8gFnB;A0B1/EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANk9Ef;A0Bp/EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B8hF7L;A0B/+EI;EAKI,yCAAA;A1B6+ER;;AyBr+EE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1BoiFF;AOjiFE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B6iFzG;A0BjiFE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,2GALa;Ab6iFnB;A0BzhFE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANi/Ef;A0BnhFE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B6jF7L;A0B9gFI;EAKI,0CAAA;A1B4gFR;;AyBpgFE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1BmkFF;AOhkFE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B4kFzG;A0BhkFE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,6GALa;Ab4kFnB;A0BxjFE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ANghFf;A0BljFE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B4lF7L;A0B7iFI;EAKI,4CAAA;A1B2iFR;;AyBniFE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;EO5DT,2EaPJ;A1BkmFF;AO/lFE;EmBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B2mFzG;A0B/lFE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EbWnG,6GALa;Ab2mFnB;A0BvlFE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AN+iFf;A0BjlFE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B2nF7L;A0B5kFI;EAKI,4CAAA;A1B0kFR;;AyBlkFE;EC3DA,cAAA;EFAE,uBlBsEW;EoBpEb,mBpBoEa;EO5DT,2EaPJ;A1BioFF;AO9nFE;EmBAE,cAAA;EFNA,uBED2D;EAS3D,mBATqG;A1B0oFzG;A0B9nFE;EAEE,cAAA;EFbA,uBED2D;EAgB3D,mBAhBqG;EbWnG,0GALa;Ab0oFnB;A0BtnFE;EAEE,cAAA;EACA,uBpB0CW;EoBzCX,mBpByCW;AN8kFf;A0BhnFE;EAGE,cAAA;EACA,uBAzC+I;EA6C/I,mBA7CyL;A1B0pF7L;A0B3mFI;EAKI,yCAAA;A1BymFR;;AyB3lFE;ECPA,cpBYa;EoBXb,qBpBWa;AN2lFf;AO3pFE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ANgmFf;A0BnmFE;EAEE,2CAAA;A1BomFJ;A0BjmFE;EAEE,cpBJW;EoBKX,6BAAA;A1BkmFJ;A0B/lFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AN4mFf;A0B7lFI;EAKI,2CAAA;A1B2lFR;;AyBpnFE;ECPA,cpBYa;EoBXb,qBpBWa;ANonFf;AOprFE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ANynFf;A0B5nFE;EAEE,4CAAA;A1B6nFJ;A0B1nFE;EAEE,cpBJW;EoBKX,6BAAA;A1B2nFJ;A0BxnFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ANqoFf;A0BtnFI;EAKI,4CAAA;A1BonFR;;AyB7oFE;ECPA,cpBYa;EoBXb,qBpBWa;AN6oFf;AO7sFE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ANkpFf;A0BrpFE;EAEE,0CAAA;A1BspFJ;A0BnpFE;EAEE,cpBJW;EoBKX,6BAAA;A1BopFJ;A0BjpFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AN8pFf;A0B/oFI;EAKI,0CAAA;A1B6oFR;;AyBtqFE;ECPA,cpBYa;EoBXb,qBpBWa;ANsqFf;AOtuFE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AN2qFf;A0B9qFE;EAEE,2CAAA;A1B+qFJ;A0B5qFE;EAEE,cpBJW;EoBKX,6BAAA;A1B6qFJ;A0B1qFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ANurFf;A0BxqFI;EAKI,2CAAA;A1BsqFR;;AyB/rFE;ECPA,cpBYa;EoBXb,qBpBWa;AN+rFf;AO/vFE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ANosFf;A0BvsFE;EAEE,4CAAA;A1BwsFJ;A0BrsFE;EAEE,cpBJW;EoBKX,6BAAA;A1BssFJ;A0BnsFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ANgtFf;A0BjsFI;EAKI,4CAAA;A1B+rFR;;AyBxtFE;ECPA,cpBYa;EoBXb,qBpBWa;ANwtFf;AOxxFE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AN6tFf;A0BhuFE;EAEE,2CAAA;A1BiuFJ;A0B9tFE;EAEE,cpBJW;EoBKX,6BAAA;A1B+tFJ;A0B5tFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ANyuFf;A0B1tFI;EAKI,2CAAA;A1BwtFR;;AyBjvFE;ECPA,cpBYa;EoBXb,qBpBWa;ANivFf;AOjzFE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ANsvFf;A0BzvFE;EAEE,4CAAA;A1B0vFJ;A0BvvFE;EAEE,cpBJW;EoBKX,6BAAA;A1BwvFJ;A0BrvFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ANkwFf;A0BnvFI;EAKI,4CAAA;A1BivFR;;AyB1wFE;ECPA,cpBYa;EoBXb,qBpBWa;AN0wFf;AO10FE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AN+wFf;A0BlxFE;EAEE,yCAAA;A1BmxFJ;A0BhxFE;EAEE,cpBJW;EoBKX,6BAAA;A1BixFJ;A0B9wFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AN2xFf;A0B5wFI;EAKI,yCAAA;A1B0wFR;;AyBnyFE;ECPA,cpBYa;EoBXb,qBpBWa;ANmyFf;AOn2FE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ANwyFf;A0B3yFE;EAEE,0CAAA;A1B4yFJ;A0BzyFE;EAEE,cpBJW;EoBKX,6BAAA;A1B0yFJ;A0BvyFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ANozFf;A0BryFI;EAKI,0CAAA;A1BmyFR;;AyB5zFE;ECPA,cpBYa;EoBXb,qBpBWa;AN4zFf;AO53FE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ANi0Ff;A0Bp0FE;EAEE,4CAAA;A1Bq0FJ;A0Bl0FE;EAEE,cpBJW;EoBKX,6BAAA;A1Bm0FJ;A0Bh0FE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AN60Ff;A0B9zFI;EAKI,4CAAA;A1B4zFR;;AyBr1FE;ECPA,cpBYa;EoBXb,qBpBWa;ANq1Ff;AOr5FE;EmBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AN01Ff;A0B71FE;EAEE,4CAAA;A1B81FJ;A0B31FE;EAEE,cpBJW;EoBKX,6BAAA;A1B41FJ;A0Bz1FE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;ANs2Ff;A0Bv1FI;EAKI,4CAAA;A1Bq1FR;;AyB92FE;ECPA,YpBYa;EoBXb,mBpBWa;AN82Ff;AO96FE;EmBwDE,cALgD;EAMhD,uBpBOW;EoBNX,mBpBMW;ANm3Ff;A0Bt3FE;EAEE,sCAAA;A1Bu3FJ;A0Bp3FE;EAEE,YpBJW;EoBKX,6BAAA;A1Bq3FJ;A0Bl3FE;EAGE,cAAA;EACA,uBpBZW;EoBaX,mBpBbW;AN+3Ff;A0Bh3FI;EAKI,sCAAA;A1B82FR;;AyB53FA;EACE,gBxB2T4B;EwB1T5B,cxBec;EwBdd,qBxB2K0B;ADotF5B;AOx8FE;EkB4EE,cxByKwB;EwBxKxB,qBxByKwB;ADstF5B;AyB53FE;EAEE,qBxBoKwB;ADytF5B;AyB13FE;EAEE,cxB/EO;EwBgFP,oBAAA;AzB23FJ;;AyBh3FA;ECPE,kBAAA;ErB4DE,cAAA;EqB1DF,iBzB6Z4B;EWrf1B,wBAAA;AZo9FJ;;AyBn3FA;ECXE,iBAAA;ErB4EI,kBAAA;EqB1EJ,iBzByZ4B;EWjf1B,sBAAA;AZ29FJ;;AyBj3FA;EACE,cAAA;EACA,WAAA;AzBo3FF;AyBj3FE;EACE,kBnBwT0B;AN2jF9B;;AyB32FE;;;EACE,WAAA;AzBg3FJ;;A2B3/FA;ELgBM,gCKfJ;A3B8/FF;AsB3+FM;EKpBN;ILqBQ,gBAAA;EtB8+FN;AACF;A2BjgGE;EACE,UAAA;A3BmgGJ;;A2B9/FE;EACE,aAAA;A3BigGJ;;A2B7/FA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A3BggGF;AsB9/FM;EKNN;ILOQ,gBAAA;EtBigGN;AACF;A2BngGE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;A3BqgGJ;AsBxgGM;EKAJ;ILCM,gBAAA;EtB2gGN;AACF;;A4BhiGA;;;;EAIE,kBAAA;A5BmiGF;;A4BhiGA;EACE,mBAAA;A5BmiGF;A6B/gGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A7BkjGF;A6B7/FI;EACE,cAAA;A7B+/FN;;A4BziGA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBypBkC;EsBxpBlC,aAAA;EACA,WAAA;EACA,gBtBiuBkC;EsBhuBlC,iBAAA;EACA,oBAAA;EvB2JI,mBAAA;EuBzJJ,c3BNS;E2BOT,gBAAA;EACA,gBAAA;EACA,yB3BhBS;E2BiBT,4BAAA;EACA,sCAAA;EhBdE,wBAAA;ECFE,iHekBJ;A5B4iGF;;A4BriGI;EACE,WAAA;EACA,OAAA;A5BwiGN;;A4BriGI;EACE,QAAA;EACA,UAAA;A5BwiGN;;AiB5hGI;EWnBA;IACE,WAAA;IACA,OAAA;E5BmjGJ;E4BhjGE;IACE,QAAA;IACA,UAAA;E5BkjGJ;AACF;AiBviGI;EWnBA;IACE,WAAA;IACA,OAAA;E5B6jGJ;E4B1jGE;IACE,QAAA;IACA,UAAA;E5B4jGJ;AACF;AiBjjGI;EWnBA;IACE,WAAA;IACA,OAAA;E5BukGJ;E4BpkGE;IACE,QAAA;IACA,UAAA;E5BskGJ;AACF;AiB3jGI;EWnBA;IACE,WAAA;IACA,OAAA;E5BilGJ;E4B9kGE;IACE,QAAA;IACA,UAAA;E5BglGJ;AACF;A4BzkGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtB+rBgC;AN44EpC;A6B1mGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A7BsoGF;A6BxlGI;EACE,cAAA;A7B0lGN;;A4B/kGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtBirBgC;ANi6EpC;A6B/nGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A7BopGF;A6B7mGI;EACE,cAAA;A7B+mGN;A4B1lGI;EACE,iBAAA;A5B4lGN;;A4BtlGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtBgqBgC;ANy7EpC;A6BvpGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;A7BypGN;A6B9oGM;EACE,aAAA;A7BgpGR;A6B7oGM;EACE,qBAAA;EACA,qBvB4MsB;EuB3MtB,uBvB0MsB;EuBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A7B8qGF;A6B7oGI;EACE,cAAA;A7B+oGN;A4BzmGI;EACE,iBAAA;A5B2mGN;;A4BnmGE;EAIE,WAAA;EACA,YAAA;A5BmmGJ;;A4B9lGA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A9BgtGF;;A4B9lGA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gB3B+Q4B;E2B9Q5B,c3BzGS;E2B0GT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A5BgmGF;AOrtGE;EqBoIE,ctBonBgC;EsBnnBhC,qBAAA;EJ/IA,yBvBUO;AD0tGX;A4BjlGE;EAEE,c3B7IO;E2B8IP,qBAAA;EJtJA,yBvB4V4B;AD64FhC;A4B/kGE;EAEE,c3B/IO;E2BgJP,oBAAA;EACA,6BAAA;A5BglGJ;;A4BxkGA;EACE,cAAA;A5B2kGF;;A4BvkGA;EACE,cAAA;EACA,sBtBimBkC;EsBhmBlC,gBAAA;EvBAI,0BAAA;EuBEJ,c3BlKS;E2BmKT,mBAAA;A5B0kGF;;A4BtkGA;EACE,cAAA;EACA,uBAAA;EACA,c3BvKS;ADgvGX;;A+BpwGA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A/BuwGF;A+BrwGE;;EACE,kBAAA;EACA,cAAA;A/BwwGJ;AOvwGE;;EwBII,UAAA;A/BuwGN;A+BrwGI;;;;EAGE,UAAA;A/BwwGN;;A+BlwGA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A/BqwGF;A+BnwGE;EACE,WAAA;A/BqwGJ;;A+B/vGE;;EAEE,iBAAA;A/BkwGJ;A+B9vGE;;EnBXE,0BAAA;EACA,6BAAA;AZ6wGJ;A+B9vGE;;EnBFE,yBAAA;EACA,4BAAA;AZowGJ;;A+BjvGA;EACE,mBAAA;EACA,kBAAA;A/BovGF;A+BlvGE;EAGE,cAAA;A/BkvGJ;A+B/uGE;EACE,eAAA;A/BivGJ;;A+B7uGA;EACE,sBAAA;EACA,qBAAA;A/BgvGF;;A+B7uGA;EACE,mBAAA;EACA,kBAAA;A/BgvGF;;A+B1uGA;ElBhFM,gBkBiFJ;A/B6uGF;A+B1uGE;ElBpFI,gBkBqFF;A/B4uGJ;;A+BnuGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A/BsuGF;A+BpuGE;;EAEE,WAAA;A/BsuGJ;A+BnuGE;;EAEE,gBAAA;A/BquGJ;A+BjuGE;;EnBrFE,6BAAA;EACA,4BAAA;AZ0zGJ;A+BjuGE;;EnBxGE,yBAAA;EACA,0BAAA;AZ60GJ;;A+BltGE;;EAEE,gBAAA;A/BqtGJ;A+BntGI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A/ButGN;;AgCh3GA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AhCm3GF;AgCj3GE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AhCm3GJ;AgCj3GI;;;;;;;;;;;;EAGE,iBAAA;AhC43GN;AgCv3GE;;;EAGE,UAAA;AhCy3GJ;AgCr3GE;EACE,UAAA;AhCu3GJ;AgCl3GI;;EpBIA,yBAAA;EACA,4BAAA;AZk3GJ;AgCl3GE;EACE,aAAA;EACA,mBAAA;AhCo3GJ;AgCl3GI;EpBnBA,0BAAA;EACA,6BAAA;AZw4GJ;AgCp3GI;EpBPA,yBAAA;EACA,4BAAA;AZ83GJ;AgCp3GI;;;;EpBzBA,0BAAA;EACA,6BAAA;AZm5GJ;AgCl3GI;;;;EpBlCA,0BAAA;EACA,6BAAA;AZ05GJ;;AgCz2GA;;EAEE,aAAA;AhC42GF;AgCv2GE;;EACE,kBAAA;EACA,UAAA;AhC02GJ;AgCx2GI;;EACE,UAAA;AhC22GN;AgCv2GE;;;;;;;;EAIE,iBAAA;AhC62GJ;;AgCz2GA;EAAuB,kBAAA;AhC62GvB;;AgC52GA;EAAsB,iBAAA;AhCg3GtB;;AgCx2GA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;E3B2DI,mBAAA;E2BzDJ,gB/BmR4B;E+BlR5B,qB/ByR6B;E+BxR7B,c/B1GS;E+B2GT,kBAAA;EACA,mBAAA;EACA,6B/BvG2B;E+BwG3B,yBAAA;EpB/GE,sBAAA;AZ29GJ;AgCx2GE;;EAEE,aAAA;AhC02GJ;;AgCh2GA;;EAEE,oC1BmWsC;ANggGxC;;AgCh2GA;;;;;;EAME,sBAAA;E3BwBI,mBAAA;E2BtBJ,iB/ByW4B;EWrf1B,wBAAA;AZg/GJ;;AgCh2GA;;EAEE,mC1BiVsC;ANkhGxC;;AgCh2GA;;;;;;EAME,uBAAA;E3BOI,kBAAA;E2BLJ,iB/BoV4B;EWjf1B,wBAAA;AZigHJ;;AgCh2GA;;EAEE,qBAAA;AhCm2GF;;AgCx1GA;;;;;;;;EpB9JI,0BAAA;EACA,6BAAA;AZigHJ;;AgCz1GA;;;;;;EpB3JI,yBAAA;EACA,4BAAA;AZ6/GJ;;AiCriHA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;UAAA,yBAAA;AjCwiHF;;AiCriHA;EACE,oBAAA;EACA,kBhC2lBsC;AD68FxC;;AiCriHA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,chCqlBsC;EgCplBtC,kBAAA;EACA,UAAA;AjCwiHF;AiCtiHE;EACE,chClBO;EgCmBP,qBhCkU4B;EuB7V5B,yBvB4V4B;EYlV1B,gBoBmBF;AjCwiHJ;AiCriHE;EAGI,sBAAA;AjCqiHN;AiC/hHE;EACE,sChCkiBoC;AD+/FxC;AiC9hHE;EACE,chCtCO;EgCuCP,yBhC6S4B;EgC5S5B,qBhC6S4B;EYnV1B,gBoBuCF;AjCgiHJ;AiC1hHI;EACE,chC1CK;ADskHX;AiC1hHM;EACE,yBhCjDG;AD6kHX;;AiClhHA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AjCohHF;AiChhHE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,chCwhBoC;EgCvhBpC,ehCuhBoC;EgCthBpC,oBAAA;EACA,WAAA;EACA,6BhCnEyB;EgCoEzB,yBAAA;EpB7EE,gBoB8EF;AjCkhHJ;AiC9gHE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,chCygBoC;EgCxgBpC,ehCwgBoC;EgCvgBpC,WAAA;EACA,iCAAA;AjCghHJ;;AiCtgHE;ErBlGE,wBAAA;AZ4mHJ;AiCrgHI;EACE,yDAAA;AjCugHN;AiClgHI;EACE,qBhCkO0B;EuB5V5B,yBvB4V4B;ADmyGhC;AiCjgHI;EACE,yDAAA;AjCmgHN;AiC9/GI;ETpIA,yCvBgoB4C;ADqgGhD;AiC9/GI;ETvIA,yCvBgoB4C;ADwgGhD;;AiCt/GE;EAEE,kB3B0Z4C;AN8lGhD;AiCp/GI;EACE,yDAAA;AjCs/GN;AiCj/GI;ET9JA,yCvBgoB4C;ADkhGhD;;AiCz+GA;EACE,uBAAA;AjC4+GF;AiCz+GI;EACE,gBAAA;EACA,gB3BkY0C;E2BjY1C,mBAAA;EAEA,uB3BgY0C;AN0mGhD;AiCv+GI;EACE,2BAAA;EACA,4BAAA;EACA,0B3B2X0C;E2B1X1C,2B3B0X0C;E2BzX1C,yBhC6YkC;EgC3YlC,uB3BsX0C;EgBxiB1C,yIWmLA;AjCw+GN;AsBvpHM;EWuKF;IXtKI,gBAAA;EtB0pHN;AACF;AiCx+GI;EACE,6BhChLuB;EgCiLvB,gCAAA;AjC0+GN;AiCr+GI;ETzMA,yCvBgoB4C;ADijGhD;;AiC39GA;EACE,qBAAA;EACA,WAAA;EACA,kChC6XsC;EgC5XtC,oCAAA;E5B5CI,mBAAA;E4B+CJ,gBhC2K4B;EgC1K5B,qBhCiL6B;EgChL7B,+BhCnK2B;EgCoK3B,sBAAA;EACA,sGAAA;EACA,yBAAA;ErBtNE,sBAAA;ECFE,mDoB0NJ;EACA,gBAAA;AjC69GF;AiC39GE;EACE,sChCoWoC;EgCnWpC,UAAA;EpB/NE,oEALa;AbksHnB;AiCt9GI;EAME,+BhC3LuB;EgC4LvB,6BhCrOuB;ADwrH7B;AiC/8GE;EAEE,YAAA;EACA,qBhCoP0B;EgCnP1B,sBAAA;AjCg9GJ;AiC78GE;EACE,chCtPO;EgCuPP,yBhC3PO;AD0sHX;AiC38GE;EACE,aAAA;AjC68GJ;AiCz8GE;EACE,kBAAA;EACA,2CAAA;AjC28GJ;;AiCv8GA;EACE,mC3B0NsC;E2BzNtC,oBhCqO4B;EgCpO5B,uBhCoO4B;EgCnO5B,oBhCoO4B;EI9UxB,kBAAA;ALqjHN;;AiCv8GA;EACE,oC3BmNsC;E2BlNtC,qBhCiO4B;EgChO5B,wBhCgO4B;EgC/N5B,kBhCgO4B;EIlVxB,mBAAA;AL6jHN;;AiCl8GA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,kChCySsC;EgCxStC,gBAAA;AjCq8GF;;AiCl8GA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kChCiSsC;EgChStC,SAAA;EACA,gBAAA;EACA,UAAA;AjCq8GF;AiCn8GE;EACE,sChCiRoC;EgChRpC,gBhCmRoC;ADkrGxC;AiCj8GE;EAEE,yBhCxTO;AD0vHX;AiC97GI;EACE,iB3B2Ta;ANqoGnB;AiC57GE;EACE,0BAAA;AjC87GJ;;AiC17GA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,kChCgQsC;EgC/PtC,sBAAA;EACA,gBAAA;EAEA,gBhC8C4B;EgC7C5B,qBhCoD6B;EgCnD7B,+BhChS2B;EgCiS3B,6BhC1U2B;EgC2U3B,yBAAA;ErBlVE,sBAAA;ECFE,gBoBsVJ;AjC47GF;AiC17GE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,sBhC4OoC;EgC3OpC,sBAAA;EACA,qBhCoC2B;EgCnC3B,+BhChTyB;EgCiTzB,iBAAA;ET7WA,6BvBmByB;EgC4VzB,oBAAA;ErBnWA,kCAAA;AZgyHJ;;AiCl7GA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;AjCq7GF;AiCn7GE;EACE,UAAA;AjCq7GJ;AiCj7GI;EAA0B,mC3BoOe;ANgtG7C;AiCn7GI;EAA0B,mC3BmOe;ANmtG7C;AiCr7GI;EAA0B,mC3BkOe;ANstG7C;AiCr7GE;EACE,SAAA;AjCu7GJ;AiCp7GE;EACE,W3BoNyC;E2BnNzC,Y3BmNyC;E2BlNzC,oBAAA;ETlZA,yBvB4V4B;EgCwD5B,S3BmNyC;EM3lBzC,mBAAA;ECFE,kDoB4YF;EX5YE,oHW6YF;EX7YE,4GW6YF;EACA,gBAAA;AjCs7GJ;AsBh0HM;EWiYJ;IXhYM,wBAAA;IAAA,gBAAA;EtBm0HN;AACF;AiCz7GI;ET1ZA,yBlB4mByC;AN0uG7C;AiCv7GE;EACE,W3B6LgC;E2B5LhC,c3B6LgC;E2B5LhC,kBAAA;EACA,e3B4LgC;E2B3LhC,yBhCzZO;EgC0ZP,yBAAA;ErBzZA,mBAAA;ECFE,yDoB6ZF;AjCy7GJ;AiCt7GE;EACE,W3ByLyC;E2BxLzC,Y3BwLyC;EkBpmBzC,yBvB4V4B;EgCkF5B,S3ByLyC;EM3lBzC,mBAAA;ECFE,kDoBsaF;EXtaE,iHWuaF;EXvaE,4GWuaF;EACA,gBAAA;AjCw7GJ;AsB51HM;EW4ZJ;IX3ZM,qBAAA;IAAA,gBAAA;EtB+1HN;AACF;AiC37GI;ETpbA,yBlB4mByC;ANswG7C;AiCz7GE;EACE,W3BmKgC;E2BlKhC,c3BmKgC;E2BlKhC,kBAAA;EACA,e3BkKgC;E2BjKhC,yBhCnbO;EgCobP,yBAAA;ErBnbA,mBAAA;ECFE,yDoBubF;AjC27GJ;AiCx7GE;EACE,W3B+JyC;E2B9JzC,Y3B8JyC;E2B7JzC,aAAA;EACA,ehCsIoC;EgCrIpC,chCqIoC;EuB9kBpC,yBvB4V4B;EgC+G5B,S3B4JyC;EM3lBzC,mBAAA;ECFE,kDoBmcF;EXncE,gHWocF;EXpcE,4GWocF;EACA,gBAAA;AjC07GJ;AsB33HM;EWsbJ;IXrbM,oBAAA;IAAA,gBAAA;EtB83HN;AACF;AiC77GI;ETjdA,yBlB4mByC;ANqyG7C;AiC37GE;EACE,W3BsIgC;E2BrIhC,c3BsIgC;E2BrIhC,kBAAA;EACA,e3BqIgC;E2BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;EpBndE,yDoBodF;AjC67GJ;AiC17GE;EACE,yBhCvdO;EWCP,mBAAA;AZm5HJ;AiCz7GE;EACE,kBAAA;EACA,yBhC7dO;EWCP,mBAAA;AZw5HJ;AiCv7GI;EACE,yBhCjeK;AD05HX;AiCt7GI;EACE,eAAA;AjCw7GN;AiCr7GI;EACE,yBhCzeK;ADg6HX;AiCp7GI;EACE,eAAA;AjCs7GN;AiCn7GI;EACE,yBhCjfK;ADs6HX;;AiCh7GA;;;EXzfM,4GW4fJ;AjCm7GF;AsB36HM;EWqfN;;;IXpfQ,gBAAA;EtBg7HN;AACF;;AkCj8HA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlCo8HF;;AkCj8HA;EACE,cAAA;EACA,oBAAA;AlCo8HF;AOn8HE;E2BGE,qBAAA;AlCm8HJ;AkC/7HE;EACE,cjCJO;EiCKP,oBAAA;EACA,eAAA;AlCi8HJ;;AkCz7HA;EACE,sCAAA;AlC47HF;AkC17HE;EACE,yBAAA;EACA,6BAAA;EACA,mCAAA;EtBbA,+BAAA;EACA,gCAAA;AZ08HJ;AOt9HE;E2B6BI,kBAAA;EACA,qC5BipB8B;AN2yGpC;AkCz7HI;EACE,cjC9BK;EiC+BL,6BAAA;EACA,yBAAA;AlC27HN;AkCv7HE;;EAEE,cjCrCO;EiCsCP,yBjC4DyB;EiC3DzB,qC5BsoBgC;ANmzGpC;AkCt7HE;EAEE,sBAAA;EtBtCA,yBAAA;EACA,0BAAA;AZ89HJ;;AkC76HE;EACE,gBAAA;EACA,SAAA;EtB7DA,sBAAA;AZ8+HJ;AkC76HE;;EAEE,cjC6nBgC;EiC5nBhC,yBjC6nBgC;ADkzGpC;;AkCr6HE;;EAEE,cAAA;EACA,kBAAA;AlCw6HJ;;AkCn6HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AlCs6HJ;;AkC55HE;EACE,aAAA;AlC+5HJ;AkC75HE;EACE,cAAA;AlC+5HJ;;AmCxgIA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;AnC2gIF;AmCvgIE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AnC8gIJ;AmC1/HA;EACE,qBAAA;EACA,yB7BkqBkC;E6BjqBlC,4B7BiqBkC;E6BhqBlC,uBlCmqBkC;EItiB9B,qBAAA;E8B3HJ,oBAAA;EACA,mBAAA;AnC4/HF;AOtiIE;E4B6CE,qBAAA;AnC4/HJ;;AmCn/HA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnCs/HF;AmCp/HE;EACE,gBAAA;EACA,eAAA;AnCs/HJ;AmCn/HE;EACE,gBAAA;EACA,WAAA;AnCq/HJ;;AmC5+HA;EACE,qBAAA;EACA,mBlCkmBkC;EkCjmBlC,sBlCimBkC;AD84GpC;;AmCn+HA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AnCo+HF;;AmCh+HA;EACE,wBAAA;E9B8DI,qBAAA;E8B5DJ,cAAA;EACA,6BAAA;EACA,mCAAA;EvBxGE,sBAAA;AZ4kIJ;AO9kIE;E4B8GE,qBAAA;AnCm+HJ;;AmC79HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AnCg+HF;;AmC79HA;EACE,gB7BglBkC;E6B/kBlC,gBAAA;AnCg+HF;;AiBtiII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnC69HR;AACF;AiB/jII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnCk9HN;EmCh9HM;IACE,mBAAA;EnCk9HR;EmCh9HQ;IACE,kBAAA;EnCk9HV;EmC/8HQ;IACE,mBlCoiBwB;IkCniBxB,kBlCmiBwB;ED86GlC;EmC58HM;;;;;;IACE,iBAAA;EnCm9HR;EmCr8HM;IACE,iBAAA;EnCu8HR;EmCp8HM;IACE,wBAAA;IAGA,gBAAA;EnCo8HR;EmCj8HM;IACE,aAAA;EnCm8HR;AACF;AiBplII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnC0gIR;AACF;AiB5mII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnC+/HN;EmC7/HM;IACE,mBAAA;EnC+/HR;EmC7/HQ;IACE,kBAAA;EnC+/HV;EmC5/HQ;IACE,mBlCoiBwB;IkCniBxB,kBlCmiBwB;ED29GlC;EmCz/HM;;;;;;IACE,iBAAA;EnCggIR;EmCl/HM;IACE,iBAAA;EnCo/HR;EmCj/HM;IACE,wBAAA;IAGA,gBAAA;EnCi/HR;EmC9+HM;IACE,aAAA;EnCg/HR;AACF;AiBjoII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnCujIR;AACF;AiBzpII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnC4iIN;EmC1iIM;IACE,mBAAA;EnC4iIR;EmC1iIQ;IACE,kBAAA;EnC4iIV;EmCziIQ;IACE,mBlCoiBwB;IkCniBxB,kBlCmiBwB;EDwgHlC;EmCtiIM;;;;;;IACE,iBAAA;EnC6iIR;EmC/hIM;IACE,iBAAA;EnCiiIR;EmC9hIM;IACE,wBAAA;IAGA,gBAAA;EnC8hIR;EmC3hIM;IACE,aAAA;EnC6hIR;AACF;AiB9qII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnComIR;AACF;AiBtsII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnCylIN;EmCvlIM;IACE,mBAAA;EnCylIR;EmCvlIQ;IACE,kBAAA;EnCylIV;EmCtlIQ;IACE,mBlCoiBwB;IkCniBxB,kBlCmiBwB;EDqjHlC;EmCnlIM;;;;;;IACE,iBAAA;EnC0lIR;EmC5kIM;IACE,iBAAA;EnC8kIR;EmC3kIM;IACE,wBAAA;IAGA,gBAAA;EnC2kIR;EmCxkIM;IACE,aAAA;EnC0kIR;AACF;AmC3oII;EAoBI,qBAAA;EACA,2BAAA;AnC0nIR;AmC7oIQ;;;;;;EACE,gBAAA;EACA,eAAA;AnCopIV;AmCjoIQ;EACE,mBAAA;AnCmoIV;AmCjoIU;EACE,kBAAA;AnCmoIZ;AmChoIU;EACE,mBlCoiBwB;EkCniBxB,kBlCmiBwB;AD+lHpC;AmC7nIQ;;;;;;EACE,iBAAA;AnCooIV;AmCtnIQ;EACE,iBAAA;AnCwnIV;AmCrnIQ;EACE,wBAAA;EAGA,gBAAA;AnCqnIV;AmClnIQ;EACE,aAAA;AnConIV;;AmCtmIE;EACE,4BlC8gBgC;AD2lHpC;AOj0IE;E4B2NI,4BlC2gB8B;AD8lHpC;AmCpmII;EACE,4BlCmgB8B;ADmmHpC;AOv0IE;E4BoOM,4BlCigB4B;ADqmHpC;AmCnmIM;EACE,4BlC+f4B;ADsmHpC;AmCjmII;;;;EAIE,4BlCsf8B;AD6mHpC;AmC/lIE;EACE,4BlC+egC;EkC9ehC,yBlCmfgC;AD8mHpC;AmC9lIE;EACE,yDAAA;AnCgmIJ;AmC7lIE;EACE,4BlCsegC;ADynHpC;AmC9lII;EACE,4BlCse8B;AD0nHpC;AOh2IE;E4BmQM,4BlCme4B;AD6nHpC;;AmCxlIE;EACE,gClCidgC;AD0oHpC;AOv2IE;E4B+QI,gClC8c8B;AD6oHpC;AmCtlII;EACE,gClCsc8B;ADkpHpC;AO72IE;E4BwRM,gClCoc4B;ADopHpC;AmCrlIM;EACE,gClCkc4B;ADqpHpC;AmCnlII;;;;EAIE,gClCyb8B;AD4pHpC;AmCjlIE;EACE,gClCkbgC;EkCjbhC,yBlCqbgC;AD8pHpC;AmChlIE;EACE,yDAAA;AnCklIJ;AmC/kIE;EACE,gClCyagC;ADwqHpC;AmChlII;EACE,gClCya8B;ADyqHpC;AOt4IE;E4BuTM,gClCsa4B;AD4qHpC;;AoCr5IA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,yBnCGS;EmCFT,2BAAA;EACA,8CAAA;ExBKE,wBAAA;AZm5IJ;AoCr5IE;EACE,eAAA;EACA,cAAA;ApCu5IJ;AoCp5IE;EACE,mBAAA;EACA,sBAAA;ApCs5IJ;AoCp5II;EACE,mBAAA;ExBCF,mDAAA;EACA,oDAAA;AZs5IJ;AoCp5II;EACE,sBAAA;ExBUF,uDAAA;EACA,sDAAA;AZ64IJ;AoCj5IE;;EAEE,aAAA;ApCm5IJ;;AoC/4IA;EAGE,cAAA;EAGA,eAAA;EACA,enCw0BkC;ADskHpC;;AoC14IA;EACE,sBnCk0BkC;AD2kHpC;;AoC14IA;EACE,qBAAA;EACA,gBAAA;ApC64IF;;AoC14IA;EACE,gBAAA;ApC64IF;;AOl8IE;E6B0DE,qBAAA;ApC44IJ;AoCz4IE;EACE,mBnCizBgC;AD0lHpC;;AoCn4IA;EACE,uBAAA;EACA,gBAAA;EAEA,yBnCvES;EmCwET,qDAAA;ApCq4IF;AoCn4IE;ExBvEE,0EAAA;AZ68IJ;;AoCj4IA;EACE,uBAAA;EAEA,yBnClFS;EmCmFT,kDAAA;ApCm4IF;AoCj4IE;ExBlFE,0EAAA;AZs9IJ;;AoC13IA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;ApC63IF;;AoC13IA;EACE,sBAAA;EACA,qBAAA;ApC63IF;;AoCz3IA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBnCkwBkC;EWj3BhC,0CAAA;AZ4+IJ;;AoCz3IA;;;EAGE,cAAA;EACA,WAAA;ApC43IF;;AoCz3IA;;ExBjHI,mDAAA;EACA,oDAAA;AZ++IJ;;AoC13IA;;ExBxGI,uDAAA;EACA,sDAAA;AZu+IJ;;AoCv3IE;EACE,mB9BqrBgC;ANqsHpC;AiBz9II;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EpC03IF;EoCx3IE;IAEE,SAAA;IACA,kB9ByqB8B;I8BxqB9B,gBAAA;IACA,iB9BuqB8B;ENktHlC;AACF;;AoC72IE;EACE,mB9BypBgC;ANutHpC;AiB3+II;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EpCg3IF;EoC72IE;IAEE,SAAA;IACA,gBAAA;EpC82IJ;EoC52II;IACE,cAAA;IACA,cAAA;EpC82IN;EoCz2IM;IxBzKJ,0BAAA;IACA,6BAAA;EZqhJF;EoC12IQ;;IAGE,0BAAA;EpC22IV;EoCz2IQ;;IAGE,6BAAA;EpC02IV;EoCt2IM;IxB1KJ,yBAAA;IACA,4BAAA;EZmhJF;EoCv2IQ;;IAGE,yBAAA;EpCw2IV;EoCt2IQ;;IAGE,4BAAA;EpCu2IV;AACF;;AoC11IE;EACE,sBnCsoBgC;ADutHpC;AiBrhJI;EmBsLJ;IAMI,enCgpBgC;ImC/oBhC,mBnCgpBgC;ImC/oBhC,UAAA;IACA,SAAA;EpC61IF;EoC31IE;IACE,qBAAA;IACA,WAAA;EpC61IJ;AACF;;AoCp1IA;EACE,qBAAA;ApCu1IF;AoCr1IE;EACE,gBAAA;ApCu1IJ;AoCr1II;EACE,gBAAA;ExBvOF,6BAAA;EACA,4BAAA;AZ+jJJ;AoCr1II;ExBzPA,yBAAA;EACA,0BAAA;AZilJJ;AoCr1II;ExBtQA,gBAAA;EwBwQE,yBAAA;ApCu1IN;;AqCjnJA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BqiCkC;E+BniClC,gBAAA;EACA,yBpC6GqB;EWlGnB,sBAAA;AZymJJ;;AqC9mJE;EACE,oB/ByhCgC;ANwlHpC;AqC/mJI;EACE,WAAA;EACA,qB/BqhC8B;E+BphC9B,cpCLK;EoCML,YAAA;ArCinJN;AqCvmJE;EACE,0BAAA;ArCymJJ;AqCtmJE;EACE,qBAAA;ArCwmJJ;AqCrmJE;EACE,cpCzBO;ADgoJX;;AsC9oJA;EACE,aAAA;E7BGA,eAAA;EACA,gBAAA;EGaE,sBAAA;AZmoJJ;;AsC/oJA;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,iBhCoxBkC;EgCnxBlC,crCES;EqCAT,6BrCs1BkC;EqCr1BlC,+BAAA;AtCipJF;AsC/oJE;EACE,UAAA;EACA,crCCO;EqCAP,qBAAA;EACA,yBrCJO;EqCKP,qBrCLO;ADspJX;AsC9oJE;EACE,UAAA;EACA,UhC4wBgC;EgC3wBhC,gBrCme0B;AD6qI9B;;AsC1oJI;EACE,cAAA;E1BaF,+BAAA;EACA,kCAAA;AZioJJ;AsC1oJI;E1BNA,gCAAA;EACA,mCAAA;AZmpJJ;AsCzoJE;EACE,UAAA;EACA,crCjCO;EqCkCP,yBrCkT4B;EqCjT5B,qBrCiT4B;AD01IhC;AsCxoJE;EACE,crCjCO;EqCkCP,oBAAA;EAEA,YAAA;EACA,6BrC2zBgC;EqC1zBhC,qBrCzCO;ADkrJX;;AuChsJE;EACE,uBAAA;ElCgLE,qBAAA;EkC9KF,qBtCgD0B;ADmpJ9B;AuC9rJM;E3BqCF,iCAAA;EACA,oCAAA;AZ4pJJ;AuC7rJM;E3BkBF,kCAAA;EACA,qCAAA;AZ8qJJ;;AuC9sJE;EACE,uBAAA;ElCgLE,0BAAA;EkC9KF,gBtCiD0B;ADgqJ9B;AuC5sJM;E3BqCF,iCAAA;EACA,oCAAA;AZ0qJJ;AuC3sJM;E3BkBF,kCAAA;EACA,qCAAA;AZ4rJJ;;AwC1tJA;EACE,qBAAA;EACA,uBAAA;EnC6KI,qBAAA;EmC3KJ,gBvCuY4B;EuCtY5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E5BKE,sBAAA;EUFE,qIkBDJ;AxC6tJF;AsBxtJM;EkBfN;IlBgBQ,gBAAA;EtB2tJN;AACF;AOjuJE;EiCGI,qBAAA;AxCiuJN;;AwC5tJE;EACE,aAAA;AxC+tJJ;;AwC1tJA;EACE,kBAAA;EACA,SAAA;AxC6tJF;;AwCttJA;EACE,sBvCgzBkC;EuC/yBlC,qBvC+yBkC;EWt0BhC,uBAAA;AZivJJ;;AwCjtJE;ECjDA,cAAA;EACA,yBnC0Ea;AN4rJf;AOxvJE;EkCVI,cAAA;EACA,yBAAA;AzCqwJN;AyClwJI;EAEE,UAAA;EACA,2CAAA;AzCmwJN;;AwC9tJE;ECjDA,cAAA;EACA,yBnC0Ea;ANysJf;AOrwJE;EkCVI,cAAA;EACA,yBAAA;AzCkxJN;AyC/wJI;EAEE,UAAA;EACA,4CAAA;AzCgxJN;;AwC3uJE;ECjDA,cAAA;EACA,yBnC0Ea;ANstJf;AOlxJE;EkCVI,cAAA;EACA,yBAAA;AzC+xJN;AyC5xJI;EAEE,UAAA;EACA,0CAAA;AzC6xJN;;AwCxvJE;ECjDA,cAAA;EACA,yBnC0Ea;ANmuJf;AO/xJE;EkCVI,cAAA;EACA,yBAAA;AzC4yJN;AyCzyJI;EAEE,UAAA;EACA,2CAAA;AzC0yJN;;AwCrwJE;ECjDA,cAAA;EACA,yBnC0Ea;ANgvJf;AO5yJE;EkCVI,cAAA;EACA,yBAAA;AzCyzJN;AyCtzJI;EAEE,UAAA;EACA,4CAAA;AzCuzJN;;AwClxJE;ECjDA,cAAA;EACA,yBnC0Ea;AN6vJf;AOzzJE;EkCVI,cAAA;EACA,yBAAA;AzCs0JN;AyCn0JI;EAEE,UAAA;EACA,2CAAA;AzCo0JN;;AwC/xJE;ECjDA,cAAA;EACA,yBnC0Ea;AN0wJf;AOt0JE;EkCVI,cAAA;EACA,yBAAA;AzCm1JN;AyCh1JI;EAEE,UAAA;EACA,4CAAA;AzCi1JN;;AwC5yJE;ECjDA,cAAA;EACA,yBnC0Ea;ANuxJf;AOn1JE;EkCVI,cAAA;EACA,yBAAA;AzCg2JN;AyC71JI;EAEE,UAAA;EACA,yCAAA;AzC81JN;;AwCzzJE;ECjDA,cAAA;EACA,yBnC0Ea;ANoyJf;AOh2JE;EkCVI,cAAA;EACA,yBAAA;AzC62JN;AyC12JI;EAEE,UAAA;EACA,0CAAA;AzC22JN;;AwCt0JE;ECjDA,cAAA;EACA,yBnC0Ea;ANizJf;AO72JE;EkCVI,cAAA;EACA,yBAAA;AzC03JN;AyCv3JI;EAEE,UAAA;EACA,4CAAA;AzCw3JN;;AwCn1JE;ECjDA,cAAA;EACA,yBnC0Ea;AN8zJf;AO13JE;EkCVI,cAAA;EACA,yBAAA;AzCu4JN;AyCp4JI;EAEE,UAAA;EACA,4CAAA;AzCq4JN;;AwCh2JE;ECjDA,cAAA;EACA,uBnC0Ea;AN20Jf;AOv4JE;EkCVI,cAAA;EACA,uBAAA;AzCo5JN;AyCj5JI;EAEE,UAAA;EACA,sCAAA;AzCk5JN;;A0C/5JA;EACE,kBAAA;EACA,mBpCyzBkC;EoCvzBlC,yBzCYS;EWEP,wBAAA;AZo5JJ;AiB12JI;EyB5DJ;IAQI,kBAAA;E1Ck6JF;AACF;;A0C/5JA;EACE,gBAAA;EACA,eAAA;E9BIE,gBAAA;AZ+5JJ;;A2C76JA;EACE,kBAAA;EACA,uBAAA;EACA,mBrCy9BkC;EqCx9BlC,mCAAA;E/BUE,wBAAA;AZu6JJ;;A2C56JA;EAEE,cAAA;A3C86JF;;A2C16JA;EACE,gB1C2X4B;ADkjJ9B;;A2Cr6JA;EACE,wBAAA;A3Cw6JF;A2Cr6JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;A3Cu6JJ;;A2C75JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3Ck6JvE;A4C98JE;EACE,yBAAA;A5Cg9JJ;A4C78JE;EACE,cAAA;A5C+8JJ;;A2Cz6JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C86JvE;A4C19JE;EACE,yBAAA;A5C49JJ;A4Cz9JE;EACE,cAAA;A5C29JJ;;A2Cr7JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C07JvE;A4Ct+JE;EACE,yBAAA;A5Cw+JJ;A4Cr+JE;EACE,cAAA;A5Cu+JJ;;A2Cj8JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3Cs8JvE;A4Cl/JE;EACE,yBAAA;A5Co/JJ;A4Cj/JE;EACE,cAAA;A5Cm/JJ;;A2C78JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3Ck9JvE;A4C9/JE;EACE,yBAAA;A5CggKJ;A4C7/JE;EACE,cAAA;A5C+/JJ;;A2Cz9JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C89JvE;A4C1gKE;EACE,yBAAA;A5C4gKJ;A4CzgKE;EACE,cAAA;A5C2gKJ;;A2Cr+JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C0+JvE;A4CthKE;EACE,yBAAA;A5CwhKJ;A4CrhKE;EACE,cAAA;A5CuhKJ;;A2Cj/JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3Cs/JvE;A4CliKE;EACE,yBAAA;A5CoiKJ;A4CjiKE;EACE,cAAA;A5CmiKJ;;A2C7/JE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CkgKvE;A4C9iKE;EACE,yBAAA;A5CgjKJ;A4C7iKE;EACE,cAAA;A5C+iKJ;;A2CzgKE;EC/CA,YDgDqH;EnB3CnH,uBmB2CuB;EC9CzB,mBD8CqE;A3C8gKvE;A4C1jKE;EACE,yBAAA;A5C4jKJ;A4CzjKE;EACE,cAAA;A5C2jKJ;;A2CrhKE;EC/CA,YDgDqH;EnB3CnH,uBmB2CuB;EC9CzB,mBD8CqE;A3C0hKvE;A4CtkKE;EACE,yBAAA;A5CwkKJ;A4CrkKE;EACE,cAAA;A5CukKJ;;A2CjiKE;EC/CA,YDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CsiKvE;A4CllKE;EACE,yBAAA;A5ColKJ;A4CjlKE;EACE,YAAA;A5CmlKJ;;A6C3lKE;EACE;IAAO,6BAAA;E7C+lKT;E6C9lKE;IAAK,wBAAA;E7CimKP;AACF;A6C9lKA;EACE,aAAA;EACA,c5C26BkC;E4C16BlC,gBAAA;EACA,cAAA;ExCwKI,qBAAA;EwCtKJ,oC5Cw6BkC;EWp6BhC,uBAAA;ECFE,8CAAA;AbgmKN;;A6C7lKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,c5CVS;E4CWT,kBAAA;EACA,mBAAA;EACA,yBvCu9BkC;EgBl+B9B,2BuBYJ;A7CgmKF;AsBxmKM;EuBDN;IvBEQ,gBAAA;EtB2mKN;AACF;;A6ClmKA;ErBYE,qMAAA;EqBVA,8BAAA;A7CqmKF;;A6CjmKE;EACE,kDAAA;A7ComKJ;A6CjmKM;EAJJ;IAKM,eAAA;E7ComKN;AACF;;A8C/oKA;EACE,aAAA;EACA,uBAAA;A9CkpKF;;A8C/oKA;EACE,SAAA;A9CkpKF;;A+CppKA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EnCQE,sBAAA;AZ8oKJ;;A+C5oKA;EACE,WAAA;EACA,c9CDS;E8CET,mBAAA;A/C+oKF;AOtpKE;EwCWE,UAAA;EACA,c9CPO;E8CQP,qBAAA;EACA,yB9CfO;AD6pKX;A+C3oKE;EACE,c9CbO;E8CcP,yB9CnBO;ADgqKX;;A+CpoKA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EAGA,yB9CpCS;E8CqCT,+BAAA;A/CqoKF;A+CnoKE;EnC1BE,+BAAA;EACA,gCAAA;AZgqKJ;A+CnoKE;EnChBE,mCAAA;EACA,kCAAA;AZspKJ;A+CnoKE;EAEE,c9C3CO;E8C4CP,oBAAA;EACA,yB9CnDO;ADurKX;A+ChoKE;EACE,UAAA;EACA,c9CzDO;E8C0DP,yB9C0R4B;E8CzR5B,qB9CyR4B;ADy2JhC;A+C/nKE;EACE,mBAAA;A/CioKJ;A+C/nKI;EACE,sBAAA;EACA,2B9C4PwB;ADq4J9B;;A+CnnKI;EACE,mBAAA;A/CsnKN;A+CnnKQ;EnC1BJ,kCAAA;EAZA,0BAAA;AZ6pKJ;A+ClnKQ;EnC3CJ,gCAAA;EAYA,4BAAA;AZqpKJ;A+CjnKQ;EACE,aAAA;A/CmnKV;A+ChnKQ;EACE,2B9C2NoB;E8C1NpB,oBAAA;A/CknKV;A+ChnKU;EACE,uBAAA;EACA,4B9CsNkB;AD45J9B;;AiB7qKI;E8BmCA;IACE,mBAAA;E/C8oKJ;E+C3oKM;InC1BJ,kCAAA;IAZA,0BAAA;EZqrKF;E+C1oKM;InC3CJ,gCAAA;IAYA,4BAAA;EZ6qKF;E+CzoKM;IACE,aAAA;E/C2oKR;E+CxoKM;IACE,2B9C2NoB;I8C1NpB,oBAAA;E/C0oKR;E+CxoKQ;IACE,uBAAA;IACA,4B9CsNkB;EDo7J5B;AACF;AiBtsKI;E8BmCA;IACE,mBAAA;E/CsqKJ;E+CnqKM;InC1BJ,kCAAA;IAZA,0BAAA;EZ6sKF;E+ClqKM;InC3CJ,gCAAA;IAYA,4BAAA;EZqsKF;E+CjqKM;IACE,aAAA;E/CmqKR;E+ChqKM;IACE,2B9C2NoB;I8C1NpB,oBAAA;E/CkqKR;E+ChqKQ;IACE,uBAAA;IACA,4B9CsNkB;ED48J5B;AACF;AiB9tKI;E8BmCA;IACE,mBAAA;E/C8rKJ;E+C3rKM;InC1BJ,kCAAA;IAZA,0BAAA;EZquKF;E+C1rKM;InC3CJ,gCAAA;IAYA,4BAAA;EZ6tKF;E+CzrKM;IACE,aAAA;E/C2rKR;E+CxrKM;IACE,2B9C2NoB;I8C1NpB,oBAAA;E/C0rKR;E+CxrKQ;IACE,uBAAA;IACA,4B9CsNkB;EDo+J5B;AACF;AiBtvKI;E8BmCA;IACE,mBAAA;E/CstKJ;E+CntKM;InC1BJ,kCAAA;IAZA,0BAAA;EZ6vKF;E+CltKM;InC3CJ,gCAAA;IAYA,4BAAA;EZqvKF;E+CjtKM;IACE,aAAA;E/CmtKR;E+ChtKM;IACE,2B9C2NoB;I8C1NpB,oBAAA;E/CktKR;E+ChtKQ;IACE,uBAAA;IACA,4B9CsNkB;ED4/J5B;AACF;A+CrsKA;EnCnHI,gBAAA;AZ2zKJ;A+CrsKE;EACE,2BAAA;A/CusKJ;A+CrsKI;EACE,sBAAA;A/CusKN;;AgDh1KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CgsK3C;AOx0KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhDk1KR;AgD/0KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/CysK1E;;AgD91KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C8sK3C;AOt1KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhDg2KR;AgD71KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/CutK1E;;AgD52KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C4tK3C;AOp2KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhD82KR;AgD32KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/CquK1E;;AgD13KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C0uK3C;AOl3KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhD43KR;AgDz3KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/CmvK1E;;AgDx4KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CwvK3C;AOh4KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhD04KR;AgDv4KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/CiwK1E;;AgDt5KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CswK3C;AO94KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhDw5KR;AgDr5KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/C+wK1E;;AgDp6KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CoxK3C;AO55KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhDs6KR;AgDn6KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/C6xK1E;;AgDl7KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CkyK3C;AO16KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhDo7KR;AgDj7KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/C2yK1E;;AgDh8KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CgzK3C;AOx7KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhDk8KR;AgD/7KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/CyzK1E;;AgD98KE;EACE,cDoJsE;ECnJtE,uBDmJuC;A/C8zK3C;AOt8KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhDg9KR;AgD78KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/Cu0K1E;;AgD59KE;EACE,cDoJsE;ECnJtE,uBDmJuC;A/C40K3C;AOp9KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhD89KR;AgD39KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/Cq1K1E;;AgD1+KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C01K3C;AOl+KE;EyCPM,cD+IkE;EC9IlE,yBAAA;AhD4+KR;AgDz+KM;EACE,cAAA;EACA,yBDyIkE;ECxIlE,qBDwIkE;A/Cm2K1E;;AiD3/KA;EACE,YAAA;E5CmLI,oBAAA;E4CjLJ,gBhD4Y4B;EgD3Y5B,cAAA;EACA,yBhDmyBkC;EgDlyBlC,iBhDoyBkC;EgDnyBlC,YAAA;AjD8/KF;AOz/KE;E0CDE,yBhD6xBgC;EgD5xBhC,qBAAA;AjD6/KJ;AOz/KE;E0CCI,aAAA;AjD2/KN;;AiDh/KA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AjDm/KF;;AiD7+KA;EACE,oBAAA;AjDg/KF;;AkDhhLA;EAEE,gBAAA;AlDkhLF;AkDhhLE;EACE,kBAAA;EACA,gBAAA;AlDkhLJ;;AkD7gLA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C4pBkC;E4C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AlD8gLF;;AkDvgLA;EACE,kBAAA;EACA,WAAA;EACA,c5Ci5BkC;E4C/4BlC,oBAAA;AlDygLF;AkDtgLE;E5B3BI,mC4B4BF;EACA,8B5Cu6BgC;ANimJpC;AsBjiLM;E4BuBJ;I5BtBM,gBAAA;EtBoiLN;AACF;AkD3gLE;EACE,e5Cq6BgC;ANwmJpC;AkDzgLE;EACE,sB5Ck6BgC;ANymJpC;;AkDvgLA;EACE,aAAA;EACA,6BAAA;AlD0gLF;AkDxgLE;EACE,8BAAA;EACA,gBAAA;AlD0gLJ;AkDvgLE;;EAEE,cAAA;AlDygLJ;AkDtgLE;EACE,gBAAA;AlDwgLJ;;AkDpgLA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AlDugLF;AkDpgLE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AlDsgLJ;AkDlgLE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AlDogLJ;AkDlgLI;EACE,gBAAA;AlDogLN;AkDjgLI;EACE,aAAA;AlDmgLN;;AkD7/KA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,yBjDpGS;EiDqGT,4BAAA;EACA,uCAAA;EtClGE,wBAAA;ECFE,gDqCsGJ;EAEA,UAAA;AlD6/KF;;AkDz/KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5CgjBkC;E4C/iBlC,YAAA;EACA,aAAA;EACA,yBjD1Bc;ADshLhB;AkDz/KE;EAAS,UAAA;AlD4/KX;AkD3/KE;EAAS,ajDqyBmB;ADytJ9B;;AkDz/KA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBjDiyB4B;EiDhyB5B,gCAAA;EtCtHE,6CAAA;EACA,8CAAA;AZmnLJ;AkD3/KE;EACE,yBjD4xB0B;EiD1xB1B,8BAAA;AlD4/KJ;;AkDv/KA;EACE,gBAAA;EACA,gBjDqwBkC;ADqvJpC;;AkDr/KA;EACE,kBAAA;EAGA,cAAA;EACA,4BjDsvBkC;ADgwJpC;;AkDl/KA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,6BAAA;EtCzIE,iDAAA;EACA,gDAAA;AZ+nLJ;AkDj/KE;EACE,eAAA;AlDm/KJ;;AkD9+KA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AlDi/KF;;AiBxnLI;EiC6IF;IACE,gBjDutBgC;IiDttBhC,oBAAA;ElD++KF;EkD5+KA;IACE,+BAAA;ElD8+KF;EkD5+KE;IACE,gCAAA;ElD8+KJ;EkD1+KA;IACE,+BAAA;ElD4+KF;EkD1+KE;IACE,4BAAA;IACA,mBAAA;ElD4+KJ;EkDx+KA;IrC/MI,6EqCgNF;ElD0+KF;EkDv+KA;IAAY,gBjD+rBsB;ED2yJlC;AACF;AiBlpLI;EiC2KF;;IAEE,gBjDurBgC;EDmzJlC;AACF;AiBxpLI;EiCkLF;IAAY,iB5CiuBsB;ENywJlC;AACF;AmDxtLA;EACE,kBAAA;EACA,a7CgrBkC;E6C/qBlC,cAAA;EACA,SlDi5BkC;EmDr5BlC,kCnD0X4B;EmDxX5B,kBAAA;EACA,gBnD0Y4B;EmDzY5B,gB9CgS4B;E8C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,0BAAA;E8CzKJ,qBAAA;EACA,UAAA;AnDouLF;AmDluLE;EAAS,YlDq4ByB;ADg2JpC;AmDnuLE;EACE,kBAAA;EACA,cAAA;EACA,alDq4BgC;EkDp4BhC,clDq4BgC;ADg2JpC;AmDnuLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDquLN;;AmDhuLA;EACE,iBAAA;AnDmuLF;AmDjuLE;EACE,SAAA;AnDmuLJ;AmDjuLI;EACE,MAAA;EACA,6BAAA;EACA,yBlD1BK;AD6vLX;;AmD9tLA;EACE,iBAAA;AnDiuLF;AmD/tLE;EACE,OAAA;EACA,alDu2BgC;EkDt2BhC,clDq2BgC;AD43JpC;AmD/tLI;EACE,QAAA;EACA,oCAAA;EACA,2BlD1CK;AD2wLX;;AmD5tLA;EACE,iBAAA;AnD+tLF;AmD7tLE;EACE,MAAA;AnD+tLJ;AmD7tLI;EACE,SAAA;EACA,6BAAA;EACA,4BlDxDK;ADuxLX;;AmD1tLA;EACE,iBAAA;AnD6tLF;AmD3tLE;EACE,QAAA;EACA,alDy0BgC;EkDx0BhC,clDu0BgC;ADs5JpC;AmD3tLI;EACE,OAAA;EACA,oCAAA;EACA,0BlDxEK;ADqyLX;;AmDxsLA;EACE,gBlDmyBkC;EkDlyBlC,uBAAA;EACA,clDLc;EkDMd,kBAAA;EACA,yBlDlGS;EWIP,sBAAA;AZ0yLJ;;AqD5zLA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/C8qBkC;E+C7qBlC,cAAA;EACA,gBpD2yBkC;EmDhzBlC,kCnD0X4B;EmDxX5B,kBAAA;EACA,gBnD0Y4B;EmDzY5B,gB9CgS4B;E8C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,0BAAA;EgDxKJ,qBAAA;EACA,yBpDCS;EoDAT,4BAAA;EACA,wCAAA;EzCGE,wBAAA;ECFE,qDwCCJ;ArDy0LF;AqDv0LE;EACE,kBAAA;EACA,cAAA;EACA,apD0yBgC;EoDzyBhC,epD0yBgC;EoDzyBhC,mBAAA;ArDy0LJ;AqDv0LI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDw0LN;;AqDn0LA;EACE,sBpD2xBkC;AD2iKpC;AqDp0LE;EACE,4BAAA;ArDs0LJ;AqDp0LI;EACE,SAAA;EACA,+BAAA;EACA,6BpDsxB8B;ADgjKpC;AqDn0LI;EACE,WpDgwB8B;EoD/vB9B,+BAAA;EACA,yBpDtCK;AD22LX;;AqDh0LA;EACE,oBpDuwBkC;AD4jKpC;AqDj0LE;EACE,0BAAA;EACA,cpDmwBgC;EoDlwBhC,cpDiwBgC;EoDhwBhC,mBAAA;ArDm0LJ;AqDj0LI;EACE,OAAA;EACA,uCAAA;EACA,+BpD+vB8B;ADokKpC;AqDh0LI;EACE,SpDyuB8B;EoDxuB9B,uCAAA;EACA,2BpD7DK;AD+3LX;;AqD7zLA;EACE,mBpDgvBkC;ADglKpC;AqD9zLE;EACE,yBAAA;ArDg0LJ;AqD9zLI;EACE,MAAA;EACA,uCAAA;EACA,gCpD2uB8B;ADqlKpC;AqD7zLI;EACE,QpDqtB8B;EoDptB9B,uCAAA;EACA,4BpDjFK;ADg5LX;AqD1zLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,apDutBgC;EoDttBhC,qBAAA;EACA,WAAA;EACA,gCAAA;ArD4zLJ;;AqDxzLA;EACE,qBpDgtBkC;AD2mKpC;AqDzzLE;EACE,2BAAA;EACA,cpD4sBgC;EoD3sBhC,cpD0sBgC;EoDzsBhC,mBAAA;ArD2zLJ;AqDzzLI;EACE,QAAA;EACA,uCAAA;EACA,8BpDwsB8B;ADmnKpC;AqDxzLI;EACE,UpDkrB8B;EoDjrB9B,uCAAA;EACA,0BpDpHK;AD86LX;;AqDpyLA;EACE,wBAAA;EACA,gBAAA;EhD0BI,mBAAA;EgDxBJ,cpDtIS;EoDuIT,yBpD/IS;EoDgJT,gCAAA;EzCnIE,6CAAA;EACA,8CAAA;AZ26LJ;AqDtyLE;EACE,aAAA;ArDwyLJ;;AqDpyLA;EACE,wBAAA;EACA,cpDnJS;AD07LX;;AsDl8LA;EACE,kBAAA;AtDq8LF;;AsDl8LA;EACE,mBAAA;AtDq8LF;;AsDl8LA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtDq8LF;AuD59LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD89LJ;;AsDt8LA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AtDy8LF;AsBx9LM;EgCQN;IhCPQ,gBAAA;EtB29LN;AACF;;AsD38LA;;;EAGE,cAAA;AtD88LF;;AsD38LA;;EAEE,2BAAA;AtD88LF;;AsD38LA;;EAEE,4BAAA;AtD88LF;;AsDr8LE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDw8LJ;AsDr8LE;;;EAGE,UAAA;EACA,UAAA;AtDu8LJ;AsDp8LE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtDs8LJ;AsB//LM;EgCqDJ;;IhCpDM,gBAAA;EtBmgMN;AACF;;AsDn8LA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDs9BmC;EgDr9BnC,UAAA;EACA,crDpFS;EqDqFT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhDi9BmC;EgBviC/B,8BgCuFJ;AtDq8LF;AsBxhMM;EgCkEN;;IhCjEQ,gBAAA;EtB4hMN;AACF;AOliME;;;E+C2FE,crD7FO;EqD8FP,qBAAA;EACA,UAAA;EACA,YhD08BiC;ANkgKrC;;AsDz8LA;EACE,OAAA;AtD48LF;;AsDv8LA;EACE,QAAA;AtD08LF;;AsDn8LA;;EAEE,qBAAA;EACA,WhDm8BmC;EgDl8BnC,YhDk8BmC;EgDj8BnC,mCAAA;AtDs8LF;;AsDp8LA;EACE,yDAAA;AtDu8LF;;AsDr8LA;EACE,yDAAA;AtDw8LF;;AsD/7LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhDy5BmC;EgDx5BnC,gBhDw5BmC;EgDv5BnC,gBAAA;AtDi8LF;AsD/7LE;EACE,uBAAA;EACA,cAAA;EACA,WhDu5BiC;EgDt5BjC,WhDu5BiC;EgDt5BjC,iBhDw5BiC;EgDv5BjC,gBhDu5BiC;EgDt5BjC,mBAAA;EACA,eAAA;EACA,yBrD5JO;EqD6JP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EhC/JE,6BgCgKF;AtDg8LJ;AsB5lMM;EgC6IJ;IhC5IM,gBAAA;EtB+lMN;AACF;AsDl8LE;EACE,UAAA;AtDo8LJ;;AsD37LA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,crDvLS;EqDwLT,kBAAA;AtD87LF;;AwDloMA;EAAqB,mCAAA;AxDsoMrB;;AwDroMA;EAAqB,8BAAA;AxDyoMrB;;AwDxoMA;EAAqB,iCAAA;AxD4oMrB;;AwD3oMA;EAAqB,iCAAA;AxD+oMrB;;AwD9oMA;EAAqB,sCAAA;AxDkpMrB;;AwDjpMA;EAAqB,mCAAA;AxDqpMrB;;AyDvpME;EACE,oCAAA;AzD0pMJ;;AOhpME;;;EkDLI,oCAAA;AzD2pMN;;AyDjqME;EACE,oCAAA;AzDoqMJ;;AO1pME;;;EkDLI,oCAAA;AzDqqMN;;AyD3qME;EACE,oCAAA;AzD8qMJ;;AOpqME;;;EkDLI,oCAAA;AzD+qMN;;AyDrrME;EACE,oCAAA;AzDwrMJ;;AO9qME;;;EkDLI,oCAAA;AzDyrMN;;AyD/rME;EACE,oCAAA;AzDksMJ;;AOxrME;;;EkDLI,oCAAA;AzDmsMN;;AyDzsME;EACE,oCAAA;AzD4sMJ;;AOlsME;;;EkDLI,oCAAA;AzD6sMN;;AyDntME;EACE,oCAAA;AzDstMJ;;AO5sME;;;EkDLI,oCAAA;AzDutMN;;AyD7tME;EACE,oCAAA;AzDguMJ;;AOttME;;;EkDLI,oCAAA;AzDiuMN;;AyDvuME;EACE,oCAAA;AzD0uMJ;;AOhuME;;;EkDLI,oCAAA;AzD2uMN;;AyDjvME;EACE,oCAAA;AzDovMJ;;AO1uME;;;EkDLI,oCAAA;AzDqvMN;;AyD3vME;EACE,oCAAA;AzD8vMJ;;AOpvME;;;EkDLI,oCAAA;AzD+vMN;;AyDrwME;EACE,kCAAA;AzDwwMJ;;AO9vME;;;EkDLI,kCAAA;AzDywMN;;A0DxwMA;EACE,oCAAA;A1D2wMF;;A0DxwMA;EACE,wCAAA;A1D2wMF;;A2DtxMA;EAAkB,0CAAA;A3D0xMlB;;A2DzxMA;EAAkB,8CAAA;A3D6xMlB;;A2D5xMA;EAAkB,gDAAA;A3DgyMlB;;A2D/xMA;EAAkB,iDAAA;A3DmyMlB;;A2DlyMA;EAAkB,+CAAA;A3DsyMlB;;A2DpyMA;EAAmB,oBAAA;A3DwyMnB;;A2DvyMA;EAAmB,wBAAA;A3D2yMnB;;A2D1yMA;EAAmB,0BAAA;A3D8yMnB;;A2D7yMA;EAAmB,2BAAA;A3DizMnB;;A2DhzMA;EAAmB,yBAAA;A3DozMnB;;A2DjzME;EACE,gCAAA;A3DozMJ;;A2DrzME;EACE,gCAAA;A3DwzMJ;;A2DzzME;EACE,gCAAA;A3D4zMJ;;A2D7zME;EACE,gCAAA;A3Dg0MJ;;A2Dj0ME;EACE,gCAAA;A3Do0MJ;;A2Dr0ME;EACE,gCAAA;A3Dw0MJ;;A2Dz0ME;EACE,gCAAA;A3D40MJ;;A2D70ME;EACE,gCAAA;A3Dg1MJ;;A2Dj1ME;EACE,gCAAA;A3Do1MJ;;A2Dr1ME;EACE,gCAAA;A3Dw1MJ;;A2Dz1ME;EACE,gCAAA;A3D41MJ;;A2D71ME;EACE,8BAAA;A3Dg2MJ;;A2D51MA;EACE,gCAAA;A3D+1MF;;A2Dx1MA;EACE,mCAAA;A3D21MF;;A2Dx1MA;EACE,iCAAA;A3D21MF;;A2Dx1MA;EACE,0CAAA;EACA,2CAAA;A3D21MF;;A2Dx1MA;EACE,2CAAA;EACA,8CAAA;A3D21MF;;A2Dx1MA;EACE,8CAAA;EACA,6CAAA;A3D21MF;;A2Dx1MA;EACE,0CAAA;EACA,6CAAA;A3D21MF;;A2Dx1MA;EACE,mCAAA;A3D21MF;;A2Dx1MA;EACE,6BAAA;A3D21MF;;A2Dx1MA;EACE,+BAAA;A3D21MF;;A2Dx1MA;EACE,2BAAA;A3D21MF;;AuDn6ME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDs6MJ;;A4D/5MM;EAAwB,wBAAA;A5Dm6M9B;;A4Dn6MM;EAAwB,0BAAA;A5Du6M9B;;A4Dv6MM;EAAwB,gCAAA;A5D26M9B;;A4D36MM;EAAwB,yBAAA;A5D+6M9B;;A4D/6MM;EAAwB,yBAAA;A5Dm7M9B;;A4Dn7MM;EAAwB,6BAAA;A5Du7M9B;;A4Dv7MM;EAAwB,8BAAA;A5D27M9B;;A4D37MM;EAAwB,wBAAA;A5D+7M9B;;A4D/7MM;EAAwB,+BAAA;A5Dm8M9B;;AiBl5MI;E2CjDE;IAAwB,wBAAA;E5Dw8M5B;E4Dx8MI;IAAwB,0BAAA;E5D28M5B;E4D38MI;IAAwB,gCAAA;E5D88M5B;E4D98MI;IAAwB,yBAAA;E5Di9M5B;E4Dj9MI;IAAwB,yBAAA;E5Do9M5B;E4Dp9MI;IAAwB,6BAAA;E5Du9M5B;E4Dv9MI;IAAwB,8BAAA;E5D09M5B;E4D19MI;IAAwB,wBAAA;E5D69M5B;E4D79MI;IAAwB,+BAAA;E5Dg+M5B;AACF;AiBh7MI;E2CjDE;IAAwB,wBAAA;E5Dq+M5B;E4Dr+MI;IAAwB,0BAAA;E5Dw+M5B;E4Dx+MI;IAAwB,gCAAA;E5D2+M5B;E4D3+MI;IAAwB,yBAAA;E5D8+M5B;E4D9+MI;IAAwB,yBAAA;E5Di/M5B;E4Dj/MI;IAAwB,6BAAA;E5Do/M5B;E4Dp/MI;IAAwB,8BAAA;E5Du/M5B;E4Dv/MI;IAAwB,wBAAA;E5D0/M5B;E4D1/MI;IAAwB,+BAAA;E5D6/M5B;AACF;AiB78MI;E2CjDE;IAAwB,wBAAA;E5DkgN5B;E4DlgNI;IAAwB,0BAAA;E5DqgN5B;E4DrgNI;IAAwB,gCAAA;E5DwgN5B;E4DxgNI;IAAwB,yBAAA;E5D2gN5B;E4D3gNI;IAAwB,yBAAA;E5D8gN5B;E4D9gNI;IAAwB,6BAAA;E5DihN5B;E4DjhNI;IAAwB,8BAAA;E5DohN5B;E4DphNI;IAAwB,wBAAA;E5DuhN5B;E4DvhNI;IAAwB,+BAAA;E5D0hN5B;AACF;AiB1+MI;E2CjDE;IAAwB,wBAAA;E5D+hN5B;E4D/hNI;IAAwB,0BAAA;E5DkiN5B;E4DliNI;IAAwB,gCAAA;E5DqiN5B;E4DriNI;IAAwB,yBAAA;E5DwiN5B;E4DxiNI;IAAwB,yBAAA;E5D2iN5B;E4D3iNI;IAAwB,6BAAA;E5D8iN5B;E4D9iNI;IAAwB,8BAAA;E5DijN5B;E4DjjNI;IAAwB,wBAAA;E5DojN5B;E4DpjNI;IAAwB,+BAAA;E5DujN5B;AACF;A4D9iNA;EAEI;IAAqB,wBAAA;E5DgjNvB;E4DhjNE;IAAqB,0BAAA;E5DmjNvB;E4DnjNE;IAAqB,gCAAA;E5DsjNvB;E4DtjNE;IAAqB,yBAAA;E5DyjNvB;E4DzjNE;IAAqB,yBAAA;E5D4jNvB;E4D5jNE;IAAqB,6BAAA;E5D+jNvB;E4D/jNE;IAAqB,8BAAA;E5DkkNvB;E4DlkNE;IAAqB,wBAAA;E5DqkNvB;E4DrkNE;IAAqB,+BAAA;E5DwkNvB;AACF;A6D9lNA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A7DgmNF;A6D9lNE;EACE,cAAA;EACA,WAAA;A7DgmNJ;A6D7lNE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A7D+lNJ;;A6DtlNI;EACE,yBAAA;A7DylNN;;A6D1lNI;EACE,mBAAA;A7D6lNN;;A6D9lNI;EACE,gBAAA;A7DimNN;;A6DlmNI;EACE,iBAAA;A7DqmNN;;A8D9nNI;EAAgC,8BAAA;A9DkoNpC;;A8DjoNI;EAAgC,iCAAA;A9DqoNpC;;A8DpoNI;EAAgC,sCAAA;A9DwoNpC;;A8DvoNI;EAAgC,yCAAA;A9D2oNpC;;A8DzoNI;EAA8B,0BAAA;A9D6oNlC;;A8D5oNI;EAA8B,4BAAA;A9DgpNlC;;A8D/oNI;EAA8B,kCAAA;A9DmpNlC;;A8DlpNI;EAA8B,yBAAA;A9DspNlC;;A8DrpNI;EAA8B,uBAAA;A9DypNlC;;A8DxpNI;EAA8B,uBAAA;A9D4pNlC;;A8D3pNI;EAA8B,yBAAA;A9D+pNlC;;A8D9pNI;EAA8B,yBAAA;A9DkqNlC;;A8DhqNI;EAAoC,sCAAA;A9DoqNxC;;A8DnqNI;EAAoC,oCAAA;A9DuqNxC;;A8DtqNI;EAAoC,kCAAA;A9D0qNxC;;A8DzqNI;EAAoC,yCAAA;A9D6qNxC;;A8D5qNI;EAAoC,wCAAA;A9DgrNxC;;A8D9qNI;EAAiC,kCAAA;A9DkrNrC;;A8DjrNI;EAAiC,gCAAA;A9DqrNrC;;A8DprNI;EAAiC,8BAAA;A9DwrNrC;;A8DvrNI;EAAiC,gCAAA;A9D2rNrC;;A8D1rNI;EAAiC,+BAAA;A9D8rNrC;;A8D5rNI;EAAkC,oCAAA;A9DgsNtC;;A8D/rNI;EAAkC,kCAAA;A9DmsNtC;;A8DlsNI;EAAkC,gCAAA;A9DssNtC;;A8DrsNI;EAAkC,uCAAA;A9DysNtC;;A8DxsNI;EAAkC,sCAAA;A9D4sNtC;;A8D3sNI;EAAkC,iCAAA;A9D+sNtC;;A8D7sNI;EAAgC,2BAAA;A9DitNpC;;A8DhtNI;EAAgC,iCAAA;A9DotNpC;;A8DntNI;EAAgC,+BAAA;A9DutNpC;;A8DttNI;EAAgC,6BAAA;A9D0tNpC;;A8DztNI;EAAgC,+BAAA;A9D6tNpC;;A8D5tNI;EAAgC,8BAAA;A9DguNpC;;AiBptNI;E6ClDA;IAAgC,8BAAA;E9D2wNlC;E8D1wNE;IAAgC,iCAAA;E9D6wNlC;E8D5wNE;IAAgC,sCAAA;E9D+wNlC;E8D9wNE;IAAgC,yCAAA;E9DixNlC;E8D/wNE;IAA8B,0BAAA;E9DkxNhC;E8DjxNE;IAA8B,4BAAA;E9DoxNhC;E8DnxNE;IAA8B,kCAAA;E9DsxNhC;E8DrxNE;IAA8B,yBAAA;E9DwxNhC;E8DvxNE;IAA8B,uBAAA;E9D0xNhC;E8DzxNE;IAA8B,uBAAA;E9D4xNhC;E8D3xNE;IAA8B,yBAAA;E9D8xNhC;E8D7xNE;IAA8B,yBAAA;E9DgyNhC;E8D9xNE;IAAoC,sCAAA;E9DiyNtC;E8DhyNE;IAAoC,oCAAA;E9DmyNtC;E8DlyNE;IAAoC,kCAAA;E9DqyNtC;E8DpyNE;IAAoC,yCAAA;E9DuyNtC;E8DtyNE;IAAoC,wCAAA;E9DyyNtC;E8DvyNE;IAAiC,kCAAA;E9D0yNnC;E8DzyNE;IAAiC,gCAAA;E9D4yNnC;E8D3yNE;IAAiC,8BAAA;E9D8yNnC;E8D7yNE;IAAiC,gCAAA;E9DgzNnC;E8D/yNE;IAAiC,+BAAA;E9DkzNnC;E8DhzNE;IAAkC,oCAAA;E9DmzNpC;E8DlzNE;IAAkC,kCAAA;E9DqzNpC;E8DpzNE;IAAkC,gCAAA;E9DuzNpC;E8DtzNE;IAAkC,uCAAA;E9DyzNpC;E8DxzNE;IAAkC,sCAAA;E9D2zNpC;E8D1zNE;IAAkC,iCAAA;E9D6zNpC;E8D3zNE;IAAgC,2BAAA;E9D8zNlC;E8D7zNE;IAAgC,iCAAA;E9Dg0NlC;E8D/zNE;IAAgC,+BAAA;E9Dk0NlC;E8Dj0NE;IAAgC,6BAAA;E9Do0NlC;E8Dn0NE;IAAgC,+BAAA;E9Ds0NlC;E8Dr0NE;IAAgC,8BAAA;E9Dw0NlC;AACF;AiB7zNI;E6ClDA;IAAgC,8BAAA;E9Dm3NlC;E8Dl3NE;IAAgC,iCAAA;E9Dq3NlC;E8Dp3NE;IAAgC,sCAAA;E9Du3NlC;E8Dt3NE;IAAgC,yCAAA;E9Dy3NlC;E8Dv3NE;IAA8B,0BAAA;E9D03NhC;E8Dz3NE;IAA8B,4BAAA;E9D43NhC;E8D33NE;IAA8B,kCAAA;E9D83NhC;E8D73NE;IAA8B,yBAAA;E9Dg4NhC;E8D/3NE;IAA8B,uBAAA;E9Dk4NhC;E8Dj4NE;IAA8B,uBAAA;E9Do4NhC;E8Dn4NE;IAA8B,yBAAA;E9Ds4NhC;E8Dr4NE;IAA8B,yBAAA;E9Dw4NhC;E8Dt4NE;IAAoC,sCAAA;E9Dy4NtC;E8Dx4NE;IAAoC,oCAAA;E9D24NtC;E8D14NE;IAAoC,kCAAA;E9D64NtC;E8D54NE;IAAoC,yCAAA;E9D+4NtC;E8D94NE;IAAoC,wCAAA;E9Di5NtC;E8D/4NE;IAAiC,kCAAA;E9Dk5NnC;E8Dj5NE;IAAiC,gCAAA;E9Do5NnC;E8Dn5NE;IAAiC,8BAAA;E9Ds5NnC;E8Dr5NE;IAAiC,gCAAA;E9Dw5NnC;E8Dv5NE;IAAiC,+BAAA;E9D05NnC;E8Dx5NE;IAAkC,oCAAA;E9D25NpC;E8D15NE;IAAkC,kCAAA;E9D65NpC;E8D55NE;IAAkC,gCAAA;E9D+5NpC;E8D95NE;IAAkC,uCAAA;E9Di6NpC;E8Dh6NE;IAAkC,sCAAA;E9Dm6NpC;E8Dl6NE;IAAkC,iCAAA;E9Dq6NpC;E8Dn6NE;IAAgC,2BAAA;E9Ds6NlC;E8Dr6NE;IAAgC,iCAAA;E9Dw6NlC;E8Dv6NE;IAAgC,+BAAA;E9D06NlC;E8Dz6NE;IAAgC,6BAAA;E9D46NlC;E8D36NE;IAAgC,+BAAA;E9D86NlC;E8D76NE;IAAgC,8BAAA;E9Dg7NlC;AACF;AiBr6NI;E6ClDA;IAAgC,8BAAA;E9D29NlC;E8D19NE;IAAgC,iCAAA;E9D69NlC;E8D59NE;IAAgC,sCAAA;E9D+9NlC;E8D99NE;IAAgC,yCAAA;E9Di+NlC;E8D/9NE;IAA8B,0BAAA;E9Dk+NhC;E8Dj+NE;IAA8B,4BAAA;E9Do+NhC;E8Dn+NE;IAA8B,kCAAA;E9Ds+NhC;E8Dr+NE;IAA8B,yBAAA;E9Dw+NhC;E8Dv+NE;IAA8B,uBAAA;E9D0+NhC;E8Dz+NE;IAA8B,uBAAA;E9D4+NhC;E8D3+NE;IAA8B,yBAAA;E9D8+NhC;E8D7+NE;IAA8B,yBAAA;E9Dg/NhC;E8D9+NE;IAAoC,sCAAA;E9Di/NtC;E8Dh/NE;IAAoC,oCAAA;E9Dm/NtC;E8Dl/NE;IAAoC,kCAAA;E9Dq/NtC;E8Dp/NE;IAAoC,yCAAA;E9Du/NtC;E8Dt/NE;IAAoC,wCAAA;E9Dy/NtC;E8Dv/NE;IAAiC,kCAAA;E9D0/NnC;E8Dz/NE;IAAiC,gCAAA;E9D4/NnC;E8D3/NE;IAAiC,8BAAA;E9D8/NnC;E8D7/NE;IAAiC,gCAAA;E9DggOnC;E8D//NE;IAAiC,+BAAA;E9DkgOnC;E8DhgOE;IAAkC,oCAAA;E9DmgOpC;E8DlgOE;IAAkC,kCAAA;E9DqgOpC;E8DpgOE;IAAkC,gCAAA;E9DugOpC;E8DtgOE;IAAkC,uCAAA;E9DygOpC;E8DxgOE;IAAkC,sCAAA;E9D2gOpC;E8D1gOE;IAAkC,iCAAA;E9D6gOpC;E8D3gOE;IAAgC,2BAAA;E9D8gOlC;E8D7gOE;IAAgC,iCAAA;E9DghOlC;E8D/gOE;IAAgC,+BAAA;E9DkhOlC;E8DjhOE;IAAgC,6BAAA;E9DohOlC;E8DnhOE;IAAgC,+BAAA;E9DshOlC;E8DrhOE;IAAgC,8BAAA;E9DwhOlC;AACF;AiB7gOI;E6ClDA;IAAgC,8BAAA;E9DmkOlC;E8DlkOE;IAAgC,iCAAA;E9DqkOlC;E8DpkOE;IAAgC,sCAAA;E9DukOlC;E8DtkOE;IAAgC,yCAAA;E9DykOlC;E8DvkOE;IAA8B,0BAAA;E9D0kOhC;E8DzkOE;IAA8B,4BAAA;E9D4kOhC;E8D3kOE;IAA8B,kCAAA;E9D8kOhC;E8D7kOE;IAA8B,yBAAA;E9DglOhC;E8D/kOE;IAA8B,uBAAA;E9DklOhC;E8DjlOE;IAA8B,uBAAA;E9DolOhC;E8DnlOE;IAA8B,yBAAA;E9DslOhC;E8DrlOE;IAA8B,yBAAA;E9DwlOhC;E8DtlOE;IAAoC,sCAAA;E9DylOtC;E8DxlOE;IAAoC,oCAAA;E9D2lOtC;E8D1lOE;IAAoC,kCAAA;E9D6lOtC;E8D5lOE;IAAoC,yCAAA;E9D+lOtC;E8D9lOE;IAAoC,wCAAA;E9DimOtC;E8D/lOE;IAAiC,kCAAA;E9DkmOnC;E8DjmOE;IAAiC,gCAAA;E9DomOnC;E8DnmOE;IAAiC,8BAAA;E9DsmOnC;E8DrmOE;IAAiC,gCAAA;E9DwmOnC;E8DvmOE;IAAiC,+BAAA;E9D0mOnC;E8DxmOE;IAAkC,oCAAA;E9D2mOpC;E8D1mOE;IAAkC,kCAAA;E9D6mOpC;E8D5mOE;IAAkC,gCAAA;E9D+mOpC;E8D9mOE;IAAkC,uCAAA;E9DinOpC;E8DhnOE;IAAkC,sCAAA;E9DmnOpC;E8DlnOE;IAAkC,iCAAA;E9DqnOpC;E8DnnOE;IAAgC,2BAAA;E9DsnOlC;E8DrnOE;IAAgC,iCAAA;E9DwnOlC;E8DvnOE;IAAgC,+BAAA;E9D0nOlC;E8DznOE;IAAgC,6BAAA;E9D4nOlC;E8D3nOE;IAAgC,+BAAA;E9D8nOlC;E8D7nOE;IAAgC,8BAAA;E9DgoOlC;AACF;A+D3qOI;EAAwB,sBAAA;A/D8qO5B;;A+D7qOI;EAAwB,uBAAA;A/DirO5B;;A+DhrOI;EAAwB,sBAAA;A/DorO5B;;AiBhoOI;E8CtDA;IAAwB,sBAAA;E/D2rO1B;E+D1rOE;IAAwB,uBAAA;E/D6rO1B;E+D5rOE;IAAwB,sBAAA;E/D+rO1B;AACF;AiB5oOI;E8CtDA;IAAwB,sBAAA;E/DssO1B;E+DrsOE;IAAwB,uBAAA;E/DwsO1B;E+DvsOE;IAAwB,sBAAA;E/D0sO1B;AACF;AiBvpOI;E8CtDA;IAAwB,sBAAA;E/DitO1B;E+DhtOE;IAAwB,uBAAA;E/DmtO1B;E+DltOE;IAAwB,sBAAA;E/DqtO1B;AACF;AiBlqOI;E8CtDA;IAAwB,sBAAA;E/D4tO1B;E+D3tOE;IAAwB,uBAAA;E/D8tO1B;E+D7tOE;IAAwB,sBAAA;E/DguO1B;AACF;AgEtuOE;EAAyB,mCAAA;UAAA,2BAAA;AhEyuO3B;;AgEzuOE;EAAyB,oCAAA;UAAA,4BAAA;AhE6uO3B;;AgE7uOE;EAAyB,oCAAA;UAAA,4BAAA;AhEivO3B;;AiEjvOE;EAAsB,yBAAA;AjEqvOxB;;AiErvOE;EAAsB,2BAAA;AjEyvOxB;;AkExvOE;EAAyB,2BAAA;AlE4vO3B;;AkE5vOE;EAAyB,6BAAA;AlEgwO3B;;AkEhwOE;EAAyB,6BAAA;AlEowO3B;;AkEpwOE;EAAyB,0BAAA;AlEwwO3B;;AkExwOE;EAAyB,2BAAA;AlE4wO3B;;AkEvwOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a5DiqBkC;ANymNpC;;AkEvwOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5DypBkC;ANinNpC;;AkEtwOE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a5DipBgC;ENynNlC;AACF;;AmEpyOA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ApEsyOF;;AoE5xOE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;ApE8xOJ;;AqE3zOA;EAAa,iEAAA;ArE+zOb;;AqE9zOA;EAAU,wDAAA;ArEk0OV;;AqEj0OA;EAAa,0DAAA;ArEq0Ob;;AqEp0OA;EAAe,2BAAA;ArEw0Of;;AsEv0OI;EAAuB,qBAAA;AtE20O3B;;AsE30OI;EAAuB,qBAAA;AtE+0O3B;;AsE/0OI;EAAuB,qBAAA;AtEm1O3B;;AsEn1OI;EAAuB,sBAAA;AtEu1O3B;;AsEv1OI;EAAuB,sBAAA;AtE21O3B;;AsE31OI;EAAuB,sBAAA;AtE+1O3B;;AsE/1OI;EAAuB,sBAAA;AtEm2O3B;;AsEn2OI;EAAuB,sBAAA;AtEu2O3B;;AsEv2OI;EAAuB,uBAAA;AtE22O3B;;AsE32OI;EAAuB,uBAAA;AtE+2O3B;;AsE32OA;EAAU,0BAAA;AtE+2OV;;AsE92OA;EAAU,2BAAA;AtEk3OV;;AsE92OA;EAAc,2BAAA;AtEk3Od;;AsEj3OA;EAAc,4BAAA;AtEq3Od;;AsEn3OA;EAAU,uBAAA;AtEu3OV;;AsEt3OA;EAAU,wBAAA;AtE03OV;;AuEn4OQ;EAAgC,oBAAA;AvEu4OxC;;AuEt4OQ;;EAEE,wBAAA;AvEy4OV;;AuEv4OQ;;EAEE,0BAAA;AvE04OV;;AuEx4OQ;;EAEE,2BAAA;AvE24OV;;AuEz4OQ;;EAEE,yBAAA;AvE44OV;;AuE35OQ;EAAgC,0BAAA;AvE+5OxC;;AuE95OQ;;EAEE,8BAAA;AvEi6OV;;AuE/5OQ;;EAEE,gCAAA;AvEk6OV;;AuEh6OQ;;EAEE,iCAAA;AvEm6OV;;AuEj6OQ;;EAEE,+BAAA;AvEo6OV;;AuEn7OQ;EAAgC,yBAAA;AvEu7OxC;;AuEt7OQ;;EAEE,6BAAA;AvEy7OV;;AuEv7OQ;;EAEE,+BAAA;AvE07OV;;AuEx7OQ;;EAEE,gCAAA;AvE27OV;;AuEz7OQ;;EAEE,8BAAA;AvE47OV;;AuE38OQ;EAAgC,uBAAA;AvE+8OxC;;AuE98OQ;;EAEE,2BAAA;AvEi9OV;;AuE/8OQ;;EAEE,6BAAA;AvEk9OV;;AuEh9OQ;;EAEE,8BAAA;AvEm9OV;;AuEj9OQ;;EAEE,4BAAA;AvEo9OV;;AuEn+OQ;EAAgC,yBAAA;AvEu+OxC;;AuEt+OQ;;EAEE,6BAAA;AvEy+OV;;AuEv+OQ;;EAEE,+BAAA;AvE0+OV;;AuEx+OQ;;EAEE,gCAAA;AvE2+OV;;AuEz+OQ;;EAEE,8BAAA;AvE4+OV;;AuE3/OQ;EAAgC,uBAAA;AvE+/OxC;;AuE9/OQ;;EAEE,2BAAA;AvEigPV;;AuE//OQ;;EAEE,6BAAA;AvEkgPV;;AuEhgPQ;;EAEE,8BAAA;AvEmgPV;;AuEjgPQ;;EAEE,4BAAA;AvEogPV;;AuEnhPQ;EAAgC,uBAAA;AvEuhPxC;;AuEthPQ;;EAEE,2BAAA;AvEyhPV;;AuEvhPQ;;EAEE,6BAAA;AvE0hPV;;AuExhPQ;;EAEE,8BAAA;AvE2hPV;;AuEzhPQ;;EAEE,4BAAA;AvE4hPV;;AuE3iPQ;EAAgC,uBAAA;AvE+iPxC;;AuE9iPQ;;EAEE,2BAAA;AvEijPV;;AuE/iPQ;;EAEE,6BAAA;AvEkjPV;;AuEhjPQ;;EAEE,8BAAA;AvEmjPV;;AuEjjPQ;;EAEE,4BAAA;AvEojPV;;AuEnkPQ;EAAgC,uBAAA;AvEukPxC;;AuEtkPQ;;EAEE,2BAAA;AvEykPV;;AuEvkPQ;;EAEE,6BAAA;AvE0kPV;;AuExkPQ;;EAEE,8BAAA;AvE2kPV;;AuEzkPQ;;EAEE,4BAAA;AvE4kPV;;AuE3lPQ;EAAgC,uBAAA;AvE+lPxC;;AuE9lPQ;;EAEE,2BAAA;AvEimPV;;AuE/lPQ;;EAEE,6BAAA;AvEkmPV;;AuEhmPQ;;EAEE,8BAAA;AvEmmPV;;AuEjmPQ;;EAEE,4BAAA;AvEomPV;;AuEnnPQ;EAAgC,qBAAA;AvEunPxC;;AuEtnPQ;;EAEE,yBAAA;AvEynPV;;AuEvnPQ;;EAEE,2BAAA;AvE0nPV;;AuExnPQ;;EAEE,4BAAA;AvE2nPV;;AuEznPQ;;EAEE,0BAAA;AvE4nPV;;AuE3oPQ;EAAgC,2BAAA;AvE+oPxC;;AuE9oPQ;;EAEE,+BAAA;AvEipPV;;AuE/oPQ;;EAEE,iCAAA;AvEkpPV;;AuEhpPQ;;EAEE,kCAAA;AvEmpPV;;AuEjpPQ;;EAEE,gCAAA;AvEopPV;;AuEnqPQ;EAAgC,0BAAA;AvEuqPxC;;AuEtqPQ;;EAEE,8BAAA;AvEyqPV;;AuEvqPQ;;EAEE,gCAAA;AvE0qPV;;AuExqPQ;;EAEE,iCAAA;AvE2qPV;;AuEzqPQ;;EAEE,+BAAA;AvE4qPV;;AuE3rPQ;EAAgC,wBAAA;AvE+rPxC;;AuE9rPQ;;EAEE,4BAAA;AvEisPV;;AuE/rPQ;;EAEE,8BAAA;AvEksPV;;AuEhsPQ;;EAEE,+BAAA;AvEmsPV;;AuEjsPQ;;EAEE,6BAAA;AvEosPV;;AuEntPQ;EAAgC,0BAAA;AvEutPxC;;AuEttPQ;;EAEE,8BAAA;AvEytPV;;AuEvtPQ;;EAEE,gCAAA;AvE0tPV;;AuExtPQ;;EAEE,iCAAA;AvE2tPV;;AuEztPQ;;EAEE,+BAAA;AvE4tPV;;AuE3uPQ;EAAgC,wBAAA;AvE+uPxC;;AuE9uPQ;;EAEE,4BAAA;AvEivPV;;AuE/uPQ;;EAEE,8BAAA;AvEkvPV;;AuEhvPQ;;EAEE,+BAAA;AvEmvPV;;AuEjvPQ;;EAEE,6BAAA;AvEovPV;;AuEnwPQ;EAAgC,wBAAA;AvEuwPxC;;AuEtwPQ;;EAEE,4BAAA;AvEywPV;;AuEvwPQ;;EAEE,8BAAA;AvE0wPV;;AuExwPQ;;EAEE,+BAAA;AvE2wPV;;AuEzwPQ;;EAEE,6BAAA;AvE4wPV;;AuE3xPQ;EAAgC,wBAAA;AvE+xPxC;;AuE9xPQ;;EAEE,4BAAA;AvEiyPV;;AuE/xPQ;;EAEE,8BAAA;AvEkyPV;;AuEhyPQ;;EAEE,+BAAA;AvEmyPV;;AuEjyPQ;;EAEE,6BAAA;AvEoyPV;;AuEnzPQ;EAAgC,wBAAA;AvEuzPxC;;AuEtzPQ;;EAEE,4BAAA;AvEyzPV;;AuEvzPQ;;EAEE,8BAAA;AvE0zPV;;AuExzPQ;;EAEE,+BAAA;AvE2zPV;;AuEzzPQ;;EAEE,6BAAA;AvE4zPV;;AuE30PQ;EAAgC,wBAAA;AvE+0PxC;;AuE90PQ;;EAEE,4BAAA;AvEi1PV;;AuE/0PQ;;EAEE,8BAAA;AvEk1PV;;AuEh1PQ;;EAEE,+BAAA;AvEm1PV;;AuEj1PQ;;EAEE,6BAAA;AvEo1PV;;AuE50PQ;EAAwB,2BAAA;AvEg1PhC;;AuE/0PQ;;EAEE,+BAAA;AvEk1PV;;AuEh1PQ;;EAEE,iCAAA;AvEm1PV;;AuEj1PQ;;EAEE,kCAAA;AvEo1PV;;AuEl1PQ;;EAEE,gCAAA;AvEq1PV;;AuEp2PQ;EAAwB,0BAAA;AvEw2PhC;;AuEv2PQ;;EAEE,8BAAA;AvE02PV;;AuEx2PQ;;EAEE,gCAAA;AvE22PV;;AuEz2PQ;;EAEE,iCAAA;AvE42PV;;AuE12PQ;;EAEE,+BAAA;AvE62PV;;AuE53PQ;EAAwB,wBAAA;AvEg4PhC;;AuE/3PQ;;EAEE,4BAAA;AvEk4PV;;AuEh4PQ;;EAEE,8BAAA;AvEm4PV;;AuEj4PQ;;EAEE,+BAAA;AvEo4PV;;AuEl4PQ;;EAEE,6BAAA;AvEq4PV;;AuEp5PQ;EAAwB,0BAAA;AvEw5PhC;;AuEv5PQ;;EAEE,8BAAA;AvE05PV;;AuEx5PQ;;EAEE,gCAAA;AvE25PV;;AuEz5PQ;;EAEE,iCAAA;AvE45PV;;AuE15PQ;;EAEE,+BAAA;AvE65PV;;AuE56PQ;EAAwB,wBAAA;AvEg7PhC;;AuE/6PQ;;EAEE,4BAAA;AvEk7PV;;AuEh7PQ;;EAEE,8BAAA;AvEm7PV;;AuEj7PQ;;EAEE,+BAAA;AvEo7PV;;AuEl7PQ;;EAEE,6BAAA;AvEq7PV;;AuEp8PQ;EAAwB,wBAAA;AvEw8PhC;;AuEv8PQ;;EAEE,4BAAA;AvE08PV;;AuEx8PQ;;EAEE,8BAAA;AvE28PV;;AuEz8PQ;;EAEE,+BAAA;AvE48PV;;AuE18PQ;;EAEE,6BAAA;AvE68PV;;AuE59PQ;EAAwB,wBAAA;AvEg+PhC;;AuE/9PQ;;EAEE,4BAAA;AvEk+PV;;AuEh+PQ;;EAEE,8BAAA;AvEm+PV;;AuEj+PQ;;EAEE,+BAAA;AvEo+PV;;AuEl+PQ;;EAEE,6BAAA;AvEq+PV;;AuEp/PQ;EAAwB,wBAAA;AvEw/PhC;;AuEv/PQ;;EAEE,4BAAA;AvE0/PV;;AuEx/PQ;;EAEE,8BAAA;AvE2/PV;;AuEz/PQ;;EAEE,+BAAA;AvE4/PV;;AuE1/PQ;;EAEE,6BAAA;AvE6/PV;;AuE5gQQ;EAAwB,wBAAA;AvEghQhC;;AuE/gQQ;;EAEE,4BAAA;AvEkhQV;;AuEhhQQ;;EAEE,8BAAA;AvEmhQV;;AuEjhQQ;;EAEE,+BAAA;AvEohQV;;AuElhQQ;;EAEE,6BAAA;AvEqhQV;;AuE/gQI;EAAmB,uBAAA;AvEmhQvB;;AuElhQI;;EAEE,2BAAA;AvEqhQN;;AuEnhQI;;EAEE,6BAAA;AvEshQN;;AuEphQI;;EAEE,8BAAA;AvEuhQN;;AuErhQI;;EAEE,4BAAA;AvEwhQN;;AiBjiQI;EsDlDI;IAAgC,oBAAA;EvEwlQtC;EuEvlQM;;IAEE,wBAAA;EvEylQR;EuEvlQM;;IAEE,0BAAA;EvEylQR;EuEvlQM;;IAEE,2BAAA;EvEylQR;EuEvlQM;;IAEE,yBAAA;EvEylQR;EuExmQM;IAAgC,0BAAA;EvE2mQtC;EuE1mQM;;IAEE,8BAAA;EvE4mQR;EuE1mQM;;IAEE,gCAAA;EvE4mQR;EuE1mQM;;IAEE,iCAAA;EvE4mQR;EuE1mQM;;IAEE,+BAAA;EvE4mQR;EuE3nQM;IAAgC,yBAAA;EvE8nQtC;EuE7nQM;;IAEE,6BAAA;EvE+nQR;EuE7nQM;;IAEE,+BAAA;EvE+nQR;EuE7nQM;;IAEE,gCAAA;EvE+nQR;EuE7nQM;;IAEE,8BAAA;EvE+nQR;EuE9oQM;IAAgC,uBAAA;EvEipQtC;EuEhpQM;;IAEE,2BAAA;EvEkpQR;EuEhpQM;;IAEE,6BAAA;EvEkpQR;EuEhpQM;;IAEE,8BAAA;EvEkpQR;EuEhpQM;;IAEE,4BAAA;EvEkpQR;EuEjqQM;IAAgC,yBAAA;EvEoqQtC;EuEnqQM;;IAEE,6BAAA;EvEqqQR;EuEnqQM;;IAEE,+BAAA;EvEqqQR;EuEnqQM;;IAEE,gCAAA;EvEqqQR;EuEnqQM;;IAEE,8BAAA;EvEqqQR;EuEprQM;IAAgC,uBAAA;EvEurQtC;EuEtrQM;;IAEE,2BAAA;EvEwrQR;EuEtrQM;;IAEE,6BAAA;EvEwrQR;EuEtrQM;;IAEE,8BAAA;EvEwrQR;EuEtrQM;;IAEE,4BAAA;EvEwrQR;EuEvsQM;IAAgC,uBAAA;EvE0sQtC;EuEzsQM;;IAEE,2BAAA;EvE2sQR;EuEzsQM;;IAEE,6BAAA;EvE2sQR;EuEzsQM;;IAEE,8BAAA;EvE2sQR;EuEzsQM;;IAEE,4BAAA;EvE2sQR;EuE1tQM;IAAgC,uBAAA;EvE6tQtC;EuE5tQM;;IAEE,2BAAA;EvE8tQR;EuE5tQM;;IAEE,6BAAA;EvE8tQR;EuE5tQM;;IAEE,8BAAA;EvE8tQR;EuE5tQM;;IAEE,4BAAA;EvE8tQR;EuE7uQM;IAAgC,uBAAA;EvEgvQtC;EuE/uQM;;IAEE,2BAAA;EvEivQR;EuE/uQM;;IAEE,6BAAA;EvEivQR;EuE/uQM;;IAEE,8BAAA;EvEivQR;EuE/uQM;;IAEE,4BAAA;EvEivQR;EuEhwQM;IAAgC,uBAAA;EvEmwQtC;EuElwQM;;IAEE,2BAAA;EvEowQR;EuElwQM;;IAEE,6BAAA;EvEowQR;EuElwQM;;IAEE,8BAAA;EvEowQR;EuElwQM;;IAEE,4BAAA;EvEowQR;EuEnxQM;IAAgC,qBAAA;EvEsxQtC;EuErxQM;;IAEE,yBAAA;EvEuxQR;EuErxQM;;IAEE,2BAAA;EvEuxQR;EuErxQM;;IAEE,4BAAA;EvEuxQR;EuErxQM;;IAEE,0BAAA;EvEuxQR;EuEtyQM;IAAgC,2BAAA;EvEyyQtC;EuExyQM;;IAEE,+BAAA;EvE0yQR;EuExyQM;;IAEE,iCAAA;EvE0yQR;EuExyQM;;IAEE,kCAAA;EvE0yQR;EuExyQM;;IAEE,gCAAA;EvE0yQR;EuEzzQM;IAAgC,0BAAA;EvE4zQtC;EuE3zQM;;IAEE,8BAAA;EvE6zQR;EuE3zQM;;IAEE,gCAAA;EvE6zQR;EuE3zQM;;IAEE,iCAAA;EvE6zQR;EuE3zQM;;IAEE,+BAAA;EvE6zQR;EuE50QM;IAAgC,wBAAA;EvE+0QtC;EuE90QM;;IAEE,4BAAA;EvEg1QR;EuE90QM;;IAEE,8BAAA;EvEg1QR;EuE90QM;;IAEE,+BAAA;EvEg1QR;EuE90QM;;IAEE,6BAAA;EvEg1QR;EuE/1QM;IAAgC,0BAAA;EvEk2QtC;EuEj2QM;;IAEE,8BAAA;EvEm2QR;EuEj2QM;;IAEE,gCAAA;EvEm2QR;EuEj2QM;;IAEE,iCAAA;EvEm2QR;EuEj2QM;;IAEE,+BAAA;EvEm2QR;EuEl3QM;IAAgC,wBAAA;EvEq3QtC;EuEp3QM;;IAEE,4BAAA;EvEs3QR;EuEp3QM;;IAEE,8BAAA;EvEs3QR;EuEp3QM;;IAEE,+BAAA;EvEs3QR;EuEp3QM;;IAEE,6BAAA;EvEs3QR;EuEr4QM;IAAgC,wBAAA;EvEw4QtC;EuEv4QM;;IAEE,4BAAA;EvEy4QR;EuEv4QM;;IAEE,8BAAA;EvEy4QR;EuEv4QM;;IAEE,+BAAA;EvEy4QR;EuEv4QM;;IAEE,6BAAA;EvEy4QR;EuEx5QM;IAAgC,wBAAA;EvE25QtC;EuE15QM;;IAEE,4BAAA;EvE45QR;EuE15QM;;IAEE,8BAAA;EvE45QR;EuE15QM;;IAEE,+BAAA;EvE45QR;EuE15QM;;IAEE,6BAAA;EvE45QR;EuE36QM;IAAgC,wBAAA;EvE86QtC;EuE76QM;;IAEE,4BAAA;EvE+6QR;EuE76QM;;IAEE,8BAAA;EvE+6QR;EuE76QM;;IAEE,+BAAA;EvE+6QR;EuE76QM;;IAEE,6BAAA;EvE+6QR;EuE97QM;IAAgC,wBAAA;EvEi8QtC;EuEh8QM;;IAEE,4BAAA;EvEk8QR;EuEh8QM;;IAEE,8BAAA;EvEk8QR;EuEh8QM;;IAEE,+BAAA;EvEk8QR;EuEh8QM;;IAEE,6BAAA;EvEk8QR;EuE17QM;IAAwB,2BAAA;EvE67Q9B;EuE57QM;;IAEE,+BAAA;EvE87QR;EuE57QM;;IAEE,iCAAA;EvE87QR;EuE57QM;;IAEE,kCAAA;EvE87QR;EuE57QM;;IAEE,gCAAA;EvE87QR;EuE78QM;IAAwB,0BAAA;EvEg9Q9B;EuE/8QM;;IAEE,8BAAA;EvEi9QR;EuE/8QM;;IAEE,gCAAA;EvEi9QR;EuE/8QM;;IAEE,iCAAA;EvEi9QR;EuE/8QM;;IAEE,+BAAA;EvEi9QR;EuEh+QM;IAAwB,wBAAA;EvEm+Q9B;EuEl+QM;;IAEE,4BAAA;EvEo+QR;EuEl+QM;;IAEE,8BAAA;EvEo+QR;EuEl+QM;;IAEE,+BAAA;EvEo+QR;EuEl+QM;;IAEE,6BAAA;EvEo+QR;EuEn/QM;IAAwB,0BAAA;EvEs/Q9B;EuEr/QM;;IAEE,8BAAA;EvEu/QR;EuEr/QM;;IAEE,gCAAA;EvEu/QR;EuEr/QM;;IAEE,iCAAA;EvEu/QR;EuEr/QM;;IAEE,+BAAA;EvEu/QR;EuEtgRM;IAAwB,wBAAA;EvEygR9B;EuExgRM;;IAEE,4BAAA;EvE0gRR;EuExgRM;;IAEE,8BAAA;EvE0gRR;EuExgRM;;IAEE,+BAAA;EvE0gRR;EuExgRM;;IAEE,6BAAA;EvE0gRR;EuEzhRM;IAAwB,wBAAA;EvE4hR9B;EuE3hRM;;IAEE,4BAAA;EvE6hRR;EuE3hRM;;IAEE,8BAAA;EvE6hRR;EuE3hRM;;IAEE,+BAAA;EvE6hRR;EuE3hRM;;IAEE,6BAAA;EvE6hRR;EuE5iRM;IAAwB,wBAAA;EvE+iR9B;EuE9iRM;;IAEE,4BAAA;EvEgjRR;EuE9iRM;;IAEE,8BAAA;EvEgjRR;EuE9iRM;;IAEE,+BAAA;EvEgjRR;EuE9iRM;;IAEE,6BAAA;EvEgjRR;EuE/jRM;IAAwB,wBAAA;EvEkkR9B;EuEjkRM;;IAEE,4BAAA;EvEmkRR;EuEjkRM;;IAEE,8BAAA;EvEmkRR;EuEjkRM;;IAEE,+BAAA;EvEmkRR;EuEjkRM;;IAEE,6BAAA;EvEmkRR;EuEllRM;IAAwB,wBAAA;EvEqlR9B;EuEplRM;;IAEE,4BAAA;EvEslRR;EuEplRM;;IAEE,8BAAA;EvEslRR;EuEplRM;;IAEE,+BAAA;EvEslRR;EuEplRM;;IAEE,6BAAA;EvEslRR;EuEhlRE;IAAmB,uBAAA;EvEmlRrB;EuEllRE;;IAEE,2BAAA;EvEolRJ;EuEllRE;;IAEE,6BAAA;EvEolRJ;EuEllRE;;IAEE,8BAAA;EvEolRJ;EuEllRE;;IAEE,4BAAA;EvEolRJ;AACF;AiB9lRI;EsDlDI;IAAgC,oBAAA;EvEopRtC;EuEnpRM;;IAEE,wBAAA;EvEqpRR;EuEnpRM;;IAEE,0BAAA;EvEqpRR;EuEnpRM;;IAEE,2BAAA;EvEqpRR;EuEnpRM;;IAEE,yBAAA;EvEqpRR;EuEpqRM;IAAgC,0BAAA;EvEuqRtC;EuEtqRM;;IAEE,8BAAA;EvEwqRR;EuEtqRM;;IAEE,gCAAA;EvEwqRR;EuEtqRM;;IAEE,iCAAA;EvEwqRR;EuEtqRM;;IAEE,+BAAA;EvEwqRR;EuEvrRM;IAAgC,yBAAA;EvE0rRtC;EuEzrRM;;IAEE,6BAAA;EvE2rRR;EuEzrRM;;IAEE,+BAAA;EvE2rRR;EuEzrRM;;IAEE,gCAAA;EvE2rRR;EuEzrRM;;IAEE,8BAAA;EvE2rRR;EuE1sRM;IAAgC,uBAAA;EvE6sRtC;EuE5sRM;;IAEE,2BAAA;EvE8sRR;EuE5sRM;;IAEE,6BAAA;EvE8sRR;EuE5sRM;;IAEE,8BAAA;EvE8sRR;EuE5sRM;;IAEE,4BAAA;EvE8sRR;EuE7tRM;IAAgC,yBAAA;EvEguRtC;EuE/tRM;;IAEE,6BAAA;EvEiuRR;EuE/tRM;;IAEE,+BAAA;EvEiuRR;EuE/tRM;;IAEE,gCAAA;EvEiuRR;EuE/tRM;;IAEE,8BAAA;EvEiuRR;EuEhvRM;IAAgC,uBAAA;EvEmvRtC;EuElvRM;;IAEE,2BAAA;EvEovRR;EuElvRM;;IAEE,6BAAA;EvEovRR;EuElvRM;;IAEE,8BAAA;EvEovRR;EuElvRM;;IAEE,4BAAA;EvEovRR;EuEnwRM;IAAgC,uBAAA;EvEswRtC;EuErwRM;;IAEE,2BAAA;EvEuwRR;EuErwRM;;IAEE,6BAAA;EvEuwRR;EuErwRM;;IAEE,8BAAA;EvEuwRR;EuErwRM;;IAEE,4BAAA;EvEuwRR;EuEtxRM;IAAgC,uBAAA;EvEyxRtC;EuExxRM;;IAEE,2BAAA;EvE0xRR;EuExxRM;;IAEE,6BAAA;EvE0xRR;EuExxRM;;IAEE,8BAAA;EvE0xRR;EuExxRM;;IAEE,4BAAA;EvE0xRR;EuEzyRM;IAAgC,uBAAA;EvE4yRtC;EuE3yRM;;IAEE,2BAAA;EvE6yRR;EuE3yRM;;IAEE,6BAAA;EvE6yRR;EuE3yRM;;IAEE,8BAAA;EvE6yRR;EuE3yRM;;IAEE,4BAAA;EvE6yRR;EuE5zRM;IAAgC,uBAAA;EvE+zRtC;EuE9zRM;;IAEE,2BAAA;EvEg0RR;EuE9zRM;;IAEE,6BAAA;EvEg0RR;EuE9zRM;;IAEE,8BAAA;EvEg0RR;EuE9zRM;;IAEE,4BAAA;EvEg0RR;EuE/0RM;IAAgC,qBAAA;EvEk1RtC;EuEj1RM;;IAEE,yBAAA;EvEm1RR;EuEj1RM;;IAEE,2BAAA;EvEm1RR;EuEj1RM;;IAEE,4BAAA;EvEm1RR;EuEj1RM;;IAEE,0BAAA;EvEm1RR;EuEl2RM;IAAgC,2BAAA;EvEq2RtC;EuEp2RM;;IAEE,+BAAA;EvEs2RR;EuEp2RM;;IAEE,iCAAA;EvEs2RR;EuEp2RM;;IAEE,kCAAA;EvEs2RR;EuEp2RM;;IAEE,gCAAA;EvEs2RR;EuEr3RM;IAAgC,0BAAA;EvEw3RtC;EuEv3RM;;IAEE,8BAAA;EvEy3RR;EuEv3RM;;IAEE,gCAAA;EvEy3RR;EuEv3RM;;IAEE,iCAAA;EvEy3RR;EuEv3RM;;IAEE,+BAAA;EvEy3RR;EuEx4RM;IAAgC,wBAAA;EvE24RtC;EuE14RM;;IAEE,4BAAA;EvE44RR;EuE14RM;;IAEE,8BAAA;EvE44RR;EuE14RM;;IAEE,+BAAA;EvE44RR;EuE14RM;;IAEE,6BAAA;EvE44RR;EuE35RM;IAAgC,0BAAA;EvE85RtC;EuE75RM;;IAEE,8BAAA;EvE+5RR;EuE75RM;;IAEE,gCAAA;EvE+5RR;EuE75RM;;IAEE,iCAAA;EvE+5RR;EuE75RM;;IAEE,+BAAA;EvE+5RR;EuE96RM;IAAgC,wBAAA;EvEi7RtC;EuEh7RM;;IAEE,4BAAA;EvEk7RR;EuEh7RM;;IAEE,8BAAA;EvEk7RR;EuEh7RM;;IAEE,+BAAA;EvEk7RR;EuEh7RM;;IAEE,6BAAA;EvEk7RR;EuEj8RM;IAAgC,wBAAA;EvEo8RtC;EuEn8RM;;IAEE,4BAAA;EvEq8RR;EuEn8RM;;IAEE,8BAAA;EvEq8RR;EuEn8RM;;IAEE,+BAAA;EvEq8RR;EuEn8RM;;IAEE,6BAAA;EvEq8RR;EuEp9RM;IAAgC,wBAAA;EvEu9RtC;EuEt9RM;;IAEE,4BAAA;EvEw9RR;EuEt9RM;;IAEE,8BAAA;EvEw9RR;EuEt9RM;;IAEE,+BAAA;EvEw9RR;EuEt9RM;;IAEE,6BAAA;EvEw9RR;EuEv+RM;IAAgC,wBAAA;EvE0+RtC;EuEz+RM;;IAEE,4BAAA;EvE2+RR;EuEz+RM;;IAEE,8BAAA;EvE2+RR;EuEz+RM;;IAEE,+BAAA;EvE2+RR;EuEz+RM;;IAEE,6BAAA;EvE2+RR;EuE1/RM;IAAgC,wBAAA;EvE6/RtC;EuE5/RM;;IAEE,4BAAA;EvE8/RR;EuE5/RM;;IAEE,8BAAA;EvE8/RR;EuE5/RM;;IAEE,+BAAA;EvE8/RR;EuE5/RM;;IAEE,6BAAA;EvE8/RR;EuEt/RM;IAAwB,2BAAA;EvEy/R9B;EuEx/RM;;IAEE,+BAAA;EvE0/RR;EuEx/RM;;IAEE,iCAAA;EvE0/RR;EuEx/RM;;IAEE,kCAAA;EvE0/RR;EuEx/RM;;IAEE,gCAAA;EvE0/RR;EuEzgSM;IAAwB,0BAAA;EvE4gS9B;EuE3gSM;;IAEE,8BAAA;EvE6gSR;EuE3gSM;;IAEE,gCAAA;EvE6gSR;EuE3gSM;;IAEE,iCAAA;EvE6gSR;EuE3gSM;;IAEE,+BAAA;EvE6gSR;EuE5hSM;IAAwB,wBAAA;EvE+hS9B;EuE9hSM;;IAEE,4BAAA;EvEgiSR;EuE9hSM;;IAEE,8BAAA;EvEgiSR;EuE9hSM;;IAEE,+BAAA;EvEgiSR;EuE9hSM;;IAEE,6BAAA;EvEgiSR;EuE/iSM;IAAwB,0BAAA;EvEkjS9B;EuEjjSM;;IAEE,8BAAA;EvEmjSR;EuEjjSM;;IAEE,gCAAA;EvEmjSR;EuEjjSM;;IAEE,iCAAA;EvEmjSR;EuEjjSM;;IAEE,+BAAA;EvEmjSR;EuElkSM;IAAwB,wBAAA;EvEqkS9B;EuEpkSM;;IAEE,4BAAA;EvEskSR;EuEpkSM;;IAEE,8BAAA;EvEskSR;EuEpkSM;;IAEE,+BAAA;EvEskSR;EuEpkSM;;IAEE,6BAAA;EvEskSR;EuErlSM;IAAwB,wBAAA;EvEwlS9B;EuEvlSM;;IAEE,4BAAA;EvEylSR;EuEvlSM;;IAEE,8BAAA;EvEylSR;EuEvlSM;;IAEE,+BAAA;EvEylSR;EuEvlSM;;IAEE,6BAAA;EvEylSR;EuExmSM;IAAwB,wBAAA;EvE2mS9B;EuE1mSM;;IAEE,4BAAA;EvE4mSR;EuE1mSM;;IAEE,8BAAA;EvE4mSR;EuE1mSM;;IAEE,+BAAA;EvE4mSR;EuE1mSM;;IAEE,6BAAA;EvE4mSR;EuE3nSM;IAAwB,wBAAA;EvE8nS9B;EuE7nSM;;IAEE,4BAAA;EvE+nSR;EuE7nSM;;IAEE,8BAAA;EvE+nSR;EuE7nSM;;IAEE,+BAAA;EvE+nSR;EuE7nSM;;IAEE,6BAAA;EvE+nSR;EuE9oSM;IAAwB,wBAAA;EvEipS9B;EuEhpSM;;IAEE,4BAAA;EvEkpSR;EuEhpSM;;IAEE,8BAAA;EvEkpSR;EuEhpSM;;IAEE,+BAAA;EvEkpSR;EuEhpSM;;IAEE,6BAAA;EvEkpSR;EuE5oSE;IAAmB,uBAAA;EvE+oSrB;EuE9oSE;;IAEE,2BAAA;EvEgpSJ;EuE9oSE;;IAEE,6BAAA;EvEgpSJ;EuE9oSE;;IAEE,8BAAA;EvEgpSJ;EuE9oSE;;IAEE,4BAAA;EvEgpSJ;AACF;AiB1pSI;EsDlDI;IAAgC,oBAAA;EvEgtStC;EuE/sSM;;IAEE,wBAAA;EvEitSR;EuE/sSM;;IAEE,0BAAA;EvEitSR;EuE/sSM;;IAEE,2BAAA;EvEitSR;EuE/sSM;;IAEE,yBAAA;EvEitSR;EuEhuSM;IAAgC,0BAAA;EvEmuStC;EuEluSM;;IAEE,8BAAA;EvEouSR;EuEluSM;;IAEE,gCAAA;EvEouSR;EuEluSM;;IAEE,iCAAA;EvEouSR;EuEluSM;;IAEE,+BAAA;EvEouSR;EuEnvSM;IAAgC,yBAAA;EvEsvStC;EuErvSM;;IAEE,6BAAA;EvEuvSR;EuErvSM;;IAEE,+BAAA;EvEuvSR;EuErvSM;;IAEE,gCAAA;EvEuvSR;EuErvSM;;IAEE,8BAAA;EvEuvSR;EuEtwSM;IAAgC,uBAAA;EvEywStC;EuExwSM;;IAEE,2BAAA;EvE0wSR;EuExwSM;;IAEE,6BAAA;EvE0wSR;EuExwSM;;IAEE,8BAAA;EvE0wSR;EuExwSM;;IAEE,4BAAA;EvE0wSR;EuEzxSM;IAAgC,yBAAA;EvE4xStC;EuE3xSM;;IAEE,6BAAA;EvE6xSR;EuE3xSM;;IAEE,+BAAA;EvE6xSR;EuE3xSM;;IAEE,gCAAA;EvE6xSR;EuE3xSM;;IAEE,8BAAA;EvE6xSR;EuE5ySM;IAAgC,uBAAA;EvE+yStC;EuE9ySM;;IAEE,2BAAA;EvEgzSR;EuE9ySM;;IAEE,6BAAA;EvEgzSR;EuE9ySM;;IAEE,8BAAA;EvEgzSR;EuE9ySM;;IAEE,4BAAA;EvEgzSR;EuE/zSM;IAAgC,uBAAA;EvEk0StC;EuEj0SM;;IAEE,2BAAA;EvEm0SR;EuEj0SM;;IAEE,6BAAA;EvEm0SR;EuEj0SM;;IAEE,8BAAA;EvEm0SR;EuEj0SM;;IAEE,4BAAA;EvEm0SR;EuEl1SM;IAAgC,uBAAA;EvEq1StC;EuEp1SM;;IAEE,2BAAA;EvEs1SR;EuEp1SM;;IAEE,6BAAA;EvEs1SR;EuEp1SM;;IAEE,8BAAA;EvEs1SR;EuEp1SM;;IAEE,4BAAA;EvEs1SR;EuEr2SM;IAAgC,uBAAA;EvEw2StC;EuEv2SM;;IAEE,2BAAA;EvEy2SR;EuEv2SM;;IAEE,6BAAA;EvEy2SR;EuEv2SM;;IAEE,8BAAA;EvEy2SR;EuEv2SM;;IAEE,4BAAA;EvEy2SR;EuEx3SM;IAAgC,uBAAA;EvE23StC;EuE13SM;;IAEE,2BAAA;EvE43SR;EuE13SM;;IAEE,6BAAA;EvE43SR;EuE13SM;;IAEE,8BAAA;EvE43SR;EuE13SM;;IAEE,4BAAA;EvE43SR;EuE34SM;IAAgC,qBAAA;EvE84StC;EuE74SM;;IAEE,yBAAA;EvE+4SR;EuE74SM;;IAEE,2BAAA;EvE+4SR;EuE74SM;;IAEE,4BAAA;EvE+4SR;EuE74SM;;IAEE,0BAAA;EvE+4SR;EuE95SM;IAAgC,2BAAA;EvEi6StC;EuEh6SM;;IAEE,+BAAA;EvEk6SR;EuEh6SM;;IAEE,iCAAA;EvEk6SR;EuEh6SM;;IAEE,kCAAA;EvEk6SR;EuEh6SM;;IAEE,gCAAA;EvEk6SR;EuEj7SM;IAAgC,0BAAA;EvEo7StC;EuEn7SM;;IAEE,8BAAA;EvEq7SR;EuEn7SM;;IAEE,gCAAA;EvEq7SR;EuEn7SM;;IAEE,iCAAA;EvEq7SR;EuEn7SM;;IAEE,+BAAA;EvEq7SR;EuEp8SM;IAAgC,wBAAA;EvEu8StC;EuEt8SM;;IAEE,4BAAA;EvEw8SR;EuEt8SM;;IAEE,8BAAA;EvEw8SR;EuEt8SM;;IAEE,+BAAA;EvEw8SR;EuEt8SM;;IAEE,6BAAA;EvEw8SR;EuEv9SM;IAAgC,0BAAA;EvE09StC;EuEz9SM;;IAEE,8BAAA;EvE29SR;EuEz9SM;;IAEE,gCAAA;EvE29SR;EuEz9SM;;IAEE,iCAAA;EvE29SR;EuEz9SM;;IAEE,+BAAA;EvE29SR;EuE1+SM;IAAgC,wBAAA;EvE6+StC;EuE5+SM;;IAEE,4BAAA;EvE8+SR;EuE5+SM;;IAEE,8BAAA;EvE8+SR;EuE5+SM;;IAEE,+BAAA;EvE8+SR;EuE5+SM;;IAEE,6BAAA;EvE8+SR;EuE7/SM;IAAgC,wBAAA;EvEggTtC;EuE//SM;;IAEE,4BAAA;EvEigTR;EuE//SM;;IAEE,8BAAA;EvEigTR;EuE//SM;;IAEE,+BAAA;EvEigTR;EuE//SM;;IAEE,6BAAA;EvEigTR;EuEhhTM;IAAgC,wBAAA;EvEmhTtC;EuElhTM;;IAEE,4BAAA;EvEohTR;EuElhTM;;IAEE,8BAAA;EvEohTR;EuElhTM;;IAEE,+BAAA;EvEohTR;EuElhTM;;IAEE,6BAAA;EvEohTR;EuEniTM;IAAgC,wBAAA;EvEsiTtC;EuEriTM;;IAEE,4BAAA;EvEuiTR;EuEriTM;;IAEE,8BAAA;EvEuiTR;EuEriTM;;IAEE,+BAAA;EvEuiTR;EuEriTM;;IAEE,6BAAA;EvEuiTR;EuEtjTM;IAAgC,wBAAA;EvEyjTtC;EuExjTM;;IAEE,4BAAA;EvE0jTR;EuExjTM;;IAEE,8BAAA;EvE0jTR;EuExjTM;;IAEE,+BAAA;EvE0jTR;EuExjTM;;IAEE,6BAAA;EvE0jTR;EuEljTM;IAAwB,2BAAA;EvEqjT9B;EuEpjTM;;IAEE,+BAAA;EvEsjTR;EuEpjTM;;IAEE,iCAAA;EvEsjTR;EuEpjTM;;IAEE,kCAAA;EvEsjTR;EuEpjTM;;IAEE,gCAAA;EvEsjTR;EuErkTM;IAAwB,0BAAA;EvEwkT9B;EuEvkTM;;IAEE,8BAAA;EvEykTR;EuEvkTM;;IAEE,gCAAA;EvEykTR;EuEvkTM;;IAEE,iCAAA;EvEykTR;EuEvkTM;;IAEE,+BAAA;EvEykTR;EuExlTM;IAAwB,wBAAA;EvE2lT9B;EuE1lTM;;IAEE,4BAAA;EvE4lTR;EuE1lTM;;IAEE,8BAAA;EvE4lTR;EuE1lTM;;IAEE,+BAAA;EvE4lTR;EuE1lTM;;IAEE,6BAAA;EvE4lTR;EuE3mTM;IAAwB,0BAAA;EvE8mT9B;EuE7mTM;;IAEE,8BAAA;EvE+mTR;EuE7mTM;;IAEE,gCAAA;EvE+mTR;EuE7mTM;;IAEE,iCAAA;EvE+mTR;EuE7mTM;;IAEE,+BAAA;EvE+mTR;EuE9nTM;IAAwB,wBAAA;EvEioT9B;EuEhoTM;;IAEE,4BAAA;EvEkoTR;EuEhoTM;;IAEE,8BAAA;EvEkoTR;EuEhoTM;;IAEE,+BAAA;EvEkoTR;EuEhoTM;;IAEE,6BAAA;EvEkoTR;EuEjpTM;IAAwB,wBAAA;EvEopT9B;EuEnpTM;;IAEE,4BAAA;EvEqpTR;EuEnpTM;;IAEE,8BAAA;EvEqpTR;EuEnpTM;;IAEE,+BAAA;EvEqpTR;EuEnpTM;;IAEE,6BAAA;EvEqpTR;EuEpqTM;IAAwB,wBAAA;EvEuqT9B;EuEtqTM;;IAEE,4BAAA;EvEwqTR;EuEtqTM;;IAEE,8BAAA;EvEwqTR;EuEtqTM;;IAEE,+BAAA;EvEwqTR;EuEtqTM;;IAEE,6BAAA;EvEwqTR;EuEvrTM;IAAwB,wBAAA;EvE0rT9B;EuEzrTM;;IAEE,4BAAA;EvE2rTR;EuEzrTM;;IAEE,8BAAA;EvE2rTR;EuEzrTM;;IAEE,+BAAA;EvE2rTR;EuEzrTM;;IAEE,6BAAA;EvE2rTR;EuE1sTM;IAAwB,wBAAA;EvE6sT9B;EuE5sTM;;IAEE,4BAAA;EvE8sTR;EuE5sTM;;IAEE,8BAAA;EvE8sTR;EuE5sTM;;IAEE,+BAAA;EvE8sTR;EuE5sTM;;IAEE,6BAAA;EvE8sTR;EuExsTE;IAAmB,uBAAA;EvE2sTrB;EuE1sTE;;IAEE,2BAAA;EvE4sTJ;EuE1sTE;;IAEE,6BAAA;EvE4sTJ;EuE1sTE;;IAEE,8BAAA;EvE4sTJ;EuE1sTE;;IAEE,4BAAA;EvE4sTJ;AACF;AiBttTI;EsDlDI;IAAgC,oBAAA;EvE4wTtC;EuE3wTM;;IAEE,wBAAA;EvE6wTR;EuE3wTM;;IAEE,0BAAA;EvE6wTR;EuE3wTM;;IAEE,2BAAA;EvE6wTR;EuE3wTM;;IAEE,yBAAA;EvE6wTR;EuE5xTM;IAAgC,0BAAA;EvE+xTtC;EuE9xTM;;IAEE,8BAAA;EvEgyTR;EuE9xTM;;IAEE,gCAAA;EvEgyTR;EuE9xTM;;IAEE,iCAAA;EvEgyTR;EuE9xTM;;IAEE,+BAAA;EvEgyTR;EuE/yTM;IAAgC,yBAAA;EvEkzTtC;EuEjzTM;;IAEE,6BAAA;EvEmzTR;EuEjzTM;;IAEE,+BAAA;EvEmzTR;EuEjzTM;;IAEE,gCAAA;EvEmzTR;EuEjzTM;;IAEE,8BAAA;EvEmzTR;EuEl0TM;IAAgC,uBAAA;EvEq0TtC;EuEp0TM;;IAEE,2BAAA;EvEs0TR;EuEp0TM;;IAEE,6BAAA;EvEs0TR;EuEp0TM;;IAEE,8BAAA;EvEs0TR;EuEp0TM;;IAEE,4BAAA;EvEs0TR;EuEr1TM;IAAgC,yBAAA;EvEw1TtC;EuEv1TM;;IAEE,6BAAA;EvEy1TR;EuEv1TM;;IAEE,+BAAA;EvEy1TR;EuEv1TM;;IAEE,gCAAA;EvEy1TR;EuEv1TM;;IAEE,8BAAA;EvEy1TR;EuEx2TM;IAAgC,uBAAA;EvE22TtC;EuE12TM;;IAEE,2BAAA;EvE42TR;EuE12TM;;IAEE,6BAAA;EvE42TR;EuE12TM;;IAEE,8BAAA;EvE42TR;EuE12TM;;IAEE,4BAAA;EvE42TR;EuE33TM;IAAgC,uBAAA;EvE83TtC;EuE73TM;;IAEE,2BAAA;EvE+3TR;EuE73TM;;IAEE,6BAAA;EvE+3TR;EuE73TM;;IAEE,8BAAA;EvE+3TR;EuE73TM;;IAEE,4BAAA;EvE+3TR;EuE94TM;IAAgC,uBAAA;EvEi5TtC;EuEh5TM;;IAEE,2BAAA;EvEk5TR;EuEh5TM;;IAEE,6BAAA;EvEk5TR;EuEh5TM;;IAEE,8BAAA;EvEk5TR;EuEh5TM;;IAEE,4BAAA;EvEk5TR;EuEj6TM;IAAgC,uBAAA;EvEo6TtC;EuEn6TM;;IAEE,2BAAA;EvEq6TR;EuEn6TM;;IAEE,6BAAA;EvEq6TR;EuEn6TM;;IAEE,8BAAA;EvEq6TR;EuEn6TM;;IAEE,4BAAA;EvEq6TR;EuEp7TM;IAAgC,uBAAA;EvEu7TtC;EuEt7TM;;IAEE,2BAAA;EvEw7TR;EuEt7TM;;IAEE,6BAAA;EvEw7TR;EuEt7TM;;IAEE,8BAAA;EvEw7TR;EuEt7TM;;IAEE,4BAAA;EvEw7TR;EuEv8TM;IAAgC,qBAAA;EvE08TtC;EuEz8TM;;IAEE,yBAAA;EvE28TR;EuEz8TM;;IAEE,2BAAA;EvE28TR;EuEz8TM;;IAEE,4BAAA;EvE28TR;EuEz8TM;;IAEE,0BAAA;EvE28TR;EuE19TM;IAAgC,2BAAA;EvE69TtC;EuE59TM;;IAEE,+BAAA;EvE89TR;EuE59TM;;IAEE,iCAAA;EvE89TR;EuE59TM;;IAEE,kCAAA;EvE89TR;EuE59TM;;IAEE,gCAAA;EvE89TR;EuE7+TM;IAAgC,0BAAA;EvEg/TtC;EuE/+TM;;IAEE,8BAAA;EvEi/TR;EuE/+TM;;IAEE,gCAAA;EvEi/TR;EuE/+TM;;IAEE,iCAAA;EvEi/TR;EuE/+TM;;IAEE,+BAAA;EvEi/TR;EuEhgUM;IAAgC,wBAAA;EvEmgUtC;EuElgUM;;IAEE,4BAAA;EvEogUR;EuElgUM;;IAEE,8BAAA;EvEogUR;EuElgUM;;IAEE,+BAAA;EvEogUR;EuElgUM;;IAEE,6BAAA;EvEogUR;EuEnhUM;IAAgC,0BAAA;EvEshUtC;EuErhUM;;IAEE,8BAAA;EvEuhUR;EuErhUM;;IAEE,gCAAA;EvEuhUR;EuErhUM;;IAEE,iCAAA;EvEuhUR;EuErhUM;;IAEE,+BAAA;EvEuhUR;EuEtiUM;IAAgC,wBAAA;EvEyiUtC;EuExiUM;;IAEE,4BAAA;EvE0iUR;EuExiUM;;IAEE,8BAAA;EvE0iUR;EuExiUM;;IAEE,+BAAA;EvE0iUR;EuExiUM;;IAEE,6BAAA;EvE0iUR;EuEzjUM;IAAgC,wBAAA;EvE4jUtC;EuE3jUM;;IAEE,4BAAA;EvE6jUR;EuE3jUM;;IAEE,8BAAA;EvE6jUR;EuE3jUM;;IAEE,+BAAA;EvE6jUR;EuE3jUM;;IAEE,6BAAA;EvE6jUR;EuE5kUM;IAAgC,wBAAA;EvE+kUtC;EuE9kUM;;IAEE,4BAAA;EvEglUR;EuE9kUM;;IAEE,8BAAA;EvEglUR;EuE9kUM;;IAEE,+BAAA;EvEglUR;EuE9kUM;;IAEE,6BAAA;EvEglUR;EuE/lUM;IAAgC,wBAAA;EvEkmUtC;EuEjmUM;;IAEE,4BAAA;EvEmmUR;EuEjmUM;;IAEE,8BAAA;EvEmmUR;EuEjmUM;;IAEE,+BAAA;EvEmmUR;EuEjmUM;;IAEE,6BAAA;EvEmmUR;EuElnUM;IAAgC,wBAAA;EvEqnUtC;EuEpnUM;;IAEE,4BAAA;EvEsnUR;EuEpnUM;;IAEE,8BAAA;EvEsnUR;EuEpnUM;;IAEE,+BAAA;EvEsnUR;EuEpnUM;;IAEE,6BAAA;EvEsnUR;EuE9mUM;IAAwB,2BAAA;EvEinU9B;EuEhnUM;;IAEE,+BAAA;EvEknUR;EuEhnUM;;IAEE,iCAAA;EvEknUR;EuEhnUM;;IAEE,kCAAA;EvEknUR;EuEhnUM;;IAEE,gCAAA;EvEknUR;EuEjoUM;IAAwB,0BAAA;EvEooU9B;EuEnoUM;;IAEE,8BAAA;EvEqoUR;EuEnoUM;;IAEE,gCAAA;EvEqoUR;EuEnoUM;;IAEE,iCAAA;EvEqoUR;EuEnoUM;;IAEE,+BAAA;EvEqoUR;EuEppUM;IAAwB,wBAAA;EvEupU9B;EuEtpUM;;IAEE,4BAAA;EvEwpUR;EuEtpUM;;IAEE,8BAAA;EvEwpUR;EuEtpUM;;IAEE,+BAAA;EvEwpUR;EuEtpUM;;IAEE,6BAAA;EvEwpUR;EuEvqUM;IAAwB,0BAAA;EvE0qU9B;EuEzqUM;;IAEE,8BAAA;EvE2qUR;EuEzqUM;;IAEE,gCAAA;EvE2qUR;EuEzqUM;;IAEE,iCAAA;EvE2qUR;EuEzqUM;;IAEE,+BAAA;EvE2qUR;EuE1rUM;IAAwB,wBAAA;EvE6rU9B;EuE5rUM;;IAEE,4BAAA;EvE8rUR;EuE5rUM;;IAEE,8BAAA;EvE8rUR;EuE5rUM;;IAEE,+BAAA;EvE8rUR;EuE5rUM;;IAEE,6BAAA;EvE8rUR;EuE7sUM;IAAwB,wBAAA;EvEgtU9B;EuE/sUM;;IAEE,4BAAA;EvEitUR;EuE/sUM;;IAEE,8BAAA;EvEitUR;EuE/sUM;;IAEE,+BAAA;EvEitUR;EuE/sUM;;IAEE,6BAAA;EvEitUR;EuEhuUM;IAAwB,wBAAA;EvEmuU9B;EuEluUM;;IAEE,4BAAA;EvEouUR;EuEluUM;;IAEE,8BAAA;EvEouUR;EuEluUM;;IAEE,+BAAA;EvEouUR;EuEluUM;;IAEE,6BAAA;EvEouUR;EuEnvUM;IAAwB,wBAAA;EvEsvU9B;EuErvUM;;IAEE,4BAAA;EvEuvUR;EuErvUM;;IAEE,8BAAA;EvEuvUR;EuErvUM;;IAEE,+BAAA;EvEuvUR;EuErvUM;;IAEE,6BAAA;EvEuvUR;EuEtwUM;IAAwB,wBAAA;EvEywU9B;EuExwUM;;IAEE,4BAAA;EvE0wUR;EuExwUM;;IAEE,8BAAA;EvE0wUR;EuExwUM;;IAEE,+BAAA;EvE0wUR;EuExwUM;;IAEE,6BAAA;EvE0wUR;EuEpwUE;IAAmB,uBAAA;EvEuwUrB;EuEtwUE;;IAEE,2BAAA;EvEwwUJ;EuEtwUE;;IAEE,6BAAA;EvEwwUJ;EuEtwUE;;IAEE,8BAAA;EvEwwUJ;EuEtwUE;;IAEE,4BAAA;EvEwwUJ;AACF;AwEz0UE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AxEy0UJ;;AyEn1UA;EAAkB,4GAAA;AzEu1UlB;;AyEn1UA;EAAiB,8BAAA;AzEu1UjB;;AyEt1UA;EAAiB,8BAAA;AzE01UjB;;AyEz1UA;EAAiB,8BAAA;AzE61UjB;;AyE51UA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A1Ey2UF;;AyE11UI;EAAwB,2BAAA;AzE81U5B;;AyE71UI;EAAwB,4BAAA;AzEi2U5B;;AyEh2UI;EAAwB,6BAAA;AzEo2U5B;;AiB/zUI;EwDvCA;IAAwB,2BAAA;EzE22U1B;EyE12UE;IAAwB,4BAAA;EzE62U1B;EyE52UE;IAAwB,6BAAA;EzE+2U1B;AACF;AiB30UI;EwDvCA;IAAwB,2BAAA;EzEs3U1B;EyEr3UE;IAAwB,4BAAA;EzEw3U1B;EyEv3UE;IAAwB,6BAAA;EzE03U1B;AACF;AiBt1UI;EwDvCA;IAAwB,2BAAA;EzEi4U1B;EyEh4UE;IAAwB,4BAAA;EzEm4U1B;EyEl4UE;IAAwB,6BAAA;EzEq4U1B;AACF;AiBj2UI;EwDvCA;IAAwB,2BAAA;EzE44U1B;EyE34UE;IAAwB,4BAAA;EzE84U1B;EyE74UE;IAAwB,6BAAA;EzEg5U1B;AACF;AyE34UA;EAAmB,oCAAA;AzE84UnB;;AyE74UA;EAAmB,oCAAA;AzEi5UnB;;AyEh5UA;EAAmB,qCAAA;AzEo5UnB;;AyEh5UA;EAAuB,2BAAA;AzEo5UvB;;AyEn5UA;EAAuB,+BAAA;AzEu5UvB;;AyEt5UA;EAAuB,2BAAA;AzE05UvB;;AyEz5UA;EAAuB,2BAAA;AzE65UvB;;AyE55UA;EAAuB,8BAAA;AzEg6UvB;;AyE/5UA;EAAuB,6BAAA;AzEm6UvB;;AyE/5UA;EAAc,yBAAA;AzEm6Ud;;A2E18UE;EACE,yBAAA;A3E68UJ;;AOn8UE;EoELM,yBAAA;A3E48UR;;A2El9UE;EACE,yBAAA;A3Eq9UJ;;AO38UE;EoELM,yBAAA;A3Eo9UR;;A2E19UE;EACE,yBAAA;A3E69UJ;;AOn9UE;EoELM,yBAAA;A3E49UR;;A2El+UE;EACE,yBAAA;A3Eq+UJ;;AO39UE;EoELM,yBAAA;A3Eo+UR;;A2E1+UE;EACE,yBAAA;A3E6+UJ;;AOn+UE;EoELM,yBAAA;A3E4+UR;;A2El/UE;EACE,yBAAA;A3Eq/UJ;;AO3+UE;EoELM,yBAAA;A3Eo/UR;;A2E1/UE;EACE,yBAAA;A3E6/UJ;;AOn/UE;EoELM,yBAAA;A3E4/UR;;A2ElgVE;EACE,yBAAA;A3EqgVJ;;AO3/UE;EoELM,uBAAA;A3EogVR;;A2E1gVE;EACE,yBAAA;A3E6gVJ;;AOngVE;EoELM,yBAAA;A3E4gVR;;A2ElhVE;EACE,yBAAA;A3EqhVJ;;AO3gVE;EoELM,yBAAA;A3EohVR;;A2E1hVE;EACE,yBAAA;A3E6hVJ;;AOnhVE;EoELM,yBAAA;A3E4hVR;;A2EliVE;EACE,uBAAA;A3EqiVJ;;AO3hVE;EoELM,uBAAA;A3EoiVR;;AyE7/UA;EAAa,yBAAA;AzEigVb;;AyEhgVA;EAAc,yBAAA;AzEogVd;;AyElgVA;EAAiB,uCAAA;AzEsgVjB;;AyErgVA;EAAiB,0CAAA;AzEygVjB;;AyErgVA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A5EgkVF;;AyEzgVA;EAAwB,gCAAA;AzE6gVxB;;AyE3gVA;EACE,iCAAA;EACA,gCAAA;AzE8gVF;;AyEzgVA;EAAc,yBAAA;AzE6gVd;;A6E9kVA;EACE,8BAAA;A7EilVF;;A6E9kVA;EACE,6BAAA;A7EilVF;;A8EjlVE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E9EilVJ;E8E7kVI;IACE,0BAAA;E9E+kVN;E8EtkVE;IACE,6BAAA;E9EwkVJ;E8E1jVE;IACE,gCAAA;E9E4jVJ;E8E1jVE;;IAEE,+BAAA;IACA,wBAAA;E9E4jVJ;E8EzjVE;;IAEE,wBAAA;E9E2jVJ;E8ExjVE;;;IAGE,UAAA;IACA,SAAA;E9E0jVJ;E8EvjVE;;IAEE,uBAAA;E9EyjVJ;E8EjjVE;IACE,QxE2iC8B;ENwgTlC;E8EjjVE;IACE,2BAAA;E9EmjVJ;E8EjjVE;IACE,2BAAA;E9EmjVJ;E8E/iVE;IACE,aAAA;E9EijVJ;E8E/iVE;IACE,+BAAA;E9EijVJ;E8E9iVE;IACE,oCAAA;E9EgjVJ;E8E9iVI;;IAEE,oCAAA;E9EgjVN;E8E3iVI;;IAEE,oCAAA;E9E6iVN;E8EziVE;IACE,cAAA;E9E2iVJ;E8EziVI;;;;IAIE,qB7EvGG;EDkpVT;E8EviVE;IACE,cAAA;IACA,qB7E7GK;EDspVT;AACF;A+ExqVA;EACE,kCAAA;EACA,mCAAA;A/E0qVF;;A+EvqVA;EACI,SAAA;A/E0qVJ;;A+EvqVA;;;EAGI,cAAA;A/E0qVJ;;A+EvqVA;EACC,gBAAA;A/E0qVD;;AgFxrVA;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;AhF2rVJ;;AgFxrVA;EAEI,iBAAA;EACA,uBAAA;EACA,cAAA;AhF0rVJ;AgFvrVQ;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mB/ETD;E+EUC,UAAA;EACA,gCAAA;EnETN,6CmEUM;EACA,wDAAA;AhFyrVZ;AgFvrVY;EACI,uBAAA;EACA,wBAAA;EACA,gBAAA;AhFyrVhB;AgFtrVY;EACI,0BAAA;EACA,2BAAA;EACA,gBAAA;AhFwrVhB;AgFrrVY;EACI,eAAA;EACA,cAAA;EACA,UAAA;AhFurVhB;AgFlrVY;EACI,gCAAA;EACA,SAAA;EACA,QAAA;AhForVhB;AgFlrVgB;EACI,UAAA;AhForVpB;AgF7qVY;EACI,UAAA;AhF+qVhB;AgF7qVgB;EACI,SAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AhF+qVpB;AgF5qVgB;EACI,qCAAA;EACA,QAAA;AhF8qVpB;AgF3qVgB;EACI,+BAAA;EACA,8BAAA;AhF6qVpB;AgF1qVgB;EACI,+BAAA;EACA,8BAAA;AhF4qVpB;AgFzqVgB;EACI,mCAAA;EACA,QAAA;AhF2qVpB;AgFxqVgB;EACI,qCAAA;EACA,oCAAA;AhF0qVpB;AgFvqVgB;EACI,qCAAA;EACA,oCAAA;AhFyqVpB;AgFtqVgB;EACI,qCAAA;EACA,QAAA;AhFwqVpB;AgFrqVgB;EACI,+BAAA;EACA,8BAAA;AhFuqVpB;AgFpqVgB;EACI,+BAAA;EACA,8BAAA;AhFsqVpB;AgFnqVgB;EACI,mCAAA;EACA,QAAA;AhFqqVpB;AgFlqVgB;EACI,qCAAA;EACA,oCAAA;AhFoqVpB;AgFjqVgB;EACI,qCAAA;EACA,oCAAA;AhFmqVpB;;AgFxpVA;EACI,kBAAA;AhF2pVJ;AgFzpVI;EACI,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;AhF2pVR;AgFxpVI;EACI,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,0B/E+MsB;E+E9MtB,YAAA;AhF0pVR;AgFvpVQ;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;AhFypVZ;AgFvpVQ;EACI,UAAA;EACA,QAAA;AhFypVZ;;AyD5zVE;EACE,oCAAA;AzD+zVJ;;AOrzVE;;;EkDLI,oCAAA;AzDg0VN;;AyDt0VE;EACE,oCAAA;AzDy0VJ;;AO/zVE;;;EkDLI,oCAAA;AzD00VN;;AyDh1VE;EACE,oCAAA;AzDm1VJ;;AOz0VE;;;EkDLI,oCAAA;AzDo1VN;;AyD11VE;EACE,oCAAA;AzD61VJ;;AOn1VE;;;EkDLI,oCAAA;AzD81VN;;AyDp2VE;EACE,oCAAA;AzDu2VJ;;AO71VE;;;EkDLI,oCAAA;AzDw2VN;;AyD92VE;EACE,oCAAA;AzDi3VJ;;AOv2VE;;;EkDLI,oCAAA;AzDk3VN;;AyDx3VE;EACE,oCAAA;AzD23VJ;;AOj3VE;;;EkDLI,oCAAA;AzD43VN;;AyDl4VE;EACE,oCAAA;AzDq4VJ;;AO33VE;;;EkDLI,oCAAA;AzDs4VN;;AyD54VE;EACE,oCAAA;AzD+4VJ;;AOr4VE;;;EkDLI,oCAAA;AzDg5VN;;AyDt5VE;EACE,oCAAA;AzDy5VJ;;AO/4VE;;;EkDLI,oCAAA;AzD05VN;;AyDh6VE;EACE,oCAAA;AzDm6VJ;;AOz5VE;;;EkDLI,oCAAA;AzDo6VN;;AyD16VE;EACE,oCAAA;AzD66VJ;;AOn6VE;;;EkDLI,oCAAA;AzD86VN;;AyDp7VE;EACE,oCAAA;AzDu7VJ;;AO76VE;;;EkDLI,oCAAA;AzDw7VN;;AyD97VE;EACE,oCAAA;AzDi8VJ;;AOv7VE;;;EkDLI,oCAAA;AzDk8VN;;AyDx8VE;EACE,oCAAA;AzD28VJ;;AOj8VE;;;EkDLI,oCAAA;AzD48VN;;AyDr8VE;EACE,iFAAA;AzDw8VJ;;AyDz8VE;EACE,iFAAA;AzD48VJ;;AyD78VE;EACE,iFAAA;AzDg9VJ;;AyDj9VE;EACE,iFAAA;AzDo9VJ;;AyDr9VE;EACE,iFAAA;AzDw9VJ;;AyDz9VE;EACE,iFAAA;AzD49VJ;;AyD79VE;EACE,iFAAA;AzDg+VJ;;AyDj+VE;EACE,iFAAA;AzDo+VJ;;AyDr+VE;EACE,iFAAA;AzDw+VJ;;AyDz+VE;EACE,iFAAA;AzD4+VJ;;AyD7+VE;EACE,iFAAA;AzDg/VJ;;AyDj/VE;EACE,6EAAA;AzDo/VJ;;AyDr/VE;EACE,iFAAA;AzDw/VJ;;AyDz/VE;EACE,iFAAA;AzD4/VJ;;AyD7/VE;EACE,iFAAA;AzDggWJ;;AyDjgWE;EACE,iFAAA;AzDogWJ;;AyDrgWE;EACE,iFAAA;AzDwgWJ;;AyDzgWE;EACE,iFAAA;AzD4gWJ;;AyD7gWE;EACE,iFAAA;AzDghWJ;;AyDjhWE;EACE,iFAAA;AzDohWJ;;AyDrhWE;EACE,iFAAA;AzDwhWJ;;AyDzhWE;EACE,iFAAA;AzD4hWJ;;AyD7hWE;EACE,iFAAA;AzDgiWJ;;AyDjiWE;EACE,iFAAA;AzDoiWJ;;AyDriWE;EACE,iFAAA;AzDwiWJ;;AyDziWE;EACE,iFAAA;AzD4iWJ;;AyD7iWE;EACE,iFAAA;AzDgjWJ;;AyD9jWE;EACE,oCAAA;AzDikWJ;;AOvjWE;;;EkDLI,oCAAA;AzDkkWN;;AyDxkWE;EACE,oCAAA;AzD2kWJ;;AOjkWE;;;EkDLI,oCAAA;AzD4kWN;;AyDllWE;EACE,oCAAA;AzDqlWJ;;AO3kWE;;;EkDLI,oCAAA;AzDslWN;;AyD5lWE;EACE,oCAAA;AzD+lWJ;;AOrlWE;;;EkDLI,oCAAA;AzDgmWN;;AyDtmWE;EACE,kCAAA;AzDymWJ;;AO/lWE;;;EkDLI,kCAAA;AzD0mWN;;AyDnmWE;EACE,iFAAA;AzDsmWJ;;AyDvmWE;EACE,iFAAA;AzD0mWJ;;AyD3mWE;EACE,iFAAA;AzD8mWJ;;AyD/mWE;EACE,iFAAA;AzDknWJ;;AyDnnWE;EACE,iFAAA;AzDsnWJ;;AyDvnWE;EACE,iFAAA;AzD0nWJ;;AyD3nWE;EACE,iFAAA;AzD8nWJ;;AyD/nWE;EACE,iFAAA;AzDkoWJ;;AyDnoWE;EACE,iFAAA;AzDsoWJ;;AyDvoWE;EACE,iFAAA;AzD0oWJ;;AyD3oWE;EACE,iFAAA;AzD8oWJ;;AyD/oWE;EACE,6EAAA;AzDkpWJ;;AiFvoWI;EACI,a3E6CO;AN6lWf;;AiFvoWI;EACI,e3EyCO;ANimWf;;AiF/oWI;EACI,a3E6CO;ANqmWf;;AiF/oWI;EACI,e3EyCO;ANymWf;;AiFvpWI;EACI,a3E6CO;AN6mWf;;AiFvpWI;EACI,e3EyCO;ANinWf;;AiF/pWI;EACI,a3E6CO;ANqnWf;;AiF/pWI;EACI,e3EyCO;ANynWf;;AiFvqWI;EACI,a3E6CO;AN6nWf;;AiFvqWI;EACI,e3EyCO;ANioWf;;AiF/qWI;EACI,a3E6CO;ANqoWf;;AiF/qWI;EACI,e3EyCO;ANyoWf;;AiFvrWI;EACI,a3E6CO;AN6oWf;;AiFvrWI;EACI,e3EyCO;ANipWf;;AiF/rWI;EACI,a3E6CO;ANqpWf;;AiF/rWI;EACI,e3EyCO;ANypWf;;AiFvsWI;EACI,a3E6CO;AN6pWf;;AiFvsWI;EACI,e3EyCO;ANiqWf;;AiF/sWI;EACI,a3E6CO;ANqqWf;;AiF/sWI;EACI,e3EyCO;ANyqWf;;AiFvtWI;EACI,a3E6CO;AN6qWf;;AiFvtWI;EACI,e3EyCO;ANirWf;;AiF/tWI;EACI,W3E6CO;ANqrWf;;AiF/tWI;EACI,a3EyCO;ANyrWf;;AiF9tWA;EACC,iBAAA;AjFiuWD;;AkFzwWA;EACC,oCAAA;EACA,sBAAA;AlF4wWD;AkF1wWC;EACO,4BAAA;AlF4wWR;;AkFxwWA;EACC,uCAAA;AlF2wWD;;AkFxwWA;EACC,uCAAA;AlF2wWD;;AkFtwWA;EACI;IACI,0BAAA;ElFywWN;EkFvwWE;IACI,2BAAA;ElFywWN;EkFvwWE;IACI,0BAAA;ElFywWN;AACF;AkFtwWA;EACI;IACI,0BAAA;ElFwwWN;EkFtwWE;IACI,2BAAA;ElFwwWN;EkFtwWE;IACI,0BAAA;ElFwwWN;AACF;AkFrwWA;EACI;IACI,0BAAA;ElFuwWN;EkFrwWE;IACI,0BAAA;ElFuwWN;EkFrwWE;IACI,0BAAA;ElFuwWN;AACF;AmFzzWA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AnF2zWJ;;AmFrzWI;EAEI,WAAA;EACA,cAAA;AnFuzWR;AmFrzWI;EACI,WAAA;AnFuzWR;;AmFjzWA;EACI,4BAAA;AnFozWJ;;AmFlzWA;EACI,2BAAA;AnFqzWJ;;AmFhzWA;EACI,uBAAA;AnFmzWJ;;AmFjzWA;EACI,uBAAA;AnFozWJ;;AmFlzWA;EACI,uBAAA;AnFqzWJ;;AmFnzWA;EACI,uBAAA;AnFszWJ;;AmFpzWA;EACI,uBAAA;AnFuzWJ;;AmFrzWA;EACI,uBAAA;AnFwzWJ;;AmFtzWA;EACI,uBAAA;AnFyzWJ;;AmFvzWA;EACI,uBAAA;AnF0zWJ;;AmFxzWA;EACI,uBAAA;AnF2zWJ;;AmFzzWA;EACI,qBAAA;AnF4zWJ;;AoFv3WC;EACC,M9EuIQ;ANmvWV;;AoFx3WC;EACC,Q9EoIQ;ANuvWV;;AoFz3WC;EACC,S9EiIQ;AN2vWV;;AoF13WC;EACC,O9E8HQ;AN+vWV;;AoFv4WC;EACC,Y9EuIQ;ANmwWV;;AoFx4WC;EACC,c9EoIQ;ANuwWV;;AoFz4WC;EACC,e9EiIQ;AN2wWV;;AoF14WC;EACC,a9E8HQ;AN+wWV;;AoFv5WC;EACC,W9EuIQ;ANmxWV;;AoFx5WC;EACC,a9EoIQ;ANuxWV;;AoFz5WC;EACC,c9EiIQ;AN2xWV;;AoF15WC;EACC,Y9E8HQ;AN+xWV;;AoFv6WC;EACC,S9EuIQ;ANmyWV;;AoFx6WC;EACC,W9EoIQ;ANuyWV;;AoFz6WC;EACC,Y9EiIQ;AN2yWV;;AoF16WC;EACC,U9E8HQ;AN+yWV;;AoFv7WC;EACC,W9EuIQ;ANmzWV;;AoFx7WC;EACC,a9EoIQ;ANuzWV;;AoFz7WC;EACC,c9EiIQ;AN2zWV;;AoF17WC;EACC,Y9E8HQ;AN+zWV;;AoFv8WC;EACC,S9EuIQ;ANm0WV;;AoFx8WC;EACC,W9EoIQ;ANu0WV;;AoFz8WC;EACC,Y9EiIQ;AN20WV;;AoF18WC;EACC,U9E8HQ;AN+0WV;;AoFv9WC;EACC,S9EuIQ;ANm1WV;;AoFx9WC;EACC,W9EoIQ;ANu1WV;;AoFz9WC;EACC,Y9EiIQ;AN21WV;;AoF19WC;EACC,U9E8HQ;AN+1WV;;AoFv+WC;EACC,S9EuIQ;ANm2WV;;AoFx+WC;EACC,W9EoIQ;ANu2WV;;AoFz+WC;EACC,Y9EiIQ;AN22WV;;AoF1+WC;EACC,U9E8HQ;AN+2WV;;AoFv/WC;EACC,S9EuIQ;ANm3WV;;AoFx/WC;EACC,W9EoIQ;ANu3WV;;AoFz/WC;EACC,Y9EiIQ;AN23WV;;AoF1/WC;EACC,U9E8HQ;AN+3WV;;AoFvgXC;EACC,S9EuIQ;ANm4WV;;AoFxgXC;EACC,W9EoIQ;ANu4WV;;AoFzgXC;EACC,Y9EiIQ;AN24WV;;AoF1gXC;EACC,U9E8HQ;AN+4WV;;AoFzgXA;EACC,SAAA;EACA,2BAAA;ApF4gXD;;AqF3hXA;EACC,wBAAA;ArF8hXD;;AsF/hXA;EACI,gBAAA;AtFkiXJ;;AiBz+WI;EqErDA;IACI,aAAA;EtFkiXN;AACF;AiB/+WI;EqEhDA;IACI,aAAA;EtFkiXN;AACF;AiBp/WI;EqE3CA;IACI,aAAA;EtFkiXN;AACF;AsF/hXA;EACI,gBAAA;AtFiiXJ;;AiB5/WI;EqE/BA;;;;IAII,kBAAA;IACA,UAAA;EtF+hXN;EsFzhXE;IACI,6BAAA;EtF2hXN;EsFzhXE;IACI,+BAAA;EtF2hXN;EsFzhXE;IACI,gCAAA;EtF2hXN;EsFzhXE;IACI,8BAAA;EtF2hXN;EsFzhXE;IACI,6BAAA;EtF2hXN;EsFzhXE;IACI,gCAAA;EtF2hXN;EsFzhXE;IACI,6BAAA;EtF2hXN;EsFzhXE;IACI,gCAAA;EtF2hXN;EsFzhXE;IACI,6BAAA;EtF2hXN;EsFzhXE;IACI,gCAAA;EtF2hXN;EsFrhXE;IACI,6BAAA;EtFuhXN;EsFrhXE;IACI,gCAAA;EtFuhXN;EsFrhXE;IACI,6BAAA;EtFuhXN;EsFrhXE;IACI,gCAAA;EtFuhXN;EsFrhXE;IACI,6BAAA;EtFuhXN;EsFrhXE;IACI,gCAAA;EtFuhXN;EsFrhXE;IACI,6BAAA;EtFuhXN;EsFrhXE;IACI,gCAAA;EtFuhXN;EsFrhXE;IACI,6BAAA;EtFuhXN;EsFrhXE;IACI,gCAAA;EtFuhXN;AACF;AuF9nXA;EAEQ,0BtFyWsB;ADsxW9B;;AuF3nXA;EAA0B,iEAAA;AvF+nX1B;;AuF9nXA;EAAuB,wDAAA;AvFkoXvB;;AuFjoXA;EAA0B,0DAAA;AvFqoX1B;;AuFpoXA;EAA4B,2BAAA;AvFwoX5B;;AwF/oXA;EAAmB,2BAAA;AxFmpXnB;;AwFlpXA;EAAmB,2BAAA;AxFspXnB;;AwFrpXA;EAAmB,2BAAA;AxFypXnB;;AwFxpXA;EAAmB,2BAAA;AxF4pXnB;;AwF3pXA;EAAmB,2BAAA;AxF+pXnB;;AwF9pXA;EAAmB,2BAAA;AxFkqXnB;;AwFjqXA;EAAmB,2BAAA;AxFqqXnB;;AwFhqXA;EAAkB,0BAAA;AxFoqXlB;;AwFnqXA;EAAgB,6BAAA;AxFuqXhB;;AwFlqXA;EAAU,cAAA;AxFsqXV;;AwFrqXA;EAAU,gBAAA;AxFyqXV;;AwFxqXA;EAAU,gBAAA;AxF4qXV;;AwF3qXA;EAAU,gBAAA;AxF+qXV;;AwF9qXA;EAAU,gBAAA;AxFkrXV;;AwFjrXA;EAAU,gBAAA;AxFqrXV;;AwFprXA;EAAU,gBAAA;AxFwrXV;;AwFvrXA;EAAU,gBAAA;AxF2rXV;;AwF1rXA;EAAU,gBAAA;AxF8rXV;;AwF1rXA;EAAc,yBAAA;AxF8rXd;;AwFxrXA;EAAQ,yBAAA;AxF4rXR;;AwF3rXA;EAAS,0BAAA;AxF+rXT;;AwF9rXA;EAAQ,wBAAA;AxFksXR;;AiB7qXI;EwE3DH;IACC,kFAAA;EzF4uXA;EyF1uXD;IACC,kFAAA;EzF4uXA;AACF;A0FlvXA;EACI,SAAA;EACA,czFYO;ADwuXX;A0FlvXI;EACE,czFSK;AD2uXX;A0FjvXI;EACE,yBAAA;A1FmvXN;A0FhvXI;;EAEI,ezFoYuB;AD82W/B;A0F/uXI;EACI,czFJG;EyFKH,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;A1FivXR;A0F9uXI;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;A1FgvXN;A0F7uXI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A1F+uXN;A0F5uXI;EACI,cAAA;EACA,cAAA;A1F8uXR;A0F3uXI;EACI,kBAAA;A1F6uXR;;A0FxuXI;EACI,QAAA;EACA,czFwsBU;EyFvsBV,UAAA;EACA,2BAAA;EACA,+BAAA;EACA,UAAA;A1F2uXR;A0FzuXQ;EAEI,+BAAA;EACA,qBAAA;A1F0uXZ;AiBnuXI;EyElBA;IAeQ,SAAA;IACA,aAAA;E1F0uXV;AACF;A0FxuXQ;EACI,iBAAA;EACA,6BAAA;EACA,+BAAA;A1F0uXZ;A0FruXY;EACI,6BAAA;EACA,+BAAA;A1FuuXhB;;A2F3zXA;EACC,c1FaU;E0FZV,yB1FiBU;E0FhBV,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,e1F4Y8B;E0F3Y9B,kBAAA;EACA,YAAA;EACA,WAAA;A3F8zXD;;A2F3zXA;EACC,WAAA;EACA,kBAAA;A3F8zXD;;A2F3zXA;EACC,qBAAA;EACA,oBAAA;A3F8zXD;;A2F5zXA;EACC,WAAA;EACA,YAAA;EACA,0B1F2W6B;ADo9W9B;;A2F5zXA;EACC,WAAA;EACA,YAAA;EACA,0B1FqW6B;AD09W9B;;A2FzzXC;EACC,kBAAA;EACA,UAAA;EACA,yBAAA;A3F4zXF;A2F1zXE;EACC,UAAA;A3F4zXH;A2FxzXC;EACC,kBAAA;A3F0zXF;;A4Fz2XA,iCAAA;AACA;EACI,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;A5F42XJ;A4F12XI;EAEE,qBAAA;A5F22XN;;A4Fv2XA;EACE,qBAAA;A5F02XF;A4Fx2XE;EACG,gBAAA;A5F02XL;;A4Ft2XA;EnDrBE,cAAA;EACA,yBmDqByB;A5F02X3B;AOj3XE;EkCVI,cAAA;EACA,yBAAA;AzC83XN;AyC33XI;EAEE,UAAA;EACA,0CAAA;AzC43XN;;A6Fz4XA;;EAEI,iB5F0UyB;E4FzUzB,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wB5F2U0B;E4F1U1B,eAAA;ECkBF,mB7FwEc;E6FpEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FgGY;E8F/FZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;ADi5XX;A+F15XI;;EACE,gCAAA;EACA,4BAAA;A/F65XN;A+F15XI;;;;;;;;;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/F45XR;A+Fz5XI;;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/F45XN;A+Fz5XI;;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/F25XR;A+Fp5XQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,yB9F+CI;E8F9CJ,qB9F8CI;AD23XhB;A+F90XI;;EACI,c9F9CQ;E8F+CR,qB9F/CQ;E8FgDR,uB9FzHqB;AD08X7B;A+F/0XQ;;;;;EAII,c9FtDI;E8FuDJ,qB9FvDI;E8FwDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/Fk1XZ;A+F/0XQ;;EACE,gCAAA;A/Fk1XV;A+Fj1XU;;;;;EAII,c9FvJH;E8FwJG,qB9FpEE;E8FqEF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/Fo1Xd;A+F/0XI;;EACI,c9FhFQ;ADk6XhB;A+Fj1XQ;;;;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/Fo1XZ;A6FlgYI;;;EGTF,UHWuB;EGRvB,0BAAA;EHSM,qBAAA;A7FsgYR;A6FpgYI;;;;EhFDE,gBgFIG;EACA,qBAAA;A7FugYT;A6FpgYI;;EACE,SAAA;A7FugYN;A6FpgYI;;EAEI,gB5FwboB;E4FvbpB,mB5FuboB;E4FtbpB,e5FsboB;E4FrbpB,UAAA;EACA,oB5FqboB;E4FpbpB,gBAAA;EACA,kBAAA;EACA,mBAAA;A7FsgYR;A6FpgYQ;;EACI,UAAA;A7FugYZ;A6FpgYQ;;;EACI,gB5F6agB;E4F5ahB,mB5F4agB;E4F3ahB,e5F2agB;AD6lX5B;A6FtgYY;;;;;;;;;;;EAII,oB5FoaY;AD2mX5B;A6F3gYQ;;;EACI,c5FkagB;E4FjahB,iB5FiagB;E4FhahB,a5FgagB;AD+mX5B;A6F7gYY;;;;;;;;;;;EAII,mB5FyZY;AD6nX5B;A6FlhYQ;;;;;EAII,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;A7FqhYZ;A6FhhYI;;EACI,kBAAA;EACA,QAAA;A7FmhYR;A6FhhYI;;EACE,kBAAA;EACA,cAAA;A7FmhYN;A6FhhYE;;EACE,c5FqCyB;AD8+X7B;A6FhhYE;;EACE,4BAAA;A7FmhYJ;;A6F7gYA;EC/EE,mB7FyEc;E6FrEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FiGY;E8FhGZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;ADsnYX;A+F/nYI;EACE,gCAAA;EACA,4BAAA;A/FioYN;A+F9nYI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/FwnYR;A+FrnYI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/FunYN;A+FpnYI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/FqnYR;A+F9mYQ;EAMI,yB9FgDI;E8F/CJ,qB9F+CI;AD4jYhB;A+FhhYI;EACI,c9F7CQ;E8F8CR,qB9F9CQ;E8F+CR,uB9FzHqB;AD2oY7B;A+FhhYQ;EAII,c9FrDI;E8FsDJ,qB9FtDI;E8FuDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/F+gYZ;A+F5gYQ;EACE,gCAAA;A/F8gYV;A+F7gYU;EAII,c9FvJH;E8FwJG,qB9FnEE;E8FoEF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/F4gYd;A+FvgYI;EACI,c9F/EQ;ADwlYhB;A+FxgYQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/FwgYZ;;A6FtlYA;EClFE,mB7F2Ec;E6FvEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FmGY;E8FlGZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;ADksYX;A+F3sYI;EACE,gCAAA;EACA,4BAAA;A/F6sYN;A+F1sYI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/FosYR;A+FjsYI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/FmsYN;A+FhsYI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/FisYR;A+F1rYQ;EAMI,yB9FkDI;E8FjDJ,qB9FiDI;ADsoYhB;A+F5lYI;EACI,c9F3CQ;E8F4CR,qB9F5CQ;E8F6CR,uB9FzHqB;ADutY7B;A+F5lYQ;EAII,c9FnDI;E8FoDJ,qB9FpDI;E8FqDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/F2lYZ;A+FxlYQ;EACE,gCAAA;A/F0lYV;A+FzlYU;EAII,c9FvJH;E8FwJG,qB9FjEE;E8FkEF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/FwlYd;A+FnlYI;EACI,c9F7EQ;ADkqYhB;A+FplYQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/FolYZ;;A6F/pYA;ECrFE,mB7F4Ec;E6FxEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FoGY;E8FnGZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;AD8wYX;A+FvxYI;EACE,gCAAA;EACA,4BAAA;A/FyxYN;A+FtxYI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/FgxYR;A+F7wYI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/F+wYN;A+F5wYI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/F6wYR;A+FtwYQ;EAMI,yB9FmDI;E8FlDJ,qB9FkDI;ADitYhB;A+FxqYI;EACI,c9F1CQ;E8F2CR,qB9F3CQ;E8F4CR,uB9FzHqB;ADmyY7B;A+FxqYQ;EAII,c9FlDI;E8FmDJ,qB9FnDI;E8FoDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/FuqYZ;A+FpqYQ;EACE,gCAAA;A/FsqYV;A+FrqYU;EAII,c9FvJH;E8FwJG,qB9FhEE;E8FiEF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/FoqYd;A+F/pYI;EACI,c9F5EQ;AD6uYhB;A+FhqYQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/FgqYZ;;A6FxuYA;ECxFE,mB7F6Ec;E6FzEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FqGY;E8FpGZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;AD01YX;A+Fn2YI;EACE,gCAAA;EACA,4BAAA;A/Fq2YN;A+Fl2YI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/F41YR;A+Fz1YI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/F21YN;A+Fx1YI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/Fy1YR;A+Fl1YQ;EAMI,yB9FoDI;E8FnDJ,qB9FmDI;AD4xYhB;A+FpvYI;EACI,c9FzCQ;E8F0CR,qB9F1CQ;E8F2CR,uB9FzHqB;AD+2Y7B;A+FpvYQ;EAII,c9FjDI;E8FkDJ,qB9FlDI;E8FmDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/FmvYZ;A+FhvYQ;EACE,gCAAA;A/FkvYV;A+FjvYU;EAII,c9FvJH;E8FwJG,qB9F/DE;E8FgEF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/FgvYd;A+F3uYI;EACI,c9F3EQ;ADwzYhB;A+F5uYQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/F4uYZ;A6FnzYgB;EACE,c5FtGP;AD25YX;;A6FlzYA;EC7FE,mB7F8Ec;E6F1Ed,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FsGY;E8FrGZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;ADy6YX;A+Fl7YI;EACE,gCAAA;EACA,4BAAA;A/Fo7YN;A+Fj7YI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/F26YR;A+Fx6YI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/F06YN;A+Fv6YI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/Fw6YR;A+Fj6YQ;EAMI,yB9FqDI;E8FpDJ,qB9FoDI;AD02YhB;A+Fn0YI;EACI,c9FxCQ;E8FyCR,qB9FzCQ;E8F0CR,uB9FzHqB;AD87Y7B;A+Fn0YQ;EAII,c9FhDI;E8FiDJ,qB9FjDI;E8FkDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/Fk0YZ;A+F/zYQ;EACE,gCAAA;A/Fi0YV;A+Fh0YU;EAII,c9FvJH;E8FwJG,qB9F9DE;E8F+DF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/F+zYd;A+F1zYI;EACI,c9F1EQ;ADs4YhB;A+F3zYQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/F2zYZ;;A6F33YA;EChGE,mB7FZS;E6FgBT,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FYO;E8FXP,0BAAA;EACA,gBAAA;EAsDI,c9FyCQ;ADg6YhB;A+F9/YI;EACE,gCAAA;EACA,4BAAA;A/FggZN;A+F7/YI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/Fu/YR;A+Fp/YI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/Fs/YN;A+Fn/YI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/Fo/YR;A+F7+YQ;EAMI,yB9FrCD;E8FsCC,qB9FtCD;ADghZX;A+Fl+YQ;EACI,c9F2CI;ADy7YhB;A+Fl+YY;EAII,c9FgDO;ADi7YvB;A+F79YQ;EACI,c9F8BI;ADi8YhB;A+F79YY;EAII,c9FmCO;ADy7YvB;A+Fx9YQ;EACI,c9FoBI;ADs8YhB;A+Fx9YY;EAII,c9FyBO;AD87YvB;A+Fn9YQ;EACI,c9FOI;AD88YhB;A+Fn9YY;EAII,c9FYO;ADs8YvB;A+F98YQ;EACI,c9FPI;ADu9YhB;A+F98YY;EAII,c9FDO;AD88YvB;A+Fz8YQ;EASI,yB9F9GD;E8F+GC,c9FdW;E8FeX,gBAAA;A/Fm8YZ;A+Fh8YQ;EAEI,c9FpBW;ADq9YvB;A+F/7YY;EACI,gBAAA;A/Fi8YhB;A+Fx7YI;EACI,c9FlIG;E8FmIH,qB9FnIG;E8FoIH,uB9FzHqB;ADmjZ7B;A+Fx7YQ;EAII,c9F1ID;E8F2IC,qB9F3ID;E8F4IC,wCAAA;EACA,iCAAA;EACA,gBAAA;A/Fu7YZ;A+Fp7YQ;EACE,gCAAA;A/Fs7YV;A+Fr7YU;EAII,c9FvJH;E8FwJG,qB9FxJH;E8FyJG,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/Fo7Yd;A+F/6YI;EACI,c9FpKG;ADqlZX;A+Fh7YQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/Fg7YZ;;A6F7+YK;EG1HH,YH6HuB;EG1HvB,yBAAA;EH2HM,oBAAA;A7F++YR;;A6F5+YA;EACI,iB5FkN4B;E4FjN5B,qB5FpCY;E4FqCZ,gBAAA;EACA,kBAAA;EACA,6B5FhHyB;AD+lZ7B;;A6Ft+YQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,uB5F/HiB;AD2nZ7B;;A6Fv/YA;EACE,0CAAA;A7F0/YF;;A6Fx/YA;EACI,S5FyKyB;E4FxKzB,gBAAA;EACA,sBAAA;EACA,uB5F3IyB;E4F4IzB,c5FpJO;E4FqJP,gB5FyO0B;ADkxY9B;A6Fz/YE;EACE,2BAAA;EACA,0BAAA;A7F2/YJ;;A6Fv/YA;EEgHG,mB9FgG2B;E8F/F3B,wB9FmD2B;E8FlD3B,kBAAA;A/F24YH;A+Fz4YG;EACI,kBAAA;A/F24YP;;A6F7/YA;EE6GG,mB9FgG2B;E8F/F3B,wB9FoD2B;E8FnD3B,iBAAA;A/Fo5YH;A+Fl5YG;EACI,iBAAA;A/Fo5YP;;A6FlgZA;EACI,gBAAA;A7FqgZJ;;A6FngZA;EACI,WAAA;A7FsgZJ;;A6FlgZE;EACE,0CAAA;EACA,2BAAA;EACA,mCAAA;A7FqgZJ;A6FlgZE;EACE,wBAAA;EACA,gCAAA;A7FogZJ;;A6F//YA;EACI,gBAAA;A7FkgZJ;;A6FhgZA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;A7FmgZJ;;A6FhgZA;EACI,iB5FsHyB;E4FrHzB,mB5FuV0B;AD4qY9B;A6FjgZI;EACI,kBAAA;A7FmgZR;;A6F9/YE;EACE,aAAA;A7FigZJ;;A6F3/YE;EC3MA,mB7FwHsB;E6FpHtB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/F+7YJ;A+F77YI;EAGI,yB9FjKgB;E8FkKhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;ADwuZX;A+F17YI;EACI,c9F1KgB;E8F2KhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9F9KgB;AD0mZxB;A+F17YQ;EAGI,c9FnLY;E8FoLZ,qB9FpLY;AD8mZxB;A+Ft7YI;EACI,c9F1LgB;E8F2LhB,yB9F/TG;ADuvZX;A+Fr7YQ;EAGI,c9FhMY;ADqnZxB;A6FhiZE;EC9MA,mB7F0HsB;E6FtHtB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/Fs+YJ;A+Fp+YI;EAGI,yB9F/JgB;E8FgKhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;AD+wZX;A+Fj+YI;EACI,c9FxKgB;E8FyKhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9F5KgB;AD+oZxB;A+Fj+YQ;EAGI,c9FjLY;E8FkLZ,qB9FlLY;ADmpZxB;A+F79YI;EACI,c9FxLgB;E8FyLhB,yB9F/TG;AD8xZX;A+F59YQ;EAGI,c9F9LY;AD0pZxB;A6FpkZE;ECjNA,mB7FkIsB;E6F9HtB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/F6gZJ;A+F3gZI;EAGI,yB9FvJgB;E8FwJhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;ADszZX;A+FxgZI;EACI,c9FhKgB;E8FiKhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9FpKgB;AD8qZxB;A+FxgZQ;EAGI,c9FzKY;E8F0KZ,qB9F1KY;ADkrZxB;A+FpgZI;EACI,c9FhLgB;E8FiLhB,yB9F/TG;ADq0ZX;A+FngZQ;EAGI,c9FtLY;ADyrZxB;A6FxmZE;ECpNA,mB7F4HsB;E6FxHtB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/FojZJ;A+FljZI;EAGI,yB9F7JgB;E8F8JhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;AD61ZX;A+F/iZI;EACI,c9FtKgB;E8FuKhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9F1KgB;AD2tZxB;A+F/iZQ;EAGI,c9F/KY;E8FgLZ,qB9FhLY;AD+tZxB;A+F3iZI;EACI,c9FtLgB;E8FuLhB,yB9F/TG;AD42ZX;A+F1iZQ;EAGI,c9F5LY;ADsuZxB;A6F5oZE;ECvNA,mB7FgIsB;E6F5HtB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/F2lZJ;A+FzlZI;EAGI,yB9FzJgB;E8F0JhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;ADo4ZX;A+FtlZI;EACI,c9FlKgB;E8FmKhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9FtKgB;AD8vZxB;A+FtlZQ;EAGI,c9F3KY;E8F4KZ,qB9F5KY;ADkwZxB;A+FllZI;EACI,c9FlLgB;E8FmLhB,yB9F/TG;ADm5ZX;A+FjlZQ;EAGI,c9FxLY;ADywZxB;A6FhrZE;EC1NA,mB7FsIsB;E6FlItB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/FkoZJ;A+FhoZI;EAGI,yB9FnJgB;E8FoJhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;AD26ZX;A+F7nZI;EACI,c9F5JgB;E8F6JhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9FhKgB;AD+xZxB;A+F7nZQ;EAGI,c9FrKY;E8FsKZ,qB9FtKY;ADmyZxB;A+FznZI;EACI,c9F5KgB;E8F6KhB,yB9F/TG;AD07ZX;A+FxnZQ;EAGI,c9FlLY;AD0yZxB;A6FptZE;EC7NA,mB7FwIsB;E6FpItB,0EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/FyqZJ;A+FvqZI;EAGI,sB9FjJgB;E8FkJhB,qFAAA;EAGA,0FAAA;EACA,c9F3SG;ADk9ZX;A+FpqZI;EACI,W9F1JgB;E8F2JhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,kB9F9JgB;ADo0ZxB;A+FpqZQ;EAGI,W9FnKY;E8FoKZ,kB9FpKY;ADw0ZxB;A+FhqZI;EACI,c9F1KgB;E8F2KhB,yB9F/TG;ADi+ZX;A+F/pZQ;EAGI,W9FhLY;AD+0ZxB;A6FxvZE;EChOA,mB7FoIsB;E6FhItB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/FgtZJ;A+F9sZI;EAGI,yB9FrJgB;E8FsJhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;ADy/ZX;A+F3sZI;EACI,c9F9JgB;E8F+JhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9FlKgB;AD+2ZxB;A+F3sZQ;EAGI,c9FvKY;E8FwKZ,qB9FxKY;ADm3ZxB;A+FvsZI;EACI,c9F9KgB;E8F+KhB,yB9F/TG;ADwgaX;A+FtsZQ;EAGI,c9FpLY;AD03ZxB;A6F5xZE;ECnOA,mB7F8HsB;E6F1HtB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/FuvZJ;A+FrvZI;EAGI,yB9F3JgB;E8F4JhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;ADgiaX;A+FlvZI;EACI,c9FpKgB;E8FqKhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9FxKgB;AD45ZxB;A+FlvZQ;EAGI,c9F7KY;E8F8KZ,qB9F9KY;ADg6ZxB;A+F9uZI;EACI,c9FpLgB;E8FqLhB,yB9F/TG;AD+iaX;A+F7uZQ;EAGI,c9F1LY;ADu6ZxB;A6Fh0ZE;ECtOA,mB7F0IsB;E6FtItB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/F8xZJ;A+F5xZI;EAGI,yB9F/IgB;E8FgJhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;ADukaX;A+FzxZI;EACI,c9FxJgB;E8FyJhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9F5JgB;ADu7ZxB;A+FzxZQ;EAGI,c9FjKY;E8FkKZ,qB9FlKY;AD27ZxB;A+FrxZI;EACI,c9FxKgB;E8FyKhB,yB9F/TG;ADslaX;A+FpxZQ;EAGI,c9F9KY;ADk8ZxB;A6Fp2ZE;ECzOA,mB7F4IsB;E6FxItB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/Fq0ZJ;A+Fn0ZI;EAGI,yB9F7IgB;E8F8IhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;AD8maX;A+Fh0ZI;EACI,c9FtJgB;E8FuJhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9F1JgB;AD49ZxB;A+Fh0ZQ;EAGI,c9F/JY;E8FgKZ,qB9FhKY;ADg+ZxB;A+F5zZI;EACI,c9FtKgB;E8FuKhB,yB9F/TG;AD6naX;A+F3zZQ;EAGI,c9F5KY;ADu+ZxB;A6Fx4ZE;EC5OA,mB7F8IsB;E6F1ItB,4EAAA;EACA,0BAAA;EACA,8BAAA;EC4QE,c9F9RO;E8F+RP,0BAAA;EACA,8BAAA;EACA,wBAAA;A/F42ZJ;A+F12ZI;EAGI,yB9F3IgB;E8F4IhB,uFAAA;EAGA,4FAAA;EACA,c9F3SG;ADqpaX;A+Fv2ZI;EACI,c9FpJgB;E8FqJhB,6B9FrSqB;E8FsSrB,iCAAA;EACA,gBAAA;EACA,qB9FxJgB;ADigaxB;A+Fv2ZQ;EAGI,c9F7JY;E8F8JZ,qB9F9JY;ADqgaxB;A+Fn2ZI;EACI,c9FpKgB;E8FqKhB,yB9F/TG;ADoqaX;A+Fl2ZQ;EAGI,c9F1KY;AD4gaxB;;A6F16ZA;;;EAGI,c5FhQO;AD6qaX;;AiBlnaI;E4E2MF;IACE,kB5FyB2B;I4FxB3B,mB5FwB2B;EDm5Z7B;AACF;AiGlsaA;EAEQ,0BhGyWsB;AD01Z9B;AiGjsaI;EACI,6BhGiyB4B;EgGhyB5B,yBhGkyB4B;EgGjyB5B,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EAEI,0BhG6VkB;ADq2Z9B;AiG9raI;EAEI,6BhGmxB4B;EgGlxB5B,yBhGoxB4B;EgGnxB5B,aAAA;AjG+raR;AiG7raQ;EACI,6BhG8wBwB;ADi7YpC;;AkGttaI;EACI,yBAAA;EAEI,2DjGylB4B;AD+nZxC;AkGptaI;EACI,kBAAA;EACA,QAAA;AlGstaR;;AkGltaA;EACI,gBAAA;AlGqtaJ;;AkGjtaI;EACI,qBjG8UwB;ADs4ZhC;;AkG5saQ;EACI,SAAA;EACA,yEjG0iB4B;ADqqZxC;AkGxsagB;EACI,2EjGmiBoB;ADuqZxC;AkGrsaQ;EAEI,yEjG2hB4B;AD2qZxC;;AkG9raI;EACI,eAAA;EACA,0BjG2UsB;ADs3Z9B;AkG3ragB;EACI,qBjGoSY;ADy5ZhC;AkG3ragB;EACI,0D5F0e4B;ANmtZhD;AkGtragB;EACI,qBjG1DT;ADkvaX;AkGnragB;EACI,qCjGsjB4B;AD+nZhD;;AkG5qaI;EACI,eAAA;EACA,0BjGwSsB;ADu4Z9B;AkGzqagB;EACI,qBjGiQY;AD06ZhC;AkGzqagB;EACI,0D5Fgd4B;AN2tZhD;AkGpqagB;EACI,qBjG7FT;ADmwaX;AkGjqagB;EACI,qCjGmhB4B;ADgpZhD;;AkG1paA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AlG6paJ;AkG3paI;EACI,aAAA;AlG6paR;AkG1paa;EACG,yBAAA;AlG4pahB;AkG1pagB;EACI,mBjGqgBQ;EiGpgBR,+BAAA;AlG4papB;AkGtpaY;EACI,yBAAA;AlGwpahB;AkGppagB;EACI,yBAAA;AlGspapB;AkGppaoB;EACI,yBAAA;AlGspaxB;;AkG9oaA;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;AlGipaJ;AkG9oaI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,sBjGwdoB;EiGvdpB,2DjGuagC;ADyuZxC;;AmGv0aA;EACI,SAAA;EACA,gDAAA;EACA,wBlGiV0B;E6F9T1B,4BAAA;A9F4zaJ;AmG30aM;EACE,UAAA;EACA,WAAA;AnG60aR;AmGz0aI;EACE,gEAAA;EACA,yBAAA;AnG20aN;AmG10aM;EACE,+BAAA;AnG40aR;AmGz0aM;EACE,qBlG6EQ;AD8vahB;AmGx0aM;EACE,clGgFQ;EkG/ER,UAAA;AnG00aR;AmGv0aM;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,clG0DQ;EkGzDR,0BAAA;EACA,qCAAA;EACA,oCAAA;AnGy0aR;AmGr0aQ;EACE,UAAA;EACA,WAAA;AnGu0aV;AmGl0aQ;EACE,clG6Da;EkG5Db,UAAA;AnGo0aV;AmGj0aQ;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,clG3CmB;EkG4CnB,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,mBAAA;EACA,UAAA;AnGm0aV;AmG9zaI;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;AnGg0aR;AmG7zaI;EACI,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AnG+zaR;AmG3zaQ;EAEI,cAAA;AnG4zaZ;AmGvzaQ;EACI,aAAA;AnGyzaZ;AmGtzaQ;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,clGxGC;EkGyGD,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,mBAAA;AnGwzaV;AmGpzaU;EACE,WAAA;EACA,UAAA;AnGszaZ;AmG/yaI;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,clGnIK;EkGoIL,0BAAA;EACA,qCAAA;EACA,oCAAA;AnGizaN;AmG5yaI;EACE,mBAAA;EACA,qBAAA;AnG8yaN;AmG3yaI;EAEE,0BlGmOwB;EkGlOxB,mBAAA;EACA,sBAAA;EACA,eAAA;EL7IF,4BAAA;A9F87aJ;AmG9yaM;EAEE,0ClG7GqB;AD45a7B;AmG5yaM;EAEE,+BlGlDe;AD+1avB;AmG3yaQ;EAEE,6BAAA;EACA,gBAAA;AnG4yaV;AmGtyaI;EACI,0ClG7HqB;ADq6a7B;AmGryaI;EACI,+BlGlEe;EkGmEf,qBlGsMsB;EkGrMtB,yBAAA;EACA,gBlG+MsB;ADwla9B;AmGpyaI;EClMA,yBDmM6B;AnGsyajC;AoGv+aI;EACI,cDgMyB;AnGyyajC;AoGt+aI;EACI,+BnG0DqB;AD86a7B;AoGr+aI;EACI,cnGEG;ADq+aX;AoGr+aQ;EAEI,0CnGuDiB;AD+6a7B;AoGl+aI;EACI,0CnGkDqB;ADk7a7B;AmGlzaI;ECtMA,yBDuM6B;AnGozajC;AoGz/aI;EACI,cDoMyB;AnGuzajC;AoGx/aI;EACI,+BnG0DqB;ADg8a7B;AoGv/aI;EACI,cnGEG;ADu/aX;AoGv/aQ;EAEI,0CnGuDiB;ADi8a7B;AoGp/aI;EACI,0CnGkDqB;ADo8a7B;AmGh0aI;EC1MA,yBD2M6B;AnGk0ajC;AoG3gbI;EACI,cDwMyB;AnGq0ajC;AoG1gbI;EACI,+BnG0DqB;ADk9a7B;AoGzgbI;EACI,cnGEG;ADygbX;AoGzgbQ;EAEI,0CnGuDiB;ADm9a7B;AoGtgbI;EACI,0CnGkDqB;ADs9a7B;AmG90aI;EC9MA,yBD+M6B;AnGg1ajC;AoG7hbI;EACI,cD4MyB;AnGm1ajC;AoG5hbI;EACI,+BnG0DqB;ADo+a7B;AoG3hbI;EACI,cnGEG;AD2hbX;AoG3hbQ;EAEI,0CnGuDiB;ADq+a7B;AoGxhbI;EACI,0CnGkDqB;ADw+a7B;AmG51aI;EClNA,yBDmN6B;AnG81ajC;AoG/ibI;EACI,cDgNyB;AnGi2ajC;AoG9ibI;EACI,+BnG0DqB;ADs/a7B;AoG7ibI;EACI,cnGEG;AD6ibX;AoG7ibQ;EAEI,0CnGuDiB;ADu/a7B;AoG1ibI;EACI,0CnGkDqB;AD0/a7B;AmG12aI;EL/JG,8CAAA;EKoKC,kBAAA;EACA,cAAA;EH1NN,UG2NuB;EHxNvB,wBAAA;EGyNM,oBAAA;AnG82aR;AmG32aI;EL1KG,8CAAA;EK4KD,kBAAA;EACA,cAAA;EHlOJ,UGmOqB;EHhOrB,wBAAA;AhGklbF;AmG/2aI;ELjLG,8CAAA;A9FuibP;AmGj3aI;ELtLG,6CAAA;A9F8ibP;AmGp3aI;EL1LG,6CAAA;EK4LC,oBAAA;EACA,YAAA;AnG03aR;AmGv3aI;EHrPF,UG2PuB;EHxPvB,0BAAA;EGyPM,mBAAA;ELvMD,4CAAA;A9FikbP;AmGt3aI;EL3MG,4CAAA;A9FwkbP;AmGx3aI;ELhNG,6CAAA;A9F+kbP;AmG33aI;EACE,WAAA;AnG63aN;AmG53aM;EACE,UAAA;EACA,WAAA;AnG83aR;;AmGv3aA;EACI,eAAA;AnG03aJ;AmGx3aI;EACI,aAAA;EACA,SAAA;EACA,kBAAA;AnG03aR;AmGx3aQ;EACE,WAAA;EACA,gBAAA;AnG03aV;AmGr3aI;EACE,aAAA;AnGu3aN;AmGn3aM;EACE,YAAA;EACA,UAAA;EACA,iBAAA;AnGq3aR;;AmGh3aA;EAEE,eAAA;EAAA,gBAAA;AnGk3aF;;AmG92aA;;;EAGG,gBAAA;AnGi3aH;;AmG52aA;EACI,gBAAA;EACA,iBlGe0B;ADg2a9B;;AmG52aA;EACI,gBAAA;EACA,wBlGU0B;ADq2a9B;;AmG52aA;EACI,gBAAA;EACA,wBlGK0B;AD02a9B;;AiBnnbI;EkFwQF;IACI,aAAA;EnG+2aJ;EmG72aA;IACI,qBAAA;IACA,QAAA;IACA,SAAA;IACA,oBAAA;IACA,uBAAA;IACA,WAAA;IACA,uBAAA;IACA,qCAAA;IACA,gBAAA;IACA,oCAAA;EnG+2aJ;AACF;AiBlpbI;EkFySF;IACE,clGlOyB;ED8kb3B;AACF;AqGntbA;EACI,kBAAA;ArGqtbJ;AqGntbI;EACE,UAAA;ArGqtbN;AqGltbI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;ArGotbR;AqGjtbI;EACE,qBAAA;ArGmtbN;AqGjtbM;EACE,eAAA;ArGmtbR;AqG/sbI;EACE,cpGVK;EoGWL,epG+QyB;EoG9QzB,0BpGyWwB;EoGxWxB,yBAAA;EACA,qBAAA;ArGitbN;AqG/sbM;EACI,qBAAA;ArGitbV;AqG3sbI;EACI,0BpG6VsB;EoG5VtB,gBAAA;EACA,cpG1BG;ADuubX;AqG1sbI;EACI,cAAA;EACA,WAAA;EACA,YAAA;ArG4sbR;;AiBjrbI;EoFrBF;IACE,kBAAA;IACA,kBAAA;ErG0sbF;EqGxsbE;IACI,iBAAA;ErG0sbN;AACF;AiBxsbI;EoFKA;IACE,YAAA;IACA,eAAA;ErGssbJ;AACF;AiBjsbI;EoFAF;IACE,kBAAA;ErGosbF;EqGnsbI;IACE,cAAA;IACA,kBAAA;IACA,WAAA;ErGqsbN;EqGlsbI;IACE,kBAAA;ErGosbN;AACF;AiB9sbI;EoFgBA;IACE,kBAAA;ErGisbJ;EqG/rbE;IACE,WAAA;ErGisbJ;AACF;AiBvsbI;EoFWF;IACE,6BAAA;IACA,kBAAA;ErG+rbF;EqG7rbE;IACE,YAAA;IACA,eAAA;ErG+rbJ;AACF;AsGzybA,kBAAA;ApGKG;EACI,coGL2B;ENEhC,U9FIsB;E8FDtB,0BAAA;AhGyybF;;AEtybG;EACI,coGT2B;ENEhC,U9FQsB;E8FLtB,0BAAA;AhG+ybF;;AExybG;EACI,coGb2B;ENEhC,U9FYsB;E8FTtB,0BAAA;AhGqzbF;;AE1ybG;EACI,coGjB2B;ENEhC,U9FgBsB;E8FbtB,0BAAA;AhG2zbF;;AsG9zbA;EACE,qBAAA;EACA,wBrG6U4B;EqG5U5B,0BrG6X4B;E6FrS1B,oGAAA;A9F8ubJ;AsGl0bE;EACE,qBrGwFY;EqGvFZ,6BrGayB;EYTvB,gByFHF;AtGo0bJ;AsGl0bI;EAII,yBAAA;EACA,iBAAA;EACA,6BrGIqB;AD6zb7B;AsG7zbE;EzFTI,gByFaA;AtG4zbN;AsGvzbM;EAEI,sBAAA;AtGwzbV;AsGpzbE;EACI,wBrGySwB;EqGxSxB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AtGszbN;AsGnzbE;EACI,sCAAA;EACA,gCrG1BuB;AD+0b7B;AsGlzbE;EAEI,yBrG1CK;AD61bX;;AsG9ybA;;;EAGI,qBAAA;AtGizbJ;;AsG9ybA;;;EAGE,qBAAA;AtGizbF;;AsG9ybA;;;;;EAKI,qBAAA;EACA,crGoCmB;EqGnCnB,0CAAA;AtGizbJ;AsG/ybI;;;;;EACI,6BrG1DqB;AD+2b7B;;AsG/ybI;;EACI,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,crGKQ;EqGJR,eAAA;AtGmzbR;AsG/ybM;;EACE,eAAA;EACA,SAAA;AtGkzbR;AsG7ybM;;EACE,SAAA;AtGgzbR;AsG3ybI;;EACE,wBAAA;AtG8ybN;AsG3ybI;;EACE,crGlBU;ADg0bhB;;AsGzybE;EACE,gBAAA;EACA,crGXmB;ADuzbvB;AsGzybE;EACE,crGfmB;AD0zbvB;AsGvybI;EACE,gCAAA;AtGyybN;;AiBv2bI;EqFqEF;;IAEE,mBAAA;IACA,cAAA;EtGsybF;EsGrybE;;IACE,eAAA;EtGwybJ;AACF;AiBh4bI;EsF3DH;IACC,iBAAA;EvG87bA;AACF;AwGj8bA;EACC,evGod2B;EuGnd3B,gBvGmd2B;ADg/a5B;AwGj8bC;EACC,mBAAA;AxGm8bF;;AwG/7bA;EACC,kBAAA;EACA,gCAAA;AxGk8bD;;AwG/7bA;EACC,WvG6c2B;EuG5c3B,YvG4c2B;ADs/a5B;AwGh8bC;EACC,kBAAA;AxGk8bF;;AwG97bA;EACC,4BAAA;AxGi8bD;;AwG97bA;EACC,avG+b2B;EuG9b3B,cvG8b2B;ADmgb5B;AwG/7bC;EACC,kBAAA;AxGi8bF;;AwGz7bA;EACC,evGgb2B;EuG/a3B,gBvG+a2B;AD6gb5B;AwG17bC;EACC,mBAAA;AxG47bF;;AwGl7bA;EACC,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AxGq7bD;AwGl7bC;EACC,kBAAA;AxGo7bF;AwGh7bE;EACC,mBAAA;AxGk7bH;AwG76bE;EACC,mBAAA;AxG+6bH;AwG36bC;EACC,WAAA;EACA,YAAA;AxG66bF;;AwGv6bC;ECvFG,cAAA;EACA,0CAAA;AzGkgcJ;;AwG56bC;ECvFG,cAAA;EACA,0CAAA;AzGugcJ;;AwGj7bC;ECvFG,cAAA;EACA,yCAAA;AzG4gcJ;;AwGt7bC;ECvFG,cAAA;EACA,yCAAA;AzGihcJ;;AwG37bC;ECvFG,cAAA;EACA,0CAAA;AzGshcJ;;AwGh8bC;ECvFG,cAAA;EACA,0CAAA;AzG2hcJ;;AwGr8bC;ECvFG,cAAA;EACA,0CAAA;AzGgicJ;;AwG18bC;ECvFG,cAAA;EACA,uCAAA;AzGqicJ;;AwG/8bC;ECvFG,cAAA;EACA,wCAAA;AzG0icJ;;AwGp9bC;ECvFG,cAAA;EACA,0CAAA;AzG+icJ;;AwGz9bC;ECvFG,cAAA;EACA,0CAAA;AzGojcJ;;AwG99bC;ECvFG,YAAA;EACA,uCAAA;AzGyjcJ;;A0G3jcA;EACI,eAAA;EACA,wBzGiV0B;AD6ub9B;;A0G5jcA;EACI,gDzGyVuB;ADsub3B;;A2GpkcA;;EAEE,c1GiHqB;ADs9bvB;;A2GnkcA;;EAEE,c1G6Fc;ADy+bhB;;AEricQ;;EACI,yBAAA;AFyicZ;AEticQ;;EACI,kBAAA;AFyicZ;AEvicY;;;EAEI,yBAAA;AF0ichB;;AEjicQ;;EACI,kBAAA;EACA,YAAA;AFqicZ;AEnicY;;;EAEI,yBAAA;AFsichB;AElicQ;;;;EAEI,yBAAA;AFsicZ;AEpicY;;;;EACI,4BAAA;AFyichB;;AE9hcQ;;EACI,kBAAA;AFkicZ;AEhicY;;;EAEI,yBAAA;AFmichB;AE/hcQ;;;;EAEI,yBAAA;AFmicZ;;AE7hcQ;;EACI,4BAAA;AFiicZ;AE/hcY;;;EAEI,yBAAA;AFkichB;AE9hcQ;;;;EAEI,yBAAA;AFkicZ;AEhicY;;;;;;;EAEI,4BAAA;AFuichB;;A2G5ocE;;;;;;EAIE,yBAAA;EACA,mBAAA;A3GipcJ;A2GhpcI;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,yBAAA;A3G+pcN;A2GzpcM;;;EAEE,yBAAA;A3G4pcR;A2GvpcE;;;;EAEE,yBAAA;EACA,YAAA;A3G2pcJ;;A2GtpcE;EACE,c1GmEmB;ADslcvB;;A2GrpcI;EACI,c1GgDQ;ADwmchB;;A2GppcA;;EAEI,6BAAA;EACA,yBAAA;EACA,wB1GqR0B;E0GpR1B,c1GhDO;E6FgFP,oGAAA;A9F4ncJ;A2G1pcI;;EACE,YAAA;A3G6pcN;A2GxpcI;;EACI,6B1G9CqB;ADysc7B;A2GxpcI;;EACI,6B1GlDqB;AD6sc7B;A2GzpcI;;EACI,c1GqCe;ADuncvB;A2G1pcI;;EACI,c1GoBQ;ADyochB;A2G1pcI;;;EzGnFA,uBAAA;EyGsFI,kBAAA;A3G6pcR;A2G1pcI;;EACI,WAAA;A3G6pcR;;A2GzpcA;;;EAGI,6BAAA;EACA,yBAAA;EACA,wB1G8O0B;E0G7O1B,c1GvFO;E0GwFP,SAAA;A3G4pcJ;;A2GzpcA;EACE,iBAAA;A3G4pcF;;A2G1pcA;EACE,kBAAA;A3G6pcF;;A2GzpcI;;EAEI,yB1GrGG;E0GsGH,qB1GjBQ;E0GkBR,6B1G5FqB;E0G6FrB,qB1GnBQ;AD+qchB;A2GxpcQ;;EAEI,yBAAA;A3G0pcZ;;A2GrpcA;;EAEI,mBAAA;EACA,kBAAA;A3GwpcJ;A2GtpcI;;EACI,eAAA;A3GypcR;;A2GppcI;;EAEI,yB1GZqB;ADmqc7B;;A2GnpcA;EACI,wB1G+L0B;E0G9L1B,yBAAA;EACA,4BAAA;EACA,mBAAA;A3GspcJ;;A2GnpcA;;;EAGI,oBAAA;A3GspcJ;;A2GppcA;;;EAGI,mBAAA;A3GupcJ;;A2GrpcA;EACI,yB1GhDmB;E0GiDnB,c1GnEY;E0GoEZ,mBAAA;A3GwpcJ;;A2GrpcA;EACI,iB1GiKyB;E0GhKzB,oBAAA;A3GwpcJ;;A2GtpcA;EACI,qB1G3CyB;ADosc7B;;A2GtpcA;EACI,cAAA;A3GypcJ;;A2GtpcA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;A3GypcJ;A2GvpcI;EAEE,iBAAA;EACA,gBAAA;EACA,kBAAA;A3GwpcN;;A2GlpcE;;;EAEE,mBAAA;A3GspcJ;;A2GlpcA;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;A3GqpcF;;A2GlpcA;EACE,eAAA;A3GqpcF;;A2GjpcA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A3GopcF;;A2GjpcA;EACI,0B1G2J0B;E0G1J1B,+BAAA;A3GopcJ;;A2GjpcA;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;A3GopcJ;A2GlpcI;EACE,4BAAA;A3GopcN;;A2G/ocE;;EAEE,wBAAA;EACA,iBAAA;EACA,gBAAA;A3GkpcJ;A2G/ocI;EACE,mBAAA;A3GipcN;A2G/ocM;EACE,eAAA;A3GipcR;A2G7ocI;EACE,gBAAA;EACA,wBAAA;A3G+ocN;A2G5ocI;EACE,eAAA;A3G8ocN;A2G7ocM;EACE,oBAAA;A3G+ocR;;A2G1ocA;EACI,iB1GiC2B;AD4mc/B;A2G5ocM;EACE,SAAA;A3G8ocR;A2G5ocO;EACI,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;A3G8ocX;A2G7ocW;EACG,aAAA;EACA,uBAAA;EACA,YAAA;EACA,+BAAA;A3G+ocd;A2G3ocW;EACC,eAAA;EACA,YAAA;EACA,wBAAA;A3G6ocZ;A2G3ocW;EACI,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,YAAA;A3G6ocf;A2G5oce;EACI,uBAAA;A3G8ocnB;A2G3ocW;EACI,UAAA;EACA,c1G1SJ;ADu7cX;A2G5oce;EACE,c1G5SN;AD07cX;;A2GxocG;EACE,iBAAA;EACA,iBAAA;A3G2ocL;A2GzocK;EACE,YAAA;EACA,c1G7NS;ADw2chB;A2GzocO;EACE,c1GhOO;AD22chB;;A2GtocA;EACE,eAAA;A3GyocF;;A2GrocE;;EACE,e1G8D2B;AD2kc/B;;A4G39cQ;EACI,sBAAA;A5G89cZ;A4G19cY;EdOJ,qCAAA;A9F09cR;A4G79coB;EACI,oDAAA;A5G+9cxB;A4G39coB;EACI,qDAAA;A5G69cxB;A4Gz9coB;EACI,oDAAA;A5G29cxB;A4Gv9coB;EACI,qDAAA;A5Gy9cxB;A4Gr9coB;EACI,oDAAA;A5Gu9cxB;A4Gn9cgB;EACI,c3GiEJ;ADo5chB;A4Gl9cgB;EACI,c3G8DJ;ADs5chB;A4Gj9cgB;EACI,c3G2DJ;ADw5chB;A4Gh9cgB;EACI,c3GkDJ;ADg6chB;A4G/8cgB;EACI,c3GgDJ;ADi6chB;A4G38cI;EACI,c3GsCQ;E2GrCR,2CAAA;A5G68cR;A4G38cQ;EACI,gBAAA;A5G68cZ;A4G18cQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gDAAA;EACA,qB3G0TkB;E2GzTlB,yB3G7DD;E2G8DC,kBAAA;A5G48cZ;A4G18cY;EACI,kBAAA;A5G48chB;A4Gv8cI;EACI,kBAAA;EACA,eAAA;EACA,c3GkBQ;E2GjBR,gB3GuTsB;ADkpc9B;A4Gv8cI;EACI,c3GOQ;E2GNR,eAAA;EACA,gBAAA;A5Gy8cR;;A4Gr8cA;EACI,2BAAA;A5Gw8cJ;A4Gt8cI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;A5Gw8cR;A4Gt8cQ;EACI,cAAA;A5Gw8cZ;A4Gr8cQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;A5Gu8cZ;A4Gr8cY;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A5Gu8chB;A4Gn8cI;EACI,gBAAA;A5Gq8cR;;A4G/7cI;EACI,c3GhCQ;ADk+chB;A4Gh8cQ;EACI,qDAAA;A5Gk8cZ;A4G/7cI;EACI,c3GpCQ;ADq+chB;A4G/7cQ;EACI,qDAAA;A5Gi8cZ;A4G97cI;EACI,c3G5CQ;AD4+chB;A4G97cQ;EACI,oDAAA;A5Gg8cZ;A4G77cI;EACI,c3GjDQ;ADg/chB;A4G77cQ;EACI,sDAAA;A5G+7cZ;A4G57cI;EACI,c3GvDQ;ADq/chB;A4G57cQ;EACI,qDAAA;A5G87cZ;A4G17cI;EACI,c3GzJG;ADqldX;;A6GhmdA;EACE,SAAA;A7GmmdF;A6G9ldE;EACE,mBAAA;A7GgmdJ;A6G9ldI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;A7GgmdR;A6G9ldI;EACI,c5GoFQ;E4GnFR,eAAA;EACA,gBAAA;A7GgmdR;A6G7ldI;EACE,c5G8EU;ADihdhB;A6G5ldI;EACE,eAAA;A7G8ldN;A6GvldE;EACE,gBAAA;A7GyldJ;A6GvldI;EACE,c5G+DU;AD0hdhB;A6GrldE;EACE,aAAA,EACA,gBAAA;EACA,8BAAA;A7GuldJ;A6GrldI;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;A7GuldN;A6GrldM;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A7GuldR;A6GlldE;EACE,cAAA;A7GoldJ;;A6GjldA;EACE,8BAAA;A7GoldF;;A6GhldE;EACE,gBAAA;A7GmldJ;A6GhldQ;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;A7GkldZ;A6G5kdQ;EACI,kBAAA;A7G8kdZ;A6G3kdQ;EACI,gBAAA;EACA,cAAA;A7G6kdZ;A6GxkdQ;EAGI,4BAAA;A7G0kdZ;A6GrkdY;EACI,yBAAA;EACA,c5G/FL;ADsqdX;A6GrkdgB;EACI,YAAA;A7GukdpB;A6GjkdI;EACI,WAAA;EACA,YAAA;EACA,yB5G3GG;E4G4GH,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;A7GmkdR;A6GjkdQ;EACI,c5G7BI;E4G8BJ,eAAA;EACA,iBAAA;A7GmkdZ;A6G/jdY;EACI,c5GzHL;AD0rdX;A6G7jdQ;EACI,yB5GzCI;ADwmdhB;A6G5jdQ;EACI,yB5GxCI;ADsmdhB;A6G3jdQ;EACI,yB5G7CI;AD0mdhB;A6G3jdQ;EACI,yB5GlDI;AD+mdhB;A6G1jdQ;EACI,yB5GrDI;ADindhB;A8GttdI;EACI,yB7GYG;E6GXH,c7GsGQ;ADkndhB;A8GrtdI;EACE,+BAAA;A9GutdN;AEztdG;EACI,+BA+H+B;E8FlIpC,U9FIsB;E8FDtB,0BAAA;AhG6tdF;AE1tdG;EACI,+BA2H+B;E8FlIpC,U9FQsB;E8FLtB,0BAAA;AhGkudF;AE3tdG;EACI,+BAuH+B;E8FlIpC,U9FYsB;E8FTtB,0BAAA;AhGuudF;AE5tdG;EACI,+BAmH+B;E8FlIpC,U9FgBsB;E8FbtB,0BAAA;AhG4udF;AE3mdI;EACI,sCDxEqB;ECyErB,cD3HG;ADwudX;AE3mdQ;EACI,qBD9HD;EC+HC,6BDpHiB;ECqHjB,cDhID;AD6udX;AEvmdQ;;EACI,cDvID;ADivdX;AErmdQ;EACI,6BDlIiB;ADyud7B;AEnmdI;EACE,eAAA;AFqmdN;AElmdI;;EAEI,uCAAA;EACA,sCDtGqB;ECuGrB,cDzJG;AD6vdX;AE9ldQ;;EAEI,uCAAA;EACA,qBDlKD;ECmKC,cDnKD;ADmwdX;AE1ldQ;;EACI,uCAAA;EACA,cD3KD;ADwwdX;AE3ldY;;;;EAGI,uCAAA;EACA,cDjLL;AD+wdX;AE1ldQ;;;;EAEI,uCAAA;AF8ldZ;AE5ldY;;;;;;;;;;EAGI,uCAAA;EACA,cD7LL;ADkydX;AE/ldgB;;;EAEI,uCAAA;EACA,cDtMT;ADwydX;AE7ldQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cD/MD;ADgzdX;AE7ldY;;;;EAEI,uCAAA;EACA,cDtNL;ADuzdX;A8Gp0dI;EACI,yB7GiGQ;E6GhGR,c7GWG;AD2zdX;A8Gn0dI;EACE,+BAAA;A9Gq0dN;AEv0dG;EACI,+BA+H+B;E8FlIpC,U9FIsB;E8FDtB,0BAAA;AhG20dF;AEx0dG;EACI,+BA2H+B;E8FlIpC,U9FQsB;E8FLtB,0BAAA;AhGg1dF;AEz0dG;EACI,+BAuH+B;E8FlIpC,U9FYsB;E8FTtB,0BAAA;AhGq1dF;AE10dG;EACI,+BAmH+B;E8FlIpC,U9FgBsB;E8FbtB,0BAAA;AhG01dF;AEztdI;EACI,sCDxEqB;ECyErB,cD3HG;ADs1dX;AEztdQ;EACI,qBD9HD;EC+HC,6BDpHiB;ECqHjB,cDhID;AD21dX;AErtdQ;;EACI,cDvID;AD+1dX;AEntdQ;EACI,6BDlIiB;ADu1d7B;AEjtdI;EACE,eAAA;AFmtdN;AEhtdI;;EAEI,uCAAA;EACA,sCDtGqB;ECuGrB,cDzJG;AD22dX;AE5sdQ;;EAEI,uCAAA;EACA,qBDlKD;ECmKC,cDnKD;ADi3dX;AExsdQ;;EACI,uCAAA;EACA,cD3KD;ADs3dX;AEzsdY;;;;EAGI,uCAAA;EACA,cDjLL;AD63dX;AExsdQ;;;;EAEI,uCAAA;AF4sdZ;AE1sdY;;;;;;;;;;EAGI,uCAAA;EACA,cD7LL;ADg5dX;AE7sdgB;;;EAEI,uCAAA;EACA,cDtMT;ADs5dX;AE3sdQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cD/MD;AD85dX;AE3sdY;;;;EAEI,uCAAA;EACA,cDtNL;ADq6dX;A8Gl7dI;EACI,yB7GsGQ;E6GrGR,c7GWG;ADy6dX;A8Gj7dI;EACE,+BAAA;A9Gm7dN;AEr7dG;EACI,+BA+H+B;E8FlIpC,U9FIsB;E8FDtB,0BAAA;AhGy7dF;AEt7dG;EACI,+BA2H+B;E8FlIpC,U9FQsB;E8FLtB,0BAAA;AhG87dF;AEv7dG;EACI,+BAuH+B;E8FlIpC,U9FYsB;E8FTtB,0BAAA;AhGm8dF;AEx7dG;EACI,+BAmH+B;E8FlIpC,U9FgBsB;E8FbtB,0BAAA;AhGw8dF;AEv0dI;EACI,sCDxEqB;ECyErB,cD3HG;ADo8dX;AEv0dQ;EACI,qBD9HD;EC+HC,6BDpHiB;ECqHjB,cDhID;ADy8dX;AEn0dQ;;EACI,cDvID;AD68dX;AEj0dQ;EACI,6BDlIiB;ADq8d7B;AE/zdI;EACE,eAAA;AFi0dN;AE9zdI;;EAEI,uCAAA;EACA,sCDtGqB;ECuGrB,cDzJG;ADy9dX;AE1zdQ;;EAEI,uCAAA;EACA,qBDlKD;ECmKC,cDnKD;AD+9dX;AEtzdQ;;EACI,uCAAA;EACA,cD3KD;ADo+dX;AEvzdY;;;;EAGI,uCAAA;EACA,cDjLL;AD2+dX;AEtzdQ;;;;EAEI,uCAAA;AF0zdZ;AExzdY;;;;;;;;;;EAGI,uCAAA;EACA,cD7LL;AD8/dX;AE3zdgB;;;EAEI,uCAAA;EACA,cDtMT;ADogeX;AEzzdQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cD/MD;AD4geX;AEzzdY;;;;EAEI,uCAAA;EACA,cDtNL;ADmheX;A8GhieI;EACI,yB7GqGQ;E6GpGR,c7GWG;ADuheX;A8G/heI;EACE,+BAAA;A9GiieN;AEnieG;EACI,+BA+H+B;E8FlIpC,U9FIsB;E8FDtB,0BAAA;AhGuieF;AEpieG;EACI,+BA2H+B;E8FlIpC,U9FQsB;E8FLtB,0BAAA;AhG4ieF;AErieG;EACI,+BAuH+B;E8FlIpC,U9FYsB;E8FTtB,0BAAA;AhGijeF;AEtieG;EACI,+BAmH+B;E8FlIpC,U9FgBsB;E8FbtB,0BAAA;AhGsjeF;AEr7dI;EACI,sCDxEqB;ECyErB,cD3HG;ADkjeX;AEr7dQ;EACI,qBD9HD;EC+HC,6BDpHiB;ECqHjB,cDhID;ADujeX;AEj7dQ;;EACI,cDvID;AD2jeX;AE/6dQ;EACI,6BDlIiB;ADmje7B;AE76dI;EACE,eAAA;AF+6dN;AE56dI;;EAEI,uCAAA;EACA,sCDtGqB;ECuGrB,cDzJG;ADukeX;AEx6dQ;;EAEI,uCAAA;EACA,qBDlKD;ECmKC,cDnKD;AD6keX;AEp6dQ;;EACI,uCAAA;EACA,cD3KD;ADkleX;AEr6dY;;;;EAGI,uCAAA;EACA,cDjLL;ADyleX;AEp6dQ;;;;EAEI,uCAAA;AFw6dZ;AEt6dY;;;;;;;;;;EAGI,uCAAA;EACA,cD7LL;AD4meX;AEz6dgB;;;EAEI,uCAAA;EACA,cDtMT;ADkneX;AEv6dQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cD/MD;AD0neX;AEv6dY;;;;EAEI,uCAAA;EACA,cDtNL;ADioeX;A8G9oeI;EACI,yB7GmGQ;E6GlGR,c7GWG;ADqoeX;A8G7oeI;EACE,+BAAA;A9G+oeN;AEjpeG;EACI,+BA+H+B;E8FlIpC,U9FIsB;E8FDtB,0BAAA;AhGqpeF;AElpeG;EACI,+BA2H+B;E8FlIpC,U9FQsB;E8FLtB,0BAAA;AhG0peF;AEnpeG;EACI,+BAuH+B;E8FlIpC,U9FYsB;E8FTtB,0BAAA;AhG+peF;AEppeG;EACI,+BAmH+B;E8FlIpC,U9FgBsB;E8FbtB,0BAAA;AhGoqeF;AEnieI;EACI,sCDxEqB;ECyErB,cD3HG;ADgqeX;AEnieQ;EACI,qBD9HD;EC+HC,6BDpHiB;ECqHjB,cDhID;ADqqeX;AE/heQ;;EACI,cDvID;ADyqeX;AE7heQ;EACI,6BDlIiB;ADiqe7B;AE3heI;EACE,eAAA;AF6heN;AE1heI;;EAEI,uCAAA;EACA,sCDtGqB;ECuGrB,cDzJG;ADqreX;AEtheQ;;EAEI,uCAAA;EACA,qBDlKD;ECmKC,cDnKD;AD2reX;AElheQ;;EACI,uCAAA;EACA,cD3KD;ADgseX;AEnheY;;;;EAGI,uCAAA;EACA,cDjLL;ADuseX;AElheQ;;;;EAEI,uCAAA;AFsheZ;AEpheY;;;;;;;;;;EAGI,uCAAA;EACA,cD7LL;AD0teX;AEvhegB;;;EAEI,uCAAA;EACA,cDtMT;ADgueX;AErheQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cD/MD;ADwueX;AErheY;;;;EAEI,uCAAA;EACA,cDtNL;AD+ueX;A8G5veI;EACI,yB7GoGQ;E6GnGR,c7GWG;ADmveX;A8G3veI;EACE,+BAAA;A9G6veN;AE/veG;EACI,+BA+H+B;E8FlIpC,U9FIsB;E8FDtB,0BAAA;AhGmweF;AEhweG;EACI,+BA2H+B;E8FlIpC,U9FQsB;E8FLtB,0BAAA;AhGwweF;AEjweG;EACI,+BAuH+B;E8FlIpC,U9FYsB;E8FTtB,0BAAA;AhG6weF;AElweG;EACI,+BAmH+B;E8FlIpC,U9FgBsB;E8FbtB,0BAAA;AhGkxeF;AEjpeI;EACI,sCDxEqB;ECyErB,cD3HG;AD8weX;AEjpeQ;EACI,qBD9HD;EC+HC,6BDpHiB;ECqHjB,cDhID;ADmxeX;AE7oeQ;;EACI,cDvID;ADuxeX;AE3oeQ;EACI,6BDlIiB;AD+we7B;AEzoeI;EACE,eAAA;AF2oeN;AExoeI;;EAEI,uCAAA;EACA,sCDtGqB;ECuGrB,cDzJG;ADmyeX;AEpoeQ;;EAEI,uCAAA;EACA,qBDlKD;ECmKC,cDnKD;ADyyeX;AEhoeQ;;EACI,uCAAA;EACA,cD3KD;AD8yeX;AEjoeY;;;;EAGI,uCAAA;EACA,cDjLL;ADqzeX;AEhoeQ;;;;EAEI,uCAAA;AFooeZ;AEloeY;;;;;;;;;;EAGI,uCAAA;EACA,cD7LL;ADw0eX;AEroegB;;;EAEI,uCAAA;EACA,cDtMT;AD80eX;AEnoeQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cD/MD;ADs1eX;AEnoeY;;;;EAEI,uCAAA;EACA,cDtNL;AD61eX;A6GpreI;EACI,c5GhFQ;E4GiFR,iBAAA;A7GsreR;A6GpreQ;EAEI,UAAA;A7GqreZ;A6GhreM;EACE,gEAAA;EACA,+BAAA;A7GkreR;A6GhreU;EACE,+BAAA;A7GkreZ;A6G9qeU;EACE,+BAAA;A7GgreZ;A6G5qeM;EACE,c5GnMG;ADi3eX;;A6GxqeE;EACE,iBAAA;EACA,gBAAA;A7G2qeJ;A6G1qeI;EACE,YAAA;EACA,eAAA;EACA,gBAAA;A7G4qeN;A6G1qeI;EACE,eAAA;EACA,c5GzFuB;ADqwe7B;A6GxqeI;EACE,aAAA;A7G0qeN;A6GtqeE;EACE,c5GhNyB;E4GiNzB,oBAAA;A7GwqeJ;A6GrqeE;EACE,6BAAA;EACA,qBAAA;A7GuqeJ;;AiB/0eI;E4F+KA;IACE,0BAAA;E7GoqeJ;E6GlqeI;IACE,yBAAA;E7GoqeN;AACF;A+Gj6eA;EACI,c9GoBO;AD+4eX;A+Gj6eI;EACI,cAAA;A/Gm6eR;;A+G35eI;EACG,qBAAA;EACC,c9GksB4B;E8GjsB5B,gBAAA;EACA,yB9GFG;E8GGH,0B9G0VsB;ADoke9B;A+G55eQ;EACC,c9G6rB2B;ADiudpC;A+G15eI;;EAEI,c9GwrB4B;E8GvrB5B,yB9GwrB4B;ADoudpC;;AiB92eI;E8FtCI;IACI,gBAAA;E/Gw5eV;AACF;A+Gj5eI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;A/Gm5eR;A+G/4eQ;EACI,eAAA;A/Gi5eZ;;A+G34eA;EACI,eAAA;EnGnCA,iCAAA;EACA,kCAAA;AZk7eJ;A+G74eI;EnGtCA,yBAAA;EACA,0BAAA;EAaA,qCAAA;EACA,oCAAA;AZ06eJ;;AiB34eI;E8FAF;IACE,qBAAA;IACA,WAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;E/G+4eF;E+G74eE;IACI,kBAAA;E/G+4eN;AACF;AgHj+eA;EACE,WAAA;EACA,aAAA;EACA,mB/GouBkC;AD+vdpC;AgHj+eE;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AhHm+eJ;AgHl+eM;EACE,WAAA;AhHo+eR;AgHh+eE;EACE,aAAA;EACA,mBAAA;AhHk+eJ;AgH/9eE;EACE,c/GTO;AD0+eX;AgH99eE;EACE,oBAAA;AhHg+eJ;AgH79eE;EACE,kBAAA;EACA,aAAA;AhH+9eJ;AgH39eE;EACE,kCAAA;AhH69eJ;AgHv9eQ;EACE,c/G6DM;AD45ehB;AgHr9eM;EACE,iCAAA;EACA,kBAAA;AhHu9eR;AgHp9eM;EACE,yBAAA;AhHs9eR;AgHr9eQ;EACE,c/GiDM;ADs6ehB;AgHj9eI;EACE,c/G0CU;ADy6ehB;AgHh9eI;EACE,yBAAA;AhHk9eN;AgH/8eI;EACE,yBAAA;AhHi9eN;AgH58eE;EACE,8BAAA;AhH88eJ;AgH38eE;EACE,oCAAA;AhH68eJ;AgH18eE;EACE,oCAAA;AhH48eJ;AgHz8eE;EACE,oCAAA;AhH28eJ;AgHx8eE;EACE,oCAAA;AhH08eJ;AgHv8eE;EACE,oCAAA;AhHy8eJ;AgHt8eE;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,c/G1FO;E+G2FP,iBAAA;EACA,yBAAA;EACA,e/GuS2B;ADiqe/B;AgHr8eE;EACE,aAAA;AhHu8eJ;;AgHl8eA;EACC,eAAA;EACC,iBAAA;EACA,gBAAA;EACD,qBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;AhHq8eD;AgHn8eE;EACC,eAAA;AhHq8eH;;AgHh8eA;EACE,mB/G7Bc;E+G8Bf,c/GxHU;E+GyHV,uB/G0M6B;E+GzM7B,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACC,SAAA;EACA,WAAA;EACD,yBAAA;AhHm8eD;;AgHh8eA;EACE,eAAA;AhHm8eF;AgHl8eE;EACE,c/GxIO;AD4kfX;AgHl8eE;EACE,sBAAA;EACA,eAAA;AhHo8eJ;;AiBrhfI;E+FsFF;IACE,UAAA;EhHm8eF;EgH/7eI;IACI,mBAAA;IACA,kBAAA;EhHi8eR;EgH77eM;IACE,SAAA;IACA,eAAA;EhH+7eR;EgHz7eM;IACE,iBAAA;IACA,aAAA;EhH27eR;EgHz7eQ;IACE,kBAAA;EhH27eV;EgHx7eQ;IACE,SAAA;IACA,yBAAA;IACA,gBAAA;EhH07eV;EgHx7eU;IAKE,yBAAA;EhHs7eZ;EgHh7eU;IACE,UAAA;IACA,gBAAA;IACA,iBAAA;EhHk7eZ;EgHh7eU;IACE,qBAAA;IACA,yBAAA;IACA,gBAAA;EhHk7eZ;EgH96eQ;IACE,eAAA;EhHg7eV;EgH96eQ;IACE,aAAA;EhHg7eV;EgH/6eU;IACE,iBAAA;EhHi7eZ;EgH96eY;IACE,aAAA;IACA,kBAAA;EhHg7ed;EgH16eI;IACI,cAAA;EhH46eR;EgHx6eI;IACI,aAAA;EhH06eR;EgHz6eQ;IACE,c/GtII;EDijfd;EgHv6eI;;IAEI,6BAAA;IACA,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;EhHy6eR;EgHv6eQ;;IACI,aAAA;EhH06eZ;EgHt6eI;;IAEI,c/GxPC;EDgqfT;EgHr6eI;IAEI,c/GzKM;ED+kfd;EgHn6eI;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mB/GtQC;ED2qfT;EgHn6eQ;IACE,WAAA;IACA,UAAA;IACA,kBAAA;IACA,kBAAA;EhHq6eV;EgHl6eQ;IACI,eAAA;EhHo6eZ;EgHj6eQ;IACI,eAAA;EhHm6eZ;EgHh6eQ;IACI,WAAA;IACA,6BAAA;EhHk6eZ;EgH95eI;IACI,yB/G1MM;ED0mfd;EgH75eI;IACI,WAAA;EhH+5eR;EgH35eA;;;IAGE,8BAAA;EhH65eF;EgH35eA;IACE,QAAA;IlBpRC,+BAAA;IAGA,6BAAA;E9ForfH;EgHh6eA;IACE,UAAA;EhHk6eF;EgHh6eA;IACE,WAAA;IlB3RC,kCAAA;IAGA,6BAAA;E9FgsfH;EgHr6eA;IACE,QAAA;IlB/RC,4BAAA;IAGA,6BAAA;E9FysfH;EgH16eA;IACE,UAAA;EhH46eF;EgH16eA;IACE,WAAA;IlBtSC,+BAAA;IAGA,6BAAA;E9FqtfH;E8F5pfE;IACE;MAAI,QAAA;MAAU,uBAAA;I9FgqfhB;I8F/pfE;MAAK,QAAA;MAAU,yBAAA;I9FmqfjB;I8FlqfE;MAAK,yBAAA;I9FqqfP;I8FpqfE;MAAM,yBAAA;I9FuqfR;EACF;E8FvpfE;IACE;MAAK,QAAA;MAAU,yBAAA;I9F2rfjB;I8F1rfE;MAAM,yBAAA;I9F6rfR;I8F5rfE;MAAM,uBAAA;I9F+rfR;I8F9rfE;MAAO,QAAA;MAAU,oBAAA;I9FksfnB;EACF;E8FhrfE;IACE;MAAI,WAAA;MAAa,uBAAA;I9FotfnB;I8FntfE;MAAK,WAAA;MAAa,0BAAA;I9FutfpB;I8FttfE;MAAK,0BAAA;I9FytfP;I8FxtfE;MAAM,0BAAA;I9F2tfR;EACF;E8F3sfE;IACE;MAAK,WAAA;MAAY,0BAAA;I9F+ufnB;I8F9ufE;MAAM,wBAAA;I9FivfR;I8FhvfE;MAAM,wBAAA;I9FmvfR;I8FlvfE;MAAO,WAAA;MAAY,oBAAA;I9FsvfrB;EACF;EgHjkfA;IACE;MAAI,UAAA;IhHonfJ;IgHnnfA;MAAM,UAAA;IhHsnfN;EACF;EgHlnfQ;;IAEI,YAAA;EhHonfZ;AACF;AiB/5fI;E+FkTF;IACI,2BAAA;EhHgnfJ;EgH7mfA;IACI,aAAA;EhH+mfJ;EgHzmfQ;IACI,UAAA;IACA,kBAAA;EhH2mfZ;EgHrmfE;IACE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,cAAA;EhHumfJ;EgHnmfA;IACE,qB/GkE0B;I+GjE1B,oB/GiE0B;EDoif5B;AACF;AiBx6fI;E+FwUF;IACE,cAAA;IACA,eAAA;EhHmmfF;AACF;AiB/5fI;E+FiUF;;;IAGE,8BAAA;EhHimfF;EgH/lfA;IACE,QAAA;IlBzXC,+BAAA;IAGA,6BAAA;E9F69fH;EgHpmfA;IACE,UAAA;EhHsmfF;EgHpmfA;IACE,WAAA;IlBhYC,kCAAA;IAGA,6BAAA;E9Fy+fH;EgHzmfA;IACE,QAAA;IlBpYC,4BAAA;IAGA,6BAAA;E9Fk/fH;EgH9mfA;IACE,UAAA;EhHgnfF;EgH9mfA;IACE,WAAA;IlB3YC,+BAAA;IAGA,6BAAA;E9F8/fH;E8Fr8fE;IACE;MAAI,QAAA;MAAU,uBAAA;I9Fy8fhB;I8Fx8fE;MAAK,QAAA;MAAU,yBAAA;I9F48fjB;I8F38fE;MAAK,yBAAA;I9F88fP;I8F78fE;MAAM,yBAAA;I9Fg9fR;EACF;E8Fh8fE;IACE;MAAK,QAAA;MAAU,yBAAA;I9Fo+fjB;I8Fn+fE;MAAM,yBAAA;I9Fs+fR;I8Fr+fE;MAAM,uBAAA;I9Fw+fR;I8Fv+fE;MAAO,QAAA;MAAU,oBAAA;I9F2+fnB;EACF;E8Fz9fE;IACE;MAAI,WAAA;MAAa,uBAAA;I9F6/fnB;I8F5/fE;MAAK,WAAA;MAAa,0BAAA;I9FgggBpB;I8F//fE;MAAK,0BAAA;I9FkggBP;I8FjggBE;MAAM,0BAAA;I9FoggBR;EACF;E8Fp/fE;IACE;MAAK,WAAA;MAAY,0BAAA;I9FwhgBnB;I8FvhgBE;MAAM,wBAAA;I9F0hgBR;I8FzhgBE;MAAM,wBAAA;I9F4hgBR;I8F3hgBE;MAAO,WAAA;MAAY,oBAAA;I9F+hgBrB;EACF;EgHrwfA;IACE;MAAI,UAAA;IhHwzfJ;IgHvzfA;MAAM,UAAA;IhH0zfN;EACF;EgHxzfA;IACE,WAAA;IACA,6BAAA;EhH0zfF;EgHvzfA;IACE,cAAA;IACA,6BAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mB/GpcO;ED6vgBT;EgHvzfA;IACE,eAAA;EhHyzfF;EgHtzfA;IACE,cAAA;EhHwzfF;EgHrzfA;IACE,aAAA;EhHuzfF;AACF;AiHpxgBI;EACE,SAAA;EACA,8BAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;AjHsxgBN;AiHpxgBM;EAEI,0CAAA;EACA,chHHC;EgHID,YAAA;EACA,gBAAA;AjHqxgBV;AiHjxgBI;;EAEI,kBAAA;AjHmxgBR;AiHhxgBI;EACI,QAAA;AjHkxgBR;AiH/wgBI;EACI,OAAA;AjHixgBR;AiH9wgBI;EACI,chHvBG;EgHwBH,6ChHyTmB;ADu9f3B;AiH9wgBQ;EnBdN,mB7FyEc;E6FrEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EmBaU,chH/BD;ADkzgBX;AiH/wgBI;EACI,YAAA;AjHixgBR;AiH3wgBY;EnB9BV,mB7F4Ec;E6FxEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9F4ygBF;AiH1wgBY;EnBxCV,mB7F2Ec;E6FvEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9FqzgBF;AiHzwgBY;EnBlDV,mB7FyEc;E6FrEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9F8zgBF;AiHvwgBY;EnB7DV,mB7F6Ec;E6FzEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fu0gBF;AiHrwgBY;EnBxEV,mB7F8Ec;E6F1Ed,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fg1gBF;AiHpwgBQ;EACI,chH/FD;ADq2gBX;AiHpwgBY;EAEI,0ChH1Ca;EgH2Cb,chHpGL;ADy2gBX;AiHhwgBY;EAGI,yBhH5GL;EgH6GK,qBhH7GL;EgH8GK,chHzBA;ADyxgBhB;;AiBnzgBI;EgG4DA;;;;IAIG,wBAAA;EjH2vgBL;AACF;AkHn4gBA;EACI,SAAA;EACA,sBAAA;AlHq4gBJ;AkHl4gBQ;EACI,cjHMD;EiHLC,SAAA;EACA,iBAAA;EACA,6BjHciB;EiHbjB,mBAAA;EACA,kBAAA;EACA,gBjHyCkB;AD21gB9B;AkHl4gBY;EACI,6BjHQa;EiHPb,yBAAA;EACA,+BAAA;AlHo4gBhB;AkHj4gBY;EACI,yBAAA;EACA,mBAAA;AlHm4gBhB;AkHh4gBY;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AlHk4gBhB;AkH93gBQ;EAEI,+BAAA;AlH+3gBZ;AkHz3gBY;EACI,cjH9BL;ADy5gBX;AkHz3gBgB;EACI,sCjHiBS;EiHhBT,cjHlCT;AD65gBX;AkHl3gBgB;EACI,qBjHyCJ;EiHxCI,cjHwCJ;AD40gBhB;AkH32gBgB;EACI,qBjHiCJ;EiHhCI,cjHgCJ;AD60gBhB;AkHp2gBgB;EACI,qBjHwBJ;EiHvBI,cjHuBJ;AD+0gBhB;AkH71gBgB;EACI,qBjHYJ;EiHXI,cjHWJ;ADo1gBhB;AkHt1gBgB;EACI,qBjHDJ;EiHEI,cjHFJ;AD01gBhB;;AmH77gBE;EACE,mBAAA;AnHg8gBJ;AmH77gBE;EACE,kBAAA;EACA,kBAAA;AnH+7gBJ;AmH57gBE;EACE,mBlHiiB0B;AD65f9B;AmH37gBE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;AnH67gBJ;AmH37gBI;EACE,eAAA;EACA,iBAAA;AnH67gBN;AmHx7gBQ;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBlH2WkB;EkH1WlB,+BAAA;EACA,yBAAA;AnH07gBZ;AmHv7gBY;EACI,yBAAA;AnHy7gBhB;AmHr7gBgB;EAGI,yBlHoFS;EkHnFT,clHnCT;EkHoCS,0CAAA;AnHq7gBpB;AmHj7gBY;EAGI,YAAA;AnHi7gBhB;AmH76gBQ;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AnH+6gBZ;AmHz6gBY;EACI,0CAAA;EACA,clH1DL;ADq+gBX;AmHx6gBoB;EAGI,yBlHhEb;EkHiEa,clHoBR;ADo5gBhB;AmH95gBgB;ErB/Dd,mB7FyEc;E6FrEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fg+gBF;AmH35gBgB;ErB3Ed,mB7F4Ec;E6FxEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fy+gBF;AmHx5gBgB;ErBvFd,mB7F2Ec;E6FvEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fk/gBF;AmHr5gBgB;ErBnGd,mB7F6Ec;E6FzEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9F2/gBF;AmHl5gBgB;ErB/Gd,mB7F8Ec;E6F1Ed,4EAAA;EACA,0BAAA;EACA,8BAAA;A9FoghBF;;AmHl5gBA;EACI,wBAAA;AnHq5gBJ;;AmHj5gBI;EACI,gBAAA;EACA,6BlHhIqB;EkHiIrB,kBAAA;EACA,mBAAA;AnHo5gBR;AmHl5gBI;EACE,+BAAA;AnHo5gBN;;AmHh5gBA;EACI,kBAAA;AnHm5gBJ;AmHj5gBI;EACI,oBAAA;AnHm5gBR;;AoHzjhBA;EACE,SAAA;ApH4jhBF;;AoHzjhBA;EACC,gBnH0Y6B;ADkrgB9B;;AoHvjhBI;ECTF,yB/G2Ea;ANy/gBf;AqHlkhBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArHokhBJ;AqHjkhBE;EACE,cAAA;ArHmkhBJ;AqHhkhBE;EACE,sCAAA;ArHkkhBJ;AqH9jhBI;EACE,yB/GyDS;ANughBf;AqH3jhBI;EACE,2B/GmDS;AN0ghBf;AqHxjhBI;EACE,4B/G6CS;AN6ghBf;AqHrjhBI;EACE,0B/GuCS;ANghhBf;;AoHllhBI;ECTF,yB/G2Ea;ANohhBf;AqH7lhBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArH+lhBJ;AqH5lhBE;EACE,cAAA;ArH8lhBJ;AqH3lhBE;EACE,mCAAA;ArH6lhBJ;AqHzlhBI;EACE,yB/GyDS;ANkihBf;AqHtlhBI;EACE,2B/GmDS;ANqihBf;AqHnlhBI;EACE,4B/G6CS;ANwihBf;AqHhlhBI;EACE,0B/GuCS;AN2ihBf;;AoH7mhBI;ECTF,yB/G2Ea;AN+ihBf;AqHxnhBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArH0nhBJ;AqHvnhBE;EACE,cAAA;ArHynhBJ;AqHtnhBE;EACE,sCAAA;ArHwnhBJ;AqHpnhBI;EACE,yB/GyDS;AN6jhBf;AqHjnhBI;EACE,2B/GmDS;ANgkhBf;AqH9mhBI;EACE,4B/G6CS;ANmkhBf;AqH3mhBI;EACE,0B/GuCS;ANskhBf;;AoHxohBI;ECTF,yB/G2Ea;AN0khBf;AqHnphBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArHqphBJ;AqHlphBE;EACE,cAAA;ArHophBJ;AqHjphBE;EACE,sCAAA;ArHmphBJ;AqH/ohBI;EACE,yB/GyDS;ANwlhBf;AqH5ohBI;EACE,2B/GmDS;AN2lhBf;AqHzohBI;EACE,4B/G6CS;AN8lhBf;AqHtohBI;EACE,0B/GuCS;ANimhBf;;AoHnqhBI;ECTF,yB/G2Ea;ANqmhBf;AqH9qhBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArHgrhBJ;AqH7qhBE;EACE,cAAA;ArH+qhBJ;AqH5qhBE;EACE,sCAAA;ArH8qhBJ;AqH1qhBI;EACE,yB/GyDS;ANmnhBf;AqHvqhBI;EACE,2B/GmDS;ANsnhBf;AqHpqhBI;EACE,4B/G6CS;ANynhBf;AqHjqhBI;EACE,0B/GuCS;AN4nhBf;;AoH9rhBI;ECTF,yB/G2Ea;ANgohBf;AqHzshBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArH2shBJ;AqHxshBE;EACE,cAAA;ArH0shBJ;AqHvshBE;EACE,sCAAA;ArHyshBJ;AqHrshBI;EACE,yB/GyDS;AN8ohBf;AqHlshBI;EACE,2B/GmDS;ANiphBf;AqH/rhBI;EACE,4B/G6CS;ANophBf;AqH5rhBI;EACE,0B/GuCS;ANuphBf;;AoHzthBI;ECTF,yB/G2Ea;AN2phBf;AqHpuhBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArHsuhBJ;AqHnuhBE;EACE,cAAA;ArHquhBJ;AqHluhBE;EACE,sCAAA;ArHouhBJ;AqHhuhBI;EACE,yB/GyDS;ANyqhBf;AqH7thBI;EACE,2B/GmDS;AN4qhBf;AqH1thBI;EACE,4B/G6CS;AN+qhBf;AqHvthBI;EACE,0B/GuCS;ANkrhBf;;AoHpvhBI;ECTF,yB/G2Ea;ANsrhBf;AqH/vhBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArHiwhBJ;AqH9vhBE;EACE,cAAA;ArHgwhBJ;AqH7vhBE;EACE,sCAAA;ArH+vhBJ;AqH3vhBI;EACE,yB/GyDS;ANoshBf;AqHxvhBI;EACE,2B/GmDS;ANushBf;AqHrvhBI;EACE,4B/G6CS;AN0shBf;AqHlvhBI;EACE,0B/GuCS;AN6shBf;;AoH/whBI;ECTF,yB/G2Ea;ANithBf;AqH1xhBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArH4xhBJ;AqHzxhBE;EACE,cAAA;ArH2xhBJ;AqHxxhBE;EACE,sCAAA;ArH0xhBJ;AqHtxhBI;EACE,yB/GyDS;AN+thBf;AqHnxhBI;EACE,2B/GmDS;ANkuhBf;AqHhxhBI;EACE,4B/G6CS;ANquhBf;AqH7whBI;EACE,0B/GuCS;ANwuhBf;;AoH1yhBI;ECTF,yB/G2Ea;AN4uhBf;AqHrzhBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArHuzhBJ;AqHpzhBE;EACE,cAAA;ArHszhBJ;AqHnzhBE;EACE,mCAAA;ArHqzhBJ;AqHjzhBI;EACE,yB/GyDS;AN0vhBf;AqH9yhBI;EACE,2B/GmDS;AN6vhBf;AqH3yhBI;EACE,4B/G6CS;ANgwhBf;AqHxyhBI;EACE,0B/GuCS;ANmwhBf;;AoHr0hBI;ECTF,yB/G2Ea;ANuwhBf;AqHh1hBE;EACE,yB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArHk1hBJ;AqH/0hBE;EACE,cAAA;ArHi1hBJ;AqH90hBE;EACE,mCAAA;ArHg1hBJ;AqH50hBI;EACE,yB/GyDS;ANqxhBf;AqHz0hBI;EACE,2B/GmDS;ANwxhBf;AqHt0hBI;EACE,4B/G6CS;AN2xhBf;AqHn0hBI;EACE,0B/GuCS;AN8xhBf;;AoHh2hBI;ECTF,uB/G2Ea;ANkyhBf;AqH32hBE;EACE,uB/GwEW;E+GvEX,cAAA;EACA,YAAA;ArH62hBJ;AqH12hBE;EACE,cAAA;ArH42hBJ;AqHz2hBE;EACE,sCAAA;ArH22hBJ;AqHv2hBI;EACE,uB/GyDS;ANgzhBf;AqHp2hBI;EACE,yB/GmDS;ANmzhBf;AqHj2hBI;EACE,0B/G6CS;ANszhBf;AqH91hBI;EACE,wB/GuCS;ANyzhBf;;AsHp4hBA;EACI,kBAAA;AtHu4hBJ;AsHr4hBI;EACE,gBAAA;AtHu4hBN;AsHp4hBQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,crHEC;EqHDD,qBrHuXoB;AD+ghB9B;AsHj4hBI;EAEI,gBrHmSuB;AD+lhB/B;AsHh4hBI;EACI,crHTG;EqHUH,0BrH2WsB;EqH1WtB,yBAAA;AtHk4hBR;AsHh4hBQ;EACE,kBAAA;AtHk4hBV;AsH73hBI;EACE,mBAAA;EACA,8CAAA;AtH+3hBN;AsH73hBQ;EACE,uBrH2SoB;EqH1SpB,gBAAA;EACA,mBrH0DM;ADq0hBhB;AsH73hBU;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,crHhCD;EqHiCC,qBrHqVkB;AD0ihB9B;AsH33hBQ;EACE,WAAA;AtH63hBV;AsHx3hBQ;EACI,oCAAA;AtH03hBZ;AsHv3hBQ;EACI,mBrHhDD;ADy6hBX;AsHp3hBM;ExBzCJ,mB7FqFqB;E6FjFrB,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fg6hBF;AsHv3hBM;ExB/CJ,mB7FuFqB;E6FnFrB,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fy6hBF;AsH13hBM;ExBrDJ,mB7FsFqB;E6FlFrB,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fk7hBF;AsH73hBM;ExB3DJ,mB7FwFqB;E6FpFrB,4EAAA;EACA,0BAAA;EACA,8BAAA;A9F27hBF;AsHh4hBM;ExBjEJ,mB7FyFqB;E6FrFrB,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fo8hBF;;AsHl4hBE;;EAEE,gBAAA;AtHq4hBJ;;AuHz+hBA;;EAEE,gBtHwZ4B;ADolhB9B;;AuHx+hBA;;;;;EAKI,kCtHgX0B;AD2nhB9B;;AuHx+hBE;EACE,+BtHmDyB;ADw7hB7B;;AuHx+hBA;EACI,gBtH2X0B;EsH1X1B,+BtH8CyB;AD67hB7B;;AuHx+hBA;EACI,ctHuFmB;EsHtFnB,gBtHoX0B;ADunhB9B;AuH1+hBI;EAEI,ctHuEQ;ADo6hBhB;;AuHx+hBA;EACI,iBAAA;EACA,mBAAA;AvH2+hBJ;AuHz+hBI;EACI,gBtH2WsB;EsH1WtB,yBAAA;EACA,YAAA;AvH2+hBR;;AuHv+hBA;EACI,mBAAA;EACA,gBAAA;AvH0+hBJ;;AuHv+hBA;EACI,mBAAA;EACA,kBAAA;AvH0+hBJ;;AuHx+hBA;EACI,mBAAA;EACA,mBtHkQ2B;ADyuhB/B;AuHz+hBI;EAEI,iBAAA;AvH0+hBR;;AuHv+hBA;EACI,kBAAA;EACA,mBAAA;AvH0+hBJ;;AuHx+hBA;EACI,yBAAA;EACA,gBtH6U0B;AD8phB9B;;AuHz+hBA;EACI,+BtHHyB;EsHIzB,kBAAA;AvH4+hBJ;AuH1+hBI;EACI,iBAAA;AvH4+hBR;;AuHv+hBA;EACI,gBtHgU0B;AD0qhB9B;AuHz+hBI;EACI,yBAAA;AvH2+hBR;AuHz+hBQ;EACI,ctHqBI;EsHpBJ,qBAAA;AvH2+hBZ;AuHx+hBI;EACI,iBAAA;AvH0+hBR;;AuHt+hBA;;;;EAII,ctHmCyB;EsHlCzB,gBtH2S0B;AD8rhB9B;;AuHv+hBA;;EAEI,0BAAA;EACA,gBtHuS0B;EsHtS1B,+BAAA;EACA,0BtH0R0B;ADgthB9B;;AuHv+hBA;EACI,0BtHsR0B;ADothB9B;;AuHv+hBA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,oBtH+U0B;EsH9U1B,gBAAA;AvH0+hBJ;AuHx+hBI;EACI,ctHtBQ;EsHuBR,0BtH0QsB;EsHzQtB,yBAAA;AvH0+hBR;AuHv+hBI;EACI,qBtH3BQ;EsH4BR,ctH5BQ;ADqgiBhB;AuHv+hBQ;EACI,ctH/BI;ADwgiBhB;AuHr+hBI;EACI,qBtH/BQ;EsHgCR,ctHhCQ;ADugiBhB;AuHr+hBQ;EACI,ctHnCI;AD0giBhB;AuHn+hBI;EACI,sCtH9EqB;EsH+ErB,ctHnIG;ADwmiBX;AuHn+hBQ;EACI,+BtHlFiB;ADujiB7B;;AuHh+hBA;EACE,ctH5IS;AD+miBX;;AuHh+hBA;EACE,+BtH5F2B;AD+jiB7B;;AuHh+hBA;EACE,wCAAA;EACA,gBtHsHO;EsHrHP,mBtHqHO;AD82hBT;;AwHroiBE;EACE,0CAAA;AxHwoiBJ;AwHtoiBI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AxHwoiBN;AwHtoiBM;EACE,WAAA;AxHwoiBR;AwHnoiBE;EACE,yBAAA;AxHqoiBJ;AwHloiBE;EACE,yBvH+EY;ADqjiBhB;AwHjoiBE;EACE,yBvHwEY;AD2jiBhB;AwHhoiBE;EACE,yBvHwEY;AD0jiBhB;AwHhoiBE;EACE,yBvHsEY;AD4jiBhB;AwH9niBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AxHgoiBN;AwH7niBI;EACE,eAAA;EACA,WAAA;AxH+niBN;AwH5niBI;EACI,SAAA;EACA,eAAA;AxH8niBR;AwH5niBQ;EAEI,UAAA;EACA,SAAA;AxH6niBZ;AwHzniBI;EACI,SAAA;AxH2niBR;AwHxniBI;EACE,gBAAA;AxH0niBN;AwHvniBI;EACI,gBAAA;AxHyniBR;AwHvniBQ;;;;;;EAMI,gBAAA;EACA,mBAAA;AxHyniBZ;AwHrniBG;EACI,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBvHwTuB;EuHvTvB,SAAA;EACA,+BAAA;AxHuniBP;AwHpniBG;;EAEI,aAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AxHsniBP;AwHpniBO;;EACI,kBAAA;AxHuniBX;AwHnniBY;;;EAEI,UAAA;EACA,UAAA;AxHsniBhB;AwHlniBG;;;;;;EAMI,sCAAA;EACA,iBAAA;EACA,sBAAA;AxHoniBP;AwHjniBG;EACG,YAAA;AxHmniBN;AwHhniBG;EACI,gBAAA;AxHkniBP;AwHhniBG;EACI,eAAA;EACA,gBvHyQuB;EuHxQvB,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AxHkniBP;AwHhniBG;EACK,gBvHoQsB;EuHnQtB,yBvH8PsB;EuH7PtB,iBAAA;EACA,iBAAA;AxHkniBR;AwH/miBG;EACC,WAAA;AxHiniBJ;AwH9miBI;EACI,kBAAA;AxHgniBR;AwH7miBI;EACE,gCAAA;EACA,yBAAA;AxH+miBN;;AwHzmiBI;EACI,yBAAA;AxH4miBR;AwH1miBI;EACI,evH6OuB;AD+3hB/B;AwH1miBQ;EACI,cAAA;EACA,kBAAA;AxH4miBZ;AwHzmiBI;EACI,gBvHiOsB;EuHhOtB,gBAAA;AxH2miBR;AwH1miBQ;EACI,cvH5CiB;EuH6CjB,iBAAA;EACA,gBvH2NkB;ADi5hB9B;AwHzmiBI;EACG,gBvHuNuB;ADo5hB9B;AwHzmiBO;EACE,mBAAA;AxH2miBT;AwHxmiBI;EACI,gBAAA;AxH0miBR;AwHxmiBI;EACI,iBAAA;EACA,gBAAA;AxH0miBR;AwHxmiBQ;EACI,iBAAA;AxH0miBZ;AwHtmiBI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AxHwmiBR;AwHtmiBQ;EACI,WAAA;AxHwmiBZ;;AwHnmiBA;EAEE,oBAAA;AxHqmiBF;;AwHlmiBA;EACI,mBAAA;AxHqmiBJ;;AwHlmiBA;EACC,0DAAA;EACC,4BAAA;EACA,iCAAA;EACA,eAAA;AxHqmiBF;;AwHlmiBA;EACC,0DAAA;AxHqmiBD;;AwHnmiBA;EACC,0DAAA;AxHsmiBD;;AwH9liBE;EACE,qCAAA;AxHimiBJ;AwH9liBE;EACE,eAAA;AxHgmiBJ;;AyHr1iBA;EACC,kBAAA;EACA,eAAA;AzHw1iBD;;AyHr1iBA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAKA,6BAAA;AzHw1iBF;;AyHt1iBA;EACI,kBAAA;AzHy1iBJ;;AyHt1iBA;EACE,iBAAA;EACA,kBAAA;AzHy1iBF;;AyHt1iBA;;EAEE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,yBAAA;EAKA,+BAAA;AzHy1iBF;;AyHt1iBA;;EAEE,YAAA;EACA,yBxHkDc;ADuyiBhB;;AyHt1iBC;EACC,qBAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,cxH7CS;EwH8CT,gBxHmV4B;EwHlV5B,SAAA;EACA,yBAAA;AzHy1iBF;;AyHt1iBA;;EAEI,cxHiEyB;EwHhEzB,YAAA;EACA,mBAAA;AzHy1iBJ;;AyHt1iBA;;EAEE,UAAA;EACA,kBAAA;EACA,kBAAA;AzHy1iBF;;AyHv1iBA;EACE,UAAA;EACA,eAAA;EACA,aAAA;AzH01iBF;;AyHt1iBA;EACE,UAAA;EACA,eAAA;EACA,aAAA;AzHy1iBF;;AyHt1iBA;;EAEI,mBAAA;AzHy1iBJ;;AyHt1iBA;;EAEI,oBAAA;AzHy1iBJ;;AyHt1iBA;EACE,gBAAA;AzHy1iBF;;AyHv1iBA;;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EAKA,+BAAA;AzH01iBF;;AyHv1iBA;;EAEI,UAAA;AzH01iBJ;;AyHx1iBA;EACI,UAAA;EACA,WAAA;EACA,yBxH/BY;EwHgCZ,qBxHhCY;EwHiCZ,QAAA;EACA,SAAA;EACA,UAAA;AzH21iBJ;;AyHx1iBA;EACE,qBxHvCc;ADk4iBhB;;AyHv1iBA;EACI,UAAA;AzH01iBJ;;AyHv1iBA;EACE,cxHf2B;ADy2iB7B;;AyHv1iBA;;EAEE,cxHpB2B;AD82iB7B;;A0Hl/iBA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;A1Hq/iBJ;A0Hn/iBI;;EAEI,qBAAA;EACA,6BAAA;EACA,0BAAA;A1Hq/iBR;A0Hl/iBI;EACI,czHJG;EyHKH,aAAA;EACA,0BAAA;EACA,WAAA;A1Ho/iBR;A0Hj/iBI;EACI,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,6CAAA;A1Hm/iBR;A0Hh/iBI;EACE,QAAA;A1Hk/iBN;A0H/+iBI;;EAEI,WAAA;EACA,iBAAA;EACA,UAAA;A1Hi/iBR;A0H9+iBI;EACI,czHhCG;ADghjBX;A0H7+iBI;EACI,czHwFqB;ADu5iB7B;A0H5+iBI;;;EAGI,czH8EqB;EyH7ErB,kBAAA;A1H8+iBR;A0H3+iBI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;A1H6+iBR;A0H1+iBI;;EAEI,gBAAA;A1H4+iBR;A0Hz+iBI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;A1H2+iBR;A0Hx+iBI;;EAEI,qBzH+Be;AD28iBvB;A0Hv+iBI;EACE,SAAA;EACA,yBAAA;A1Hy+iBN;A0Hx+iBM;EACE,yBAAA;A1H0+iBR;A0Ht+iBI;EACE,mBzHnFK;AD2jjBX;A0Hv+iBM;EACE,mBzHrFG;AD8jjBX;A0Hr+iBI;EACE,mBzHCU;ADs+iBhB;A0Ht+iBM;EACE,mBzHDQ;ADy+iBhB;A0Hp+iBI;EACE,YAAA;A1Hs+iBN;A0Hn+iBI;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;A1Hq+iBR;A0Hl+iBI;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;A1Ho+iBR;A0Hj+iBI;EACI,YAAA;A1Hm+iBR;A0Hj+iBQ;EACI,kBAAA;A1Hm+iBZ;A0H/9iBI;EACI,kBAAA;EACA,eAAA;EACA,YAAA;A1Hi+iBR;A0H99iBI;EACI,czHlIG;EyHmIH,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;A1Hg+iBR;A0H39iBQ;EACI,kBAAA;A1H69iBZ;A0H39iBY;EACI,kBAAA;EACA,SAAA;A1H69iBhB;A0H19iBY;;EAEI,kBAAA;A1H49iBhB;A0Hx9iBQ;EACI,kBAAA;A1H09iBZ;A0Hx9iBY;EACE,kBAAA;EACA,WAAA;EACA,qBzHqNgB;EyHpNhB,czHlKH;AD4njBX;A0Hx9iBc;EACE,UAAA;A1H09iBhB;A0Ht9iBY;EACI,eAAA;A1Hw9iBhB;A0Hp9iBQ;EACE,kBAAA;EACA,SAAA;EACA,qBzHqMoB;EyHpMpB,czHlLC;ADwojBX;A0Hn9iBQ;EACM,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;A1Hq9iBd;A0H78iBY;EACM,ezHiMa;EyHhMb,kBAAA;EACA,mBAAA;EACA,yBzHtMP;EyHuMO,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;A1H+8iBlB;A0H78iBkB;EACG,gBAAA;A1H+8iBrB;A0H38iBY;EAEI,6BAAA;A1H48iBhB;A0Hv8iBgB;EACI,qCAAA;A1Hy8iBpB;A0Hp8iBQ;;EAEI,qBzHzGiB;EyH0GjB,yBzHtOD;AD4qjBX;A0Hj8iBI;EACI,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;A1Hm8iBR;A0H/7iBQ;EACI,iBAAA;A1Hi8iBZ;A0H97iBQ;EACI,gBAAA;A1Hg8iBZ;A0H37iBQ;EAKK,2BAAA;EACA,SAAA;EACA,UAAA;EAEA,qBAAA;A1H47iBb;A0H17iBa;EACI,2CAAA;EACA,2CAAA;EACA,wCAAA;EACA,YAAA;EACA,SAAA;A1H47iBjB;A0Hz7iBa;EACI,2CAAA;EACA,gCAAA;EACA,wCAAA;EACA,YAAA;A1H27iBjB;A0Hx7iBa;EAEI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;A1Hy7iBjB;A0Hr7iBQ;EACK,UAAA;EAMA,2BAAA;EAEA,qBAAA;A1Hq7iBb;A0Hj7iBI;EACI,SAAA;A1Hm7iBR;;AiB3qjBI;EyG6PF;IACE,UAAA;E1Hk7iBF;E0H/6iBA;IACE,YAAA;IACA,qBAAA;E1Hi7iBF;AACF;A2H9vjBA;EACE,kBAAA;EACA,MAAA;A3HgwjBF;A2H7vjBE;EACI,iBAAA;EACA,YAAA;A3H+vjBN;;A2H3vjBA;;;EAIA,iBAAA;A3H6vjBA;;A2H1vjBA;;E7B0CI,mB7FmDmB;E6F/CnB,2DAAA;E6B3CF,0BAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,sBAAA;EACA,kCAAA;EACA,cAAA;EACA,+CAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;A3HiwjBF;A2H/vjBE;;EACI,W1HstB8B;E0HrtB9B,gBAAA;EACA,+BAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;A3HkwjBN;A2HhwjBM;;EACE,wBAAA;A3HmwjBR;A2HhwjBM;;EACI,YAAA;A3HmwjBV;A2H7vjBY;;;;EACE,qBAAA;A3HkwjBd;A2H7vjBY;;;;EACE,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,+B1HHe;ADqwjB7B;A2H/vjBY;;;;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,+B1HnBe;ADuxjB7B;A2HjwjBY;;;;EACE,eAAA;EACA,iBAAA;EACA,WAAA;A3HswjBd;A2H9vjBQ;;;EACE,c1HtFC;ADw1jBX;A2H7vjBM;;EACE,UAAA;A3HgwjBR;A2H1vjBE;;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;A3H6vjBJ;A2HzvjBE;;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;A3H4vjBJ;A2H1vjBI;;EACI,WAAA;EACA,YAAA;A3H6vjBR;A2HzvjBE;;EACI,gBAAA;EACA,cAAA;A3H4vjBN;A2H1vjBM;;EACI,SAAA;EACA,kBAAA;EACA,WAAA;A3H6vjBV;A2HzvjBU;;EACE,eAAA;A3H4vjBZ;A2H3vjBa;;EACG,eAAA;EACA,gBAAA;A3H8vjBhB;A2H1vjBU;;EACI,mBAAA;EACA,mB1HiZgB;E0HhZhB,c1H/IH;E0HgJG,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EAEA,iBAAA;EACA,qB1HhHgB;AD42jB9B;A2HzvjBU;;EACI,cAAA;A3H4vjBd;A2HtvjBc;;;;;EACE,yBAAA;EACJ,2BAAA;A3H4vjBZ;A2HxvjBU;;;EAGE,yBAAA;EACA,2BAAA;A3H0vjBZ;A2HvvjBU;;EACI,uBAAA;EACA,2BAAA;A3H0vjBd;A2HxvjBc;;;EAGE,yBAAA;EACA,2BAAA;A3H0vjBhB;A2HvvjBc;;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;A3H0vjBhB;A2HrvjBU;;EACE,uBAAA;EACA,gBAAA;EACA,c1HzMD;ADi8jBX;A2HtvjBY;;EACE,c1H5MH;ADq8jBX;A2HtvjBY;;EAEE,gBAAA;A3HwvjBd;A2HvvjBc;;;;EACE,c1HnNL;E0HoNK,gB1H4Kc;ADgljB9B;A2HtvjBc;;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;A3HyvjBhB;A2HrvjBY;;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;A3HwvjBd;A2HlvjBM;;EACI,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;A3HqvjBV;A2HjvjBM;;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,+B1H/MmB;E0HgNnB,kBAAA;A3HovjBV;A2HlvjBM;;EAEE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,kBAAA;A3HmvjBR;A2HhvjBE;;EACE,sBAAA;EACA,2BAAA;A3HmvjBJ;A2HjvjBE;;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,W1Hkd8B;E0Hjd9B,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;A3HovjBN;A2HlvjBM;;EACI,kBAAA;EACA,UAAA;EACA,W1Hwc0B;E0Hvc1B,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;A3HqvjBV;A2HjvjBE;;EACI,kBAAA;EACA,2BAAA;EACA,UAAA;A3HovjBN;A2H7ujBM;;EACI,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;A3HgvjBV;A2H7ujBM;;EACI,cAAA;EACA,UAAA;E7B1UF,iCAAA;A9F+jkBR;A2HjvjBM;;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oC1H3RmB;AD+gkB7B;A2HhvjBM;;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,c1HrVC;E0HsVD,iBAAA;EACA,2DAAA;A3HmvjBV;A2HhvjBM;;EACI,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACC,mB1HiBmB;E0HfpB,qBAAA;EACA,gB1H8BoB;E0H7BpB,iBAAA;EACA,gBAAA;A3HkvjBV;A2H9ujBE;;EACI,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;A3HivjBN;A2H/ujBM;;EACI,WAAA;EACA,YAAA;A3HkvjBV;A2H/ujBE;;E7BxUE,mB7F9CO;E6FkDP,2DAAA;A9F2jkBJ;A2HpvjBI;;EACE,sBAAA;A3HuvjBN;A2HrvjBI;;EACE,sBAAA;A3HwvjBN;A2HrvjBI;;EACE,4B1H1Re;ADkhkBrB;A2HpvjBE;;E7BvVE,mB7FqDmB;E6FjDnB,2DAAA;A9F+kkBJ;A2H1vjBI;;EACE,4B1HhTU;AD6ikBhB;A2H1vjBE;;E7B7VE,mB7FoDmB;E6FhDnB,2DAAA;A9F2lkBJ;A2HhwjBI;;EACE,4B1HvTU;AD0jkBhB;A2HhwjBE;;E7BnWE,mB7FsDmB;E6FlDnB,2DAAA;A9FumkBJ;A2HtwjBI;;EACE,4B1H3TU;ADokkBhB;A2HtwjBE;;E7BzWE,mB7FuDmB;E6FnDnB,2DAAA;A9FmnkBJ;A2H5wjBI;;EACE,4B1HhUU;AD+kkBhB;A2H1wjBE;;EACI,oBAAA;EACA,mBAAA;EACA,kBAAA;A3H6wjBN;A2H3wjBM;;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oC1HzXmB;ADuokB7B;A2H3wjBM;;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gD1HvGiB;ADq3jB3B;A2H3wjBU;;EACI,W1HiTsB;AD69iBpC;A2H1wjBM;;EACI,c1HhcC;E0HicD,qBAAA;EACA,oBAAA;EACA,mBAAA;A3H6wjBV;A2HxwjBU;;EACG,cAAA;EACA,iBAAA;A3H2wjBb;A2HzwjBc;;EAEG,cAAA;EACA,kBAAA;EACA,UAAA;A3H2wjBjB;A2HvwjBU;;EACI,kBAAA;EACA,QAAA;EACA,WAAA;A3H0wjBd;A2HrwjBE;;EACE,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;A3HwwjBJ;;A2HnwjBA;EACE,gCAAA;A3HswjBF;;A2HpwjBA;EACE,wBAAA;A3HuwjBF;;A2HlwjBM;;EAEI,c1HpfC;ADyvkBX;A2HlwjBM;EACI,oCAAA;A3HowjBV;;A2H9vjBA;EACE,kBAAA;EACA,YAAA;EACA,W1H2OkC;E0H1OlC,iBAAA;EACA,6BAAA;EACA,6CAAA;E7B5fE,0DAAA;A9FkwkBJ;A2HnwjBE;EACE,6BAAA;A3HqwjBJ;A2HlwjBE;EACE,6BAAA;A3HowjBJ;A2HjwjBE;EACE,6BAAA;A3HmwjBJ;A2HhwjBE;EACE,6BAAA;A3HkwjBJ;A2H/vjBE;EACE,6BAAA;A3HiwjBJ;A2H9vjBE;EACE,6BAAA;A3HgwjBJ;A2H7vjBE;EAEI,6BAAA;EACA,8BAAA;A3H8vjBN;A2H3vjBE;EACI,gBAAA;A3H6vjBN;A2HzvjBE;EACI,mBAAA;A3H2vjBN;;A2HrvjBA;;EAEI,YAAA;EACA,gBAAA;A3HwvjBJ;;A2HnvjBA;EACA,a1HkZ2B;E0HjZ3B,iBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,8BAAA;EAEA,4EAAA;EACA,kBAAA;EACA,gBAAA;A3HsvjBA;A2HnvjBE;EACE,c1HrkBO;AD0zkBX;A2HnvjBE;EACE,gBAAA;EACA,+B1HvhByB;E0HwhBzB,cAAA;EACA,eAAA;A3HqvjBJ;A2HnvjBI;EACE,c1H9kBK;ADm0kBX;;A2H/ujBA;EACA,aAAA;A3HkvjBA;;A2H/ujBA;EACA,aAAA;A3HkvjBA;;AiBhxkBI;E0GkiBJ;IACI,eAAA;IACA,cAAA;IACA,MAAA;IACA,aAAA;IACA,Y1H0WuB;I0HzWvB,WAAA;IACA,OAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,UAAA;IrGxmBE,sDqGymBF;I7BnnBI,oCAAA;E9F02kBN;AACF;AsB71kBM;EqGulBN;IrGtlBQ,gBAAA;EtBg2kBN;AACF;AiB7ykBI;E0GmjBA;IACE,aAAA;E3H6vjBJ;AACF;AiBlzkBI;E0GwjBJ;IACI,aAAA;E3H6vjBF;AACF;AiBvzkBI;E0G8jBA;IACI,QAAA;I7BloBA,mCAAA;E9Fm4kBN;E2H7vjBE;IrG5nBE,sDqG8nBE;I7BxoBA,iCAAA;E9F24kBN;AACF;AsB93kBM;EqGwnBF;IrGvnBI,gBAAA;EtBi4kBN;AACF;AiB90kBI;E0GukBI;IACE,eAAA;IAAA,gBAAA;E3H0wjBR;AACF;AiBn1kBI;E0G4kBA;IACI,kBAAA;IACA,kBAAA;E3H0wjBN;AACF;AiBz1kBI;E0GmlBE;I7BtpBE,oCAAA;E9Fo6kBN;E2H1wjBI;;I7B1pBE,iCAAA;E9F46kBN;E2H7wjBI;IACI,Y1HoTiB;I0HnTjB,UAAA;E3H+wjBR;AACF;AiB92kBI;E0GomBF;IACE,UAAA;IACA,QAAA;I7BzqBI,mCAAA;E9F27kBN;AACF;AiBz3kBI;E0G2mBJ;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,QAAA;IACA,W1H+RuB;I0H9RvB,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;I7BzqBA,0DAAA;E9F+7kBF;AACF;AiB74kBI;E0G0nBJ;I7B7qBI,0DAAA;E9Fw8kBF;AACF;AiBt5kBI;E0G8nBJ;IACI,WAAA;E3H2xjBF;E2H1xjBE;IACA,kBAAA;E3H4xjBF;AACF;AiB36kBI;E0GopBF;;;IAIG,uCAAA;IAEA,sCAAA;IAEA,gDAAA;IACD,iCAAA;E3H0xjBF;E2HrxjBI;IACE,wBAAA;E3HuxjBN;E2HrxjBI;IACE,gCAAA;E3HuxjBN;E2HpxjBI;IACE,WAAA;E3HsxjBN;E2HpxjBM;IACE,sBAAA;E3HsxjBR;E2HjxjBI;IACE,cAAA;IACA,aAAA;IACA,iF1H2OmB;EDwijBzB;E2HhxjBU;IACI,UAAA;I7B/uBR,mCAAA;E9FsglBN;E2HjxjBQ;;;;I7BrvBF,mCAAA;I6B0vBM,UAAA;E3HuxjBZ;E2HnxjBM;IACE,UAAA;E3HqxjBR;E2HjxjBI;IACE,Y1HgNmB;EDmkjBzB;E2HhxjBQ;IACI,UAAA;I7BxwBN,+BAAA;E9F+hlBN;E2HjxjBM;IACE,UAAA;E3HmxjBR;E2HjxjBM;IACE,Y1HkMiB;EDiljBzB;E2HjxjBQ;;;;I7BpxBF,iCAAA;I6ByxBI,UAAA;E3HuxjBV;E2HnxjBM;IACE,UAAA;E3HqxjBR;E2H7wjBM;IACE,mBAAA;E3H+wjBR;E2H3wjBI;IACE,mBAAA;E3H6wjBN;E2HxwjBA;IACE,iBAAA;E3H0wjBF;E2HzwjBE;IACA,c1H5yBO;I0H6yBP,eAAA;E3H2wjBF;AACF;AiB9/kBI;E0G0vBJ;IACE,kBAAA;IACA,mBAAA;E3HuwjBA;AACF;AiBr/kBI;E0GkvBJ;I7BpzBI,0DAAA;E9F+jlBF;E2HvwjBF;IACI,eAAA;IACA,cAAA;IACA,MAAA;IACA,aAAA;IACA,uBAAA;IACA,WAAA;IACA,OAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,UAAA;IrG30BE,sDqG40BF;I7Bt1BI,oCAAA;E9FomlBN;AACF;AsBvllBM;EqG0zBN;IrGzzBQ,gBAAA;EtB0llBN;AACF;AiBxhlBI;E0GuwBA;IACE,aAAA;E3HoxjBJ;AACF;AiB7hlBI;E0G4wBJ;IrGp1BM,sDqGq1BA;E3HoxjBJ;AACF;AsBtmlBM;EqGg1BN;IrG/0BQ,gBAAA;EtBymlBN;AACF;AiBvilBI;E0GixBA;IACI,QAAA;I7Bp2BA,mCAAA;E9FkolBN;E2H1xjBE;IrG91BE,sDqGg2BE;I7B12BA,iCAAA;E9F0olBN;AACF;AsB7nlBM;EqG01BF;IrGz1BI,gBAAA;EtBgolBN;AACF;AiB9jlBI;E0G0xBK;IACE,eAAA;IAAA,gBAAA;E3HuyjBT;AACF;AiBnklBI;E0G+xBA;IACI,kBAAA;IACA,kBAAA;E3HuyjBN;AACF;AiBzklBI;E0GsyBE;I7Bx3BE,oCAAA;E9FmqlBN;E2HvyjBI;;I7B53BE,iCAAA;E9F2qlBN;E2H1yjBI;IACI,Y1HkFiB;I0HjFjB,UAAA;E3H4yjBR;AACF;AiB9llBI;E0GuzBF;IACE,UAAA;IACA,QAAA;I7B34BI,mCAAA;E9F0rlBN;AACF;AiBzmlBI;E0G8zBJ;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,QAAA;IACA,W1H6DuB;I0H5DvB,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;I7B34BA,0DAAA;E9F8rlBF;AACF;AiB7nlBI;E0G60BJ;IACE,6BAAA;E3HmzjBA;AACF;AiBlolBI;E0Gi1BJ;IACE,UAAA;IACA,iCAAA;E3HozjBA;AACF;AiBxolBI;E0Gs1BJ;IACE,UAAA;E3HqzjBA;AACF;AiB7olBI;E0G01BJ;IACE,qBAAA;IACA,iCAAA;E3HszjBA;AACF;AiBnplBI;E0G+1BJ;IACI,aAAA;E3HuzjBF;AACF;A2HpzjBA;EACA,8BAAA;A3HszjBA;;A2HnzjBA;EACA,aAAA;A3HszjBA;;A2HpzjBA;EACA,iBAAA;A3HuzjBA;;A2HrzjBA;EACA,0BAAA;EACE,gBAAA;A3HwzjBF;;A2HrzjBA;EACA,0BAAA;EACA,gBAAA;A3HwzjBA;;A2HrzjBA;EACA,gBAAA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;A3HwzjBF;;A2HtzjBA;EACA,kBAAA;EACA,gBAAA;A3HyzjBA;;A2HvzjBA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;EACA,iBAAA;A3H0zjBA;;A2HxzjBA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;A3H2zjBA;;A2HzzjBA;EACA,YAAA;A3H4zjBA;;A2HzzjBA;EACA,YAAA;A3H4zjBA;;A2HzzjBA;EACA,kBAAA;EACA,iCAAA;A3H4zjBA;;A2H1zjBA;EACA,gBAAA;A3H6zjBA;;A2H3zjBA;EACA,eAAA;EACA,gBAAA;A3H8zjBA;A2H7zjBA;EACE,cAAA;EACA,gBAAA;A3H+zjBF;;A2H1zjBE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EAEA,eAAA;A3H4zjBJ;A2H1zjBC;EACC,gBAAA;A3H4zjBF;A2H3zjBE;EACE,YAAA;EACF,gBAAA;A3H6zjBF;A2HvzjBC;EACC,iBAAA;A3HyzjBF;A2HxzjBE;EAAE,gBAAA;A3H2zjBJ;A2H1zjBE;EACE,YAAA;EACF,gBAAA;A3H4zjBF;;A2HrzjBA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;A3HwzjBA;;A2HtzjBA;EACA,iCAAA;EACA,6DAAA;A3HyzjBA;A2HxzjBA;EACE,6BAAA;EACA,iBAAA;A3H0zjBF;A2HzzjBE;EACE,gBAAA;EACA,kBAAA;A3H2zjBJ;A2HzzjBE;EACE,cAAA;EACA,gBAAA;A3H2zjBJ;;A2HvzjBA;EACA,2BAAA;EACA,eAAA;EAEA,2BAAA;A3HyzjBA;;A2HtzjBA;EACE,wBAAA;EACA,gBAAA;EACA,YAAA;A3HyzjBF;;A2HtzjBA;EACE,4BAAA;A3HyzjBF;;A2HvzjBA;EACA,kBAAA;EACA,aAAA;A3H0zjBA;;A2HxzjBA;EACE,kBAAA;EACA,aAAA;A3H2zjBF;;A2HzzjBA;EACE,kBAAA;EACA,aAAA;A3H4zjBF;;A2H1zjBA;EACE,kBAAA;EACA,aAAA;A3H6zjBF;;A2H1zjBA;EACA,kBAAA;EACA,aAAA;A3H6zjBA;;A2H1zjBA;EACA,kBAAA;A3H6zjBA;;A2HvzjBA;EACA,WAAA;EACE,YAAA;EACA,gBAAA;A3H0zjBF;;A2HxzjBA;EACA,6BAAA;A3H2zjBA;;A2HzzjBA;EAEA,sCAAA;A3H4zjBA;;A2H1zjBA;EACA,QAAA;EACA,UAAA;A3H6zjBA;;A2H3zjBA;EACE,wGAAA;EACA,6BAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;EACA,gBAAA;A3H8zjBF;;A2H3zjBA;EACE,0BAAA;EACA,2BAAA;A3H8zjBF;;A2HzzjBA;EACA;IACE,2BAAA;IACA,oBAAA;E3H4zjBA;E2H1zjBF;IACA,4BAAA;IACA,oBAAA;E3H4zjBE;AACF;A2HlzjBA;EACE,eAAA;EACA,gBAAA;A3HozjBF;;A2H9yjBA;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;A3HizjBF;;A2H5yjBA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A3H+yjBF;;A2H5yjBA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;A3H+yjBF;;A2H3yjBA;EACE,WAAA;EACA,kBAAA;A3H8yjBF;;A2H5yjBA;EACE,8BAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;A3H+yjBF;;A2H3yjBA;EACE,WAAA;EACA,UAAA;A3H8yjBF;;A2H5yjBA;EACE,YAAA;EACA,UAAA;EACA,eAAA;A3H+yjBF;;A2H1yjBA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;A3H6yjBF;;A2H1yjBA;EACE,sBAAA;EACA,eAAA;A3H6yjBF;;A2HzyjBA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;A3H4yjBF;;A2H1yjBA;EACE,aAAA;A3H6yjBF;;A2H1yjBA;EAAiC,gBAAA;A3H8yjBjC;;A2H7yjBA;EAAkC,gBAAA;A3HizjBlC;;A2H9yjBA;EACE,gBAAA;EACA,eAAA;A3HizjBF;;A2H9yjBA;;EAEA,wBAAA;EACC,SAAA;A3HizjBD;;A2H9yjBA;EACE,YAAA;EACA,uCAAA;EACA,8BAAA;EACA,eAAA;A3HizjBF;;A2H9yjBA;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;A3HizjBF;;A2H/yjBA;EACE,yBAAA;A3HkzjBF;;A2HhzjBA;EACE,yBAAA;EACA,2BAAA;A3HmzjBF;;A2HjzjBA;EACE,kBAAA;A3HozjBF;;A2HhzjBA;EACE,yCAAA;A3HmzjBF;;A2HjzjBA;EACE,yCAAA;A3HozjBF;;A2HlzjBA;EACE,yCAAA;A3HqzjBF;;A2HnzjBA;EACE,yCAAA;A3HszjBF;;A2HpzjBA;EACE,+CAAA;EACE,uBAAA;EACA,6BAAA;A3HuzjBJ;;A2HpzjBA;EACI,0BAAA;A3HuzjBJ;;A2HrzjBA;EACE,qCAAA;A3HwzjBF;;A2HtzjBA;EACE,mCAAA;A3HyzjBF;;A2HvzjBA;EACE,sBAAA;A3H0zjBF;;A2HxzjBA;EACE,gBAAA;EACA,wBAAA;A3H2zjBF;;A2HxzjBA;EACE,kCAAA;EACA,wBAAA;A3H2zjBF;;A2HxzjBA;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;A3H2zjBF;;A2HxzjBA;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;A3H2zjBF;;A2HxzjBA;EACE,eAAA;EACA,8BAAA;EACA,iCAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;A3H2zjBF;;A2HxzjBA;EACE,uBAAA;EACA,kCAAA;EACA,kCAAA;A3H2zjBF;;A2HzzjBA;EACE,uCAAA;EACA,sBAAA;EACA,kCAAA;A3H4zjBF;;A2H1zjBA;EACE,uBAAA;EACA,wBAAA;EACA,mCAAA;A3H6zjBF;;A2H3zjBA;EACE,wCAAA;EACA,sBAAA;EACA,mCAAA;A3H8zjBF;;A2H1zjBA;EACG,mBAAA;EACD,4EAAA;EACA,0BAAA;EACA,8BAAA;EACA,cAAA;A3H6zjBF;;A2H1zjBA;EACE,YAAA;A3H6zjBF;;A2H3zjBA;EACE,YAAA;A3H8zjBF;;A2H3zjBA;EACE,YAAA;A3H8zjBF;;A2H5zjBA;EACE,uBAAA;A3H+zjBF;;A2H7zjBA;EACE,sBAAA;EACA,qCAAA;A3Hg0jBF;;A2H9zjBA;EACE;IACE,YAAA;E3Hi0jBF;E2H/zjBA;IACE,YAAA;IACA,oBAAA;IACA,kBAAA;E3Hi0jBF;E2H/zjBA;IACE,YAAA;IACA,oBAAA;IACA,kBAAA;E3Hi0jBF;E2H/zjBA;IACE,YAAA;IACA,oBAAA;IACA,kBAAA;E3Hi0jBF;E2H/zjBA;IACE,YAAA;IACA,oBAAA;IACA,kBAAA;E3Hi0jBF;E2H/zjBA;IACI,YAAA;E3Hi0jBJ;E2H9zjBA;IACE,qCAAA;E3Hg0jBF;E2H9zjBA;IACE,qCAAA;E3Hg0jBF;AACF;A2H7zjBA;EACE,eAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gCAAA;EACE,6BAAA;A3H+zjBJ;;A2H3zjBA;EACE,eAAA;A3H8zjBF;;A2H5zjBA;EACE,gBAAA;A3H+zjBF;;A2H5zjBA;EACE,8BAAA;A3H+zjBF;;A2H5zjBA;EACE,gBAAA;A3H+zjBF;;A2H7zjBA;EACE,2BAAA;A3Hg0jBF;;A2H9zjBA;EACE,mBAAA;A3Hi0jBF;;A2H/zjBA;EACE,yBAAA;A3Hk0jBF;;A2Hh0jBA;EACE,4BAAA;A3Hm0jBF;;A2Hh0jBA;EACE,+CAAA;EACA,8DAAA;A3Hm0jBF;;A2Hh0jBA;EACE,iBAAA;A3Hm0jBF;;A4HtxmBA,eAAA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;E9BoBI,6BAAA;A9FqzmBJ;;A4H1zmBA;;E9BKI,6BAAA;A9F8zmBJ;;A4H9zmBA;;;;E9BuBI,gEAAA;EAGA,yBAAA;A9F8ymBJ;;A4Hj0mBA;EACE,QAAA;EACA,SAAA;EACA,sBAAA;EACA,sBAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;A5Ho0mBF;;A4Hj0mBA;EACE,WAAA;A5Ho0mBF;;A4Hl0mBA;EACE,YAAA;A5Hq0mBF;;A4H7zmBI;EACE,mBAAA;A5Hg0mBN;;A4HxzmBE;EACE,+BAAA;A5H2zmBJ;A4HxzmBE;EACE,YAAA;A5H0zmBJ;A4HvzmBE;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,c3H9DO;E2H+DP,oBAAA;A5HyzmBJ;;A4HnzmBE;EACE,c3HtEO;AD43mBX;A4HjzmBQ;EACE,gBAAA;EACA,gBAAA;A5HmzmBV;A4H5ymBI;;EAEE,wBAAA;A5H8ymBN;;A4HrymBE;EACE,cAAA;A5HwymBJ;A4HpymBE;EACE,c3HVY;ADgzmBhB;A4HlymBE;EACE,+BAAA;A5HoymBJ;A4HlymBE;EACE,6CAAA;A5HoymBJ;A4HhymBE;EACE,gBAAA;A5HkymBJ;A4HhymBI;EACE,0CAAA;A5HkymBN;A4H5xmBI;EACE,aAAA;A5H8xmBN;A4H5xmBI;EACE,qBAAA;A5H8xmBN;A4H3xmBI;EACE,c3HnIK;ADg6mBX;A4H1xmBI;EACA,+BAAA;A5H4xmBJ;A4HvxmBM;EACE,c3HpIG;AD65mBX;A4HrxmBI;EACE,+BAAA;A5HuxmBN;A4HnxmBE;;EAEE,gCAAA;A5HqxmBJ;A4HlxmBE;;EAEE,gCAAA;A5HoxmBJ;A4HjxmBE;EACE,gBAAA;A5HmxmBJ;A4H9wmBI;;EACE,gCAAA;A5HixmBN;A4H9wmBI;;;;;;;;;;;;;;EAEE,gCAAA;A5H4xmBN;A4HxxmBM;;;;EACE,c3H5FQ;ADy3mBhB;A4HxxmBI;;EACE,c3HlGU;AD63mBhB;A4HtxmBI;EACE,qBAAA;A5HwxmBN;A4HnxmBI;EACE,yBAAA;A5HqxmBN;;A4HjxmBA;EAEE,4BAAA;A5HoxmBF;;A4HjxmBA;EACE,c3H7KQ;ADi8mBV;;A6H9+mBE;;EAEE,QAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;A7Hi/mBJ;A6H9+mBQ;;EACE,YAAA;EACA,iBAAA;EACA,eAAA;A7Hi/mBV;A6H9+mBQ;;EACE,kBAAA;EACA,iBAAA;A7Hi/mBV;A6H9+mBQ;;EACE,UAAA;EACA,WAAA;A7Hi/mBV;A6H7+mBU;;EACE,qBAAA;EACA,WAAA;A7Hg/mBZ;A6H1+mBQ;;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;A7H6+mBV;A6H1+mBQ;;EACE,iBAAA;A7H6+mBV;A6Hz+mBI;;;;EAEE,YAAA;EACA,iBAAA;EACA,eAAA;A7H6+mBN;A6H1+mBI;;;;EAEE,iBAAA;A7H8+mBN;A6H3+mBI;;EACE,WAAA;EACA,UAAA;A7H8+mBN;A6H1+mBE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A7H4+mBJ;A6Hz+mBE;EACE,8BAAA;A7H2+mBJ;A6Hx+mBE;EACE,qBAAA;EACA,cAAA;A7H0+mBJ;A6Hv+mBE;EACE,wBAAA;EACA,UAAA;A7Hy+mBJ;A6Hv+mBI;EACE,WAAA;EACA,UAAA;A7Hy+mBN;A6Hr+mBE;EACE,UAAA;EACA,WAAA;A7Hu+mBJ;A6Hp+mBE;EACE,WAAA;EACA,OAAA;A7Hs+mBJ;A6Hn+mBE;EACE,cAAA;EACA,kBAAA;A7Hq+mBJ;A6Hl+mBE;EACE,kBAAA;EACA,iBAAA;A7Ho+mBJ;A6Hj+mBE;EACE,YAAA;A7Hm+mBJ;A6Hh+mBE;EACE,OAAA;EACA,cAAA;EACA,eAAA;A7Hk+mBJ;A6Hj+mBM;EACE,qBAAA;EACA,sBAAA;A7Hm+mBR;A6Hh+mBM;EACE,WAAA;EACA,UAAA;A7Hk+mBR;A6H79mBM;EACE,mBAAA;EACA,kBAAA;A7H+9mBR;A6H59mBM;EACE,WAAA;EACA,UAAA;A7H89mBR;A6H19mBE;EACE,cAAA;A7H49mBJ;A6Hz9mBE;EACE,kBAAA;EACA,UAAA;A7H29mBJ;A6Hx9mBE;EACE,6BAAA;A7H09mBJ;A6Hv9mBE;EACE,sBAAA;EACA,OAAA;A7Hy9mBJ;A6Hn9mBQ;EACE,kBAAA;A7Hq9mBV;A6Hl9mBQ;EACE,2BAAA;A7Ho9mBV;A6H98mBE;EACE,WAAA;A7Hg9mBJ;;AiBjknBI;E4GyHA;IACE,oBAAA;IACA,kBAAA;E7H48mBJ;E6Hz8mBE;IACE,oBAAA;IACA,kBAAA;E7H28mBJ;E6Hx8mBE;IACE,kBAAA;E7H08mBJ;E6Hv8mBE;IACE,0BAAA;E7Hy8mBJ;AACF;AiBrknBI;E4GoIA;I/BvMI,mCAAA;E9FgpnBN;E6Hr8mBE;IACE,YAAA;IACA,QAAA;IACA,UAAA;I/B9ME,iCAAA;E9F0pnBN;E6Hv8mBA;IACE,eAAA;E7Hy8mBF;E6Ht8mBA;IACE,mBAAA;E7Hw8mBF;AACF;AiB9lnBI;E4G0JA;IACE,mBAAA;E7Hu8mBJ;E6Hp8mBE;IACE,YAAA;IACA,UAAA;E7Hs8mBJ;E6Hn8mBE;IACI,cAAA;IACA,kBAAA;E7Hq8mBN;E6Hj8mBI;IACE,gBAAA;E7Hm8mBN;E6Hl8mBM;IACE,iBAAA;E7Ho8mBR;E6Hn8mBQ;IACE,iBAAA;E7Hq8mBV;E6Hj8mBM;IACE,eAAA;IACA,UAAA;E7Hm8mBR;E6Hl8mBQ;IACE,gBAAA;IACA,iBAAA;E7Ho8mBV;E6Hh8mBM;IACE,kBAAA;E7Hk8mBR;E6H77mBI;IACE,eAAA;E7H+7mBN;AACF;AiBlonBI;E4G0MA;IACE,kBAAA;IACA,mBAAA;E7H27mBJ;AACF;AiBxonBI;E4GoNJ;IACI,uBAAA;E7Hu7mBF;AACF;A8HrtnBE;EACE,eAAA;EACA,gBAAA;A9HutnBJ;A8HrtnBI;EACI,gBAAA;EACA,oBAAA;EACA,kBAAA;A9HutnBR;A8HrtnBQ;EACI,MAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,yB7HyFI;E6HxFJ,SAAA;EACA,mBAAA;A9HutnBZ;A8HntnBU;EACE,SAAA;A9HqtnBZ;A8HltnBc;EACE,SAAA;EACA,UAAA;A9HotnBhB;A8HjtnBc;EACE,4BAAA;A9HmtnBhB;A8H7snBQ;EACI,+BAAA;EACA,gBAAA;EACA,oBAAA;A9H+snBZ;A8H1snBY;EACI,QAAA;A9H4snBhB;A8HzsnBY;EACI,UAAA;A9H2snBhB;A8HxsnBY;EACI,QAAA;A9H0snBhB;A8HtsnBQ;EACI,mBAAA;EACA,kBAAA;A9HwsnBZ;A8HtsnBY;EAEI,YAAA;EACA,cAAA;A9HusnBhB;A8HpsnBY;EACI,WAAA;A9HssnBhB;A8HjsnBQ;EACI,mB7HszBwB;E6HrzBxB,UAAA;EACA,WAAA;EACA,aAAA;EACA,wB7HmQkB;E6HlQlB,6CAAA;EACA,c7HuBI;E6HtBJ,mBAAA;EACA,kBAAA;A9HmsnBZ;A8HjsnBY;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,qCAAA;EACA,YAAA;A9HmsnBhB;A8HhsnBY;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,qCAAA;EACA,YAAA;A9HksnBhB;A8H/rnBY;EACE,mB7HjGH;ADkynBX;A8HhsnBc;EACE,c7HGO;AD+rnBvB;A8H/rnBc;EACE,2B7HvGL;E6HwGK,0B7HxGL;ADyynBX;A8H1rnBQ;EACI,c7HhHD;E6HiHC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,yB7HJiB;E6HKjB,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,+BAAA;EACA,8BAAA;A9H4rnBZ;A8H1rnBY;;EAEI,oBAAA;A9H4rnBhB;A8HzrnBY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A9H2rnBd;A8HrrnBQ;EACI,YAAA;A9HurnBZ;A8HrrnBY;EACI,oBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;A9HurnBhB;A8HprnBY;EACI,oBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;A9HsrnBhB;A8H/qnBI;EACI,mBAAA;A9HirnBR;A8H/qnBI;EACE,oCAAA;A9HirnBN;A8H/qnBI;EACE,oCAAA;A9HirnBN;A8H9qnBI;EACE,oCAAA;A9HgrnBN;A8H7qnBI;EACE,oCAAA;A9H+qnBN;A8H5qnBI;EACE,oCAAA;A9H8qnBN;A8H1qnBI;EACE,aAAA;EACA,cAAA;A9H4qnBN;A8HzqnBI;;EAEE,gBAAA;EACA,c7HnMK;AD82nBX;A8HxqnBI;EACE,eAAA;A9H0qnBN;;AiBtznBI;E6GqJI;IACE,QAAA;E9HqqnBR;E8HlqnBM;IACI,QAAA;E9HoqnBV;E8HjqnBM;IACI,YAAA;IACA,qBAAA;E9HmqnBV;E8HjqnBU;IACI,oBAAA;IACA,wBAAA;IACA,WAAA;IACA,WAAA;E9HmqnBd;E8HhqnBU;IACI,oBAAA;IACA,wBAAA;IACA,WAAA;IACA,WAAA;E9HkqnBd;AACF;A+Hx5nBA;;;;;;;;;;;;;EAaE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;A/H05nBF;;A+Hv5nBA;EACE,gBAAA;A/H05nBF;;A+Hx5nBA;EACE,6BAAA;A/H25nBF;;A+Hz5nBA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;A/H45nBF;A+H15nBE;EACI,UAAA;A/H45nBN;A+Hv5nBM;EACE,gBAAA;EACA,kBAAA;A/Hy5nBR;A+Hn5nBI;EACE,gBAAA;EACA,kBAAA;A/Hq5nBN;A+Hn5nBM;;EAEE,yBAAA;A/Hq5nBR;A+Hh5nBI;;;EAGE,c9HsEuB;AD40nB7B;A+Hh5nBM;;;EACE,c9HnDG;ADu8nBX;;AiBz5nBI;E8GWF;IACE,WAAA;E/Hk5nBF;AACF;AiB/5nBI;E8GgBF;IACE,WAAA;E/Hk5nBF;AACF;AiBp6nBI;E8GqBF;IACE,WAAA;E/Hk5nBF;AACF;A+Hh5nBA;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;A/Hk5nBJ;;A+H74nBA;EACI,aAAA;A/Hg5nBJ;;A+H74nBA;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,c9HrGO;E8HsGP,uBAAA;EACA,qCAAA;EACA,oCAAA;A/Hg5nBJ;;A+H94nBA;EACE,gBAAA;EACA,oBAAA;A/Hi5nBF;;A+H/4nBA;EACE,gBAAA;EACA,kBAAA;A/Hk5nBF;;A+Hh5nBA;EACE,UAAA;EACA,UAAA;A/Hm5nBF;;A+Hj5nBA;EACE,UAAA;EACA,UAAA;A/Ho5nBF;;A+Hl5nBA;EACE,SAAA;A/Hq5nBF;;A+Hn5nBA;EACE,UAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;A/Hs5nBF;;A+Hp5nBA;;EAEI,c9HhDY;ADu8nBhB;;A+Hr5nBA;EACE,6BAAA;A/Hw5nBF;;A+Ht5nBA;EACE,gBAAA;A/Hy5nBF;;A+Hv5nBA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,c9HjC2B;AD27nB7B;;A+Hx5nBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;A/H25nBF;;A+Hx5nBA;EACI,oBAAA;A/H25nBJ;;A+Hz5nBA;EACE,0BAAA;A/H45nBF;;A+H15nBA;EACE,4BAAA;A/H65nBF;;A+H35nBA;EACE,0BAAA;A/H85nBF;;A+H55nBA;EACE,4BAAA;A/H+5nBF;;A+H75nBA;EACE,qBAAA;A/Hg6nBF;;A+H95nBA;EACE,uBAAA;A/Hi6nBF;;A+H/5nBA;EACE,uBAAA;A/Hk6nBF;;A+Hh6nBA;EACE,2BAAA;A/Hm6nBF;;A+Hj6nBA;EACE,gCAAA;A/Ho6nBF;;A+Hl6nBA;EACE,kBAAA;EACA,kBAAA;EACA,c9H5Gc;ADihoBhB;;A+Hn6nBA;EACE,uCAAA;A/Hs6nBF;;A+Hp6nBA;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;A/Hu6nBF;;A+Hr6nBA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;A/Hw6nBF;;A+Ht6nBA;EACE,WAAA;EACA,SAAA;EACA,kBAAA;A/Hy6nBF;;A+Hv6nBA;EACE,kBAAA;A/H06nBF;;A+Hx6nBA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;A/H26nBF;;A+Hz6nBA;EACE,YAAA;A/H46nBF;;A+H16nBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;A/H66nBF;;A+H36nBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,c9H7Jc;AD2koBhB;;A+H56nBA;EACE,yBAAA;A/H+6nBF;;A+H76nBA;EACE,qBAAA;A/Hg7nBF;;A+H96nBA;EACE,kBAAA;EACA,c9HvKc;E8HwKd,mBAAA;EACA,iBAAA;A/Hi7nBF;;A+H/6nBA;EACE,eAAA;A/Hk7nBF;;A+Hh7nBA;EACE,gBAAA;A/Hm7nBF;;A+Hh7nBA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;A/Hm7nBF;;A+Hj7nBA;;;EAGE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,c9HlK2B;E8HmK3B,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EjCrRE,6BAAA;A9F8soBJ;;A+Ht7nBA;EACE,gBAAA;EACA,eAAA;A/Hy7nBF;;A+Hv7nBA;EACE,c9HjNc;AD2ooBhB;;A+Hx7nBA;EACE,WAAA;EACA,qBAAA;EACA,qCAAA;EACA,4BAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;A/H27nBF;;A+Hz7nBA;EACE,yB9H7Nc;E8H8Nd,c9HnTS;E8HoTT,+CAAA;A/H47nBF;;A+H17nBA;EACE,4B9HvTS;ADovoBX;;A+H37nBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;A/H87nBF;;A+H57nBA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A/H+7nBF;;A+H57nBA;EACE,yB9HrPc;E8HsPd,cAAA;A/H+7nBF;;A+H77nBA;EACE,cAAA;A/Hg8nBF;;A+H97nBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;A/Hi8nBF;;A+H/7nBA;;;EAGE,6BAAA;A/Hk8nBF;;A+Hh8nBA;EACE,YAAA;EACA,iBAAA;A/Hm8nBF;;A+Hh8nBA;EACE,eAAA;A/Hm8nBF;;A+Hh8nBA;;;;;;EAME,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A/Hm8nBF;;A+H/7nBI;;;;;;;;;;;;EAYI,c9HtQqB;ADwsoB7B;A+H77nBI;EACI,+B9H9UqB;AD6woB7B;A+H57nBI;;EAEI,+BAAA;A/H87nBR;A+H37nBI;EACI,yB9H3YG;ADw0oBX;A+H17nBI;;EAEI,yB9HhZG;AD40oBX;A+Hz7nBI;;;;;EAKI,oC9H/VqB;AD0xoB7B;A+Hx7nBI;;EAEI,0C9HpWqB;AD8xoB7B;;A+Hr7nBA;EACI,yB9H9UY;ADswoBhB;A+Ht7nBI;;;EAKI,c9HrVQ;AD2woBhB;;A+Hl7nBA;EACI,yB9HvVY;AD4woBhB;A+Hn7nBI;;;EAKI,c9H9VQ;ADixoBhB;;A+H/6nBA;EACI,yB9HpWY;ADsxoBhB;A+Hh7nBI;;;EAKI,c9H3WQ;AD2xoBhB;;A+H56nBA;EACI,yB9H7WY;AD4xoBhB;A+H76nBI;;;EAKI,c9HpXQ;ADiyoBhB;;A+Hz6nBA;EACI,yB9H1XY;ADsyoBhB;A+H16nBI;;;EAKI,c9HjYQ;AD2yoBhB;;A+Hl6nBM;EACE,+BAAA;A/Hq6nBR;A+Hn6nBQ;EACE,cAAA;A/Hq6nBV;A+Hh6nBI;EACE,+BAAA;A/Hk6nBN;A+Hh6nBI;EACE,uBAAA;EACA,+BAAA;A/Hk6nBN;A+Hh6nBI;EACE,uBAAA;A/Hk6nBN;A+H75nBI;EACE,c9HzfK;ADw5oBX;A+H55nBI;EACE,uBAAA;A/H85nBN;;AgIz6oBA,+CAAA;AACA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AhI46oBF;;AgI16oBA;EACE,kBAAA;EACA,cAAA;AhI66oBF;;AgI36oBA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AhI86oBF;;AgI56oBA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AhI+6oBF;;AgI76oBA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;AhIg7oBF;;AgI76oBA;EACE,YAAA;EACA,WAAA;AhIg7oBF;;AgI96oBA;EACE,WAAA;EACA,UAAA;AhIi7oBF;;AgI96oBA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;AhIi7oBF;;AgI/6oBA;;EAAA;AAGA;EACE,QAAA;AhIk7oBF;;AgIh7oBA;EACE,SAAA;AhIm7oBF;;AgIj7oBA;EAEE,2BAAA;EACA,kBAAA;AhIo7oBF;;AgIl7oBA;EACE,YAAA;EACA,WAAA;AhIq7oBF;;AgIn7oBA;;EAGE,0BAAA;AhIs7oBF;;AgIp7oBA;EACE,0BAAA;AhIu7oBF;;AgIr7oBA;EAAA;AAEC;EACC,WAAA;AhIw7oBF;;AgIt7oBC;EACC,kBAAA;EACA,yB/HrFS;E+HsFT,2CAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AhIy7oBF;;AgIv7oBA;EACE,WAAA;AhI07oBF;;AgIx7oBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AhI27oBF;;AgIz7oBA;EACE,YAAA;EACA,UAAA;EACD,aAAA;AhI47oBD;;AgI17oBA;;EAAA;AAGA;EACE,0CAAA;EACD,kBAAA;AhI67oBD;;AgI37oBA;EACE,kBAAA;AhI87oBF;;AgI57oBA;EACE,mB/HlCc;E+HmCd,kBAAA;EAED,4BAAA;AhI+7oBD;;AgI77oBA;EAAA;AAEA;EACE,iBAAA;AhIg8oBF;;AgI97oBA;EACE,iBAAA;AhIi8oBF;;AgI/7oBA;EACE,kBAAA;EACA,mB/HrIS;E+HsIT,eAAA;EACA,4EAAA;EAGA,iCAAA;EACE,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;AhIg8oBJ;;AgI77oBA;EAKI,+BAAA;AhIg8oBJ;;AgI57oBA;EAAA;AAEA;EACE,mBAAA;AhI+7oBF;;AgI77oBA;;;EAGE,mBAAA;AhIg8oBF;;AgI97oBA;;EAAA;AAGA;;EAGE,sBAAA;AhIi8oBF;;AgI/7oBA;EACE,kBAAA;EACA,WAAA;AhIk8oBF;;AgIh8oBA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AhIm8oBF;;AgIj8oBA;EACE,WAAA;EACA,eAAA;AhIo8oBF;;AgIl8oBA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AhIq8oBF;;AgIn8oBA;EACE,gBAAA;AhIs8oBF;;AgIp8oBA;EACE,gBAAA;AhIu8oBF;;AgIr8oBA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AhIw8oBF;;AgIt8oBA;EAEE,kCAAA;AhIy8oBF;;AgIv8oBA;EAEE,8BAAA;AhI08oBF;;AgIx8oBA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AhI28oBF;;AgIz8oBA;EACE,YAAA;AhI48oBF;;AgI18oBA;EACE,YAAA;AhI68oBF;;AgI38oBA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AhI88oBF;;AgI58oBA;EAEE,iCAAA;EACA,kBAAA;AhI+8oBF;;AgI78oBA;EAEE,4BAAA;AhIg9oBF;;AgI98oBA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AhIi9oBF;;AgI/8oBA;EACE,WAAA;AhIk9oBF;;AgIh9oBA;EACE,WAAA;AhIm9oBF;;AgIj9oBA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mB/HxQS;E+HyQT,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AhIo9oBF;;AgIl9oBA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AhIq9oBF;;AgIn9oBA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AhIs9oBF;;AgIj9oBE;EAEU,yB/H/RD;ADkvpBX;AgIh9oBE;EACC,0CAAA;AhIk9oBH;AgI/8oBE;EACC,yB/HvSQ;ADwvpBX;AgI58oBE;EAEU,yB/HzNI;ADsqpBhB;AgI18oBE;EACC,wC/HpMoB;ADgppBvB;AgIz8oBE;EACC,yB/HjOa;E+HkOb,oCAAA;AhI28oBH;AgIt8oBQ;EAEI,yB/HtOI;AD6qpBhB;AgIp8oBE;EACC,yC/HlNoB;ADwppBvB;AgIn8oBE;EACC,yB/H9Oa;E+H+Ob,oCAAA;AhIq8oBH;AgIj8oBQ;EAEI,yB/HtPI;ADwrpBhB;AgI/7oBQ;EACL,wC/HlOoB;ADmqpBvB;AgI97oBE;EACC,yB/H9Pa;E+H+Pb,oCAAA;AhIg8oBH;AgI57oBQ;EAEI,yB/HnQI;ADgspBhB;AgI17oBQ;EACL,yC/H/OoB;AD2qpBvB;AgIz7oBE;EACC,yB/H3Qa;E+H4Qb,oCAAA;AhI27oBH;AgIv7oBQ;EAEI,yB/HjRI;ADyspBhB;AgIr7oBQ;EACL,wC/H7PoB;ADorpBvB;AgIp7oBE;EACC,yB/HzRa;E+H0Rb,oCAAA;AhIs7oBH;;AiIrzpBA;EACE,cAAA;EACA,gBAAA;AjIwzpBF;;AiIrzpBA;EACE,iBAAA;AjIwzpBF;;AiIrzpBA;EACE,sCAAA;EACA,cAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAEA;EACE,iCAAA;EACA,mBAAA;EACA,YAAA;AjIwzpBF;;AiIrzpBA;EACE,uCAAA;EACA,mBAAA;EACA,YAAA;AjIwzpBF;;AiIrzpBA;EACE,8CAAA;EACA,sCAAA;EACA,mBAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAEA;EACE,kBAAA;EACA,yCAAA;AjIwzpBF;;AiIrzpBA;EACE,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AjIwzpBF;;AiIrzpBA;EACE,2BAAA;AjIwzpBF;;AiIrzpBA;EACE,aAAA;AjIwzpBF;;AiIrzpBA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAEA;EACE,mBAAA;EACA,iBAAA;AjIwzpBF;;AiIrzpBA;EACE,SAAA;EACA,SAAA;EACA,gBAAA;EACA,yDAAA;EACA,mBAAA;AjIwzpBF;;AiIrzpBA;;;;EAIE,gEAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AjIwzpBF;;AiIrzpBA;EACE,SAAA;EACA,6BAAA;AjIwzpBF;;AiIrzpBA;EACE,YAAA;EACA,6BAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAEA;EACE,WAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;AjIwzpBF;;AiIrzpBA;EACE,kBAAA;AjIwzpBF;;AiIrzpBA;;EAEE,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AjIwzpBF;;AiIrzpBA;EACE,oBAAA;EACA,iCAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAEA;EACE,eAAA;AjIwzpBF;;AiIrzpBA;EACE,0BAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAEA;EACE,6DAAA;EACA,+FAAA;EACA,mBAAA;EACA,eAAA;AjIwzpBF;;AiIrzpBA;EACE;4CAAA;EAEA,iCAAA;EACA,kCAAA;EACA,8BAAA;EACA,mCAAA;AjIwzpBF;;AiIrzpBA;EACE,gCAAA;EACA,+BAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAEA;EACE,kBAAA;AjIwzpBF;;AiIrzpBA;EACE,UAAA;AjIwzpBF;;AiIrzpBA,mDAAA;AACA;;EAEE,SAAA;EACA,sCAAA;AjIwzpBF;;AiIrzpBA;;EAEE,YAAA;EACA,sCAAA;AjIwzpBF;;AiIrzpBA;;EAEE,yBAAA;AjIwzpBF;;AiIrzpBA;EACE,UAAA;AjIwzpBF;;AiIrzpBA;EACE,UAAA;AjIwzpBF;;AiIrzpBA;;;CAAA;AAIA;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,uCAAA;AjIwzpBF;;AiIrzpBA;EACE,UAAA;AjIwzpBF;;AiIrzpBA;;;EAGE,wCAAA;EACA,2DAAA;EACA,gBAAA;EACA,sCAAA;EACA,yBAAA;AjIwzpBF;;AiIrzpBA;;EAEE,4DAAA;EACA,gBAAA;AjIwzpBF;;AiIrzpBA;;EAEE,2CAAA;EACA,aAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAEA;EACE,iCAAA;AjIwzpBF;;AiIrzpBA,mCAAA;AACA;;EAEE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,gFAAA;AjIwzpBF;;AiIrzpBA;mGAAA;AAGA;EACC,kBAAA,EAAA,kDAAA;EACA,cAAA,EAAA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBhIlKe,EgIkKmB,6BAAA;EAElC,mBAAA,EAAA,sCAAA;AjIszpBD;AiIpzpBI;EACI,yBhItKQ;AD49pBhB;AiInzpBI;EACI,yBAAA;AjIqzpBR;AiIlzpBI;EACI,yBhI7KQ;ADi+pBhB;AiIjzpBI;EACI,yBhIhLQ;ADm+pBhB;AiI5ypBC;EACC,yBhI9Lc;AD4+pBhB;;AiIzypBA;EACC,yBAAA,EAAA,6BAAA;AjI4ypBD;;AiIzypBA;;;EAGC,chI9RU,EgI8RK,uBAAA;EACf,qBAAA,EAAA,uBAAA;AjI4ypBD;;AiIzypBA;;EAEE,eAAA;EACA,qEAAA;AjI4ypBF;;AiIzypBA;;EAEE,yCAAA;EACA,mBAAA;AjI4ypBF;;AiIzypBA,mBAAA,6CAAA;EACC,UAAA;EACA,mBhIhTU;EgIiTV,aAAA;AjI4ypBD;;AiIzypBA;EACE,kBAAA;EACA,UAAA;AjI4ypBF;;AiIzypBA,uCAAA;AACA;EACE,kBAAA;EACA,UAAA;AjI4ypBF;;AiIzypBA,4BAAA;AACA;EACE,aAAA;AjI4ypBF;;AiIzypBA;;EAEE,qDAAA;EACA,cAAA;AjI4ypBF;;AiIzypBA,aAAA;AACA;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uDAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AjI4ypBF;;AiIzypBA;mGAAA;AAEA;EACE,wBAAA;EACA,6BAAA;EACA,wCAAA;AjI4ypBF;;AiIzypBA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,uCAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AjI4ypBF;;AiIzypBA;mGAAA;AAEA;EACE,wBAAA,EAAA,6BAAA;EACA,wCAAA;AjI4ypBF;;AiIzypBA;EACC,wCAAA;AjI4ypBD;;AiIzypBA;EACE,aAAA;AjI4ypBF;;AiIzypBA;mGAAA;AAEA,oCAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;AjI4ypBF;;AiIzypBA,mGAAA;AACA;;EAEE,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,4BAAA;AjI4ypBF;;AiIzypBA;;EAEE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,oCAAA;EACA,0BAAA;EACA,6BAAA;AjI4ypBF;;AiIzypBA,uCAAA;AACA,kBAAA;AACA;;EAEE,gBAAA;EACA,UAAA;EACA,oBAAA;AjI4ypBF;;AiIzypBA,kBAAA;AACA;;EAEE,gBAAA;EACA,WAAA;EACA,oBAAA;AjI4ypBF;;AiIzypBA,4BAAA;AACA;EACE,UAAA;EACA,SAAA;EACA,wBAAA;EACA,YAAA;EACA,2BAAA;AjI4ypBF;;AiIzypBA,4BAAA;AACA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AjI4ypBF;;AiIzypBA,kBAAA;AACA;;EAEE,iBAAA;EACA,yCAAA;AjI4ypBF;;AiIzypBA,kBAAA;AACA;;EAEE,kBAAA;EACA,0CAAA;AjI4ypBF;;AiIzypBA;;;;CAAA;AAKA;EACE,iBAAA;EACA,qCAAA;EACA,cAAA;AjI4ypBF;;AiIzypBA;EACE,eAAA;EACA,mDAAA;AjI4ypBF;;AiIzypBA;EACC,WAAA;EACA,kBAAA;EACA,UAAA,EAAA,uCAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AjI4ypBD;;AiIxypBA,iCAAA,qCAAA;EACC,mBAAA;EACA,gBAAA;EACC,chI3fS;EgI4fT,cAAA;AjI2ypBF;;AiIxypBA;EACC,iBAAA;AjI2ypBD;;AiIxypBA,6BAAA;AAEA,kBAAA;AACA;;EAEC,iBAAA,EAAA,2BAAA;AjI0ypBD;;AiIvypBA,kBAAA;AACA;;EAEC,kBAAA,EAAA,2BAAA;AjI0ypBD;;AiIvypBA;EACE,aAAA;EACA,+BAAA;AjI0ypBF;;AiIvypBA;EACE,qCAAA;EACA,mBAAA;EACA,gBAAA;AjI0ypBF;;AiIvypBA;EACE,iBAAA;AjI0ypBF;;AiIvypBA,6BAAA;AACA,kBAAA;AACA;;EAEE,iBAAA;EACA,2BAAA;AjI0ypBF;;AiIvypBA,kBAAA;AACA;;EAEE,kBAAA;EACA,2BAAA;AjI0ypBF;;AiIvypBA;mGAAA;AAEA,8CAAA;AACA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AjI0ypBF;;AiIvypBA;EACE,0BAAA;AjI0ypBF;;AiIvypBA;EACE,4DAAA;EACA,aAAA;AjI0ypBF;;AiIvypBA,qDAAA;AACA;EACE,UAAA;EACA,iDAAA;AjI0ypBF;;AiIvypBA;EACE,UAAA;EACA,YAAA;AjI0ypBF;;AiIvypBA;EACE,aAAA;AjI0ypBF;;AiIvypBA;mGAAA;AAEA;EACE,kBAAA;EACA,mBAAA;AjI0ypBF;;AiIvypBA;mGAAA;AAEA;EACE,yBAAA;EAIA,iBAAA;EACA,2BAAA;EACA,6CAAA;AjI0ypBF;;AiIvypBA;;CAAA;AAGA;mGAAA;AAEA;;;;;;;;;;EAUE,qBAAA;AjI0ypBF;;AiIvypBA;EACE,yBhIvnBS;ADi6qBX;;AiIvypBA;;;EAGE,gBAAA;AjI0ypBF;;AiIvypBA;EACC,chIvnB4B;ADi6qB7B;;AiIvypBA;EACE,mBAAA;EACA,chItoBS;ADg7qBX;;AiIvypBA;EACE,mBAAA;EACA,YAAA;AjI0ypBF;;AiIvypBA;;;CAAA;AAIA;EACE,sBAAA;EACA,gEAAA;EACA,mBAAA;EACA,kBAAA;AjI0ypBF;AiIxypBA;EACE,+EAAA;EACA,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;AjI0ypBF;;AiIvypBA;EACE,gBAAA;AjI0ypBF;;AiIvypBA;EACE,gBAAA;AjI0ypBF;;AiIvypBA;EACE,gBAAA;AjI0ypBF;;AiIvypBA;EACE,gBAAA;AjI0ypBF;;AiIvypBA;EACE,gBAAA;AjI0ypBF;;AiIvypBA;EACE,gBAAA;AjI0ypBF;;AiIvypBA;EACE,gBAAA;AjI0ypBF;;AiIvypBA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AjI0ypBF;;AiIvypBA;;;CAAA;AAIA,UAAA;AACA;EACE,iBhIjZ2B;EgIkZ3B,gBhIhV4B;EgIiV5B,0BhI5V4B;EgI6V5B,chIltBS;EgImtBT,mBhIzqB4B;EgI0qB5B,eAAA;EACA,YAAA;EACA,gBAAA;EACA,wBhIlZ4B;EgImZ5B,iBAAA;EACA,eAAA;EAGA,gCAAA;EACD,aAAA;AjI0ypBD;AiIxypBE;EACA,SAAA;AjI0ypBF;AiIvypBE;EnCvtBA,mB7FyEc;E6FrEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FiGY;E8FhGZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;ADuhrBX;A+FhirBI;EACE,gCAAA;EACA,4BAAA;A/FkirBN;A+F/hrBI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/FyhrBR;A+FthrBI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/FwhrBN;A+FrhrBI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/FshrBR;A+F/grBQ;EAMI,yB9FgDI;E8F/CJ,qB9F+CI;AD69qBhB;A+Fj7qBI;EACI,c9F7CQ;E8F8CR,qB9F9CQ;E8F+CR,uB9FzHqB;AD4irB7B;A+Fj7qBQ;EAII,c9FrDI;E8FsDJ,qB9FtDI;E8FuDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/Fg7qBZ;A+F76qBQ;EACE,gCAAA;A/F+6qBV;A+F96qBU;EAII,c9FvJH;E8FwJG,qB9FnEE;E8FoEF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/F66qBd;A+Fx6qBI;EACI,c9F/EQ;ADy/qBhB;A+Fz6qBQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/Fy6qBZ;AiI72pBE;;;EAGI,eAAA;EACH,YAAA;EACA,oBAAA;AjI+2pBH;;AiIx2pBA;EACE,mBAAA;EACA,0CAAA;AjI22pBF;;AiIx2pBA;EACE,0BAAA;AjI22pBF;;AiIx2pBA;EACE,eAAA;AjI22pBF;;AiIx2pBA;EACE,UAAA;EACA,kBAAA;AjI22pBF;;AiIv2pBA;;;;EAIC,cAAA;EACA,yBAAA;AjI02pBD;;AiIv2pBA;EACC,cAAA;EACA,qBAAA;EACA,4BAAA;EAIQ,2CAAA;AjI02pBT;;AiIv2pBA;;EAEC,yBAAA;EACA,sBAAA;AjI02pBD;;AiIv2pBA;EACC,eAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AjI02pBD;;AiIt2pBA,UAAA;AAEA;EACE,UAAA;EAEA,+CAAA;AjIw2pBF;;AiIr2pBA;EACE,aAAA;AjIw2pBF;;AiIr2pBA;;EAEE,oBAAA;EACA,4BAAA;AjIw2pBF;;AiIr2pBA;EACE,mBAAA;AjIw2pBF;;AiIr2pBA;EACE,yBAAA;EACA,2BAAA;AjIw2pBF;;AiIr2pBA;EACE,0BAAA;AjIw2pBF;;AiIr2pBA;EACE,WAAA;EACA,iBAAA;AjIw2pBF;;AiIr2pBA;EACE,eAAA;AjIw2pBF;;AiIr2pBA;EACE,iBAAA;AjIw2pBF;;AiIr2pBA,yBAAA;AACA;EACE,sBAAA;EACA,gBAAA;AjIw2pBF;;AiIr2pBA;mGAAA;AAEA;EACE,qBAAA;AjIw2pBF;AiIv2pBC;;EAEG,YAAA;EACA,chIh2BO;EgIi2BP,iBAAA;EACF,uBhIv1B2B;EgIw1B3B,yBAAA;AjIy2pBF;AiIx2pBE;;;;EACC,wCAAA;EACA,iCAAA;EACG,UAAA;AjI62pBN;;AiIv2pBA;EACE,kBAAA;EAGA,cAAA;AjI02pBF;;AiIv2pBA;EACE,UAAA;AjI02pBF;;AiIx2pBA;EACE,mCAAA;EACA,uBAAA;AjI22pBF;AiIz2pBE;EAEE,qBAAA;AjI02pBJ;;AiIt2pBA;;;EAGE,UAAA;AjIy2pBF;;AiIt2pBA;EACE,iBAAA;AjIy2pBF;;AiIt2pBA;EACE,0BAAA;EACA,6BAAA;AjIy2pBF;;AiIt2pBA;EACE,yBAAA;EACA,4BAAA;AjIy2pBF;;AiIt2pBA;mGAAA;AAEA;EACE,kBAAA;EACA,yCAAA;AjIy2pBF;;AiIt2pBA;mGAAA;AAEA;EACE,yBAAA;AjIy2pBF;;AiIt2pBA;mGAAA;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;AjIy2pBF;;AiIt2pBA;EACE,iBAAA;AjIy2pBF;;AiIt2pBA,kBAAA;AACA;EACE,mBAAA;AjIy2pBF;;AiIt2pBA;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;AjIy2pBF;;AiIt2pBA;mGAAA;AAEA;EACE,kBAAA;AjIy2pBF;;AiIt2pBA,iFAAA;AACA,iGAAA;AACA;;;EAKE,uBAAA;AjIy2pBF;;AiIt2pBA;;EAEE,6DAAA;EACA,kBAAA;EACA,UAAA;AjIy2pBF;;AiIt2pBA;EACE;IACE,0BAAA;EjIy2pBF;EiIt2pBA;qGAAA;EAEA;IACE,2BAAA;IACA,sBAAA;IACA,wBAAA;EjIw2pBF;EiIr2pBA;IACE,aAAA;EjIu2pBF;EiIp2pBA;qGAAA;EAEF;;;;;;IAMI,6BAAA;IACA,2BAAA;EjIs2pBF;EiIn2pBA,wDAAA;EACA,cAAA;EACA;;;;;;;;IAQE,aAAA;EjIq2pBF;EiIl2pBA,mDAAA;EACA;IACE,uBAAA;IACA,gDAAA;IACA,wBAAA;IACA,6DAAA;EjIo2pBF;EiIj2pBA;IACE,gBAAA;IACA,mBAAA;IACA,4BAAA;IACA,kDAAA;EjIm2pBF;EiIh2pBA;IACE,iCAAA;IACA,mBAAA;IACA,yEAAA;EjIk2pBF;EiI/1pBA;IACE;sFAAA;IAEA,WAAA;EjIi2pBF;EiI91pBA;qGAAA;EAEA;;IAEE,wBAAA;EjIg2pBF;EiI71pBA;IACE,6BAAA;EjI+1pBF;EiI51pBA;IACE,8BAAA;EjI81pBF;EiI31pBA;IACE,aAAA;IACA,qDAAA;EjI61pBF;EiI11pBA;qGAAA;EAEA,uEAAA;EACA;IACE,wBAAA;EjI41pBF;EiIz1pBA,kEAAA;EACA;IACE,aAAA;EjI21pBF;EiIx1pBA,uCAAA;EACA;;IAEE,oEAAA;IACA,wBAAA;IACA,2CAAA;EjI01pBF;EiIv1pBA,2FAAA;EACA;IACE,gBAAA;EjIy1pBF;EiIt1pBA,2DAAA;EACA;IACE,WAAA;EjIw1pBF;EiIr1pBA,8FAAA;EACA;IACE,oBAAA;EjIu1pBF;EiIp1pBA;qGAAA;EAEA,wDAAA;EACA;IACE,2BAAA;IACA,0BAAA;EjIs1pBF;EiIn1pBA,0EAAA;EACA;IACE,mCAAA;EjIq1pBF;EiIl1pBA,gDAAA;EACA;IACE,cAAA;EjIo1pBF;EiIj1pBA,mFAAA;EACA;IACE,gCAAA;EjIm1pBF;EiIh1pBA,wDAAA;EACA;IACE,cAAA;EjIk1pBF;EiI/0pBA,SAAA;EACA,4EAAA;EACA;IACE,8BAAA;EjIi1pBF;EiI90pBA,oDAAA;EACA;IACE,aAAA;EjIg1pBF;EiI70pBA,2FAAA;EACA;IACE,wBAAA;EjI+0pBF;EiI50pBA;qGAAA;EAEA,iDAAA;EACA;;;IAGE,IAAA;IACA,4BAAA;IACA,uBAAA;EjI80pBF;EiI30pBA,yEAAA;EACA;IACE,oBAAA;IACA,oBAAA;EjI60pBF;EiI10pBA;qGAAA;EAEA;;IAEE,aAAA;IACA,8CAAA;EjI40pBF;AACF;AiIz0pBA;EACE,gCAAA;AjI20pBF;;AiIz0pBA;EACE,chIvpCS;ADm+rBX;;AiIv0pBA;mGAAA;AAEA,sBAAA;AACA;;EAEE,gEAAA;EACA,mBAAA;EACA,iEAAA;AjI00pBF;;AiIv0pBA;EACE,eAAA;EACA,gDAAA;AjI00pBF;;AiIv0pBA,gGAAA;AACA;EACE,gBAAA;AjI00pBF;;AiIv0pBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AjI00pBF;;AiIv0pBA,gCAAA;AACA;EACE,YAAA;AjI00pBF;;AiIv0pBA;;EAEE,YAAA;AjI00pBF;;AiIv0pBA;;EAEE,cAAA;EACA,8CAAA;AjI00pBF;;AiIv0pBA;EACE,YAAA;AjI00pBF;;AiIv0pBA;EACE,WAAA;AjI00pBF;;AiIv0pBA;EACE,WAAA;EACA,wBAAA;AjI00pBF;;AiIv0pBA;EACE,YAAA;EACA,wBAAA;AjI00pBF;;AiIv0pBA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AjI00pBF;;AiIv0pBA,yCAAA;AACA;EACE,kBAAA;AjI00pBF;;AiIv0pBA;EACE,yEAAA;EACA,qBAAA;EACA,iBAAA;AjI00pBF;;AiIv0pBA;mGAAA;AAEA;EACE,kBAAA;EACA,UAAA;EACA,uDAAA;AjI00pBF;;AiIv0pBA;EACE,eAAA;EACA,qDAAA;AjI00pBF;;AiIv0pBA;EACE,mBAAA;EACA,6DAAA;AjI00pBF;;AiIv0pBA;mGAAA;AAEA;EACE,wCAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AjI00pBF;;AiIv0pBA;EACE,iBAAA;AjI00pBF;;AiIv0pBA;EACE,gBAAA;AjI00pBF;;AiIv0pBA;mGAAA;AAEA;;EAEE,6DAAA;EACA,kBAAA;EACA,UAAA;AjI00pBF;;AiIv0pBA;EACE,gBAAA;EACA,oEAAA;AjI00pBF;;AiIv0pBA;EACE,oDAAA;EACA,4BAAA;AjI00pBF;;AiIv0pBA;EACE,UAAA;AjI00pBF;;AiIv0pBA;;EAEE,qEAAA;EACA,kBAAA;EACA,UAAA;AjI00pBF;;AiIv0pBA;EACE,kBAAA;EACA,gDAAA;AjI00pBF;;AiIv0pBA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AjI00pBF;;AiIv0pBA,sDAAA;AACA;EACE,kBAAA;EACA,UAAA;AjI00pBF;;AiIv0pBA;EACE,kBAAA;EACA,UAAA;AjI00pBF;;AiIv0pBA;EACE,kBAAA;EACA,UAAA;AjI00pBF;;AiIv0pBA;EACE,kBAAA;EACA,UAAA;AjI00pBF;;AiIv0pBA;EACE,UAAA;AjI00pBF;;AiIv0pBA;EACE,+BAAA;EACA,kBAAA;EACA,UAAA;AjI00pBF;;AiIv0pBA;mGAAA;AAEA;EACE,aAAA;EACA,gBAAA;EACA,gDAAA;AjI00pBF;;AiIv0pBA;EACE,wBAAA;AjI00pBF;;AiIv0pBA;mGAAA;AAEA;EACE,yDAAA;EACA,kBAAA;EACA,kEAAA;AjI00pBF;;AiIv0pBA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;AjI00pBF;;AiIv0pBA;mGAAA;AAEA;EACE,mDAAA;EACA,oBAAA;AjI00pBF;;AiIv0pBA;EACE,yCAAA;EACA,oBAAA;AjI00pBF;;AiIv0pBA;;EAEE,kBAAA;EACA,UAAA;EACA,0BAAA;AjI00pBF;;AiIv0pBA;EACE,6CAAA;EACA,OAAA;EACA,QAAA;AjI00pBF;;AiIv0pBA;;;;CAAA;AAKA;EACE,kBAAA;AjI00pBF;;AiIv0pBA;EAEE,gCAAA;AjI00pBF;;AiIv0pBA;EACE,gDAAA;EACA,sDAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,0BAAA;AjI00pBF;;AiIv0pBA;EACE,sDAAA;EACA,sBAAA;EACA,mBAAA;EACA,kCAAA;EACA,4BAAA;EACA,6BAAA;AjI00pBF;;AiIv0pBA;EACE,gBAAA;EACA,gBAAA;AjI00pBF;;AiIv0pBA;;EAEE,cAAA;AjI00pBF;;AiIv0pBA;EACE,iBAAA;EACA,mBAAA;AjI00pBF;;AiIv0pBA,0DAAA;AACA;EACE,iEAAA;EACA,mBAAA;AjI00pBF;;AiIv0pBA;;EAEE,4CAAA;EACA,qBAAA;EACA,mBAAA;AjI00pBF;;AiIv0pBA;EACE,aAAA;EACA,wCAAA;AjI00pBF;;AiIv0pBA;EACE,yBAAA;EACA,4CAAA;AjI00pBF;;AiIv0pBA;EACE,cAAA;EACA,4CAAA;AjI00pBF;;AiIv0pBA;EACE,iBAAA;EACA,kDAAA;EACA,UAAA;EACA,4BAAA;AjI00pBF;;AiIv0pBA,4BAAA;AACA;EACE,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AjI00pBF;;AiIv0pBA;EACE,YAAA;AjI00pBF;;AiIv0pBA,2BAAA;AACA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,iBAAA;EACA,8BAAA;EACA,YAAA;AjI00pBF;;AiIv0pBA;mGAAA;AAEA;EACE,qBAAA;EACA,OAAA;EACA,QAAA;AjI00pBF;;AiIv0pBA,kBAAA;AACA;EACE,gBAAA;EACA,wCAAA;AjI00pBF;;AiIv0pBA;EACE,OAAA;EACA,+BAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AjI00pBF;;AiIv0pBA;EACE,QAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AjI00pBF;AkIt2sBA;EACE;IACE,qBAAA;ElIu3sBF;EkIr3sBA;IACE,sBAAA;ElIu3sBF;EkIr3sBA;IACE,sBAAA;ElIu3sBF;EkIr3sBA;IACE,mBAAA;ElIu3sBF;AACF;AkI32sBA;EACE;IACE,mBAAA;IACA,UAAA;ElIu3sBF;EkIr3sBA;IACE,qBAAA;IACA,UAAA;ElIu3sBF;AACF;AkI11sBA;EACE;IACE,aAAA;IACA,cAAA;IACA,QAAA;ElIu3sBF;EkIr3sBA;IACE,aAAA;IACA,aAAA;IACA,QAAA;ElIu3sBF;EkIr3sBA;IACE,aAAA;IACA,cAAA;IACA,cAAA;ElIu3sBF;EkIr3sBA;IACE,QAAA;IACA,cAAA;IACA,eAAA;ElIu3sBF;EkIr3sBA;IACE,aAAA;IACA,aAAA;IACA,eAAA;ElIu3sBF;AACF;AkI/1sBA;EACE;IACE,YAAA;IACA,cAAA;IACA,QAAA;ElIu3sBF;EkIr3sBA;IACE,YAAA;IACA,cAAA;IACA,QAAA;ElIu3sBF;EkIr3sBA;IACE,aAAA;IACA,QAAA;IACA,eAAA;ElIu3sBF;EkIr3sBA;IACE,YAAA;IACA,YAAA;IACA,eAAA;ElIu3sBF;AACF;AkIv2sBA;EACE;IACE,yBAAA;ElIu3sBF;EkIr3sBA;IACE,yBAAA;ElIu3sBF;EkIr3sBA;IACE,0BAAA;ElIu3sBF;EkIr3sBA;IACE,0BAAA;ElIu3sBF;AACF;AkIh2sBA;EACE;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ElIu3sBF;EkIr3sBA;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ElIu3sBF;EkIr3sBA;IACE,oBAAA;IACA,sBAAA;ElIu3sBF;EkIr3sBA;IACE,aAAA;IACA,mBAAA;IACA,UAAA;ElIu3sBF;AACF;AkI32sBA;EACE;IACE,0BAAA;IACA,UAAA;ElIu3sBF;EkIr3sBA;IACE,wBAAA;IACA,UAAA;ElIu3sBF;AACF;AkIr3sBA;EACE,6BAAA;AlIu3sBF;;AkIr3sBA;EACE,6BAAA;AlIw3sBF;;AkIt3sBA;EACE,MAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AlIy3sBF;;AkIv3sBA;EACE,MAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AlI03sBF;;AkIx3sBA;EACE,MAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;AlI23sBF;;AkIz3sBA;EACE,QAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,2BAAA;AlI43sBF;;AkI13sBA;EACE,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;AlI63sBF;;AkI33sBA;EACE,QAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;AlI83sBF;;AkI53sBA;EACE,SAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;AlI+3sBF;;AkI73sBA;EACE,SAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AlIg4sBF;;AkI93sBA;EACE,SAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AlIi4sBF;;AkI/3sBA;EACE,sBAAA;EACA,oBAAA;AlIk4sBF;;AkIh4sBA;EACE,SAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AlIm4sBF;;AkIj4sBA;EACE,uBAAA;AlIo4sBF;;AkIl4sBA;EACE,WAAA;EACA,qBAAA;EACA,cAAA;AlIq4sBF;;AkIn4sBA;EACE,cAAA;AlIs4sBF;;AkIn4sBA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;AlIs4sBF;;AkIp4sBA;EACE,mBAAA;AlIu4sBF;;AkIr4sBA;EACE,YAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;AlIw4sBF;;AkIt4sBA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AlIy4sBF;;AkIv4sBA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AlI04sBF;;AkIx4sBA;EACE,2BAAA;EACA,cAAA;AlI24sBF;;AkIz4sBA;EACE,UAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;AlI44sBF;;AkI14sBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AlI64sBF;;AkI34sBA;EACE;IACE,iBAAA;ElI84sBF;AACF;AkI54sBA;EACE,UAAA;EACA,WAAA;AlI84sBF;;AkI54sBA;EACE,YAAA;EACA,cAAA;AlI+4sBF;;AkI74sBA;EACE,cAAA;AlIg5sBF;;AkI94sBA;EACE,eAAA;AlIi5sBF;;AkI/4sBA;EACE,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AlIk5sBF;;AkIh5sBA;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;AlIm5sBF;;AkIj5sBA;EACE,sEAAA;AlIo5sBF;;AkIl5sBA;EACE,qBAAA;AlIq5sBF;;AkIn5sBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AlIs5sBF;;AkIp5sBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;AlIu5sBF;;AkIr5sBA;EACE,YAAA;EACA,cAAA;EACA,yBAAA;EACA,0BAAA;AlIw5sBF;;AkIt5sBA;EACE,UAAA;EACA,WAAA;AlIy5sBF;;AkIv5sBA;EACE,MAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AlI05sBF;;AkIx5sBA;EACE,gBAAA;AlI25sBF;;AkIz5sBA;EACE,YAAA;EACA,cAAA;EACA,aAAA;AlI45sBF;;AkI15sBA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AlI65sBF;;AkI35sBA;EAEU,gCAAA;AlI85sBV;;AkI55sBA;EAEU,yCAAA;AlI+5sBV;;AkI75sBA;EAEU,qDAAA;AlIg6sBV;;AkI95sBA;EAEU,sDAAA;AlIi6sBV;AkI/4sBA;EACE;IACE,6CAAA;ElIg6sBF;EkI95sBA;IACE,uCAAA;ElIg6sBF;EkI95sBA;IACE,6CAAA;ElIg6sBF;EkI95sBA;IACE,sCAAA;ElIg6sBF;AACF;AkIx5sBA;EACE;IACE,wBAAA;IACA,UAAA;ElIg6sBF;AACF;AkIn4sBA;EACE;IACE,aAAA;IACA,cAAA;IACA,QAAA;ElIg6sBF;EkI95sBA;IACE,YAAA;IACA,aAAA;IACA,QAAA;ElIg6sBF;EkI95sBA;IACE,YAAA;IACA,aAAA;IACA,cAAA;ElIg6sBF;EkI95sBA;IACE,aAAA;IACA,YAAA;IACA,YAAA;ElIg6sBF;EkI95sBA;IACE,YAAA;IACA,cAAA;IACA,aAAA;ElIg6sBF;AACF;AkIx4sBA;EACE;IACE,YAAA;IACA,cAAA;IACA,QAAA;ElIg6sBF;EkI95sBA;IACE,WAAA;IACA,eAAA;IACA,QAAA;ElIg6sBF;EkI95sBA;IACE,aAAA;IACA,QAAA;IACA,cAAA;ElIg6sBF;EkI95sBA;IACE,aAAA;IACA,eAAA;IACA,cAAA;ElIg6sBF;AACF;AkI95sBA;EACE,gBAAA;AlIg6sBF;;AkI95sBA;EACE,uBAAA;AlIi6sBF;;AkI/5sBA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,8BAAA;EACA,6BAAA;AlIk6sBF;;AkIh6sBA;EACE,uCAAA;AlIm6sBF;;AkIj6sBA;EACE,MAAA;EACA,SAAA;EACA,2BAAA;AlIo6sBF;;AkIl6sBA;EACE,MAAA;EACA,OAAA;AlIq6sBF;;AkIn6sBA;EACE,MAAA;EACA,QAAA;AlIs6sBF;;AkIp6sBA;EACE,QAAA;EACA,SAAA;EACA,gCAAA;AlIu6sBF;;AkIr6sBA;EACE,QAAA;EACA,OAAA;EACA,2BAAA;AlIw6sBF;;AkIt6sBA;EACE,QAAA;EACA,QAAA;EACA,2BAAA;AlIy6sBF;;AkIv6sBA;EACE,SAAA;EACA,SAAA;EACA,2BAAA;AlI06sBF;;AkIx6sBA;EACE,SAAA;EACA,OAAA;AlI26sBF;;AkIz6sBA;EACE,QAAA;EACA,SAAA;AlI46sBF;;AkIz6sBA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,iCAAA;AlI46sBF;;AkI16sBA;EACE,uBAAA;AlI66sBF;;AkI36sBA;EACE,uBAAA;EACA,2BAAA;AlI86sBF;;AkI56sBA;EACE,uBAAA;EACA,yBAAA;AlI+6sBF;;AkI76sBA;EACE,mBAAA;AlIg7sBF;;AkI96sBA;EACE,mBAAA;EACA,2BAAA;AlIi7sBF;;AkI/6sBA;EACE,mBAAA;EACA,yBAAA;AlIk7sBF;;AkIh7sBA;EACE,qBAAA;AlIm7sBF;;AkIj7sBA;EACE,qBAAA;EACA,2BAAA;AlIo7sBF;;AkIl7sBA;EACE,qBAAA;EACA,yBAAA;AlIq7sBF;;AkIn7sBA;EACE,gBAAA;AlIs7sBF;;AkIp7sBA;EACE,wBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AlIu7sBF;;AkIr7sBA;EACE,wBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;AlIw7sBF;;AkIt7sBA;EACE,SAAA;EACA,sBAAA;AlIy7sBF;;AkIv7sBA;EACE,mBAAA;AlI07sBF;;AkIx7sBA;EACE,uBAAA;AlI27sBF;;AkIz7sBA;EACE,qBAAA;AlI47sBF;;AkI17sBA;EACE,wBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;AlI67sBF;;AkI37sBA;EACE,YAAA;AlI87sBF;;AkI57sBA;EACE;IACE,oBAAA;ElI+7sBF;AACF;AkI77sBA;EACE,iCAAA;AlI+7sBF;;AkI77sBA;EACE,oCAAA;AlIg8sBF;;AkI77sBA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AlIg8sBF;;AkI97sBA;EACE,aAAA;AlIi8sBF;;AkI/7sBA;EACE,kBAAA;AlIk8sBF;;AkI/7sBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AlIk8sBF;;AkI/7sBA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;AlIk8sBF;;AkI/7sBA;EACE,aAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;AlIk8sBF;;AkIh8sBA;EACE,YAAA;AlIm8sBF;;AkIj8sBA;EACE,yEAAA;AlIo8sBF;;AkIl8sBA;EACE,yEAAA;AlIq8sBF;;AkIn8sBA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;EAEQ,8DAAA;EACR,gCAAA;EACA,mBAAA;EACA,yBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EAGQ,iBAAA;AlIs8sBV;;AkIp8sBA;EACE,kBAAA;EACA,iBAAA;AlIu8sBF;;AkIr8sBA;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAEQ,8DAAA;EACR,yBAAA;EACA,kBAAA;EACA,+BAAA;EACA,4BAAA;AlIw8sBF;;AkIr8sBA;EACE,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;AlIw8sBF;;AkIt8sBA;EACE,eAAA;AlIy8sBF;;AkIv8sBA;EACE,SAAA;EACA,qBAAA;EACA,iFAAA;EAAA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AlI08sBF;;AkIx8sBA;EACE,SAAA;EACA,qBAAA;EACA,iFAAA;EAAA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AlI28sBF;;AkIz8sBA;EACE,aAAA;EACA,6DAAA;AlI48sBF;;AkI18sBA;EACE,SAAA;AlI68sBF;;AkI18sBA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,cAAA;AlI68sBF;;AkI18sBA;EACE,eAAA;EACA,mBAAA;AlI68sBF;;AkI18sBA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,MAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EAAA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AlI68sBF;;AkI38sBA;EACE,eAAA;EACA,uBAAA;EACA,cAAA;AlI88sBF;;AkI38sBA;EACE,UAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AlI88sBF;;AkI38sBA;;;;;;EAME,gBAAA;AlI88sBF;;AkI38sBA;;;EAGE,sBAAA;EACA,WAAA;EACA,8CAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,+CAAA;EACA,cAAA;EACA,kBAAA;AlI88sBF;;AkI58sBA;;;EAGE,gCAAA;EACA,sCAAA;AlI+8sBF;;AkI78sBA;;;EAGE,yBAAA;EACA,aAAA;EACA,2BAAA;AlIg9sBF;;AkI17sBA;;;EAGE,cAAA;AlIq9sBF;;AkIl9sBA;EACE,gBAAA;EACA,mBAAA;AlIq9sBF;;AkIn9sBA;EACE,UAAA;AlIs9sBF;;AkIp9sBA;EACE,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AlIu9sBF;;AkIr9sBA;;EAEE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AlIw9sBF;;AkIr9sBA;EACE,eAAA;EACA,iBAAA;AlIw9sBF;;AkIt9sBA;EACE,eAAA;AlIy9sBF;;AkIt9sBA;EACE,mBAAA;EACA,kBAAA;AlIy9sBF;;AkIt9sBA;EACE,cAAA;EACA,eAAA;AlIy9sBF;;AkIt9sBA;EACE,cAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AlIy9sBF;;AkIt9sBA;;EAEE,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AlIy9sBF;;AkIv9sBA;;EAEE,eAAA;EACA,kBAAA;AlI09sBF;;AkIx9sBA;;EAEE,eAAA;AlI29sBF;;AkIx9sBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AlI29sBF;;AkIz9sBA;EACE,YAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AlI49sBF;;AkIz9sBA;EACE;IACE,sBAAA;ElI49sBF;EkI19sBA;IACE,aAAA;ElI49sBF;AACF;AkI19sBA;EACE;IACE,sBAAA;ElI49sBF;EkI19sBA;IACE,aAAA;ElI49sBF;AACF;AkI19sBA;EACE;IACE,0CAAA;ElI49sBF;AACF;AkI19sBA;EACE,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EAGQ,iBAAA;AlI49sBV;;AkI19sBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AlI69sBF;;AkI39sBA;EACE,qBAAA;AlI89sBF;;AkI59sBA;EACE,kBAAA;EACA,YAAA;AlI+9sBF;;AkI79sBA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AlIg+sBF;;AkI99sBA;EACE,cAAA;EACA,wBAAA;AlIi+sBF;;AkI/9sBA;EACE,UAAA;EACA,yBAAA;AlIk+sBF;;AkIh+sBA;EACE,qBAAA;EACA,cAAA;AlIm+sBF;;AkIj+sBA;EACE,YAAA;AlIo+sBF;;AkIl+sBA;EACE,qBAAA;EACA,cAAA;AlIq+sBF;;AkIn+sBA;EACE,YAAA;AlIs+sBF;;AkIp+sBA;EACE,qBAAA;EACA,cAAA;AlIu+sBF;;AkIr+sBA;EACE,YAAA;AlIw+sBF;;AkIt+sBA;EACE,YAAA;AlIy+sBF;;AkIv+sBA;EACE,qBAAA;AlI0+sBF;;AkIx+sBA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,wBAAA;EACA,kBAAA;AlI2+sBF;;AkIz+sBA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,+BAAA;EACA,8BAAA;AlI4+sBF;;AkI1+sBA;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;AlI6+sBF;;AkI3+sBA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;AlI8+sBF;;AkI5+sBA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AlI++sBF;;AkI7+sBA;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AlIg/sBF;;AkI9+sBA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;AlIi/sBF;;AkI/+sBA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AlIk/sBF;;AkI/+sBA;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;AlIk/sBF;;AkIh/sBA;EACE,qBAAA;EACA,kBAAA;AlIm/sBF;;AkIj/sBA;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AlIo/sBF;;AkIl/sBA;EACE,mBAAA;AlIq/sBF;;AkIn/sBA;EACE,mBAAA;EACA,WAAA;AlIs/sBF;;AkIp/sBA;EACE,mBAAA;AlIu/sBF;;AkIr/sBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AlIw/sBF;;AkIr/sBA;EACE,wCAAA;AlIw/sBF;;AkIr/sBA;EAEU,0BAAA;AlIw/sBV;;AkIt/sBA;EAEU,eAAA;AlIy/sBV;;AkIt/sBA;EAEU,oCAAA;AlIy/sBV;;AkIv/sBA;EAEU,eAAA;AlI0/sBV;;AkIv/sBA;EACE,WAAA;EACA,OAAA;AlI0/sBF;;AkIv/sBA;EAEU,+CAAA;AlI0/sBV;;AkIx/sBA;EAEU,gDAAA;AlI2/sBV;;AkIz/sBA;EAEU,2DAAA;AlI4/sBV;;AkIz/sBA;EAEU,wCAAA;AlI4/sBV;;AkI1/sBA;EAEU,0CAAA;AlI6/sBV;AkIj/sBA;EACE;IACE,uBAAA;ElI4/sBF;EkI1/sBA;IACE,yBAAA;ElI4/sBF;AACF;AkI1/sBA;EACE;IACE,6BAAA;ElI4/sBF;EkI1/sBA;IACE,aAAA;ElI4/sBF;EkI1/sBA;IACE,2BAAA;ElI4/sBF;AACF;AmIr1vBA;;;;;;;GAAA;AAcC;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;EACA,iPAAA;EACA,kCAAA;EACA,sBAAA;AnIi1vBH;;AmI90vBC;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;AnIi1vBH;;AmI/0vBC;;;EAKE,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEQ,0BAAA;AnIk1vBX;;AmI/0vBC;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AnIk1vBH;;AmIh1vBC;;EAEE,WAAA;EACA,mBlImBa;ADg0vBhB;;AmIj1vBC;;EAEE,WAAA;EACA,mBlIiBa;ADm0vBhB;;AmIl1vBC;;EAEE,WAAA;EACA,mBlIWa;AD00vBhB;;AmIn1vBC;;EAEE,mBlISa;EkIRb,WAAA;AnIs1vBH;;AmIp1vBC;;EAEE,WAAA;EACA,mBlIIa;ADm1vBhB;;AmIr1vBC;;EAEE,WAAA;AnIw1vBH;;AmIt1vBC;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;AnIy1vBH;;AmIt1vBC;EACI,0CAAA;EACA,SAAA;AnIy1vBL;;AmIv1vBC;EACI,sBAAA;EACA,kBAAA;AnI01vBL;;AmIx1vBC;EACI,sBAAA;EACA,kBAAA;AnI21vBL;;AmIz1vBC;EACE,8BAAA;EACA,2BAAA;AnI41vBH;;AmI11vBC;EACE,gBAAA;AnI61vBH;;AmI31vBC;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AnI81vBH;;AmI51vBC;;EAEE,YAAA;AnI+1vBH;;AmI71vBC;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;AnIg2vBH;;AmI91vBC;;;EAGE,iBAAA;EACA,eAAA;EACA,gBAAA;AnIi2vBH;;AmI/1vBC;;;EAGE,iBAAA;EACA,eAAA;EACA,iBAAA;AnIk2vBH;;AmIh2vBC;;;EAGE,0BAAA;AnIm2vBH;;AmIj2vBC;;;;;;;;;EASE,YAAA;EACA,yBAAA;EACA,0BAAA;AnIo2vBH;;AmIl2vBC;EAEE,4BAAA;AnIq2vBH;;AmIn2vBC;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;AnIs2vBH;;AmIp2vBC;EACE,6BAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;AnIu2vBH;;AmIp1vBC;EACI,4BAAA;AnIu1vBL;;AmIp1vBC;EACI,6BAAA;AnIu1vBL;;AmIn1vBK;EACI,yBAAA;AnIs1vBT;;AmIl1vBC;EACI,yBlI1IW;AD+9vBhB;;AmIl1vBC;EACI,yBlI/IW;ADo+vBhB;;AmIl1vBC;EACI,yBlIrJW;AD0+vBhB;;AmIl1vBC;EACI,yBlI3JW;ADg/vBhB;;AmIl1vBC;EACI,yBlI5JW;ADi/vBhB;;AmIl1vBC;;;;;EAKI,yBlIxIwB;AD69vB7B;;AmIl1vBC;;EAEI,UAAA;EACA,kBAAA;AnIq1vBL;;AmIl1vBC;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,iCAAA;AnIq1vBH;;AoI/mwBA;;;;;EAAA;AAOA;;;EAGE,wBAAA;ApIinwBF;;AoI/mwBA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;ApIknwBF;AoI/mwBI;EACE,4BAAA;ApIinwBN;;AoI7mwBA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EAIA,oBAAA;EAIQ,mBAAA;EAIA,8BAAA;ApIgnwBV;AoI9mwBE;EACE,2BAAA;EACA,0BAAA;ApIgnwBJ;AoI7mwBE;EACE,wBAAA;ApI+mwBJ;AoI5mwBE;EACE,2BAAA;ApI8mwBJ;;AoI3mwBA;EACE,gBAAA;ApI8mwBF;;AoI5mwBA;;;;EAIE,WAAA;ApI+mwBF;;AoI7mwBA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,+BAAA;ApIgnwBF;;AoI9mwBA;EACE,6BAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;ApIinwBF;;AoI/mwBA;EACE,MAAA;EACA,OAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ApIknwBF;;AoIhnwBA;;;;EAIE,qBAAA;ApImnwBF;;AoIjnwBA;;EAEE,qBAAA;ApIonwBF;;AoIlnwBA;EACE,sBAAA;ApIqnwBF;;AoInnwBA;EACE,WAAA;ApIsnwBF;;AoIpnwBA;EACE,gBAAA;EACA,UAAA;EACA,YAAA;ApIunwBF;;AoIrnwBA;EACE,WAAA;ApIwnwBF;;AoItnwBA;EACE,WAAA;EACA,aAAA;ApIynwBF;;AoIvnwBA;;EAEE,WAAA;ApI0nwBF;;AoIxnwBA;;EAEE,WAAA;EACA,qBAAA;EACA,cAAA;ApI2nwBF;;AoIznwBA;;;EAGE,YAAA;ApI4nwBF;;AoI1nwBA;;;EAGE,gBAAA;ApI6nwBF;;AoI3nwBA;;EAEE,UAAA;ApI8nwBF;;AoI5nwBA;;EAEE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;ApI+nwBF;;AoI7nwBA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApIgowBF;;AoI9nwBA;EACE,uBAAA;ApIiowBF;;AoI/nwBA;EACE,oBAAA;ApIkowBF;;AoIhowBA;EACE,WAAA;ApImowBF;;AoIjowBA;;EAEE,mBAAA;ApIoowBF;;AoIlowBA;;EAEE,wBAAA;ApIqowBF;;AoInowBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,qBAAA;ApIsowBF;;AoIpowBA;EACE,aAAA;ApIuowBF;;AoIrowBA;EACE,gBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EAIQ,cAAA;EACR,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;ApIwowBF;;AoItowBA;EACE,sBAAA;ApIyowBF;;AoIvowBA;EACE,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;ApI0owBF;;AoIxowBA;EACE,sBAAA;ApI2owBF;;AoIzowBA;EACE,gBAAA;ApI4owBF;;AoI1owBA;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;ApI6owBF;;AoI3owBA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;ApI8owBF;;AoI5owBA;EACE,sBAAA;ApI+owBF;;AoI7owBA;EACE,WAAA;ApIgpwBF;;AoI9owBA;EACE,eAAA;EAGQ,sBAAA;ApIipwBV;;AoI/owBA;EACE,wBAAA;ApIkpwBF;;AoIhpwBA;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EAEQ,gBAAA;ApImpwBV;;AoIjpwBA;EACE,kBAAA;ApIopwBF;;AoIlpwBA;EACE,0CAAA;ApIqpwBF;;AoInpwBA;EACE,mBAAA;ApIspwBF;;AoIppwBA;EACE,eAAA;EACA,yBAAA;EAGQ,iBAAA;ApIupwBV;;AoIrpwBA;EACE,kBAAA;EACA,oBAAA;ApIwpwBF;;AoItpwBA;EACE,aAAA;ApIypwBF;;AoIvpwBA;EACE,qBAAA;ApI0pwBF;;AoIxpwBA;EACE,mBAAA;ApI2pwBF;;AoIzpwBA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EAEQ,+CAAA;EACR,oBAAA;EACA,YAAA;EAGQ,sBAAA;ApI4pwBV;;AoI1pwBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;ApI6pwBF;;AoI3pwBA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;ApI8pwBF;;AoI5pwBA;;EAEE,eAAA;ApI+pwBF;;AoI7pwBA;EACE,YAAA;ApIgqwBF;;AoI9pwBA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;ApIiqwBF;;AoI/pwBA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,QAAA;ApIkqwBF;;AoIhqwBA;EACE,kBAAA;ApImqwBF;;AoIjqwBA;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;EAIQ,wBAAA;ApIoqwBV;;AoIlqwBA;;EAEE,aAAA;ApIqqwBF;;AoInqwBA;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,iDAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;ApIsqwBF;;AoIpqwBA;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;ApIuqwBF;;AoIrqwBA;EACE,YAAA;EACA,SAAA;EACA,8CAAA;EACA,gBAAA;ApIwqwBF;;AoItqwBA;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;ApIyqwBF;;AoIvqwBA;EACE,WAAA;EACA,UAAA;ApI0qwBF;;AoIxqwBA;EACE,WAAA;EACA,UAAA;ApI2qwBF;;AoIzqwBA;;;;EAIE,cAAA;ApI4qwBF;;AoI1qwBA;;;EAGE,gBAAA;ApI6qwBF;;AoI3qwBA;EACE,WAAA;EAGQ,sBAAA;ApI8qwBV;;AoI5qwBA;EACE,UAAA;ApI+qwBF;;AoI7qwBA;EACE,WAAA;EACA,WAAA;EAGQ,sBAAA;ApIgrwBV;;AoI9qwBA;EACE,WAAA;ApIirwBF;;AoI/qwBA;EACE,kBAAA;ApIkrwBF;;AoIhrwBA;EACE,gBAAA;EACA,WAAA;EACA,WAAA;ApImrwBF;;AoI9qwBI;EACE,oBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;ApIirwBN;AoI9qwBI;EACE,+BnIvViB;ADugxBvB;AoI9qwBM;EAEE,6BAAA;ApI+qwBR;AoIxqwBI;EACE,4BAAA;ApI0qwBN;AoIvqwBI;EACE,gEAAA;EACA,yBAAA;ApIyqwBN;AoIvqwBM;EACE,+BAAA;ApIyqwBR;;AqI/oxBA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;ArIkpxBF;;AqIhpxBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;EACA,UAAA;EAEA,cAAA;ArIkpxBF;;AqIhpxBA;EACE,qBAAA;EACA,kBAAA;ArImpxBF;;AqIjpxBA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;ArIopxBF;;AqIlpxBA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,6CpIyTyB;AD41wB3B;AqInpxBE;EACI,kBAAA;EACA,gBAAA;ArIqpxBN;;AqIlpxBA;EACE,gBAAA;ArIqpxBF;;AqInpxBA;EACE,sBAAA;ArIspxBF;;AqIppxBA;;EAEE,aAAA;ArIupxBF;;AqIrpxBA;EACE,eAAA;ArIwpxBF;;AqItpxBA;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;ArIypxBF;;AqIvpxBA;EACE,sBAAA;ArI0pxBF;;AqIxpxBA;EACE,cAAA;ArI2pxBF;;AqIzpxBA;EACE,kBAAA;EACA,UAAA;ArI4pxBF;;AqI1pxBA;EACE,UAAA;ArI6pxBF;;AqI3pxBA;;EAEE,0BAAA;ArI8pxBF;;AqI5pxBA;;;;;;EAIE,0BAAA;ArIiqxBF;;AqI/pxBA;;;EAEE,0BAAA;ArImqxBF;;AqIjqxBA;EACE,cpIYc;ADwpxBhB;;AqIlqxBA;EACE,qBpISc;AD4pxBhB;;AqInqxBA;EACE,cpIOc;AD+pxBhB;;AqIpqxBA;EACE,qBpIIc;ADmqxBhB;;AqIrqxBA;EACE,cpIFc;AD0qxBhB;;AqItqxBA;EACE,qBpILc;AD8qxBhB;;AqIvqxBA;EACE,cAAA;ArI0qxBF;;AqIxqxBA;EACI,cAAA;EACA,kBAAA;EACA,UAAA;ArI2qxBJ;;AsI7xxBA;;;EAAA;AAKA;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AtI+xxBJ;AsI7xxBI;EACI,YAAA;EACA,crIqHqB;EqIpHrB,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AtI+xxBR;AsI7xxBQ;EACE,YAAA;EACA,gBAAA;AtI+xxBV;AsI3xxBI;EACI,WAAA;EACA,UAAA;AtI6xxBR;AsI1xxBI;EAEI,WAAA;AtI2xxBR;AsIxxxBI;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,crItCG;ADg0xBX;AsIxxxBQ;EACI,mBAAA;AtI0xxBZ;AsIxxxBY;EACI,UAAA;EACA,kBAAA;AtI0xxBhB;AsItxxBQ;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;AtIwxxBZ;AsIpxxBY;EACI,qBAAA;EACA,gBAAA;EACA,gBAAA;AtIsxxBhB;;AuIl2xBA;;EAAA;AAGC;EACC,2BAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,sBAAA;AvIq2xBF;;AuIl2xBA;;EAAA;AAGA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,qEAAA;EACA,YAAA;EACA,mDAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AvIq2xBF;;AuIl2xBA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,qEAAA;EACA,WAAA;EACA,mDAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;AvIq2xBF;;AuIl2xBA;;EAEE,cAAA;EACA,6BAAA;AvIq2xBF;;AuIl2xBA;;;;;;EAME,YAAA;AvIq2xBF;;AuIl2xBA;;;;;;EAME,sBAAA;EACA,YAAA;AvIq2xBF;;AuIl2xBA;;EAAA;AAGA;EACE,sBAAA;EACA,kBAAA;EACA,iEAAA;EACA,yEAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AvIq2xBF;;AuIl2xBA;EACE,sBAAA;EACA,kBAAA;EACA,gEAAA;EACA,wEAAA;EACA,UAAA;EACA,0CAAA;EACA,UAAA;EACA,mCAAA;EACA,kBAAA;AvIq2xBF;;AuIl2xBA;;;EAGE,sBAAA;EACA,YAAA;AvIq2xBF;;AuIl2xBA;;;EAGE,sBAAA;EACA,WAAA;AvIq2xBF;;AuIl2xBA,gBAAA;AACA;EACE;IACE,yBAAA;EvIq2xBF;AACF;AuIl2xBA;EACE;IACE,yBAAA;EvIo2xBF;AACF;AwIt9xBA;EACI,kBAAA;AxIw9xBJ;;AwIr9xBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AxIw9xBJ;;AwIr9xBA;EAEI,kBAAA;EACA,aAAA;EACA,cvIkFY;EuIjFZ,kBAAA;EACA,mBvIJO;EuIKP,YAAA;EACA,uBvI6T0B;EuI5T1B,iBAAA;EACA,aAAA;AxIu9xBJ;;AwIp9xBA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AxIu9xBJ;;AwIp9xBA;EACI,WAAA;EACA,YAAA;AxIu9xBJ;;AwIp9xBA;EACI,SAAA;AxIu9xBJ;;AwIp9xBA;EACI,SAAA;AxIu9xBJ;;AwIp9xBA;EACI,YAAA;EACA,aAAA;EACA,YAAA;AxIu9xBJ;;AwIp9xBA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,qEAAA;AxIu9xBJ;;AwIp9xBA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;AxIu9xBJ;;AwIp9xBA;EACI,kBAAA;AxIu9xBJ;;AwIp9xBA;EACI,SAAA;EACA,QAAA;AxIu9xBJ;;AwIp9xBA;EACI,MAAA;EACA,QAAA;AxIu9xBJ;;AwIp9xBA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;AxIu9xBJ;;AwIp9xBA;EACI,WAAA;EACA,qBAAA;EACA,wBAAA;AxIu9xBJ;;AwIp9xBA;EACI,WAAA;AxIu9xBJ;;AwIp9xBA;EACI,qBAAA;EACA,YAAA;AxIu9xBJ;;AwIp9xBA;EACI,WAAA;AxIu9xBJ;;AwIp9xBA;EACI,YAAA;AxIu9xBJ;;AwIp9xBA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AxIu9xBJ;;AwIp9xBA;EACI,eAAA;AxIu9xBJ;;AwIp9xBA;EACI,kBAAA;AxIu9xBJ;;AwIp9xBA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AxIu9xBJ;;AyI7lyBA;;;;;;;;;;EAAA;AAYA;EAAgB,WAAA;EAAW,0BAAA;EAA0B,6BAAA;EAA6B,0BAAA;EAA0B,oCAAA;EAAoC,iBAAA;AzIqmyBhJ;;AyIrmyBiK;EAAqE,uBAAA;AzI0myBtO;;AyI1myB6P;EAAwE,kBAAA;AzI8myBrU;;AyI9myBuV;EAAoD,mBAAA;AzIknyB3Y;;AyIlnyB8Z;EAAmD,mBAAA;EAAmB,gBAAA;EAAgB,mBAAA;AzIwnyBpf;;AyIxnyBugB;EAAoD,WAAA;EAAW,qBAAA;AzI6nyBtkB;;AyI7nyB2lB;EAA6C,iBAAA;AzIioyBxoB;;AyIjoyBypB;EAAmD,mBAAA;EAAmB,mBAAA;EAAmB,gBAAA;AzIuoyBlvB;;AyIvoyBkwB;EAAmD,kBAAA;EAAkB,qBAAA;EAAqB,WAAA;AzI6oyB51B;;AyI7oyBu2B;EAA2C,mBAAA;EAAmB,mBAAA;AzIkpyBr6B;;AyIlpyBw7B;EAA+C,SAAA;EAAS,mBAAA;EAAmB,iBAAA;AzIwpyBngC;;AyIxpyBohC;EAA6D,aAAA;EAAa,mBAAA;EAAmB,yBAAA;AzI8pyBjnC;;AyI9pyB0oC;EAAiD,kBAAA;EAAkB,QAAA;EAAQ,SAAA;EAAS,YAAA;EAAY,mBAAA;EAAmB,iBAAA;EAAiB,kBAAA;EAAkB,cAAA;AzIyqyBhyC;;AyIzqyB8yC;EAA0O,mBAAA;AzI6qyBxhD;;AyI7qyB2iD;EAAsE,aAAA;AzIiryBjnD;;AyIjryB8nD;EAA+L,eAAA;EAAe,kBAAA;AzIsryB50D;;AyItryB81D;EAA+b,kBAAA;EAAkB,aAAA;EAAa,cAAA;EAAc,YAAA;AzI6ryB10E;;AyI7ryBs1E;EAAkO,UAAA;EAAU,YAAA;AzIksyBlkF;;AyIlsyBklF;EAA6N,YAAA;EAAY,YAAA;AzIusyB3zF;;AyIvsyB20F;EAAoF,UAAA;AzI2syB/5F;;AyI3syBy6F;EAAsG,UAAA;AzI+syB/gG;;AyI/syByhG;EAA0C,2BAAA;AzImtyBnkG;;AyIntyB8lG;EAAgC,gBAAA;EAAgB,wBAAA;EAAwB,2BAAA;AzIytyBtqG;;AyIztyBisG;EAAmV,aAAA;AzI6tyBphH;;AyI7tyBiiH;EAAgH,gBAAA;AzIiuyBjpH;;AyIjuyBiqH;EAAsD,uBAAA;AzIquyBvtH;;AyIruyB8uH;EAA4D,wBAAA;EAAwB,gBAAA;AzI0uyBl0H;;AyI1uyBk1H;EAAqC;IAAoL,kBAAA;EzI+uyBziI;AACF;AyIhvyB8jI;EAAqC,mBAAA;AzImvyBnmI;;AyInvyBsnI;EAAoI,QAAA;EAAQ,aAAA;AzIwvyBlwI;;AyIxvyB+wI;EAAiI,QAAA;AzI4vyBh5I;;AyI5vyBw5I;EAAoE,oBAAA;AzIgwyB59I;;AyIhwyBg/I;EAAoL,qBAAA;AzIowyBpqJ;;AyIpwyByrJ;EAAgF,sBAAA;AzIwwyBzwJ;;AyIxwyB+xJ;EAA+C,sBAAA;AzI4wyB90J;;AyI5wyBo2J;EAAoD,SAAA;AzIgxyBx5J;;AyIhxyBi6J;EAAmF,eAAA;AzIoxyBp/J;;AyIpxyBmgK;EAAkF,gBAAA;AzIwxyBrlK;;AyIrxyBA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AzIwxyBF;;AyIrxyBA;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,6IAAA;AzIwxyBF;;AyItxyBA;EACE,WAAA;EACA,gBAAA;AzIyxyBF;;AyIvxyBA;EACE,UAAA;EACA,iBAAA;AzI0xyBF;;AyIvxyBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AzI0xyBF;;AyIxxyBA;EACE,cAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AzI2xyBF;;AyIzxyBA;EACE,kBAAA;AzI4xyBF;;AyI1xyBA;EACE,mBAAA;AzI6xyBF;;AyI3xyBA;EACE,yBAAA;AzI8xyBF;;AyI5xyBA;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;AzI+xyBF;;AyI7xyBA;EACE,YAAA;EACA,WAAA;EACA,cAAA;AzIgyyBF;;AyI9xyBA;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;AzIiyyBF;;AyI9xyBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,8GAAA;EACA,WAAA;AzIiyyBF;;AyI9xyBA;EACE,YAAA;EACA,WAAA;EACA,cAAA;AzIiyyBF;;AyI/xyBA;EACE,gCAAA;AzIkyyBF;;AyI9xyBA;EAAuB;IAAK,yBAAA;EzImyyB1B;AACF;AyIpyyB0Z;EAAmB,eAAA;EAAe,QAAA;EAAQ,SAAA;EAAS,YAAA;EAAY,kBAAA;EAAkB,mBAAA;EAAmB,uBAAA;EAAuB,sBAAA;EAAsB,0CAAA;EAAuC,kBAAA;EAAkB,kBAAA;EAAkB,WAAA;AzI00yBtnB;;AyI10yBioB;EAAsB,cAAA;EAAc,SAAA;EAAS,mBAAA;EAAmB,6BAAA;EAA6B,yBAAA;AzIk1yB9tB;;AyIl1yBuvB;EAAuB,YAAA;AzIs1yB9wB;;AyIt1yB0xB;EAAsC,cAAA;EAAc,aAAA;EAAwD,mBAAA;EAAmB,kBAAA;EAAkB,eAAA;AzIg2yB36B;;AyIh2yB07B;EAA4C,eAAA;EAAe,QAAA;EAAQ,SAAA;EAAS,kBAAA;EAAkB,gBAAA;AzIw2yBxhC;;AyIx2yBwiC;EAAuD,mBAAA;AzI42yB/lC;;AyI52yBknC;EAAyD,mBAAA;AzIg3yB3qC;;AyIh3yB8rC;EAAwD,mBAAA;AzIo3yBtvC;;AyIp3yBywC;EAA0E,wBAAA;EAAA,mBAAA;AzIy3yBn1C;;AyIz3yBs2C;EAAiD,YAAA;EAAY,mBAAA;EAA8D,mBAAA;EAAmB,kBAAA;EAAkB,eAAA;AzIm4yBtgD;;AyIn4yBqhD;EAAmD,YAAA;EAAY,mBAAA;EAA8D,mBAAA;EAAmB,kBAAA;EAAkB,eAAA;AzI64yBvrD;;AyI74yBssD;EAAkD,YAAA;EAAY,mBAAA;EAA8D,mBAAA;EAAmB,kBAAA;EAAkB,eAAA;AzIu5yBv2D;;AyIv5yBs3D;EAAiD,gBAAA;AzI25yBv6D;;AyI35yBu7D;EAAmE,mBAAA;EAAmB,kBAAA;EAAkB,eAAA;AzIm6yB/hE;;AyIn6yB8iE;EAA8B,eAAA;EAAe,QAAA;EAAQ,SAAA;EAAS,kBAAA;EAAkB,gBAAA;AzI26yB9nE;;AyI36yB8oE;EAAyC,mBAAA;AzI+6yBvrE;;AyI/6yB0sE;EAA2C,mBAAA;AzIm7yBrvE;;AyIn7yBwwE;EAA0C,mBAAA;AzIu7yBlzE;;AyIv7yBq0E;EAA4D,wBAAA;EAAA,mBAAA;AzI47yBj4E;;AyI57yBo5E;EAAmC,YAAA;EAAY,mBAAA;EAA8D,mBAAA;EAAmB,kBAAA;EAAkB,eAAA;AzIs8yBtiF;;AyIt8yBqjF;EAAqC,YAAA;EAAY,mBAAA;EAA8D,mBAAA;EAAmB,kBAAA;EAAkB,eAAA;AzIg9yBzsF;;AyIh9yBwtF;EAAoC,YAAA;EAAY,mBAAA;EAA8D,mBAAA;EAAmB,kBAAA;EAAkB,eAAA;AzI09yB32F;;AyI19yB03F;EAAmC,gBAAA;AzI89yB75F;;AyI99yB66F;EAA8B,eAAA;AzIk+yB38F;;AyIl+yB09F;EAAyE,aAAA;AzIs+yBniG;;AyIt+yBgjG;EAAyB,eAAA;EAAe,MAAA;EAAM,OAAA;EAAO,WAAA;EAAW,YAAA;EAAY,YAAA;AzI++yB5nG;;AyI/+yBwoG;EAAqC;IAAe,WAAA;IAAW,WAAA;IAAW,kBAAA;IAAkB,oBAAA;EzIu/yBluG;EyIv/yBsvG;IAAqB,WAAA;EzI0/yB3wG;AACF;AyI3/yByxG;EAAuG,yBAAA;AzI8/yBh4G;;AyI9/yBs5G;EAAyH,kBAAA;EAAkB,QAAA;EAAQ,SAAA;EAAS,WAAA;EAAW,YAAA;EAAY,qBAAA;EAAqB,sBAAA;EAAsB,cAAA;EAAc,YAAA;EAAY,yBAAA;EAAyB,kBAAA;EAAkB,8BAAA;EAA8B,+BAAA;EAA+B,6CAAA;EAA6C,gDAAA;EAAgD,iDAAA;EAAiD,qDAAA;EAAqD,kDAAA;AzImhzBz7H;;AyIhhzBA;EAAiC,6BAAA;EAA6B,0CAAA;EAAuC,YAAA;AzIshzBrG;;AyIthzBiH;EAAiB,UAAA;EAAU,yBAAA;EAAyB,YAAA;AzI4hzBrK;;AyIzhzBA;EAAqB,uBAAA;EAAuB,gBAAA;AzI8hzB5C;;AyI9hzB4D;EAA+D,8BAAA;EAA8B,2BAAA;EAA2B,uBAAA;AzIoizBpL;;AyIpizB2M;EAA+D,gBAAA;EAAgB,oBAAA;AzIyizB1R;;AyIzizB8S;EAA0pB,aAAA;AzI6izBx8B;;AyI7izBq9B;EAA8N,gBAAA;AzIijzBnrC;;AyIjjzBmsC;EAA+D,gBAAA;EAAgB,wBAAA;EAAwB,uBAAA;AzIujzB1yC;;AyIvjzBi0C;EAAiB,uBAAA;AzI2jzBl1C;;AyI3jzBy2C;EAAgD,uBAAA;AzI+jzBz5C;;AyI5jzBA;EAAwE,uBAAA;EAAuB,wBAAA;EAAwB,2BAAA;AzIkkzBvH;;AyIlkzBkJ;EAAqC,0BAAA;AzIskzBvL;;AyItkzBiN;EAAmC,6BAAA;AzI0kzBpP;;AyI1kzBiR;EAAa;IAA2B,aAAA;EzI+kzBvT;AACF;AyI7kzBA;EAA8D,qCAAA;AzIglzB9D;;AyI7kzBA;EAAgL,0BAAA;AzIilzBhL;;AyIjlzB0M;EAAqM,wBAAA;AzIqlzB/Y;;AyIrlzBua;EAAkJ,kBAAA;EAAkB,kBAAA;EAAkB,eAAA;AzI2lzB7lB;;AyI3lzB4mB;EAAgK,SAAA;EAAS,SAAA;EAAS,YAAA;EAAY,WAAA;EAAW,cAAA;EAAc,kBAAA;EAAkB,YAAA;EAAY,uBAAA;EAAuB,mBAAA;EAAmB,wBAAA;EAAwB,uBAAA;EAAuB,kBAAA;EAAkB,yBAAA;EAAyB,8CAAA;EAA8C,iBAAA;EAAiB,YAAA;EAAY,yBAAA;AzI+mzBhjC;;AyI/mzBykC;EAAsJ,YAAA;EAAY,yBAAA;AzIonzB3uC;;AyIpnzBowC;EAA0I,kBAAA;AzIwnzB94C;;AyIxnzBg6C;EAAwJ,QAAA;EAAQ,SAAA;EAAS,YAAA;EAAY,WAAA;EAAW,mBAAA;EAAmB,iBAAA;EAAiB,gBAAA;AzIkozBpoD;;AyIlozBopD;EAA8F,kBAAA;EAAkB,eAAA;AzIuozBpwD;;AyIvozBmxD;EAA4G,QAAA;EAAQ,SAAA;EAAS,YAAA;EAAY,WAAA;EAAW,iBAAA;EAAiB,kBAAA;EAAkB,cAAA;EAAc,kBAAA;EAAkB,YAAA;EAAY,uBAAA;EAAuB,mBAAA;EAAmB,wBAAA;EAAwB,uBAAA;EAAuB,kBAAA;EAAkB,yBAAA;EAAyB,8CAAA;EAA8C,iBAAA;EAAiB,YAAA;EAAY,yBAAA;AzI6pzBrsE;;AyI7pzB8tE;EAA0H,YAAA;EAAY,yBAAA;AzIkqzBp2E;;AyIlqzB63E;EAA+B,kBAAA;AzIsqzB55E;;AyItqzB86E;EAAqC,kCAAA;AzI0qzBn9E;;AyI1qzBq/E;EAA8C,qBAAA;EAAqB,qBAAA;EAAqB,SAAA;EAAS,UAAA;AzIirzBtlF;;AyIjrzBgmF;EAAiD,gCAAA;EAAgC,gBAAA;AzIsrzBjrF;;AyItrzBisF;EAA6D,cAAA;AzI0rzB9vF;;AyI1rzB4wF;EAA4D,mBAAA;AzI8rzBx0F;;AyI9rzB21F;EAA8C,qBAAA;EAAqB,eAAA;EAAe,iBAAA;AzIoszB76F;;AyIpszB87F;EAAc,eAAA;EAAe,sBAAA;EAAsB,MAAA;EAAM,OAAA;EAAO,YAAA;EAAY,WAAA;EAAW,YAAA;EAAY,iBAAA;AzI+szBjiG;;AyI/szBkjG;EAAoC,kBAAA;EAAkB,MAAA;EAAM,OAAA;EAAO,SAAA;EAAS,QAAA;EAAQ,UAAA;EAAU,WAAA;EAAW,cAAA;EAAc,YAAA;EAAY,YAAA;EAAY,cAAA;EAAc,yBAAA;EAAyB,uBAAA;EAAuB,oBAAA;EAAoB,0CAAA;AzIiuzBnxG;;AyIjuzB0zG;EAAoC,kBAAA;EAAkB,YAAA;AzIsuzBh3G;;AyItuzB43G;EAAkC,kBAAA;EAAkB,QAAA;EAAQ,UAAA;EAAU,WAAA;EAAW,YAAA;EAAY,yBAAA;EAAyB,yBAAA;EAAyB,kBAAA;EAAkB,kBAAA;EAAkB,eAAA;EAAe,WAAA;AzIovzB9jH;;AyIpvzBykH;EAAwC,yBAAA;AzIwvzBjnH;;AyIxvzB0oH;EAAuC,eAAA;EAAe,MAAA;EAAM,OAAA;EAAO,QAAA;EAAQ,SAAA;EAAS,YAAA;EAAY,8BAAA;AzIkwzB1uH;;AyIlwzBqwH;EAAqC;IAAoC,UAAA;EzIuwzB50H;AACF;AyIxwzBy1H;EAA+C,gBAAA;AzI2wzBx4H;;AyIxwzBA;EAA4B,iBAAA;EAAiB,yBAAA;AzI6wzB7C;;AyI1wzBA;EAA0B,6BAAA;EAA6B,YAAA;EAAY,mBAAA;EAAmB,0BAAA;EAA0B,oBAAA;EAAoB,aAAA;AzImxzBpI;;AyInxzBiJ;EAAwB,uBAAA;EAAuB,oBAAA;AzIwxzBhM;;AyIxxzBoN;EAA8B,kBAAA;AzI4xzBlP;;AyI5xzBoQ;EAA2B,kBAAA;EAAkB,YAAA;AzIiyzBjT;;AyI9xzBA;EAAQ,yBAAA;AzIkyzBR;;AyIlyzBiC;EAAkC,mBAAA;AzIsyzBnE;;AyItyzBsF;EAAwB,UAAA;AzI0yzB9G;;AyI1yzBwH;EAAkC,yFAAA;AzI8yzB1J;;AyI9yzBmP;EAAwC,UAAA;AzIkzzB3R;;AyIlzzBqS;EAA8D,aAAA;AzIszzBnW;;AyItzzBgX;EAAwC,uBAAA;AzI0zzBxZ;;AyIvzzBA;EAAqE,yBAAA;AzI2zzBrE;;AyI3zzB8F;EAAwL,yBAAA;AzI+zzBtR;;AyI/zzB+S;EAA8L,yBAAA;AzIm0zB7e;;AyIn0zBsgB;EAAwa,yBAAA;AzIu0zB96B;;AyIv0zBu8B;EAA8H,yBAAA;AzI20zBrkC;;AyI30zB8lC;EAA8H,yBAAA;AzI+0zB5tC;;AyI/0zBqvC;EAA8H,yBAAA;AzIm1zBn3C;;AyIn1zB44C;EAAgI,yBAAA;AzIu1zB5gD;;AyIv1zBqiD;EAAgI,yBAAA;AzI21zBrqD;;AyI31zB8rD;EAAgI,yBAAA;AzI+1zB9zD;;AyI/1zBu1D;EAA0G,yBAAA;AzIm2zBj8D;;AyIn2zB09D;EAA4G,yBAAA;AzIu2zBtkE;;AyIv2zB+lE;EAAiI,yBAAA;AzI22zBhuE;;AyI32zByvE;EAAiI,yBAAA;AzI+2zB13E;;AyI/2zBm5E;EAAiI,yBAAA;AzIm3zBphF;;AyIn3zB6iF;EAA0N,yBAAA;AzIu3zBvwF;;AyIv3zBgyF;EAAkF,kBAAA;AzI23zBl3F;;AyI33zBo4F;EAA8L,cAAA;EAAc,kBAAA;EAAkB,UAAA;EAAU,SAAA;EAAS,WAAA;EAAW,YAAA;EAAY,sBAAA;AzIq4zB5oG;;AyIr4zBkqG;EAAgG,YAAA;EAAY,gBAAA;EAAgB,iBAAA;EAAiB,uBAAA;EAAuB,kBAAA;AzI64zBt0G;;AyI74zBw1G;EAA0G,YAAA;EAAgB,iBAAA;EAAiB,iBAAA;EAAiB,kBAAA;EAAkB,mFAAA;AzIq5zBtgH;;AyIr5zBylH;EAAgF,kBAAA;AzIy5zBzqH;;AyIz5zB2rH;EAAqC;IAAgF,cAAA;IAAc,cAAA;EzI+5zB5zH;AACF;AyIh6zB60H;EAAsG,YAAA;AzIm6zBn7H;;AyIn6zB+7H;EAA4G,cAAA;AzIu6zB3iI;;A0I3g0BA;;;;;CAAA;AAOA;EAEE,sBAAA;EAEA,yBAAA;A1I6g0BF;;A0I1g0BA;EAEE,mCAAA;A1I6g0BF;;A0I1g0BA;EAEE,sBAAA;A1I6g0BF;;A0I1g0BA;;EAGE,yBAAA;A1I6g0BF;;A0I1g0BA;;EAGE,yBAAA;A1I6g0BF;A0Iz/zBA;EACE;IAEE,+BAAA;E1I0g0BF;E0Ivg0BA;IAEE,mCAAA;E1Iyg0BF;E0Itg0BA;IAEE,kCAAA;E1Iwg0BF;AACF;A0Irg0BA;EAEE,qBAAA;A1Iug0BF;A0Ip/zBA;EACE;IACE,UAAA;IAEA,mCAAA;E1Img0BF;E0Ihg0BA;IACE,UAAA;IAEA,eAAA;E1Ikg0BF;AACF;A0I//zBA;EAEE,0BAAA;A1Iig0BF;A0In/zBA;EACE;IACE,UAAA;E1I8/zBF;E0I3/zBA;IACE,UAAA;E1I6/zBF;AACF;A0I1/zBA;EAEE,uBAAA;A1I4/zBF;A0I7+zBA;EACE;IACE,UAAA;E1I0/zBF;E0Iv/zBA;IACE,UAAA;IAEA,kCAAA;E1Iy/zBF;AACF;A0It/zBA;EAEE,2BAAA;A1Iw/zBF;A0Iz+zBA;EACE;IACE,UAAA;E1Is/zBF;E0In/zBA;IACE,UAAA;IAEA,mCAAA;E1Iq/zBF;AACF;A0Il/zBA;EAEE,yBAAA;A1Io/zBF;;A2Irt0BA;EACI,iBAAA;EACA,kCAAA;EACA,2BAAA;EACA,UAAA;E7CkBA,4BAAA;A9F2s0BJ;A2I1t0BI;EACI,UAAA;A3I4t0BR;A4Inu0BM;EACI,mB3IiGM;ADoo0BhB;A4Ilu0BM;EACE,c3I6FQ;ADuo0BhB;A4Ilu0BQ;EACE,mB3I0FM;E2IzFN,YAAA;A5Iou0BV;A4Ilu0BQ;EACE,mB3ICC;ADmu0BX;A4Ihu0BM;;;;;EAKI,mB3I6EM;ADqp0BhB;A4Ivv0BM;EACI,mB3IiGM;ADwp0BhB;A4Itv0BM;EACE,c3I6FQ;AD2p0BhB;A4Itv0BQ;EACE,mB3I0FM;E2IzFN,YAAA;A5Iwv0BV;A4Itv0BQ;EACE,mB3ICC;ADuv0BX;A4Ipv0BM;;;;;EAKI,mB3I6EM;ADyq0BhB;A4I3w0BM;EACI,mBDgBwB;A3I6v0BlC;A4I1w0BM;EACE,cDY0B;A3Igw0BlC;A4I1w0BQ;EACE,mBDSwB;ECRxB,YAAA;A5I4w0BV;A4I1w0BQ;EACE,mB3ICC;AD2w0BX;A4Ixw0BM;;;;;EAKI,mBDJwB;A3I8w0BlC;A4I/x0BM;EACI,mB3IoGM;AD6r0BhB;A4I9x0BM;EACE,c3IgGQ;ADgs0BhB;A4I9x0BQ;EACE,mB3I6FM;E2I5FN,YAAA;A5Igy0BV;A4I9x0BQ;EACE,mB3ICC;AD+x0BX;A4I5x0BM;;;;;EAKI,mB3IgFM;AD8s0BhB;A4Inz0BM;EACI,mB3IsGM;AD+s0BhB;A4Ilz0BM;EACE,c3IkGQ;ADkt0BhB;A4Ilz0BQ;EACE,mB3I+FM;E2I9FN,YAAA;A5Ioz0BV;A4Ilz0BQ;EACE,mB3ICC;ADmz0BX;A4Ihz0BM;;;;;EAKI,mB3IkFM;ADgu0BhB;A4Iv00BM;EACI,mB3IqGM;ADou0BhB;A4It00BM;EACE,c3IiGQ;ADuu0BhB;A4It00BQ;EACE,mB3I8FM;E2I7FN,YAAA;A5Iw00BV;A4It00BQ;EACE,mB3ICC;ADu00BX;A4Ip00BM;;;;;EAKI,mB3IiFM;ADqv0BhB;A2I3z0BI;EACE,kBAAA;A3I6z0BN;A2I5z0BM;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,uBAAA;A3I8z0BV;A2I7z0BU;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,0BAAA;EACA,gB1I4VkB;E0I3VlB,c1IrCD;ADo20BX;A2I5z0BU;EACE,uBAAA;A3I8z0BZ;A2Itz0BI;;;;;EAKI,gBAAA;A3Iwz0BR;A2Irz0BI;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;A3Iuz0BR;A2Ipz0BI;EACE,mB1I2BU;E0I1BV,iC1ImQwB;E0IlQxB,kC1IkQwB;E0IjQxB,gBAAA;A3Isz0BN;A2Inz0BI;EACE,oCAAA;EACA,oC1I4PwB;E0I3PxB,qC1I2PwB;E0I1PxB,oBAAA;A3Iqz0BN;A2Inz0BM;EACE,mBAAA;A3Iqz0BR;A2Inz0BM;EACE,kBAAA;A3Iqz0BR;A2Ijz0BI;EACE,kBAAA;EACA,sBAAA;A3Imz0BN;A2Ijz0BM;EACE,aAAA;EACA,mBAAA;EAEA,uBAAA;A3Imz0BR;A2Ihz0BM;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,wB1IiOoB;ADil0B9B;A2Ihz0BU;EACI,YAAA;EACA,wB1I6NgB;E0I5NhB,gBAAA;EAGA,2BAAA;A3Ikz0Bd;A2I7y0BI;;EAEE,qBAAA;EACA,eAAA;EACA,mBAAA;EAAA,oBAAA;EACA,UAAA;EACA,sBAAA;A3I+y0BN;A2I5y0BI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;A3I8y0BR;A2I5y0BQ;EACI,qBAAA;A3I8y0BZ;A2Ity0BI;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;A3Iwy0BR;A2Iry0BI;EACI,WAAA;A3Iuy0BR;A2Ipy0BI;EACI,eAAA;A3Isy0BR;A2Iny0BI;EACI,eAAA;A3Iqy0BR;A2Iny0BQ;EACI,gBAAA;A3Iqy0BZ;A2Ijy0BI;EACI,aAAA;A3Imy0BR;A2Ihy0BI;EACI,kBAAA;EACA,oBAAA;A3Iky0BR;A2Ihy0BQ;EACG,eAAA;A3Iky0BX;A2I9x0BI;EACI,kBAAA;A3Igy0BR;A2I7x0BI;EACI,yBAAA;A3I+x0BR;A2I5x0BI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;A3I8x0BR;A2I3x0BI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;A3I6x0BR;A2I3x0BQ;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;A3I6x0BZ;A2I1x0BQ;EACI,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,c1IjII;E0IkIJ,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;A3I4x0BZ;A2Izx0BQ;EACI,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;A3I2x0BZ;A2Itx0BY;EACI,qBAAA;A3Iwx0BhB;A2Ipx0BQ;;EAEI,kBAAA;EACA,cAAA;EACA,WAAA;A3Isx0BZ;A2Ilx0BI;EACI,aAAA;A3Iox0BR;A2Ijx0BI;EACI,eAAA;EACA,mBAAA;A3Imx0BR;A2Ihx0BI;EACI,SAAA;A3Ikx0BR;A2I/w0BI;EACI,yB1IjQG;E0IkQH,wB1IkEsB;E0IjEtB,WAAA;A3Iix0BR;A2I/w0BQ;EACI,cAAA;A3Iix0BZ;A2I9w0BQ;EACI,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;A3Igx0BZ;A2I7w0BQ;;;;;EAKI,yBAAA;EACA,gBAAA;A3I+w0BZ;A2I5w0BQ;EACI,cAAA;EACA,eAAA;EACA,eAAA;A3I8w0BZ;A2Izw0BM;EACE,cAAA;EACA,WAAA;EACA,eAAA;A3I2w0BR;;A6Ilk1BA;;;EAAA;AAIA;EACC;IAAO,aAAA;E7Isk1BN;E6Irk1BD;IAAK,UAAA;E7Iwk1BJ;AACF;A6Itk1BA;EACC,0CAAA;A7Iwk1BD;;A6Irk1BA;;;EAAA;AAIA;;;EAGC,kBAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;A7Iwk1BD;;A6Irk1BA;EACC,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,OAAA;EACA,MAAA;A7Iwk1BD;;A6Irk1BA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;A7Iwk1BD;;A8Ipn1BI;EACI,wB7IgVsB;E6I/UtB,sB7IsSuB;ADi10B/B;A8Irn1BQ;EACE,kBAAA;EACA,gBAAA;A9Iun1BV;A8Itn1BU;EACE,kBAAA;A9Iwn1BZ;A8Itn1BU;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,c7I0FI;E6IzFJ,yBAAA;EACA,iBAAA;EACA,UAAA;A9Iwn1BZ;A8Irn1BQ;EACI,gBAAA;A9Iun1BZ;A8Ipn1BQ;EACI,WAAA;EACA,cAAA;EACA,mBAAA;A9Isn1BZ;A8Ipn1BY;EACI,WAAA;A9Isn1BhB;AEhp1BG;EACI,+BA+H+B;E8FlIpC,U9FIsB;E8FDtB,0BAAA;AhGop1BF;AEjp1BG;EACI,+BA2H+B;E8FlIpC,U9FQsB;E8FLtB,0BAAA;AhGyp1BF;AElp1BG;EACI,+BAuH+B;E8FlIpC,U9FYsB;E8FTtB,0BAAA;AhG8p1BF;AEnp1BG;EACI,+BAmH+B;E8FlIpC,U9FgBsB;E8FbtB,0BAAA;AhGmq1BF;AEli1BI;EACI,sCDxEqB;ECyErB,cD3HG;AD+p1BX;AEli1BQ;EACI,qBD9HD;EC+HC,6BDpHiB;ECqHjB,cDhID;ADoq1BX;AE9h1BQ;;EACI,cDvID;ADwq1BX;AE5h1BQ;EACI,6BDlIiB;ADgq1B7B;AE1h1BI;EACE,eAAA;AF4h1BN;AEzh1BI;;EAEI,uCAAA;EACA,sCDtGqB;ECuGrB,cDzJG;ADor1BX;AErh1BQ;;EAEI,uCAAA;EACA,qBDlKD;ECmKC,cDnKD;AD0r1BX;AEjh1BQ;;EACI,uCAAA;EACA,cD3KD;AD+r1BX;AElh1BY;;;;EAGI,uCAAA;EACA,cDjLL;ADss1BX;AEjh1BQ;;;;EAEI,uCAAA;AFqh1BZ;AEnh1BY;;;;;;;;;;EAGI,uCAAA;EACA,cD7LL;ADyt1BX;AEth1BgB;;;EAEI,uCAAA;EACA,cDtMT;AD+t1BX;AEph1BQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cD/MD;ADuu1BX;AEph1BY;;;;EAEI,uCAAA;EACA,cDtNL;AD8u1BX;A8Ilt1BY;;;EAGI,+B7IqBa;AD+r1B7B;A8Iht1BQ;EAEE,mB7IrCC;ADsv1BX;A8I9s1BY;EACE,c7IzCH;ADyv1BX;AElw1BG;EACI,4B4IqDqC;E9CxD1C,U9FIsB;E8FDtB,0BAAA;AhGsw1BF;AEnw1BG;EACI,4B4IiDqC;E9CxD1C,U9FQsB;E8FLtB,0BAAA;AhG2w1BF;AEpw1BG;EACI,4B4I6CqC;E9CxD1C,U9FYsB;E8FTtB,0BAAA;AhGgx1BF;AErw1BG;EACI,4B4IyCqC;E9CxD1C,U9FgBsB;E8FbtB,0BAAA;AhGqx1BF;A8I9t1Bc;EACE,qB7IqDO;AD2q1BvB;A8I5t1BY;EACE,mCAAA;EACA,c7IgDS;AD8q1BvB;A8I3t1BY;EACE,c7IiCE;E6IhCF,mCAAA;A9I6t1Bd;A8I5t1Bc;EACE,qB7IwBA;ADss1BhB;A8Ixt1Bc;;;;;;;;;;EAKI,0C7I3BW;AD0v1B7B;A8I9t1BkB;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGI,0C7I9BO;ADux1B7B;A8Inv1BsB;;;EAGI,6B7I1EG;AD+z1B7B;A8I5u1Bc;;EAEI,yB7ILF;ADmv1BhB;A8I1u1BU;EACE,mB7IeiB;E6IdjB,mCAAA;A9I4u1BZ;A8Ixu1Bc;;;EAGE,yB7I7GL;E6I8GK,qB7IzBA;ADmw1BhB;A8Itu1BkB;;EAGI,0C7IvEO;AD8y1B7B;A8Inu1BU;EACI,kBAAA;A9Iqu1Bd;A8Ilu1BU;EACI,iBAAA;A9Iou1Bd;A8Iju1BU;EACE,qB7I7BW;ADgw1BvB;A8Ihu1BU;EACE,qBAAA;A9Iku1BZ;A8I5t1BI;EACI,eAAA;EACA,qBAAA;A9I8t1BR;A8I1t1BM;EACE,c7InJG;AD+21BX;;A8Itt1BI;EAEI,kBAAA;EACA,UAAA;A9Iwt1BR;A8Irt1BI;EACI,qBAAA;EACA,kBAAA;A9Iut1BR;A8Ipt1BI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;A9Ist1BR;A8Ipt1BQ;EACI,c7I5KD;ADk41BX;A8Ilt1BI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;A9Iot1BR;A8I9s1BQ;EACI,mBAAA;EACA,+BAAA;A9Igt1BZ;A8I3s1BQ;EACI,qBAAA;A9I6s1BZ;A8I1s1BQ;EACI,2BAAA;A9I4s1BZ;A8I1s1BY;EACI,aAAA;A9I4s1BhB;A8I1s1BgB;EACI,cAAA;A9I4s1BpB;A8Izs1BgB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;A9I2s1BpB;A8Izs1BoB;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A9I2s1BxB;A8Ivs1BY;EACI,gBAAA;A9Iys1BhB;A8Ixs1BgB;EACE,mBAAA;A9I0s1BlB;A8Ins1BI;EACE,iBAAA;EACA,6CAAA;A9Iqs1BN;;AiBx31BI;E6HyLF;IACE,cAAA;IACA,mBAAA;E9Ims1BF;E8Ihs1BA;IACE,UAAA;E9Iks1BF;AACF;AiBl41BI;E6HoMF;IACE,iBAAA;E9Iis1BF;E8I7r1BE;IACI,UAAA;E9I+r1BN;AACF;A8I3r1BA;EASI;;;;IACE,aAAA;E9Iwr1BJ;AACF;A8Inr1BA;EAKI;IACE,2BAAA;E9Iir1BJ;AACF;AiBv51BI;E6HgPE;;;;IACE,wBAAA;E9I6q1BN;AACF;A+Ix+1BA;EAEE,gBAAA;A/Iy+1BF;A+Iv+1BE;EACE,c9I+GmB;AD031BvB;A+It+1BE;EACE,mB9I2GmB;AD631BvB;A+It+1BE;EACI,c9IwGiB;ADg41BvB;A+Iv+1BM;EACE,c9IsGe;ADm41BvB;A+Ir+1BE;EACE,c9IiGmB;ADs41BvB;A+Ip+1BE;EACE,c9I6FmB;ADy41BvB;A+Ip+1BE;EACE,c9IwEY;AD851BhB;A+Ir+1BI;EACE,c9IwGuB;AD+31B7B;A+In+1BE;EAEE,2BAAA;A/Io+1BJ;A+In+1BI;EACE,+B9I8BuB;ADu81B7B;A+Ij+1BE;EACE,mB9IfyB;ADk/1B7B;A+Ih+1BE;EACE,c9IuEmB;AD251BvB;A+I/91BE;EACE,c9IwDY;ADy61BhB;A+I991BE;EACE,2EAAA;A/Ig+1BJ;A+I791BE;EACE,4BAAA;A/I+91BJ;AEnh2BG;EACI,4B6IwD6B;E/C3DlC,U9FIsB;E8FDtB,0BAAA;AhGuh2BF;AEph2BG;EACI,4B6IoD6B;E/C3DlC,U9FQsB;E8FLtB,0BAAA;AhG4h2BF;AErh2BG;EACI,4B6IgD6B;E/C3DlC,U9FYsB;E8FTtB,0BAAA;AhGii2BF;AEth2BG;EACI,4B6I4C6B;E/C3DlC,U9FgBsB;E8FbtB,0BAAA;AhGsi2BF;A+I5+1BM;EACE,qB9IkDe;AD471BvB;A+I1+1BI;EACE,mCAAA;EACA,c9I6CiB;AD+71BvB;A+Iz+1BI;EACE,c9I8BU;E8I7BV,mCAAA;A/I2+1BN;A+I1+1BM;EACE,qB9IqBQ;ADu91BhB;A+It+1BM;;;;;;;;;;EAKI,0C9I9BmB;AD2g2B7B;A+I5+1BU;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGI,0C9IjCe;ADwi2B7B;A+Ijg2Bc;;;EAGI,6B9I7EW;ADgl2B7B;A+I1/1BM;;EAEI,yB9IRM;ADog2BhB;A+Ix/1BE;EACE,mB9IYyB;E8IXzB,mCAAA;A/I0/1BJ;A+It/1BM;;;EAGE,qB9I3BQ;ADmh2BhB;A+Ip/1BU;;EAGI,0C9IzEe;AD8j2B7B;A+Ij/1BE;EACI,kBAAA;A/Im/1BN;A+Ih/1BE;EACI,iBAAA;A/Ik/1BN;A+I/+1BE;EACE,qB9I/BmB;ADgh2BvB;A+I9+1BE;EACE,qBAAA;A/Ig/1BJ;A+I5+1BI;EACE,yBAAA;A/I8+1BN;A+I1+1BE;EACE,2EAAA;A/I4+1BJ;A+Iz+1BE;EACE,mBAAA;A/I2+1BJ;A+Ix+1BE;EACE,oCAAA;A/I0+1BJ;A+Ir+1BI;EACE,mB9IotB8B;ADmx0BpC;AEhp2BG;EACI,c6I2KiC;E/C9KtC,U9FIsB;E8FDtB,0BAAA;AhGop2BF;AEjp2BG;EACI,c6IuKiC;E/C9KtC,U9FQsB;E8FLtB,0BAAA;AhGyp2BF;AElp2BG;EACI,c6ImKiC;E/C9KtC,U9FYsB;E8FTtB,0BAAA;AhG8p2BF;AEnp2BG;EACI,c6I+JiC;E/C9KtC,U9FgBsB;E8FbtB,0BAAA;AhGmq2BF;A+It/1BM;EACE,qBAAA;A/Iw/1BR;A+In/1BU;;;;;;;;;;;EAII,yBAAA;A/I4/1Bd;A+I3/1Bc;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGI,yBAAA;A/Iyh2BlB;A+Inh2BkB;;;;;EAEI,yBAAA;A/Iwh2BtB;A+Inh2BU;;;;;;;EAEI,yBAAA;A/I0h2Bd;A+Irh2BM;;;EAEI,yBAAA;EACA,kBAAA;EACA,c9I3MC;ADmu2BX;A+Iph2BM;;;;;EAGE,qB9I7HQ;ADqp2BhB;A+Iph2BI;EACE,c9IvNK;AD6u2BX;A+Inh2BI;EACE,+B9IxKuB;AD6r2B7B;A+I/g2BE;EAEE,yBAAA;EACA,kDAAA;A/Igh2BJ;A+I/g2BI;EACE,c9I3IU;AD4p2BhB;A+Ihh2BM;EACE,c9I7IQ;AD+p2BhB;A+I/g2BI;EACE,c9ItIiB;ADup2BvB;A+I7g2BM;EACE,c9I3Ie;AD0p2BvB;A+I1g2BI;EACE,c9InKU;AD+q2BhB;A+Izg2BK;EACE,c9IrJgB;ADgq2BvB;A+I1g2BQ;EACE,oCAAA;A/I4g2BV;A+Ixg2BK;EACG,c9IzIqB;E8I0IrB,0CAAA;A/I0g2BR;A+Izg2BQ;EACE,oCAAA;A/I2g2BV;A+Izg2BQ;EACE,c9IxQC;ADmx2BX;A+Itg2BI;EACI,c9IrJqB;AD6p2B7B;A+Ipg2BI;EACE,gBAAA;A/Isg2BN;A+Ijg2BQ;EACE,c9InKmB;ADsq2B7B;A+I7/1BM;EACE,c9I1KqB;ADyq2B7B;A+I5/1BQ;EACE,c9IpSC;ADky2BX;A+I1/1BI;EACE,uB9I9RuB;E8I+RvB,gBAAA;A/I4/1BN;A+Iv/1BQ;EACE,4BAAA;A/Iy/1BV;A+Ix/1BU;EACE,c9IvNI;ADit2BhB;A+Ij/1BM;EACE,uCAAA;A/Im/1BR;A+I/+1BI;;;;;;EAMI,mCAAA;EACA,iBAAA;EACA,sBAAA;EACA,uCAAA;A/Ii/1BR;A+I/+1BI;EAAyC,sBAAA;A/Ik/1B7C;A+Ih/1BI;EACE,4BAAA;A/Ik/1BN;A+I9+1BE;EACE,c9I7OmB;AD6t2BvB;A+I7+1BE;EACE,c9IjPmB;ADgu2BvB;A+I3+1BM;EACE,iCAAA;EACA,2CAAA;A/I6+1BR;A+I5+1BQ;EACE,c9I3QM;ADyv2BhB;A+I1+1BM;EACE,c9I9Pe;AD0u2BvB;A+Ix+1BE;EACE,mCAAA;A/I0+1BJ;A+Iz+1BI;EACE,c9IrQiB;ADgv2BvB;A+Ix+1BI;EACE,c9IzQiB;ADmv2BvB;A+In+1BE;EACI,YAAA;EACA,c9IpSU;ADyw2BhB;A+Il+1BE;EACE,mBAAA;A/Io+1BJ;A+Ij+1BE;EACM,qB9IrQqB;ADwu2B7B;A+Ih+1BG;EACE,c9IhTW;ADkx2BhB;A+Ij+1BK;EACE,c9IlTS;ADqx2BhB;A+I/91BG;EACE,2EAAA;A/Ii+1BL;A+I991BG;EACE,mB9InYwB;ADm22B7B;A+I991BK;EACE,c9I5SgB;AD4w2BvB;A+I791BK;EACE,c9IhSsB;AD+v2B7B;A+I591BK;EACE,c9IpTgB;ADkx2BvB;A+I391BK;EACE,c9IxTgB;ADqx2BvB;A+Iz91BG;EACE,mBAAA;EACA,c9I9TkB;ADyx2BvB;A+I191BK;EACE,mBAAA;A/I491BP;A+It91BK;EACG,c9I7aG;ADq42BX;A+Ij91BO;EACE,mB9IrbE;ADw42BX;A+Ij91BO;EACE,oCAAA;A/Im91BT;A+Ih91BO;EACE,c9ItVc;ADwy2BvB;A+I781BO;EACE,mCAAA;A/I+81BT;A+I781BO;EACE,c9I/Vc;AD8y2BvB;A+I781BO;EACE,c9IjVoB;ADgy2B7B;A+Ix81BG;EACE,mB9IhdM;AD052BX;A+Iz81BK;EACE,c9I5WgB;ADuz2BvB;A+Ix81BK;EACE,2B9ItdI;E8IudJ,0B9IvdI;ADi62BX;A+It81BG;EACE,yB9IxWwB;ADgz2B7B;;AgJl72BA;EACI,mB/Ii4BgC;E+Ih4BhC,SAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,6C/IyVuB;AD4l2B3B;AgJn72BI;EACE,+BAAA;AhJq72BN;AgJl72BI;EACE,sBAAA;AhJo72BN;AgJj72BI;EACE,aAAA;AhJm72BN;AgJj72BM;EACE,eAAA;EACA,gBAAA;AhJm72BR;AgJh72BM;EACE,c/IXG;E+IYH,uBAAA;EACA,gB/IkXsB;E+IjXtB,sBAAA;AhJk72BR;AgJ/62BM;EACE,+BAAA;AhJi72BR;AgJ562BI;EAIE,oBAAA;EACA,SAAA;EACA,+BAAA;AhJ262BN;AgJh72BM;EACE,6BAAA;AhJk72BR;AgJ562BM;EACI,c/IhCC;E+IiCD,gBAAA;AhJ862BV;AgJ362BM;EACE,c/IiFqB;E+IhFrB,kBAAA;EACA,gBAAA;AhJ662BR;AgJz62BI;EACI,wB/IyRsB;ADkp2B9B;AgJz62BQ;EACE,aAAA;AhJ262BV;AgJv62BI;EACE,mB/IpDK;AD692BX;AgJv62BM;EACE,c/IoCQ;ADq42BhB;AgJv62BM;EACE,c/I6DqB;AD422B7B;AE5+2BG;EACI,4B8IuEiC;EhD1EtC,U9FIsB;E8FDtB,0BAAA;AhGg/2BF;AE7+2BG;EACI,4B8ImEiC;EhD1EtC,U9FQsB;E8FLtB,0BAAA;AhGq/2BF;AE9+2BG;EACI,4B8I+DiC;EhD1EtC,U9FYsB;E8FTtB,0BAAA;AhG0/2BF;AE/+2BG;EACI,4B8I2DiC;EhD1EtC,U9FgBsB;E8FbtB,0BAAA;AhG+/2BF;AgJt72BU;EACE,qB/ImCW;ADq52BvB;AgJp72BQ;EACE,mCAAA;EACA,c/I8Ba;ADw52BvB;AgJn72BQ;EACE,c/IeM;E+IdN,mCAAA;AhJq72BV;AgJp72BU;EACE,qB/IMI;ADg72BhB;AgJn72BQ;EACE,c/ICM;ADo72BhB;AgJh72BU;;;;;;;;;;EAKE,0C/IhDiB;ADu+2B7B;AgJt72Bc;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,0C/InDa;ADog3B7B;AgJ382BkB;;;EAEE,6B/I9FS;AD4i3B7B;AgJr82BU;;EAEI,yB/IzBE;ADg+2BhB;AgJn82BM;EACE,mB/ILqB;E+IMrB,mCAAA;AhJq82BR;AgJj82BU;;;EAGE,yB/IjID;E+IkIC,qB/I7CI;ADg/2BhB;AgJ/72Bc;;EAGI,0C/I3FW;AD2h3B7B;AgJ572BM;EACI,kBAAA;AhJ872BV;AgJ372BM;EACI,iBAAA;AhJ672BV;AgJ172BM;EACE,qB/IjDe;AD6+2BvB;AgJz72BM;EACE,qBAAA;AhJ272BR;AgJt72BI;EACE,uBAAA;EACA,gBAAA;AhJw72BN;AgJr72BI;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;AhJu72BR;AgJp72BI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AhJs72BR;AgJn72BI;EACI,0B/IkMsB;E+IjMtB,kBAAA;AhJq72BR;AgJj72BI;EACI,6BAAA;EACA,SAAA;EACA,aAAA;AhJm72BR;AgJ/62BY;EACI,iBAAA;EACA,kBAAA;AhJi72BhB;AgJ562BQ;EACE,gBAAA;EACA,cAAA;AhJ862BV;;AgJz62BA;EACE,gB/I8pBkC;AD8w1BpC;;AiJxo3BA;EACE,gBAAA;AjJ2o3BF;AiJxo3BM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AjJ0o3BR;AiJvo3BI;EACE,kBAAA;AjJyo3BN;AiJto3BI;EACE,iBAAA;EACA,kBAAA;AjJwo3BN;AiJvo3BM;EACE,UAAA;AjJyo3BR;AiJto3BE;EACE,gBAAA;AjJwo3BJ;AiJto3BI;EACE,gBAAA;EACA,iDAAA;AjJwo3BN;AiJpo3BE;EACE,gBAAA;EACA,eAAA;AjJso3BJ;AiJno3BE;EACE,aAAA;EACA,WAAA;AjJqo3BJ;AiJno3BE;EACE,gBAAA;AjJqo3BJ;AiJno3BI;EACE,chJyFuB;AD4i3B7B;AiJjo3BE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AjJmo3BJ;AiJjo3BI;EACE,SAAA;AjJmo3BN;AiJ9n3BI;EACE,oBAAA;EACA,YAAA;AjJgo3BN;AiJ7n3BI;EACE,mBAAA;AjJ+n3BN;AiJ9n3BM;EACE,eAAA;AjJgo3BR;;AiBzn3BI;EgIIE;IACE,mBhJgTsB;IgJ/StB,SAAA;EjJyn3BN;AACF;AkJzs3BA;EACI,aAAA;AlJ2s3BJ;;AmJ5s3BA;EACE,gBAAA;AnJ+s3BF;AmJ9s3BI;EACI,aAAA;AnJgt3BR;AmJ7s3BI;EACI,kBAAA;EACA,oBAAA;EACA,gBAAA;AnJ+s3BR;AmJ7s3BQ;EACI,gBAAA;AnJ+s3BZ;AmJ5s3BQ;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AnJ8s3BV;AmJ7s3BU;ErDiDN,mCqDhDuC;ErDoDvC,6FAAA;EAkHF,iEAAA;EAKA,yBAAA;EqDzKU,iBAAA;EACA,kBAAA;AnJwt3BZ;AmJrt3BU;ErD0CN,mCqDzCuC;ErD6CvC,6FAAA;EAkHF,iEAAA;EAKA,wBAAA;EqDlKU,iBAAA;EACA,mBAAA;AnJgu3BZ;AmJ7t3BU;ErDmCN,mCqDlCuC;ErDsCvC,6FAAA;EAkHF,iEAAA;EAKA,yBAAA;EqD3JU,iBAAA;EACA,YAAA;AnJwu3BZ;AmJpu3BU;ErD2BN,mCqD1BuC;ErD8BvC,6FAAA;EAkHF,iEAAA;EAKA,yBAAA;EqDnJU,iBAAA;EACA,YAAA;AnJ+u3BZ;AmJzu3BI;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,gClJ9BuB;EkJ+BvB,6BlJ/BuB;EkJgCvB,kBAAA;AnJ2u3BN;AmJxu3BI;EACI,iBAAA;AnJ0u3BR;AmJvu3BI;EACI,gBAAA;AnJyu3BR;AmJtu3BI;EACI,kBAAA;EACA,kBAAA;AnJwu3BR;AmJru3BI;EACE,gBAAA;AnJuu3BN;;AoJjz3BA;EACE,aAAA;ApJoz3BF;AoJlz3BE;EACE,iBAAA;EACA,kBAAA;ApJoz3BJ;AoJhz3BI;EACE,kBAAA;EACA,gBnJmYwB;AD+62B9B;AoJ/y3BI;EACE,YAAA;EACA,cAAA;ApJiz3BN;AoJ3y3BI;EACE,cnJ6GuB;EmJ5GvB,gBAAA;ApJ6y3BN;AoJ5y3BM;EACE,cnJZG;AD0z3BX;;AqJv03BA;EACE,qDAAA;ArJ003BF;AqJz03BE;EACE,kCAAA;ArJ203BJ;;AsJ903BI;EACI,kBAAA;EACA,uBrJsBqB;EqJrBrB,gBAAA;AtJi13BR;AsJ/03BQ;EACI,kBAAA;EACA,qBAAA;AtJi13BZ;AsJ/03BY;EACI,cAAA;EACA,+BAAA;AtJi13BhB;AsJ903BgB;EACI,YAAA;EACA,kBAAA;EACA,crJiFJ;EqJhFI,QAAA;AtJg13BpB;AsJ303BY;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;AtJ603BhB;AsJt03BQ;EACI,oBAAA;EACA,qBAAA;EACA,+BAAA;AtJw03BZ;AsJp03BU;EACE,aAAA;AtJs03BZ;;AuJj33BE;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AvJo33BJ;AuJj33BE;EACE,iBAAA;AvJm33BJ;AuJh33BE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AvJk33BJ;AuJ923BI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;AvJg33BN;AuJ523BE;EACE,SAAA;AvJ823BJ;AuJ323BE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BtJ0ByB;ADm13B7B;;AiB303BI;EsI1BF;IACE,sBAAA;EvJy23BF;EuJv23BE;IACE,mBAAA;EvJy23BJ;AACF;AwJ353BQ;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,gDvJuVe;ADsk3B3B;;AiBx23BI;EuI9CF;IACE,gBAAA;ExJ053BF;AACF;AyJ163BA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AzJ463BJ;AyJ163BI;EACE,gBAAA;EACA,UAAA;AzJ463BN;AyJ163BI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,cxJ2FU;EwJ1FV,yBAAA;EACA,iBAAA;EACA,UAAA;AzJ463BN;AyJ163BM;EACE,iBAAA;EACA,kBAAA;AzJ463BR;AyJx63BI;EACE,kBAAA;EACA,wBxJwTwB;EwJvTxB,MAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;AzJ063BN;AyJt63BM;EACE,kBAAA;EACA,UAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AzJw63BR;AyJv63BQ;EAEE,gBAAA;AzJw63BV;AyJp63BM;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AzJs63BR;AyJn63BM;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;AzJq63BR;AyJh63BI;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;AzJk63BR;AyJh63BQ;EACI,+BAAA;EACA,uBxJnDiB;EwJoDjB,kBAAA;EACA,gBAAA;EACA,gBxJgUkB;EwJ/TlB,cAAA;EACA,YAAA;AzJk63BZ;AyJ953BI;EACE,mBxJxEK;ADw+3BX;AyJ953BQ;EACE,YAAA;AzJg63BV;AyJ553BQ;EACI,cxJgBW;AD843BvB;AyJ753BY;EACE,cxJcS;ADi53BvB;AyJ153BM;EAEE,cxJOe;ADo53BvB;AyJx53BM;EACE,uBxJlFqB;AD4+3B7B;AyJp53BQ;EACE,8BAAA;AzJs53BV;AyJh53BM;EACE,8BAAA;AzJk53BR;AyJ543BQ;EACE,6BAAA;AzJ843BV;AyJv43BQ;EACE,+BAAA;AzJy43BV;AyJl43BQ;EACE,8BAAA;AzJo43BV;AyJ/33BI;EACE,UAAA;EACA,mDAAA;EACA,eAAA;EACA,iBAAA;EACA,wBxJyLwB;ADws3B9B;AyJh43BM;EACE,wBxJuLsB;AD2s3B9B;;AiBl+3BI;EwIwGE;IACI,gBAAA;EzJ833BR;EyJ733BO;IACC,0BAAA;IACA,6BAAA;EzJ+33BR;EyJ533BI;IACE,UAAA;EzJ833BN;EyJ733BM;IACE,gBAAA;EzJ+33BR;EyJ933BQ;IACE,gBAAA;EzJg43BV;EyJ533BI;IACE,eAAA;EzJ833BN;EyJ733BM;IACE,yBAAA;IACA,4BAAA;EzJ+33BR;AACF;A0Jxj4BA;EACI,gBAAA;EACA,kBAAA;A1J0j4BJ;A0Jxj4BI;EACI,aAAA;A1J0j4BR;A0Jtj4BQ;EACI,gBAAA;A1Jwj4BZ;A0Jtj4BY;EACI,eAAA;A1Jwj4BhB;A0Jjj4BI;EACI,gBAAA;EACA,iBAAA;EACA,oBAAA;A1Jmj4BR;A0Jjj4BQ;EACI,6BAAA;A1Jmj4BZ;A0Jhj4BQ;EACI,gBAAA;A1Jkj4BZ;A0J7i4BQ;EACI,aAAA;A1J+i4BZ;A0J3i4BQ;EACI,mBAAA;A1J6i4BZ;;A2Jtl4BA;EACE,uBAAA;EACA,gBAAA;A3Jyl4BF;A2Jvl4BE;;EAEE,cAAA;EACA,eAAA;EACA,6BAAA;A3Jyl4BJ;A2Jtl4BE;EACI,eAAA;EACA,gBAAA;A3Jwl4BN;;A4Jrm4BA;EACE,gBAAA;A5Jwm4BF;A4Jtm4BI;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;A5Jwm4BR;A4Jrm4BI;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;A5Jum4BR;A4Jpm4BI;EACI,iBAAA;A5Jsm4BR;A4Jnm4BI;EACI,gBAAA;EACA,iBAAA;A5Jqm4BR;A4Jnm4BQ;EACE,kBAAA;A5Jqm4BV;A4Jjm4BI;EACE,iBAAA;EACA,gBAAA;A5Jmm4BN;A4Jjm4BM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,c3JqEQ;E2JpER,yBAAA;EACA,iBAAA;EACA,UAAA;A5Jmm4BR;A4J/l4BI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;A5Jim4BN;A4J9l4BI;EACI,gBAAA;EACA,kBAAA;A5Jgm4BR;A4J9l4BQ;;EAEI,gBAAA;EACA,iBAAA;EACA,+CAAA;A5Jgm4BZ;A4J5l4BI;EACI,mBAAA;EACA,gBAAA;A5J8l4BR;A4J1l4BM;EACE,c3JvDG;ADmp4BX;;AiBxl4BI;E2IEF;IACE,UAAA;E5J0l4BF;AACF;A6Jtq4BE;EACE,gBAAA;A7Jwq4BJ;;A6Jjq4BG;EACE,YAAA;EACA,WAAA;EACA,kBAAA;E/DcH,mB7FyEc;E6FrEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fup4BF;A6Jxq4BK;EACE,c5JFI;E4JGJ,gBAAA;EACA,kBAAA;A7J0q4BP;A6Jtq4BK;E/DIH,mB7F8Ec;E6F1Ed,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fqq4BF;A6J3q4BK;E/DAH,mB7F6Ec;E6FzEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9F8q4BF;A6Jhr4BK;E/DJH,mB7F2Ec;E6FvEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fur4BF;A6Jrr4BK;E/DRH,mB7F4Ec;E6FxEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fgs4BF;A6J1r4BK;E/DZH,mB7FyEc;E6FrEd,4EAAA;EACA,0BAAA;EACA,8BAAA;A9Fys4BF;A6J9r4BG;EACE,iBAAA;A7Jgs4BL;A6J/r4BK;EACE,aAAA;A7Jis4BP;A6J/r4BK;EACE,gBAAA;EACA,c5JkFsB;AD+m4B7B;A6J7r4BG;EACE,UAAA;A7J+r4BL;A6J5r4BG;EACE,qBAAA;A7J8r4BL;A6J3r4BG;EACE,+BAAA;EACA,iBAAA;EACA,gBAAA;A7J6r4BL;A6Jzr4BI;EACE,mCAAA;A7J2r4BN;;AiBxr4BI;E4IGF;IACE,aAAA;E7Jyr4BF;AACF;A8Jvw4BA;EACI,oBAAA;A9Jyw4BJ;;A+Jvw4BI;EACI,iBAAA;A/J0w4BR;A+Jvw4BI;EACI,gBAAA;A/Jyw4BR;A+Jtw4BI;EACI,aAAA;EACA,qBAAA;A/Jww4BR;A+Jrw4BQ;EACI,gBAAA;A/Juw4BZ;A+Jnw4BQ;EACI,eAAA;A/Jqw4BZ;A+Jlw4BQ;EACI,c9JyEI;AD2r4BhB;A+Jjw4BQ;EACI,c9JwEI;AD2r4BhB;A+Jhw4BQ;EACI,c9JsEI;AD4r4BhB;A+J/v4BQ;EACI,c9JiEI;ADgs4BhB;A+J9v4BQ;EACI,c9J2DI;ADqs4BhB;;AgKzy4BE;EACE,oBAAA;AhK4y4BJ;;AiBru4BI;E+IjEF;IACE,eAAA;IACA,WAAA;IACA,kBAAA;EhK0y4BF;EgKvy4BA;IACE,gBAAA;IACA,WAAA;IACA,kBAAA;EhKyy4BF;AACF;AiK3z4BA;EACE,UAAA;EACA,YAAA;AjK6z4BF;AiK5z4BE;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AjK8z4BJ;;AkKx04BA;EACE,cAAA;EACA,aAAA;EACA,SAAA;AlK204BF;;AkKz04BA;EACE,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;AlK404BF;;AkK104BA;EACE,mBAAA;AlK604BF;;AkK304BA;EACE,SAAA;EACA,UAAA;AlK804BF;;AkK504BA;EACE,sBAAA;EACA,YAAA;EAGA,aAAA;EAGA,sBAAA;EAGA,oBAAA;AlK+04BF;;AkK704BA;;;EAGE,mBAAA;AlKg14BF;;AkK904BA;;EAEE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AlKi14BF;;AkK/04BA;;;;EAIE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlKk14BF;;AkKh14BA;EACE,cAAA;AlKm14BF;;AkKj14BA;EACE,cAAA;EACA,YAAA;AlKo14BF;;AkK/04BA;;;;;;EAME,gBAAA;EAGA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AlKk14BF;AkKh14BI;;;;;;EACE,mBAAA;AlKu14BN;AkKp14BE;;;;;;EACE,gBAAA;AlK214BJ;;AkKv14BA;EACE,kBAAA;EAGA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;AlK014BF;;AkKx14BA;EAGE,aAAA;EAGA,mBAAA;EACA,kBAAA;EACA,eAAA;AlK214BF;;AkKz14BA;EAGE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AlK414BF;;AkK114BA;EACE,iBjK6M2B;EiK5M3B,gBjK8Q4B;EiK7Q5B,0BjKkQ4B;EiKjQ5B,mBjK1E4B;EiK2E5B,eAAA;EACA,YAAA;EACA,gBAAA;EACA,wBjK6M4B;EiK5M5B,iBAAA;EACA,eAAA;EAGA,gCAAA;EACA,aAAA;EACA,yBAAA;EpEnHA,mB7F4Ec;E6FxEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FoGY;E8FnGZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;ADu+4BX;AkKv24BE;EACE,SAAA;AlKy24BJ;A+Fn/4BI;EACE,gCAAA;EACA,4BAAA;A/Fq/4BN;A+Fl/4BI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/F4+4BR;A+Fz+4BI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/F2+4BN;A+Fx+4BI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/Fy+4BR;A+Fl+4BQ;EAMI,yB9FmDI;E8FlDJ,qB9FkDI;AD664BhB;A+Fp44BI;EACI,c9F1CQ;E8F2CR,qB9F3CQ;E8F4CR,uB9FzHqB;AD+/4B7B;A+Fp44BQ;EAII,c9FlDI;E8FmDJ,qB9FnDI;E8FoDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/Fm44BZ;A+Fh44BQ;EACE,gCAAA;A/Fk44BV;A+Fj44BU;EAII,c9FvJH;E8FwJG,qB9FhEE;E8FiEF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/Fg44Bd;A+F334BI;EACI,c9F5EQ;ADy84BhB;A+F534BQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/F434BZ;;AkKn64BA;EACE,aAAA;AlKs64BF;;AkKp64BA;EACE,qBAAA;AlKu64BF;AkKr64BI;EACE,YAAA;AlKu64BN;;AkKl64BA;EACE,iBAAA;AlKq64BF;;AkKn64BA;EACE;IACE,sBAAA;ElKs64BF;AACF;AkKn64BA;EACE,iBAAA;AlKq64BF;;AkK/54BA;;EAEE,iBAAA;AlKk64BF;;AkK/54BA;EACE,eAAA;EACA,oBAAA;AlKk64BF;;AkKh64BA;EACE,yBAAA;AlKm64BF;;AkKj64BA;EACE,cAAA;AlKo64BF;;AkKl64BA;EACE,kDAAA;AlKq64BF;;AkKn64BA;EACE,yBAAA;EACA,4BAAA;AlKs64BF;;AkKp64BA;EACE,0BAAA;EACA,6BAAA;AlKu64BF;;AkKr64BA;EACE,yBAAA;EACA,0BAAA;AlKw64BF;;AkKt64BA;EACE,4BAAA;EACA,6BAAA;AlKy64BF;;AkKv64BA;EACE,4BAAA;EACA,6BAAA;AlK064BF;;AkKx64BA;EACE,yBAAA;EACA,0BAAA;AlK264BF;;AkKz64BA;EAGE,aAAA;EAGA,mBAAA;AlK464BF;;AkK164BA;EACE,oBAAA;AlK664BF;;AkK364BA;EACE,oCAAA;AlK864BF;;AkK564BA;EACE,0CAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AlK+64BF;;AkK764BA;EACE,kBAAA;EAGA,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,WAAA;EAGA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AlKg74BF;;AkK964BA;EACE,gBAAA;AlKi74BF;;AkK/64BA;EAGE,aAAA;EAGA,mBAAA;AlKk74BF;;AkK/64BA;EAGE,aAAA;EACA,kBAAA;EAGA,sBAAA;EAGA,SAAA;EAEA,4BAAA;EAEA,gBAAA;EACA,YAAA;AlKg74BF;;AkK964BA;EACE,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AlKi74BF;;AkK/64BA;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlKk74BF;;AkKh74BA;EACE,iBAAA;AlKm74BF;;AkKj74BA;;;EAGE,YAAA;EACA,qBAAA;AlKo74BF;;AkKl74BA;EAGE,aAAA;EAGA,mBAAA;EAGA,SAAA;EACA,gBAAA;AlKq74BF;;AkKn74BA;EAGE,SAAA;AlKs74BF;;AkKp74BA;EACE,8BAAA;AlKu74BF;;AkKr74BA;EACE,oBAAA;EACA,+BAAA;AlKw74BF;;AkKt74BA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;AlKy74BF;;AkKv74BA;EACE,eAAA;AlK074BF;;AkKx74BA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;AlK274BF;;AkKz74BA;EAGE,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,cAAA;AlK474BF;;AkK174BA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;AlK674BF;;AkK374BA;EACE,iBAAA;EACA,mBAAA;AlK874BF;;AkK574BA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;AlK+74BF;;AkK774BA;EACE,8BAAA;AlKg84BF;;AkK974BA;EACE,oBAAA;EACA,+BAAA;AlKi84BF;;AkK/74BA;EACE,6BAAA;AlKk84BF;;AkKh84BA;EACE,gBAAA;EACA,gBAAA;EACA,gCAAA;AlKm84BF;;AkKj84BA;EACE,iBAAA;AlKo84BF;;AkKl84BA;EACE,yBAAA;EACA,+BAAA;AlKq84BF;;AkKn84BA;EACE,aAAA;AlKs84BF;;AkKp84BA;EACE,aAAA;AlKu84BF;;AkKr84BA;EACE,+BAAA;AlKw84BF;;AkKt84BA;;EAEE,mBAAA;AlKy84BF;;AkKv84BA;EACE,WAAA;EACA,+BAAA;AlK084BF;;AkKx84BA;EAGE,aAAA;EAGA,sBAAA;EACA,gBAAA;AlK284BF;;AkKz84BA;EAGE,SAAA;EACA,sBAAA;AlK484BF;;AkK184BA;EACE,gCAAA;EACA,gBAAA;EAGA,aAAA;EAGA,wBAAA;AlK684BF;;AkK384BA;;EAIE,UAAA;AlK884BF;;AkK584BA;EACE,cAAA;AlK+84BF;;AkK784BA;EACE,kBAAA;AlKg94BF;;AkK984BA;EACE,SAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;AlKi94BF;;AkK/84BA;EACE,UAAA;EACA,QAAA;AlKk94BF;;AkKh94BA;EAGE,aAAA;EACA,gBAAA;EACA,gBAAA;EAGA,sBAAA;EAGA,uBAAA;EACA,gBAAA;EACA,kBAAA;AlKm94BF;;AkKj94BA;EAGE,UAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EAGA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AlKo94BF;;AkKl94BA;EACE,WAAA;EAGA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AlKq94BF;;AkKn94BA;EACE,8BAAA;AlKs94BF;;AkKp94BA;EAGE,SAAA;AlKu94BF;;AkKr94BA;EACE,iBAAA;AlKw94BF;;AkKt94BA;EACE,kBAAA;AlKy94BF;;AkKv94BA;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AlK094BF;;AkKx94BA;EACE,YAAA;AlK294BF;;AkKz94BA;EAGE,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AlK494BF;;AkK194BA;EACE,mBAAA;AlK694BF;;AkK394BA;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;AlK894BF;;AkK594BA;EACE,kBAAA;EACA,UAAA;AlK+94BF;;AkK794BA;EACE,sBAAA;EACA,gBAAA;AlKg+4BF;;AkK994BA;EAGE,aAAA;EAGA,cAAA;EAGA,mBAAA;AlKi+4BF;;AkK/94BA;EACE,4BAAA;AlKk+4BF;;AkKh+4BA;EACE,qBAAA;EACA,2BAAA;AlKm+4BF;;AkKj+4BA;EACE,6BAAA;AlKo+4BF;;AkKl+4BA;EACE,6BAAA;AlKq+4BF;;AkKn+4BA;EAGE,SAAA;EACA,YAAA;EAGA,sBAAA;EACA,8BAAA;AlKs+4BF;;AkKp+4BA;EACE,oBAAA;EACA,+BAAA;AlKu+4BF;;AkKr+4BA;EAGE,aAAA;EAGA,SAAA;EAGA,uBAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AlKw+4BF;;AkKt+4BA;EAGE,UAAA;AlKy+4BF;;AkKv+4BA;EACE,8BAAA;AlK0+4BF;;AkKx+4BA;EACE,oBAAA;EACA,+BAAA;AlK2+4BF;;AkKz+4BA;EACE,WAAA;EAGA,iBAAA;EACA,yBAAA;AlK4+4BF;;AkK1+4BA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;AlK6+4BF;;AkK3+4BA;EACE,WAAA;EACA,kBAAA,EAAA,kDAAA;EACA,cAAA,EAAA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBjK1iBc,EiK0iBc,6BAAA;EAE5B,mBAAA,EAAA,sCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AlK6+4BF;AkK3+4BE;EACE,yBjK/iBY;AD4h6BhB;AkK3+4BE;EACE,yBAAA;AlK6+4BJ;AkK3+4BE;EACE,yBjKpjBY;ADii6BhB;AkK3+4BE;EACE,yBjKtjBY;ADmi6BhB;AkK1+4BE;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AlK4+4BJ;;AkKz+4BA;EACE,yBAAA;EACA,2BAAA;EAAA,8BAAA;AlK4+4BF;;AkKz+4BA;EACE,yBAAA;AlK4+4BF;;AkK1+4BA;EACE;IACE,cAAA;ElK6+4BF;EkK5+4BE;IACE,cAAA;IACA,kBAAA;ElK8+4BJ;EkK5+4BE;IACE,cAAA;IACA,kBAAA;IACA,UAAA;ElK8+4BJ;AACF;AkK3+4BA;EACE,gCAAA;AlK6+4BF;;AkK1+4BE;EACE,aAAA;EAAA,mBAAA;AlK6+4BJ;;AkK1+4BA;EACE,iBAAA;AlK6+4BF;;AiB9m6BI;EiJooBF;IACE,gBAAA;ElK8+4BF;AACF;AiBpn6BI;EiJyoBF;IACE,gBAAA;ElK8+4BF;AACF;AmKls6BA;EACE,6BAAA;EA6BA,uBAAA;AnKwq6BF;AmKps6BE;;EAEE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;AnKss6BJ;AmKps6BE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AnKss6BJ;AmKps6BE;EACE,YAAA;AnKss6BJ;;AoKlu6BA;;;;;;EAAA;AAUA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAGA,wEAAA;EACA,iPAAA;EACA,kCAAA;EACA,sBAAA;ApKiu6BF;;AoK9t6BA;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;ApKiu6BF;;AoK/t6BA;;;EAKE,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,0BAAA;ApKku6BF;;AoKhu6BA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;ApKmu6BF;;AoKju6BA;;EAEE,WAAA;EACA,mBnKuBc;AD6s6BhB;;AoKlu6BA;;EAEE,WAAA;EACA,mBnKqBc;ADgt6BhB;;AoKnu6BA;;EAEE,WAAA;EACA,mBnKec;ADut6BhB;;AoKpu6BA;;EAEE,mBnKac;EmKZd,WAAA;ApKuu6BF;;AoKru6BA;;EAEE,WAAA;EACA,mBnKQc;ADgu6BhB;;AoKtu6BA;;EAEE,WAAA;ApKyu6BF;;AoKvu6BA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;ApK0u6BF;;AoKvu6BA;EACE,0CAAA;EACA,SAAA;ApK0u6BF;;AoKxu6BA;EACE,sBAAA;EACA,kBAAA;ApK2u6BF;;AoKzu6BA;EACE,sBAAA;EACA,kBAAA;ApK4u6BF;;AoK1u6BA;EACE,8BAAA;EACA,2BAAA;ApK6u6BF;;AoK3u6BA;EACE,gBAAA;ApK8u6BF;;AoK5u6BA;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;ApK+u6BF;;AoK7u6BA;;EAEE,YAAA;ApKgv6BF;;AoK9u6BA;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;ApKiv6BF;;AoK/u6BA;;;EAGE,iBAAA;EACA,eAAA;EACA,gBAAA;ApKkv6BF;;AoKhv6BA;;;EAGE,iBAAA;EACA,eAAA;EACA,iBAAA;ApKmv6BF;;AoKjv6BA;;;EAGE,0BAAA;ApKov6BF;;AoKlv6BA;;;;;;;;;EASE,YAAA;EACA,yBAAA;EACA,0BAAA;ApKqv6BF;;AoKnv6BA;EAEE,4BAAA;ApKsv6BF;;AoKpv6BA;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;ApKuv6BF;;AoKrv6BA;EACE,6BAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;ApKwv6BF;;AoKru6BA;EACE,4BAAA;ApKwu6BF;;AoKru6BA;EACE,6BAAA;ApKwu6BF;;AoKpu6BE;EACE,yBAAA;ApKuu6BJ;;AoKnu6BA;EAGE,yBnKxIc;AD426BhB;;AoKju6BA;EAGE,yBnK/Ic;ADi36BhB;;AoK/t6BA;EAGE,yBnKvJc;ADu36BhB;;AoK7t6BA;EAGE,yBnK/Jc;AD636BhB;;AoK3t6BA;EAGE,yBnKlKc;AD836BhB;;AoKzt6BA;;;;;EAKE,yBnK9I2B;AD026B7B;;AoKzt6BA;;EAEE,UAAA;EACA,kBAAA;ApK4t6BF;;AoKzt6BA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,iCAAA;ApK4t6BF;;AoKzt6BA;EACE,YAAA;EAAA,eAAA;ApK4t6BF;;AqKhg7BA;EACE,iBAAA;EACA,kCAAA;EACA,2BAAA;EACA,UAAA;E/IYI,yB+IXJ;ArKmg7BF;AsBp/6BM;E+IpBN;I/IqBQ,gBAAA;EtBu/6BN;AACF;AqKtg7BE;EACE,UAAA;ArKwg7BJ;A4I/g7BM;EACI,mB3IiGM;ADg76BhB;A4I9g7BM;EACE,c3I6FQ;ADm76BhB;A4I9g7BQ;EACE,mB3I0FM;E2IzFN,YAAA;A5Igh7BV;A4I9g7BQ;EACE,mB3ICC;AD+g7BX;A4I5g7BM;;;;;EAKI,mB3I6EM;ADi86BhB;AqKvh7BE;EACE,6BAAA;EAAA,yBAAA;ArKyh7BJ;AqKvh7BE;EACE,cAAA;EACA,WAAA;EACA,eAAA;ArKyh7BJ;A4I3i7BM;EACI,mB3IiGM;AD486BhB;A4I1i7BM;EACE,c3I6FQ;AD+86BhB;A4I1i7BQ;EACE,mB3I0FM;E2IzFN,YAAA;A5I4i7BV;A4I1i7BQ;EACE,mB3ICC;AD2i7BX;A4Ixi7BM;;;;;EAKI,mB3I6EM;AD696BhB;A4I/j7BM;EACI,mByByBoB;ArKwi7B9B;A4I9j7BM;EACE,cyBqBsB;ArK2i7B9B;A4I9j7BQ;EACE,mByBkBoB;EzBjBpB,YAAA;A5Igk7BV;A4I9j7BQ;EACE,mB3ICC;AD+j7BX;A4I5j7BM;;;;;EAKI,mByBKoB;ArKyj7B9B;A4Inl7BM;EACI,mB3IoGM;ADi/6BhB;A4Ill7BM;EACE,c3IgGQ;ADo/6BhB;A4Ill7BQ;EACE,mB3I6FM;E2I5FN,YAAA;A5Iol7BV;A4Ill7BQ;EACE,mB3ICC;ADml7BX;A4Ihl7BM;;;;;EAKI,mB3IgFM;ADkg7BhB;A4Ivm7BM;EACI,mB3IsGM;ADmg7BhB;A4Itm7BM;EACE,c3IkGQ;ADsg7BhB;A4Itm7BQ;EACE,mB3I+FM;E2I9FN,YAAA;A5Iwm7BV;A4Itm7BQ;EACE,mB3ICC;ADum7BX;A4Ipm7BM;;;;;EAKI,mB3IkFM;ADoh7BhB;A4I3n7BM;EACI,mB3IqGM;ADwh7BhB;A4I1n7BM;EACE,c3IiGQ;AD2h7BhB;A4I1n7BQ;EACE,mB3I8FM;E2I7FN,YAAA;A5I4n7BV;A4I1n7BQ;EACE,mB3ICC;AD2n7BX;A4Ixn7BM;;;;;EAKI,mB3IiFM;ADyi7BhB;AqKtm7BE;EACE,kBAAA;ArKwm7BJ;AqKvm7BI;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,uBAAA;ArKym7BN;AqKxm7BM;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,0BAAA;EACA,gBpKmVsB;EoKlVtB,cpK9CG;ADwp7BX;AqKvm7BM;EAEE,uBAAA;ArKwm7BR;AqKnm7BE;;;;;EAKE,gBAAA;ArKqm7BJ;AqKlm7BE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;ArKom7BJ;AqKjm7BE;EACE,mBpKoBY;EoKnBZ,iCpK4P0B;EoK3P1B,kCpK2P0B;EoK1P1B,gBAAA;ArKmm7BJ;AqKhm7BE;EACE,oCAAA;EACA,oCpKqP0B;EoKpP1B,qCpKoP0B;AD826B9B;AqKhm7BI;EACE,mBAAA;ArKkm7BN;AqKhm7BI;EACE,kBAAA;ArKkm7BN;AqK9l7BE;EACE,kBAAA;EACA,sBAAA;ArKgm7BJ;AqK9l7BI;EACE,aAAA;EACA,mBAAA;EAEA,uBAAA;EACA,eAAA;ArKgm7BN;AqK7l7BI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,wBpK0NwB;ADq46B9B;AqK7l7BM;EACE,YAAA;EACA,wBpKsNsB;EoKrNtB,gBAAA;EAGA,2BAAA;ArK+l7BR;AqK1l7BE;;EAEE,qBAAA;EACA,eAAA;EACA,mBAAA;EAAA,oBAAA;EACA,UAAA;EACA,sBAAA;ArK4l7BJ;AqKzl7BE;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;ArK2l7BJ;AqKzl7BI;EACE,qBAAA;ArK2l7BN;AqKvl7BE;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ArKyl7BJ;AqKtl7BE;EACE,WAAA;ArKwl7BJ;AqKrl7BE;EACE,eAAA;ArKul7BJ;AqKpl7BE;EACE,eAAA;ArKsl7BJ;AqKpl7BI;EACE,gBAAA;ArKsl7BN;AqKll7BE;EACE,aAAA;ArKol7BJ;AqKjl7BE;EACE,kBAAA;EACA,oBAAA;ArKml7BJ;AqKjl7BI;EACE,eAAA;ArKml7BN;AqK/k7BE;EACE,kBAAA;ArKil7BJ;AqK9k7BE;EACE,yBAAA;ArKgl7BJ;AqK7k7BE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;ArK+k7BJ;AqK5k7BE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;ArK8k7BJ;AqK5k7BI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;ArK8k7BN;AqK3k7BI;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,cpKpIU;EoKqIV,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;ArK6k7BN;AqK1k7BI;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;ArK4k7BN;AqKvk7BM;EACE,qBAAA;ArKyk7BR;AqKrk7BI;;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;ArKuk7BN;AqKnk7BE;EACE,aAAA;ArKqk7BJ;AqKlk7BE;EACE,eAAA;EACA,mBAAA;ArKok7BJ;AqKjk7BE;EACE,SAAA;ArKmk7BJ;AqKhk7BE;EACE,yBpKpQO;EoKqQP,wBpK+D0B;EoK9D1B,WAAA;ArKkk7BJ;AqKhk7BI;EACE,cAAA;ArKkk7BN;AqK/j7BI;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;ArKik7BN;AqK9j7BI;;;;;EAKE,yBAAA;EACA,gBAAA;ArKgk7BN;AqK7j7BI;EACE,cAAA;EACA,eAAA;EACA,eAAA;ArK+j7BN;;AsKj37BA;;CAAA;AAGA;EACE,kBAAA;AtKo37BF;AsKn37BE;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AtKq37BJ;AsKl37BI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;AtKo37BN;;AsKh37BA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gDAAA;EACA,oCAAA;EACA,4BAAA;EACA,gBAAA;AtKm37BF;AsKj37BE;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;AtKm37BJ;AsKj37BE;EACE,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AtKm37BJ;;AsK/27BA;EACE,cAAA;EACA,SAAA;AtKk37BF;;AsKh37BA;EACE,gBAAA;EACA,gBAAA;AtKm37BF;;AsKh37BA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AtKm37BF;AsKl37BE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;AtKo37BJ;;AsKh37BA;EACE,WAAA;EACA,SAAA;EACA,gCAAA;AtKm37BF;;AsKj37BA;;EAEE,kBAAA;EACA,YAAA;AtKo37BF;;AsKl37BA;EACE,eAAA;AtKq37BF;;AsKn37BA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AtKs37BF;AsKr37BE;EAGE,oCAAA;EACA,yBAAA;AtKq37BJ;;AsKh37BI;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AtKm37BN;AsKj37BI;EACE,crKNuB;ADy37B7B;AsKl37BM;EAEE,crK3CQ;EqK4CR,gBAAA;AtKm37BR;;AsK727BA;;;;;;EAME,mBAAA;EACA,eAAA;AtKg37BF;;AsK927BA;EACE,kBAAA;AtKi37BF;;AsK/27BA;EACE,yBAAA;AtKk37BF;;AsKh37BA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AtKm37BF;;AsKh37BA;EACE,cAAA;AtKm37BF;;AsKj37BA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AtKo37BF;;AsKl37BA;EACE,eAAA;EACA,mBAAA;AtKq37BF;;AsKn37BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AtKs37BF;;AsKp37BA;;EAEE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AtKu37BF;AsKt37BE;;EACE,QAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yCAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,mCAAA;AtKy37BJ;AsKv37BE;;EACE,aAAA;AtK037BJ;;AsKr37BE;;;;;EAKE,crK3HY;ADm/7BhB;;AsKn37BE;EACE,gBAAA;AtKs37BJ;;AsKj37BE;EACE,gBAAA;AtKo37BJ;;AsKh37BA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AtKm37BF;;AsKh37BA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AtKm37BF;;AsKj37BA;EACE,eAAA;AtKo37BF;;AsKl37BA;EACE,mBAAA;AtKq37BF;;AsKl37BA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AtKq37BF;;AsKn37BA;EACE,sBAAA;AtKs37BF;;AsKn37BA;EACE,WAAA;EACA,YAAA;AtKs37BF;;AsKn37BA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;AtKs37BF;;AsKp37BA;;EAEE,gBAAA;AtKu37BF;;AsKp37BA;EACE,qBAAA;AtKu37BF;;AsKn37BE;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AtKs37BJ;AsKp37BE;EACE,QAAA;EACA,6BAAA;AtKs37BJ;;AsKl37BA;EACE,aAAA;AtKq37BF;;AsKl37BA;EACE,WAAA;AtKq37BF;AsKp37BE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;AtKs37BJ;;AsKj37BI;EACE,crK7NU;EqK8NV,kBAAA;EACA,yBAAA;AtKo37BN;;AsK/27BA;EACE,YAAA;EACA,kBAAA;AtKk37BF;;AsKh37BA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,crK7M2B;EqKkN3B,4BAAA;EAEA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AtKk37BF;;AsKn17BA;EACE,gBAAA;EACA,cAAA;AtKs17BF;;AsKp17BA;EACE,kBAAA;EACA,iBAAA;AtKu17BF;;AsKp17BA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;AtKu17BF;;AsKp17BA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AtKu17BF;;AsKr17BA;;EAEE,oBAAA;AtKw17BF;AsKv17BE;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AtK217BJ;AsKz17BI;;;;EACE,oCAAA;EACA,crKjZK;AD+u8BX;;AuK7v8BA;EACE,kBAAA;AvKgw8BF;;AuK7v8BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AvKgw8BF;;AuK7v8BA;EAEE,kBAAA;EACA,aAAA;EACA,ctKkFc;EsKjFd,kBAAA;EACA,mBtKJS;EsKKT,YAAA;EACA,uBtK6T4B;EsK5T5B,iBAAA;EACA,aAAA;AvK+v8BF;;AuK5v8BA;;;EAGE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AvK+v8BF;;AuK5v8BA;;EAEE,WAAA;EACA,YAAA;AvK+v8BF;;AuK5v8BA;EACE,SAAA;AvK+v8BF;;AuK5v8BA;EACE,SAAA;AvK+v8BF;;AuK5v8BA;EACE,YAAA;EACA,aAAA;EACA,YAAA;AvK+v8BF;;AuK5v8BA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,qEAAA;AvK+v8BF;;AuK3v8BA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AvK8v8BF;;AuK3v8BA;EACE,kBAAA;AvK8v8BF;;AuK3v8BA;EACE,SAAA;EACA,QAAA;AvK8v8BF;;AuK3v8BA;EACE,MAAA;EACA,QAAA;AvK8v8BF;;AuK3v8BA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;AvK8v8BF;;AuK3v8BA;EACE,WAAA;EACA,qBAAA;EACA,wBAAA;AvK8v8BF;;AuK3v8BA;EACE,WAAA;AvK8v8BF;;AuK3v8BA;EACE,qBAAA;EACA,YAAA;AvK8v8BF;;AuK3v8BA;EACE,WAAA;AvK8v8BF;;AuK3v8BA;EACE,YAAA;AvK8v8BF;;AuK3v8BA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AvK8v8BF;;AuK3v8BA;EACE,eAAA;AvK8v8BF;;AuK3v8BA;EACE,kBAAA;AvK8v8BF;;AuK3v8BA;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AvK8v8BF;;AwKx48BA;;;;;;CAAA;AAQA;;CAAA;AAKE;EACE,SAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,gDAAA;EACA,yGAAA;EAEA,yBvKTO;EuKUP,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,oBAAA;EACA,gBAAA;EAAA,sBAAA;EACA,aAAA;EAAA,mBAAA;AxKu48BJ;AwKt48BI;EACE,iCAAA;EACA,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AxKw48BN;AwKr48BI;EACE,UAAA;EACA,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AxKu48BN;AwKp48BE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EAAA,uBAAA;EACA,cAAA;EAAA,oBAAA;EACA,kBAAA;AxKs48BJ;AwKp48BE;EACE,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EAKA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AxKs48BJ;AwKl48BM;EAEE,6BAAA;AxKm48BR;AwK938BU;EAEE,yBvK2CiB;ADo18B7B;AwK138BQ;EAEE,yBAAA;AxK238BV;AwKv38BQ;EAEE,cAAA;EACA,eAAA;AxKw38BV;AwKn38BE;EACE,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;AxKq38BJ;AwKp38BI;EAEE,yBAAA;EACA,gBAAA;EACA,6BAAA;AxKq38BN;AwKj38BQ;EACE,yBAAA;EACA,SAAA;AxKm38BV;AwKh38BM;EAEE,yBAAA;EACA,gBAAA;AxKi38BR;AwK728BM;EACE,oBAAA;EACA,kBAAA;EACA,6BAAA;AxK+28BR;AwK928BQ;EACE,oBAAA;AxKg38BV;AwK928BQ;EACE,gBAAA;AxKg38BV;AwK728BM;EACE,QAAA;EACA,cvKhDQ;AD+58BhB;AwK528BI;EACE,cvKnBuB;EuKoBvB,mBAAA;EACA,mBAAA;EACA,QAAA;AxK828BN;AwK528BI;;EAEE,mBAAA;AxK828BN;AwK528BI;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AxK828BN;AwK728BM;EACE,aAAA;AxK+28BR;AwK728BM;EACE,UAAA;EACA,qBAAA;AxK+28BR;AwK528BQ;EACE,6BAAA;EACA,0CAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AxK828BV;AwK528BQ;EACE,yBvKlKmB;ADgh9B7B;AwK528BQ;EACE,aAAA;AxK828BV;AwK128BQ;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AxK428BV;AwK128BQ;EACE,aAAA;AxK428BV;AwKp28BQ;EAEE,qBvKlHM;ADu98BhB;AwKj28BQ;;EAEE,cvKxHM;AD298BhB;AwK/18BI;EACE,yBAAA;AxKi28BN;AwKh28BM;EACE,6BvKtGe;EuKuGf,6CAAA;AxKk28BR;AwKj28BQ;EACE,cvKlIM;EuKmIN,6BAAA;AxKm28BV;AwK318BQ;EAEE,qBvK3IM;ADu+8BhB;AwKx18BQ;;EAEE,cvKjJM;AD2+8BhB;AwKt18BI;EACE,yBAAA;AxKw18BN;AwKv18BM;EACE,6BvKhIe;EuKiIf,6CAAA;AxKy18BR;AwKx18BQ;EACE,cvK3JM;EuK4JN,6BAAA;AxK018BV;AwKl18BQ;EAEE,qBvKrKM;ADw/8BhB;AwK/08BQ;;EAEE,cvK3KM;AD4/8BhB;AwK708BI;EACE,yBAAA;AxK+08BN;AwK908BM;EACE,8BvK1Je;EuK2Jf,8CAAA;AxKg18BR;AwK/08BQ;EACE,cvKrLM;EuKsLN,6BAAA;AxKi18BV;AwKz08BQ;EAEE,qBvK/LM;ADyg9BhB;AwKt08BQ;;EAEE,cvKrMM;AD6g9BhB;AwKp08BI;EACE,yBAAA;AxKs08BN;AwKr08BM;EACE,8BvKpLe;EuKqLf,8CAAA;AxKu08BR;AwKt08BQ;EACE,cvK/MM;EuKgNN,6BAAA;AxKw08BV;AwKh08BQ;EAEE,qBvKzNM;AD0h9BhB;AwK7z8BQ;;EAEE,cvK/NM;AD8h9BhB;AwK3z8BI;EACE,yBAAA;AxK6z8BN;AwK5z8BM;EACE,6BvK9Me;EuK+Mf,6CAAA;AxK8z8BR;AwK7z8BQ;EACE,cvKzOM;EuK0ON,6BAAA;AxK+z8BV;AwK1z8BE;EACE,yBAAA;AxK4z8BJ;AwK3z8BI;EACE,kBAAA;EACA,+BvK9RuB;EuK+RvB,+CAAA;AxK6z8BN;AwK5z8BM;EACE,cvK1NqB;EuK2NrB,6BAAA;AxK8z8BR;AwKxz8BM;EACE,aAAA;AxK0z8BR;AwKxz8BM;EACE,yBAAA;EACA,yBAAA;AxK0z8BR;AwKvz8BI;EACE,yBAAA;AxKyz8BN;AwKtz8BE;EACE,cAAA;EACA,iBAAA;AxKwz8BJ;;AwKrz8BA;EACE,cAAA;AxKwz8BF;;AwKrz8BE;EACE,yBAAA;EACA,4BAAA;EACA,cAAA;AxKwz8BJ;;AwKpz8BE;EACE,0BAAA;EACA,6BAAA;EACA,eAAA;EACA,WAAA;AxKuz8BJ;;AyK5r9BA;EACE,kBAAA;EAGA,aAAA;EAIA,sBAAA;EACA,6BAAA;AzK+r9BF;;AyK5r9BE;EACE,iBAAA;AzK+r9BJ;AyK7r9BE;EACE,gBAAA;AzK+r9BJ;AyK7r9BE;EACE,kBAAA;AzK+r9BJ;;AyK5r9BA;EACE,sBAAA;AzK+r9BF;;AyK7r9BA;EAGE,YAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AzKgs9BF;;AyK9r9BA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EACA,yBAAA;EAGA,iBAAA;AzKis9BF;;AyK/r9BA;EACE,+BAAA;EACA,4CAAA;AzKks9BF;;AyKhs9BA;EACE,4CAAA;AzKms9BF;;AyKjs9BA;;;;EAIE,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,wBAAA;EACA,+BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oGAAA;EAEA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,6BAAA;EACA,uBAAA;AzKms9BF;AyKls9BE;;;;EACE,qBxKeY;EwKdZ,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,+BAAA;AzKus9BJ;AyKrs9BE;;;;EACE,cxKxEO;ADkx9BX;;AyKvs9BA;EACE,kBAAA;AzK0s9BF;;AyKxs9BA;EACE,iBAAA;AzK2s9BF;;AyKxs9BE;EAEE,kBAAA;EACA,cAAA;EACA,YAAA;AzK0s9BJ;AyKxs9BE;EACE,UAAA;EACA,YAAA;AzK0s9BJ;AyKxs9BE;EACE,YAAA;EACA,YAAA;EACA,UAAA;AzK0s9BJ;;AyKts9BE;EACE,UAAA;AzKys9BJ;;AyKrs9BE;EACE,UAAA;AzKws9BJ;;AyKrs9BA;;EAEE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mEAAA;EACA,qCAAA;AzKws9BF;;AyKts9BA;;EAEE,eAAA;AzKys9BF;;AyKvs9BA;;EAEE,eAAA;AzK0s9BF;;AyKxs9BA;EACE,iBAAA;AzK2s9BF;;AyKzs9BA;EACE,gBAAA;AzK4s9BF;;AyK1s9BA;EACE,gBAAA;EACA,uBAAA;AzK6s9BF;AyK5s9BE;EACE,aAAA;AzK8s9BJ;;AyK3s9BA;EACE,2BAAA;AzK8s9BF;;AyK5s9BA;;EAEE,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AzK+s9BF;;AyK7s9BA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AzKgt9BF;;AyK9s9BA;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AzKit9BF;;AyK/s9BA;EAGE,kBAAA;EAGA,aAAA;EAIA,sBAAA;EACA,cAAA;AzKkt9BF;;AyKht9BA;EACE,4CAAA;AzKmt9BF;;AyKjt9BA;EACE,gBAAA;AzKot9BF;;AyKlt9BA;EACE,eAAA;AzKqt9BF;;AyKnt9BA;EACE,eAAA;AzKst9BF;;AyKpt9BA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;AzKut9BF;;AyKrt9BA;EAGE,cAAA;EAGA,oBAAA;AzKwt9BF;;AyKtt9BA;;EAIE,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uDAAA;EACA,YAAA;AzKyt9BF;;AyKvt9BA;;EAEE,6BAAA;EACA,sCAAA;AzK0t9BF;;AyKxt9BA;EACE,iBAAA;EACA,sBAAA;EACA,0CAAA;AzK2t9BF;;AyKzt9BA;;EAEE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AzK4t9BF;;AyK1t9BA;EACE,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AzK6t9BF;;AyK3t9BA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EAEA,+CAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EACA,eAAA;AzK8t9BF;;AyK5t9BA;EAEE,0CAAA;AzK+t9BF;;AyK7t9BA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AzKgu9BF;;AyK9t9BA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EACA,0CAAA;AzKiu9BF;;AyK/t9BA;EACE,2CAAA;AzKku9BF;;AyKhu9BA;EACE,eAAA;AzKmu9BF;;AyKju9BA;EACE,+BAAA;AzKou9BF;;AyKlu9BA;EACE,+BAAA;AzKqu9BF;;AyKnu9BA;EACE,UAAA;EAGA,aAAA;EAGA,8BAAA;EAGA,oBAAA;EAEA,eAAA;EACA,YAAA;AzKsu9BF;;AyKpu9BA;EACE,iBxKb2B;EwKc3B,gBxKyM4B;EwKxM5B,cxKuM4B;EwKtM5B,mBxKpS4B;EwKqS5B,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBxKf4B;EwKgB5B,kBAAA;EACA,eAAA;E3EzUA,mB7F4Ec;E6FxEd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB9FoGY;E8FnGZ,0BAAA;EACA,gBAAA;EAwII,c9F9HG;EwKuVT,WAAA;EACA,wBAAA;AzKiv9BF;A+Fll+BI;EACE,gCAAA;EACA,4BAAA;A/Fol+BN;A+Fjl+BI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,c9FVG;E8FWH,gBAAA;A/F2k+BR;A+Fxk+BI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;A/F0k+BN;A+Fvk+BI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;A/Fwk+BR;A+Fjk+BQ;EAMI,yB9FmDI;E8FlDJ,qB9FkDI;AD4g+BhB;A+Fn+9BI;EACI,c9F1CQ;E8F2CR,qB9F3CQ;E8F4CR,uB9FzHqB;AD8l+B7B;A+Fn+9BQ;EAII,c9FlDI;E8FmDJ,qB9FnDI;E8FoDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;A/Fk+9BZ;A+F/99BQ;EACE,gCAAA;A/Fi+9BV;A+Fh+9BU;EAII,c9FvJH;E8FwJG,qB9FhEE;E8FiEF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;A/F+99Bd;A+F199BI;EACI,c9F5EQ;ADwi+BhB;A+F399BQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/F299BZ;;AyK7y9BA;EACE,YAAA;EACA,mBAAA;AzKgz9BF;;AyK9y9BA;EACE,WAAA;AzKiz9BF;;AyK/y9BA;;EAIE,SAAA;EACA,kBAAA;AzKkz9BF;;AyKhz9BA;EAGE,WAAA;EACA,kBAAA;EACA,gBAAA;EAGA,aAAA;EAIA,mBAAA;EAEA,eAAA;EAGA,mBAAA;EAEA,6BAAA;AzKmz9BF;;AyKjz9BA;EACE,qBAAA;EACA,gBAAA;AzKoz9BF;;AyKlz9BA;EACE,qBAAA;AzKqz9BF;;AyKnz9BA;EACE,gBAAA;AzKsz9BF;;AyKpz9BA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EAEA,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;AzKuz9BF;;AyKrz9BA;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AzKwz9BF;;AyKtz9BA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,yBAAA;EAEA,2BAAA;EACA,yDAAA;AzKyz9BF;;AyKvz9BA;EACE,UAAA;EACA,UAAA;EACA,mBAAA;AzK0z9BF;;AyKxz9BA;EAEE,0BAAA;AzK2z9BF;;AyKzz9BA;;EAEE,2BAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;AzK4z9BF;;AyKzz9BA;EACE,aAAA;AzK4z9BF;;AyK1z9BA;EACE,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;AzK6z9BF;;A0Kpx+BA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A1Kux+BF;;A0Kpx+BA;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;A1Kux+BF;A0Ktx+BE;EACE,gBAAA;A1Kwx+BJ;;A0Kpx+BA;EACE,eAAA;EACA,iBAAA;A1Kux+BF;;A0Kpx+BA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;A1Kux+BF;;A0Krx+BA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;A1Kwx+BF;;A0Krx+BA;EACE,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;A1Kwx+BF;;A0Kpx+BE;EAKE,6BAAA;EjI/DF,cAAA;EACA,yBxCgGc;ADuv+BhB;A0Kvx+BI;EACE,mBAAA;A1Kyx+BN;A0Kvx+BM;EACE,UAAA;EACA,kBAAA;A1Kyx+BR;AOh1+BE;EkCVI,cAAA;EACA,yBAAA;AzC61+BN;AyC11+BI;EAEE,UAAA;EACA,0CAAA;AzC21+BN;;A0K5x+BI;EjI3EF,cAAA;EACA,yBxCiGc;AD0w+BhB;AO71+BE;EkCVI,cAAA;EACA,yBAAA;AzC02+BN;AyCv2+BI;EAEE,UAAA;EACA,2CAAA;AzCw2+BN;;A0Kty+BI;EjI9EF,cAAA;EACA,yBxCoGc;ADox+BhB;AO12+BE;EkCVI,cAAA;EACA,yBAAA;AzCu3+BN;AyCp3+BI;EAEE,UAAA;EACA,2CAAA;AzCq3+BN;;A0Khz+BI;EjIjFF,cAAA;EACA,yBxCmGc;ADky+BhB;AOv3+BE;EkCVI,cAAA;EACA,yBAAA;AzCo4+BN;AyCj4+BI;EAEE,UAAA;EACA,0CAAA;AzCk4+BN;;A0K1z+BI;EjIpFF,cAAA;EACA,yBxCqGc;AD6y+BhB;AOp4+BE;EkCVI,cAAA;EACA,yBAAA;AzCi5+BN;AyC94+BI;EAEE,UAAA;EACA,4CAAA;AzC+4+BN;;A0Kp0+BI;EjIvFF,cAAA;EACA,yBxCsGc;ADyz+BhB;AOj5+BE;EkCVI,cAAA;EACA,yBAAA;AzC85+BN;AyC35+BI;EAEE,UAAA;EACA,2CAAA;AzC45+BN;;A0K90+BI;EjI1FF,cAAA;EACA,yBxCYS;EyK+EL,cAAA;A1Kk1+BN;AO/5+BE;EkCVI,cAAA;EACA,yBAAA;AzC46+BN;AyCz6+BI;EAEE,UAAA;EACA,4CAAA;AzC06+BN;;A2Kv7+BA;EACE,aAAA;EACA,eAAA;A3K07+BF;;A2Kv7+BE;EACE,gBAAA;EACA,c1KOO;E0KNP,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;A3K07+BJ;A2Kz7+BI;EACE,qBAAA;EACA,yCAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;A3K27+BN;A2Kz7+BI;EACE,wBAAA;A3K27+BN;A2Kx7+BE;EACE,sBAAA;A3K07+BJ;;A4Kp9+BE;EACE,gBAAA;A5Ku9+BJ;;A6Kz9+BA;;;;;;gFAAA;AAQA;;iFAAA;AAIA;EAuqDE,4CAAA;A7Koz7BF;A6K19+BE;EACE,cAAA;A7K49+BJ;A6K19+BE;EACE,cAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;A7K49+BJ;A6K19+BE;EACE,gBAAA;A7K49+BJ;A6K19+BE;EACE,gBAAA;EACA,eAAA;EAAA,qBAAA;A7K49+BJ;A6K19+BE;EACE,gBAAA;EACA,eAAA;EAAA,qBAAA;EACA,kBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,eAAA;EACA,cAAA;EAAA,oBAAA;A7K49+BJ;A6K19+BE;EACE;IACE,YAAA;IACA,YAAA;IACA,gBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,cAAA;E7K49+BJ;AACF;A6K19+BE;EACE,+BAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;;EAEE,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;A7K49+BJ;A6K19+BE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A7K49+BJ;A6K19+BE;;;;;;;;;;;;EAYE,YAAA;A7K49+BJ;A6K19+BE;EACE,WAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,SAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,SAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,SAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,WAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,mBAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,WAAA;EACA,OAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,0BAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,0BAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,0BAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,0BAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,0BAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,0BAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,0BAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,yBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,gBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE;;;;;;;;;;;;IAYE,YAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,yBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,gBAAA;IACA,cAAA;E7K49+BJ;AACF;A6K19+BE;EACE;;;;;;;;;;;;IAYE,YAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,yBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,gBAAA;IACA,cAAA;E7K49+BJ;AACF;A6K19+BE;EACE;;;;;;;;;;;;IAYE,YAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,SAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,WAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,UAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,mBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,WAAA;IACA,OAAA;E7K49+BJ;E6K19+BE;IACE,kBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,iBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,0BAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,yBAAA;IACA,cAAA;E7K49+BJ;E6K19+BE;IACE,gBAAA;IACA,cAAA;E7K49+BJ;AACF;A6K19+BE;EACE,iBAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;A7K49+BJ;A6K19+BE;EACE;IACE,SAAA;E7K49+BJ;E6K19+BE;;;;;;IAME,eAAA;IACA,cAAA;IAAA,oBAAA;E7K49+BJ;E6K19+BE;;;;;;IAME,cAAA;IACA,eAAA;IAAA,qBAAA;E7K49+BJ;AACF;A6K19+BE;;EAEE,mBAAA;EACA,eAAA;EAAA,qBAAA;A7K49+BJ;A6K19+BE;;;;EAIE,mBAAA;EACA,iBAAA;A7K49+BJ;A6K19+BE;;EAEE,mBAAA;EACA,eAAA;A7K49+BJ;A6K19+BE;;EAEE,kBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,oBAAA;EACA,mBAAA;A7K49+BJ;A6K19+BE;EACE,OAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE;IACE,gBAAA;IACA,eAAA;IAAA,qBAAA;E7K49+BJ;E6K19+BE;;IAEE,eAAA;IACA,iBAAA;E7K49+BJ;AACF;A6K19+BE;EACE;IACE,gBAAA;E7K49+BJ;AACF;A6K19+BE;EACE,UAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;EACA,cAAA;A7K49+BJ;A6K19+BE;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;A7K49+BJ;A6K19+BE;EACE,OAAA;EACA,WAAA;EACA,YAAA;A7K49+BJ;A6K19+BE;EACE,UAAA;EACA,QAAA;A7K49+BJ;A6K19+BE;EACE,OAAA;EACA,WAAA;A7K49+BJ;A6K19+BE;EACE;IACE,UAAA;IACA,QAAA;E7K49+BJ;E6K19+BE;IACE,OAAA;IACA,WAAA;E7K49+BJ;AACF;A6K19+BE;;EAEE,YAAA;A7K49+BJ;A6K19+BE;;;;EAIE,kBAAA;EACA,gBAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,gBAAA;A7K49+BJ;A6K19+BE;;EAEE,YAAA;A7K49+BJ;A6K19+BE;;;EAGE,iBAAA;EACA,gBAAA;A7K49+BJ;A6K19+BE;EACE,eAAA;A7K49+BJ;A6K19+BE;EACE,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,yBAAA;A7K49+BJ;A6K19+BE;;EAEE,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;A7K49+BJ;A6K19+BE;EACE,YAAA;A7K49+BJ;A6K19+BE;;EAEE,WAAA;A7K49+BJ;A6K19+BE;EACE,gBAAA;A7K49+BJ;A6K19+BE;;EAEE,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,yBAAA;A7K49+BJ;A6K19+BE;EACE,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;A7K49+BJ;A6K19+BE;EACE,eAAA;A7K49+BJ;A6K19+BE;;;;EAIE,gBAAA;EACA,eAAA;A7K49+BJ;A6K19+BE;EACE,YAAA;A7K49+BJ;A6K19+BE;;;;;;;EAOE,+BAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;A7K49+BJ;A6K19+BE;EACE,gBAAA;EACA,uBAAA;A7K49+BJ;A6K19+BE;;;;;;;EAOE,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;A7K49+BJ;A6K19+BE;EACE,sBAAA;EACA,wBAAA;EACA,iBAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;EACA,iBAAA;A7K49+BJ;A6K19+BE;;EAEE,iBAAA;EACA,kBAAA;A7K49+BJ;A6K19+BE;;EAEE,kBAAA;EACA,iBAAA;A7K49+BJ;A6K19+BE;EACE,gBAAA;EACA,eAAA;EAAA,qBAAA;A7K49+BJ;A6K19+BE;EACE,YAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;EACA,kBAAA;EACA,0BAAA;A7K49+BJ;A6K19+BE;EACE,YAAA;A7K49+BJ;A6K19+BE;EACE,kBAAA;A7K49+BJ;A6K19+BE;EACE,iBAAA;EACA,iBAAA;A7K49+BJ;A6K19+BE;EACE,WAAA;A7K49+BJ;A6K19+BE;EACE,eAAA;EACA,iBAAA;A7K49+BJ;A6K19+BE;EACE,WAAA;A7K49+BJ;A6K19+BE;EACE,cAAA;EACA,kBAAA;A7K49+BJ;A6K19+BE;EACE;IACE,0BAAA;E7K49+BJ;AACF;A6K19+BE;EACE;IACE,YAAA;E7K49+BJ;AACF;A6K19+BE;EACE,mBAAA;EACA,kBAAA;A7K49+BJ;A6K19+BE;EACE,YAAA;A7K49+BJ;A6K19+BE;EACE;;;;;;IAEE,mBAAA;IACA,iBAAA;E7Kg++BJ;AACF;A6K99+BE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;A7Kg++BJ;A6K99+BE;EACE;;IAEE,0BAAA;E7Kg++BJ;AACF;A6K99+BE;EACE;IACE,YAAA;E7Kg++BJ;E6K99+BE;IACE,YAAA;E7Kg++BJ;AACF;A6K99+BE;EACE;IACE,uBAAA;E7Kg++BJ;E6K99+BE;IACE,kBAAA;IACA,kBAAA;E7Kg++BJ;E6K99+BE;IACE,sBAAA;IACA,kBAAA;IACA,kBAAA;E7Kg++BJ;E6K99+BE;IACE,OAAA;IACA,WAAA;E7Kg++BJ;AACF;A6K99+BE;EACE;IACE,YAAA;E7Kg++BJ;E6K99+BE;IACE,cAAA;IACA,kBAAA;E7Kg++BJ;AACF;A6K99+BE;EACE,gBAAA;A7Kg++BJ;A6K99+BE;;EAEE,YAAA;EACA,kBAAA;EACA,gBAAA;A7Kg++BJ;A6K99+BE;;EAEE,cAAA;EACA,+BAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;A7Kg++BJ;A6K99+BE;;EAEE,kBAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;A7Kg++BJ;A6K99+BE;EACE,gBAAA;EACA,eAAA;EAAA,qBAAA;A7Kg++BJ;A6K99+BE;;EAEE,WAAA;A7Kg++BJ;A6K99+BE;;EAEE,YAAA;A7Kg++BJ;A6K99+BE;EACE,gBAAA;EACA,iBAAA;A7Kg++BJ;A6K99+BE;EACE,WAAA;A7Kg++BJ;A6K99+BE;EACE,gBAAA;EACA,kBAAA;A7Kg++BJ;A6K99+BE;;EAEE,kBAAA;EACA,mBAAA;A7Kg++BJ;A6K99+BE;;EAEE,WAAA;EACA,WAAA;A7Kg++BJ;A6K99+BE;EACE,YAAA;A7Kg++BJ;A6K99+BE;EACE,kBAAA;A7Kg++BJ;A6K99+BE;EACE,eAAA;EACA,iBAAA;A7Kg++BJ;A6K99+BE;EACE,iBAAA;A7Kg++BJ;A6K99+BE;EACE,cAAA;EACA,kBAAA;A7Kg++BJ;A6K99+BE;;EAEE,mBAAA;EACA,eAAA;EAAA,qBAAA;A7Kg++BJ;A6K99+BE;;EAEE,kBAAA;EACA,gBAAA;EAAA,sBAAA;A7Kg++BJ;A6K99+BE;EACE,gBAAA;EACA,eAAA;EAAA,qBAAA;EACA,gBAAA;A7Kg++BJ;A6K99+BE;EACE,gBAAA;EACA,eAAA;EAAA,qBAAA;A7Kg++BJ;A6K99+BE;;;;;;;;EA4CE,4BAAA;EACA,yBAAA;A7K47+BJ;A6K17+BE;;;;;;;;EA4CE,2BAAA;EACA,0BAAA;A7Kw5+BJ;A6Kt5+BE;;;;;;;;EA4BE,8BAAA;EACA,0BAAA;A7Ko4+BJ;A6Kl4+BE;;;;;;;;EA4BE,+BAAA;EACA,yBAAA;A7Kg3+BJ;A6K92+BE;;;;;;;;;;;;EAYE,eAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;;;;;;;;;;;;EAYE,kBAAA;EACA,cAAA;A7Kg3+BJ;A6K92+BE;;;;EAIE,QAAA;EACA,UAAA;A7Kg3+BJ;A6K92+BE;EACE,WAAA;A7Kg3+BJ;A6K92+BE;EACE,gBAAA;A7Kg3+BJ;A6K92+BE;EACE,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,iBAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,kBAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,eAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,UAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,UAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,mBAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,UAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,mBAAA;EACA,iBAAA;A7Kg3+BJ;A6K92+BE;EACE,QAAA;EACA,SAAA;A7Kg3+BJ;A6K92+BE;EACE,WAAA;EACA,OAAA;EAWA,8FAAA;EAKA,2BAAA;EACA,wHAAA;A7Ko2+BJ;A6K91+BE;EACE,UAAA;EACA,QAAA;EAWA,8FAAA;EAKA,2BAAA;EACA,wHAAA;A7Ko1+BJ;A6K90+BE;;EAEE,SAAA;EACA,WAAA;EACA,mBAAA;A7Kg1+BJ;A6K90+BE;;EAEE,UAAA;EACA,UAAA;EACA,kBAAA;A7Kg1+BJ;A6K90+BE;EACE,UAAA;EACA,OAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;A7Kg1+BJ;A6K90+BE;EACE;;IAEE,cAAA;IACA,mBAAA;E7Kg1+BJ;E6K90+BE;;IAEE,cAAA;IACA,mBAAA;E7Kg1+BJ;E6K90+BE;IACE,SAAA;IACA,UAAA;IACA,oBAAA;E7Kg1+BJ;AACF;A6K90+BE;EACE,sBAAA;A7Kg1+BJ;A6K90+BE;EACE,uBAAA;A7Kg1+BJ;;A8KhgiCE;EACE,gBAAA;A9KmgiCJ;;A8KhgiCA;EACE,gBAAA;A9KmgiCF;;A+KzgiCA;EACE,kBAAA;A/K4giCF;;AgL7giCA;EACE,gBAAA;AhLghiCF;;AiLhhiCE;EACE,kBAAA;EACA,iBAAA;EACA,sBAAA;AjLmhiCJ;AiLlhiCI;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,0DAAA;EACA,kCAAA;EACA,sBAAA;AjLohiCN;AiLlhiCI;EACE,YAAA;EACA,WAAA;EACA,0CAAA;EACA,8BAAA;AjLohiCN;AiLhhiCI;EACE,0DAAA;AjLkhiCN;AiLhhiCI;EACE,yBhLXK;EgLYL,2BAAA;AjLkhiCN;AiL9giCI;EACE,WAAA;AjLghiCN;AiL9giCI;EACE,iBAAA;AjLghiCN;;AkLljiCA;EACE,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;AlLqjiCF;;AmLzjiCA;EACE,aAAA;AnL4jiCF;;AoL5jiCE;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;ApL+jiCJ;AoL7jiCM;EACE,UAAA;EAAA,aAAA;EACA,YAAA;ApL+jiCR;AoL3jiCE;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;ApL6jiCJ;AoL3jiCE;EACE,gBAAA;EACA,mBAAA;ApL6jiCJ;;AqL7kiCM;EACE,gBAAA;ArLgliCR;;AsLjliCE;;;EACE,yBAAA;EACA,wBrL6U0B;ADywhC9B;AsLrliCI;;;;;EAEE,yBAAA;AtL0liCN;AsLrliCI;;;;;;;;;;;;EAEE,qBrLuFU;AD0giChB;AsL9liCM;;;;;;EACE,qBrLmFQ;ADkhiChB;AsLpmiCQ;;;;;;;;;;;;;;;;;;;;;EAIE,yBAAA;AtLuniCV;AsLjniCI;;;EACE,qBrLuEU;AD8iiChB;AsLpniCM;;;;;;;;;EAIE,yBAAA;AtL2niCR;;AsLtniCA;EACE,qBrL4Dc;AD6jiChB;AsLxniCE;EAIE,yBAAA;AtLuniCJ;;AsLpniCA;;EAEE,yBAAA;AtLuniCF;;AsLrniCA;EACE,cAAA;AtLwniCF;;AsLtniCA;;EAEE,6BAAA;AtLyniCF;;AsLvniCA;;EAEE,SAAA;AtL0niCF;;AsLvniCE;EACE,yBAAA;AtL0niCJ;;AsLvniCA;;EAEE,kBAAA;EACA,0BAAA;EACA,6BAAA;AtL0niCF;;AuLnsiCE;EACE,sBAAA;EAAA,2BAAA;EACA,yBAAA;EAAA,4BAAA;EACA,oBAAA;EAAA,uBAAA;AvLssiCJ;AuLpsiCE;EACE,0BAAA;AvLssiCJ;;AuLnsiCA;EACE,uBAAA;AvLssiCF;;AiBxoiCI;EuKxEF;IACE,2BAAA;ExLotiCF;EwLjtiCE;IACE,+BvL4DuB;EDupiC3B;EwLjtiCE;IACE,0CAAA;ExLmtiCJ;EwLhtiCA;IACE,QAAA;ExLktiCF;AACF;AiBvpiCI;EuKvDA;IACE,kBAAA;ExLitiCJ;EwL7siCE;IACE,WAAA;IACA,kBAAA;IACA,WAAA;IAAA,cAAA;IACA,kBAAA;ExL+siCJ;EwL1siCI;IACE,YAAA;IACA,kBAAA;IACA,UAAA;IAAA,aAAA;IACA,kBAAA;ExL4siCN;AACF;AwLxsiCA;EACE,cvL4Dc;AD8oiChB;;AyLnviCE;;EASE,WAAA;EACA,UAAA;AzL+uiCJ;AyL7uiCE;EACE,kBAAA;EACA,iBAAA;AzL+uiCJ;AyL7uiCE;EACE,0BAAA;EACA,OAAA;EACA,WAAA;EAAA,cAAA;AzL+uiCJ;AyL9uiCI;EACE,qBAAA;EACA,sBAAA;AzLgviCN;AyL/uiCM;EAEE,UAAA;EACA,kBAAA;EACA,WAAA;AzLgviCR;AyL9uiCM;EACE,WAAA;EAAA,cAAA;EACA,WAAA;EACA,cAAA;EAAA,oBAAA;EACA,4CAAA;AzLgviCR;AyL9uiCM;EACE,WAAA;EAAA,cAAA;EACA,WAAA;EACA,cAAA;EAAA,oBAAA;EACA,iCAAA;AzLgviCR;AyL5uiCE;EACE,eAAA;EACA,iBAAA;AzL8uiCJ;AyL5uiCE;EACE,kBAAA,EAAA,+BAAA;EACA,iCAAA;AzL8uiCJ;;A0LhyiCA;EACE,kBAAA;EACA,WAAA;A1LmyiCF;;A0LhyiCE;EACE,WAAA;A1LmyiCJ;;AiBhuiCI;EyK/DF;IACE,YAAA;E1LmyiCF;AACF;AiBtuiCI;EyKzDA;IACE,YAAA;E1LkyiCJ;E0L/xiCA;IACE,kBAAA;IACA,kBAAA;E1LiyiCF;E0L/xiCA;IACE,cAAA;IACA,aAAA;IAAA,mBAAA;E1LiyiCF;E0L/xiCA;IACE,gBAAA;E1LiyiCF;AACF;A0L7xiCE;EACE,+BAAA;A1L+xiCJ;A0L7xiCE;EACE,aAAA;A1L+xiCJ;;A2LzziCA;EACE;IACE,yBAAA;E3L4ziCF;AACF;A2LzziCA;EACE,qBAAA;EACA,WrL4jCwB;EqL3jCxB,YrL2jCwB;EqL1jCxB,2BAAA;EACA,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;A3L0ziCF;;A2LvziCA;EACE,WrLsjCwB;EqLrjCxB,YrLqjCwB;EqLpjCxB,mBrLsjCwB;ANowgC1B;;A2LnziCA;EACE;IACE,mBAAA;E3LsziCF;E2LpziCA;IACE,UAAA;E3LsziCF;AACF;A2LnziCA;EACE,qBAAA;EACA,WrL6hCwB;EqL5hCxB,YrL4hCwB;EqL3hCxB,2BAAA;EACA,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;A3LoziCF;;A2LjziCA;EACE,WrLuhCwB;EqLthCxB,YrLshCwB;AN8xgC1B;;A4Ll3iCE;;;;EAIE,c3LoGY;ADixiChB;A4Ln3iCE;;EAEE,uCAAA;A5Lq3iCJ;A4Ln3iCE;;EAEE,mCAAA;A5Lq3iCJ;A4Ln3iCE;EACE,qCAAA;A5Lq3iCJ;A4Ln3iCE;EACE,mBAAA;A5Lq3iCJ;A4Ln3iCE;;;;;;;;;;;EAWE,qBAAA;A5Lq3iCJ;A4Ln3iCE;;;;;;EAME,c3LiEY;ADoziChB;A4Ln3iCE;EACE,c3LyEmB;AD4yiCvB;A4Ln3iCE;;;;;;EAME,c3L+CY;ADs0iChB;A4Ll3iCI;EACE,c3L6DiB;ADuziCvB;A4Lj3iCE;EACE,mBAAA;EACA,cAAA;A5Lm3iCJ;A4L/2iCI;;;;EAEE,qB3LoCU;AD+0iChB;A4Lh3iCM;;EACE,qB3LgCQ;ADm1iChB;A4Ll3iCQ;;;;;EAIE,yBAAA;A5Lq3iCV;A4L92iCI;;;;EAEE,qB3LoBU;AD81iChB;A4L/2iCM;;EACE,qB3LgBQ;ADk2iChB;A4Lj3iCQ;;;;;EAIE,yBAAA;A5Lo3iCV;;AA/0iCA;EACI,6BAAA;AAk1iCJ","sourcesContent":["\n@import \"black-dashboard-pro-react/custom/functions\";\n@import \"../../../node_modules/bootstrap/scss/functions\";\n\n@import \"black-dashboard-pro-react/custom/variables\";\n@import \"../../../node_modules/bootstrap/scss/variables\";\n\n@import \"black-dashboard-pro-react/custom/mixins\";\n@import \"../../../node_modules/bootstrap/scss/mixins\";\n\n// Bootstrap components\n\n@import \"../../../node_modules/bootstrap/scss/root\";\n@import \"../../../node_modules/bootstrap/scss/reboot\";\n@import \"../../../node_modules/bootstrap/scss/type\";\n@import \"../../../node_modules/bootstrap/scss/images\";\n@import \"../../../node_modules/bootstrap/scss/code\";\n@import \"../../../node_modules/bootstrap/scss/grid\";\n@import \"../../../node_modules/bootstrap/scss/tables\";\n@import \"../../../node_modules/bootstrap/scss/forms\";\n@import \"../../../node_modules/bootstrap/scss/buttons\";\n@import \"../../../node_modules/bootstrap/scss/transitions\";\n@import \"../../../node_modules/bootstrap/scss/dropdown\";\n@import \"../../../node_modules/bootstrap/scss/button-group\";\n@import \"../../../node_modules/bootstrap/scss/input-group\";\n@import \"../../../node_modules/bootstrap/scss/custom-forms\";\n@import \"../../../node_modules/bootstrap/scss/nav\";\n@import \"../../../node_modules/bootstrap/scss/navbar\";\n@import \"../../../node_modules/bootstrap/scss/card\";\n@import \"../../../node_modules/bootstrap/scss/breadcrumb\";\n@import \"../../../node_modules/bootstrap/scss/pagination\";\n@import \"../../../node_modules/bootstrap/scss/badge\";\n@import \"../../../node_modules/bootstrap/scss/jumbotron\";\n@import \"../../../node_modules/bootstrap/scss/alert\";\n@import \"../../../node_modules/bootstrap/scss/progress\";\n@import \"../../../node_modules/bootstrap/scss/media\";\n@import \"../../../node_modules/bootstrap/scss/list-group\";\n@import \"../../../node_modules/bootstrap/scss/close\";\n@import \"../../../node_modules/bootstrap/scss/modal\";\n@import \"../../../node_modules/bootstrap/scss/tooltip\";\n@import \"../../../node_modules/bootstrap/scss/popover\";\n@import \"../../../node_modules/bootstrap/scss/carousel\";\n@import \"../../../node_modules/bootstrap/scss/utilities\";\n@import \"../../../node_modules/bootstrap/scss/print\";\n\n// Custom components\n\n@import \"black-dashboard-pro-react/custom/reboot.scss\";\n@import \"black-dashboard-pro-react/custom/global.scss\";\n@import \"black-dashboard-pro-react/custom/utilities.scss\";\n@import \"black-dashboard-pro-react/custom/alerts.scss\";\n@import \"black-dashboard-pro-react/custom/avatars.scss\";\n@import \"black-dashboard-pro-react/custom/badge.scss\";\n@import \"black-dashboard-pro-react/custom/buttons.scss\";\n@import \"black-dashboard-pro-react/custom/close.scss\";\n@import \"black-dashboard-pro-react/custom/custom-forms.scss\";\n@import \"black-dashboard-pro-react/custom/dropdown.scss\";\n@import \"black-dashboard-pro-react/custom/footer.scss\";\n@import \"black-dashboard-pro-react/custom/forms.scss\";\n@import \"black-dashboard-pro-react/custom/grid.scss\";\n@import \"black-dashboard-pro-react/custom/icons.scss\";\n@import \"black-dashboard-pro-react/custom/images.scss\";\n@import \"black-dashboard-pro-react/custom/input-group.scss\";\n@import \"black-dashboard-pro-react/custom/info-areas.scss\";\n@import \"black-dashboard-pro-react/custom/modal.scss\";\n@import \"black-dashboard-pro-react/custom/nav.scss\";\n@import \"black-dashboard-pro-react/custom/navbar.scss\";\n@import \"black-dashboard-pro-react/custom/pagination.scss\";\n@import \"black-dashboard-pro-react/custom/tabs.scss\";\n@import \"black-dashboard-pro-react/custom/pills.scss\";\n@import \"black-dashboard-pro-react/custom/popover.scss\";\n@import \"black-dashboard-pro-react/custom/progress.scss\";\n@import \"black-dashboard-pro-react/custom/type.scss\";\n@import \"black-dashboard-pro-react/custom/tables\";\n@import \"black-dashboard-pro-react/custom/checkboxes-radio\";\n@import \"black-dashboard-pro-react/custom/fixed-plugin\";\n@import \"black-dashboard-pro-react/custom/sidebar-and-main-panel.scss\";\n@import \"black-dashboard-pro-react/custom/misc.scss\";\n@import \"black-dashboard-pro-react/custom/rtl.scss\";\n@import \"black-dashboard-pro-react/custom/timeline.scss\";\n\n// Vendor / Plugins\n\n@import \"black-dashboard-pro-react/custom/vendor/plugin-datetimepicker.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-nouislider.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-fullcalendar.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-sweetalert2.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-bootstrap-switch.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-bootstrap-select.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-jasny-fileupload.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-tagsinput.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-perfect-scrollbar.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-jquery.jvectormap.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-datatables.net.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-animate-bootstrap-notify.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-card-wizard.scss\";\n@import \"black-dashboard-pro-react/custom/vendor/plugin-chartjs.scss\";\n\n// example pages and sections\n\n@import \"black-dashboard-pro-react/custom/example-pages.scss\";\n\n// light mode\n\n@import \"black-dashboard-pro-react/custom/white-content.scss\";\n\n// Cards\n\n@import \"black-dashboard-pro-react/custom/card\";\n@import \"black-dashboard-pro-react/custom/cards/card-chart\";\n@import \"black-dashboard-pro-react/custom/cards/card-map\";\n@import \"black-dashboard-pro-react/custom/cards/card-user\";\n@import \"black-dashboard-pro-react/custom/cards/card-task\";\n@import \"black-dashboard-pro-react/custom/cards/card-animation-on-hover\";\n@import \"black-dashboard-pro-react/custom/cards/card-collapse\";\n@import \"black-dashboard-pro-react/custom/cards/card-contributions\";\n@import \"black-dashboard-pro-react/custom/cards/card-lock\";\n@import \"black-dashboard-pro-react/custom/cards/card-pricing\";\n@import \"black-dashboard-pro-react/custom/cards/card-profile\";\n@import \"black-dashboard-pro-react/custom/cards/card-plain\";\n@import \"black-dashboard-pro-react/custom/cards/card-register\";\n@import \"black-dashboard-pro-react/custom/cards/card-stats\";\n@import \"black-dashboard-pro-react/custom/cards/card-subcategories\";\n@import \"black-dashboard-pro-react/custom/cards/card-testimonials\";\n@import \"black-dashboard-pro-react/custom/cards/card-wizard\";\n\n// React Differences\n@import \"black-dashboard-pro-react/react/react-differences\";\n\n\n.footer-login .footer {\n    padding:24px 38px !important;\n}","\n// Global settings\n\n$enable-caret:              true !default;\n$enable-rounded:            true !default;\n$enable-shadows:            true !default;\n$enable-gradients:          false !default;\n$enable-transitions:        true !default;\n$enable-grid-classes:       true !default;\n$enable-print-styles:       true !default;\n\n\n// Color system\n\n$white:    #ffffff !default;\n$gray-100: #f6f9fc !default;\n$gray-200: #e9ecef !default;\n$gray-300: #e3e3e3 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;   // Line footer color\n$gray-700: #525f7f !default;   // Line p color\n$gray-800: #32325d !default;   // Line heading color\n$gray-900: #212529 !default;\n$link-disabled:              #666666 !default;\n$transparent-bg:             transparent !default;\n$light-bg:                   #f5f6fa !default;\n$dark-background:            #555555 !default;\n\n\n$grays: () !default;\n$grays: map-merge((\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n), $grays);\n\n$blue:    #5e72e4 !default;\n$indigo:  #5603ad !default;\n$purple:  #8965e0 !default;\n$pink:    #f3a4b5 !default;\n$red:     #f5365c !default;\n$orange:  #fb6340 !default;\n$yellow:  #ffd600 !default;\n$green:   #2dce89 !default;\n$teal:    #11cdef !default;\n$cyan:    #2bffc6 !default;\n\n$line-height-lg:              1.625rem !default;\n$line-height-sm:              1.5 !default;\n$line-height:                 1.35em         !default;\n\n\n$opacity-gray-3:             rgba(222,222,222, .3) !default;\n$opacity-gray-5:             rgba(222,222,222, .5) !default;\n$opacity-gray-8:             rgba(222,222,222, .8) !default;\n\n\n$opacity-5:                  rgba(255,255,255, .5) !default;\n$opacity-6:                  rgba(255,255,255, .6) !default;\n$opacity-8:                  rgba(255,255,255, .8) !default;\n\n\n\n$opacity-1:                  rgba(255,255,255, .1) !default;\n$opacity-2:                  rgba(255,255,255, .2) !default;\n\n\n// end beniamin\n\n$colors: () !default;\n$colors: map-merge((\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"light\":      $gray-400,\n  \"lighter\":    $gray-200,\n  \"gray-dark\":  $gray-800\n), $colors);\n\n$default-color-opacity:      rgba(182, 182, 182, .6) !default;\n$orange-color:               #f96332 !default;\n\n$default:       #344675 !default;\n$primary:       #e14eca !default;\n$secondary:     #f4f5f7 !default;\n$success:       #00f2c3 !default;\n$info:          #1d8cf8 !default;\n$warning:       #ff8d72 !default;\n$danger:        #fd5d93 !default;\n$black:         #222a42 !default;\n$white:         #ffffff !default;\n\n\n// gradient\n$default-states:       #263148 !default;\n$primary-states:       #ba54f5 !default;\n$success-states:       #0098f0 !default;\n$info-states:          #3358f4 !default;\n$warning-states:       #ff6491 !default;\n$danger-states:        #ec250d !default;\n$black-states:         #1d253b !default;\n$white-states:       #ffffff !default;\n\n$background-black:           #1e1e2f !default;\n$background-states-black:    #1e1e24 !default;\n\n// opacity\n$default-opacity:      rgba(182, 182, 182, .6) !default;\n$primary-opacity:      rgba(249, 99, 50, .3) !default;\n$success-opacity:      rgba(24, 206, 15, .3) !default;\n$info-opacity:         rgba(44, 168, 255, .3) !default;\n$warning-opacity:      rgba(255, 178, 54, .3) !default;\n$danger-opacity:       rgba(255, 54, 54, .3) !default;\n\n$light-gray:                 #E3E3E3 !default;\n$medium-gray:                #DDDDDD !default;\n$dark-gray:                  #9A9A9A !default;\n$card-stats-gray:            #808080 !default;\n$active-gray:                #777777 !default;\n$nav-gray:                   #444444 !default;\n$search-gray:                #b7b7b7 !default;\n$calendar-gray:              #9499a7 !default;\n$active-blue:                #00bbff !default;\n\n\n\n$light:         $gray-500 !default;\n$dark:          $gray-900 !default;\n$darker:        darken($gray-900, 15%) !default;\n\n$facebook:              #3b5998 !default;\n$facebook-states:       darken($facebook, 5%) !default;\n$twitter:               #55acee !default;\n$twitter-states:        darken($twitter, 5%) !default;\n$google-plus:           #dd4b39 !default;\n$google-plus-states:    darken($google-plus, 5%) !default;\n$instagram:             #125688 !default;\n$instagram-states:      lighten($instagram, 6%) !default;\n$linkedin:              #0077B5 !default;\n$linkedin-states:       darken($linkedin, 5%) !default;\n$pinterest:             #cc2127 !default;\n$pinterest-states:      lighten($pinterest, 6%) !default;\n$youtube:               #e52d27 !default;\n$youtube-states:        lighten($youtube, 6%) !default;\n$dribbble:              #ea4c89 !default;\n$dribbble-states:       lighten($dribbble, 6%) !default;\n$github:                #333333 !default;\n$github-states:         #ccc !default;\n$reddit:                #ff4500 !default;\n$reddit-states:         lighten($reddit, 6%) !default;\n$tumblr:                #35465c !default;\n$tumblr-states:         lighten($tumblr, 6%) !default;\n$behance:               #1769ff !default;\n$behance-states:        lighten($behance, 6%) !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge((\n  \"default\":      $default,\n  \"primary\":      $primary,\n  \"secondary\":    $secondary,\n  \"success\":      $success,\n  \"info\":         $info,\n  \"warning\":      $warning,\n  \"danger\":       $danger,\n  \"white\":        $white,\n  \"neutral\":      $white,\n  \"dark\":         $dark,\n  \"darker\":       $darker\n), $theme-colors);\n\n$brand-colors: () !default;\n$brand-colors: map-merge((\n  \"facebook\":     $facebook,\n  \"twitter\":      $twitter,\n  \"google-plus\":  $google-plus,\n  \"instagram\":    $instagram,\n  \"pinterest\":    $pinterest,\n  \"youtube\":      $youtube,\n  \"dribbble\":     $dribbble,\n  \"github\":       $github,\n  \"reddit\":       $reddit,\n  \"behance\":      $behance,\n  \"tumblr\":       $tumblr,\n  \"linkedin\":     $linkedin,\n), $brand-colors);\n\n\n/*     brand Colors              */\n$brand-primary:              $primary !default;\n$brand-info:                 $info !default;\n$brand-success:              $success !default;\n$brand-warning:              $warning !default;\n$brand-danger:               $danger !default;\n$brand-inverse:              $black !default;\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  200 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Action colors\n\n$star-rating-color: $gray-400 !default;\n$star-rating-color-active: $yellow !default;\n\n$favorite-color: $yellow !default;\n$like-color: $blue !default;\n$love-color: $red !default;\n\n\n// Body\n\n$body-bg: $background-black !default;\n$body-color: $gray-700 !default;\n\n\n// Sections\n\n$section-colors: () !default;\n$section-colors: map-merge((\n  \"primary\":      $body-bg,\n  \"secondary\":    $secondary,\n  \"light\":        $gray-400,\n  \"dark\":         $dark,\n  \"darker\":       $darker\n), $section-colors);\n\n// Links\n\n$link-color:                $primary !default;\n$link-decoration:           none !default;\n$link-hover-color:          darken($link-color, 15%);\n$link-hover-decoration:     none !default;\n\n// Grid breakpoints\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n);\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints);\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n\n// Spacing\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge((\n  0: 0,\n  1: ($spacer * .25),\n  2: ($spacer * .5),\n  3: $spacer,\n  4: ($spacer * 1.5),\n  5: ($spacer * 3),\n  'sm': ($spacer * 2),\n  'md': ($spacer * 4),\n  'lg': ($spacer * 6),\n  'xl': ($spacer * 8)\n), $spacers);\n\n$padding-base-vertical:        .5rem !default;\n$padding-base-horizontal:      .7rem !default;\n\n$padding-btn-vertical:         11px !default;\n$padding-btn-horizontal:       40px !default;\n\n$padding-round-horizontal:     23px !default;\n\n$padding-lg-vertical:       15px !default;\n\n$padding-input-vertical:        11px !default;\n$padding-input-horizontal:      19px !default;\n\n\n$margin-lg-vertical:           30px !default;\n$margin-base-vertical:         15px !default;\n\n// This variable affects the `.h-*` and `.w-*` classes.\n\n$sizes: () !default;\n$sizes: map-merge((\n  25: 25%,\n  50: 50%,\n  75: 75%,\n  100: 100%\n), $sizes);\n\n// Components\n\n$shape-height-xl:              1.5 !default;\n$shape-height-lg:              1.5 !default;\n$shape-height-sm:              1.5 !default;\n\n// border\n$none:                       0   !default;\n$border-thin:                1px !default;\n$border-thick:               2px !default;\n$border-width:                .0625rem !default;\n$border-color:                $gray-200 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-xl:            0.875rem !default;\n$border-radius-lg:            0.4285rem !default;\n$border-radius-sm:            0.2857rem !default;\n$border-radius-xs:            0.1428rem !default;\n\n$margin-bottom:                 10px        !default;\n$border:                        1px solid   !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075);\n$box-shadow:                  0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07);\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175);\n\n$dropdown-shadow:          1px 2px 3px 0px rgba(0, 0, 0, 0.125);\n$box-shadow-raised:        0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n$box-shadow:               0 1px 20px 0px rgba(0, 0, 0, 0.1);\n\n$component-active-color:        $white !default;\n$component-active-bg:           theme-color(\"primary\") !default;\n$component-active-border-color: theme-color(\"primary\") !default;\n\n$component-hover-color:        $gray-300 !default;\n$component-hover-bg:           $gray-300 !default;\n$component-hover-border-color: $gray-300 !default;\n\n$caret-width:                 .3em !default;\n\n$transition-base:             all .15s ease !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n\n$fast-transition-time:           150ms       !default;\n\n$transition-linear:         linear           !default;\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\n$transition-ease:           ease 0s;\n\n$select-coordinates:          50% -40px       !default;\n$general-transition-time:     300ms             !default;\n\n\n// Fonts\n\n$font-family-base:            'Poppins', sans-serif !default;\n$font-family-alt:             'Poppins', sans-serif !default;\n\n$font-size-dash:              .875rem !default;\n\n$font-size-base:              $font-size-dash !default; // Assumes the browser default, typically `16px`\n$font-size-xl:                ($font-size-base * 1.428);\n$font-size-lg:                ($font-size-base * 1.142);\n$font-size-sm:                ($font-size-base * .85714286);\n$font-size-xs:                ($font-size-base * .714);\n\n$h1-font-size:                $font-size-base * 2.35714285 !default;  //2.1875rem\n$h2-font-size:                $font-size-base * 1.9285714 !default;\n$h3-font-size:                $font-size-base * 1.642857 !default;\n$h4-font-size:                $font-size-base * 1.2142857 !default;\n$h5-font-size:                $font-size-base * 0.9285714 !default;\n$h6-font-size:                $font-size-base * 0.8571428 !default;\n\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            600 !default;\n$font-weight-extra-bold:      700 !default;\n\n$font-paragraph:               1rem          !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$shape-height-base:            1.428571 !default;\n\n$headings-margin-bottom:      ($spacer / 2);\n$headings-font-family:        inherit !default;\n$headings-font-weight:        $font-weight-normal !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              $gray-800 !default;\n\n$heading-letter-spacing:      .025em !default;\n$heading-font-size:           .95rem !default;\n$heading-text-transform:      uppercase !default;\n$heading-font-weight:         $headings-font-weight !default;\n\n$heading-title-letter-spacing:      .025em !default;\n$heading-title-font-size:           1.375rem !default;\n$heading-title-font-weight:         $font-weight-bold !default;\n$heading-title-text-transform:      uppercase !default;\n\n$heading-section-letter-spacing:      .025em !default;\n$heading-section-font-size:           1.375rem !default;\n$heading-section-font-weight:         $font-weight-bold !default;\n$heading-section-text-transform:      uppercase !default;\n\n$display1-size:               3.3rem !default;\n$display2-size:               2.75rem !default;\n$display3-size:               2.1875rem !default;\n$display4-size:               1.6275rem !default;\n\n$display1-weight:             $font-weight-bold !default;\n$display2-weight:             $font-weight-bold !default;\n$display3-weight:             $font-weight-bold !default;\n$display4-weight:             $font-weight-bold !default;\n$display-line-height:         $headings-line-height !default;\n\n$paragraph-font-size:         0.625rem !default;\n$paragraph-font-weight:       300 !default;\n$paragraph-line-height:       1.7 !default;\n\n$lead-font-size:              ($paragraph-font-size * 1.25);\n$lead-font-weight:            300 !default;\n\n$small-font-size:             80% !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-font-size:        ($font-size-base * 1.1);\n\n$hr-border-color:             rgba($black, .1);\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer * 2 !default;\n\n\n// Icons\n\n$icon-size:                 2.375rem       !default;\n$icon-size-regular:         2.375rem      !default;\n$icon-font-size-regular:    0.9375rem     !default;\n$icon-font-size-sm:         0.6875rem      !default;\n$icon-size-sm:              1.875rem     !default;\n$icon-font-size-lg:         1.325rem     !default;\n$icon-size-lg:              3.6rem         !default;\n$icon-size-xl:              5rem !default;\n\n\n// Tables\n\n$table-cell-padding:          1rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-bg:                    transparent !default;\n$table-accent-bg:             rgba($black, .05);\n$table-hover-bg:              rgba($black, .075);\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $gray-300 !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n\n$table-dark-bg:               $gray-900 !default;\n$table-dark-accent-bg:        rgba($white, .05);\n$table-dark-hover-bg:         rgba($white, .075);\n$table-dark-border-color:     lighten($gray-900, 7.5%);\n$table-dark-color:            $body-bg !default;\n\n\n// Buttons + Forms\n\n$input-btn-padding-y:         .5rem !default;\n$input-btn-padding-x:         .7rem !default;\n$input-btn-line-height:       $shape-height-base !default;\n\n$input-btn-focus-width:       0 !default;\n$input-btn-focus-color:       rgba($component-active-bg, 1);\n//$input-btn-focus-box-shadow:  0 4px 10px 0 rgba(0, 0, 0, 0.04);\n$input-btn-focus-box-shadow:  none !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-line-height-sm:    1.35 !default;\n\n$input-btn-padding-y-lg:      .875rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-line-height-lg:    1.35 !default;\n\n$input-btn-border-width:      1px !default;\n\n$input-btn-font-size-sm:      .75rem !default;\n$input-btn-font-size:         .875rem !default;\n$input-btn-font-size-lg:         .875rem !default;\n\n$input-padding-vertical:        11px !default;\n$input-padding-horizontal:      19px !default;\n\n// Buttons\n\n$btn-padding-y:               11px !default;\n$btn-padding-x:               40px !default;\n$btn-line-height:             $line-height !default;\n\n$btn-padding-y-sm:            5px !default;\n$btn-padding-x-sm:            15px !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            15px !default;\n$btn-padding-x-lg:            48px !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-size-lg:            1em !default;\n$btn-font-weight:             600 !default;\n$btn-text-transform:          uppercase !default;\n$btn-letter-spacing:          .025em !default;\n$btn-box-shadow:              0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\n$btn-hover-box-shadow:        0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);\n$btn-focus-box-shadow:        $btn-hover-box-shadow !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n\n\n$btn-active-box-shadow:       none !default;\n$btn-round-radius:            30px         !default;\n\n\n\n// Forms\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-xl:                $border-radius-xl !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-bg:                              $transparent-bg !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-muted-bg:                        #EDF0F5 !default;\n\n$input-alternative-box-shadow:          0 1px 3px rgba(50,50,93,.15), 0 1px 0 rgba(0,0,0,.02);\n$input-focus-alternative-box-shadow:    0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);\n\n$input-color:                           $opacity-8 !default;\n$input-border-color:                    #cad1d7 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      none !default; // 0 1px 3px 0 $gray-400 !default;\n\n$input-focus-bg:                        $white !default;\n$input-focus-border-color:              rgba(50,151,211,.25);\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     0 !default;\n$input-focus-box-shadow:                none !default; //0 1px 3px 0 $gray-500 !default;\n\n$input-placeholder-color:               $gray-500 !default;\n$input-focus-placeholder-color:         $gray-500 !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n$input-height-inner:                    ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\n$input-height:                          calc(#{$input-height-inner} + #{$input-height-border}) !default;\n\n$input-transition:                      all .2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n\n\n// Input groups\n\n$input-group-addon-color:               $input-placeholder-color !default;\n$input-group-addon-bg:                  $input-bg !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$input-group-addon-focus-color:               $input-focus-color !default;\n$input-group-addon-focus-bg:                  $input-focus-bg !default;\n$input-group-addon-focus-border-color:        $input-focus-border-color !default;\n\n\n// Custom forms\n\n$custom-control-gutter:                 1.75rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-indicator-size:         1.25rem !default;\n\n$custom-control-indicator-bg:                   $input-bg !default;\n$custom-control-indicator-border-width:         1px !default;\n$custom-control-indicator-border-color:         $input-border-color !default;\n$custom-control-indicator-box-shadow:           none !default;\n\n$custom-control-indicator-focus-box-shadow:     $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-hover-color:         $component-hover-color !default;\n$custom-control-indicator-hover-bg:            $component-hover-bg !default;\n$custom-control-indicator-hover-border-color:  $component-hover-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            $component-active-bg !default;\n$custom-control-indicator-active-border-color:  $component-active-border-color !default;\n$custom-control-indicator-active-box-shadow:    $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-border-color: $component-active-border-color !default;\n$custom-control-indicator-checked-box-shadow:   $custom-control-indicator-box-shadow !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5);\n\n$custom-control-indicator-disabled-bg:          $gray-200 !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius-sm !default;\n//$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$custom-toggle-slider-bg:   #ddd !default;\n$custom-toggle-checked-bg:  theme-color(\"primary\") !default;\n\n// Form validation\n\n$form-feedback-valid-bg:         lighten($success, 15%);\n$form-feedback-valid-color:      theme-color(\"success\") !default;\n$form-feedback-invalid-bg:       lighten($warning, 15%);\n$form-feedback-invalid-color:    theme-color(\"warning\") !default;\n\n\n// Allows for customizing button radius independently from global border radius\n\n$btn-border-radius:           $input-border-radius !default;\n$btn-border-radius-xl:        $input-border-radius-xl !default;\n$btn-border-radius-lg:        $input-border-radius-lg !default;\n$btn-border-radius-sm:        $input-border-radius !default;\n\n\n// No UI Slider\n\n$noui-target-bg:                  #eceeef !default;\n$noui-target-thickness:           5px !default;\n$noui-target-border-radius:       5px !default;\n$noui-target-border-color:        0 !default;\n$noui-target-box-shadow:          inset 0 1px 2px rgba(90,97,105,.1);\n\n$noui-slider-connect-bg:          $primary !default;\n$noui-slider-connect-disabled-bg: #b2b2b2 !default;\n\n$noui-handle-width:               15px !default;\n$noui-handle-bg:                  theme-color(\"primary\") !default;\n$noui-handle-border:              0 !default;\n$noui-handle-border-radius:       100% !default;\n\n$noui-origin-border-radius:       2px !default;\n\n\n// Dropdown\n\n$dropdown-bg:                       $white !default;\n$dropdown-border-width:             0 !default;\n$dropdown-border-color:             rgba($black, .15);\n$dropdown-border-radius:            $border-radius-xs !default;\n$dropdown-box-shadow:               0 50px 100px rgba(50, 50, 93, .1), 0 15px 35px rgba(50, 50, 93, .15), 0 5px 15px rgba(0, 0, 0, .1);\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-color:                    $gray-700 !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-pills-padding-y:               .75rem !default;\n$nav-pills-padding-x:               1rem !default;\n\n$nav-pills-space-x:                 1rem !default;\n\n$nav-pills-bg:                      $white;\n$nav-pills-border-width:            1px !default;\n$nav-pills-border-color:            theme-color(\"primary\") !default;\n$nav-pills-border-radius:           $border-radius !default;\n\n$nav-pills-link-color:              theme-color(\"primary\") !default;\n$nav-pills-link-hover-color:        darken(theme-color(\"primary\"), 5%);\n$nav-pills-link-active-color:       color-yiq(theme-color(\"primary\"));\n$nav-pills-link-active-bg:          theme-color(\"primary\") !default;\n$nav-pills-box-shadow:              $btn-box-shadow !default;\n\n// Navbar\n\n$navbar-transition:                 all .15s linear !default;\n$navbar-padding-y:                  .625rem !default;\n$navbar-padding-x:                  .9375rem !default;\n\n$navbar-nav-link-padding-x:         1rem !default;\n$navbar-nav-link-padding-y:         1rem !default;\n\n$navbar-nav-link-font-family:       $font-family-alt !default;\n$navbar-nav-link-font-size:         .9rem !default;\n$navbar-nav-link-font-weight:       400 !default;\n$navbar-nav-link-text-transform:    normal !default;\n$navbar-nav-link-letter-spacing:    0 !default;\n$navbar-nav-link-border-radius:     $border-radius !default;\n\n/* navbar color */\n$navbar-color:                      #1a1e34 !default;\n$navbar-dark-bg:                    transparent !default;\n$navbar-dark-hover-bg:              rgba(255, 255, 255, .1);\n$navbar-dark-active-bg:             rgba(255, 255, 255, .1);\n$navbar-dark-color:                 rgba($white, .95);\n$navbar-dark-hover-color:           rgba($white, .65);\n$navbar-dark-active-color:          rgba($white, .65);\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-border-color:  transparent !default;\n\n$navbar-light-bg:                   transparent !default;\n$navbar-light-hover-bg:             rgba(0, 0, 0, .1);\n$navbar-light-active-bg:            rgba(0, 0, 0, .1);\n$navbar-light-color:                rgba($black, .5);\n$navbar-light-hover-color:          rgba($black, .7);\n$navbar-light-active-color:         rgba($black, .9);\n$navbar-light-disabled-color:       rgba($black, .3);\n$navbar-light-toggler-icon-bg:      str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$navbar-light-toggler-border-color: transparent !default;\n$full-width:                        100% !default;\n$navbar-padding:                    10px 15px !default;\n\n\n// Alerts\n\n$alert-padding-y: .9rem !default;\n$alert-padding-x: 1.25rem !default;\n$alert-border-radius: $border-radius-sm !default;\n\n$alert-bg-level: -2 !default;\n$alert-border-level: -2 !default;\n$alert-color-level: 0 !default;\n\n\n// List group\n\n$list-group-bg:                     $white !default;\n$list-group-border-color:           $border-color !default; //rgba($black, .125);\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         1rem !default;\n$list-group-item-padding-x:         1rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $list-group-action-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-bg:                          transparent !default;\n$close-hover-bg:                    transparent !default;\n$close-color:                       rgba(0, 0, 0, .6);\n$close-hover-color:                 rgba(0, 0, 0, .9);\n$close-text-shadow:                 none !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              1px !default;\n$popover-border-color:              rgba($black, .05);\n$popover-border-radius:             $border-radius-lg !default;\n$popover-box-shadow:                0px .5rem 2rem 0px rgba($black, .2);\n\n$popover-header-bg:                 $popover-bg !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .75rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1.5rem !default;\n$popover-arrow-height:              .75rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         transparent !default;\n\n// Breadcrumbs\n\n$breadcrumb-bg:                     $black-states !default;\n$breadcrumb-divider-color:          $white !default;\n$breadcrumb-active-color:           $white !default;\n\n\n\n\n// Badges\n\n$badge-font-size:                   $font-size-xs !default;\n$badge-font-weight:                 $font-weight-extra-bold !default;\n$badge-padding-y:                   .25rem !default;\n$badge-padding-x:                   .5rem !default;\n$badge-border-radius:               $border-radius !default;\n$badge-text-transfom:               uppercase;\n\n$badge-pill-padding-x:              .875em !default;\n$badge-pill-border-radius:          $border-radius-xl !default;\n\n$badge-circle-size:                 2rem;\n\n// Pagination\n\n$pagination-padding-y:                0 !default;\n$pagination-padding-x:                .6875rem !default;\n\n\n$pagination-color:                  $white !default;\n$pagination-bg:                     transparent  !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n//$pagination-focus-box-shadow:       $btn-hover-box-shadow !default;\n\n$pagination-hover-color:            $gray-600 !default;\n$pagination-hover-bg:               $gray-300 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n$pagination-active-box-shadow:      $btn-hover-box-shadow !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            transparent !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n\n// Cards\n\n$card-spacer-y:                     1.25rem !default;\n$card-spacer-x:                     1.5rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius-sm !default;\n$card-border-color:                 rgba($black, .05);\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width});\n$card-cap-bg:                       $gray-100 !default;\n$card-bg:                           $white !default;\n$card-black-background:             #27293d !default;\n$card-img-overlay-padding:          1.25rem !default;\n\n//$card-group-margin:                 ($grid-gutter-width / 2);\n//$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $black !default;\n$tooltip-bg:                        $white !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Modals\n\n$modal-inner-padding:               24px 24px 16px 24px !default;\n\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          380px !default;\n$modal-title-line-height:           1.1;\n$modal-content-bg:               $white !default;\n$modal-content-border-color:     rgba($black, .2);\n$modal-content-border-width:     1px !default;\n$modal-content-border-radius:    $border-radius-sm !default;\n$modal-content-box-shadow-xs:    0px 10px 50px 0px rgba(0, 0, 0, 0.5);\n$modal-content-box-shadow-sm-up: 0 15px 35px rgba(50,50,93,.2), 0 5px 15px rgba(0,0,0,.17);\n\n$modal-backdrop-bg:           $black !default;\n$modal-backdrop-opacity:      .16 !default;\n$modal-header-border-color:   $gray-200 !default;\n$modal-footer-border-color:   $modal-header-border-color !default;\n$modal-header-border-width:   $modal-content-border-width !default;\n$modal-footer-border-width:   $modal-header-border-width !default;\n$modal-header-padding:        24px 24px 0 24px !default;\n\n// Progress bars\n\n$progress-height:                   .5rem !default;\n$progress-bg:                       rgba(0, 0, 0, 0.3) !default;\n$progress-border-radius:            $border-radius-xl !default;\n$progress-box-shadow:               0px 0px 0px 3px rgba(0, 0, 0, 0.3) !default;\n$progress-bar-color:                $white !default;\n\n// Datepicker\n\n$datepicker-border-radius: $card-border-radius !default;\n$datepicker-dropdown-padding: 20px 22px !default;\n\n$datepicker-cell-transition: $transition-base !default;\n$datepicker-cell-hover-background: lighten($gray-400, 55%);\n$datepicker-cell-border-radius: 50% !default;\n$datepicker-cell-width: 36px !default;\n$datepicker-cell-height: 36px !default;\n\n$datepicker-disabled-cell-color: $gray-300 !default;\n$datepicker-disabled-old-new-color: $gray-500 !default;\n\n$datepicker-header-cell-border-radius: $border-radius !default;\n\n$datepicker-active-color: $white !default;\n$datepicker-active-background: theme-color(\"primary\") !default;\n$datepicker-active-box-shadow:      none !default;\n\n$datepicker-range-background: theme-color(\"primary\") !default;\n$datepicker-range-cell-focused-background: darken($datepicker-range-background, 5%);\n$datepicker-range-color: $white !default;\n$datepicker-range-highlighted-bg: $gray-200 !default;\n\n$datepicker-dropdown-border: lighten($gray-400, 40%);\n$datepicker-dropdown-bg: $white !default;\n$datepicker-highlighted-bg: $datepicker-active-background !default;\n\n// Sidebar\n\n$sidebar-width:            260px;\n$sidebar-transition:       .5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n$sidebar-box-shadow:       0px 2px 22px 0 rgba(0, 0, 0,.20), 0px 2px 30px 0 rgba(0, 0, 0,.35);\n\n// Footer\n\n$footer-link-font-size: .85rem !default;\n$footer-bg: theme-color(\"secondary\") !default;\n$footer-color: $gray-600 !default;\n$footer-link-color: $gray-600 !default;\n$footer-link-hover-color: $gray-700 !default;\n$footer-heading-color: $gray-600 !default;\n$footer-heading-font-size: $font-size-sm !default;\n","@mixin input-size($padding-vertical, $padding-horizontal){\n    padding: $padding-vertical $padding-horizontal;\n}\n\n@mixin form-control-placeholder($color, $opacity){\n   .form-control::-moz-placeholder{\n       color: $color;\n       @include opacity(1);\n   }\n   .form-control:-moz-placeholder{\n       color: $color;\n       @include opacity(1);\n   }\n   .form-control::-webkit-input-placeholder{\n       color: $color;\n       @include opacity(1);\n   }\n   .form-control:-ms-input-placeholder{\n       color: $color;\n       @include opacity(1);\n   }\n}\n\n@mixin placeholder() {\n  &::-moz-placeholder {@content; } // Firefox\n  &:-ms-input-placeholder {@content; } // Internet Explorer 10+\n  &::-webkit-input-placeholder  {@content; } // Safari and Chrome\n}\n\n@mixin light-form(){\n    border-radius: 0;\n    border:0;\n    padding: 0;\n    background-color: transparent;\n\n}\n\n\n@mixin form-control-lg-padding($padding-vertical, $padding-horizontal) {\n    .form-group.no-border.form-control-lg,\n    .input-group.no-border.form-control-lg{\n        .input-group-append .input-group-text{\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n        }\n\n        .form-control{\n            padding: $padding-vertical $padding-horizontal;\n\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n            }\n\n\n        }\n    }\n\n    .form-group.form-control-lg,\n    .input-group.form-control-lg{\n        .form-control{\n            padding: $padding-vertical - 1 $padding-horizontal - 1;\n            height: 100%;\n\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\n            }\n        }\n\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            padding: $padding-vertical - 1 0 $padding-vertical $padding-horizontal - 1;\n\n            & + .form-control{\n                padding: $padding-vertical  $padding-horizontal - 1 $padding-vertical $padding-horizontal - 3;\n            }\n        }\n    }\n}\n\n\n\n@mixin input-base-padding($padding-vertical, $padding-horizontal) {\n    .form-group.no-border,\n    .input-group.no-border{\n        .form-control{\n            padding: $padding-vertical $padding-horizontal;\n\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n            }\n        }\n\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n        }\n    }\n\n    .form-group,\n    .input-group{\n        .form-control{\n            padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 $padding-horizontal - 1;\n\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\n            }\n        }\n\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            padding: $padding-vertical - 1 0 $padding-vertical - 1 $padding-horizontal - 1;\n\n            & + .form-control,\n            & ~ .form-control{\n                padding:$padding-vertical - 1 $padding-horizontal $padding-vertical $padding-horizontal - 3;\n            }\n        }\n    }\n}\n\n\n//color1 = $opacity-5\n//color2 = $opacity-8\n//color3 = $white-color\n//color4 = $transparent-bg\n//color5 = $opacity-1\n//color6 = $opacity-2\n\n\n@mixin input-coloured-bg($color1, $color2, $color3, $color4, $color5, $color6) {\n    @include form-control-placeholder(rgba($white, 0.4), 1);\n\n    .form-control{\n        border-color: $color1;\n        color: $color2;\n\n        &:focus{\n            border-color: $color3;\n            background-color: $color4;\n            color: $color3;\n        }\n    }\n\n    .has-success,\n    .has-danger{\n        &:after{\n            color: $color3;\n        }\n    }\n\n    .has-danger{\n        .form-control{\n            background-color: $color4;\n        }\n    }\n\n    .input-group-prepend{\n      margin-right: 0;\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: rgba($background-black, 0.2);\n        border-color: $color1;\n        color: $color2;\n\n\n    }\n\n    .input-group-focus{\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            background-color: rgba($background-black, 0.3);\n            border-color: $color3;\n            color: $color3;\n        }\n    }\n\n    .form-group.no-border,\n    .input-group.no-border{\n        .form-control{\n            background-color: rgba($background-black,0.2);\n            color: $color2;\n\n            &:focus,\n            &:active,\n            &:active{\n                background-color: rgba($background-black,0.3);\n                color: $color3;\n            }\n        }\n\n        .form-control + .input-group-prepend .input-group-text,\n        .form-control + .input-group-append .input-group-text{\n            background-color: rgba($background-black,0.2);;\n\n            &:focus,\n            &:active,\n            &:active{\n                background-color: rgba($background-black,0.3);\n                color: $color3;\n            }\n        }\n\n        .form-control{\n            &:focus{\n                & + .input-group-prepend .input-group-text,\n                & + .input-group-append .input-group-text{\n                    background-color: rgba($background-black, 0.3);\n                    color: $color3;\n                }\n            }\n        }\n\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            background-color: rgba($background-black, 0.2);\n            border: none;\n            color: $color2;\n        }\n\n        &.input-group-focus{\n            .input-group-prepend .input-group-text,\n            .input-group-append .input-group-text{\n                background-color: rgba($background-black, 0.3);\n                color: $color3;\n            }\n        }\n    }\n\n}\n.input-group .input-group-prepend .input-group-text{\n    padding:8px 0 10px 18px !important;\n}\n.input-group .input-group-prepend .input-group-text i {\n    color:#e59b12;\n}",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @if (length($shadow) == 1) {\n      // We can pass `@include box-shadow(none);`\n      $result: $shadow;\n    } @else {\n      // Filter to avoid invalid properties for example `box-shadow: none, 1px 1px black;`\n      @for $i from 1 through length($shadow) {\n        @if nth($shadow, $i) != \"none\" {\n          $result: append($result, nth($shadow, $i), \"comma\");\n        }\n      }\n    }\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","body {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\niframe {\n    border: 0;\n}\n\nfigcaption,\nfigure,\nmain {\n    display: block;\n}\n\nmain {\n\toverflow: hidden;\n}\n","// Nucleo icons\n\n.section-nucleo-icons .icons-container {\n    position: relative;\n    max-width: 100%;\n    height: 360px;\n    margin: 0 auto;\n    z-index: 1;\n}\n\n.section-nucleo-icons {\n\n    --icon-size: 5rem;\n    --icon-sm-size: 3.75rem;\n    --gutter: 7rem;\n\n    .icons-container {\n        i {\n            position: absolute;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 50%;\n            background: $white;\n            z-index: 1;\n            transform: translate(-50%, -50%);\n            @include box-shadow($box-shadow);\n            transition: all .2s cubic-bezier(.25,.65,.9,.75);\n\n            &.icon {\n                width: var(--icon-size);\n                height: var(--icon-size);\n                font-size: 1.7em;\n            }\n\n            &.icon-sm {\n                width: var(--icon-sm-size);\n                height: var(--icon-sm-size);\n                font-size: 1.5em;\n            }\n\n            &:nth-child(1) {\n                font-size: 42px;\n                color: theme-color(\"warning\");\n                z-index: 2;\n            }\n        }\n\n        &:not(.on-screen) {\n            i {\n                transform: translate(-50%, -50%);\n                left: 50%;\n                top: 50%;\n\n                &:not(:nth-child(1)) {\n                    opacity: 0;\n                } \n            }\n        }\n\n        &.on-screen {\n\n            i {\n                opacity: 1;\n\n                &:nth-child(1) {\n                    left: 50%;\n                    top: 50%;\n                    font-size: 42px;\n                    color: theme-color(\"warning\");\n                }\n\n                &:nth-child(2) {\n                    left: calc(50% + (var(--gutter) * 1.7));\n                    top: 50%;\n                }\n\n                &:nth-child(3) {\n                    left: calc(50% + var(--gutter));\n                    top: calc(50% + var(--gutter));\n                }\n\n                &:nth-child(4) {\n                    left: calc(50% + var(--gutter));\n                    top: calc(50% - var(--gutter));\n                }\n\n                &:nth-child(5) {\n                    left: calc(50% + (var(--gutter) * 4));\n                    top: 50%;\n                }\n\n                &:nth-child(6) {\n                    left: calc(50% + (var(--gutter) * 2.7));\n                    top: calc(50% + (var(--gutter) * 1.5));\n                }\n\n                &:nth-child(7) {\n                    left: calc(50% + (var(--gutter) * 2.7));\n                    top: calc(50% - (var(--gutter) * 1.5));\n                }\n\n                &:nth-child(8) {\n                    left: calc(50% - (var(--gutter) * 1.7));\n                    top: 50%;\n                }\n\n                &:nth-child(9) {\n                    left: calc(50% - var(--gutter));\n                    top: calc(50% + var(--gutter));\n                }\n\n                &:nth-child(10) {\n                    left: calc(50% - var(--gutter));\n                    top: calc(50% - var(--gutter));\n                }\n\n                &:nth-child(11) {\n                    left: calc(50% - (var(--gutter) * 4));\n                    top: 50%;\n                }\n\n                &:nth-child(12) {\n                    left: calc(50% - (var(--gutter) * 2.7));\n                    top: calc(50% + (var(--gutter) * 1.5));\n                }\n\n                &:nth-child(13) {\n                    left: calc(50% - (var(--gutter) * 2.7));\n                    top: calc(50% - (var(--gutter) * 1.5));\n                } \n            }\n            \n        }\n    }\n}\n\n\n// Blurable sections\n\n.blur--hover {\n    position: relative;\n\n    .blur-item {\n        transition: 1s cubic-bezier(.19,1,.22,1);\n        will-change: transform;\n        filter: blur(0);\n        opacity: 1;\n    }\n\n    .blur-hidden {\n        position: absolute;\n        top: calc(50% + 7px);\n        left: 50%;\n        transform: translate(-50%, -50%);\n        opacity: 0;\n        transition: $transition-base;\n        z-index: 100;\n    }\n    &:hover {\n        .blur-item {\n            opacity: .8;\n            filter: blur(10px);\n            transform: scale(.95);\n            z-index: 1;\n        }\n        .blur-hidden {\n            opacity: 1;\n            top: 50%;\n        }\n    }\n}\n","@each $color, $value in $colors {\n\t@include bg-variant(\".bg-#{$color}\", $value, $ignore-warning: true);\n}\n\n@each $color, $value in $theme-colors {\n\t@include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, $ignore-warning: true);\n}\n\n@each $color, $value in $colors {\n\t@include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, $ignore-warning: true);\n}\n\n\n// Sections\n\nsection {\n    //background-color: section-color(\"primary\");\n}\n\n@each $color, $value in $section-colors {\n    @include bg-variant(\".section-#{$color}\", $value, $ignore-warning: true);\n}\n\n@each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, $ignore-warning: true);\n}\n\n\n// Shape (svg) fill colors\n@each $color, $value in $theme-colors {\n    .fill-#{$color}  {\n        fill: $value;\n    }\n\n    .stroke-#{$color}  {\n        stroke: $value;\n    }\n}\n\n.fill-opacity-8 {\n\tfill-opacity: .8;\n}\n",".floating {\n\tanimation: floating 3s ease infinite;\n\twill-change: transform;\n\n\t&:hover {\n        animation-play-state: paused;\n    }\n}\n\n.floating-lg {\n\tanimation: floating-lg 3s ease infinite;\n}\n\n.floating-sm {\n\tanimation: floating-sm 3s ease infinite;\n}\n\n// Keyframes\n\n@keyframes floating-lg {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(15px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}\n\n@keyframes floating {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(10px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}\n\n@keyframes floating-sm {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(5px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}","// Image\n\n.img-center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n// Clearfix\n\n.floatfix {\n    &:before,\n    &:after {\n        content: '';\n        display: table;\n    }\n    &:after {\n        clear: both;\n    }\n}\n\n// Overflows\n\n.overflow-visible {\n    overflow: visible !important;\n}\n.overflow-hidden {\n    overflow: hidden !important;\n}\n\n// Opacity classes\n\n.opacity-1 {\n    opacity: .1 !important;\n}\n.opacity-2 {\n    opacity: .2 !important;\n}\n.opacity-3 {\n    opacity: .3 !important;\n}\n.opacity-4 {\n    opacity: .4 !important;\n}\n.opacity-5 {\n    opacity: .5 !important;\n}\n.opacity-6 {\n    opacity: .6 !important;\n}\n.opacity-7 {\n    opacity: .7 !important;\n}\n.opacity-8 {\n    opacity: .8 !important;\n}\n.opacity-8 {\n    opacity: .9 !important;\n}\n.opacity-10 {\n    opacity: 1 !important;\n}","@each $size, $value in $spacers {\n\t.top-#{$size} {\n\t\ttop: $value;\n\t}\n\t.right-#{$size} {\n\t\tright: $value;\n\t}\n\t.bottom-#{$size} {\n\t\tbottom: $value;\n\t}\n\t.left-#{$size} {\n\t\tleft: $value;\n\t}\n}\n\n.center {\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}","// Height values in vh\n\n.h-100vh {\n\theight: 100vh !important;\n}\n","// Spacing columns vertically\n\n.row.row-grid > [class*=\"col-\"] + [class*=\"col-\"] {\n    margin-top: 3rem;\n}\n\n@include media-breakpoint-up(xl) {\n    .row.row-grid > [class*=\"col-lg-\"] + [class*=\"col-lg-\"] {\n        margin-top: 0;\n    }\n}\n@include media-breakpoint-up(lg) {\n    .row.row-grid > [class*=\"col-md-\"] + [class*=\"col-md-\"] {\n        margin-top: 0;\n    }\n}\n@include media-breakpoint-up(md) {\n    .row.row-grid > [class*=\"col-sm-\"] + [class*=\"col-sm-\"] {\n        margin-top: 0;\n    }\n}\n\n.row-grid + .row-grid {\n    margin-top: 3rem;\n}\n\n// Negative margins and paddings\n\n@include media-breakpoint-up(lg){\n    [class*=\"mt--\"],\n    [class*=\"mr--\"],\n    [class*=\"mb--\"],\n    [class*=\"ml--\"] {\n        position: relative;\n        z-index: 5;\n    }\n\n\n    // Large negative margins in pixels\n\n    .mt--100 {\n        margin-top: -100px !important;\n    }\n    .mr--100 {\n        margin-right: -100px !important;\n    }\n    .mb--100 {\n        margin-bottom: -100px !important;\n    }\n    .ml--100 {\n        margin-left: -100px !important;\n    }\n    .mt--150 {\n        margin-top: -150px !important;\n    }\n    .mb--150 {\n        margin-bottom: -150px !important;\n    }\n    .mt--200 {\n        margin-top: -200px !important;\n    }\n    .mb--200 {\n        margin-bottom: -200px !important;\n    }\n    .mt--300 {\n        margin-top: -300px !important;\n    }\n    .mb--300 {\n        margin-bottom: -300px !important;\n    }\n\n\n    // Large margins in pixels\n\n    .pt-100 {\n        padding-top: 100px !important;\n    }\n    .pb-100 {\n        padding-bottom: 100px !important;\n    }\n    .pt-150 {\n        padding-top: 150px !important;\n    }\n    .pb-150 {\n        padding-bottom: 150px !important;\n    }\n    .pt-200 {\n        padding-top: 200px !important;\n    }\n    .pb-200 {\n        padding-bottom: 200px !important;\n    }\n    .pt-250 {\n        padding-top: 250px !important;\n    }\n    .pb-250 {\n        padding-bottom: 250px !important;\n    }\n    .pt-300 {\n        padding-top: 300px!important;\n    }\n    .pb-300 {\n        padding-bottom: 300px!important;\n    }\n}\n","[class*=\"shadow\"] {\n\t@if $enable-transitions {\n        transition: $transition-base;\n    }\n}\n\n.shadow-sm--hover:hover { box-shadow: $box-shadow-sm !important; }\n.shadow--hover:hover { box-shadow: $box-shadow !important; }\n.shadow-lg--hover:hover { box-shadow: $box-shadow-lg !important; }\n.shadow-none--hover:hover { box-shadow: none !important; }\n","// Weight and italics\n\n.font-weight-300 { font-weight: 300 !important; }\n.font-weight-400 { font-weight: 400 !important; }\n.font-weight-500 { font-weight: 500 !important; }\n.font-weight-600 { font-weight: 600 !important; }\n.font-weight-700 { font-weight: 700 !important; }\n.font-weight-800 { font-weight: 800 !important; }\n.font-weight-900 { font-weight: 900 !important; }\n\n\n// Text decorations\n\n.text-underline { text-decoration: underline; }\n.text-through { text-decoration: line-through; }\n\n\n// Line heights\n\n.lh-100 { line-height: 1; }\n.lh-110 { line-height: 1.1; }\n.lh-120 { line-height: 1.2; }\n.lh-130 { line-height: 1.3; }\n.lh-140 { line-height: 1.4; }\n.lh-150 { line-height: 1.5; }\n.lh-160 { line-height: 1.6; }\n.lh-170 { line-height: 1.7; }\n.lh-180 { line-height: 1.8; }\n\n//Contextual colors\n\n.text-muted { color: $text-muted !important; }\n\n\n\n// Letter spacings\n\n.ls-1 { letter-spacing: .0625rem; }\n.ls-15 { letter-spacing: .09375rem; }\n.ls-2 { letter-spacing: 0.125rem; }\n","@include media-breakpoint-up(xl) {\n\t.transform-perspective-right {\n\t\ttransform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);\n\t}\n\t.transform-perspective-left{\n\t\ttransform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg)\n\t}\n}\n",".alert{\n    border: 0;\n    color: $white;\n\n    .alert-link{\n      color: $white;\n    }\n\n    &.alert-success{\n      background-color: darken($success, 10%);\n    }\n\n    i.fa,\n    i.tim-icons{\n        font-size: $font-paragraph;\n    }\n\n    .close{\n        color: $white;\n        opacity: .9;\n        text-shadow: none;\n        line-height: 0;\n        outline: 0;\n    }\n\n    span[data-notify=\"icon\"]{\n      font-size: 22px;\n      display: block;\n      left: 19px;\n      position: absolute;\n      top: 50%;\n      margin-top: -11px;\n    }\n\n    button.close{\n      position: absolute;\n      right: 15px;\n      top: 50%;\n      margin-top: -13px;\n      width: 25px;\n      height: 25px;\n      padding: 3px;\n    }\n\n    .close ~ span{\n        display: block;\n        max-width: 89%;\n    }\n\n    &.alert-with-icon{\n        padding-left: 65px;\n    }\n}\n\n.alert-dismissible {\n    .close {\n        top: 50%;\n        right: $alert-padding-x;\n        padding: 0;\n        transform: translateY(-50%);\n        color: rgba($white, .6);\n        opacity: 1;\n\n        &:hover,\n        &:focus {\n            color: rgba($white, .9);\n            opacity: 1 !important;\n        }\n\n        @include media-breakpoint-down(xs) {\n            top: 1rem;\n            right: .5rem;\n        }\n\n        &>span:not(.sr-only) {\n            font-size: 1.5rem;\n            background-color: transparent;\n            color: rgba($white, .6);\n        }\n\n        &:hover,\n        &:focus {\n            &>span:not(.sr-only) {\n                background-color: transparent;\n                color: rgba($white, .9);\n            }\n        }\n    }\n}\n",".avatar {\n\tcolor: $white;\n\tbackground-color: $gray-500;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: $font-paragraph;\n\tborder-radius: 50%;\n\theight: 48px;\n\twidth: 48px;\n}\n\n.avatar img {\n\twidth: 100%;\n\tborder-radius: 50%;\n}\n\n.avatar + .avatar-content {\n\tdisplay: inline-block;\n\tmargin-left: .75rem;\n}\n.avatar-lg {\n\twidth: 58px;\n\theight: 58px;\n\tfont-size: $font-size-sm;\n}\n\n.avatar-sm {\n\twidth: 38px;\n\theight: 38px;\n\tfont-size: $font-size-sm;\n}\n\n// Overlapped avatars\n\n.avatar-group {\n\t.avatar {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tborder: 2px solid $card-bg;\n\n\t\t&:hover {\n\t\t\tz-index: 3;\n\t\t}\n\t}\n\n\t.avatar + .avatar {\n\t\tmargin-left: -1rem;\n\n\t}\n}\n","/*           badges             */\n.badge{\n    text-transform: uppercase;\n    line-height: 12px;\n    border: none;\n    text-decoration: none;\n    margin-bottom: 5px;\n\n    &:hover,\n    &:focus{\n      text-decoration: none;\n    }\n}\n\n.badge-icon{\n  padding: 0.4em 0.55em;\n\n  i {\n     font-size: 0.8em;\n  }\n}\n\n.badge-success{\n    @include badge-variant(darken($success,10%));\n}\n",".btn,\n.navbar .navbar-nav > a.btn{\n    border-width: $border-thick;\n    border: none;\n    position: relative;\n    overflow: hidden;\n    margin:4px 1px;\n    border-radius: $border-radius-lg;\n    cursor: pointer;\n\n    @include btn-styles($default, $default-states);\n\n    &:hover,\n    &:focus{\n        @include opacity(1);\n        outline: 0 !important;\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n    .badge{\n      margin: 0;\n    }\n\n    &.btn-icon {\n        // see above for color variations\n        height: $icon-size-regular;\n        min-width: $icon-size-regular;\n        width: $icon-size-regular;\n        padding: 0;\n        font-size: $icon-font-size-regular;\n        overflow: hidden;\n        position: relative;\n        line-height: normal;\n\n        &.btn-simple{\n            padding: 0;\n        }\n\n        &.btn-sm{\n            height: $icon-size-sm;\n            min-width: $icon-size-sm;\n            width: $icon-size-sm;\n\n            .fa,\n            .far,\n            .fas,\n            .tim-icons{\n                font-size: $icon-font-size-sm;\n            }\n        }\n\n        &.btn-lg{\n            height: $icon-size-lg;\n            min-width: $icon-size-lg;\n            width: $icon-size-lg;\n\n            .fa,\n            .far,\n            .fas,\n            .tim-icons{\n                font-size: $icon-font-size-lg;\n            }\n        }\n\n        &:not(.btn-footer) .tim-icons,\n        &:not(.btn-footer) .fa,\n        &:not(.btn-footer) .far,\n        &:not(.btn-footer) .fas{\n            position: absolute;\n            font-size: 1em;\n            top: 50%;\n            left: 50%;\n            transform: translate(-12px, -12px);\n            line-height: 1.5626rem;\n            width: 24px;\n        }\n\n    }\n\n    &:not(.btn-icon) .tim-icons{\n        position: relative;\n        top: 1px;\n    }\n\n    span{\n      position: relative;\n      display: block;\n    }\n\n  &.btn-link.dropdown-toggle {\n    color: $dark-gray;\n  }\n\n  &.dropdown-toggle:after {\n    margin-left: 30px !important;\n  }\n}\n\n// Apply the mixin to the buttons\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\n.btn-primary { @include btn-styles($primary, $primary-states);\n\n              }\n.btn-success { @include btn-styles($success, $success-states);\n\n              }\n.btn-info    { @include btn-styles($info, $info-states);\n\n              }\n.btn-warning { @include btn-styles($warning, $warning-states);\n                &:not(:disabled):not(.disabled):active{\n                  color: $white;\n                }\n              }\n.btn-danger  { @include btn-styles($danger, $danger-states);\n\n              }\n.btn-neutral { @include btn-styles($white, $white); }\n\n.btn{\n     &:disabled,\n     &[disabled],\n     &.disabled{\n        @include opacity(.5);\n        pointer-events: none;\n    }\n}\n.btn-simple{\n    border: $border;\n    border-color: $default;\n    box-shadow: none;\n    padding: $padding-btn-vertical - 1 $padding-round-horizontal - 1;\n    background-color: $transparent-bg;\n}\n\n.btn-simple,\n.btn-link{\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background: $transparent-bg;\n        }\n    }\n}\n\n.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active{\n  box-shadow: 2px 2px 6px rgba(0,0,0,.4);\n}\n.btn-link{\n    border: $none;\n    box-shadow: none;\n    padding: $padding-base-vertical $padding-base-horizontal;\n    background: $transparent-bg;\n    color: $gray-300;\n    font-weight: $font-weight-bold;\n\n  &:hover {\n    box-shadow: none !important;\n    transform: none !important;\n  }\n}\n\n.btn-lg{\n   @include btn-size($btn-padding-y-lg, $btn-padding-x-lg, $font-size-base, $border-radius-lg);\n}\n.btn-sm{\n    @include btn-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-base, $border-radius-sm);\n}\n\n.btn-wd {\n    min-width: 140px;\n}\n.btn-group.select{\n    width: 100%;\n}\n\n.btn-group {\n  .btn.active {\n    box-shadow: 2px 2px 6px rgba(0,0,0,.4);\n    transform: translateY(-1px);\n    -webkit-transform: translateY(-1px);\n  }\n\n  label.btn.active {\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n  }\n}\n\n\n.btn-group.select .btn{\n    text-align: left;\n}\n.btn-group.select .caret{\n    position: absolute;\n    top: 50%;\n    margin-top: -1px;\n    right: 8px;\n}\n\n.btn-round{\n    border-width: $border-thin;\n    border-radius: $btn-round-radius;\n\n    &.btn-simple{\n        padding: $padding-btn-vertical - 1  $padding-round-horizontal - 1;\n    }\n}\n\n.no-caret {\n  &.dropdown-toggle::after {\n    display: none;\n  }\n}\n\n.btn{\n  // social buttons\n  &.btn-facebook {\n    @include social-buttons-color($facebook, $facebook-states);\n  }\n  &.btn-twitter {\n    @include social-buttons-color($twitter, $twitter-states);\n  }\n  &.btn-pinterest {\n    @include social-buttons-color($pinterest, $pinterest-states);\n  }\n  &.btn-google {\n    @include social-buttons-color($google-plus, $google-plus-states);\n  }\n  &.btn-linkedin {\n    @include social-buttons-color($linkedin, $linkedin-states);\n  }\n  &.btn-dribbble {\n    @include social-buttons-color($dribbble, $dribbble-states);\n  }\n  &.btn-github {\n    @include social-buttons-color($github, $github-states);\n  }\n  &.btn-youtube {\n    @include social-buttons-color($youtube, $youtube-states);\n  }\n  &.btn-instagram {\n    @include social-buttons-color($instagram, $instagram-states);\n  }\n  &.btn-reddit {\n    @include social-buttons-color($reddit, $reddit-states);\n  }\n  &.btn-tumblr {\n    @include social-buttons-color($tumblr, $tumblr-states);\n  }\n  &.btn-behance {\n    @include social-buttons-color($behance, $behance-states);\n  }\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active,\n.btn-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-secondary.dropdown-toggle {\n    color: $white;\n}\n\n\n\n@include media-breakpoint-down(md) {\n  .btn-group .btn {\n    padding-left: $padding-round-horizontal;\n    padding-right: $padding-round-horizontal;\n  }\n}\n","\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-y($value){\n     -webkit-transform:  translate3d(0,$value,0);\n        -moz-transform: translate3d(0,$value,0);\n        -o-transform: translate3d(0,$value,0);\n        -ms-transform: translate3d(0,$value,0);\n        transform: translate3d(0,$value,0);\n}\n\n@mixin transitions($time, $type){\n    -webkit-transition: all $time $type;\n    -moz-transition: all $time $type;\n    -o-transition: all $time $type;\n    -ms-transition: all $time $type;\n    transition: all $time $type;\n}\n\n@mixin diagonal-gradient($start-color, $end-color){\n  background: $start-color;\n  background-image: -webkit-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\n  background-image: -o-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\n  background-image: -moz-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\n  background-image: linear-gradient(to bottom left, $start-color, $end-color, $start-color);\n  background-size: 210% 210%;\n  background-position: top right;\n}\n\n@mixin bar-animation($type){\n     -webkit-animation: $type 500ms linear 0s;\n     -moz-animation: $type 500ms linear 0s;\n     animation: $type 500ms 0s;\n     -webkit-animation-fill-mode: forwards;\n     -moz-animation-fill-mode: forwards;\n     animation-fill-mode: forwards;\n}\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n@mixin transform-translate-y-dropdown($value) {\n    -webkit-transform:  translate3d(0,$value,0) !important;\n       -moz-transform: translate3d(0,$value,0) !important;\n       -o-transform: translate3d(0,$value,0) !important;\n       -ms-transform: translate3d(0,$value,0) !important;\n       transform: translate3d(0,$value,0) !important;\n}\n\n@mixin linear-gradient($color, $states-color){\n    background: $color;\n    background: -webkit-linear-gradient(0deg, $color 0%, $states-color 100%);\n    background: -o-linear-gradient(0deg, $color 0%, $states-color 100%);\n    background: -moz-linear-gradient(0deg, $color 0%, $states-color 100%);\n    background: linear-gradient(0deg, $color 0%, $states-color 100%);\n}\n\n@mixin linear-gradient-right($color, $states-color){\n    background: $color;\n    background: -webkit-linear-gradient(to right, $color 0%, $states-color 100%);\n    background: -o-linear-gradient(to right, $color 0%, $states-color 100%);\n    background: -moz-linear-gradient(to right, $color 0%, $states-color 100%);\n    background: linear-gradient(to right, $color 0%, $states-color 100%);\n}\n\n@mixin sidebar-color($color){\n  &:after{\n    background: $color;\n  }\n\n  .nav li.active > a{\n    color: $color;\n\n    i{\n      color: $color;\n    }\n  }\n}\n\n@mixin transition-input-focus-color() {\n    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n}\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n\n\n@mixin nc-rotate($degrees, $rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\n  -webkit-transform: rotate($degrees);\n  -moz-transform: rotate($degrees);\n  -ms-transform: rotate($degrees);\n  -o-transform: rotate($degrees);\n  transform: rotate($degrees);\n}\n\n@mixin nc-flip($horiz, $vert, $rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\n  -webkit-transform: scale($horiz, $vert);\n  -moz-transform: scale($horiz, $vert);\n  -ms-transform: scale($horiz, $vert);\n  -o-transform: scale($horiz, $vert);\n  transform: scale($horiz, $vert);\n}\n","@mixin btn-styles($btn-color, $btn-states-color) {\n  @include diagonal-gradient($btn-color, $btn-states-color);\n    background-color: $btn-color;\n    transition: all 0.15s ease;\n    box-shadow: none;\n    &.animation-on-hover:hover{\n      background-position: bottom left;\n      transition:0.3s ease-in-out;\n    }\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    &:active:focus,\n    &:active:hover,\n    &.active:focus,\n    &.active:hover\n     {\n        background-color: $btn-states-color !important;\n        background-image: linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n        background-image: -webkit-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n        background-image: -o-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n        background-image: -moz-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n        color: $white;\n        box-shadow: none;\n    }\n\n    &:active{\n      box-shadow: none !important;\n      transform: translateY(1px) !important;\n      transition: all .15s ease;\n    }\n\n    &:not([data-action]):hover{\n\n        box-shadow:  2px 2px 6px rgba(0,0,0,0.4);\n        transform: translateY(-1px);\n        -webkit-transform: translateY(-1px);\n    }\n\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $btn-color;\n            border-color: $btn-color;\n        }\n    }\n\n    // btn-neutral style\n    @if $btn-color == $white{\n        color: $primary;\n\n        &.btn-danger{\n            color: $danger;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $danger-states;\n            }\n        }\n\n        &.btn-info{\n            color: $info;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $info-states;\n            }\n        }\n\n        &.btn-warning{\n            color: $warning;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $warning-states;\n            }\n        }\n\n        &.btn-success{\n            color: $success;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $success-states;\n            }\n        }\n\n        &.btn-default{\n            color: $default;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $default-states;\n            }\n        }\n\n        &.active,\n        &:active,\n        &:active:focus,\n        &:active:hover,\n        &.active:focus,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover {\n            background-color: $white;\n            color: $primary-states;\n            box-shadow: none;\n        }\n\n        &:hover,\n        &:focus{\n            color: $primary-states;\n\n            &:not(.nav-link){\n                box-shadow: none;\n            }\n\n        }\n\n    } @else {\n        color: $white;\n    }\n\n    &.btn-simple{\n        color: $btn-color;\n        border-color: $btn-color;\n        background: $transparent-bg;\n\n        &:hover,\n        &:focus,\n        &:active,\n        &:not(:disabled):not(.disabled):active{\n            color: $btn-color;\n            border-color: $btn-color;\n            background-color: $transparent-bg !important;\n            background-image: none !important;\n            box-shadow: none;\n        }\n\n        &.active{\n          border-color: $btn-color !important;\n          &:hover,\n          &:focus,\n          &:active,\n          &:not(:disabled):not(.disabled):active{\n              color: $white;\n              border-color: $btn-color;\n              background-image: linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n              background-image: -webkit-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n              background-image: -o-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n              background-image: -moz-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n              background-color: $btn-states-color !important;\n              box-shadow: none;\n          }\n        }\n    }\n\n    &.btn-link{\n        color: $btn-color;\n        &:hover,\n        &:focus,\n        &:active{\n            background-color: $transparent-bg !important;\n            background-image: none !important;\n            color: $white !important;\n            text-decoration: none;\n            box-shadow: none;\n        }\n    }\n}\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 0%), $hover-border: darken($border, 0%), $active-background: darken($background, 10%), $active-border: darken($border, 0%)) {\n    color: color-yiq($background);\n    @include gradient-bg($background);\n    border-color: $border;\n    @include box-shadow($btn-box-shadow);\n\n    @include hover {\n        color: color-yiq($hover-background);\n        @include gradient-bg($hover-background);\n        border-color: $hover-border;\n    }\n\n    &:focus,\n    &.focus {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        @if $enable-shadows {\n            box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n        }\n        @else {\n            box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n        }\n    } // Disabled comes first so active can properly restyle\n    &.disabled,\n    &:disabled {\n        color: color-yiq($background);\n        background-color: $background;\n        border-color: $border;\n    }\n\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    .show>&.dropdown-toggle {\n        color: color-yiq($active-background);\n        background-color: $active-background;\n        @if $enable-gradients {\n            background-image: none; // Remove the gradient for the pressed/active state\n        }\n        border-color: $active-border;\n\n        &:focus {\n            // Avoid using mixin so we can pass custom focus shadow properly\n            @if $enable-shadows {\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n            }\n            @else {\n                box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n            }\n        }\n    }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n    color: $color;\n    background-color: transparent;\n    background-image: none;\n    border-color: $color;\n\n    &:hover {\n        color: $color-hover;\n        background-color: $active-background;\n        border-color: $active-border;\n    }\n\n    &:focus,\n    &.focus {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n    }\n\n    &.disabled,\n    &:disabled {\n        color: $color;\n        background-color: transparent;\n    }\n\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    .show>&.dropdown-toggle {\n        color: color-yiq($active-background);\n        background-color: $active-background;\n        border-color: $active-border;\n\n        &:focus {\n            // Avoid using mixin so we can pass custom focus shadow properly\n            @if $enable-shadows and $btn-active-box-shadow !=none {\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n            }\n            @else {\n                box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n            }\n        }\n    }\n}\n\n// Button sizes\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n\n   &.btn-simple{\n       padding: $padding-vertical - 1 $padding-horizontal - 1;\n   }\n\n}\n\n// for social buttons\n@mixin social-buttons-color ($color, $state-color){\n  @include diagonal-gradient($color, darken($color,20%));\n    //background-color: $color;\n    color: $white;\n    background-size: 210% 210%;\n    background-position: top right;\n    background-repeat: space;\n\n    &:focus,\n    &:active,\n    &:hover{\n        background-color: $state-color;\n        background-image: linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\n        background-image: -webkit-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\n        background-image: -o-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\n        background-image: -moz-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\n        color: $white;\n    }\n\n    &.btn-simple{\n        color: $state-color;\n        background-color: $transparent-bg;\n        background-image: none !important;\n        box-shadow: none;\n        border-color: $state-color;\n\n        &:hover,\n        &:focus,\n        &:active{\n            color: $state-color;\n            border-color: $state-color;\n        }\n    }\n\n    &.btn-neutral{\n        color: $color;\n        background-color: $white;\n\n\n        &:hover,\n        &:focus,\n        &:active{\n            color: $state-color;\n        }\n    }\n}\n","// Opacity\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  // IE8 filter\n  $opacity-ie: ($opacity * 100);\n  filter: #{alpha(opacity=$opacity-ie)};\n}\n",".close { \n    @if $enable-transitions {\n        transition: $transition-base;\n    } \n    &>span:not(.sr-only) {\n        background-color: $close-bg;\n        color: $close-color;\n        line-height: 17px;\n        height: 1.25rem;\n        width: 1.25rem; \n        border-radius: 50%;\n        font-size: 1.25rem;\n        display: block;\n        @if $enable-transitions {\n            transition: $transition-base;\n        } \n    } \n\n    &:hover,\n    &:focus {\n        background-color: $close-hover-bg;\n        color: $close-hover-color;\n        outline: none;\n        \n        span:not(.sr-only) {\n            background-color: $close-hover-bg;\n        }\n    }\n}\n",".custom-control-label {\n    // Background-color and (when enabled) gradient\n    &::before {\n        border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n        @if $enable-transitions {\n            transition: $input-transition;\n        } \n    }\n\n    span {\n        position: relative;\n        top: 2px;\n    }\n} \n\n.custom-control-label {\n    margin-bottom: 0;\n}\n\n.custom-control-input {\n    &:active~.custom-control-label::before {\n        border-color: $custom-control-indicator-active-border-color;\n    }\n}\n\n// Alternative custom control \n.custom-control-alternative {\n    .custom-control-label {\n        // Background-color and (when enabled) gradient\n        &::before {\n            border: 0;\n            box-shadow: $input-alternative-box-shadow;\n        }\n    } \n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    box-shadow: $input-focus-alternative-box-shadow;\n                }\n            }\n        }\n\n        &:active~.custom-control-label::before,\n        &:focus~.custom-control-label::before {\n            box-shadow: $input-alternative-box-shadow;\n        }\n    }\n}\n\n\n// Checkboxes\n.custom-checkbox {\n    .custom-control-input~.custom-control-label {\n        cursor: pointer;\n        font-size: $font-size-sm;\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-checked-border-color;\n                }\n                &::after {\n                    background-image: $custom-checkbox-indicator-icon-checked;\n                }\n            }\n        }\n\n        &:disabled {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-disabled-bg;\n                }\n            }\n\n            &:checked {\n                &::before {\n                    border-color: $custom-control-indicator-checked-disabled-bg;\n                }\n            }\n        }\n    }\n}\n\n// Radios\n.custom-radio {\n    .custom-control-input~.custom-control-label {\n        cursor: pointer;\n        font-size: $font-size-sm;\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-checked-border-color;\n                }\n                &::after {\n                    background-image: $custom-radio-indicator-icon-checked;\n                }\n            }\n        }\n\n        &:disabled {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-disabled-bg;\n                }\n            }\n\n            &:checked {\n                &::before {\n                    border-color: $custom-control-indicator-checked-disabled-bg;\n                }\n            }\n        }\n    }\n\n}\n\n// Toggles\n.custom-toggle {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 1.5rem;\n\n    input {\n        display: none;\n\n        &:checked {\n             + .custom-toggle-slider {\n                border: $custom-control-indicator-border-width solid $custom-control-indicator-checked-border-color;\n\n                &:before {\n                    background: $custom-toggle-checked-bg;\n                    transform: translateX(1.625rem);\n                }  \n            }\n        }\n        \n        &:disabled {\n            + .custom-toggle-slider {\n                border: $custom-control-indicator-border-width solid $custom-control-indicator-disabled-bg;\n            }\n\n            &:checked {\n                + .custom-toggle-slider {\n                    border: $custom-control-indicator-border-width solid $custom-control-indicator-disabled-bg;\n\n                    &:before {\n                        background-color: lighten($custom-control-indicator-checked-bg, 10%);\n                    }\n                }\n            }\n        }\n    }\n}\n\n.custom-toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: $custom-control-indicator-border-width solid $input-border-color;\n    border-radius: 34px !important;\n    background-color: transparent;\n    \n\n    &:before {\n        position: absolute;\n        content: \"\";\n        height: 18px;\n        width: 18px;\n        left: 2px;\n        bottom: 2px;\n        border-radius: 50% !important;\n        background-color: $custom-toggle-slider-bg;\n        transition: $input-transition;\n    }\n}\n",".dropdown-menu {\n    border: 0;\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n    border-radius: $border-radius-xs;\n    @include transitions($fast-transition-time, $transition-linear);\n\n    &.dropdown-menu-right {\n      &:before, &:after {\n        left:auto;\n        right: 10px;\n      }\n    }\n\n    &.dropdown-black {\n      background: linear-gradient(to bottom, $black 0%, $black-states 100%);\n      border: 1px solid $default;\n      .dropdown-item {\n        color: rgba(255, 255, 255, 0.7);\n      }\n\n      .dropdown-divider {\n        border-color: $default;\n      }\n\n      &:before {\n        color: $black;\n        z-index: 2;\n      }\n\n      &:after {\n        display: inline-block;\n        position: absolute;\n        width: 0;\n        height: 0;\n        z-index: 1;\n        vertical-align: middle;\n        content: \"\";\n        top: -6px;\n        left: 10px;\n        right: auto;\n        color: $default;\n        border-bottom: .4em solid;\n        border-right: .4em solid transparent;\n        border-left: .4em solid transparent;\n      }\n\n      &.dropdown-menu-right {\n        &:after {\n          left: auto;\n          right: 10px;\n        }\n      }\n\n      .dropup & {\n        &:after {\n          color: $black-states;\n          z-index: 2;\n        }\n\n        &:before {\n          display: inline-block;\n          position: absolute;\n          width: 0;\n          height: 0;\n          vertical-align: middle;\n          content: \"\";\n          top: auto;\n          bottom: -6px;\n          right: auto;\n          left: 10px;\n          color: $dark-background;\n          border-top: .4em solid;\n          border-right: .4em solid transparent;\n          border-left: .4em solid transparent;\n          border-bottom: none;\n          z-index: 1;\n        }\n      }\n    }\n\n    i {\n        margin-right: 5px;\n        position: relative;\n        top: 1px;\n    }\n\n    .tim-icons {\n        margin-right: 10px;\n        position: relative;\n        top: 4px;\n        font-size: 18px;\n        margin-top: -5px;\n        opacity: .5;\n    }\n\n    .dropdown-item {\n        &.active,\n        &:active{\n            color: inherit;\n        }\n    }\n\n    .dropup & {\n        &:before {\n            display: none;\n        }\n\n        &:after {\n          display: inline-block;\n          position: absolute;\n          width: 0;\n          height: 0;\n          vertical-align: middle;\n          content: \"\";\n          top: auto;\n          bottom: -5px;\n          right: auto;\n          left: 10px;\n          color: $white;\n          border-top: .4em solid;\n          border-right: .4em solid transparent;\n          border-left: .4em solid transparent;\n          border-bottom: none;\n        }\n\n        &.dropdown-menu-right {\n          &:after, &:before {\n            right: 10px;\n            left: auto;\n          }\n        }\n    }\n\n\n\n    &:before {\n      display: inline-block;\n      position: absolute;\n      width: 0;\n      height: 0;\n      vertical-align: middle;\n      content: \"\";\n      top: -5px;\n      left: 10px;\n      right: auto;\n      color: $white;\n      border-bottom: .4em solid;\n      border-right: .4em solid transparent;\n      border-left: .4em solid transparent;\n    }\n\n\n\n    &.dropdown-menu-right {\n      right: 0 !important;\n      left: auto !important;\n    }\n\n    .dropdown-item,\n    .bootstrap-select &.inner li a {\n      font-size: $font-size-sm;\n      padding-top: .6rem;\n      padding-bottom: .6rem;\n      margin-top: 5px;\n      @include transitions($fast-transition-time, $transition-linear);\n\n      &:hover,\n      &:focus {\n        background-color: $opacity-gray-3;\n      }\n\n      &.disabled,\n      &:disabled {\n        color: $default-opacity;\n\n        &:hover,\n        &:focus {\n          background-color: transparent;\n          box-shadow: none;\n        }\n      }\n    }\n\n\n    .dropdown-divider {\n        background-color: $opacity-gray-5;\n    }\n\n    .dropdown-header:not([href]):not([tabindex]) {\n        color: $default-opacity;\n        font-size: $font-size-xs;\n        text-transform: uppercase;\n        font-weight: $font-weight-bold;\n    }\n\n    &.dropdown-primary {\n        @include dropdown-colors(darken($primary, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    &.dropdown-info {\n        @include dropdown-colors(darken($info, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    &.dropdown-danger {\n        @include dropdown-colors(darken($danger, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    &.dropdown-success {\n        @include dropdown-colors(darken($success, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    &.dropdown-warning {\n        @include dropdown-colors(darken($warning, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    .dropdown &,\n    .dropup:not(.bootstrap-select) &,\n    .bootstrap-select &:not(.inner),\n    &.bootstrap-datetimepicker-widget.bottom {\n        @include transform-translate-y-dropdown(-20px);\n        visibility: hidden;\n        display: block;\n        @include opacity(0);\n        top: 100% !important;\n    }\n\n    &.bootstrap-datetimepicker-widget.top {\n      @include transform-translate-y-dropdown(-20px);\n      visibility: hidden;\n      display: block;\n      @include opacity(0);\n    }\n\n    &.bootstrap-datetimepicker-widget.top,\n    &.bootstrap-datetimepicker-widget.bottom {\n        @include transform-translate-y-dropdown(-20px);\n    }\n\n    .bootstrap-select.dropup &:not(.inner){\n        @include transform-translate-y-dropdown(25px);\n    }\n\n    .dropup:not(.bootstrap-select) &{\n        @include transform-translate-y-dropdown(20px);\n        top: auto !important;\n        bottom: 100%;\n    }\n\n    .dropdown.show &,\n    .bootstrap-select.show &:not(.inner),\n    &.bootstrap-datetimepicker-widget.top.open,\n    &.bootstrap-datetimepicker-widget.bottom.open,\n    .dropup.show:not(.bootstrap-select) &,\n    .navbar .dropdown.show &{\n        @include opacity(1);\n        visibility: visible;\n        @include transform-translate-y-dropdown(1px);\n    }\n\n    &.bootstrap-datetimepicker-widget.top.open,\n    &.bootstrap-datetimepicker-widget.bottom.open{\n        @include transform-translate-y-dropdown(0px);\n    }\n\n    .dropup.show:not(.bootstrap-select) &{\n        @include transform-translate-y-dropdown(-2px);\n    }\n\n    &.dropdown-navbar{\n      left: -80px;\n      &:before, &:after{\n        left: auto;\n        right: 17px;\n      }\n    }\n\n\n}\n\n.btn{\n    cursor: pointer;\n\n    &.dropdown-toggle[data-toggle=\"dropdown\"]{\n        padding:10px;\n        margin: 0;\n        margin-bottom: 5px;\n\n        &:after{\n          content: \"\";\n          margin-left: 5px;\n        }\n\n    }\n\n    span.bs-caret{\n      display: none;\n    }\n\n    &.btn-link{\n      &.dropdown-toggle{\n        height: 22px;\n        padding: 0;\n        margin-right: 5px;\n      }\n    }\n}\n\n.dropdown-toggle:after{\n\n  content: unset;\n\n}\n\n.btn:not(:disabled):not(.disabled).active:focus,\n .btn:not(:disabled):not(.disabled):active:focus,\n .show>.btn.dropdown-toggle:focus{\n   box-shadow: none;\n }\n\n// Dropown: Sizes\n\n.dropdown-menu-sm {\n    min-width: 100px;\n    border: $border-radius-lg;\n}\n\n.dropdown-menu-lg {\n    min-width: 260px;\n    border-radius: $border-radius-lg;\n}\n\n.dropdown-menu-xl {\n    min-width: 450px;\n    border-radius: $border-radius-lg;\n}\n\n@include media-breakpoint-down(md){\n  .button-dropdown{\n      display: none;\n  }\n  .dropdown-toggle:after{\n      display: inline-block;\n      width: 0;\n      height: 0;\n      margin-left: .255em;\n      vertical-align: .255em;\n      content: \"\";\n      border-top: .3em solid;\n      border-right: .3em solid transparent;\n      border-bottom: 0;\n      border-left: .3em solid transparent;\n\n  }\n}\n\n\n@include media-breakpoint-up(lg){\n  .dropdown-menu .dropdown-item{\n    color: $dark-gray;\n  }\n}\n","@mixin dropdown-colors($brand-color, $dropdown-header-color, $dropdown-color, $background-color ) {\n    background-color: $brand-color;\n\n    &:before{\n        color: $brand-color;\n    }\n\n    .dropdown-header:not([href]):not([tabindex]){\n        color: $dropdown-header-color;\n    }\n\n    .dropdown-item{\n        color: $dropdown-color;\n\n        &:hover,\n        &:focus{\n            background-color: $background-color;\n        }\n    }\n\n    .dropdown-divider{\n        background-color: $background-color;\n    }\n\n  \n}\n",".footer{\n    padding: 24px 30px;\n\n    [class*=\"container-\"] {\n      padding: 0;\n    }\n\n    .nav{\n        display: inline-block;\n        float: left;\n        margin-bottom: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .nav-item{\n      display: inline-block;\n\n      &:first-child a {\n        padding-left: 0;\n      }\n    }\n\n    .nav-link {\n      color: $white;\n      padding: $padding-base-vertical;\n      font-size: $font-size-sm;\n      text-transform: uppercase;\n      text-decoration: none;\n\n      &:hover{\n          text-decoration: none;\n      }\n    }\n\n\n\n    .copyright{\n        font-size: $font-size-sm;\n        line-height: 1.8;\n        color: $white;\n    }\n\n    &:after{\n        display: table;\n        clear: both;\n        content: \" \";\n    }\n}\n\n@include media-breakpoint-down(md){\n\n  .footer {\n    padding-left: 30px;\n    text-align: center;\n\n    .copyright {\n        text-align: right;\n    }\n  }\n\n}\n\n@include media-breakpoint-up(xl){\n  .footer {\n    .copyright {\n      float: right;\n      margin-top: 5px;\n    }\n  }\n}\n\n@include media-breakpoint-down(sm){\n  .footer {\n    text-align: center;\n      nav {\n        display: block;\n        margin-bottom: 5px;\n        float: none;\n      }\n\n      .copyright {\n        text-align: center;\n      }\n  }\n}\n\n@include media-breakpoint-down(sm){\n  .footer {\n    .copyright {\n      text-align: center;\n    }\n    .nav {\n      float: none;\n    }\n  }\n}\n\n@include media-breakpoint-between (md, lg){\n  .footer {\n    padding-left: 30px !important;\n    text-align: center;\n\n    .copyright {\n      float: right;\n      margin-top: 5px;\n    }\n  }\n}\n","/* Form controls */\n@include form-control-placeholder(#6c757c, 1);\n\n.form-control {\n  border-color: lighten($black,5%);\n  border-radius: $border-radius-lg;\n  font-size: $font-size-sm;\n  @include transition-input-focus-color();\n\n\n  &:focus {\n    border-color: $primary;\n    background-color: $input-bg;\n    @include box-shadow(none);\n\n    & + .input-group-append .input-group-text,\n    & ~ .input-group-append .input-group-text,\n    & + .input-group-prepend .input-group-text,\n    & ~ .input-group-prepend .input-group-text {\n        border: 1px solid $primary;\n        border-left: none;\n        background-color: $transparent-bg;\n    }\n  }\n\n  .has-success &,\n  .has-error &,\n  .has-success &:focus,\n  .has-error &:focus {\n      @include box-shadow(none);\n  }\n\n  .has-danger &,\n  .has-success & {\n      &.form-control-success,\n      &.form-control-danger {\n          background-image: none;\n      }\n  }\n\n  & + .form-control-feedback {\n      border-radius: $border-radius-lg;\n      margin-top: -7px;\n      position: absolute;\n      right: 10px;\n      top: 50%;\n      vertical-align: middle;\n  }\n\n  .open & {\n      border-radius: $border-radius-lg $border-radius-lg 0 0;\n      border-bottom-color: $transparent-bg;\n  }\n\n  & + .input-group-append .input-group-text,\n  & + .input-group-prepend .input-group-text {\n      background-color: $white;\n  }\n\n}\n\n.has-success .input-group-append .input-group-text,\n.has-success .input-group-prepend .input-group-text,\n.has-success .form-control {\n    border-color: lighten($black,5%);\n}\n\n.has-success .form-control:focus,\n.has-success.input-group-focus .input-group-append .input-group-text,\n.has-success.input-group-focus .input-group-prepend .input-group-text {\n  border-color: darken($success, 10%);\n}\n\n.has-danger .form-control,\n.has-danger .input-group-append .input-group-text,\n.has-danger .input-group-prepend .input-group-text,\n.has-danger.input-group-focus .input-group-prepend .input-group-text,\n.has-danger.input-group-focus .input-group-append .input-group-text {\n    border-color: lighten($danger-states,5%);\n    color: $danger-states;\n    background-color: rgba(222,222,222, .1);\n\n    &:focus {\n        background-color: $transparent-bg;\n    }\n}\n\n.has-success,\n.has-danger {\n    &:after {\n        font-family: 'nucleo';\n        content: \"\\ea1b\";\n        display: inline-block;\n        position: absolute;\n        right: 20px;\n        top: 13px;\n        color: $success;\n        font-size: 11px;\n    }\n\n    &.form-control-lg {\n      &:after {\n        font-size: 13px;\n        top: 24px;\n      }\n    }\n\n    &.has-label {\n      &:after{\n        top: 37px;\n      }\n    }\n\n\n    &.form-check:after {\n      display: none !important;\n    }\n\n    &.form-check .form-check-label{\n      color: $success;\n    }\n}\n\n.has-danger {\n  &:after{\n    content: \"\\ea48\";\n    color: $danger-states;\n  }\n\n  &.form-check .form-check-label {\n    color: $danger-states;\n  }\n\n  &.input-group-focus {\n    .input-group-text {\n      border-color: #ec250d !important;\n    }\n  }\n}\n\n\n@include media-breakpoint-down(xs) {\n  .form-horizontal .col-form-label,\n  .form-horizontal .label-on-right {\n    text-align: inherit;\n    padding-top: 0;\n    code {\n      padding: 0 10px;\n    }\n  }\n}\n","@include media-breakpoint-up(xl) {\n\t.container-lg {\n\t\tmax-width: 1160px;\n\t}\n}\n",".icon {\n\twidth: $icon-size;\n\theight: $icon-size;\n\n\ti, svg {\n\t\tfont-size: $icon-size - .75;\n\t}\n}\n\n.icon + .icon-text {\n\tpadding-left: 1rem;\n\twidth: calc(100% - #{$icon-size} - 1);\n}\n\n.icon-xl {\n\twidth: $icon-size-xl;\n\theight: $icon-size-xl;\n\n\ti, svg {\n\t\tfont-size: $icon-size-xl - .75;\n\t}\n}\n\n.icon-xl + .icon-text {\n\twidth: calc(100% - #{$icon-size-xl} - 1);\n}\n\n.icon-lg {\n\twidth: $icon-size-lg;\n\theight: $icon-size-lg;\n\n\ti, svg {\n\t\tfont-size: $icon-size-lg - .75;\n\t}\n}\n\n.icon-lg + .icon-text {\n\t// width: calc(100% - #{$icon-size-lg} - 1);\n}\n\n.icon-sm {\n\twidth: $icon-size-sm;\n\theight: $icon-size-sm;\n\n\ti, svg {\n\t\tfont-size: $icon-size-sm - .75;\n\t}\n}\n\n.icon-sm + .icon-text {\n\t// width: calc(100% - #{$icon-size-sm} - 1);\n}\n\n\n// Icons included in shapes\n.icon-shape {\n\tpadding: 12px;\n\ttext-align: center;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\n\n\ti, svg {\n\t\tfont-size: 1.25rem;\n\t}\n\n\t&.icon-lg {\n\t\ti, svg {\n\t\t\tfont-size: 1.625rem;\n\t\t}\n\t}\n\n\t&.icon-sm {\n\t\ti, svg {\n\t\t\tfont-size: .875rem;\n\t\t}\n\t}\n\n\tsvg {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n\n}\n\n@each $color, $value in $theme-colors {\n\t.icon-shape-#{$color} {\n\t\t@include icon-shape-variant(theme-color($color));\n\t}\n}\n","@mixin icon-shape-variant($color) {\n    color: saturate(darken($color, 10%), 10);\n    background-color: transparentize(lighten($color, 10%), .5);\n}","img {\n    max-width: 100%;\n    border-radius: $border-radius-sm;\n}\n.img-raised {\n    box-shadow: $box-shadow-raised;\n}\n",".form-group.has-danger .error,\n.input-group.has-danger .error {\n  color: $danger-states;\n}\n\n\n.form-group.has-success .error,\n.input-group.has-success .error {\n  color: $success;\n}\n\n@include form-control-lg-padding($padding-lg-vertical, $padding-input-horizontal);\n@include input-base-padding($padding-input-vertical, $padding-input-horizontal);\n\n.form-group.no-border,\n.input-group.no-border{\n  .form-control,\n  .form-control + .input-group-prepend .input-group-text,\n  .form-control + .input-group-append .input-group-text{\n\n    background-color: lighten($black,1%);\n    border: medium none;\n    &:focus,\n    &:active,\n    &:active {\n      border: medium none;\n      background-color: lighten($black,2%);\n    }\n  }\n\n  .form-control {\n    &:focus{\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text{\n        background-color: lighten($black,2%);\n      }\n    }\n  }\n\n  .input-group-prepend .input-group-text,\n  .input-group-append .input-group-text{\n    background-color: lighten($black,1%);;\n    border: none;\n  }\n}\n\n.has-error{\n  .form-control-feedback, .control-label{\n    color: $danger-states;\n  }\n}\n.has-success{\n    .form-control-feedback, .control-label{\n        color: $success;\n    }\n}\n\n.input-group-append .input-group-text,\n.input-group-prepend .input-group-text {\n    background-color: transparent;\n    border: 1px solid lighten($black,5%);\n    border-radius: $border-radius-lg;\n    color: $white;\n\n    & i{\n      opacity: .5;\n    }\n\n    @include transition-input-focus-color();\n\n    .has-danger.input-group-focus & {\n        background-color: $transparent-bg;\n    }\n\n    .has-success &{\n        background-color: $transparent-bg;\n    }\n    .has-danger .form-control:focus + & {\n        color: $danger-states;\n    }\n    .has-success .form-control:focus + & {\n        color: $success;\n    }\n\n    & + .form-control,\n    & ~ .form-control {\n        @include input-size($padding-base-vertical - 1, $padding-base-horizontal);\n        padding-left: 18px;\n    }\n\n    i {\n        width: 17px;\n    }\n}\n\n.input-group-append,\n.input-group-prepend .input-group-text,\n.input-group-prepend .input-group-text {\n    background-color: transparent;\n    border: 1px solid lighten($black,5%);\n    border-radius: $border-radius-lg;\n    color: $white;\n    margin: 0;\n}\n\n.input-group-append .input-group-text {\n  border-left: none;\n}\n.input-group-prepend .input-group-text {\n  border-right: none;\n}\n\n.input-group-focus {\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n        background-color: $white;\n        border-color: $primary;\n        background-color: $transparent-bg;\n        border-color: $primary;\n    }\n\n    &.no-border {\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text {\n            background-color: lighten($black,2%);\n        }\n    }\n}\n\n.input-group,\n.form-group {\n    margin-bottom: 10px;\n    position: relative;\n\n    .form-control-static {\n        margin-top: 9px;\n    }\n}\n\n.input-group[disabled] {\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n        background-color: $light-gray;\n    }\n}\n\n.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child) {\n    border-radius: $border-radius-lg;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-left: 0 none;\n}\n\n.input-group .form-control:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-right: 0 none;\n}\n.input-group .form-control:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n    border-left: 0 none;\n}\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n    background-color: $black-states;\n    color: $default;\n    cursor: not-allowed;\n}\n\n.input-group-btn .btn {\n    border-width: $border-thin;\n    padding: $padding-btn-vertical  $padding-base-horizontal;\n}\n.input-group-btn .btn-default:not(.btn-fill) {\n    border-color: $medium-gray;\n}\n\n.input-group-btn:last-child > .btn {\n    margin-left: 0;\n}\n\ntextarea.form-control {\n    max-width: 100%;\n    max-height: 80px;\n    padding: 10px 10px 0 0;\n    resize: none;\n    border: none;\n    border-bottom: 1px solid lighten($black,5%);\n    border-radius: 0;\n    line-height: 2;\n\n    &:focus,\n    &:active {\n      border-left: none;\n      border-top: none;\n      border-right: none;\n    }\n}\n\n.has-success,\n.has-danger {\n  &.form-group .form-control,\n  &.form-group.no-border .form-control {\n    padding-right: $input-padding-horizontal + 21;\n  }\n}\n\n.form.form-newsletter .form-group {\n  float: left;\n  width: 78%;\n  margin-right: 2%;\n  margin-top: 9px;\n}\n\n.input-group .input-group-btn {\n  padding: 0 12px;\n}\n\n// Input files - hide actual input - requires specific markup in the sample.\n.form-group input[type=file] {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.form-text {\n    font-size: $font-size-sm;\n    color: rgba($white,0.8);\n}\n\n.form-control-lg {\n    padding: 0;\n    font-size: inherit;\n    line-height: 0;\n    border-radius: 0;\n\n    .form-control {\n      height: calc(2.875rem + 2px);\n    }\n}\n\n.form-horizontal {\n  .col-form-label,\n  .label-on-right {\n    padding: 10px 5px 0 15px;\n    text-align: right;\n    max-width: 180px;\n  }\n\n    .checkbox-radios {\n      margin-bottom: 15px;\n\n      .form-check:first-child {\n        margin-top: 8px;\n     }\n    }\n\n    .label-on-right {\n      text-align: left;\n      padding: 10px 15px 0 5px;\n    }\n\n    .form-check-inline {\n      margin-top: 6px;\n      .form-check-label {\n        margin-right: 1.5rem;\n      }\n    }\n}\n\n.search-bar {\n    margin-left: $margin-lg-vertical;\n      .btn {\n        margin: 0;\n      }\n       &.input-group {\n           border-radius: 25px;\n           z-index: 4;\n           margin-bottom: 0;\n           height: 43px;\n           .input-group-addon {\n              padding: 10px;\n              background: transparent;\n              border: none;\n              color: rgba(255, 255, 255, 0.7);\n\n           }\n\n           i {\n            font-size: 20px;\n            color: white;\n            margin-top: 0 !important;\n           }\n           input {\n               background: transparent;\n               border:none !important;\n               border-radius: 0;\n               padding: 12px !important;\n               font-size: 12px;\n               opacity: 0.5;\n               &:focus {\n                   background: transparent;\n               }\n           }\n           .form-control {\n               opacity: 1;\n               color: $white;\n               &::placeholder {\n                 color: $white;\n               }\n           }\n       }\n   }\n\n   .modal-search .modal-dialog {\n     max-width: 1000px;\n     margin: 20px auto;\n\n     .form-control {\n       border: none;\n       color: $black;\n\n       &::placeholder {\n         color: $black;\n       }\n     }\n   }\n\n.input-group-prepend {\n  margin-right: 0;\n}\n.input-group-prepend,\n.input-group-append {\n  .tim-icons {\n    font-size: $font-paragraph;\n  }\n}\n",".info{\n    &.info-hover{\n        .info-title{\n            transition: color .4s;\n        }\n\n        &:hover{\n            .icon{\n                @include transform-translate-y(-.5rem);\n\n                &.icon-primary{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.3);\n                    }\n                }\n                &.icon-info{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.3);\n                    }\n                }\n                &.icon-success{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.3);\n                    }\n                }\n                &.icon-warning{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.3);\n                    }\n                }\n                &.icon-danger{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.3);\n                    }\n                }\n\n                &.icon-info + .info-title{\n                    color: $info;\n                }\n\n                &.icon-warning + .info-title{\n                    color: $warning;\n                }\n\n                &.icon-danger + .info-title{\n                    color: $danger;\n                }\n\n                &.icon-primary + .info-title{\n                    color: $primary;\n                }\n\n                &.icon-success + .info-title{\n                    color: $success;\n                }\n            }\n        }\n    }\n\n    .icon{\n        color: $default;\n        transition: transform .4s, box-shadow .4s;\n\n        > i{\n            font-size: 2.3em;\n        }\n\n        &.icon-circle{\n            max-width: 70px;\n            width: 70px;\n            height: 70px;\n            margin: 0 auto;\n            border-radius: 50%;\n            box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);\n            font-size: $font-size-xs;\n            background-color: $white;\n            position: relative;\n\n            i{\n                line-height: 2.6em;\n            }\n        }\n    }\n\n    .info-title{\n        margin: $margin-base-vertical 0 5px;\n        padding: 0 15px;\n        color: $black;\n        font-weight: $font-weight-bold;\n    }\n    p{\n        color: $default;\n        padding: 0 15px;\n        font-size: 1.1em;\n    }\n}\n\n.info-horizontal{\n    text-align: left !important;\n\n    .icon{\n        float: left;\n        margin-top: 23px;\n        margin-right: 10px;\n\n        >i{\n            font-size: 2em;\n        }\n\n        &.icon-circle{\n            width: 65px;\n            height: 65px;\n            max-width: 65px;\n            margin-top: 8px;\n\n            i{\n                display: table;\n                margin: 0 auto;\n                line-height: 3.5;\n                font-size: 1.9em;\n            }\n        }\n    }\n    .description{\n        overflow: hidden;\n    }\n\n}\n\n.icon{\n    &.icon-primary{\n        color: $brand-primary;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($primary, .5);\n        }\n    }\n    &.icon-info{\n        color: $brand-info;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($info, .5);\n        }\n    }\n    &.icon-success{\n        color: $brand-success;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($success, .5);\n        }\n    }\n    &.icon-warning{\n        color: $brand-warning;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($warning, .5);\n        }\n    }\n    &.icon-danger{\n        color: $brand-danger;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($danger, .5);\n        }\n    }\n\n    &.icon-white{\n        color: $white;\n    }\n}\n","// Modals\n// Design element Dialogs\n// --------------------------------------------------\n.modal-content {\n  border: 0;\n\n  // Modal header\n  // Top section of the modal w/ title and dismiss\n\n  .modal-header {\n    border-bottom: none;\n\n    & button {\n        position: absolute;\n        right: 27px;\n        top: 24px;\n        outline: 0;\n        padding: 1rem;\n        margin: -1rem -1rem -1rem auto;\n    }\n    .title{\n        color: $black;\n        margin-top: 5px;\n        margin-bottom: 0;\n    }\n\n    .modal-title{\n      color: $black;\n    }\n\n    i.tim-icons {\n      font-size: 16px;\n    }\n  }\n\n\n  // Modal body\n  // Where all modal content resides (sibling of .modal-header and .modal-footer)\n  .modal-body {\n    line-height: 1.9;\n\n    p{\n      color: $black;\n    }\n  }\n  // Footer (for actions)\n  .modal-footer {\n    border-top: 0;\n    -webkit-justify-content: space-between; /* Safari 6.1+ */\n    justify-content: space-between;\n\n    button {\n      margin: 0;\n      padding-left: 16px;\n      padding-right: 16px;\n      width: auto;\n\n      &.pull-left {\n        padding-left: 5px;\n        padding-right: 5px;\n        position: relative;\n        left: -5px;\n      }\n    }\n\n  }\n  .modal-body + .modal-footer {\n    padding-top: 0;\n  }\n}\n.modal-backdrop {\n  background: rgba(0,0,0,0.3);\n}\n\n.modal{\n  .modal-login{\n    max-width: 320px;\n\n    .card-login{\n        .logo-container{\n            width: 65px;\n            margin-bottom: 38px;\n            margin-top: 27px;\n        }\n    }\n  }\n\n    &.modal-mini{\n        p{\n            text-align: center;\n        }\n\n        .modal-dialog{\n            max-width: 255px;\n            margin: 0 auto;\n\n\n        }\n\n        &.show .modal-dialog{\n            -webkit-transform: translate(0,30%);\n            -o-transform: translate(0,30%);\n            transform: translate(0,30%);\n        }\n\n\n        .modal-footer{\n            button{\n                text-transform: uppercase;\n                color: $white;\n\n                &:first-child{\n                    opacity: .5;\n                }\n            }\n        }\n    }\n\n    .modal-profile{\n        width: 70px;\n        height: 70px;\n        background-color: $white;\n        border-radius: 50%;\n        text-align: center;\n        line-height: 5.7;\n        box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.3);\n\n        i{\n            color: $primary;\n            font-size: 21px;\n            margin-top: -10px;\n        }\n\n        &[class*=\"modal-profile-\"]{\n            i{\n                color: $white;\n            }\n        }\n\n        &.modal-profile-primary{\n            background-color: $primary;\n        }\n\n        &.modal-profile-danger{\n            background-color: $danger;\n        }\n\n        &.modal-profile-warning{\n            background-color: $warning;\n        }\n        &.modal-profile-success{\n            background-color: $success;\n        }\n\n        &.modal-profile-info{\n            background-color: $info;\n        }\n    }\n\n    &.modal-default{\n        @include modal-colors($white, $black);\n    }\n\n    &.modal-primary{\n        @include modal-colors($primary, $white);\n    }\n\n    &.modal-danger{\n        @include modal-colors($danger, $white);\n    }\n\n    &.modal-warning{\n        @include modal-colors($warning, $white);\n    }\n\n    &.modal-success{\n        @include modal-colors($success, $white);\n    }\n\n    &.modal-info{\n        @include modal-colors($info, $white);\n    }\n\n    .modal-header .close{\n        color: $danger;\n        text-shadow: none;\n\n        &:hover,\n        &:focus{\n            opacity: 1;\n        }\n    }\n\n    &.modal-black{\n      .modal-content{\n        background: linear-gradient(to bottom, $black 0%, $black-states 100%);\n        color: rgba($white, 0.8);\n        .modal-header{\n          .modal-title, .title{\n            color: rgba($white, 0.9);\n          }\n        }\n        .modal-body{\n          p{\n            color: rgba($white, 0.8);\n          }\n        }\n      }\n      h1, h2, h3, h4, h5, h6, p{\n        color: $white;\n      }\n    }\n}\n\n.modal-search{\n  .modal-dialog{\n    margin: 20px auto;\n    max-width: 650px;\n    input{\n      border: none;\n      font-size: 17px;\n      font-weight: 100;\n    }\n    span{\n      font-size: 35px;\n      color: $search-gray;\n    }\n  }\n  .modal-content{\n    .modal-header{\n      padding: 24px;\n    }\n  }\n\n  .modal-header .close{\n    color: $dark-background;\n    top: 30px !important;\n  }\n\n  .modal-footer{\n    border-top: 2px solid #f9f9f9;\n    margin: 0px 25px 20px;\n  }\n}\n\n\n@include media-breakpoint-down(xs) {\n  .modal {\n    &.show .modal-dialog {\n      transform: translateY(10%);\n\n      &.modal-notice {\n        transform: translateY(3%);\n      }\n    }\n  }\n}\n","@mixin modal-colors($bg-color, $color) {\n    .modal-content{\n        background-color: $bg-color;\n        color: $color;\n    }\n\n    .modal-body p{\n      color: rgba($white, 0.8);\n    }\n\n    //inputs\n    @include input-coloured-bg($opacity-5, $white, $white, $transparent-bg, $opacity-1, $opacity-2);\n\n\n}\n",".nav-link {\n    color: $nav-link-color;\n\n    &:hover {\n        color: theme-color(\"primary\");\n    }\n}\n\n// Pills\n\n.nav-pills {\n\n    .nav-link {\n    \t  padding: $nav-pills-padding-y $nav-pills-padding-x;\n        color: $nav-pills-link-color;\n        font-weight: 500;\n        background-color: $nav-pills-bg;\n        transition: $transition-base;\n\n        &:hover {\n        \tcolor: $nav-pills-link-hover-color;\n        }\n    }\n\n    .nav-link.active,\n    .show > .nav-link {\n        color: $nav-pills-link-active-color;\n        background-color: $nav-pills-link-active-bg;\n    }\n\n\n}\n\n@include media-breakpoint-down(sm) {\n    .nav-pills:not(.nav-pills-circle) {\n        .nav-item {\n            padding-right: 0;\n        }\n    }\n}\n\n// Nav pills circle\n\n.nav-pills-circle {\n    .nav-link {\n        text-align: center;\n        height: 60px;\n        width: 60px;\n        padding: 0;\n        line-height: 60px;\n        border-radius: 50%;\n    }\n\n    .nav-link-icon {\n        i, svg {\n            font-size: 1rem;\n        }\n    }\n}\n\n// Nav wrapper\n.nav-wrapper {\n    padding: 1rem 0;\n    @include border-top-radius($card-border-radius);\n\n    + .card {\n        @include border-top-radius(0);\n        @include border-bottom-radius($card-border-radius);\n    }\n}\n\n\n@include media-breakpoint-down(sm) {\n  .nav-tabs {\n    display: inline-block;\n    width: 100%;\n    padding-left: 100px;\n    padding-right: 100px;\n    text-align: center;\n\n    .nav-item > .nav-link {\n        margin-bottom: 5px;\n    }\n  }\n}\n",".navbar {\n  width: 100%;\n  z-index: 1050;\n  background: $navbar-color;\n\n  .photo {\n    display: inline-block;\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    vertical-align: middle;\n    overflow: hidden;\n      img{\n        width: 100%;\n      }\n  }\n\n  .navbar-wrapper {\n    display: flex;\n    align-items: center;\n  }\n\n  .navbar-text {\n    color: $white;\n  }\n\n  .btn{\n    margin: 0 5px 0 10px;\n  }\n\n  &.navbar-absolute{\n    position: absolute;\n    z-index: 1050;\n  }\n\n\n  &.navbar-transparent{\n    background: transparent !important;\n  }\n\n  &.bg-white{\n    .navbar-nav{\n      .search-bar.input-group{\n        i{\n          color: $black;\n        }\n      }\n\n      .search-bar.input-group .form-control{\n        background: rgba($black,0.1);\n        border-radius: 4px;\n      }\n\n      a.nav-link{\n        color: $black !important;\n        p{\n          color: $black;\n        }\n      }\n\n    }\n\n    .navbar-text, .navbar-brand{\n      color: $black;\n    }\n\n    .form-control {\n      color: $black !important;\n    }\n\n    .form-control::placeholder {\n      color: $dark-gray !important;\n    }\n\n  }\n\n  &.bg-dark {\n    background: $black !important;\n  }\n\n  &.bg-primary {\n    background-color: $primary !important;\n  }\n\n  &.bg-warning {\n    background-color: $warning !important;\n  }\n\n  &.bg-info {\n    background-color: $info !important;\n  }\n\n  &.bg-success {\n    background-color: darken($success, 10%) !important;\n  }\n\n  &.bg-danger {\n    background-color: $danger !important;\n  }\n\n  .navbar-brand {\n    position: relative;\n    padding-top: .3125rem;\n    padding-bottom: .3125rem;\n    color: $white;\n    margin-left: 17px;\n    text-transform: uppercase;\n    font-size: $font-paragraph;\n  }\n\n  .navbar-toggle button:focus, .navbar-toggler{\n    outline: none;\n  }\n\n}\n\n.navbar-minimize-fixed {\n\tposition: fixed;\n  margin-left: 40px;\n  margin-top: 14px;\n\ttransition: 0.3s ease;\n\tcolor: white;\n\tz-index: 20;\n\topacity: 0;\n\ttransition: 0.2s ease;\n\tbutton{\n\t\ti {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n}\n\n.notification {\n  background: $danger;\n\tcolor: $white;\n\tborder-radius: $border-radius-xl;\n\theight: 6px;\n\twidth: 6px;\n\tposition: absolute;\n\ttext-align: center;\n\tfont-size: 12px;\n\tfont-weight: 800;\n  top: 10px;\n  right: 10px;\n\tborder: 1px solid $danger;\n}\n\n.navbar-nav li{\n  padding: 0 10px;\n  a{\n    color: $white;\n  }\n  i{\n    vertical-align: middle;\n    font-size: 20px;\n  }\n}\n\n@include media-breakpoint-down(md){\n  .navbar {\n    top: -70px;\n  }\n\n  .navbar{\n      .container-fluid{\n          padding-right: 15px;\n          padding-left: 15px;\n      }\n\n      .navbar-collapse{\n        .input-group{\n          margin: 0;\n          margin-top: 5px;\n        }\n      }\n\n      .navbar-nav{\n\n        .btn{\n          margin-left: -3px;\n          display: flex;\n\n          i {\n            margin-right: 12px;\n          }\n\n          span {\n            margin: 0;\n            text-transform: uppercase;\n            font-weight: 300;\n\n            &,\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus {\n              color: $black !important;\n            }\n          }\n        }\n\n          a.nav-link{\n            i{\n              opacity: 1;\n              margin-left: 4px;\n              margin-right: 5px;\n            }\n            p{\n              display: inline-block;\n              text-transform: uppercase;\n              margin-left: 7px;\n            }\n          }\n\n          .modal-search .modal-dialog{\n            padding: 0 40px;\n          }\n          .dropdown{\n            margin: 5px 0;\n            .nav-link{\n              padding-bottom: 0;\n            }\n            .dropdown-menu{\n              .dropdown-item{\n                margin-top: 0;\n                padding-left: 24px;\n              }\n            }\n          }\n      }\n\n      .dropdown.show .dropdown-menu{\n          display: block;\n\n      }\n\n      .dropdown .dropdown-menu{\n          display: none;\n          li a{\n            color: $black;\n          }\n      }\n\n      .dropdown.show .dropdown-menu,\n      .dropdown .dropdown-menu{\n          background-color: transparent;\n          border: 0;\n          transition: none;\n          -webkit-box-shadow: none;\n          box-shadow: none;\n          width: auto;\n          margin: 0px 1rem;\n          padding-top: 0;\n          margin-top: 0px;\n\n          &:before{\n              display: none;\n          }\n      }\n\n      .dropdown-menu .dropdown-item:focus,\n      .dropdown-menu .dropdown-item:hover{\n          color: $white;\n      }\n\n      &.bg-white .dropdown-menu .dropdown-item:focus,\n      &.bg-white .dropdown-menu .dropdown-item:hover{\n          color: $default;\n      }\n\n      .navbar-toggler-bar{\n          display: block;\n          position: relative;\n          width: 22px;\n          height: 1px;\n          border-radius: 1px;\n          background: $white;\n\n          &.navbar-kebab{\n            height: 4px;\n            width: 4px;\n            margin-bottom: 3px;\n            border-radius: 50%;\n          }\n\n          & + .navbar-toggler-bar{\n              margin-top: 7px;\n          }\n\n          & + .navbar-toggler-bar.navbar-kebab{\n              margin-top: 0px;\n          }\n\n          &.bar2{\n              width: 17px;\n              transition: width .2s linear;\n          }\n      }\n\n      &.bg-white:not(.navbar-transparent) .navbar-toggler-bar{\n          background-color: $default;\n      }\n\n      & .toggled .navbar-toggler-bar{\n          width: 24px;\n      }\n  }\n\n  .bar1,\n  .bar2,\n  .bar3 {\n    outline: 1px solid transparent;\n  }\n  .bar1 {\n    top: 0px;\n    @include bar-animation($topbar-back);\n  }\n  .bar2 {\n    opacity: 1;\n  }\n  .bar3 {\n    bottom: 0px;\n    @include bar-animation($bottombar-back);\n  }\n  .toggled .bar1 {\n    top: 6px;\n    @include bar-animation($topbar-x);\n  }\n  .toggled .bar2 {\n    opacity: 0;\n  }\n  .toggled .bar3 {\n    bottom: 9px;\n    @include bar-animation($bottombar-x);\n  }\n\n  @include topbar-x-rotation();\n  @include topbar-back-rotation();\n  @include bottombar-x-rotation();\n  @include bottombar-back-rotation();\n\n  @-webkit-keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n  @-moz-keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n  @keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n\n  .navbar-nav{\n      .nav-link{\n          i.fa,\n          i.tim-icons{\n              opacity: .5;\n          }\n      }\n  }\n\n}\n\n@include media-breakpoint-up(lg) {\n  .navbar-collapse {\n      background: none !important;\n  }\n\n  .navbar .navbar-toggle {\n      display: none;\n\n  }\n\n  .navbar-nav {\n      .nav-link {\n          &.profile-photo {\n              padding: 0;\n              margin: 7px $padding-base-horizontal;\n          }\n      }\n  }\n\n  .navbar {\n    .caret {\n      position: absolute;\n      left: 80%;\n      top: 55%;\n      margin-left: 0;\n    }\n  }\n\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: $list-inline-padding;\n    padding-left: $list-inline-padding;\n  }\n\n}\n\n@include media-breakpoint-down(xs) {\n  .navbar[class*='navbar-toggleable-'] .container {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n}\n\n@include media-breakpoint-between (md, lg){\n  .bar1,\n  .bar2,\n  .bar3 {\n    outline: 1px solid transparent;\n  }\n  .bar1 {\n    top: 0px;\n    @include bar-animation($topbar-back);\n  }\n  .bar2 {\n    opacity: 1;\n  }\n  .bar3 {\n    bottom: 0px;\n    @include bar-animation($bottombar-back);\n  }\n  .toggled .bar1 {\n    top: 7px;\n    @include bar-animation($topbar-x);\n  }\n  .toggled .bar2 {\n    opacity: 0;\n  }\n  .toggled .bar3 {\n    bottom: 9px;\n    @include bar-animation($bottombar-x);\n  }\n\n  @include topbar-x-rotation();\n  @include topbar-back-rotation();\n  @include bottombar-x-rotation();\n  @include bottombar-back-rotation();\n\n  @-webkit-keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n  @-moz-keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n  @keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n\n  .navbar .navbar-toggler-bar.bar2 {\n    width: 17px;\n    transition: width .2s linear;\n}\n\n  .navbar .navbar-toggler-bar {\n    display: block;\n    position: relative !important;\n    width: 22px;\n    height: 1px;\n    border-radius: 1px;\n    background: $white;\n  }\n  .navbar .navbar-toggler-bar+.navbar-toggler-bar {\n    margin-top: 7px;\n  }\n\n  .navbar .navbar-toggle .navbar-toggler{\n    display: block;\n  }\n\n  .navbar-minimize-fixed{\n    display: none;\n  }\n}\n",".pagination {\n    .page-item .page-link {\n      border: 0;\n      border-radius: 30px !important;\n      transition: all .3s;\n      margin: 0 3px;\n      min-width: 30px;\n      text-align: center;\n      height: 30px;\n      line-height: 30px;\n      cursor: pointer;\n      text-transform: uppercase;\n      outline: none;\n\n      &:hover,\n      &:focus {\n          background-color: rgba($white, 0.1);\n          color: $white;\n          border: none;\n          box-shadow: none;\n      }\n    }\n\n    .arrow-margin-left,\n    .arrow-margin-right {\n        position: absolute;\n    }\n\n    .arrow-margin-right {\n        right: 0;\n    }\n\n    .arrow-margin-left {\n        left: 0;\n    }\n\n    .page-item.active > .page-link {\n        color: $white;\n        box-shadow: $box-shadow;\n\n        &,\n        &:focus,\n        &:hover{\n          @include diagonal-gradient($primary, $primary-states);\n\n            color: $white;\n        }\n    }\n\n    .page-item.disabled > .page-link{\n        opacity: .5;\n    }\n\n    // Colors\n    &.pagination-info{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                @include diagonal-gradient($info, $info-states);\n            }\n        }\n    }\n\n    &.pagination-success{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                @include diagonal-gradient($success, $success-states);\n            }\n        }\n    }\n\n    &.pagination-primary{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n              @include diagonal-gradient($primary, $primary-states);\n\n            }\n        }\n    }\n\n    &.pagination-warning{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n              @include diagonal-gradient($warning, $warning-states);\n\n            }\n        }\n    }\n\n    &.pagination-danger{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n              @include diagonal-gradient($danger, $danger-states);\n\n            }\n        }\n    }\n\n    &.pagination-neutral{\n        .page-item > .page-link{\n            color: $white;\n\n            &:focus,\n            &:hover{\n                background-color: $opacity-2;\n                color: $white;\n            }\n        }\n\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $white;\n                border-color: $white;\n                color: $brand-primary;\n            }\n        }\n    }\n\n}\n\n@include media-breakpoint-down(sm){\n  div.dataTables_paginate ul.pagination {\n    .page-item:first-of-type,\n    .page-item:nth-of-type(2),\n    .page-item:nth-of-type(8),\n    .page-item:last-of-type {\n       display: none !important;\n     }\n  }\n}\n","// This file has been autogenerated by grunt task lessToSass. Any changes will be overwritten.\n\n.nav-tabs {\n    border: 0;\n    padding: $padding-base-vertical $padding-base-horizontal;\n\n    > .nav-item{\n        > .nav-link{\n            color: $white;\n            margin: 0;\n            margin-right: 5px;\n            background-color: $transparent-bg;\n            border-radius: 30px;\n            padding: $padding-btn-vertical $padding-round-horizontal;\n            line-height: $line-height-sm;\n\n            &:hover {\n                background-color: $transparent-bg;\n                border: 1px solid darken($black,5%);\n                color: rgba($white, 0.8);\n            }\n\n            &.active{\n                border: 1px solid $white;\n                border-radius: 30px;\n            }\n\n            i.tim-icons{\n                font-size: 14px;\n                position: relative;\n                top: 1px;\n                margin-right: 3px;\n            }\n        }\n\n        &.disabled > .nav-link,\n        &.disabled > .nav-link:hover {\n            color: rgba(255,255,255,0.5);\n        }\n    }\n\n    &.nav-tabs-neutral{\n        > .nav-item{\n            > .nav-link{\n                color: $white;\n\n                &.active{\n                    border-color: $opacity-5;\n                    color: $white;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-primary{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    border-color: $primary;\n                    color: $primary;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-info{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    border-color: $info;\n                    color: $info;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-danger{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    border-color: $danger;\n                    color: $danger;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-warning{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    border-color: $warning;\n                    color: $warning;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-success{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    border-color: $success;\n                    color: $success;\n                }\n            }\n        }\n    }\n\n}\n",".nav-pills {\n\n  &.flex-column li > a {\n    margin-bottom: 15px;\n  }\n\n  &.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {\n    margin-right: 10px;\n    margin-bottom: 5px;\n  }\n\n  &:not(.nav-pills-icons):not(.nav-pills-just-icons) .nav-item .nav-link {\n    border-radius: $btn-round-radius;\n  }\n\n  &.nav-pills-just-icons .nav-item .nav-link {\n    border-radius: 50%;\n    height: 80px;\n    max-width: 80px;\n    min-width: auto;\n    padding: 0;\n    width: 80px;\n\n    .tim-icons {\n      font-size: 24px;\n      line-height: 80px;\n    }\n  }\n\n    .nav-item {\n        .nav-link{\n            padding: 0 15.5px;\n            text-align: center;\n            padding: $padding-btn-vertical $padding-round-horizontal;\n            min-width: 100px;\n            font-weight: $font-weight-normal;\n            color: rgba($white,0.5);\n            background-color: darken($black,5%);\n\n\n            &:hover{\n                background-color: darken($black,10%);\n            }\n\n            &.active{\n                &,\n                &:focus,\n                &:hover{\n                    background-color: $dark-gray;\n                    color: $white;\n                    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);\n                }\n            }\n\n            &.disabled,\n            &:disabled,\n            &[disabled]{\n                opacity: .5;\n            }\n        }\n\n        i{\n            display: block;\n            font-size: 24px;\n            line-height: 60px;\n        }\n    }\n\n    &.nav-pills-neutral{\n        .nav-item {\n            .nav-link{\n                background-color: $opacity-2;\n                color: $white;\n\n                &.active{\n                    &,\n                    &:focus,\n                    &:hover{\n                        background-color: $white;\n                        color: $primary;\n                    }\n                }\n            }\n        }\n    }\n\n    &.nav-pills-primary{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                  @include diagonal-gradient($primary, $primary-states);\n                }\n            }\n        }\n    }\n\n    &.nav-pills-info{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    @include diagonal-gradient($info, $info-states);\n                }\n            }\n        }\n    }\n\n    &.nav-pills-success{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    @include diagonal-gradient($success, $success-states);\n                }\n            }\n        }\n    }\n\n    &.nav-pills-warning{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    @include diagonal-gradient($warning, $warning-states);\n                }\n            }\n        }\n    }\n\n    &.nav-pills-danger{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    @include diagonal-gradient($danger, $danger-states);\n                }\n            }\n        }\n    }\n}\n.tab-space{\n    padding: 20px 0 50px 0px;\n}\n\n.tab-content{\n    &.tab-subcategories{\n        margin-top: 20px;\n        background-color: $transparent-bg;\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n    .tab-pane{\n      color: rgba($white,0.5);\n    }\n}\n\n.nav-align-center{\n    text-align: center;\n\n    .nav-pills{\n        display: inline-flex;\n    }\n}\n",".popover {\n  border: 0;\n}\n\n.popover-header {\n\tfont-weight: $font-weight-bold;\n}\n\n// Alternative colors\n@each $color, $value in $theme-colors {\n    .popover-#{$color} {\n        @include popover-variant($value);\n    }\n}\n","@mixin popover-variant($background) {\n  background-color: $background;\n\n  .popover-header {\n    background-color: $background;\n    color: color-yiq($background);\n    opacity: .6;\n  }\n\n  .popover-body {\n    color: color-yiq($background);\n  }\n\n  .popover-header{\n    border-color: rgba(color-yiq($background), .2);\n  }\n\n  &.bs-popover-top {\n    .arrow::after {\n      border-top-color: $background;\n    }\n  }\n\n  &.bs-popover-right {\n    .arrow::after {\n      border-right-color: $background;\n    }\n  }\n\n  &.bs-popover-bottom {\n    .arrow::after {\n      border-bottom-color: $background;\n    }\n  }\n\n  &.bs-popover-left {\n    .arrow::after {\n      border-left-color: $background;\n    }\n  }\n}\n","// This file has been autogenerated by grunt task lessToSass. Any changes will be overwritten.\n.progress-container{\n    position: relative;\n\n    &.progress-sm {\n      margin-top: 10px;\n\n      .progress {\n        .progress-value{\n          position: absolute;\n          top: -3px;\n          left: -27px;\n          color: $white;\n          font-size: $font-size-xs;\n        }\n      }\n    }\n\n    & + .progress-container,\n    & ~ .progress-container{\n        margin-top: $margin-base-vertical;\n    }\n    .progress-badge{\n        color: $white;\n        font-size: $font-size-sm;\n        text-transform: uppercase;\n\n        &.float-left{\n          margin-right: 20px;\n        }\n\n    }\n\n    .progress {\n      margin-bottom: 10px;\n      box-shadow: 0px 0px 0px 3px rgba(0, 0, 0, 0.3);\n\n        .progress-bar {\n          border-radius:$border-radius-xl;\n          box-shadow: none;\n          background: $default;\n\n          .progress-value{\n            position: absolute;\n            top: 2px;\n            right: 0;\n            color: $white;\n            font-size: $font-size-xs;\n          }\n        }\n\n        &.progress-bar-sm{\n          height: 3px;\n        }\n    }\n\n    &.progress-neutral{\n        .progress{\n            background: rgba(255, 255, 255, .3);\n        }\n\n        .progress-bar{\n            background: $white;\n        }\n    }\n\n    &.progress-primary{\n      .progress-bar{\n        @include diagonal-gradient($primary-states, $primary);\n      }\n    }\n\n    &.progress-info{\n      .progress-bar{\n        @include diagonal-gradient($info-states, $info);\n      }\n    }\n\n    &.progress-success{\n      .progress-bar{\n        @include diagonal-gradient($success-states, $success);\n      }\n    }\n\n    &.progress-warning{\n      .progress-bar{\n        @include diagonal-gradient($warning-states, $warning);\n      }\n    }\n\n    &.progress-danger{\n      .progress-bar{\n        @include diagonal-gradient($danger-states, $danger);\n      }\n    }\n}\n\n.card-chart {\n  .progress-container+.progress-container,\n  .progress-container~.progress-container {\n    margin-top: 25px;\n  }\n}\n","h1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  line-height: $headings-line-height;\n\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea{\n    font-family: $font-family-base;\n}\n.card{\n  h1,h2,h3,h4,h5,h6,p{\n    color: $opacity-8;\n  }\n}\nh1,h2,h3,h4,h5,h6{\n    font-weight: $font-weight-normal;\n    color: $opacity-8;\n}\n\na{\n    color: $primary-states;\n    font-weight: $font-weight-light;\n    &:hover,\n    &:focus{\n        color: $primary;\n    }\n}\nh1, .h1 {\n    line-height: 1.05;\n    margin-bottom: $margin-base-vertical * 2;\n\n    small{\n        font-weight: $font-weight-bold;\n        text-transform: uppercase;\n        opacity: .8;\n    }\n\n}\nh2, .h2{\n    margin-bottom: $margin-base-vertical * 2;\n    line-height: 1.2;\n\n}\nh3, .h3{\n    margin-bottom: $margin-base-vertical * 2;\n    line-height: 1.4em;\n}\nh4, .h4{\n    line-height: 1.45em;\n    margin-bottom: $margin-base-vertical;\n\n    & + .category,\n    &.title + .category{\n        margin-top: -10px;\n    }\n}\nh5, .h5 {\n    line-height: 1.4em;\n    margin-bottom: 15px;\n}\nh6, .h6{\n    text-transform: uppercase;\n    font-weight: $font-weight-bold;\n}\np{\n    color: $opacity-8;\n    margin-bottom: 5px;\n\n    &.description{\n        font-size: 1.14em;\n    }\n}\n\n\n.title{\n    font-weight: $font-weight-bold;\n    &.title-up{\n        text-transform: uppercase;\n\n        a{\n            color: $black;\n            text-decoration: none;\n        }\n    }\n    & + .category{\n        margin-top: -10px;\n    }\n}\n\n.description,\n.card-description,\n.footer-big p,\n.card .footer .stats{\n    color: $dark-gray;\n    font-weight: $font-weight-light;\n}\n.category,\n.card-category{\n    text-transform: capitalize;\n    font-weight: $font-weight-normal;\n    color: rgba($white, 0.6);\n    font-size: $font-size-sm;\n}\n\n.card-category{\n    font-size: $font-size-sm;\n}\n\n.blockquote{\n    border-left: none;\n    border: 1px solid $default;\n    padding: 20px;\n    font-size: $blockquote-font-size;\n    line-height: 1.8;\n\n    small{\n        color: $default;\n        font-size: $font-size-sm;\n        text-transform: uppercase;\n    }\n\n    &.blockquote-primary{\n        border-color: $primary;\n        color: $primary;\n\n        small{\n            color: $primary;\n        }\n    }\n\n    &.blockquote-danger{\n        border-color: $danger;\n        color: $danger;\n\n        small{\n            color: $danger;\n        }\n    }\n\n    &.blockquote-white{\n        border-color: $opacity-8;\n        color: $white;\n\n        small{\n            color: $opacity-8;\n        }\n    }\n}\n\nul li, ol li{\n  color: $white;\n}\n\npre{\n  color: $opacity-8;\n}\n\nhr{\n  border-top: 1px solid rgba(0,0,0,0.1);\n  margin-top: $spacer;\n  margin-bottom: $spacer;\n}\n",".table{\n\n  > tbody > tr > td {\n    color: rgba(255, 255, 255, 0.7) !important;\n\n    .photo {\n      height: 30px;\n      width: 30px;\n      border-radius: 50%;\n      overflow: hidden;\n      margin: 0 auto;\n\n      img {\n        width: 100%;\n      }\n    }\n  }\n\n  > tbody > tr.table-success > td{\n    background-color: darken($success,10%);\n  }\n\n  > tbody > tr.table-info > td{\n    background-color: $info;\n  }\n\n  > tbody > tr.table-primary > td{\n    background-color: $primary;\n  }\n\n  > tbody > tr.table-warning > td{\n    background-color: $warning;\n  }\n  > tbody > tr.table-danger > td{\n    background-color: $danger;\n  }\n\n\n    .img-wrapper{\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      margin: 0 auto;\n    }\n\n    .img-row{\n      max-width: 60px;\n      width: 60px;\n    }\n\n    .form-check{\n        margin: 0;\n        margin-top: 5px;\n\n        & label .form-check-sign::before,\n        & label .form-check-sign::after{\n            top: -17px;\n            left: 4px;\n        }\n    }\n\n    .btn{\n        margin: 0;\n    }\n\n    small,.small{\n      font-weight: 300;\n    }\n\n    .card-tasks .card-body &{\n        margin-bottom: 0;\n\n        > thead > tr > th,\n        > tbody > tr > th,\n        > tfoot > tr > th,\n        > thead > tr > td,\n        > tbody > tr > td,\n        > tfoot > tr > td{\n            padding-top: 5px;\n            padding-bottom: 5px;\n        }\n    }\n\n   > thead > tr > th{\n       border-bottom-width: 1px;\n       font-size: 12px;\n       text-transform: uppercase;\n       font-weight: $font-weight-extra-bold;\n       border: 0;\n       color: rgba($white, 0.7);\n   }\n\n   .radio,\n   .checkbox{\n       margin-top: 0;\n       margin-bottom: 0;\n       padding: 0;\n       width: 15px;\n\n       .icons{\n           position: relative;\n       }\n\n        label{\n            &:after,\n            &:before{\n                top: -17px;\n                left: -3px;\n            }\n        }\n   }\n   > thead > tr > th,\n   > tbody > tr > th,\n   > tfoot > tr > th,\n   > thead > tr > td,\n   > tbody > tr > td,\n   > tfoot > tr > td{\n       border-color: rgba(255, 255, 255, 0.1);\n       padding: 12px 7px;\n       vertical-align: middle;\n   }\n\n   &.table-shopping tbody tr:last-child td{\n      border: none;\n   }\n\n   .th-description{\n       max-width: 150px;\n   }\n   .td-price{\n       font-size: 26px;\n       font-weight: $font-weight-light;\n       margin-top: 5px;\n       position: relative;\n       top: 4px;\n       text-align: right;\n   }\n   .td-total{\n        font-weight: $font-weight-bold;\n        font-size: $h5-font-size;\n        padding-top: 20px;\n        text-align: right;\n    }\n\n   .td-actions .btn{\n    margin: 0px;\n    }\n\n    > tbody > tr{\n        position: relative;\n    }\n\n    > tfoot > tr {\n      color: hsla(0,0%,100%,.7);\n      text-transform: uppercase;\n    }\n\n}\n\n.table-shopping{\n    > thead > tr > th{\n        text-transform: uppercase;\n    }\n    > tbody > tr > td{\n        font-size: $font-paragraph;\n\n        b{\n            display: block;\n            margin-bottom: 5px;\n        }\n    }\n    .td-name{\n        font-weight: $font-weight-normal;\n        font-size: 1.5em;\n        small{\n            color: $dark-gray;\n            font-size: 0.75em;\n            font-weight: $font-weight-light;\n        }\n    }\n    .td-number{\n       font-weight: $font-weight-light;\n\n       .btn-group {\n         padding-right: 15px;\n       }\n   }\n    .td-name{\n        min-width: 200px;\n    }\n    .td-number{\n        text-align: right;\n        min-width: 170px;\n\n        small{\n            margin-right: 3px;\n        }\n    }\n\n    .img-container{\n        width: 120px;\n        max-height: 160px;\n        overflow: hidden;\n        display: block;\n\n        img{\n            width: 100%;\n        }\n    }\n}\n\n.table-responsive{\n  // overflow: scroll;\n  padding-bottom: 10px;\n}\n\n#tables .table-responsive{\n    margin-bottom: 30px;\n}\n\ntable.tablesorter thead tr .header{\n\tbackground-image: url(\"../../../img/bg.gif\");\n  background-repeat: no-repeat;\n  background-position: center right;\n  cursor: pointer;\n}\n\ntable.tablesorter thead tr .headerSortUp {\n\tbackground-image: url(\"../../../img/asc.gif\");\n}\ntable.tablesorter thead tr .headerSortDown {\n\tbackground-image: url(\"../../../img/desc.gif\");\n}\n\n\n// datatables\n\n\n.dataTables_wrapper {\n  .table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(0,0,0,.05);\n  }\n\n  .form-control-sm {\n    font-size: 10px;\n  }\n}\n",".form-check{\n margin-top: .5rem;\n padding-left: 0;\n}\n\n.form-check .form-check-label{\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  padding-left: 25px;\n  line-height: 18px;\n  margin-bottom: 0;\n  -webkit-transition: color 0.3s linear;\n  -moz-transition: color 0.3s linear;\n  -o-transition: color 0.3s linear;\n  -ms-transition: color 0.3s linear;\n  transition: color 0.3s linear;\n}\n.radio .form-check-sign{\n    padding-left: 28px;\n}\n\n.form-check-radio.form-check-inline .form-check-label {\n  padding-left: 5px;\n  margin-right: 10px;\n}\n\n.form-check .form-check-sign::before,\n.form-check .form-check-sign::after{\n  content: \" \";\n  display: inline-block;\n  position: absolute;\n  width: 17px;\n  height: 17px;\n  left: 0;\n  cursor: pointer;\n  border-radius: 3px;\n  top: 0;\n  border: 1px solid darken($dark-gray,10%);\n  -webkit-transition: opacity 0.3s linear;\n  -moz-transition: opacity 0.3s linear;\n  -o-transition: opacity 0.3s linear;\n  -ms-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n}\n\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before,\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before{\n  border: none;\n  background-color: $primary;\n}\n\n .form-check .form-check-sign::after{\n  font-family: 'nucleo';\n  content: \"\\ea1b\";\n  top: 0px;\n  text-align: center;\n  font-size: 14px;\n  opacity: 0;\n  color: $white;\n  font-weight: $font-weight-bold;\n  border: 0;\n  background-color: inherit;\n}\n\n.form-check.disabled .form-check-label,\n.form-check.disabled .form-check-label {\n    color: $dark-gray;\n    opacity: .5;\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"],\n.radio input[type=\"radio\"]{\n  opacity: 0;\n  position: absolute;\n  visibility: hidden;\n}\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\n  opacity: 1;\n  font-size: 10px;\n  margin-top: 0;\n}\n\n\n.form-check input[type=\"checkbox\"]+ .form-check-sign::after{\n  opacity: 0;\n  font-size: 10px;\n  margin-top: 0;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"]:disabled + .form-check-sign,\n.form-check input[type=\"radio\"]:disabled + .form-check-sign{\n    pointer-events: none;\n}\n\n.form-check-radio .form-check-label{\n  padding-top: 3px;\n}\n.form-check-radio .form-check-sign::before,\n.form-check-radio .form-check-sign::after{\n  content: \" \";\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid darken($dark-gray,10%);\n  display: inline-block;\n  position: absolute;\n  left: 0px;\n  top: 3px;\n  padding: 1px;\n  -webkit-transition: opacity 0.3s linear;\n  -moz-transition: opacity 0.3s linear;\n  -o-transition: opacity 0.3s linear;\n  -ms-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n    opacity: 0;\n}\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    width: 6px;\n    height: 6px;\n    background-color: $primary;\n    border-color: $primary;\n    top: 9px;\n    left: 6px;\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::before {\n  border-color: $primary;\n}\n\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign {\n  color: $dark-gray;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n  color: $dark-gray;\n}\n",".fixed-plugin{\n    position: fixed;\n    right: 0;\n    width: 64px;\n    background: rgba(0,0,0,.3);\n    z-index: 1031;\n    border-radius: 8px 0 0 8px;\n    text-align: center;\n    top: 130px;\n\n    li > a,\n    .badge{\n        transition: all .34s;\n        -webkit-transition: all .34s;\n        -moz-transition: all .34s;\n    }\n\n    .fa-cog{\n        color: $white;\n        padding: 10px;\n        border-radius: 0 0 6px 6px;\n        width: auto;\n    }\n\n    .dropdown-menu{\n        right: 80px;\n        left: auto !important;\n        top: -52px !important;\n        width: 290px;\n        border-radius: 0.1875rem;\n        padding: 0 10px;\n        background: linear-gradient($black, $black-states);\n    }\n\n    .dropdown .dropdown-menu .tim-icons{\n      top: 5px;\n    }\n\n    .dropdown-menu:after,\n    .dropdown-menu:before{\n        right: 10px;\n        margin-left: auto;\n        left: auto;\n    }\n\n    .fa-circle-thin{\n        color: $white;\n    }\n\n    .active .fa-circle-thin{\n        color: $active-blue;\n    }\n\n    .dropdown-menu > .active > a,\n    .dropdown-menu > .active > a:hover,\n    .dropdown-menu > .active > a:focus{\n        color: $active-gray;\n        text-align: center;\n    }\n\n    img{\n        border-radius: 0;\n        width: 100%;\n        height: 100px;\n        margin: 0 auto;\n    }\n\n    .dropdown-menu li > a:hover,\n    .dropdown-menu li > a:focus{\n        box-shadow: none;\n    }\n\n    .badge{\n        border: 2px solid $white;\n        border-radius: 50%;\n        cursor: pointer;\n        display: inline-block;\n        height: 23px;\n        margin-right: 5px;\n        position: relative;\n        width: 23px;\n    }\n\n    .badge.active,\n    .badge:hover{\n        border-color: $black-states;\n    }\n\n    .light-badge, .dark-badge{\n      margin:0;\n      border: 1px solid $info;\n      &:hover{\n        border: 1px solid $info;\n      }\n    }\n\n    .light-badge{\n      background: $white;\n      &:hover{\n        background: $white;\n      }\n    }\n\n    .dark-badge{\n      background: $black;\n      &:hover{\n        background: $black;\n      }\n    }\n\n    h5{\n      margin: 10px;\n    }\n\n    .dropdown-menu li{\n        display: block;\n        padding: 18px 2px;\n        width: 25%;\n        float: left;\n    }\n\n    li.adjustments-line,\n    li.header-title,\n    li.button-container{\n        width: 100%;\n        height: 50px;\n        min-height: inherit;\n    }\n\n    li.button-container{\n        height: auto;\n\n        div{\n            margin-bottom: 5px;\n        }\n    }\n\n    #sharrreTitle{\n        text-align: center;\n        padding: 10px 0;\n        height: 50px;\n    }\n\n    li.header-title{\n        color: $white;\n        height: 30px;\n        line-height: 25px;\n        font-size: 12px;\n        font-weight: 600;\n        text-align: center;\n        text-transform: uppercase;\n    }\n\n    .adjustments-line{\n\n        a{\n            color: transparent;\n\n            .badge-colors{\n                position: relative;\n                top: -2px;\n            }\n\n            a:hover,\n            a:focus{\n                color: transparent;\n            }\n        }\n\n        .togglebutton{\n            text-align: center;\n\n            .label-switch{\n              position: relative;\n              left: -10px;\n              font-size: $font-size-xs;\n              color: $white;\n\n              &.label-right{\n                left: 10px;\n              }\n            }\n\n            .toggle{\n                margin-right: 0;\n            }\n        }\n\n        .color-label{\n          position: relative;\n          top: -7px;\n          font-size: $font-size-xs;\n          color: $white;\n        }\n\n        .dropdown-menu > li.adjustments-line > a{\n              padding-right: 0;\n              padding-left: 0;\n              border-bottom: 1px solid #ddd;\n              border-radius: 0;\n              margin: 0;\n        }\n    }\n\n\n\n    .dropdown-menu{\n        > li{\n            & > a.img-holder{\n                  font-size: $font-paragraph;\n                  text-align: center;\n                  border-radius: 10px;\n                  background-color: $white;\n                  border: 3px solid $white;\n                  padding-left: 0;\n                  padding-right: 0;\n                  opacity: 1;\n                  cursor: pointer;\n                  display: block;\n                  max-height: 100px;\n                  overflow: hidden;\n                  padding: 0;\n\n                  img{\n                     margin-top: auto;\n                  }\n            }\n\n            a.switch-trigger:hover,\n            & > a.switch-trigger:focus{\n                background-color: transparent;\n            }\n\n            &:hover,\n            &:focus{\n                > a.img-holder{\n                    border-color: rgba(0, 187, 255, 0.53);;\n                }\n            }\n        }\n\n        > .active > a.img-holder,\n        > .active > a.img-holder{\n            border-color: $active-blue;\n            background-color: $white;\n        }\n\n    }\n\n    .btn-social{\n        width: 50%;\n        display: block;\n        width: 48%;\n        float: left;\n        font-weight: 600;\n    }\n\n    .btn-social{\n        i{\n            margin-right: 5px;\n        }\n\n        &:first-child{\n            margin-right: 2%;\n        }\n    }\n\n    .dropdown{\n        .dropdown-menu{\n             -webkit-transform: translateY(-15%);\n             -moz-transform: translateY(-15%);\n             -o-transform: translateY(-15%);\n             -ms-transform: translateY(-15%);\n             transform: translateY(-15%);\n             top: 27px;\n             opacity: 0;\n\n             transform-origin: 0 0;\n\n             &:before{\n                 border-bottom: .4em solid rgba(0, 0, 0, 0);\n                 border-left: .4em solid rgba(0,0,0,0.2);\n                 border-top: .4em solid rgba(0,0,0,0);\n                 right: -16px;\n                 top: 46px;\n             }\n\n             &:after{\n                 border-bottom: .4em solid rgba(0, 0, 0, 0);\n                 border-left: .4em solid $black;\n                 border-top: .4em solid rgba(0,0,0,0);\n                 right: -16px;\n             }\n\n             &:before,\n             &:after{\n                 content: \"\";\n                 display: inline-block;\n                 position: absolute;\n                 top: 74px;\n                 width: 16px;\n                 transform: translateY(-50%);\n                 -webkit-transform: translateY(-50%);\n                 -moz-transform: translateY(-50%);\n             }\n        }\n\n        &.show .dropdown-menu{\n             opacity: 1;\n\n             -webkit-transform: translateY(-13%);\n             -moz-transform: translateY(-13%);\n             -o-transform: translateY(-13%);\n             -ms-transform: translateY(-13%);\n             transform: translateY(-13%);\n\n             transform-origin: 0 0;\n        }\n    }\n\n    .bootstrap-switch{\n        margin:0;\n    }\n}\n\n@include media-breakpoint-down(xs){\n  .fixed-plugin {\n    top: 100px;\n  }\n\n  .fixed-plugin .dropdown-menu {\n    width: 225px;\n    top: -65px !important;\n  }\n}\n",".wrapper{\n  position: relative;\n  top: 0;\n  // height: 100vh;\n\n  &.wrapper-full-page{\n      min-height: 100vh;\n      height: auto;\n  }\n}\n\n.sidebar-wrapper ul li div.collapse ul li div.collapse ul li a,\n.sidebar-wrapper ul li div.collapse ul li div.collapsing ul li a,\n.sidebar-wrapper ul li div.collapsing ul li div.collapse ul li a{\n\nmargin-left: 10px;\n\n}\n.sidebar,\n.off-canvas-sidebar{\n  @include linear-gradient($primary-states, $primary);\n  height: calc(100vh - 90px);\n  width: 230px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  background-size: cover;\n  background-position: center center;\n  display: block;\n  box-shadow: 0px 0px 45px 0px rgba(0,0,0,0.6);\n  margin-top: 62px;\n  margin-left: 2px;\n  border-radius: 5px;\n\n  .sidebar-wrapper{\n      width: $full-width;\n      min-height: 100%;\n      max-height: calc(100vh - 705px);\n      z-index: 4;\n      position: relative;\n      overflow: auto;\n\n      .dropdown .dropdown-backdrop{\n        display: none !important;\n      }\n\n      .navbar-form{\n          border: none;\n      }\n\n      > .nav,\n      .user .info{\n        [data-toggle=\"collapse\"] ~ div > ul > li > a{\n            span{\n              display: inline-block;\n              @extend .animation-transition-general;\n\n            }\n\n            .sidebar-normal{\n              margin: 0;\n              position: relative;\n              transform: translateX(0px);\n              opacity: 1;\n              white-space: nowrap;\n              display: block;\n              line-height: 23px;\n              z-index: 1;\n              color: $opacity-8;\n            }\n\n            .sidebar-mini-icon{\n              text-transform: uppercase;\n              width: 34px;\n              margin-right: 10px;\n              margin-left: 0px;\n              font-size: 12px;\n              text-align: center;\n              line-height: 25px;\n              position: relative;\n              float: left;\n              z-index: 1;\n              display: inherit;\n              line-height: 24px;\n              color: $opacity-8;\n            }\n\n            i{\n              font-size: 17px;\n              line-height: 20px;\n              width: 26px;\n            }\n          }\n      }\n\n\n\n      [data-toggle=\"collapse\"] ~ div > ul > li:hover > a{\n        .sidebar-mini-icon, .sidebar-normal{\n          color: $white;\n        }\n\n      }\n\n      .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon{\n        opacity: 0;\n      }\n\n\n  }\n\n  .navbar-minimize{\n    position: absolute;\n    right: 20px;\n    top: 2px;\n    opacity: 1;\n    @extend .animation-transition-general;\n\n  }\n  .logo-tim{\n    border-radius: 50%;\n    border: 1px solid #333;\n    display: block;\n    height: 61px;\n    width: 61px;\n    float: left;\n    overflow: hidden;\n\n    img{\n        width: 60px;\n        height: 60px;\n    }\n  }\n\n  .nav{\n      margin-top: 20px;\n      display: block;\n\n      .caret{\n          top: 14px;\n          position: absolute;\n          right: 10px;\n      }\n\n      li{\n          > a + div .nav{\n            margin-top: 5px;\n             li > a{\n                margin-top: 0px;\n                padding: 8px 8px;\n            }\n          }\n\n          > a{\n              margin: 10px 15px 0;\n              border-radius: $btn-round-radius;\n              color: $white;\n              display: block;\n              text-decoration: none;\n              position: relative;\n              text-transform: uppercase;\n              cursor: pointer;\n              font-size:14px;\n              // font-size: $font-size-xs;\n              padding: 10px 8px;\n              line-height: $line-height-lg;\n          }\n\n          &:first-child > a{\n              margin: 0 15px;\n\n          }\n\n          &:hover:not(.active) > a,\n          &:focus:not(.active) > a{\n              p,i{\n                color:#2c2a2a !important;                \n            font-weight: 600 !important ;\n              }\n          }\n\n          &:hover:not(.active) > a i,\n          &:focus:not(.active) > a i{\n            // color:#419ef9 !important;                \n            color:#2c2a2a !important;                \n            font-weight: 600 !important ; \n          }\n\n          &.active > a:not([data-toggle=\"collapse\"]){\n              background: transparent;\n              font-weight: 700 !important;\n\n              i,p{\n                // color: white;\n                // color :#3a372a !important;\n                color:#419ef9 !important;                \n                font-weight: 700 !important ; \n              }\n\n              &:before{\n                content: \" \";\n                position: absolute;\n                height: 29px;\n                width: 4px;\n                top: 9px;\n                left: -16px;\n                background:#419ef9 !important;\n                // border-radius: 50%;\n              }\n          }\n\n          &.active > a[data-toggle=\"collapse\"]{\n            background: transparent;\n            box-shadow: none;\n            color: $white;\n\n            i{\n              color: $white;\n            }\n\n            & + div .nav li.active a{\n\n              box-shadow: none;\n              .sidebar-mini-icon, .sidebar-normal , p{\n                color: $white;\n                font-weight: $font-weight-normal;\n                // color:#419ef9 !important;                \n                // font-weight: 400 !important; \n                \n              }\n              \n              &:before{\n                content: \" \";\n                position: absolute;\n                height: 25px;\n                width: 4px;\n                top: 4px;\n                left: -16px;\n                background:#419ef9 !important;\n                // border-radius: 50%;\n              }\n            }\n            &:before{\n              content: \" \";\n              position: absolute;\n              height: 26px;\n              width: 4px;\n              top: 9px;\n              left: -16px;\n              background:#419ef9 !important;\n              // border-radius: 50%;\n            }\n          }\n      }\n\n      p{\n          margin: 0;\n          line-height: 30px;\n          position: relative;\n          display: block;\n          height: auto;\n          white-space: nowrap;\n          @extend .animation-transition-general;\n      }\n\n      i{\n          font-size: 20px;\n          float: left;\n          margin-right: 12px;\n          line-height: 30px;\n          width: 34px;\n          text-align: center;\n          color: $opacity-8;\n          position: relative;\n      }\n      img{\n        // font-size: 20px;\n        float: left;\n        margin-right: 12px;\n        line-height: 30px;\n        width: 26px;\n        height: 26px;\n        text-align: center;\n        // color: $opacity-8;\n        position: relative;\n    }\n  }\n  .sidebar .nav li.active>a[data-toggle=collapse]+div .nav .active a .sidebar-normal {\n    color:blue !important;\n    font-weight: 700 !important;\n}\n  .sidebar-background{\n      position: absolute;\n      z-index: 1;\n      height: 100%;\n      width: $full-width;\n      display: block;\n      top: 0;\n      left: 0;\n      background-size: cover;\n      background-position: center center;\n\n      &:after{\n          position: absolute;\n          z-index: 3;\n          width: $full-width;\n          height: 100%;\n          content: \"\";\n          display: block;\n          background:transparent;\n          opacity: 1;\n      }\n  }\n\n  .logo{\n      position: relative;\n      padding: $padding-base-vertical $padding-base-horizontal 1rem;\n      z-index: 4;\n\n      a.logo-mini,\n      a.logo-normal{\n          @extend .animation-transition-general;\n      }\n\n      a.logo-mini{\n          opacity: 1;\n          float: left;\n          width: 34px;\n          text-align: center;\n          margin-left: 10px;\n          margin-right: 12px;\n      }\n\n      a.logo-normal{\n          display: block;\n          opacity: 1;\n          @include transform-translate-x(0px);\n      }\n\n      &:after{\n          content: '';\n          position: absolute;\n          bottom: 0;\n          right: 15px;\n          height: 1px;\n          width: calc(100% - 30px);\n          background: $opacity-5;\n\n      }\n\n      p{\n          float: left;\n          font-size: 20px;\n          margin: 10px 10px;\n          color: $white;\n          line-height: 20px;\n          font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n      }\n\n      .simple-text{\n          text-transform: uppercase;\n          padding: $padding-base-vertical 0;\n          display: block;\n          white-space: nowrap;\n           font-size: $font-size-base;\n          // color: $white;\n          text-decoration: none;\n          font-weight: $font-weight-normal;\n          line-height: 30px;\n          overflow: hidden;\n      }\n  }\n\n  .logo-tim{\n      border-radius: 50%;\n      border: 1px solid #333;\n      display: block;\n      height: 61px;\n      width: 61px;\n      float: left;\n      overflow: hidden;\n\n      img{\n          width: 60px;\n          height: 60px;\n      }\n  }\n  &[data=\"white\"]{\n    @include linear-gradient($white, $white-states);\n    \n    p{\n      color:#111 !important;\n    };\n    .sidebar-normal{\n      color:#111 !important;\n    }\n    \n    &:before{\n      border-bottom-color: $white-states;\n    }\n  }\n\n  &[data=\"blue\"]{\n    @include linear-gradient($info-states, $info);\n    &:before{\n      border-bottom-color: $info;\n    }\n  }\n  &[data=\"green\"]{\n    @include linear-gradient($success-states, $success);\n    &:before{\n      border-bottom-color: $success;\n    }\n  }\n  &[data=\"orange\"]{\n    @include linear-gradient($warning-states, $warning);\n    &:before{\n      border-bottom-color: $warning;\n    }\n  }\n  &[data=\"red\"]{\n    @include linear-gradient($danger-states, $danger);\n    &:before{\n      border-bottom-color: $danger;\n    }\n  }\n\n\n  .user{\n      padding-bottom: 20px;\n      margin:20px auto 0;\n      position: relative;\n\n      &:after{\n          content: '';\n          position: absolute;\n          bottom: 0;\n          right: 15px;\n          height: 1px;\n          width: calc(100% - 30px);\n          background: $opacity-5;\n      }\n\n      .photo{\n          width: 34px;\n          height: 34px;\n          overflow: hidden;\n          float: left;\n          z-index: 5;\n          margin-right: 10px;\n          border-radius: 50%;\n          margin-left: 23px;\n          box-shadow: $box-shadow-raised;\n          @extend .animation-transition-general;\n\n          img{\n              width: $full-width;\n          }\n      }\n\n      a{\n          color: $white;\n          text-decoration: none;\n          padding: $padding-base-vertical 15px;\n          white-space: nowrap;\n          @extend .animation-transition-general;\n      }\n\n      .info{\n          > a{\n             display: block;\n             line-height: 18px;\n\n              > span{\n                 @extend .animation-transition-general;\n                 display: block;\n                 position: relative;\n                 opacity: 1;\n              }\n          }\n\n          .caret{\n              position: absolute;\n              top: 8px;\n              right: 18px;\n          }\n      }\n  }\n\n  &:before{\n    content: \"\";\n    position: absolute;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid $primary;\n    top: -5px;\n    left: 57px;\n    transform: translate(-50%);\n  }\n}\n\n\n.visible-on-sidebar-regular{\n  display: inline-block !important;\n}\n.visible-on-sidebar-mini{\n  display: none !important;\n}\n\n.off-canvas-sidebar{\n  .nav {\n      > li > a,\n      > li > a:hover{\n          color: $white;\n      }\n\n      > li > a:focus{\n          background: rgba(200, 200, 200, 0.2);\n      }\n  }\n}\n\n\n.main-panel {\n  position: relative;\n  float: right;\n  width: $full-width;\n  min-height: 100vh;\n  border-top: 2px solid $primary;\n  background: linear-gradient($background-black, $background-states-black);\n\n  @include transitions (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n  &[data=\"white\"]{\n    border-top: 2px solid $white;\n  }\n\n  &[data=\"blue\"]{\n    border-top: 2px solid $info;\n  }\n\n  &[data=\"green\"]{\n    border-top: 2px solid $success;\n  }\n\n  &[data=\"orange\"]{\n    border-top: 2px solid $warning;\n  }\n\n  &[data=\"red\"]{\n    border-top: 2px solid $danger;\n  }\n\n  &[data=\"primary\"]{\n    border-top: 2px solid $primary;\n  }\n\n  > .content {\n      // padding: 60px 10px 20px 232px;\n      padding: 60px 10px 15px 235px;\n      min-height: calc(100vh - 70px);\n  }\n\n  > .navbar {\n      margin-bottom: 0;\n  }\n\n\n  .header {\n      margin-bottom: 50px;\n  }\n}\n\n\n.perfect-scrollbar-on{\n.sidebar,\n.main-panel{\n    height: 100%;\n    max-height: 100%;\n}\n}\n\n\n.panel-header {\nheight: $sidebar-width;\npadding-top: 80px;\npadding-bottom: 45px;\nbackground: #141E30;  /* fallback for old browsers */\nbackground: -webkit-gradient(linear, left top, right top, from(#0c2646), color-stop(60%, #204065), to(#2a5788));\nbackground: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\nposition: relative;\noverflow: hidden;\n\n.header{\n  .title{\n    color: $white;\n  }\n  .category{\n    max-width: 600px;\n    color: $opacity-5;\n    margin: 0 auto;\n    font-size: 13px;\n\n    a{\n      color: $white;\n    }\n  }\n}\n}\n\n.panel-header-sm{\nheight: 135px;\n}\n\n.panel-header-lg{\nheight: 380px\n}\n\n@include media-breakpoint-down(md){\n.sidebar{\n    position: fixed;\n    display: block;\n    top: 0;\n    height: 100vh;\n    width: $sidebar-width;\n    right: auto;\n    left: 0;\n    margin: 0;\n    border-radius: 0;\n    z-index: 1032;\n    visibility: visible;\n    overflow-y: visible;\n    padding: 0;\n    @include transition($sidebar-transition);\n    @include transform-translate-x(-$sidebar-width);\n\n    .sidebar-wrapper{\n      height: 100vh;\n    }\n}\n\n.minimize-sidebar{\n    display: none;\n}\n\n\n.nav-open{\n    .main-panel{\n        right: 0;\n        @include transform-translate-x($sidebar-width);\n    }\n\n    .sidebar{\n\n        @include transition($sidebar-transition);\n        @include transform-translate-x(0px);\n        &:before{\n          content: unset;\n        }\n    }\n\n    body{\n        position: relative;\n        overflow-x: hidden;\n    }\n\n    .menu-on-right{\n\n      .main-panel{\n        @include transform-translate-x(-$sidebar-width);\n      }\n\n      .navbar-collapse,\n      .sidebar{\n          @include transform-translate-x(0px);\n      }\n\n      .bodyClick{\n          right: $sidebar-width;\n          left: auto;\n      }\n    }\n}\n\n.menu-on-right{\n  .sidebar{\n    left: auto;\n    right: 0;\n    @include transform-translate-x($sidebar-width);\n  }\n}\n\n.bodyClick{\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 1;\n    top: 0;\n    right: 0;\n    left: $sidebar-width;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n    background-color: transparent;\n    @include transitions (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n}\n\n.wrapper{\n    @include transitions (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n}\n\n.main-panel{\n    width: 100%;\n    .content{\n    padding-left: 30px;\n  }\n}\n}\n\n@include media-breakpoint-up(lg){\n  .sidebar,\n  .main-panel,\n  .sidebar-wrapper{\n     -webkit-transition-property: top,bottom,width;\n     transition-property: top,bottom, width;\n     -webkit-transition-duration: .2s,.2s, .35s;\n     transition-duration: .2s,.2s, .35s;\n     -webkit-transition-timing-function: linear,linear,ease;\n     transition-timing-function: linear,linear,ease;\n    -webkit-overflow-scrolling: touch;\n  }\n\n\n  .sidebar-mini{\n      .visible-on-sidebar-regular{\n        display: none !important;\n      }\n      .visible-on-sidebar-mini{\n        display: inline-block !important;\n      }\n\n      .sidebar{\n        width: 80px;\n\n        .sidebar-wrapper{\n          width: 100% !important;\n        }\n      }\n\n\n      .sidebar{\n        display: block;\n        z-index: 1030;\n        box-shadow: $sidebar-box-shadow;\n\n        .logo{\n            a.logo-normal{\n                opacity: 0;\n                @include transform-translate-x(-25px);\n            }\n        }\n\n        .sidebar-wrapper{\n          > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n          .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n          .user .info > a > span,\n          > .nav li > a p{\n              @include transform-translate-x(-25px);\n              opacity: 0;\n          }\n        }\n\n        .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon{\n          opacity: 1;\n        }\n      }\n\n      .sidebar:hover {\n        width: $sidebar-width;\n\n        .logo {\n          a.logo-normal {\n              opacity: 1;\n              @include transform-translate-x(0);\n          }\n\n        }\n\n        .navbar-minimize{\n          opacity: 1;\n        }\n        .sidebar-wrapper{\n          width: $sidebar-width;\n\n          > .nav li > a p,\n          > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n          .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n          .user .info > a > span{\n            @include transform-translate-x(0px);\n            opacity: 1;\n          }\n        }\n\n        .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon{\n          opacity: 0;\n        }\n\n\n\n      }\n\n      .main-panel{\n        > .content{\n          padding-left: 100px;\n        }\n      }\n\n      footer{\n        padding-left: 130px;\n      }\n}\n\n.navbar-minimize{\n  button {\n    margin-left: 10px;\n    i{\n    color: $white;\n    font-size: 20px;\n    }\n  }\n}\n\n}\n\n@include media-breakpoint-down(sm){\n.main-panel .content {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n}\n\n@include media-breakpoint-between (md, lg){\n.wrapper{\n     @include transitions (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n}\n\n.sidebar{\n    position: fixed;\n    display: block;\n    top: 0;\n    height: 100vh;\n    width: $sidebar-width !important;\n    right: auto;\n    left: 0;\n    margin: 0;\n    border-radius: 0;\n    z-index: 1032;\n    visibility: visible;\n    overflow-y: visible;\n    padding: 0;\n    @include transition($sidebar-transition);\n    @include transform-translate-x(-$sidebar-width);\n\n    .sidebar-wrapper{\n      height: 100vh;\n    }\n}\n\n.main-panel{\n      @include transition($sidebar-transition);\n}\n\n.nav-open{\n    .main-panel{\n        right: 0;\n        @include transform-translate-x($sidebar-width);\n    }\n\n    .sidebar{\n\n        @include transition($sidebar-transition);\n        @include transform-translate-x(0px);\n         &:before{\n           content: unset;\n         }\n    }\n\n    body{\n        position: relative;\n        overflow-x: hidden;\n    }\n\n    .menu-on-right{\n\n      .main-panel{\n        @include transform-translate-x(-$sidebar-width);\n      }\n\n      .navbar-collapse,\n      .sidebar{\n          @include transform-translate-x(0px);\n      }\n\n      .bodyClick{\n          right: $sidebar-width;\n          left: auto;\n      }\n    }\n}\n\n.menu-on-right{\n  .sidebar{\n    left: auto;\n    right: 0;\n    @include transform-translate-x($sidebar-width);\n  }\n}\n\n.bodyClick {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 1;\n    top: 0;\n    right: 0;\n    left: $sidebar-width;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n    background-color: transparent;\n    @include transitions(0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n}\n\n.main-panel .content {\n  padding-left: 30px !important;\n}\n\n.sidebar-mini .sidebar .logo a.logo-normal{\n  opacity: 1;\n  transform: translate3d(0px,0,0);\n}\n\n.sidebar-mini .sidebar .sidebar-wrapper>.nav li>a p{\n  opacity: 1;\n}\n\n.sidebar-mini .sidebar .sidebar-wrapper .nav li a p{\n  opacity: 1 !important;\n  transform: translate3d(0px,0,0);\n}\n\n.minimize-sidebar {\n    display: none;\n}\n}\n\n.sidebar .logo:after {\nbackground: #dddddd !important;\n}\n\n.fixed-plugin {\ndisplay: none;\n}\n.collapse.show {\nmargin-left: 14px;\n}\n.label-headding{\nfont-size: 14px !important;\n  font-weight: 700;\n\n}\n.label-title{\nfont-size: 14px !important;\nfont-weight: 500;\n\n}\n.textmessage-count {\nbackground: #ddd;\n  padding:0px;\n  width: 150px;\n  text-align: center;\n  border-radius: 15px;\n}\n.textmessage-count h1{\nmargin-bottom: 0px;\npadding: 7px 0px;\n}\n.textmessage-count p{\nbackground: #222121;\nmargin-bottom: 0px;\ncolor:#fff !important;\nborder-radius: 0px 0px 15px 15px;\npadding: 14px 0px;\n} \n.summary-text {\nbackground: #ddd;\npadding: 20px 30px;\nborder-radius: 12px;\n}\n.summary-text .label-headding {\nwidth:170px;\n}\n\n.summary-text .label-title {\nwidth:220px;\n}\n\n.card-wizard .wizard-navigation {\nposition: relative;\nmargin: 20px auto 60px !important;\n}\n.reports_smsstyles {\nbackground: #ddd;\n}\n.reports_smsstyles p{\nfont-size: 14px;\nfont-weight:500;\nspan{\n  display:block;\n  font-weight: 700;\n}\n\n}\n.smscard{\n  div {\n    background: #e1e1e1;\n    padding:10px;\n    border-radius: 10px;\n    \n    cursor: pointer\n  };\n p{\n  font-weight: 700;\n  span{\n    float: right;\n  font-weight: 700;\n  \n\n  }\n };\n\n .country-list{\n  margin-left: 25px;\n  p{font-weight: 300;}\n  span{\n    float: right;\n  font-weight: 500;\n  \n\n  }\n }\n  \n}\n.reports_smsstyles .btn-styles {\nborder: solid 1px #eee;\npadding: 20px 30px;\nbackground: #eee;\n}\n.campaignhistory-styles .card{\nborder:solid 1px  #ddd !important;\nbox-shadow: 0 1px 15px 0 rgb(123 123 123 / 5%) !important;\n.bottom-part{\n  border-top:solid 1px #f7f7f7;\n  padding-top:10px;\n  p{\n    font-weight: 500;\n    text-align: center;\n  }\n  span{\n    display:block;\n    font-weight: 600;\n  }\n}\n}\n.navbar.navbar-transparent {\nbackground: #fff !important;\nposition:fixed;\n// box-shadow: 4px 6px 10px 0px grey;\npadding:2px 5px !important\n}\n\n.tab-space {\n  padding: 20px 0 50px 0px;\n  overflow-x: auto;\n  height: 69vh;\n}\n\n.footer {\n  padding: 0px 30px !important;\n}\n.div1, .div2, .div3{\noverflow-y:scroll;\nheight:267px;\n}\n.scroll-height-350 {\n  overflow-y:scroll;\n  height:337px;\n}\n.scroll-height-380 {\n  overflow-y:scroll;\n  height:367px;\n}\n.scroll-height-400 {\n  overflow-y:scroll;\n  height:420px;\n}\n\n.scroll-height-450, .wizard-container {\noverflow-y:scroll;\nheight:469px;\n}\n\n.wizard-container .card-wizard {\nmargin-bottom: 0px;\n\n}\n// .sidebar[data=white] .sidebar-normal {\n//   margin-top:10px;\n// }\n.menu-list-icons img {\nwidth: 28px;\n  height:28px;\n  margin-left: 5px;\n}\n.modelbody Label {\nmargin-bottom: 0px !important;\n}\n.modal-dialog {\n -webkit-transform: translate(0, 0%) !important; \ntransform: translate(0, 0%) !important;\n}\n.roles-popup .table .form-check label .form-check-sign::before, .roles-popup .table .form-check label .form-check-sign::after {\ntop: 5px;\nleft: 10px;\n}\n.multicolortext {\n  background-image: linear-gradient(to left, #4285f4,#ea4335,purple,#34a853,#fbbc05, #ea4335 , #4285f4);\n  -webkit-background-clip: text;\n  -moz-background-clip: text !important;\n  background-clip: text !important;\n  color:transparent !important;\n  font-weight: 700;\n}\n\n.navbar-brand .multicolortext {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n\n\n@media (min-width: 786px){\n.modal-dialog {\n  max-width: 700px !important;\n  margin: 1.75rem auto;\n}\n.roles-popup {\nmax-width: 1100px !important;\nmargin: 0.75rem auto;\n}\n// .sidenavk {\n \n//   right: -50% !important;\n  \n// }\n\n\n}\n\n.main-panel[data=white] {\n  position: fixed;\n  border-top:none;\n}\n\n\n\n\n.notification_alert {\n  padding:0.50rem;\n  font-size:20px;\n  position:relative;\n  cursor: pointer;\n}\n\n\n\n.sidenavk {\n  height: 100%;\n  width: 350px;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  right: -80%;\n  background-color: #111;\n  overflow-x: hidden;\n  transition: 0.5s;\n  padding-top: 60px;\n}\n\n.sidenavk .closebtn {\n  position: absolute;\n  top: 0;\n  right: 25px;\n  font-size: 36px;\n  margin-left: 50px;\n  \n}\n\n.notification_alert_fullbox {\n  height:96%;\n  overflow-y:scroll;\n}\n.notification_alert_box{\n  background: #1d253b !important;\n  padding:10px;\n  margin: 10px;\n  border-radius: 10px;\n  overflow: hidden;\n  \n}\n\n.box-img {\n  float:left;\n  width:30%;\n}\n.box-content {\n  float:right;\n  width:68%;\n  margin-left:2%;\n \n\n}\n\n.box-content h4{\n  font-weight: 600;\n  margin-bottom: 2px;\n  color:#f7f7f7 !important;\n\n}\n.box-content p {\n  color:#fff !important;\n  font-size:11px;\n}\n\n\nul.searchScroll{\n  position: absolute;\n  background: #fff;\n  width: 89%;\n  box-shadow: 0px 0px 10px grey;\n  z-index: 9999;\n  list-style: none;\n  padding: 0px;\n}\nul.searchScroll li {\n  padding: 10px;\n}\n\nul.searchScroll:nth-child(odd) { background:#fff }\nul.searchScroll:nth-child(even) { background:#eee }\n\n\nul.searchScroll li:hover{\n  background: #ddd;\n  cursor: pointer;\n}\n\ninput[type=number].no-spinner::-webkit-inner-spin-button, \ninput[type=number]::-webkit-outer-spin-button { \n-webkit-appearance: none; \n margin: 0; \n}\n\n.showPassword {\n  padding: 8px;\n  border: 1px solid #1d253b33;\n  border-radius: 0px 5px 5px 0px;\n  cursor: pointer;\n}\n\n.rdtPicker td.rdtToday {\n  position: relative;\n  background: #93a8e3;\n  color: #fff !important;\n}\n.rdtDays tr .rdtDay {\n  color: #2c2a2a !important;\n}\n.dropdown-menu>li:last-child, .dropdown-menu>li:last-child .dropdown-item {\n  color: #185da1 !important;\n  font-weight:700 !important;\n}\n.box-count {\n  text-align:center;\n  // min-height: 90px;\n}\n\n.box-1 {\n  border-left:solid 3px #419ef9 !important\n}\n.box-2 {\n  border-left:solid 3px #00bf9a !important\n}\n.box-3 {\n  border-left:solid 3px #ff9f89 !important\n}\n.box-4 {\n  border-left:solid 3px #fd77a4 !important\n}\n.form-group input[type=file] {\n  border: 1px solid rgb(189 189 189) !important;\n    padding: 4px !important;\n    border-radius: 5px !important;\n  }\n\n.card-category {\n    font-size:0.8500000025rem;\n}\n.white-content .table > thead > tr > th, .white-content .table > tbody > tr > th, .white-content .table > tfoot > tr > th, .white-content .table > thead > tr > td, .white-content .table > tbody > tr > td, .white-content .table > tfoot > tr > td {\n  font-size: 0.8500000025rem !important;\n}\n.submit-btn i{\n  color:rgb(47, 202, 125) !important;\n}\n.submit-btn:focus i{\n  color:grey !important;\n}\n.btn-link-add {\n  background:#eee;\n  color:rgb(47, 202, 125);\n  \n}\n.btn-link-add:hover {\n  background:transparent !important;\n  color:rgb(47, 202, 125);\n}\n\n.add-content{\n  margin-bottom:10px;\n  display:inline-block;\n  width:150px;\n  border:solid 2px #fff;\n  transition: 0.2;\n  text-transform: uppercase;\n\n}\n.add-content:hover .btn-link-add{\n  background:transparent;\n  transition: 0.5;\n  font-weight: 600;\n\n}\n.add-content:hover{\n  cursor:pointer;\n  background:#ffffff !important;\n  color:rgb(89, 91, 92) !important;\n  border:solid 2px #eee;\n  border-radius: 8px;\n  transition: 0.5;\n\n}\n.btn-remove-style{\n  background: transparent;\n  color:rgb(206, 66, 66) !important;\n  border:solid 1px rgb(206, 66, 66);\n}\n.btn-remove-style:hover{\n  background:rgb(206, 66, 66) !important;\n  color:#fff !important;\n  border:solid 1px rgb(206, 66, 66);\n}\n.btn-add-style {\n  background: transparent;\n  color:rgb(47, 202, 125);\n  border:solid 1px rgb(47, 202, 125);\n}\n.btn-add-style:hover{\n  background:rgb(47, 202, 125) !important;\n  color:#fff !important;\n  border:solid 1px rgb(47, 202, 125);\n}\n\n\n.pagination .page-item .page-link:hover, .pagination .page-item .page-link:focus {\n   background: #e14eca;\n  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);\n  background-size: 210% 210%;\n  background-position: top right;\n  color: #ffffff;\n}\n\n.graph {\n  height:60vh;\n}\n.tableheight {\n  height:60vh;\n}\n\n.tablemenu {\n  height:90vh;\n}\n.pagecount .pagination {\n  float:right !important;\n}\n.sidebar[data=white] .sidebar-normal, .off-canvas-sidebar[data=white] .sidebar-normal {\n  color: #111 !important;\n  text-transform: capitalize !important;\n}\n@media screen and (min-width: 1320px) and (max-width: 2880px)  {\n  .graph {\n    height:60vh;\n  }\n  .tableheight {\n    height:50vh;\n    padding-bottom: 15px;\n    overflow-y: scroll;\n  }\n  .tableheight_nopagi {\n    height:60vh;\n    padding-bottom: 15px;\n    overflow-y: scroll;\n  }\n  .tableheight_nosearch {\n    height:65vh;\n    padding-bottom: 15px;\n    overflow-y: scroll;\n  }\n  .tableheightwf {\n    height:75vh;\n    padding-bottom: 15px;\n    overflow-y: scroll;\n  }\n  .listing .card{\n      height: 80vh;\n  }\n  \n  .card label{\n    font-size: 0.7500000025rem !important;\n  } \n  .category{\n    font-size: 0.7500000025rem !important;\n  }\n}\n\n.company-brand {\n  position: fixed;\n  top: 50%;\n  right: 0px;\n  padding: 10px 10px;\n  z-index: 999999;\n  writing-mode: vertical-lr;\n  background: #eee;\n  height: 178px;\n  text-align: center;\n  border-radius: 20px 0px 0px 20px;\n    box-shadow: 0px 0px 10px grey;\n\n    \n}\n.company-brand:hover{\n  cursor: pointer;\n}\n.company-brand  a{\n  font-weight: 700;\n}\n\n.login-page .card-login.card-white .form-control:focus{\n  border:transparent !important;\n  // box-shadow: none !important;\n}\n.input-group .input-group-prepend .input-group-text i {\n  font-weight: 700;\n}\n.navbar .navbar-brand{\n  margin-left:0px !important;\n}\n.table .form-check label .form-check-sign::before, .table .form-check label .form-check-sign::after{\n  top:0px !important\n}\n.detailedReport {\n  max-width: 95% !important;\n}\n.detailedReport .table-responsive{\n  max-height: 450px !important;\n}\n\n.login-form {\n  background: rgb(255 255 255 / 10%) !important;\n  border: solid #ffffff69 5px !important;\n}\n\n.card-stats.mb-1.card {\n  min-height: 185px;\n}\n\n","\n/* Animations */\n.nav-pills .nav-link,\n.navbar,\n.nav-tabs .nav-link,\n.sidebar .nav a,\n.sidebar .nav a i,\n.sidebar .nav p,\n.navbar-collapse .navbar-nav .nav-link,\n.animation-transition-general,\n.tag,\n.tag [data-role=\"remove\"],\n.animation-transition-general{\n    @include transitions($general-transition-time, $transition-ease);\n}\n\n//transition for dropdown caret\n.bootstrap-switch-label:before,\n.caret{\n    @include transitions($fast-transition-time, $transition-ease);\n}\n\n.dropdown-toggle[aria-expanded=\"true\"]:after,\na[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n.card-collapse .card a[data-toggle=\"collapse\"][aria-expanded=\"true\"] i,\n.card-collapse .card a[data-toggle=\"collapse\"].expanded i{\n    @include rotate-180();\n}\n\n.caret{\n  width: 0;\n  height: 0;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n  margin-top: -5px;\n  position: absolute;\n  top: 30px;\n  margin-left: 5px;\n}\n\n.pull-left{\n  float: left;\n}\n.pull-right{\n  float: right;\n}\n\n\n// card user profile page\n\n.card {\n  form {\n    label + .form-control {\n      margin-bottom: 20px;\n    }\n  }\n}\n\n// offline documentation\n\n.offline-doc {\n  .page-header:before {\n    background: rgba(0,0,0,.75);\n  }\n\n  .navbar {\n    border: none;\n  }\n\n  .footer {\n    position: absolute;\n    width: 100%;\n    background: transparent;\n    bottom: 0;\n    color: $white;\n    padding: 0.9375rem 0;\n  }\n}\n\n\n.card {\n  .map-title {\n    color: $white;\n  }\n\n    .table {\n      tr td {\n        p.title {\n          padding-top: 7px;\n          margin-bottom: 0;\n        }\n      }\n    }\n\n\n  &.card-chart {\n    .gmnoprint,\n    .gm-style-cc {\n      display: none !important;\n    }\n  }\n}\n\n// documentation\n\n.bd-docs {\n\n  h1,h2,h3,h4,h5,h6,p,ul li,ol li{\n    color:#2c2c2c;\n  }\n\n\n  .bd-content>table>thead>tr>th {\n    color: $black;\n\n  }\n\n  .blockquote, .blockquote p, .card p{\n    color: rgba($white,0.8);\n  }\n  .bd-example {\n    background: linear-gradient(#1e1e2f,#1e1e24);\n\n  }\n\n  .navbar {\n    border-top: none;\n\n    .navbar-nav .nav-link {\n      color: rgba(255,255,255,.8) !important;\n    }\n  }\n\n  .bd-example {\n\n    .btn{\n      margin: 4px 0;\n    }\n    .btn .badge {\n      display: inline-block;\n    }\n\n    .tim-icons{\n      color: $white;\n    }\n\n    .popover .popover-header {\n    color: hsla(0,0%,71%,.6);\n  }\n\n\n    .popover-body {\n      p {\n        color: $gray-900;\n      }\n    }\n\n    &.tooltip-demo p{\n      color: rgba($white,.8);\n    }\n  }\n\n  .card.card-body,\n  .card .card-body {\n    color: hsla(0,0%,100%,.8);\n  }\n\n  label,\n  .form-check {\n    color: hsla(0,0%,100%,.8);\n  }\n\n  .form-check + .btn {\n    margin-top: 20px;\n  }\n\n  .bd-example,\n  table {\n    thead th {\n      color: hsla(0,0%,100%,.8);\n    }\n\n    h1, h2, h3, h4, h5, h6,\n    .h1, .h2, .h3, .h4, .h5, .h6 {\n      color: hsla(0,0%,100%,.8);\n    }\n\n    .datepicker{\n      thead th, table thead th,.tim-icons{\n        color: $primary;\n      }\n\n    }\n\n    .picker-switch .tim-icons{\n      color: $primary;\n    }\n  }\n\n  .footer {\n    .container-fluid > nav {\n      display: inline-block;\n    }\n  }\n\n  #exampleModalLong.modal.show {\n    .modal-dialog {\n      transform: translateY(5%);\n    }\n  }\n}\n.modal.show .modal-dialog {\n  -webkit-transform: translate(0,30%);\n  transform: translate(0,30%);\n}\n\ncode {\n  color: $pink;\n}\n",".rtl {\n  .sidebar,\n  .bootstrap-navbar {\n    right: 0;\n    left: auto;\n    margin-right: 20px;\n    margin-left: 0;\n\n    .nav {\n        i {\n          float: right;\n          margin-left: 15px;\n          margin-right: 0;\n        }\n\n        p {\n          margin-right: 45px;\n          text-align: right;\n        }\n\n        .caret {\n          left: 11px;\n          right: auto;\n        }\n\n        li.active a {\n          &:before {\n            left: auto !important;\n            right: -4px;\n          }\n        }\n    }\n\n    .logo {\n        a.logo-mini {\n          float: right;\n          margin-right: 20px;\n          margin-left: 10px;\n        }\n\n        .simple-text {\n          text-align: right;\n        }\n    }\n\n    .sidebar-wrapper .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon,\n    .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon {\n      float: right;\n      margin-left: 15px;\n      margin-right: 0;\n    }\n\n    .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n    .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal {\n      text-align: right;\n    }\n\n    &:before {\n      right: 30px;\n      left: auto;\n    }\n  }\n\n  .main-panel {\n    position: fixed;\n    height: 100%;\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n\n  .main-panel .content {\n    padding: 110px 300px 20px 50px\n  }\n\n  .dropdown-toggle:after {\n    margin-right: .255em;\n    margin-left: 0;\n  }\n\n  .dropdown-menu.dropdown-menu-right.dropdown-navbar {\n    right: -220px !important;\n    left: auto;\n\n    &:before {\n      right: auto;\n      left: 35px;\n    }\n  }\n\n  .notification {\n    left: 40px;\n    right: auto;\n  }\n\n  .dropdown-menu {\n    right: auto;\n    left: 0;\n  }\n\n  .card-timeline .timeline .timeline-footer .btn {\n    margin-left: 0;\n    margin-right: auto;\n  }\n\n  .navbar-minimize-fixed {\n    margin-right: 38px;\n    margin-left: auto;\n  }\n\n  .minimize-sidebar {\n    float: right;\n  }\n\n  .alert {\n    left: 0;\n    margin-left: 0;\n    margin-right: 0;\n      button.close{\n        left: 10px !important;\n        right: auto !important;\n      }\n\n      span[data-notify=\"icon\"] {\n        right: 15px;\n        left: auto;\n      }\n\n\n\n      &.alert-with-icon {\n        padding-right: 65px;\n        padding-left: 15px;\n      }\n\n      &.alert-with-icon i[data-notify=\"icon\"] {\n        right: 15px;\n        left: auto;\n      }\n  }\n\n  .search-bar {\n    margin-left: 0;\n  }\n\n  .modal-search .modal-header .close {\n    margin-right: auto;\n    left: 10px;\n  }\n\n  .rtl .footer {\n    padding: 24px 30px !important;\n  }\n\n  .ps__rail-y {\n    right: auto !important;\n    left: 0;\n  }\n\n  .card.card-timeline {\n    .timeline .timeline-footer {\n      .btn.dropdown-toggle {\n        i {\n          left: 0 !important;\n        }\n\n        &:after {\n          margin-left: 5px !important;\n        }\n      }\n    }\n  }\n\n  .fixed-plugin .dropdown-menu {\n    right: 80px;\n  }\n}\n\n\n\n@include media-breakpoint-up(xl) {\n  .rtl{\n    &.sidebar-mini .main-panel .content {\n      padding-right: 130px;\n      padding-left: 50px;\n    }\n\n    &.sidebar-mini footer {\n      padding-right: 130px;\n      padding-left: 50px;\n    }\n\n    .navbar-minimize button {\n      margin-right: -5px;\n    }\n\n    .footer {\n      padding: 24px 300px 24px 0;\n    }\n  }\n}\n\n@include media-breakpoint-down(lg) {\n\n\n  .rtl {\n    .sidebar {\n      @include transform-translate-x(260px);\n    }\n\n    .main-panel {\n      float: right;\n      right: 0;\n      left: auto;\n      @include transform-translate-x(0px);\n    }\n  }\n\n  .rtl .sidebar {\n    margin-right: 0;\n  }\n\n  .rtl .main-panel .content{\n    padding-right: 50px;\n  }\n}\n\n@include media-breakpoint-down(md) {\n    .rtl .main-panel .content {\n      padding-right: 50px;\n    }\n\n    .rtl #bodyClick {\n      right: 260px;\n      left: auto;\n    }\n\n    .rtl .navbar .navbar-toggle .navbar-toggler {\n        display: block;\n        margin-right: 20px;\n    }\n\n    .rtl .navbar {\n      .navbar-nav {\n        padding-right: 0;\n        a.nav-link {\n          text-align: right;\n          p{\n            margin-right: 7px;\n          }\n        }\n\n        .btn {\n          margin-right: 0;\n          padding: 0;\n          i{\n            margin-left: 4px;\n            margin-right: 5px;\n          }\n        }\n\n        .search-bar span{\n          margin-right: 10px;\n        }\n      }\n    }\n    .nav-open {\n      body {\n        position: fixed;\n      }\n    }\n  }\n\n\n@include media-breakpoint-down(sm) {\n  .rtl {\n    .main-panel .content {\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n  }\n}\n\n\n@include media-breakpoint-down(xs) {\n\n.rtl .navbar .dropdown-menu {\n    width: 200px !important;\n  }\n}\n",".card.card-timeline{\n  .card-body {\n    padding-left: 0;\n    padding-right: 0;\n  }\n    .timeline {\n        list-style: none;\n        padding: 20px 0 20px;\n        position: relative;\n\n        &:before {\n            top: 0;\n            bottom: 0;\n            position: absolute;\n            content: \" \";\n            width: 3px;\n            background-color: $black;\n            left: 50%;\n            margin-left: -1.5px;\n        }\n\n        .timeline-footer {\n          .btn{\n            margin: 0;\n\n            &.dropdown-toggle {\n              i {\n                top: -1px;\n                left: 10px;\n              }\n\n              &:after {\n                margin-left: 20px !important;\n              }\n            }\n          }\n        }\n\n        h6{\n            color: rgba($white,0.8);\n            font-weight: 400;\n            margin: 10px 0px 0px;\n        }\n\n        &.timeline-simple {\n\n            &:before {\n                left: 5%;\n            }\n\n            > li > .timeline-panel {\n                width: 86%;\n            }\n\n            > li > .timeline-badge {\n                left: 5%;\n            }\n        }\n\n        > li {\n            margin-bottom: 20px;\n            position: relative;\n\n            &:before,\n            &:after {\n                content: \" \";\n                display: table;\n            }\n\n            &:after {\n                clear: both;\n            }\n\n        }\n\n        > li > .timeline-panel {\n            background: $card-black-background;\n            width: 45%;\n            float: left;\n            padding: 20px;\n            border-radius: $border-radius-sm;\n            box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);\n            color: $black;\n            margin-bottom: 20px;\n            position: relative;\n\n            &:before {\n                position: absolute;\n                top: 26px;\n                right: -15px;\n                display: inline-block;\n                border-top: 15px solid transparent;\n                border-left: 15px solid $black;\n                border-right: 0 solid $black;\n                border-bottom: 15px solid transparent;\n                content: \" \";\n            }\n\n            &:after {\n                position: absolute;\n                top: 27px;\n                right: -14px;\n                display: inline-block;\n                border-top: 14px solid transparent;\n                border-left: 14px solid $card-black-background;\n                border-right: 0 solid $card-black-background;\n                border-bottom: 14px solid transparent;\n                content: \" \";\n            }\n\n            &.timeline-panel-white{\n              background: $white;\n              .timeline-body p{\n                color: $black-states;\n              }\n\n              &:after, &:before{\n                border-right-color: $white;\n                border-left-color: $white;\n              }\n            }\n        }\n\n\n\n        > li > .timeline-badge {\n            color: $white;\n            width: 50px;\n            height: 50px;\n            line-height: 51px;\n            font-size: 1.4em;\n            text-align: center;\n            position: absolute;\n            top: 16px;\n            left: 50%;\n            margin-left: -25px;\n            background-color: $dark-gray;\n            z-index: 100;\n            border-top-right-radius: 50%;\n            border-top-left-radius: 50%;\n            border-bottom-right-radius: 50%;\n            border-bottom-left-radius: 50%;\n\n            [class^=\"ti-\"],\n            [class*=\" ti-\"]{\n                line-height: inherit;\n            }\n\n            .tim-icons{\n              width: 25px;\n              height: 21px;\n              text-align: center;\n            }\n        }\n\n\n\n        > li.timeline-inverted > .timeline-panel {\n            float: right;\n\n            &:before {\n                border-left-width: 0;\n                border-right-width: 15px;\n                left: -15px;\n                right: auto;\n            }\n\n            &:after {\n                border-left-width: 0;\n                border-right-width: 14px;\n                left: -14px;\n                right: auto;\n            }\n\n        }\n\n\n    }\n    .timeline-heading{\n        margin-bottom: 15px;\n    }\n    .timeline-badge.primary {\n      background-color: $info !important;\n    }\n    .timeline-badge.info {\n      background-color: $info !important;\n    }\n\n    .timeline-badge.success {\n      background-color: darken($success,10%) !important;\n    }\n\n    .timeline-badge.warning {\n      background-color: $warning !important;\n    }\n\n    .timeline-badge.danger {\n      background-color: $danger !important;\n    }\n\n\n    .timeline-title {\n      margin-top: 0;\n      color: inherit;\n    }\n\n    .timeline-body > p,\n    .timeline-body > ul {\n      margin-bottom: 0;\n      color: $white;\n    }\n\n    .timeline-body > p + p {\n      margin-top: 5px;\n    }\n\n\n}\n\n@include media-breakpoint-down(sm){\n  .card.card-timeline {\n    .timeline {\n        &:before {\n          left: 5%;\n        }\n\n        > li > .timeline-badge {\n            left: 5%;\n        }\n\n        > li > .timeline-panel{\n            float: right;\n            width: 83% !important;\n\n            &:before{\n                border-left-width: 0;\n                border-right-width: 15px;\n                left: -15px;\n                right: auto;\n            }\n\n            &:after{\n                border-left-width: 0;\n                border-right-width: 14px;\n                left: -14px;\n                right: auto;\n            }\n        }\n    }\n  }\n}\n",".sr-only,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after,\n.bootstrap-datetimepicker-widget .picker-switch::after,\n.bootstrap-datetimepicker-widget table th.prev::after,\n.bootstrap-datetimepicker-widget table th.next::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.bootstrap-datetimepicker-widget {\n  list-style: none;\n}\n.bootstrap-datetimepicker-widget a .btn:hover {\n  background-color: transparent;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu {\n  padding: 8px 6px;\n  width: 254px;\n  max-width: 254px;\n\n  .tim-icons{\n      opacity: 1;\n  }\n\n  .picker-switch {\n    .table-condensed {\n      &:hover {\n        background: #eee;\n        border-radius: 3px;\n      }\n    }\n  }\n\n  .timepicker-picker {\n    .table-condensed {\n      margin-top: 10px;\n      margin-bottom: 5px;\n\n      .btn[data-action=\"togglePeriod\"]:hover,\n      .separator {\n        color: $dark-gray !important;\n      }\n    }\n  }\n  .table-condensed {\n    .month,\n    .year,\n    .decade {\n      color: $dark-gray;\n\n      &.active {\n        color: $white;\n      }\n    }\n  }\n}\n@include media-breakpoint-up(md){\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@include media-breakpoint-up(lg){\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@include media-breakpoint-up(xl){\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    right: auto;\n    border-bottom: .4em solid;\n    border-right: .4em solid transparent;\n    border-left: .4em solid transparent;\n\n\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top:before{\n    display: none;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top:after{\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    top: auto;\n    bottom: -6px;\n    right: auto;\n    left: 10px;\n    color: $white;\n    border-top: .4em solid;\n    border-right: .4em solid transparent;\n    border-left: .4em solid transparent;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.top {\n  margin-top: auto;\n  margin-bottom: -20px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.top.open {\n  margin-top: auto;\n  margin-bottom: 3px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\n  left: auto;\n  right: 6px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\n  left: auto;\n  right: 7px;\n}\n.bootstrap-datetimepicker-widget .list-unstyled {\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget a[data-action] {\n  padding: 0;\n  border-width: 0;\n  color: #fff;\n  background-color: transparent;\n}\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover {\n    color: $primary;\n}\n.bootstrap-datetimepicker-widget a[data-action]:hover {\n  background-color: transparent;\n}\n.bootstrap-datetimepicker-widget a[data-action]:active {\n  box-shadow: none;\n}\n.bootstrap-datetimepicker-widget .timepicker-hour,\n.bootstrap-datetimepicker-widget .timepicker-minute,\n.bootstrap-datetimepicker-widget .timepicker-second {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  font-weight: 300;\n  font-size: 1.5em;\n  margin: 3px;\n  border-radius: 50%;\n  color: $dark-gray;\n}\n.bootstrap-datetimepicker-widget button[data-action] {\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\n}\n\n.bootstrap-datetimepicker-widget .btn{\n    margin: 0 !important;\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n  content: \"Increment Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n  content: \"Increment Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n  content: \"Decrement Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n  content: \"Decrement Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n  content: \"Show Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n  content: \"Show Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n  content: \"Toggle AM/PM\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n  content: \"Clear the picker\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n  content: \"Set the date to today\";\n}\n.bootstrap-datetimepicker-widget .picker-switch {\n  text-align: center;\n  border-radius: 3px;\n  color: $primary;\n}\n.bootstrap-datetimepicker-widget .picker-switch::after {\n  content: \"Toggle Date and Time Screens\";\n}\n.bootstrap-datetimepicker-widget .picker-switch td {\n  padding: 0;\n  margin: 0;\n  height: auto;\n  width: auto;\n  line-height: inherit;\n}\n.bootstrap-datetimepicker-widget .picker-switch td span {\n  line-height: 2.5;\n  height: 2.5em;\n  width: 100%;\n  border-radius: 3px;\n  margin: 2px 0px !important;\n}\n.bootstrap-datetimepicker-widget table {\n  width: 100%;\n  margin: 0;\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table th {\n  height: 20px;\n  line-height: 20px;\n  width: 20px;\n  font-weight: 300;\n}\n.bootstrap-datetimepicker-widget table th.picker-switch {\n  width: 145px;\n}\n.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {\n  border-radius: 4px;\n  height: 27px;\n  width: 27px;\n  line-height: 28px;\n  font-size: 12px;\n  border-radius: 50%;\n  text-align: center;\n  color: $primary;\n}\n.bootstrap-datetimepicker-widget table th.prev::after {\n  content: \"Previous Month\";\n}\n.bootstrap-datetimepicker-widget table th.next::after {\n  content: \"Next Month\";\n}\n.bootstrap-datetimepicker-widget table th.dow {\n  text-align: center;\n  color: $primary;\n  padding-bottom: 5px;\n  padding-top: 10px;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {\n  background: #eee;\n}\n\n.bootstrap-datetimepicker-widget table td.cw > div {\n  font-size: .8em;\n  height: 20px;\n  line-height: 20px;\n  color: #cfcfca;\n}\n.bootstrap-datetimepicker-widget table td.day > div,\n.bootstrap-datetimepicker-widget table td.minute > div,\n.bootstrap-datetimepicker-widget table td.hour > div {\n  height: 30px;\n  line-height: 2.2;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n  margin: 0 auto;\n  z-index: -1;\n  color: $dark-gray;\n  position: relative;\n  font-weight: 300;\n  font-size: 14px;\n  border: none;\n  cursor: pointer;\n  @include transitions($general-transition-time, $transition-ease);\n}\n.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {\n  background: #eee;\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {\n  color: $default;\n}\n.bootstrap-datetimepicker-widget table td.today > div:before {\n  content: '';\n  display: inline-block;\n  border: 0 0 7px 7px solid transparent;\n  border-bottom-color: #68B3C8;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n}\n.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {\n  background-color: $primary;\n  color: $white;\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\n}\n.bootstrap-datetimepicker-widget table td.active.today:before > div {\n  border-bottom-color: $white;\n}\n.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table td span {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  margin: 0 3px;\n  cursor: pointer;\n  border-radius: 50%;\n  text-align: center;\n}\n\n.bootstrap-datetimepicker-widget table td span.active {\n  background-color: $primary;\n  color: #FFFFFF;\n}\n.bootstrap-datetimepicker-widget table td span.old {\n  color: #cfcfca;\n}\n.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget .timepicker-picker span,\n.bootstrap-datetimepicker-widget .timepicker-hours span,\n.bootstrap-datetimepicker-widget .timepicker-minutes span {\n  border-radius: 50% !important;\n}\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n  height: 27px;\n  line-height: 27px;\n}\n\n.input-group.date .input-group-addon {\n  cursor: pointer;\n}\n\n.table-condensed > tbody > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > thead > tr > th {\n  padding: 1px;\n  text-align: center;\n  z-index: 1;\n  cursor: pointer;\n}\n\ninput.datetimepicker[data-color] + .bootstrap-datetimepicker-widget{\n    .picker-switch,\n    table th.prev span,\n    table th.next span,\n    table td.day > div,\n    a[data-action=\"togglePicker\"],\n    a[data-action=\"togglePicker\"]:hover,\n    span,\n    .timepicker-hours span,\n    .timepicker-minutes span,\n    .separator,\n    table td.minute > div,\n    table td.hour > div{\n        color: $dark-gray;\n    }\n\n\n\n    table th.dow{\n        color: $opacity-8;\n    }\n\n    table td.old > div,\n    table td.new > div{\n        color: rgba(255,255,255, .4);\n    }\n\n    button[data-action]{\n        background-color: $white;\n    }\n\n    table td.active > div,\n    table td.active:hover > div{\n        background-color: $white;\n    }\n\n    table td:not(.active).day:hover > div,\n    table td.hour:hover > div,\n    table td.minute:hover > div,\n    table td.second:hover > div,\n    table td span:hover{\n        background: $opacity-2;\n    }\n\n    table thead tr:first-child th:hover span,\n    table thead tr:first-child th.picker-switch:hover{\n        background-color: $opacity-2;\n    }\n}\n\n\ninput.datetimepicker[data-color=\"orange\"] + .bootstrap-datetimepicker-widget{\n    background-color: $primary;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $primary;\n    }\n}\n\ninput.datetimepicker[data-color=\"blue\"] + .bootstrap-datetimepicker-widget{\n    background-color: $info;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $info;\n    }\n}\n\ninput.datetimepicker[data-color=\"green\"] + .bootstrap-datetimepicker-widget{\n    background-color: $success;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $success;\n    }\n}\n\ninput.datetimepicker[data-color=\"red\"] + .bootstrap-datetimepicker-widget{\n    background-color: $danger;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $danger;\n    }\n}\n\ninput.datetimepicker[data-color=\"yellow\"] + .bootstrap-datetimepicker-widget{\n    background-color: $warning;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $warning;\n    }\n}\n\n\n.bootstrap-datetimepicker-widget {\n  &.dropdown-black {\n    .datepicker-days {\n      .day, .minute{\n        color: rgba(255, 255, 255, 0.7);\n\n        &:hover {\n          color: #212529;\n        }\n      }\n    }\n\n    table td span, table td.minute, table td.hour{\n      color: rgba(255, 255, 255, 0.7);\n    }\n    table td span:hover, table td.minute:hover, table td.hour:hover {\n      background: transparent;\n      color: rgba(255, 255, 255, 0.4);\n\n    div{\n      background: transparent;\n    }\n\n    }\n\n    table td .btn[data-action] {\n      color: $white;\n    }\n\n    table td .btn[data-action=\"togglePeriod\"] {\n      background: transparent;\n    }\n  }\n}\n","/*! nouislider - 11.1.0 - 2018-04-02 11:18:13 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n\n/* Offset direction\n */\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n .noUi-horizontal {\n \theight: 1px;\n }\n .noUi-horizontal .noUi-handle {\n  border-radius: 50%;\n \tbackground-color: $white;\n \tbox-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);\n \theight: 15px;\n \twidth: 15px;\n \tcursor: pointer;\n  margin-left: -10px;\n  margin-top: -7px;\n }\n.noUi-vertical {\n  width: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  left: -6px;\n  top: -17px;\n}\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n  right: -15px;\n  left: auto;\n\toutline: none;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background-color: rgba(182, 182, 182, .3);\n\tborder-radius: 3px;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  background: $default;\n  border-radius: 3px;\n  -webkit-transition: background 450ms;\n\ttransition: background 450ms;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  border-radius: 3px;\n  background: $white;\n  cursor: default;\n  box-shadow: inset 0 0 1px #FFF,\n        inset 0 1px 7px #EBEBEB,\n        0 3px 6px -3px #BBB;\n  -webkit-transition: $general-transition-time $transition-ease;\n    -moz-transition: $general-transition-time $transition-ease;\n    -ms-transition: $general-transition-time $transition-ease;\n    -o-transform: $general-transition-time $transition-ease;\n    transition: $general-transition-time $transition-ease;\n\n}\n.noUi-active {\n  -webkit-transform: scale3d(1.5,1.5,1);\n    -moz-transform: scale3d(1.5,1.5,1);\n    -ms-transform: scale3d(1.5,1.5,1);\n    -o-transform: scale3d(1.5,1.5,1);\n    transform: scale3d(1.5,1.5,1);\n}\n\n\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%,0);\n  transform: translate(-50%, 50%,0);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate3d(0,50%,0);\n  transform: translate3d(0,50%,0);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: $white;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n.slider {\n\t&.slider-neutral {\n\t\t& .noUi-connect,\n        &.noUi-connect {\n            background-color: $white;\n        }\n\n\t\t&.noUi-target {\n\t\t\tbackground-color: rgba(255,255,255, .3);\n\t\t}\n\n\t\t& .noUi-handle {\n\t\t\tbackground-color: $white;\n\t\t}\n\t}\n\n\t&.slider-primary {\n\t\t& .noUi-connect,\n        &.noUi-connect {\n            background-color: $primary;\n        }\n\n\t\t&.noUi-target {\n\t\t\tbackground-color: $primary-opacity;\n\t\t}\n\n\t\t& .noUi-handle {\n\t\t\tbackground-color: $brand-primary;\n\t\t\tbox-shadow: 0px 0px 10px 0px $brand-primary;\n\t\t}\n\t}\n\n    &.slider-info {\n        & .noUi-connect,\n        &.noUi-connect {\n            background-color: $brand-info;\n        }\n\n\t\t&.noUi-target {\n\t\t\tbackground-color: $info-opacity;\n\t\t}\n\n\t\t& .noUi-handle {\n\t\t\tbackground-color: $brand-info;\n\t\t\tbox-shadow: 0px 0px 10px 0px $brand-info;\n\t\t}\n    }\n    &.slider-success {\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $brand-success;\n        }\n\n        &.noUi-target {\n\t\t\tbackground-color: $success-opacity;\n\t\t}\n\n\t\t& .noUi-handle {\n\t\t\tbackground-color: $brand-success;\n\t\t\tbox-shadow: 0px 0px 10px 0px $brand-success;\n\t\t}\n    }\n    &.slider-warning {\n        & .noUi-connect,\n        &.noUi-connect {\n            background-color: $brand-warning;\n        }\n\n        &.noUi-target {\n\t\t\tbackground-color: $warning-opacity;\n\t\t}\n\n\t\t& .noUi-handle {\n\t\t\tbackground-color: $brand-warning;\n\t\t\tbox-shadow: 0px 0px 10px 0px $brand-warning;\n\t\t}\n    }\n    &.slider-danger {\n        & .noUi-connect,\n        &.noUi-connect {\n            background-color: $brand-danger;\n        }\n\n        &.noUi-target {\n\t\t\tbackground-color: $danger-opacity;\n\t\t}\n\n\t\t& .noUi-handle {\n\t\t\tbackground-color: $brand-danger;\n\t\t\tbox-shadow: 0px 0px 10px 0px $brand-danger;\n\t\t}\n    }\n\n}\n","// core style\n\n@charset \"UTF-8\";\n.fc {\n  direction: ltr;\n  text-align: left;\n}\n\n.fc-rtl {\n  text-align: right;\n}\n\nbody .fc {\n  /* extra precedence to overcome jqui */\n  font-size: 1em;\n}\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.fc-highlight {\n  /* when user is selecting cells */\n  background: #bce8f1;\n  opacity: 0.3;\n}\n\n.fc-bgevent {\n  /* default look for background events */\n  background: #8fdf82;\n  opacity: 0.3;\n}\n\n.fc-nonbusiness {\n  /* default look for non-business-hours areas */\n  /* will inherit .fc-bgevent's styles */\n  background: #d7d7d7;\n}\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-popover {\n  position: absolute;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.fc-popover .fc-header {\n  /* TODO: be more consistent with fc-head/fc-body */\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2px 4px;\n}\n\n.fc-rtl .fc-popover .fc-header {\n  flex-direction: row-reverse;\n}\n\n.fc-popover .fc-header .fc-title {\n  margin: 0 2px;\n}\n\n.fc-popover .fc-header .fc-close {\n  cursor: pointer;\n  opacity: 0.65;\n  font-size: 1.1em;\n}\n\n/* Misc Reusable Components\n--------------------------------------------------------------------------------------------------*/\n.fc-divider {\n  border-style: solid;\n  border-width: 1px;\n}\n\nhr.fc-divider {\n  height: 0;\n  margin: 0;\n  padding: 0 0 2px;\n  /* height is unreliable across browsers, so use padding */\n  border-width: 1px 0;\n}\n\n.fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-mirror-skeleton {\n  /* these element should always cling to top-left/right corners */\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.fc-bg {\n  bottom: 0;\n  /* strech bg to bottom edge */\n}\n\n.fc-bg table {\n  height: 100%;\n  /* strech bg to bottom edge */\n}\n\n/* Tables\n--------------------------------------------------------------------------------------------------*/\n.fc table {\n  width: 100%;\n  box-sizing: border-box;\n  /* fix scrollbar issue in firefox */\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 1em;\n  /* normalize cross-browser */\n}\n\n.fc th {\n  text-align: center;\n}\n\n.fc th,\n.fc td {\n  border-style: solid;\n  border-width: 1px;\n  padding: 0;\n  vertical-align: top;\n}\n\n.fc td.fc-today {\n  border-style: double;\n  /* overcome neighboring borders */\n}\n\n/* Internal Nav Links\n--------------------------------------------------------------------------------------------------*/\na[data-goto] {\n  cursor: pointer;\n}\n\na[data-goto]:hover {\n  text-decoration: underline;\n}\n\n/* Fake Table Rows\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-row {\n  /* extra precedence to overcome themes forcing a 1px border */\n  /* no visible border by default. but make available if need be (scrollbar width compensation) */\n  border-style: solid;\n  border-width: 0;\n}\n\n.fc-row table {\n  /* don't put left/right border on anything within a fake row.\n     the outer tbody will worry about this */\n  border-left: 0 hidden transparent;\n  border-right: 0 hidden transparent;\n  /* no bottom borders on rows */\n  border-bottom: 0 hidden transparent;\n}\n\n.fc-row:first-child table {\n  border-top: 0 hidden transparent;\n  /* no top border on first row */\n}\n\n/* Day Row (used within the header and the DayGrid)\n--------------------------------------------------------------------------------------------------*/\n.fc-row {\n  position: relative;\n}\n\n.fc-row .fc-bg {\n  z-index: 1;\n}\n\n/* highlighting cells & background event skeleton */\n.fc-row .fc-bgevent-skeleton,\n.fc-row .fc-highlight-skeleton {\n  bottom: 0;\n  /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-bgevent-skeleton table,\n.fc-row .fc-highlight-skeleton table {\n  height: 100%;\n  /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-highlight-skeleton td,\n.fc-row .fc-bgevent-skeleton td {\n  border-color: transparent;\n}\n\n.fc-row .fc-bgevent-skeleton {\n  z-index: 2;\n}\n\n.fc-row .fc-highlight-skeleton {\n  z-index: 3;\n}\n\n/*\nrow content (which contains day/week numbers and events) as well as \"mirror\" (which contains\ntemporary rendered events).\n*/\n.fc-row .fc-content-skeleton {\n  position: relative;\n  z-index: 4;\n  padding-bottom: 2px;\n  /* matches the space above the events */\n}\n\n.fc-row .fc-mirror-skeleton {\n  z-index: 5;\n}\n\n.fc .fc-row .fc-content-skeleton table,\n.fc .fc-row .fc-content-skeleton td,\n.fc .fc-row .fc-mirror-skeleton td {\n  /* see-through to the background below */\n  /* extra precedence to prevent theme-provided backgrounds */\n  background: none;\n  /* in case <td>s are globally styled */\n  border-color: transparent;\n}\n\n.fc-row .fc-content-skeleton td,\n.fc-row .fc-mirror-skeleton td {\n  /* don't put a border between events and/or the day number */\n  border-bottom: 0;\n}\n\n.fc-row .fc-content-skeleton tbody td,\n.fc-row .fc-mirror-skeleton tbody td {\n  /* don't put a border between event cells */\n  border-top: 0;\n}\n\n/* Scrolling Container\n--------------------------------------------------------------------------------------------------*/\n.fc-scroller {\n  -webkit-overflow-scrolling: touch;\n}\n\n/* TODO: move to timegrid/daygrid */\n.fc-scroller > .fc-day-grid,\n.fc-scroller > .fc-time-grid {\n  position: relative;\n  /* re-scope all positions */\n  width: 100%;\n  /* hack to force re-sizing this inner element when scrollbars appear/disappear */\n}\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n\n.fc-event {\n\tposition: relative; /* for resize handle and other inner positioning */\n\tdisplay: block; /* make the <a> tag block */\n\tfont-size: .85em;\n\tline-height: 1.3;\n\tborder-radius: 2px;\n\tbackground-color: $brand-success; /* default BACKGROUND color */\n\t// @include shadow-big-color($brand-success);\n\tfont-weight: normal; /* undo jqui's ui-widget-header bold */\n\n    &.event-azure{\n        background-color: $brand-info;\n\t\t// @include shadow-big-color($brand-info);\n    }\n    &.event-green{\n        background-color: darken($brand-success,10%);\n\t\t// @include shadow-big-color($brand-success);\n    }\n    &.event-orange{\n        background-color: $brand-warning;\n\t\t// @include shadow-big-color($brand-warning);\n    }\n    &.event-red{\n        background-color: $brand-danger;\n\t\t// @include shadow-big-color($brand-danger);\n    }\n\t&.event-rose{\n\t\t// background-color: $brand-rose;\n\t\t// @include shadow-big-color($brand-rose);\n\t}\n\t&.event-default{\n\t\tbackground-color: $default;\n\t\t// @include shadow-big-color($gray-light);\n\t}\n}\n\n.fc-event-dot {\n\tbackground-color: #3a87ad; /* default BACKGROUND color */\n}\n\n.fc-event,\n.fc-event:hover,\n.ui-widget .fc-event {\n\tcolor: $white; /* default TEXT color */\n\ttext-decoration: none; /* if <a> has an href */\n}\n\n.fc-event[href],\n.fc-event.fc-draggable {\n  cursor: pointer;\n  /* give events with links and draggable events a hand mouse pointer */\n}\n\n.fc-not-allowed,\n.fc-not-allowed .fc-event {\n  /* to override an event's custom cursor */\n  cursor: not-allowed;\n}\n\n.fc-event .fc-bg { /* the generic .fc-bg already does position */\n\tz-index: 1;\n\tbackground: $white;\n\topacity: .25;\n}\n\n.fc-event .fc-content {\n  position: relative;\n  z-index: 2;\n}\n\n/* resizer (cursor AND touch devices) */\n.fc-event .fc-resizer {\n  position: absolute;\n  z-index: 4;\n}\n\n/* resizer (touch devices) */\n.fc-event .fc-resizer {\n  display: none;\n}\n\n.fc-event.fc-allow-mouse-resize .fc-resizer,\n.fc-event.fc-selected .fc-resizer {\n  /* only show when hovering or selected (with touch) */\n  display: block;\n}\n\n/* hit area */\n.fc-event.fc-selected .fc-resizer:before {\n  /* 40x40 touch area */\n  content: \"\";\n  position: absolute;\n  z-index: 9999;\n  /* user of this util can scope within a lower z-index */\n  top: 50%;\n  left: 50%;\n  width: 40px;\n  height: 40px;\n  margin-left: -20px;\n  margin-top: -20px;\n}\n\n/* Event Selection (only for touch devices)\n--------------------------------------------------------------------------------------------------*/\n.fc-event.fc-selected {\n  z-index: 9999 !important;\n  /* overcomes inline z-index */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.fc-event.fc-selected:after {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  /* same z-index as fc-bg, behind text */\n  /* overcome the borders */\n  top: -1px;\n  right: -1px;\n  bottom: -1px;\n  left: -1px;\n  /* darkening effect */\n  background: #000;\n  opacity: 0.25;\n}\n\n/* Event Dragging\n--------------------------------------------------------------------------------------------------*/\n.fc-event.fc-dragging.fc-selected {\n  z-index: 9999 !important; /* overcomes inline z-index */\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);\n}\n\n.fc-event.fc-selected.fc-dragging {\n\tbox-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);\n}\n\n.fc-event.fc-dragging:not(.fc-selected) {\n  opacity: 0.75;\n}\n\n/* Horizontal Events\n--------------------------------------------------------------------------------------------------*/\n/* bigger touch area when selected */\n.fc-h-event.fc-selected:before {\n  content: \"\";\n  position: absolute;\n  z-index: 3;\n  /* below resizers */\n  top: -10px;\n  bottom: -10px;\n  left: 0;\n  right: 0;\n}\n\n/* events that are continuing to/from another week. kill rounded corners and butt up against edge */\n.fc-ltr .fc-h-event.fc-not-start,\n.fc-rtl .fc-h-event.fc-not-end {\n  margin-left: 0;\n  border-left-width: 0;\n  padding-left: 1px;\n  /* replace the border with padding */\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.fc-ltr .fc-h-event.fc-not-end,\n.fc-rtl .fc-h-event.fc-not-start {\n  margin-right: 0;\n  border-right-width: 0;\n  padding-right: 1px;\n  /* replace the border with padding */\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n/* resizer (cursor AND touch devices) */\n/* left resizer  */\n.fc-ltr .fc-h-event .fc-start-resizer,\n.fc-rtl .fc-h-event .fc-end-resizer {\n  cursor: w-resize;\n  left: -1px;\n  /* overcome border */\n}\n\n/* right resizer */\n.fc-ltr .fc-h-event .fc-end-resizer,\n.fc-rtl .fc-h-event .fc-start-resizer {\n  cursor: e-resize;\n  right: -1px;\n  /* overcome border */\n}\n\n/* resizer (mouse devices) */\n.fc-h-event.fc-allow-mouse-resize .fc-resizer {\n  width: 7px;\n  top: -1px;\n  /* overcome top border */\n  bottom: -1px;\n  /* overcome bottom border */\n}\n\n/* resizer (touch devices) */\n.fc-h-event.fc-selected .fc-resizer {\n  /* 8x8 little dot */\n  border-radius: 4px;\n  border-width: 1px;\n  width: 6px;\n  height: 6px;\n  border-style: solid;\n  border-color: inherit;\n  background: #fff;\n  /* vertically center */\n  top: 50%;\n  margin-top: -4px;\n}\n\n/* left resizer  */\n.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,\n.fc-rtl .fc-h-event.fc-selected .fc-end-resizer {\n  margin-left: -4px;\n  /* centers the 8x8 dot on the left edge */\n}\n\n/* right resizer */\n.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,\n.fc-rtl .fc-h-event.fc-selected .fc-start-resizer {\n  margin-right: -4px;\n  /* centers the 8x8 dot on the right edge */\n}\n\n/* DayGrid events\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-day-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-day-grid-event {\n  margin: 1px 5px 0;\n  /* spacing between events and edges */\n  padding: 0 1px;\n}\n\ntr:first-child > td > .fc-day-grid-event {\n  margin-top: 2px;\n  /* a little bit more space before the first event */\n}\n\n.fc-day-grid-event.fc-selected:after {\n\tcontent: \"\";\n\tposition: absolute;\n\tz-index: 1; /* same z-index as fc-bg, behind text */\n\t/* overcome the borders */\n\ttop: -1px;\n\tright: -1px;\n\tbottom: -1px;\n\tleft: -1px;\n\t/* darkening effect */\n\tbackground: #000;\n\topacity: .25;\n}\n\n\n.fc-day-grid-event .fc-content { /* force events to be one-line tall */\n\twhite-space: nowrap;\n\toverflow: hidden;\n  color: $white;\n  padding: 0 5px;\n}\n\n.fc-day-grid-event .fc-time {\n\tfont-weight: bold;\n}\n\n/* resizer (cursor devices) */\n\n/* left resizer  */\n.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,\n.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer {\n\tmargin-left: -2px; /* to the day cell's edge */\n}\n\n/* right resizer */\n.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,\n.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer {\n\tmargin-right: -2px; /* to the day cell's edge */\n}\n\n.fc-mirror-skeleton tr:first-child > td > .fc-day-grid-event {\n  margin-top: 0;\n  /* except for mirror skeleton */\n}\n\n.fc-day-grid-event .fc-content {\n  /* force events to be one-line tall */\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.fc-day-grid-event .fc-time {\n  font-weight: bold;\n}\n\n/* resizer (cursor devices) */\n/* left resizer  */\n.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,\n.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer {\n  margin-left: -2px;\n  /* to the day cell's edge */\n}\n\n/* right resizer */\n.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,\n.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer {\n  margin-right: -2px;\n  /* to the day cell's edge */\n}\n\n/* Event Limiting\n--------------------------------------------------------------------------------------------------*/\n/* \"more\" link that represents hidden events */\na.fc-more {\n  margin: 1px 3px;\n  font-size: 0.85em;\n  cursor: pointer;\n  text-decoration: none;\n}\n\na.fc-more:hover {\n  text-decoration: underline;\n}\n\n.fc-limited {\n  /* rows and cells that are hidden because of a \"more\" link */\n  display: none;\n}\n\n/* popover that appears when \"more\" link is clicked */\n.fc-day-grid .fc-row {\n  z-index: 1;\n  /* make the \"more\" popover one higher than this */\n}\n\n.fc-more-popover {\n  z-index: 2;\n  width: 220px;\n}\n\n.fc-more-popover .fc-event-container {\n  padding: 10px;\n}\n\n/* Now Indicator\n--------------------------------------------------------------------------------------------------*/\n.fc-now-indicator {\n  position: absolute;\n  border: 0 solid red;\n}\n\n/* Utilities\n--------------------------------------------------------------------------------------------------*/\n.fc-unselectable {\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n/*\nTODO: more distinction between this file and common.css\n*/\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-content,\n.fc-unthemed .fc-popover,\n.fc-unthemed .fc-list-view,\n.fc-unthemed .fc-list-heading td {\n  border-color: lighten($black, 5%);\n}\n\n.fc-unthemed .fc-popover {\n  background-color: $white;\n}\n\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-popover .fc-header,\n.fc-unthemed .fc-list-heading td {\n  background: #eee;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tcolor: $link-disabled;\n}\n\n.fc-unthemed td.fc-today {\n  background: lighten($black, 2%);\n  color: $white;\n}\n\n.fc-unthemed .fc-disabled-day {\n  background: #d7d7d7;\n  opacity: 0.3;\n}\n\n/* Icons\n--------------------------------------------------------------------------------------------------\nfrom https://feathericons.com/ and built with IcoMoon\n*/\n@font-face {\n  font-family: \"fcicons\";\n  src: url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n.fc-icon {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"fcicons\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.fc-icon-chevron-left:before {\n  content: \"\";\n}\n\n.fc-icon-chevron-right:before {\n  content: \"\";\n}\n\n.fc-icon-chevrons-left:before {\n  content: \"\";\n}\n\n.fc-icon-chevrons-right:before {\n  content: \"\";\n}\n\n.fc-icon-minus-square:before {\n  content: \"\";\n}\n\n.fc-icon-plus-square:before {\n  content: \"\";\n}\n\n.fc-icon-x:before {\n  content: \"\";\n}\n\n.fc-icon {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  text-align: center;\n}\n\n/* Buttons\n--------------------------------------------------------------------------------------------------\nLots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css\n*/\n/* reset */\n.fc-button {\n  border-width: $border-thick;\n  font-weight: $font-weight-normal;\n  font-size: $font-size-sm;\n  color: $white;\n  line-height: $line-height;\n  margin: 5px 1px;\n  border: none;\n  margin:10px 1px;\n  border-radius: $border-radius-sm;\n  padding: 8px 20px;\n  cursor: pointer;\n  -webkit-transition: all .2s ease-in-out;\n  -o-transition: all .2s ease-in-out;\n  transition: all .2s ease-in-out;\n\toutline: none;\n\n  &::-moz-focus-inner {\n  border: 0;\n  }\n\n  &,\n  &.btn-primary{\n      @include btn-styles($primary, $primary-states);\n  }\n\n  .fc button[disabled],\n  .fc button[disabled]:focus,\n  .fc button[disabled]:hover{\n      cursor: default;\n  \topacity: .5;\n  \tpointer-events: none;\n  \t// @include shadow-2dp-color($gray-light);\n\n  }\n\n}\n\n.fc-button:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\n.fc-button {\n  -webkit-appearance: button;\n}\n\n.fc-button:not(:disabled) {\n  cursor: pointer;\n}\n\n.fc-button::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n\n.fc-state-hover,\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n\tcolor: #333333;\n\tbackground-color: #e6e6e6;\n}\n\n.fc-state-hover {\n\tcolor: #333333;\n\ttext-decoration: none;\n\tbackground-position: 0 -15px;\n\t-webkit-transition: background-position 0.1s linear;\n\t   -moz-transition: background-position 0.1s linear;\n\t     -o-transition: background-position 0.1s linear;\n\t        transition: background-position 0.1s linear;\n}\n\n.fc-state-down,\n.fc-state-active {\n\tbackground-color: #cccccc;\n\tbackground-image: none;\n}\n\n.fc-state-disabled {\n\tcursor: default;\n\tbackground-image: none;\n\topacity: 0.65;\n\tbox-shadow: none;\n}\n\n\n/* theme */\n\n.fc-button:focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);\n  box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);\n}\n\n.fc-button:disabled {\n  opacity: 0.65;\n}\n\n.fc-head-container,\n.fc-day-header {\n  border: 0 !important;\n  text-align: right !important;\n}\n\n.card-calendar .fc .fc-day-header:last-child {\n  padding-right: 15px;\n}\n\ntbody.fc-body tr >.fc-widget-content {\n  border-left: 0 !important;\n  border-bottom: 0 !important;\n}\n\n.card-calendar .fc td:last-child {\n  border-right: 0 !important;\n}\n\n.fc .fc-button-group>* {\n  float: left;\n  margin: 0 0 0 2px;\n}\n\ntr:first-child>td>.fc-day-grid-event {\n  margin-top: 2px;\n}\n\n.card-calendar table td {\n  text-align: right;\n}\n\n/* icons within buttons */\n.fc-button .fc-icon {\n  vertical-align: middle;\n  font-size: 1.5em;\n}\n\n/* Buttons Groups\n--------------------------------------------------------------------------------------------------*/\n.fc-button-group {\n  display: inline-block;\n\t.fc-prev-button,\n  .fc-next-button {\n    opacity: .7;\n    color: $white;\n    padding: 7px 20px;\n\t\tbackground: $transparent-bg;\n\t\tborder: 1px solid lighten($black,5%);\n\t\t&:hover, &:focus, &:active:hover {\n\t\t\tbackground-color: $transparent-bg !important;\n\t\t\tbackground-image: none !important;\n      opacity: 1;\n\t\t}\n\t}\n}\n\n\n.fc-button-group > .fc-button {\n  position: relative;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n\n.fc-button-group > .fc-button:hover {\n  z-index: 1;\n}\n.fc-button-group .fc-button {\n  border-radius: .2857rem !important;\n  opacity: .5 !important;\n\n  &.fc-button-active,\n  &:hover {\n    opacity: 1 !important;\n  }\n}\n\n.fc-button-group > .fc-button:focus,\n.fc-button-group > .fc-button:active,\n.fc-button-group > .fc-button.fc-button-active {\n  z-index: 1;\n}\n\n.fc-button-group > .fc-button:not(:first-child) {\n  margin: 0 0 0 2px;\n}\n\n.fc-button-group > .fc-button:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.fc-button-group > .fc-button:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed .fc-popover {\n  position: absolute;\n  box-shadow: 0 2px 6px rgba(0,0,0,.15);\n}\n\n/* List View\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed .fc-list-item:hover td {\n  background-color: #f5f5f5;\n}\n\n/* Toolbar\n--------------------------------------------------------------------------------------------------*/\n.fc-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: .8em;\n}\n\n.fc-toolbar.fc-footer-toolbar {\n  margin-top: 1.5em;\n}\n\n/* inner content */\n.fc-toolbar > * > :not(:first-child) {\n  margin-left: 0.75em;\n}\n\n.fc-toolbar h2 {\n  margin: 0;\n  margin-bottom: 10px;\n  font-size: 1.8em;\n}\n\n/* View Structure\n--------------------------------------------------------------------------------------------------*/\n.fc-view-container {\n  position: relative;\n}\n\n/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */\n/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */\n.fc-view-container *,\n.fc-view-container *:before,\n.fc-view-container *:after {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.fc-view,\n.fc-view > table {\n  /* so dragged elements can be above the view's main element */\n  position: relative;\n  z-index: 1;\n}\n\n@media print {\n  .fc {\n    max-width: 100% !important;\n  }\n\n  /* Global Event Restyling\n  --------------------------------------------------------------------------------------------------*/\n  .fc-event {\n    background: #fff !important;\n    color: #000 !important;\n    page-break-inside: avoid;\n  }\n\n  .fc-event .fc-resizer {\n    display: none;\n  }\n\n  /* Table & Day-Row Restyling\n  --------------------------------------------------------------------------------------------------*/\n.fc th,\n.fc td,\n.fc hr,\n.fc thead,\n.fc tbody,\n.fc-row {\n    border-color: #ccc !important;\n    background: #fff !important;\n  }\n\n  /* kill the overlaid, absolutely-positioned components */\n  /* common... */\n  .fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-mirror-skeleton,\n.fc-bgevent-container,\n.fc-business-container,\n.fc-highlight-container,\n.fc-mirror-container {\n    display: none;\n  }\n\n  /* don't force a min-height on rows (for DayGrid) */\n  .fc tbody .fc-row {\n    height: auto !important;\n    /* undo height that JS set in distributeHeight */\n    min-height: 0 !important;\n    /* undo the min-height from each view's specific stylesheet */\n  }\n\n  .fc tbody .fc-row .fc-content-skeleton {\n    position: static;\n    /* undo .fc-rigid */\n    padding-bottom: 0 !important;\n    /* use a more border-friendly method for this... */\n  }\n\n  .fc tbody .fc-row .fc-content-skeleton tbody tr:last-child td {\n    /* only works in newer browsers */\n    padding-bottom: 1em;\n    /* ...gives space within the skeleton. also ensures min height in a way */\n  }\n\n  .fc tbody .fc-row .fc-content-skeleton table {\n    /* provides a min-height for the row, but only effective for IE, which exaggerates this value,\n       making it look more like 3em. for other browers, it will already be this tall */\n    height: 1em;\n  }\n\n  /* Undo month-view event limiting. Display all events and hide the \"more\" links\n  --------------------------------------------------------------------------------------------------*/\n  .fc-more-cell,\n.fc-more {\n    display: none !important;\n  }\n\n  .fc tr.fc-limited {\n    display: table-row !important;\n  }\n\n  .fc td.fc-limited {\n    display: table-cell !important;\n  }\n\n  .fc-popover {\n    display: none;\n    /* never display the \"more..\" popover in print mode */\n  }\n\n  /* TimeGrid Restyling\n  --------------------------------------------------------------------------------------------------*/\n  /* undo the min-height 100% trick used to fill the container's height */\n  .fc-time-grid {\n    min-height: 0 !important;\n  }\n\n  /* don't display the side axis at all (\"all-day\" and time cells) */\n  .fc-timeGrid-view .fc-axis {\n    display: none;\n  }\n\n  /* don't display the horizontal lines */\n  .fc-slats,\n.fc-time-grid hr {\n    /* this hr is used when height is underused and needs to be filled */\n    display: none !important;\n    /* important overrides inline declaration */\n  }\n\n  /* let the container that holds the events be naturally positioned and create real height */\n  .fc-time-grid .fc-content-skeleton {\n    position: static;\n  }\n\n  /* in case there are no events, we still want some height */\n  .fc-time-grid .fc-content-skeleton table {\n    height: 4em;\n  }\n\n  /* kill the horizontal spacing made by the event container. event margins will be done below */\n  .fc-time-grid .fc-event-container {\n    margin: 0 !important;\n  }\n\n  /* TimeGrid *Event* Restyling\n  --------------------------------------------------------------------------------------------------*/\n  /* naturally position events, vertically stacking them */\n  .fc-time-grid .fc-event {\n    position: static !important;\n    margin: 3px 2px !important;\n  }\n\n  /* for events that continue to a future day, give the bottom border back */\n  .fc-time-grid .fc-event.fc-not-end {\n    border-bottom-width: 1px !important;\n  }\n\n  /* indicate the event continues via \"...\" text */\n  .fc-time-grid .fc-event.fc-not-end:after {\n    content: \"...\";\n  }\n\n  /* for events that are continuations from previous days, give the top border back */\n  .fc-time-grid .fc-event.fc-not-start {\n    border-top-width: 1px !important;\n  }\n\n  /* indicate the event is a continuation via \"...\" text */\n  .fc-time-grid .fc-event.fc-not-start:before {\n    content: \"...\";\n  }\n\n  /* time */\n  /* undo a previous declaration and let the time text span to a second line */\n  .fc-time-grid .fc-event .fc-time {\n    white-space: normal !important;\n  }\n\n  /* hide the the time that is normally displayed... */\n  .fc-time-grid .fc-event .fc-time span {\n    display: none;\n  }\n\n  /* ...replace it with a more verbose version (includes AM/PM) stored in an html attribute */\n  .fc-time-grid .fc-event .fc-time:after {\n    content: attr(data-full);\n  }\n\n  /* Vertical Scroller & Containers\n  --------------------------------------------------------------------------------------------------*/\n  /* kill the scrollbars and allow natural height */\n  .fc-scroller,\n.fc-day-grid-container,\n.fc-time-grid-container {\n    /* */\n    overflow: visible !important;\n    height: auto !important;\n  }\n\n  /* kill the horizontal border/padding used to compensate for scrollbars */\n  .fc-row {\n    border: 0 !important;\n    margin: 0 !important;\n  }\n\n  /* Button Controls\n  --------------------------------------------------------------------------------------------------*/\n  .fc-button-group,\n.fc button {\n    display: none;\n    /* don't display any button-related controls */\n  }\n}\n\n.fc-day-header span {\n  color: hsla(0,0%,100%,.4);\n}\n.fc-day-top .fc-day-number {\n  color: $white;\n}\n\n// dayGridPlugin\n\n/* DayGridView\n--------------------------------------------------------------------------------------------------*/\n/* day row structure */\n.fc-dayGridWeek-view .fc-content-skeleton,\n.fc-dayGridDay-view .fc-content-skeleton {\n  /* there may be week numbers in these views, so no padding-top */\n  padding-bottom: 1em;\n  /* ensure a space at bottom of cell for user selecting/clicking */\n}\n\n.fc-dayGrid-view .fc-body .fc-row {\n  min-height: 4em;\n  /* ensure that all rows are at least this tall */\n}\n\n/* a \"rigid\" row will take up a constant amount of height because content-skeleton is absolute */\n.fc-row.fc-rigid {\n  overflow: hidden;\n}\n\n.fc-row.fc-rigid .fc-content-skeleton {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n/* week and day number styling */\n.fc-day-top.fc-other-month {\n  opacity: 0.3;\n}\n\n.fc-dayGrid-view .fc-week-number,\n.fc-dayGrid-view .fc-day-number {\n  padding: 2px;\n}\n\n.fc-dayGrid-view th.fc-week-number,\n.fc-dayGrid-view th.fc-day-number {\n  padding: 0 2px;\n  /* column headers can't have as much v space */\n}\n\n.fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {\n  float: right;\n}\n\n.fc-rtl .fc-dayGrid-view .fc-day-top .fc-day-number {\n  float: left;\n}\n\n.fc-ltr .fc-dayGrid-view .fc-day-top .fc-week-number {\n  float: left;\n  border-radius: 0 0 3px 0;\n}\n\n.fc-rtl .fc-dayGrid-view .fc-day-top .fc-week-number {\n  float: right;\n  border-radius: 0 0 0 3px;\n}\n\n.fc-dayGrid-view .fc-day-top .fc-week-number {\n  min-width: 1.5em;\n  text-align: center;\n  background-color: #f2f2f2;\n  color: #808080;\n}\n\n/* when week/day number have own column */\n.fc-dayGrid-view td.fc-week-number {\n  text-align: center;\n}\n\n.fc-dayGrid-view td.fc-week-number > * {\n  /* work around the way we do column resizing and ensure a minimum width */\n  display: inline-block;\n  min-width: 1.25em;\n}\n\n/* TimeGridView all-day area\n--------------------------------------------------------------------------------------------------*/\n.fc-timeGrid-view .fc-day-grid {\n  position: relative;\n  z-index: 2;\n  /* so the \"more..\" popover will be over the time grid */\n}\n\n.fc-timeGrid-view .fc-day-grid .fc-row {\n  min-height: 3em;\n  /* all-day section will never get shorter than this */\n}\n\n.fc-timeGrid-view .fc-day-grid .fc-row .fc-content-skeleton {\n  padding-bottom: 1em;\n  /* give space underneath events for clicking/selecting days */\n}\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-axis {\n  /* .fc to overcome default cell styles */\n  vertical-align: middle;\n  padding: 0 4px;\n  white-space: nowrap;\n}\n\n.fc-ltr .fc-axis {\n  text-align: right;\n}\n\n.fc-rtl .fc-axis {\n  text-align: left;\n}\n\n/* TimeGrid Structure\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid-container,\n.fc-time-grid {\n  /* so slats/bg/content/etc positions get scoped within here */\n  position: relative;\n  z-index: 1;\n}\n\n.fc-time-grid {\n  min-height: 100%;\n  /* so if height setting is 'auto', .fc-bg stretches to fill height */\n}\n\n.fc-time-grid table {\n  /* don't put outer borders on slats/bg/content/etc */\n  border: 0 hidden transparent;\n}\n\n.fc-time-grid > .fc-bg {\n  z-index: 1;\n}\n\n.fc-time-grid .fc-slats,\n.fc-time-grid > hr {\n  /* the <hr> TimeGridView injects when grid is shorter than scroller */\n  position: relative;\n  z-index: 2;\n}\n\n.fc-time-grid .fc-content-col {\n  position: relative;\n  /* because now-indicator lives directly inside */\n}\n\n.fc-time-grid .fc-content-skeleton {\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n/* divs within a cell within the fc-content-skeleton */\n.fc-time-grid .fc-business-container {\n  position: relative;\n  z-index: 1;\n}\n\n.fc-time-grid .fc-bgevent-container {\n  position: relative;\n  z-index: 2;\n}\n\n.fc-time-grid .fc-highlight-container {\n  position: relative;\n  z-index: 3;\n}\n\n.fc-time-grid .fc-event-container {\n  position: relative;\n  z-index: 4;\n}\n\n.fc-time-grid .fc-now-indicator-line {\n  z-index: 5;\n}\n\n.fc-time-grid .fc-mirror-container {\n  /* also is fc-event-container */\n  position: relative;\n  z-index: 6;\n}\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-slats td {\n  height: 1.5em;\n  border-bottom: 0;\n  /* each cell is responsible for its top border */\n}\n\n.fc-time-grid .fc-slats .fc-minor td {\n  border-top-style: dotted;\n}\n\n/* TimeGrid Highlighting Slots\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-highlight-container {\n  /* a div within a cell within the fc-highlight-skeleton */\n  position: relative;\n  /* scopes the left/right of the fc-highlight to be in the column */\n}\n\n.fc-time-grid .fc-highlight {\n  position: absolute;\n  left: 0;\n  right: 0;\n  /* top and bottom will be in by JS */\n}\n\n/* TimeGrid Event Containment\n--------------------------------------------------------------------------------------------------*/\n.fc-ltr .fc-time-grid .fc-event-container {\n  /* space on the sides of events for LTR (default) */\n  margin: 0 2.5% 0 2px;\n}\n\n.fc-rtl .fc-time-grid .fc-event-container {\n  /* space on the sides of events for RTL */\n  margin: 0 2px 0 2.5%;\n}\n\n.fc-time-grid .fc-event,\n.fc-time-grid .fc-bgevent {\n  position: absolute;\n  z-index: 1;\n  /* scope inner z-index's */\n}\n\n.fc-time-grid .fc-bgevent {\n  /* background events always span full width */\n  left: 0;\n  right: 0;\n}\n\n/* TimeGrid Event Styling\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-time-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-time-grid-event {\n  margin-bottom: 1px;\n}\n\n.fc-time-grid-event-inset {\n  -webkit-box-shadow: 0px 0px 0px 1px #fff;\n  box-shadow: 0px 0px 0px 1px #fff;\n}\n\n.fc-time-grid-event.fc-not-start {\n  /* events that are continuing from another day */\n  /* replace space made by the top border with padding */\n  border-top-width: 0;\n  padding-top: 1px;\n  /* remove top rounded corners */\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.fc-time-grid-event.fc-not-end {\n  /* replace space made by the top border with padding */\n  border-bottom-width: 0;\n  padding-bottom: 1px;\n  /* remove bottom rounded corners */\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.fc-time-grid-event .fc-content {\n  overflow: hidden;\n  max-height: 100%;\n}\n\n.fc-time-grid-event .fc-time,\n.fc-time-grid-event .fc-title {\n  padding: 0 1px;\n}\n\n.fc-time-grid-event .fc-time {\n  font-size: 0.85em;\n  white-space: nowrap;\n}\n\n/* short mode, where time and title are on the same line */\n.fc-time-grid-event.fc-short .fc-content {\n  /* don't wrap to second line (now that contents will be inline) */\n  white-space: nowrap;\n}\n\n.fc-time-grid-event.fc-short .fc-time,\n.fc-time-grid-event.fc-short .fc-title {\n  /* put the time and title on the same line */\n  display: inline-block;\n  vertical-align: top;\n}\n\n.fc-time-grid-event.fc-short .fc-time span {\n  display: none;\n  /* don't display the full time text... */\n}\n\n.fc-time-grid-event.fc-short .fc-time:before {\n  content: attr(data-start);\n  /* ...instead, display only the start time */\n}\n\n.fc-time-grid-event.fc-short .fc-time:after {\n  content: \" - \";\n  /* seperate with a dash, wrapped in nbsp's */\n}\n\n.fc-time-grid-event.fc-short .fc-title {\n  font-size: 0.85em;\n  /* make the title text the same size as the time */\n  padding: 0;\n  /* undo padding from above */\n}\n\n/* resizer (cursor device) */\n.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer {\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 8px;\n  overflow: hidden;\n  line-height: 8px;\n  font-size: 11px;\n  font-family: monospace;\n  text-align: center;\n  cursor: s-resize;\n}\n\n.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after {\n  content: \"=\";\n}\n\n/* resizer (touch device) */\n.fc-time-grid-event.fc-selected .fc-resizer {\n  /* 10x10 dot */\n  border-radius: 5px;\n  border-width: 1px;\n  width: 8px;\n  height: 8px;\n  border-style: solid;\n  border-color: inherit;\n  background: #fff;\n  /* horizontally center */\n  left: 50%;\n  margin-left: -5px;\n  /* center on the bottom edge */\n  bottom: -5px;\n}\n\n/* Now Indicator\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-now-indicator-line {\n  border-top-width: 1px;\n  left: 0;\n  right: 0;\n}\n\n/* arrow on axis */\n.fc-time-grid .fc-now-indicator-arrow {\n  margin-top: -5px;\n  /* vertically center on top coordinate */\n}\n\n.fc-ltr .fc-time-grid .fc-now-indicator-arrow {\n  left: 0;\n  /* triangle pointing right... */\n  border-width: 5px 0 5px 6px;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n\n.fc-rtl .fc-time-grid .fc-now-indicator-arrow {\n  right: 0;\n  /* triangle pointing left... */\n  border-width: 5px 6px 5px 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n","@charset \"UTF-8\";\n@-webkit-keyframes swal2-show {\n  0% {\n    transform: scale(0.7);\n  }\n  45% {\n    transform: scale(1.05);\n  }\n  80% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes swal2-show {\n  0% {\n    transform: scale(0.7);\n  }\n  45% {\n    transform: scale(1.05);\n  }\n  80% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@-webkit-keyframes swal2-hide {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n}\n@keyframes swal2-hide {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n}\n@-webkit-keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: 0.0625em;\n    width: 0;\n  }\n  54% {\n    top: 1.0625em;\n    left: 0.125em;\n    width: 0;\n  }\n  70% {\n    top: 2.1875em;\n    left: -0.375em;\n    width: 3.125em;\n  }\n  84% {\n    top: 3em;\n    left: 1.3125em;\n    width: 1.0625em;\n  }\n  100% {\n    top: 2.8125em;\n    left: 0.875em;\n    width: 1.5625em;\n  }\n}\n@keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: 0.0625em;\n    width: 0;\n  }\n  54% {\n    top: 1.0625em;\n    left: 0.125em;\n    width: 0;\n  }\n  70% {\n    top: 2.1875em;\n    left: -0.375em;\n    width: 3.125em;\n  }\n  84% {\n    top: 3em;\n    left: 1.3125em;\n    width: 1.0625em;\n  }\n  100% {\n    top: 2.8125em;\n    left: 0.875em;\n    width: 1.5625em;\n  }\n}\n@-webkit-keyframes swal2-animate-success-line-long {\n  0% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n  65% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n  84% {\n    top: 2.1875em;\n    right: 0;\n    width: 3.4375em;\n  }\n  100% {\n    top: 2.375em;\n    right: 0.5em;\n    width: 2.9375em;\n  }\n}\n@keyframes swal2-animate-success-line-long {\n  0% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n  65% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n  84% {\n    top: 2.1875em;\n    right: 0;\n    width: 3.4375em;\n  }\n  100% {\n    top: 2.375em;\n    right: 0.5em;\n    width: 2.9375em;\n  }\n}\n@-webkit-keyframes swal2-rotate-success-circular-line {\n  0% {\n    transform: rotate(-45deg);\n  }\n  5% {\n    transform: rotate(-45deg);\n  }\n  12% {\n    transform: rotate(-405deg);\n  }\n  100% {\n    transform: rotate(-405deg);\n  }\n}\n@keyframes swal2-rotate-success-circular-line {\n  0% {\n    transform: rotate(-45deg);\n  }\n  5% {\n    transform: rotate(-45deg);\n  }\n  12% {\n    transform: rotate(-405deg);\n  }\n  100% {\n    transform: rotate(-405deg);\n  }\n}\n@-webkit-keyframes swal2-animate-error-x-mark {\n  0% {\n    margin-top: 1.625em;\n    transform: scale(0.4);\n    opacity: 0;\n  }\n  50% {\n    margin-top: 1.625em;\n    transform: scale(0.4);\n    opacity: 0;\n  }\n  80% {\n    margin-top: -0.375em;\n    transform: scale(1.15);\n  }\n  100% {\n    margin-top: 0;\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes swal2-animate-error-x-mark {\n  0% {\n    margin-top: 1.625em;\n    transform: scale(0.4);\n    opacity: 0;\n  }\n  50% {\n    margin-top: 1.625em;\n    transform: scale(0.4);\n    opacity: 0;\n  }\n  80% {\n    margin-top: -0.375em;\n    transform: scale(1.15);\n  }\n  100% {\n    margin-top: 0;\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes swal2-animate-error-icon {\n  0% {\n    transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n@keyframes swal2-animate-error-icon {\n  0% {\n    transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\nbody.swal2-toast-shown .swal2-container {\n  background-color: transparent;\n}\nbody.swal2-toast-shown .swal2-container.swal2-shown {\n  background-color: transparent;\n}\nbody.swal2-toast-shown .swal2-container.swal2-top {\n  top: 0;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  transform: translateX(-50%);\n}\nbody.swal2-toast-shown .swal2-container.swal2-top-end, body.swal2-toast-shown .swal2-container.swal2-top-right {\n  top: 0;\n  right: 0;\n  bottom: auto;\n  left: auto;\n}\nbody.swal2-toast-shown .swal2-container.swal2-top-start, body.swal2-toast-shown .swal2-container.swal2-top-left {\n  top: 0;\n  right: auto;\n  bottom: auto;\n  left: 0;\n}\nbody.swal2-toast-shown .swal2-container.swal2-center-start, body.swal2-toast-shown .swal2-container.swal2-center-left {\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 0;\n  transform: translateY(-50%);\n}\nbody.swal2-toast-shown .swal2-container.swal2-center {\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\nbody.swal2-toast-shown .swal2-container.swal2-center-end, body.swal2-toast-shown .swal2-container.swal2-center-right {\n  top: 50%;\n  right: 0;\n  bottom: auto;\n  left: auto;\n  transform: translateY(-50%);\n}\nbody.swal2-toast-shown .swal2-container.swal2-bottom-start, body.swal2-toast-shown .swal2-container.swal2-bottom-left {\n  top: auto;\n  right: auto;\n  bottom: 0;\n  left: 0;\n}\nbody.swal2-toast-shown .swal2-container.swal2-bottom {\n  top: auto;\n  right: auto;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\nbody.swal2-toast-shown .swal2-container.swal2-bottom-end, body.swal2-toast-shown .swal2-container.swal2-bottom-right {\n  top: auto;\n  right: 0;\n  bottom: 0;\n  left: auto;\n}\nbody.swal2-toast-column .swal2-toast {\n  flex-direction: column;\n  align-items: stretch;\n}\nbody.swal2-toast-column .swal2-toast .swal2-actions {\n  flex: 1;\n  align-self: stretch;\n  height: 2.2em;\n  margin-top: 0.3125em;\n}\nbody.swal2-toast-column .swal2-toast .swal2-loading {\n  justify-content: center;\n}\nbody.swal2-toast-column .swal2-toast .swal2-input {\n  height: 2em;\n  margin: 0.3125em auto;\n  font-size: 1em;\n}\nbody.swal2-toast-column .swal2-toast .swal2-validation-message {\n  font-size: 1em;\n}\n\n.swal2-popup.swal2-toast {\n  flex-direction: row;\n  align-items: center;\n  width: auto;\n  padding: 0.625em;\n  overflow-y: hidden;\n  box-shadow: 0 0 0.625em #d9d9d9;\n}\n.swal2-popup.swal2-toast .swal2-header {\n  flex-direction: row;\n}\n.swal2-popup.swal2-toast .swal2-title {\n  flex-grow: 1;\n  justify-content: flex-start;\n  margin: 0 0.6em;\n  font-size: 1em;\n}\n.swal2-popup.swal2-toast .swal2-footer {\n  margin: 0.5em 0 0;\n  padding: 0.5em 0 0;\n  font-size: 0.8em;\n}\n.swal2-popup.swal2-toast .swal2-close {\n  position: static;\n  width: 0.8em;\n  height: 0.8em;\n  line-height: 0.8;\n}\n.swal2-popup.swal2-toast .swal2-content {\n  justify-content: flex-start;\n  font-size: 1em;\n}\n.swal2-popup.swal2-toast .swal2-icon {\n  width: 2em;\n  min-width: 2em;\n  height: 2em;\n  margin: 0;\n}\n.swal2-popup.swal2-toast .swal2-icon::before {\n  display: flex;\n  align-items: center;\n  font-size: 2em;\n  font-weight: bold;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .swal2-popup.swal2-toast .swal2-icon::before {\n    font-size: 0.25em;\n  }\n}\n.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {\n  width: 2em;\n  height: 2em;\n}\n.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line] {\n  top: 0.875em;\n  width: 1.375em;\n}\n.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left] {\n  left: 0.3125em;\n}\n.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right] {\n  right: 0.3125em;\n}\n.swal2-popup.swal2-toast .swal2-actions {\n  flex-basis: auto !important;\n  width: auto;\n  height: auto;\n  margin: 0 0.3125em;\n}\n.swal2-popup.swal2-toast .swal2-styled {\n  margin: 0 0.3125em;\n  padding: 0.3125em 0.625em;\n  font-size: 1em;\n}\n.swal2-popup.swal2-toast .swal2-styled:focus {\n  box-shadow: 0 0 0 0.0625em #fff, 0 0 0 0.125em rgba(50, 100, 150, 0.4);\n}\n.swal2-popup.swal2-toast .swal2-success {\n  border-color: #a5dc86;\n}\n.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line] {\n  position: absolute;\n  width: 1.6em;\n  height: 3em;\n  transform: rotate(45deg);\n  border-radius: 50%;\n}\n.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left] {\n  top: -0.8em;\n  left: -0.5em;\n  transform: rotate(-45deg);\n  transform-origin: 2em 2em;\n  border-radius: 4em 0 0 4em;\n}\n.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right] {\n  top: -0.25em;\n  left: 0.9375em;\n  transform-origin: 0 1.5em;\n  border-radius: 0 4em 4em 0;\n}\n.swal2-popup.swal2-toast .swal2-success .swal2-success-ring {\n  width: 2em;\n  height: 2em;\n}\n.swal2-popup.swal2-toast .swal2-success .swal2-success-fix {\n  top: 0;\n  left: 0.4375em;\n  width: 0.4375em;\n  height: 2.6875em;\n}\n.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line] {\n  height: 0.3125em;\n}\n.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip] {\n  top: 1.125em;\n  left: 0.1875em;\n  width: 0.75em;\n}\n.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long] {\n  top: 0.9375em;\n  right: 0.1875em;\n  width: 1.375em;\n}\n.swal2-popup.swal2-toast.swal2-show {\n  -webkit-animation: swal2-toast-show 0.5s;\n          animation: swal2-toast-show 0.5s;\n}\n.swal2-popup.swal2-toast.swal2-hide {\n  -webkit-animation: swal2-toast-hide 0.1s forwards;\n          animation: swal2-toast-hide 0.1s forwards;\n}\n.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-tip {\n  -webkit-animation: swal2-toast-animate-success-line-tip 0.75s;\n          animation: swal2-toast-animate-success-line-tip 0.75s;\n}\n.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-long {\n  -webkit-animation: swal2-toast-animate-success-line-long 0.75s;\n          animation: swal2-toast-animate-success-line-long 0.75s;\n}\n\n@-webkit-keyframes swal2-toast-show {\n  0% {\n    transform: translateY(-0.625em) rotateZ(2deg);\n  }\n  33% {\n    transform: translateY(0) rotateZ(-2deg);\n  }\n  66% {\n    transform: translateY(0.3125em) rotateZ(2deg);\n  }\n  100% {\n    transform: translateY(0) rotateZ(0deg);\n  }\n}\n\n@keyframes swal2-toast-show {\n  0% {\n    transform: translateY(-0.625em) rotateZ(2deg);\n  }\n  33% {\n    transform: translateY(0) rotateZ(-2deg);\n  }\n  66% {\n    transform: translateY(0.3125em) rotateZ(2deg);\n  }\n  100% {\n    transform: translateY(0) rotateZ(0deg);\n  }\n}\n@-webkit-keyframes swal2-toast-hide {\n  100% {\n    transform: rotateZ(1deg);\n    opacity: 0;\n  }\n}\n@keyframes swal2-toast-hide {\n  100% {\n    transform: rotateZ(1deg);\n    opacity: 0;\n  }\n}\n@-webkit-keyframes swal2-toast-animate-success-line-tip {\n  0% {\n    top: 0.5625em;\n    left: 0.0625em;\n    width: 0;\n  }\n  54% {\n    top: 0.125em;\n    left: 0.125em;\n    width: 0;\n  }\n  70% {\n    top: 0.625em;\n    left: -0.25em;\n    width: 1.625em;\n  }\n  84% {\n    top: 1.0625em;\n    left: 0.75em;\n    width: 0.5em;\n  }\n  100% {\n    top: 1.125em;\n    left: 0.1875em;\n    width: 0.75em;\n  }\n}\n@keyframes swal2-toast-animate-success-line-tip {\n  0% {\n    top: 0.5625em;\n    left: 0.0625em;\n    width: 0;\n  }\n  54% {\n    top: 0.125em;\n    left: 0.125em;\n    width: 0;\n  }\n  70% {\n    top: 0.625em;\n    left: -0.25em;\n    width: 1.625em;\n  }\n  84% {\n    top: 1.0625em;\n    left: 0.75em;\n    width: 0.5em;\n  }\n  100% {\n    top: 1.125em;\n    left: 0.1875em;\n    width: 0.75em;\n  }\n}\n@-webkit-keyframes swal2-toast-animate-success-line-long {\n  0% {\n    top: 1.625em;\n    right: 1.375em;\n    width: 0;\n  }\n  65% {\n    top: 1.25em;\n    right: 0.9375em;\n    width: 0;\n  }\n  84% {\n    top: 0.9375em;\n    right: 0;\n    width: 1.125em;\n  }\n  100% {\n    top: 0.9375em;\n    right: 0.1875em;\n    width: 1.375em;\n  }\n}\n@keyframes swal2-toast-animate-success-line-long {\n  0% {\n    top: 1.625em;\n    right: 1.375em;\n    width: 0;\n  }\n  65% {\n    top: 1.25em;\n    right: 0.9375em;\n    width: 0;\n  }\n  84% {\n    top: 0.9375em;\n    right: 0;\n    width: 1.125em;\n  }\n  100% {\n    top: 0.9375em;\n    right: 0.1875em;\n    width: 1.375em;\n  }\n}\nbody.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {\n  overflow: hidden;\n}\nbody.swal2-height-auto {\n  height: auto !important;\n}\nbody.swal2-no-backdrop .swal2-shown {\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  max-width: calc(100% - 0.625em * 2);\n  background-color: transparent;\n}\nbody.swal2-no-backdrop .swal2-shown > .swal2-modal {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-top {\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-top-start, body.swal2-no-backdrop .swal2-shown.swal2-top-left {\n  top: 0;\n  left: 0;\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-top-end, body.swal2-no-backdrop .swal2-shown.swal2-top-right {\n  top: 0;\n  right: 0;\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-center {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-center-start, body.swal2-no-backdrop .swal2-shown.swal2-center-left {\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-center-end, body.swal2-no-backdrop .swal2-shown.swal2-center-right {\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-bottom {\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-bottom-start, body.swal2-no-backdrop .swal2-shown.swal2-bottom-left {\n  bottom: 0;\n  left: 0;\n}\nbody.swal2-no-backdrop .swal2-shown.swal2-bottom-end, body.swal2-no-backdrop .swal2-shown.swal2-bottom-right {\n  right: 0;\n  bottom: 0;\n}\n\n.swal2-container {\n  display: flex;\n  position: fixed;\n  z-index: 1060;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0.625em;\n  overflow-x: hidden;\n  background-color: transparent;\n  -webkit-overflow-scrolling: touch;\n}\n.swal2-container.swal2-top {\n  align-items: flex-start;\n}\n.swal2-container.swal2-top-start, .swal2-container.swal2-top-left {\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.swal2-container.swal2-top-end, .swal2-container.swal2-top-right {\n  align-items: flex-start;\n  justify-content: flex-end;\n}\n.swal2-container.swal2-center {\n  align-items: center;\n}\n.swal2-container.swal2-center-start, .swal2-container.swal2-center-left {\n  align-items: center;\n  justify-content: flex-start;\n}\n.swal2-container.swal2-center-end, .swal2-container.swal2-center-right {\n  align-items: center;\n  justify-content: flex-end;\n}\n.swal2-container.swal2-bottom {\n  align-items: flex-end;\n}\n.swal2-container.swal2-bottom-start, .swal2-container.swal2-bottom-left {\n  align-items: flex-end;\n  justify-content: flex-start;\n}\n.swal2-container.swal2-bottom-end, .swal2-container.swal2-bottom-right {\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n.swal2-container.swal2-bottom > :first-child, .swal2-container.swal2-bottom-start > :first-child, .swal2-container.swal2-bottom-left > :first-child, .swal2-container.swal2-bottom-end > :first-child, .swal2-container.swal2-bottom-right > :first-child {\n  margin-top: auto;\n}\n.swal2-container.swal2-grow-fullscreen > .swal2-modal {\n  display: flex !important;\n  flex: 1;\n  align-self: stretch;\n  justify-content: center;\n}\n.swal2-container.swal2-grow-row > .swal2-modal {\n  display: flex !important;\n  flex: 1;\n  align-content: center;\n  justify-content: center;\n}\n.swal2-container.swal2-grow-column {\n  flex: 1;\n  flex-direction: column;\n}\n.swal2-container.swal2-grow-column.swal2-top, .swal2-container.swal2-grow-column.swal2-center, .swal2-container.swal2-grow-column.swal2-bottom {\n  align-items: center;\n}\n.swal2-container.swal2-grow-column.swal2-top-start, .swal2-container.swal2-grow-column.swal2-center-start, .swal2-container.swal2-grow-column.swal2-bottom-start, .swal2-container.swal2-grow-column.swal2-top-left, .swal2-container.swal2-grow-column.swal2-center-left, .swal2-container.swal2-grow-column.swal2-bottom-left {\n  align-items: flex-start;\n}\n.swal2-container.swal2-grow-column.swal2-top-end, .swal2-container.swal2-grow-column.swal2-center-end, .swal2-container.swal2-grow-column.swal2-bottom-end, .swal2-container.swal2-grow-column.swal2-top-right, .swal2-container.swal2-grow-column.swal2-center-right, .swal2-container.swal2-grow-column.swal2-bottom-right {\n  align-items: flex-end;\n}\n.swal2-container.swal2-grow-column > .swal2-modal {\n  display: flex !important;\n  flex: 1;\n  align-content: center;\n  justify-content: center;\n}\n.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen) > .swal2-modal {\n  margin: auto;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .swal2-container .swal2-modal {\n    margin: 0 !important;\n  }\n}\n.swal2-container.swal2-fade {\n  transition: background-color 0.1s;\n}\n.swal2-container.swal2-shown {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.swal2-popup {\n  display: none;\n  position: relative;\n  box-sizing: border-box;\n  flex-direction: column;\n  justify-content: center;\n  width: 32em;\n  max-width: 100%;\n  padding: 1.25em;\n  border: none;\n  border-radius: 0.3125em;\n  background: #fff;\n  font-family: inherit;\n  font-size: 1rem;\n}\n.swal2-popup:focus {\n  outline: none;\n}\n.swal2-popup.swal2-loading {\n  overflow-y: hidden;\n}\n\n.swal2-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.swal2-title {\n  position: relative;\n  max-width: 100%;\n  margin: 0 0 0.4em;\n  padding: 0;\n  color: #595959;\n  font-size: 1.875em;\n  font-weight: 600;\n  text-align: center;\n  text-transform: none;\n  word-wrap: break-word;\n}\n\n.swal2-actions {\n  display: flex;\n  z-index: 1;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 1.25em auto 0;\n}\n.swal2-actions:not(.swal2-loading) .swal2-styled[disabled] {\n  opacity: 0.4;\n}\n.swal2-actions:not(.swal2-loading) .swal2-styled:hover {\n  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));\n}\n.swal2-actions:not(.swal2-loading) .swal2-styled:active {\n  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));\n}\n.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {\n  box-sizing: border-box;\n  width: 2.5em;\n  height: 2.5em;\n  margin: 0.46875em;\n  padding: 0;\n  -webkit-animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n          animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n  border: 0.25em solid transparent;\n  border-radius: 100%;\n  border-color: transparent;\n  background-color: transparent !important;\n  color: transparent;\n  cursor: default;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.swal2-actions.swal2-loading .swal2-styled.swal2-cancel {\n  margin-right: 30px;\n  margin-left: 30px;\n}\n.swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm::after {\n  content: \"\";\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  margin-left: 5px;\n  -webkit-animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n          animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n  border: 3px solid #999999;\n  border-radius: 50%;\n  border-right-color: transparent;\n  box-shadow: 1px 1px 1px #fff;\n}\n\n.swal2-styled {\n  margin: 0.3125em;\n  padding: 0.625em 2em;\n  box-shadow: none;\n  font-weight: 500;\n}\n.swal2-styled:not([disabled]) {\n  cursor: pointer;\n}\n.swal2-styled.swal2-confirm {\n  border: 0;\n  border-radius: 0.25em;\n  background: initial;\n  background-color: #3085d6;\n  color: #fff;\n  font-size: 1.0625em;\n}\n.swal2-styled.swal2-cancel {\n  border: 0;\n  border-radius: 0.25em;\n  background: initial;\n  background-color: #aaa;\n  color: #fff;\n  font-size: 1.0625em;\n}\n.swal2-styled:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);\n}\n.swal2-styled::-moz-focus-inner {\n  border: 0;\n}\n\n.swal2-footer {\n  justify-content: center;\n  margin: 1.25em 0 0;\n  padding: 1em 0 0;\n  border-top: 1px solid #eee;\n  color: #545454;\n  font-size: 1em;\n}\n\n.swal2-image {\n  max-width: 100%;\n  margin: 1.25em auto;\n}\n\n.swal2-close {\n  position: absolute;\n  z-index: 2;\n  /* 1617 */\n  top: 0;\n  right: 0;\n  justify-content: center;\n  width: 1.2em;\n  height: 1.2em;\n  padding: 0;\n  overflow: hidden;\n  transition: color 0.1s ease-out;\n  border: none;\n  border-radius: 0;\n  outline: initial;\n  background: transparent;\n  color: #cccccc;\n  font-family: serif;\n  font-size: 2.5em;\n  line-height: 1.2;\n  cursor: pointer;\n}\n.swal2-close:hover {\n  transform: none;\n  background: transparent;\n  color: #f27474;\n}\n\n.swal2-content {\n  z-index: 1;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 1.125em;\n  font-weight: normal;\n  line-height: normal;\n  text-align: center;\n  word-wrap: break-word;\n}\n\n.swal2-input,\n.swal2-file,\n.swal2-textarea,\n.swal2-select,\n.swal2-radio,\n.swal2-checkbox {\n  margin: 1em auto;\n}\n\n.swal2-input,\n.swal2-file,\n.swal2-textarea {\n  box-sizing: border-box;\n  width: 100%;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  border: 1px solid #d9d9d9;\n  border-radius: 0.1875em;\n  background: inherit;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n  color: inherit;\n  font-size: 1.125em;\n}\n.swal2-input.swal2-inputerror,\n.swal2-file.swal2-inputerror,\n.swal2-textarea.swal2-inputerror {\n  border-color: #f27474 !important;\n  box-shadow: 0 0 2px #f27474 !important;\n}\n.swal2-input:focus,\n.swal2-file:focus,\n.swal2-textarea:focus {\n  border: 1px solid #b4dbed;\n  outline: none;\n  box-shadow: 0 0 3px #c4e6f5;\n}\n.swal2-input::-webkit-input-placeholder,\n.swal2-file::-webkit-input-placeholder,\n.swal2-textarea::-webkit-input-placeholder {\n  color: #cccccc;\n}\n.swal2-input::-moz-placeholder,\n.swal2-file::-moz-placeholder,\n.swal2-textarea::-moz-placeholder {\n  color: #cccccc;\n}\n.swal2-input:-ms-input-placeholder,\n.swal2-file:-ms-input-placeholder,\n.swal2-textarea:-ms-input-placeholder {\n  color: #cccccc;\n}\n.swal2-input::-ms-input-placeholder,\n.swal2-file::-ms-input-placeholder,\n.swal2-textarea::-ms-input-placeholder {\n  color: #cccccc;\n}\n.swal2-input::placeholder,\n.swal2-file::placeholder,\n.swal2-textarea::placeholder {\n  color: #cccccc;\n}\n\n.swal2-range {\n  margin: 1em auto;\n  background: inherit;\n}\n.swal2-range input {\n  width: 80%;\n}\n.swal2-range output {\n  width: 20%;\n  color: inherit;\n  font-weight: 600;\n  text-align: center;\n}\n.swal2-range input,\n.swal2-range output {\n  height: 2.625em;\n  padding: 0;\n  font-size: 1.125em;\n  line-height: 2.625em;\n}\n\n.swal2-input {\n  height: 2.625em;\n  padding: 0 0.75em;\n}\n.swal2-input[type=number] {\n  max-width: 10em;\n}\n\n.swal2-file {\n  background: inherit;\n  font-size: 1.125em;\n}\n\n.swal2-textarea {\n  height: 6.75em;\n  padding: 0.75em;\n}\n\n.swal2-select {\n  min-width: 50%;\n  max-width: 100%;\n  padding: 0.375em 0.625em;\n  background: inherit;\n  color: inherit;\n  font-size: 1.125em;\n}\n\n.swal2-radio,\n.swal2-checkbox {\n  align-items: center;\n  justify-content: center;\n  background: inherit;\n  color: inherit;\n}\n.swal2-radio label,\n.swal2-checkbox label {\n  margin: 0 0.6em;\n  font-size: 1.125em;\n}\n.swal2-radio input,\n.swal2-checkbox input {\n  margin: 0 0.4em;\n}\n\n.swal2-validation-message {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  padding: 0.625em;\n  overflow: hidden;\n  background: #f0f0f0;\n  color: #666666;\n  font-size: 1em;\n  font-weight: 300;\n}\n.swal2-validation-message::before {\n  content: \"!\";\n  display: inline-block;\n  width: 1.5em;\n  min-width: 1.5em;\n  height: 1.5em;\n  margin: 0 0.625em;\n  zoom: normal;\n  border-radius: 50%;\n  background-color: #f27474;\n  color: #fff;\n  font-weight: 600;\n  line-height: 1.5em;\n  text-align: center;\n}\n\n@supports (-ms-accelerator: true) {\n  .swal2-range input {\n    width: 100% !important;\n  }\n  .swal2-range output {\n    display: none;\n  }\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .swal2-range input {\n    width: 100% !important;\n  }\n  .swal2-range output {\n    display: none;\n  }\n}\n@-moz-document url-prefix() {\n  .swal2-close:focus {\n    outline: 2px solid rgba(50, 100, 150, 0.4);\n  }\n}\n.swal2-icon {\n  position: relative;\n  box-sizing: content-box;\n  justify-content: center;\n  width: 5em;\n  height: 5em;\n  margin: 1.25em auto 1.875em;\n  zoom: normal;\n  border: 0.25em solid transparent;\n  border-radius: 50%;\n  font-family: inherit;\n  line-height: 5em;\n  cursor: default;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.swal2-icon::before {\n  display: flex;\n  align-items: center;\n  height: 92%;\n  font-size: 3.75em;\n}\n.swal2-icon.swal2-error {\n  border-color: #f27474;\n}\n.swal2-icon.swal2-error .swal2-x-mark {\n  position: relative;\n  flex-grow: 1;\n}\n.swal2-icon.swal2-error [class^=swal2-x-mark-line] {\n  display: block;\n  position: absolute;\n  top: 2.3125em;\n  width: 2.9375em;\n  height: 0.3125em;\n  border-radius: 0.125em;\n  background-color: #f27474;\n}\n.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left] {\n  left: 1.0625em;\n  transform: rotate(45deg);\n}\n.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right] {\n  right: 1em;\n  transform: rotate(-45deg);\n}\n.swal2-icon.swal2-warning {\n  border-color: #facea8;\n  color: #f8bb86;\n}\n.swal2-icon.swal2-warning::before {\n  content: \"!\";\n}\n.swal2-icon.swal2-info {\n  border-color: #9de0f6;\n  color: #3fc3ee;\n}\n.swal2-icon.swal2-info::before {\n  content: \"i\";\n}\n.swal2-icon.swal2-question {\n  border-color: #c9dae1;\n  color: #87adbd;\n}\n.swal2-icon.swal2-question::before {\n  content: \"?\";\n}\n.swal2-icon.swal2-question.swal2-arabic-question-mark::before {\n  content: \"؟\";\n}\n.swal2-icon.swal2-success {\n  border-color: #a5dc86;\n}\n.swal2-icon.swal2-success [class^=swal2-success-circular-line] {\n  position: absolute;\n  width: 3.75em;\n  height: 7.5em;\n  transform: rotate(45deg);\n  border-radius: 50%;\n}\n.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left] {\n  top: -0.4375em;\n  left: -2.0635em;\n  transform: rotate(-45deg);\n  transform-origin: 3.75em 3.75em;\n  border-radius: 7.5em 0 0 7.5em;\n}\n.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right] {\n  top: -0.6875em;\n  left: 1.875em;\n  transform: rotate(-45deg);\n  transform-origin: 0 3.75em;\n  border-radius: 0 7.5em 7.5em 0;\n}\n.swal2-icon.swal2-success .swal2-success-ring {\n  position: absolute;\n  z-index: 2;\n  top: -0.25em;\n  left: -0.25em;\n  box-sizing: content-box;\n  width: 100%;\n  height: 100%;\n  border: 0.25em solid rgba(165, 220, 134, 0.3);\n  border-radius: 50%;\n}\n.swal2-icon.swal2-success .swal2-success-fix {\n  position: absolute;\n  z-index: 1;\n  top: 0.5em;\n  left: 1.625em;\n  width: 0.4375em;\n  height: 5.625em;\n  transform: rotate(-45deg);\n}\n.swal2-icon.swal2-success [class^=swal2-success-line] {\n  display: block;\n  position: absolute;\n  z-index: 2;\n  height: 0.3125em;\n  border-radius: 0.125em;\n  background-color: #a5dc86;\n}\n.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip] {\n  top: 2.875em;\n  left: 0.875em;\n  width: 1.5625em;\n  transform: rotate(45deg);\n}\n.swal2-icon.swal2-success [class^=swal2-success-line][class$=long] {\n  top: 2.375em;\n  right: 0.5em;\n  width: 2.9375em;\n  transform: rotate(-45deg);\n}\n\n.swal2-progress-steps {\n  align-items: center;\n  margin: 0 0 1.25em;\n  padding: 0;\n  background: inherit;\n  font-weight: 600;\n}\n.swal2-progress-steps li {\n  display: inline-block;\n  position: relative;\n}\n.swal2-progress-steps .swal2-progress-step {\n  z-index: 20;\n  width: 2em;\n  height: 2em;\n  border-radius: 2em;\n  background: #3085d6;\n  color: #fff;\n  line-height: 2em;\n  text-align: center;\n}\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {\n  background: #3085d6;\n}\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {\n  background: #add8e6;\n  color: #fff;\n}\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {\n  background: #add8e6;\n}\n.swal2-progress-steps .swal2-progress-step-line {\n  z-index: 10;\n  width: 2.5em;\n  height: 0.4em;\n  margin: 0 -1px;\n  background: #3085d6;\n}\n\n[class^=swal2] {\n  -webkit-tap-highlight-color: transparent;\n}\n\n.swal2-show {\n  -webkit-animation: swal2-show 0.3s;\n          animation: swal2-show 0.3s;\n}\n.swal2-show.swal2-noanimation {\n  -webkit-animation: none;\n          animation: none;\n}\n\n.swal2-hide {\n  -webkit-animation: swal2-hide 0.15s forwards;\n          animation: swal2-hide 0.15s forwards;\n}\n.swal2-hide.swal2-noanimation {\n  -webkit-animation: none;\n          animation: none;\n}\n\n.swal2-rtl .swal2-close {\n  right: auto;\n  left: 0;\n}\n\n.swal2-animate-success-icon .swal2-success-line-tip {\n  -webkit-animation: swal2-animate-success-line-tip 0.75s;\n          animation: swal2-animate-success-line-tip 0.75s;\n}\n.swal2-animate-success-icon .swal2-success-line-long {\n  -webkit-animation: swal2-animate-success-line-long 0.75s;\n          animation: swal2-animate-success-line-long 0.75s;\n}\n.swal2-animate-success-icon .swal2-success-circular-line-right {\n  -webkit-animation: swal2-rotate-success-circular-line 4.25s ease-in;\n          animation: swal2-rotate-success-circular-line 4.25s ease-in;\n}\n\n.swal2-animate-error-icon {\n  -webkit-animation: swal2-animate-error-icon 0.5s;\n          animation: swal2-animate-error-icon 0.5s;\n}\n.swal2-animate-error-icon .swal2-x-mark {\n  -webkit-animation: swal2-animate-error-x-mark 0.5s;\n          animation: swal2-animate-error-x-mark 0.5s;\n}\n\n@-webkit-keyframes swal2-rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes swal2-rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@media print {\n  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {\n    overflow-y: scroll !important;\n  }\n  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) > [aria-hidden=true] {\n    display: none;\n  }\n  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container {\n    position: static !important;\n  }\n}\n","/**\n  * bootstrap-switch - Turn checkboxes and radio buttons into toggle switches.\n  *\n  * @version v3.3.4\n  * @homepage https://bttstrp.github.io/bootstrap-switch\n  * @author Mattia Larentis <mattia@larentis.eu> (http://larentis.eu)\n  * @license MIT\n  */\n\n\n //* IMPORTANT! Creative Tim Notice: this file has major changes to fit the Black Dashboard 's design. If you want to use the plugin as it was before our changes, please get the old files from http://www.bootstrap-switch.org\n\n\n\n .bootstrap-switch {\n   display: inline-block;\n   direction: ltr;\n   cursor: pointer;\n   border-radius: 30px;\n   border: 0;\n   position: relative;\n   text-align: left;\n   overflow: hidden;\n   box-shadow: 0 0px 10px rgba(0, 0, 0, 0.13);\n   margin-bottom: 10px;\n   line-height: 8px;\n   width: 59px !important;\n   height: 22px;\n   outline: none;\n   z-index: 0;\n   -webkit-user-select: none;\n   -moz-user-select: none;\n   -ms-user-select: none;\n   user-select: none;\n   vertical-align: middle;\n   -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n   transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n   background: url(\"https://d2v9y0dukr6mq2.cloudfront.net/video/thumbnail/J9H9WF0/night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png\");\n   background-position: center center;\n   background-size: cover;\n }\n\n .bootstrap-switch .bootstrap-switch-container {\n   display: inline-flex;\n   top: 0;\n   height: 22px;\n   border-radius: 4px;\n   -webkit-transform: translate3d(0, 0, 0);\n   transform: translate3d(0, 0, 0);\n   width: 100px !important;\n }\n .bootstrap-switch .bootstrap-switch-handle-on,\n .bootstrap-switch .bootstrap-switch-handle-off,\n .bootstrap-switch .bootstrap-switch-label {\n   -webkit-box-sizing: border-box;\n   -moz-box-sizing: border-box;\n   box-sizing: border-box;\n   cursor: pointer;\n   display: inline-block !important;\n   height: 100%;\n   color: #fff;\n   padding: 6px 10px;\n   font-size: 11px;\n   text-indent: -5px;\n   line-height: 15px;\n   -webkit-transition: 0.25s ease-out;\n           transition: 0.25s ease-out;\n\n }\n .bootstrap-switch .bootstrap-switch-handle-on,\n .bootstrap-switch .bootstrap-switch-handle-off {\n   text-align: center;\n   z-index: 1;\n   float: left;\n   line-height: 11px;\n   width: 50% !important;\n }\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-brown,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-brown {\n   color: #fff;\n   background: $brand-primary;\n }\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-blue,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-blue {\n   color: #fff;\n   background: $brand-info;\n }\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-green,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-green {\n   color: #fff;\n   background: $brand-success;\n }\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-orange,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-orange {\n   background: $brand-warning;\n   color: #fff;\n }\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-red,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-red {\n   color: #fff;\n   background: $brand-danger;\n }\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n   color: #fff;\n }\n .bootstrap-switch .bootstrap-switch-label {\n   text-align: center;\n   z-index: 100;\n   color: #333333;\n   background: #ffffff;\n   width: 18px !important;\n   height: 18px !important;\n   margin: 0px -11px;\n   border-radius: 20px;\n   position: absolute;\n   float: left;\n   top: 2px;\n   left: 51%;\n   padding: 0;\n   box-shadow: 0 1px 11px rgba(0, 0, 0, 0.25);\n }\n\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label{\n     background-color: rgba(156, 156 ,156 , .9);\n     left: 52%;\n }\n .bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label{\n     width: 27px !important;\n     margin-left: -20px;\n }\n .bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label{\n     width: 27px !important;\n     margin-left: -11px;\n }\n .bootstrap-switch .bootstrap-switch-handle-on {\n   border-bottom-left-radius: 3px;\n   border-top-left-radius: 3px;\n }\n .bootstrap-switch .bootstrap-switch-handle-off {\n   text-indent: 6px;\n }\n .bootstrap-switch input[type='radio'],\n .bootstrap-switch input[type='checkbox'] {\n   position: absolute !important;\n   top: 0;\n   left: 0;\n   opacity: 0;\n   filter: alpha(opacity=0);\n   z-index: -1;\n }\n .bootstrap-switch input[type='radio'].form-control,\n .bootstrap-switch input[type='checkbox'].form-control {\n   height: auto;\n }\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n   padding: 1px 5px;\n   font-size: 12px;\n   line-height: 1.5;\n }\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n   padding: 5px 10px;\n   font-size: 12px;\n   line-height: 1.5;\n }\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n   padding: 6px 16px;\n   font-size: 18px;\n   line-height: 1.33;\n }\n .bootstrap-switch.bootstrap-switch-disabled,\n .bootstrap-switch.bootstrap-switch-readonly,\n .bootstrap-switch.bootstrap-switch-indeterminate {\n   cursor: default !important;\n }\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n   opacity: 0.5;\n   filter: alpha(opacity=50);\n   cursor: default !important;\n }\n .bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n   -webkit-transition: margin-left 0.5s;\n   transition: margin-left 0.5s;\n }\n .bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n   border-bottom-left-radius: 0;\n   border-top-left-radius: 0;\n   border-bottom-right-radius: 3px;\n   border-top-right-radius: 3px;\n }\n .bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n   border-bottom-right-radius: 0;\n   border-top-right-radius: 0;\n   border-bottom-left-radius: 3px;\n   border-top-left-radius: 3px;\n }\n .bootstrap-switch.bootstrap-switch-focused {\n   // border-color: #66afe9;\n   // outline: 0;\n   // -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\n   // box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\n }\n // .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label,\n // .bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-off .bootstrap-switch-label {\n //   border-bottom-right-radius: 3px;\n //   border-top-right-radius: 3px;\n // }\n // .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label,\n // .bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-on .bootstrap-switch-label {\n //   border-bottom-left-radius: 3px;\n //   border-top-left-radius: 3px;\n // }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container{\n     margin-left: -2px !important;\n }\n\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container{\n     margin-left: -39px !important;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label{\n     &:before{\n         background-color: #FFFFFF;\n     }\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-red ~ .bootstrap-switch-default{\n     background-color: $brand-danger;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-orange ~ .bootstrap-switch-default{\n     background-color: $brand-warning;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-green ~ .bootstrap-switch-default{\n     background-color: $brand-success;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-brown ~ .bootstrap-switch-default{\n     background-color: $brand-primary;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-blue ~ .bootstrap-switch-default{\n     background-color: $brand-info;\n }\n\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-red,\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-brown,\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-blue,\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-orange,\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-green{\n     background-color: $light-gray;\n }\n\n .bootstrap-switch-on .bootstrap-switch-handle-off,\n .bootstrap-switch-off .bootstrap-switch-handle-on{\n     opacity: 0;\n     visibility: hidden;\n }\n\n .bootstrap-switch-off:before{\n   position: absolute;\n   content: \"\";\n   height: 100%;\n   width: 100%;\n   top: 0;\n   right: 0;\n   background: rgba(16,16,16,0.7);\n }\n","/*!\n * Bootstrap-select v1.13.9 (https://developer.snapappointments.com/bootstrap-select)\n *\n * Copyright 2012-2019 SnapAppointments, LLC\n * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)\n */\n\nselect.bs-select-hidden,\n.bootstrap-select > select.bs-select-hidden,\nselect.selectpicker {\n  display: none !important;\n}\n.bootstrap-select {\n  width: 100%;\n  /*IE9 and below*/\n  vertical-align: middle;\n\n  &.show {\n    > .dropdown-menu {\n      overflow: visible !important;\n    }\n  }\n}\n.bootstrap-select > .dropdown-toggle {\n  position: relative;\n  width: 100%;\n  text-align: right;\n  white-space: nowrap;\n  background: transparent!important;\n  background-image: none!important;\n  border: 1px solid #2b3553;\n  padding: 10px;\n  margin: 0;\n  margin-bottom: 5px;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n\n  &:hover {\n    box-shadow: none !important;\n    transform: none !important;\n  }\n\n  &:focus {\n    outline: none !important;\n  }\n\n  &:focus:active {\n    background: none !important;\n  }\n}\n.bootstrap-select > .dropdown-toggle:after {\n  margin-top: -1px;\n}\n.bootstrap-select > .dropdown-toggle.bs-placeholder,\n.bootstrap-select > .dropdown-toggle.bs-placeholder:hover,\n.bootstrap-select > .dropdown-toggle.bs-placeholder:focus,\n.bootstrap-select > .dropdown-toggle.bs-placeholder:active {\n  color: #999;\n}\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:hover,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:hover,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:hover,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:hover,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:hover,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:hover,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:focus,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:focus,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:focus,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:focus,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:focus,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:focus,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:active,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:active,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:active,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:active,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:active,\n.bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:active {\n  color: rgba(255, 255, 255, 0.5);\n}\n.bootstrap-select > select {\n  position: absolute !important;\n  bottom: 0;\n  left: 50%;\n  display: block !important;\n  width: 0.5px !important;\n  height: 100% !important;\n  padding: 0 !important;\n  opacity: 0 !important;\n  border: none;\n  z-index: 0 !important;\n}\n.bootstrap-select > select.mobile-device {\n  top: 0;\n  left: 0;\n  display: block !important;\n  width: 100% !important;\n  z-index: 2 !important;\n}\n.has-error .bootstrap-select .dropdown-toggle,\n.error .bootstrap-select .dropdown-toggle,\n.bootstrap-select.is-invalid .dropdown-toggle,\n.was-validated .bootstrap-select .selectpicker:invalid + .dropdown-toggle {\n  border-color: #b94a48;\n}\n.bootstrap-select.is-valid .dropdown-toggle,\n.was-validated .bootstrap-select .selectpicker:valid + .dropdown-toggle {\n  border-color: #28a745;\n}\n.bootstrap-select.fit-width {\n  width: auto !important;\n}\n.bootstrap-select:not([class*=\"col-\"]):not([class*=\"form-control\"]):not(.input-group-btn) {\n  width: 100%;\n}\n.bootstrap-select.form-control {\n  margin-bottom: 0;\n  padding: 0;\n  border: none;\n}\n:not(.input-group) > .bootstrap-select.form-control:not([class*=\"col-\"]) {\n  width: 100%;\n}\n.bootstrap-select.form-control.input-group-btn {\n  float: none;\n  z-index: auto;\n}\n.form-inline .bootstrap-select,\n.form-inline .bootstrap-select.form-control:not([class*=\"col-\"]) {\n  width: auto;\n}\n.bootstrap-select:not(.input-group-btn),\n.bootstrap-select[class*=\"col-\"] {\n  float: none;\n  display: inline-block;\n  margin-left: 0;\n}\n.bootstrap-select.dropdown-menu-right,\n.bootstrap-select[class*=\"col-\"].dropdown-menu-right,\n.row .bootstrap-select[class*=\"col-\"].dropdown-menu-right {\n  float: right;\n}\n.form-inline .bootstrap-select,\n.form-horizontal .bootstrap-select,\n.form-group .bootstrap-select {\n  margin-bottom: 0;\n}\n.form-group-lg .bootstrap-select.form-control,\n.form-group-sm .bootstrap-select.form-control {\n  padding: 0;\n}\n.form-group-lg .bootstrap-select.form-control .dropdown-toggle,\n.form-group-sm .bootstrap-select.form-control .dropdown-toggle {\n  height: 100%;\n  font-size: inherit;\n  line-height: inherit;\n  border-radius: inherit;\n}\n.bootstrap-select.form-control-sm .dropdown-toggle,\n.bootstrap-select.form-control-lg .dropdown-toggle {\n  font-size: inherit;\n  line-height: inherit;\n  border-radius: inherit;\n}\n.bootstrap-select.form-control-sm .dropdown-toggle {\n  padding: 0.25rem 0.5rem;\n}\n.bootstrap-select.form-control-lg .dropdown-toggle {\n  padding: 0.5rem 1rem;\n}\n.form-inline .bootstrap-select .form-control {\n  width: 100%;\n}\n.bootstrap-select.disabled,\n.bootstrap-select > .disabled {\n  cursor: not-allowed;\n}\n.bootstrap-select.disabled:focus,\n.bootstrap-select > .disabled:focus {\n  outline: none !important;\n}\n.bootstrap-select.bs-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 0 !important;\n  padding: 0 !important;\n}\n.bootstrap-select.bs-container .dropdown-menu {\n  z-index: 1060;\n}\n.bootstrap-select .dropdown-toggle .filter-option {\n  position: static;\n  top: 0;\n  left: 0;\n  float: left;\n  height: 100%;\n  text-align: left;\n  overflow: hidden;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 1 auto;\n      -ms-flex: 0 1 auto;\n          flex: 0 1 auto;\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 90%;\n  font-size: .75rem;\n  color: hsla(0,0%,100%,.8);\n  font-weight: 400;\n  text-align: left;\n}\n.bs3.bootstrap-select .dropdown-toggle .filter-option {\n  padding-right: inherit;\n}\n.input-group .bs3-has-addon.bootstrap-select .dropdown-toggle .filter-option {\n  position: absolute;\n  padding-top: inherit;\n  padding-bottom: inherit;\n  padding-left: inherit;\n  float: none;\n}\n.input-group .bs3-has-addon.bootstrap-select .dropdown-toggle .filter-option .filter-option-inner {\n  padding-right: inherit;\n}\n.bootstrap-select .dropdown-toggle .filter-option-inner-inner {\n  overflow: hidden;\n}\n.bootstrap-select .dropdown-toggle .filter-expand {\n  width: 0 !important;\n  float: left;\n  opacity: 0 !important;\n  overflow: hidden;\n}\n.bootstrap-select .dropdown-toggle .caret {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  margin-top: -2px;\n  vertical-align: middle;\n}\n.input-group .bootstrap-select.form-control .dropdown-toggle {\n  border-radius: inherit;\n}\n.bootstrap-select[class*=\"col-\"] .dropdown-toggle {\n  width: 100%;\n}\n.bootstrap-select .dropdown-menu {\n  min-width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bootstrap-select .dropdown-menu > .inner:focus {\n  outline: none !important;\n}\n.bootstrap-select .dropdown-menu.inner {\n  position: static;\n  float: none;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  border-radius: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.bootstrap-select .dropdown-menu li {\n  position: relative;\n}\n.bootstrap-select .dropdown-menu li.active small {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n.bootstrap-select .dropdown-menu li.disabled a {\n  cursor: not-allowed;\n}\n.bootstrap-select .dropdown-menu li a {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.bootstrap-select .dropdown-menu li a.opt {\n  position: relative;\n  padding-left: 2.25em;\n}\n.bootstrap-select .dropdown-menu li a span.check-mark {\n  display: none;\n}\n.bootstrap-select .dropdown-menu li a span.text {\n  display: inline-block;\n}\n.bootstrap-select .dropdown-menu li small {\n  padding-left: 0.5em;\n}\n.bootstrap-select .dropdown-menu .notify {\n  position: absolute;\n  bottom: 5px;\n  width: 96%;\n  margin: 0 2%;\n  min-height: 26px;\n  padding: 3px 5px;\n  background: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  pointer-events: none;\n  opacity: 0.9;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bootstrap-select .no-results {\n  padding: 3px;\n  background: #f5f5f5;\n  margin: 0 5px;\n  white-space: nowrap;\n}\n.bootstrap-select.fit-width .dropdown-toggle .filter-option {\n  position: static;\n  display: inline;\n  padding: 0;\n  width: auto;\n}\n.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner,\n.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner-inner {\n  display: inline;\n}\n.bootstrap-select.fit-width .dropdown-toggle .bs-caret:before {\n  content: '\\00a0';\n}\n.bootstrap-select.fit-width .dropdown-toggle .caret {\n  position: static;\n  top: auto;\n  margin-top: -1px;\n}\n.bootstrap-select.show-tick .dropdown-menu .selected span.check-mark {\n  position: absolute;\n  display: inline-block;\n  right: 15px;\n  top: 5px;\n}\n.bootstrap-select.show-tick .dropdown-menu li a span.text {\n  margin-right: 34px;\n}\n.bootstrap-select .bs-ok-default:after {\n  content: '';\n  display: block;\n  width: 0.5em;\n  height: 1em;\n  border-style: solid;\n  border-width: 0 0.26em 0.26em 0;\n  -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n       -o-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle,\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {\n  z-index: 1061;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:before {\n  content: '';\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid rgba(204, 204, 204, 0.2);\n  position: absolute;\n  bottom: -4px;\n  left: 9px;\n  display: none;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:after {\n  content: '';\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid white;\n  position: absolute;\n  bottom: -4px;\n  left: 10px;\n  display: none;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:before {\n  bottom: auto;\n  top: -4px;\n  border-top: 7px solid rgba(204, 204, 204, 0.2);\n  border-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:after {\n  bottom: auto;\n  top: -4px;\n  border-top: 6px solid white;\n  border-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:before {\n  right: 12px;\n  left: auto;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:after {\n  right: 13px;\n  left: auto;\n}\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle .filter-option:before,\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle .filter-option:before,\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle .filter-option:after,\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle .filter-option:after {\n  display: block;\n}\n.bs-searchbox,\n.bs-actionsbox,\n.bs-donebutton {\n  padding: 4px 8px;\n}\n.bs-actionsbox {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bs-actionsbox .btn-group button {\n  width: 50%;\n}\n.bs-donebutton {\n  float: left;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bs-donebutton .btn-group button {\n  width: 100%;\n}\n.bs-searchbox + .bs-actionsbox {\n  padding: 0 8px 4px;\n}\n.bs-searchbox .form-control {\n  margin-bottom: 0;\n  width: 100%;\n  float: none;\n}\n\n.bootstrap-select {\n  .dropdown-menu.inner {\n    li a {\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n      display: block;\n      outline: none;\n      color: #292b2c;\n    }\n\n    li.disabled a {\n      color: $default-opacity;\n\n      &:hover,\n      &:focus{\n        background-color: transparent;\n      }\n    }\n\n  }\n\n  .dropdown-menu {\n    &.open {\n      overflow: visible !important;\n    }\n\n    &.dropdown-black {\n      background: linear-gradient(to bottom, $black 0%, $black-states 100%);\n      border: 1px solid $dark-background;\n\n      li > a {\n        color: rgba(255, 255, 255, 0.7);\n      }\n    }\n  }\n}\n",".btn-file {\n  position: relative;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.btn-file > input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  font-size: 23px;\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  opacity: 0;\n\n  direction: ltr;\n}\n.fileinput {\n  display: inline-block;\n  margin-bottom: 9px;\n}\n.fileinput .form-control {\n  display: inline-block;\n  padding-top: 7px;\n  padding-bottom: 5px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  cursor: text;\n}\n.fileinput .thumbnail {\n  display: inline-block;\n  margin-bottom: 10px;\n  overflow: hidden;\n  text-align: center;\n  vertical-align: middle;\n  max-width: 250px;\n  box-shadow: $box-shadow;\n\n  &.img-circle{\n      border-radius: 50%;\n      max-width: 100px;\n  }\n}\n.fileinput .thumbnail > img {\n  max-height: 100%;\n}\n.fileinput .btn {\n  vertical-align: middle;\n}\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n  display: none;\n}\n.fileinput-inline .fileinput-controls {\n  display: inline;\n}\n.fileinput-filename {\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.form-control .fileinput-filename {\n  vertical-align: bottom;\n}\n.fileinput.input-group {\n  display: table;\n}\n.fileinput.input-group > * {\n  position: relative;\n  z-index: 2;\n}\n.fileinput.input-group > .btn-file {\n  z-index: 1;\n}\n.fileinput-new.input-group .btn-file,\n.fileinput-new .input-group .btn-file {\n  border-radius: 0 4px 4px 0;\n}\n.fileinput-new.input-group .btn-file.btn-xs,\n.fileinput-new .input-group .btn-file.btn-xs,\n.fileinput-new.input-group .btn-file.btn-sm,\n.fileinput-new .input-group .btn-file.btn-sm {\n  border-radius: 0 3px 3px 0;\n}\n.fileinput-new.input-group .btn-file.btn-lg,\n.fileinput-new .input-group .btn-file.btn-lg {\n  border-radius: 0 6px 6px 0;\n}\n.form-group.has-warning .fileinput .fileinput-preview {\n  color: $brand-warning;\n}\n.form-group.has-warning .fileinput .thumbnail {\n  border-color: $brand-warning;\n}\n.form-group.has-error .fileinput .fileinput-preview {\n  color: $brand-danger;\n}\n.form-group.has-error .fileinput .thumbnail {\n  border-color: $brand-danger;\n}\n.form-group.has-success .fileinput .fileinput-preview {\n  color: $brand-success;\n}\n.form-group.has-success .fileinput .thumbnail {\n  border-color: $brand-success;\n}\n.input-group-addon:not(:first-child) {\n  border-left: 0;\n}\n.thumbnail{\n    border: 0 none;\n    border-radius: 3px;\n    padding: 0;\n}\n","/*\n * bootstrap-tagsinput v2.3.3\n *\n */\n\n.bootstrap-tagsinput {\n    display: inline-block;\n    padding: 4px 6px;\n    max-width: 100%;\n    line-height: 22px;\n    vertical-align: middle;\n    cursor: text;\n\n    input{\n        border: none;\n        color: $dark-gray;\n        box-shadow: none;\n        outline: none;\n        background-color: transparent;\n        padding: 0 6px;\n        margin: 0;\n        width: auto;\n        max-width: inherit;\n\n        &:focus{\n          border: none;\n          box-shadow: none;\n        }\n    }\n\n    &.form-control input::-moz-placeholder{\n        color: #777;\n        opacity: 1;\n    }\n\n    &.form-control input:-ms-input-placeholder,\n    &.form-control input::-webkit-input-placeholder{\n        color: #777;\n    }\n\n    .tag {\n        cursor: pointer;\n        margin: 5px 3px 5px 0;\n        position: relative;\n        padding: 3px 8px;\n        border-radius: 12px;\n        font-weight: 500;\n        font-size: 0.75em;\n        text-transform: uppercase;\n        display: inline-block;\n        line-height: 1.5em;\n        padding-left: 0.8em;\n        color: $white;\n\n        &:hover{\n            padding-right: 22px;\n\n            [data-role=\"remove\"]{\n                opacity: 1;\n                padding-right: 4px;\n            }\n        }\n\n        [data-role=\"remove\"]{\n            cursor: pointer;\n            position: absolute;\n            top: 3px;\n            right: 0px;\n            opacity: 0;\n            background-color: transparent;\n        }\n\n        [data-role=\"remove\"]{\n            &:after{\n                font-family: 'Nucleo';\n                content: \"\\ea48\";\n                padding: 0px 2px;\n            }\n        }\n    }\n\n\n}\n","/*\n * Container style\n */\n .ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  -ms-overflow-style: none;\n  touch-action: auto;\n  -ms-touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, height .2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, width .2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x,\n.ps__rail-x.ps--clicking .ps__thumb-x {\n  background-color: #999;\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n  background-color: #999;\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n","svg {\n    touch-action: none;\n}\n\n.jvectormap-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    touch-action: none;\n}\n\n.jvectormap-tip {\n    // design changed by www.creative-tim.com\n    position: absolute;\n    display: none;\n    color: $default;\n    line-height: 1.5em;\n    background: $white;\n    border: none;\n    border-radius: $border-radius-xl;\n    padding: 5px 10px;\n    z-index: 1040;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {\n    position: absolute;\n    left: 10px;\n    border-radius: 3px;\n    background: #292929;\n    padding: 3px;\n    color: white;\n    cursor: pointer;\n    line-height: 10px;\n    text-align: center;\n    box-sizing: content-box;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout {\n    width: 10px;\n    height: 10px;\n}\n\n.jvectormap-zoomin {\n    top: 10px;\n}\n\n.jvectormap-zoomout {\n    top: 30px;\n}\n\n.jvectormap-goback {\n    bottom: 10px;\n    z-index: 1000;\n    padding: 6px;\n}\n\n.jvectormap-spinner {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: center no-repeat url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n}\n\n.jvectormap-legend-cnt {\n    position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n    bottom: 0;\n    right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n    top: 0;\n    right: 0;\n}\n\n.jvectormap-legend {\n    background: black;\n    color: white;\n    border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n    float: left;\n    margin: 0 10px 10px 0;\n    padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n    float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n    margin: 10px 10px 0 0;\n    padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n    width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n    height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n    height: 20px;\n    width: 20px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n    font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n    text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 20px;\n    padding-left: 3px;\n}\n","/*\n * This combined file was created by the DataTables downloader builder:\n *   https://datatables.net/download\n *\n * To rebuild or modify this file with the latest versions of the included\n * software please visit:\n *   https://datatables.net/download/#bs4/jszip-2.5.0/pdfmake-0.1.36/dt-1.10.18/af-2.3.0/b-1.5.2/b-colvis-1.5.1/b-flash-1.5.2/b-html5-1.5.2/b-print-1.5.2/cr-1.5.0/fc-3.2.5/fh-3.1.4/kt-2.4.0/r-2.2.2/rg-1.0.3/rr-1.2.4/sc-1.5.0/sl-1.2.6\n *\n * Included libraries:\n *   JSZip 2.5.0, pdfmake 0.1.36, DataTables 1.10.18, AutoFill 2.3.0, Buttons 1.5.2, Column visibility 1.5.1, Flash export 1.5.2, HTML5 export 1.5.2, Print view 1.5.2, ColReorder 1.5.0, FixedColumns 3.2.5, FixedHeader 3.1.4, KeyTable 2.4.0, Responsive 2.2.2, RowGroup 1.0.3, RowReorder 1.2.4, Scroller 1.5.0, Select 1.2.6\n */\n\ntable.dataTable{clear:both;margin-top:6px !important;margin-bottom:6px !important;max-width:none !important;border-collapse:separate !important;border-spacing:0}table.dataTable td,table.dataTable th{-webkit-box-sizing:content-box;box-sizing:content-box}table.dataTable td.dataTables_empty,table.dataTable th.dataTables_empty{text-align:center}table.dataTable.nowrap th,table.dataTable.nowrap td{white-space:nowrap}div.dataTables_wrapper div.dataTables_length label{font-weight:normal;text-align:left;white-space:nowrap}div.dataTables_wrapper div.dataTables_length select{width:auto;display:inline-block}div.dataTables_wrapper div.dataTables_filter{text-align:right}div.dataTables_wrapper div.dataTables_filter label{font-weight:normal;white-space:nowrap;text-align:left}div.dataTables_wrapper div.dataTables_filter input{margin-left:0.5em;display:inline-block;width:auto}div.dataTables_wrapper div.dataTables_info{padding-top:0.85em;white-space:nowrap}div.dataTables_wrapper div.dataTables_paginate{margin:0;white-space:nowrap;text-align:right}div.dataTables_wrapper div.dataTables_paginate ul.pagination{margin:2px 0;white-space:nowrap;justify-content:flex-end}div.dataTables_wrapper div.dataTables_processing{position:absolute;top:50%;left:50%;width:200px;margin-left:-100px;margin-top:-26px;text-align:center;padding:1em 0}table.dataTable thead>tr>th.sorting_asc,table.dataTable thead>tr>th.sorting_desc,table.dataTable thead>tr>th.sorting,table.dataTable thead>tr>td.sorting_asc,table.dataTable thead>tr>td.sorting_desc,table.dataTable thead>tr>td.sorting{padding-right:30px}table.dataTable thead>tr>th:active,table.dataTable thead>tr>td:active{outline:none}table.dataTable thead .sorting,table.dataTable thead .sorting_asc,table.dataTable thead .sorting_desc,table.dataTable thead .sorting_asc_disabled,table.dataTable thead .sorting_desc_disabled{cursor:pointer;position:relative}table.dataTable thead .sorting:before,table.dataTable thead .sorting:after,table.dataTable thead .sorting_asc:before,table.dataTable thead .sorting_asc:after,table.dataTable thead .sorting_desc:before,table.dataTable thead .sorting_desc:after,table.dataTable thead .sorting_asc_disabled:before,table.dataTable thead .sorting_asc_disabled:after,table.dataTable thead .sorting_desc_disabled:before,table.dataTable thead .sorting_desc_disabled:after{position:absolute;bottom:0.9em;display:block;opacity:0.3}table.dataTable thead .sorting:before,table.dataTable thead .sorting_asc:before,table.dataTable thead .sorting_desc:before,table.dataTable thead .sorting_asc_disabled:before,table.dataTable thead .sorting_desc_disabled:before{right:1em;content:\"\\2191\"}table.dataTable thead .sorting:after,table.dataTable thead .sorting_asc:after,table.dataTable thead .sorting_desc:after,table.dataTable thead .sorting_asc_disabled:after,table.dataTable thead .sorting_desc_disabled:after{right:0.5em;content:\"\\2193\"}table.dataTable thead .sorting_asc:before,table.dataTable thead .sorting_desc:after{opacity:1}table.dataTable thead .sorting_asc_disabled:before,table.dataTable thead .sorting_desc_disabled:after{opacity:0}div.dataTables_scrollHead table.dataTable{margin-bottom:0 !important}div.dataTables_scrollBody table{border-top:none;margin-top:0 !important;margin-bottom:0 !important}div.dataTables_scrollBody table thead .sorting:before,div.dataTables_scrollBody table thead .sorting_asc:before,div.dataTables_scrollBody table thead .sorting_desc:before,div.dataTables_scrollBody table thead .sorting:after,div.dataTables_scrollBody table thead .sorting_asc:after,div.dataTables_scrollBody table thead .sorting_desc:after{display:none}div.dataTables_scrollBody table tbody tr:first-child th,div.dataTables_scrollBody table tbody tr:first-child td{border-top:none}div.dataTables_scrollFoot>.dataTables_scrollFootInner{box-sizing:content-box}div.dataTables_scrollFoot>.dataTables_scrollFootInner>table{margin-top:0 !important;border-top:none}@media screen and (max-width: 767px){div.dataTables_wrapper div.dataTables_length,div.dataTables_wrapper div.dataTables_filter,div.dataTables_wrapper div.dataTables_info,div.dataTables_wrapper div.dataTables_paginate{text-align:center}}table.dataTable.table-sm>thead>tr>th{padding-right:20px}table.dataTable.table-sm .sorting:before,table.dataTable.table-sm .sorting_asc:before,table.dataTable.table-sm .sorting_desc:before{top:5px;right:0.85em}table.dataTable.table-sm .sorting:after,table.dataTable.table-sm .sorting_asc:after,table.dataTable.table-sm .sorting_desc:after{top:5px}table.table-bordered.dataTable th,table.table-bordered.dataTable td{border-left-width:0}table.table-bordered.dataTable th:last-child,table.table-bordered.dataTable th:last-child,table.table-bordered.dataTable td:last-child,table.table-bordered.dataTable td:last-child{border-right-width:0}table.table-bordered.dataTable tbody th,table.table-bordered.dataTable tbody td{border-bottom-width:0}div.dataTables_scrollHead table.table-bordered{border-bottom-width:0}div.table-responsive>div.dataTables_wrapper>div.row{margin:0}div.table-responsive>div.dataTables_wrapper>div.row>div[class^=\"col-\"]:first-child{padding-left:0}div.table-responsive>div.dataTables_wrapper>div.row>div[class^=\"col-\"]:last-child{padding-right:0}\n\n\ndiv.dt-autofill-handle {\n  position: absolute;\n  height: 8px;\n  width: 8px;\n  z-index: 102;\n  box-sizing: border-box;\n  border: 1px solid #0275d8;\n  background: #0275d8;\n}\n\ndiv.dt-autofill-select {\n  position: absolute;\n  z-index: 1001;\n  background-color: #0275d8;\n  background-image: repeating-linear-gradient(45deg, transparent, transparent 5px, rgba(255, 255, 255, 0.5) 5px, rgba(255, 255, 255, 0.5) 10px);\n}\ndiv.dt-autofill-select.top, div.dt-autofill-select.bottom {\n  height: 3px;\n  margin-top: -1px;\n}\ndiv.dt-autofill-select.left, div.dt-autofill-select.right {\n  width: 3px;\n  margin-left: -1px;\n}\n\ndiv.dt-autofill-list {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 500px;\n  margin-left: -250px;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 0 5px #555;\n  border: 2px solid #444;\n  z-index: 11;\n  box-sizing: border-box;\n  padding: 1.5em 2em;\n}\ndiv.dt-autofill-list ul {\n  display: table;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  width: 100%;\n}\ndiv.dt-autofill-list ul li {\n  display: table-row;\n}\ndiv.dt-autofill-list ul li:last-child div.dt-autofill-question, div.dt-autofill-list ul li:last-child div.dt-autofill-button {\n  border-bottom: none;\n}\ndiv.dt-autofill-list ul li:hover {\n  background-color: #f6f6f6;\n}\ndiv.dt-autofill-list div.dt-autofill-question {\n  display: table-cell;\n  padding: 0.5em 0;\n  border-bottom: 1px solid #ccc;\n}\ndiv.dt-autofill-list div.dt-autofill-question input[type=number] {\n  padding: 6px;\n  width: 30px;\n  margin: -2px 0;\n}\ndiv.dt-autofill-list div.dt-autofill-button {\n  display: table-cell;\n  padding: 0.5em 0;\n  border-bottom: 1px solid #ccc;\n}\n\ndiv.dt-autofill-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  background: radial-gradient(ellipse farthest-corner at center, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.7) 100%);\n  z-index: 10;\n}\n\ndiv.dt-autofill-list div.dt-autofill-question input[type=number] {\n  padding: 6px;\n  width: 60px;\n  margin: -2px 0;\n}\ndiv.dataTables_info {\n  color: hsla(0,0%,100%,.7);\n}\n\n\n@keyframes dtb-spinner{100%{transform:rotate(360deg)}}@-o-keyframes dtb-spinner{100%{-o-transform:rotate(360deg);transform:rotate(360deg)}}@-ms-keyframes dtb-spinner{100%{-ms-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes dtb-spinner{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes dtb-spinner{100%{-moz-transform:rotate(360deg);transform:rotate(360deg)}}div.dt-button-info{position:fixed;top:50%;left:50%;width:400px;margin-top:-100px;margin-left:-200px;background-color:white;border:2px solid #111;box-shadow:3px 3px 8px rgba(0,0,0,0.3);border-radius:3px;text-align:center;z-index:21}div.dt-button-info h2{padding:0.5em;margin:0;font-weight:normal;border-bottom:1px solid #ddd;background-color:#f3f3f3}div.dt-button-info>div{padding:1em}ul.dt-button-collection.dropdown-menu{display:block;z-index:2002;-webkit-column-gap:8px;-moz-column-gap:8px;-ms-column-gap:8px;-o-column-gap:8px;column-gap:8px}ul.dt-button-collection.dropdown-menu.fixed{position:fixed;top:50%;left:50%;margin-left:-75px;border-radius:0}ul.dt-button-collection.dropdown-menu.fixed.two-column{margin-left:-150px}ul.dt-button-collection.dropdown-menu.fixed.three-column{margin-left:-225px}ul.dt-button-collection.dropdown-menu.fixed.four-column{margin-left:-300px}ul.dt-button-collection.dropdown-menu>*{-webkit-column-break-inside:avoid;break-inside:avoid}ul.dt-button-collection.dropdown-menu.two-column{width:300px;padding-bottom:1px;-webkit-column-count:2;-moz-column-count:2;-ms-column-count:2;-o-column-count:2;column-count:2}ul.dt-button-collection.dropdown-menu.three-column{width:450px;padding-bottom:1px;-webkit-column-count:3;-moz-column-count:3;-ms-column-count:3;-o-column-count:3;column-count:3}ul.dt-button-collection.dropdown-menu.four-column{width:600px;padding-bottom:1px;-webkit-column-count:4;-moz-column-count:4;-ms-column-count:4;-o-column-count:4;column-count:4}ul.dt-button-collection.dropdown-menu .dt-button{border-radius:0}ul.dt-button-collection{-webkit-column-gap:8px;-moz-column-gap:8px;-ms-column-gap:8px;-o-column-gap:8px;column-gap:8px}ul.dt-button-collection.fixed{position:fixed;top:50%;left:50%;margin-left:-75px;border-radius:0}ul.dt-button-collection.fixed.two-column{margin-left:-150px}ul.dt-button-collection.fixed.three-column{margin-left:-225px}ul.dt-button-collection.fixed.four-column{margin-left:-300px}ul.dt-button-collection>*{-webkit-column-break-inside:avoid;break-inside:avoid}ul.dt-button-collection.two-column{width:300px;padding-bottom:1px;-webkit-column-count:2;-moz-column-count:2;-ms-column-count:2;-o-column-count:2;column-count:2}ul.dt-button-collection.three-column{width:450px;padding-bottom:1px;-webkit-column-count:3;-moz-column-count:3;-ms-column-count:3;-o-column-count:3;column-count:3}ul.dt-button-collection.four-column{width:600px;padding-bottom:1px;-webkit-column-count:4;-moz-column-count:4;-ms-column-count:4;-o-column-count:4;column-count:4}ul.dt-button-collection .dt-button{border-radius:0}ul.dt-button-collection.fixed{max-width:none}ul.dt-button-collection.fixed:before,ul.dt-button-collection.fixed:after{display:none}div.dt-button-background{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999}@media screen and (max-width: 767px){div.dt-buttons{float:none;width:100%;text-align:center;margin-bottom:0.5em}div.dt-buttons a.btn{float:none}}div.dt-buttons button.btn.processing,div.dt-buttons div.btn.processing,div.dt-buttons a.btn.processing{color:rgba(0,0,0,0.2)}div.dt-buttons button.btn.processing:after,div.dt-buttons div.btn.processing:after,div.dt-buttons a.btn.processing:after{position:absolute;top:50%;left:50%;width:16px;height:16px;margin:-8px 0 0 -8px;box-sizing:border-box;display:block;content:' ';border:2px solid #282828;border-radius:50%;border-left-color:transparent;border-right-color:transparent;animation:dtb-spinner 1500ms infinite linear;-o-animation:dtb-spinner 1500ms infinite linear;-ms-animation:dtb-spinner 1500ms infinite linear;-webkit-animation:dtb-spinner 1500ms infinite linear;-moz-animation:dtb-spinner 1500ms infinite linear}\n\n\ntable.DTCR_clonedTable.dataTable{position:absolute !important;background-color:rgba(255,255,255,0.7);z-index:202}div.DTCR_pointer{width:1px;background-color:#0275d8;z-index:201}\n\n\ntable.DTFC_Cloned tr{background-color:white;margin-bottom:0}div.DTFC_LeftHeadWrapper table,div.DTFC_RightHeadWrapper table{border-bottom:none !important;margin-bottom:0 !important;background-color:white}div.DTFC_LeftBodyWrapper table,div.DTFC_RightBodyWrapper table{border-top:none;margin:0 !important}div.DTFC_LeftBodyWrapper table thead .sorting:after,div.DTFC_LeftBodyWrapper table thead .sorting_asc:after,div.DTFC_LeftBodyWrapper table thead .sorting_desc:after,div.DTFC_LeftBodyWrapper table thead .sorting:after,div.DTFC_LeftBodyWrapper table thead .sorting_asc:after,div.DTFC_LeftBodyWrapper table thead .sorting_desc:after,div.DTFC_RightBodyWrapper table thead .sorting:after,div.DTFC_RightBodyWrapper table thead .sorting_asc:after,div.DTFC_RightBodyWrapper table thead .sorting_desc:after,div.DTFC_RightBodyWrapper table thead .sorting:after,div.DTFC_RightBodyWrapper table thead .sorting_asc:after,div.DTFC_RightBodyWrapper table thead .sorting_desc:after{display:none}div.DTFC_LeftBodyWrapper table tbody tr:first-child th,div.DTFC_LeftBodyWrapper table tbody tr:first-child td,div.DTFC_RightBodyWrapper table tbody tr:first-child th,div.DTFC_RightBodyWrapper table tbody tr:first-child td{border-top:none}div.DTFC_LeftFootWrapper table,div.DTFC_RightFootWrapper table{border-top:none;margin-top:0 !important;background-color:white}div.DTFC_Blocker{background-color:white}table.dataTable.table-striped.DTFC_Cloned tbody{background-color:white}\n\n\ntable.dataTable.fixedHeader-floating,table.dataTable.fixedHeader-locked{background-color:white;margin-top:0 !important;margin-bottom:0 !important}table.dataTable.fixedHeader-floating{position:fixed !important}table.dataTable.fixedHeader-locked{position:absolute !important}@media print{table.fixedHeader-floating{display:none}}\n\n\ntable.dataTable tbody th.focus,table.dataTable tbody td.focus{box-shadow:inset 0 0 1px 2px #0275d8}\n\n\ntable.dataTable.dtr-inline.collapsed>tbody>tr>td.child,table.dataTable.dtr-inline.collapsed>tbody>tr>th.child,table.dataTable.dtr-inline.collapsed>tbody>tr>td.dataTables_empty{cursor:default !important}table.dataTable.dtr-inline.collapsed>tbody>tr>td.child:before,table.dataTable.dtr-inline.collapsed>tbody>tr>th.child:before,table.dataTable.dtr-inline.collapsed>tbody>tr>td.dataTables_empty:before{display:none !important}table.dataTable.dtr-inline.collapsed>tbody>tr[role=\"row\"]>td:first-child,table.dataTable.dtr-inline.collapsed>tbody>tr[role=\"row\"]>th:first-child{position:relative;padding-left:30px;cursor:pointer}table.dataTable.dtr-inline.collapsed>tbody>tr[role=\"row\"]>td:first-child:before,table.dataTable.dtr-inline.collapsed>tbody>tr[role=\"row\"]>th:first-child:before{top:12px;left:4px;height:14px;width:14px;display:block;position:absolute;color:white;border:2px solid white;border-radius:14px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier, monospace;line-height:14px;content:'+';background-color:#0275d8}table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before{content:'-';background-color:#d33333}table.dataTable.dtr-inline.collapsed.compact>tbody>tr>td:first-child,table.dataTable.dtr-inline.collapsed.compact>tbody>tr>th:first-child{padding-left:27px}table.dataTable.dtr-inline.collapsed.compact>tbody>tr>td:first-child:before,table.dataTable.dtr-inline.collapsed.compact>tbody>tr>th:first-child:before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;text-indent:3px}table.dataTable.dtr-column>tbody>tr>td.control,table.dataTable.dtr-column>tbody>tr>th.control{position:relative;cursor:pointer}table.dataTable.dtr-column>tbody>tr>td.control:before,table.dataTable.dtr-column>tbody>tr>th.control:before{top:50%;left:50%;height:16px;width:16px;margin-top:-10px;margin-left:-10px;display:block;position:absolute;color:white;border:2px solid white;border-radius:14px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier, monospace;line-height:14px;content:'+';background-color:#0275d8}table.dataTable.dtr-column>tbody>tr.parent td.control:before,table.dataTable.dtr-column>tbody>tr.parent th.control:before{content:'-';background-color:#d33333}table.dataTable>tbody>tr.child{padding:0.5em 1em}table.dataTable>tbody>tr.child:hover{background:transparent !important}table.dataTable>tbody>tr.child ul.dtr-details{display:inline-block;list-style-type:none;margin:0;padding:0}table.dataTable>tbody>tr.child ul.dtr-details>li{border-bottom:1px solid #efefef;padding:0.5em 0}table.dataTable>tbody>tr.child ul.dtr-details>li:first-child{padding-top:0}table.dataTable>tbody>tr.child ul.dtr-details>li:last-child{border-bottom:none}table.dataTable>tbody>tr.child span.dtr-title{display:inline-block;min-width:75px;font-weight:bold}div.dtr-modal{position:fixed;box-sizing:border-box;top:0;left:0;height:100%;width:100%;z-index:100;padding:10em 1em}div.dtr-modal div.dtr-modal-display{position:absolute;top:0;left:0;bottom:0;right:0;width:50%;height:50%;overflow:auto;margin:auto;z-index:102;overflow:auto;background-color:#f5f5f7;border:1px solid black;border-radius:0.5em;box-shadow:0 12px 30px rgba(0,0,0,0.6)}div.dtr-modal div.dtr-modal-content{position:relative;padding:1em}div.dtr-modal div.dtr-modal-close{position:absolute;top:6px;right:6px;width:22px;height:22px;border:1px solid #eaeaea;background-color:#f9f9f9;text-align:center;border-radius:3px;cursor:pointer;z-index:12}div.dtr-modal div.dtr-modal-close:hover{background-color:#eaeaea}div.dtr-modal div.dtr-modal-background{position:fixed;top:0;left:0;right:0;bottom:0;z-index:101;background:rgba(0,0,0,0.6)}@media screen and (max-width: 767px){div.dtr-modal div.dtr-modal-display{width:95%}}div.dtr-bs-modal table.table tr:first-child td{border-top:none}\n\n\ntable.dataTable tr.group td{font-weight:bold;background-color:#e0e0e0}\n\n\ntable.dt-rowReorder-float{position:absolute !important;opacity:0.8;table-layout:fixed;outline:2px solid #0275d8;outline-offset:-2px;z-index:2001}tr.dt-rowReorder-moving{outline:2px solid #888;outline-offset:-2px}body.dt-rowReorder-noOverflow{overflow-x:hidden}table.dataTable td.reorder{text-align:center;cursor:move}\n\n\ndiv.DTS{display:block !important}div.DTS tbody th,div.DTS tbody td{white-space:nowrap}div.DTS div.DTS_Loading{z-index:1}div.DTS div.dataTables_scrollBody{background:repeating-linear-gradient(45deg, #edeeff, #edeeff 10px, #fff 10px, #fff 20px)}div.DTS div.dataTables_scrollBody table{z-index:2}div.DTS div.dataTables_paginate,div.DTS div.dataTables_length{display:none}div.DTS div.dataTables_scrollBody table{background-color:white}\n\n\ntable.dataTable tbody>tr.selected,table.dataTable tbody>tr>.selected{background-color:#0275d8}table.dataTable.stripe tbody>tr.odd.selected,table.dataTable.stripe tbody>tr.odd>.selected,table.dataTable.display tbody>tr.odd.selected,table.dataTable.display tbody>tr.odd>.selected{background-color:#0272d3}table.dataTable.hover tbody>tr.selected:hover,table.dataTable.hover tbody>tr>.selected:hover,table.dataTable.display tbody>tr.selected:hover,table.dataTable.display tbody>tr>.selected:hover{background-color:#0271d0}table.dataTable.order-column tbody>tr.selected>.sorting_1,table.dataTable.order-column tbody>tr.selected>.sorting_2,table.dataTable.order-column tbody>tr.selected>.sorting_3,table.dataTable.order-column tbody>tr>.selected,table.dataTable.display tbody>tr.selected>.sorting_1,table.dataTable.display tbody>tr.selected>.sorting_2,table.dataTable.display tbody>tr.selected>.sorting_3,table.dataTable.display tbody>tr>.selected{background-color:#0273d4}table.dataTable.display tbody>tr.odd.selected>.sorting_1,table.dataTable.order-column.stripe tbody>tr.odd.selected>.sorting_1{background-color:#026fcc}table.dataTable.display tbody>tr.odd.selected>.sorting_2,table.dataTable.order-column.stripe tbody>tr.odd.selected>.sorting_2{background-color:#0270ce}table.dataTable.display tbody>tr.odd.selected>.sorting_3,table.dataTable.order-column.stripe tbody>tr.odd.selected>.sorting_3{background-color:#0270d0}table.dataTable.display tbody>tr.even.selected>.sorting_1,table.dataTable.order-column.stripe tbody>tr.even.selected>.sorting_1{background-color:#0273d4}table.dataTable.display tbody>tr.even.selected>.sorting_2,table.dataTable.order-column.stripe tbody>tr.even.selected>.sorting_2{background-color:#0274d5}table.dataTable.display tbody>tr.even.selected>.sorting_3,table.dataTable.order-column.stripe tbody>tr.even.selected>.sorting_3{background-color:#0275d7}table.dataTable.display tbody>tr.odd>.selected,table.dataTable.order-column.stripe tbody>tr.odd>.selected{background-color:#026fcc}table.dataTable.display tbody>tr.even>.selected,table.dataTable.order-column.stripe tbody>tr.even>.selected{background-color:#0273d4}table.dataTable.display tbody>tr.selected:hover>.sorting_1,table.dataTable.order-column.hover tbody>tr.selected:hover>.sorting_1{background-color:#026bc6}table.dataTable.display tbody>tr.selected:hover>.sorting_2,table.dataTable.order-column.hover tbody>tr.selected:hover>.sorting_2{background-color:#026cc8}table.dataTable.display tbody>tr.selected:hover>.sorting_3,table.dataTable.order-column.hover tbody>tr.selected:hover>.sorting_3{background-color:#026eca}table.dataTable.display tbody>tr:hover>.selected,table.dataTable.display tbody>tr>.selected:hover,table.dataTable.order-column.hover tbody>tr:hover>.selected,table.dataTable.order-column.hover tbody>tr>.selected:hover{background-color:#026bc6}table.dataTable tbody td.select-checkbox,table.dataTable tbody th.select-checkbox{position:relative}table.dataTable tbody td.select-checkbox:before,table.dataTable tbody td.select-checkbox:after,table.dataTable tbody th.select-checkbox:before,table.dataTable tbody th.select-checkbox:after{display:block;position:absolute;top:1.2em;left:50%;width:12px;height:12px;box-sizing:border-box}table.dataTable tbody td.select-checkbox:before,table.dataTable tbody th.select-checkbox:before{content:' ';margin-top:-6px;margin-left:-6px;border:1px solid black;border-radius:3px}table.dataTable tr.selected td.select-checkbox:after,table.dataTable tr.selected th.select-checkbox:after{content:'\\2714';margin-top:-11px;margin-left:-4px;text-align:center;text-shadow:1px 1px #B0BED9, -1px -1px #B0BED9, 1px -1px #B0BED9, -1px 1px #B0BED9}div.dataTables_wrapper span.select-info,div.dataTables_wrapper span.select-item{margin-left:0.5em}@media screen and (max-width: 640px){div.dataTables_wrapper span.select-info,div.dataTables_wrapper span.select-item{margin-left:0;display:block}}table.dataTable tbody tr.selected,table.dataTable tbody th.selected,table.dataTable tbody td.selected{color:white}table.dataTable tbody tr.selected a,table.dataTable tbody th.selected a,table.dataTable tbody td.selected a{color:#a2d4ed}\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// This file was modified by Creative Tim to keep only the animation that we need for Bootstrap Notify\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@charset \"UTF-8\";\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n}\n\n.animated.bounceIn,\n.animated.bounceOut {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n.animated.flipOutX,\n.animated.flipOutY {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n@-webkit-keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n@-webkit-keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n",".card-wizard {\n    min-height: 410px;\n    background: transparent !important;\n    box-shadow: none !important;\n    opacity: 0;\n    @include transitions($general-transition-time, $transition-linear);\n\n    &.active{\n        opacity: 1;\n    }\n\n    @include set-wizard-color($primary);\n\n    &[data-color=\"primary\"]{\n        @include set-wizard-color($primary);\n    }\n\n    &[data-color=\"green\"]{\n        @include set-wizard-color(darken($success,10%));\n    }\n\n    &[data-color=\"blue\"]{\n        @include set-wizard-color($info);\n    }\n\n    &[data-color=\"red\"]{\n        @include set-wizard-color($danger);\n    }\n\n    &[data-color=\"orange\"]{\n        @include set-wizard-color($warning);\n    }\n\n    .nav-pills .nav-item {\n      position: relative;\n      .nav-link{\n          height: 45px;\n          width: 45px;\n          min-width: 45px;\n          border-radius: 50% !important;\n          position: absolute;\n          left: 50%;\n          top: -20px;\n          transform: translate(-50%);\n          background-color: white;\n          p{\n            position: absolute;\n            top: 110%;\n            left: 50%;\n            transform: translate(-50%);\n            font-weight: $font-weight-normal;\n            color: $white;\n          }\n\n          &:hover,&:focus{\n            background-color: white;\n          }\n\n      }\n\n\n    }\n\n    .nav-pills .nav-item .nav-link.active,\n    .nav-pills .nav-item .nav-link:hover,\n    .nav-pills .nav-item .nav-link:focus,\n    .nav-pills .nav-item .nav-link.active:focus,\n    .nav-pills .nav-item .nav-link.active:hover{\n        box-shadow: none;\n    }\n\n    .picture-container{\n        position: relative;\n        cursor: pointer;\n        text-align: center;\n    }\n\n    .card-body {\n      background: $black;\n      border-top-left-radius: $border-radius-lg;\n      border-top-right-radius: $border-radius-lg;\n      margin-top: 20px;\n    }\n\n    .card-footer {\n      background-color: $black !important;\n      border-bottom-left-radius: $border-radius-lg;\n      border-bottom-right-radius: $border-radius-lg;\n      padding-bottom: 20px;\n\n      .pull-right {\n        padding-right: 80px;\n      }\n      .pull-left {\n        padding-left: 80px;\n      }\n    }\n\n    .wizard-navigation {\n      position: relative;\n      margin: 80px auto 60px;\n\n      .nav-link{\n        display: flex;\n        align-items: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n      }\n\n      .progress-with-circle{\n          position: relative;\n          top: 5px;\n          height: 5px;\n          border-radius: $border-radius-lg;\n\n          .progress-bar{\n              height: 100%;\n              border-radius: $border-radius-lg;\n              box-shadow: none;\n              -webkit-transition: width .3s ease;\n              -o-transition: width .3s ease;\n              transition: width .3s ease;\n          }\n      }\n    }\n\n    .wizard-navigation .nav-link i,\n    .moving-tab i{\n      display: inline-block;\n      font-size: 19px;\n      line-height: initial;\n      padding: 0;\n      vertical-align: bottom;\n    }\n\n    .picture{\n        width: 106px;\n        height: 106px;\n        background-color: #999999;\n        border: 1px solid $light-gray;\n        color: #FFFFFF;\n        border-radius: 50%;\n        margin: 5px auto;\n        overflow: hidden;\n        transition: all 0.2s;\n        -webkit-transition: all 0.2s;\n\n        &:hover{\n            border-color: #2ca8ff;\n        }\n    }\n\n\n\n\n\n    .picture input[type=\"file\"] {\n        cursor: pointer;\n        display: block;\n        height: 100%;\n        left: 0;\n        opacity: 0 !important;\n        position: absolute;\n        top: 0;\n        width: 100%;\n    }\n\n    .picture-src{\n        width: 100%;\n    }\n\n    .tab-content{\n        padding: 20px 0;\n    }\n\n    .wizard-footer{\n        padding: 0 15px;\n\n        .checkbox{\n            margin-top: 16px;\n        }\n    }\n\n    .disabled{\n        display: none;\n    }\n\n    .wizard-header{\n        text-align: center;\n        padding: 25px 0 35px;\n\n        h5{\n           margin: 5px 0 0;\n       }\n    }\n\n    .nav-pills > li{\n        text-align: center;\n    }\n\n    .btn{\n        text-transform: uppercase;\n    }\n\n    .info-text{\n        text-align: center;\n        font-weight: 300;\n        margin: 10px 0 30px;\n    }\n\n    .choice{\n        text-align: center;\n        cursor: pointer;\n        margin-top: 20px;\n\n        &[disabled]{\n            pointer-events: none;\n            cursor: not-allowed;\n            opacity: .5;\n        }\n\n        .icon{\n            text-align: center;\n            vertical-align: middle;\n            height: 116px;\n            width: 116px;\n            border-radius: 50%;\n            color: $default;\n            margin: 0 auto 20px;\n            border: 1px solid $light-gray;\n            transition: all 0.2s;\n            -webkit-transition: all 0.2s;\n        }\n\n        i{\n            font-size: 30px;\n            line-height: 116px;\n            position: absolute;\n            left: 0;\n            right: 0;\n        }\n\n        &:hover,\n        &.active{\n            .icon{\n                border-color: #2ca8ff;\n            }\n        }\n\n        input[type=\"radio\"],\n        input[type=\"checkbox\"]{\n            position: absolute;\n            left: -10000px;\n            z-index: -1;\n        }\n    }\n\n    .btn-finish{\n        display: none;\n    }\n\n    .card-title + .description{\n        font-size: 17px;\n        margin-bottom: 32px;\n    }\n\n    .wizard-title{\n        margin: 0;\n    }\n\n    .nav-pills{\n        background-color: $white;\n        border-radius: $border-radius-lg;\n        height: 5px;\n\n        > li + li {\n            margin-left: 0;\n        }\n\n        > li > a {\n            border: 0 !important;\n            border-radius: 0 ;\n            line-height: 18px;\n            text-transform: uppercase;\n            font-size: 12px;\n            font-weight: 500;\n            min-width: 100px;\n            text-align: center;\n            color: #555555;\n        }\n\n        > li.active > a,\n        > li.active > a:hover,\n        > li.active > a:focus,\n        > li > a:hover,\n        > li > a:focus{\n            background-color: inherit;\n            box-shadow: none;\n        }\n\n        > li i{\n            display: block;\n            font-size: 30px;\n            padding: 15px 0;\n        }\n    }\n\n    .input-group.has-danger {\n      .error {\n        display: block;\n        width: 100%;\n        margin-top: 3px;\n      }\n    }\n}\n","@mixin set-wizard-color($color) {\n      .progress-with-circle .progress-bar{\n          background: $color;\n      }\n\n      .nav-pills .nav-item .nav-link{\n        color: $color;\n\n        &.checked, &.active{\n          background: $color;\n          color: white;\n        }\n        &:hover{\n          background: $white;\n        }\n      }\n\n      .nav-pills .nav-item .nav-link.active,\n      .nav-pills .nav-item .nav-link.checked:focus,\n      .nav-pills .nav-item .nav-link.checked:hover,\n      .nav-pills .nav-item .nav-link.active:focus,\n      .nav-pills .nav-item .nav-link.active:hover{\n          background: $color;\n      }\n\n}\n","/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n",".login-page {\n    .card-login {\n        border-radius: $border-radius-lg;\n        padding-bottom: $padding-base-horizontal;\n\n        .card-header {\n          padding: 0 0 100px;\n          overflow: hidden;\n          img{\n            position: absolute;\n          }\n          .card-title{\n            position: relative;\n            font-size: 5em;\n            font-weight: 900;\n            color: $black;\n            text-transform: lowercase;\n            margin-left: -5px;\n            z-index: 1;\n          }\n        }\n        .btn-wd{\n            min-width: 180px;\n        }\n\n        .logo-container{\n            width: 65px;\n            margin: 0 auto;\n            margin-bottom: 55px;\n\n            img{\n                width: 100%;\n            }\n        }\n\n        // .input-group:last-child{\n        //     margin-bottom: 40px;\n        // }\n\n        &.card-plain{\n            @include input-coloured-bg($opacity-5, $white, $white, $transparent-bg, $opacity-1, $opacity-2);\n\n            .input-group-addon,\n            .form-group.no-border .input-group-addon,\n            .input-group.no-border .input-group-addon{\n                color: $opacity-8;\n            }\n        }\n\n        &.card-white{\n\n          background: $white;\n\n          .card-header{\n            .card-title{\n              color: $white;\n            }\n          }\n\n          @include form-control-placeholder(rgba($black,0.4), 1);\n            .has-danger{\n              .form-control, .input-group-prepend .input-group-text{\n                border-color: $danger-states;\n              }\n            }\n\n            .input-group-prepend .input-group-text{\n              border-color: rgba($black-states,0.2);\n              color: $black-states;\n            }\n\n            .form-control{\n              color: $black;\n              border-color: rgba($black-states,0.2);\n              &:focus{\n                border-color: $primary;\n              }\n            }\n\n          .form-group.no-border,\n          .input-group.no-border{\n              .form-control,\n              .form-control + .input-group-prepend .input-group-text,\n              .form-control + .input-group-append .input-group-text,\n              .input-group-prepend .input-group-text,\n              .input-group-append .input-group-text{\n                  background-color: $opacity-gray-3;\n                  &:focus,\n                  &:active,\n                  &:active{\n                      background-color: $opacity-gray-5;\n                  }\n              }\n\n              .form-control{\n                  &:focus{\n                      & + .input-group-prepend .input-group-text,\n                      & + .input-group-append .input-group-text{\n\n                          background-color: $transparent-bg;\n                      }\n                  }\n              }\n\n\n          }\n\n          .input-group[disabled]{\n              .input-group-prepend .input-group-text,\n              .input-group-append .input-group-text{\n                  background-color: $black;\n              }\n          }\n\n          .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\n            background: $light-gray;\n            border-color: rgba($black-states,0.3);\n          }\n\n          .input-group-focus{\n              .input-group-prepend .input-group-text,\n              .input-group-append .input-group-text,\n              .form-control{\n                background-color: $white;\n                border-color: $primary;\n              }\n\n              &.no-border{\n                  .input-group-prepend .input-group-text,\n                  .input-group-append .input-group-text{\n\n                      background-color: $opacity-gray-5;\n                  }\n              }\n          }\n          .input-group-prepend .input-group-text {\n              border-right: none;\n          }\n\n          .input-group-append .input-group-text {\n              border-left: none;\n          }\n\n          .has-danger .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n            border-color: $danger-states;\n          }\n\n          .has-success .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n            border-color: darken($success, 10%);\n          }\n\n        }\n    }\n\n    .link{\n        font-size: 10px;\n        text-decoration: none;\n    }\n\n    .card-black{\n      .link{\n        color: $white;\n      }\n    }\n}\n\n.full-page{\n    & > .content,\n    & > .footer{\n        position: relative;\n        z-index: 4;\n    }\n\n    & > .content{\n        padding-bottom: 150px;\n        padding-top: 150px;\n    }\n\n    .footer{\n        position: absolute;\n        width: 100%;\n        bottom: 0;\n        padding-left: 48px;\n        padding-right: 48px;\n\n        .container{\n            color: $white;\n        }\n    }\n\n    .full-page-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n    }\n\n\n\n    &.pricing-page{\n        .description{\n            margin-bottom: 65px;\n            color: rgba($white,0.7);\n        }\n    }\n\n    &.register-page{\n        .info-horizontal{\n            padding: 0px 0px 20px;\n        }\n\n        .info-horizontal{\n            text-align: left !important;\n\n            .icon{\n                margin-top: 0;\n\n                >i{\n                    font-size: 2em;\n                }\n\n                &.icon-circle{\n                    width: 65px;\n                    height: 65px;\n                    max-width: 65px;\n                    margin-top: 8px;\n\n                    i{\n                        display: table;\n                        margin: 0 auto;\n                        line-height: 3.5;\n                        font-size: 1.9em;\n                    }\n                }\n            }\n            .description{\n                overflow: hidden;\n                .info-title{\n                  margin-bottom: 20px;\n                }\n            }\n\n        }\n    }\n\n    &.pricing-page, &.login-page, &.lock-page, &.register-page {\n      min-height: 100vh;\n      background: radial-gradient($background-black, $background-states-black);\n    }\n}\n\n@include media-breakpoint-down(sm){\n\n  .landing-page .section-story-overview .image-container:nth-child(2) {\n    margin-left: 0;\n    margin-bottom: 30px;\n  }\n\n  .login-page .card-login .card-header img {\n    width: 70%;\n  }\n}\n\n@include media-breakpoint-down(xs){\n  .register-page .full-page >.content {\n    padding-top: 50px;\n  }\n\n  .page-header{\n    .container h6.category-absolute{\n        width: 90%;\n    }\n  }\n}\n\n@media only screen\nand (min-device-width : 768px)\nand (max-device-width : 1024px)\nand (orientation : landscape) {\n\n  .pricing-page,\n  .register-page,\n  .login-page,\n  .lock-page {\n    .navbar .navbar-toggle .navbar-toggler{\n      display: none;\n    }\n  }\n\n}\n\n@media only screen\nand (min-device-width : 768px)\nand (max-device-width : 1024px)\nand (orientation : portrait) {\n  .register-page .full-page .content {\n    .card-register {\n      margin-top: 3rem!important;\n    }\n  }\n}\n\n@include media-breakpoint-down(md){\n  .lock-page,\n  .login-page,\n  .pricing-page,\n  .register-page {\n    .navbar {\n      .navbar-wrapper .navbar-toggle {\n        display: none !important;\n      }\n    }\n  }\n}\n",".white-content{\n\n  background: #fff;\n\n  .navbar.navbar-transparent .navbar-brand{\n    color: $black-states;\n  }\n\n  .navbar.navbar-transparent .navbar-toggler-bar{\n    background: $black-states;\n  }\n  .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item){\n      color: $black-states;\n      & i{\n        color: $black-states;\n      }\n  }\n\n  .navbar.navbar-transparent .navbar-minimize button i{\n    color: $black-states;\n  }\n\n  .navbar.navbar-transparent .search-bar.input-group i{\n    color: $black-states;\n  }\n  .navbar.navbar-transparent .search-bar.input-group .form-control{\n    color: $default;\n    &::placeholder{\n      color: $dark-gray;\n    }\n  }\n\n  .sidebar{\n    // box-shadow: 0 2px 22px 0 rgba(0,0,0,.1), 0 4px 20px 0 rgba(0,0,0,.15);\n    box-shadow: none !important;\n    p{\n      color: $opacity-8;\n    }\n  }\n\n  .main-panel{\n    background: $light-bg;\n  }\n\n  h1, h2, h3, h4, h5, h6, p, ol li, ul li, pre {\n    color: $black-states;\n  }\n\n  .font-icon-detail i{\n    color: $black;\n  }\n\n  .btn:not([data-action]):hover{\n    box-shadow:  0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\n  }\n\n  .btn-neutral.btn-link{\n    color: rgba($black, 0.7);\n  }\n\n  //style for inputs\n\n  @include form-control-placeholder(rgba($black,0.4), 1);\n    .has-danger{\n      .form-control, .input-group-prepend .input-group-text{\n        border-color: $danger-states;\n      }\n    }\n\n    .input-group-prepend .input-group-text{\n      border-color: rgba($black-states,0.5);\n      color: $black-states;\n    }\n\n    .form-control{\n      color: $black;\n      border-color: rgba($black-states,0.5);\n      &:focus{\n        border-color: $primary;\n      }\n    }\n\n  .form-group.no-border,\n  .input-group.no-border{\n      .form-control,\n      .form-control + .input-group-prepend .input-group-text,\n      .form-control + .input-group-append .input-group-text,\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text{\n          background-color: $opacity-gray-3;\n          &:focus,\n          &:active,\n          &:active{\n              background-color: $opacity-gray-5;\n          }\n      }\n\n      .form-control{\n          &:focus{\n              & + .input-group-prepend .input-group-text,\n              & + .input-group-append .input-group-text{\n\n                  background-color: $transparent-bg;\n              }\n          }\n      }\n\n\n  }\n\n  .input-group[disabled]{\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text{\n          background-color: $black;\n      }\n  }\n\n  .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\n    background: $light-gray;\n    border-color: rgba($black-states,0.3);\n  }\n\n  .input-group-focus{\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text,\n      .form-control{\n        border-color: $primary;\n      }\n\n      &.no-border{\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text{\n\n              background-color: $opacity-gray-5;\n          }\n      }\n  }\n  .input-group-prepend .input-group-text {\n      border-right: none;\n  }\n\n  .input-group-append .input-group-text {\n      border-left: none;\n  }\n\n  .has-danger .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n    border-color: $danger-states;\n  }\n\n  .has-success .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n    border-color: darken($success, 10%);\n  }\n\n  .btn.btn-link{\n    &:hover,&:active, &:focus{\n      color: $dark-gray !important;\n    }\n  }\n\n  .btn-group .btn.active{\n    box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\n  }\n\n  .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label{\n    background: darken($light-bg,10%);\n  }\n\n  .bootstrap-switch-off:before{\n    background: rgba(darken($light-bg,10%),0.5);\n\n  }\n\n  .card:not(.card-white){\n    &.card-pricing, &.card-login, &.card-register{\n      background: $card-black-background;\n    }\n    &.card-login, &.card-register{\n      @include form-control-placeholder(#6c757c, 1);\n\n      .form-control{\n        border-color: lighten($black,5%);\n      }\n\n      .form-group.no-border,\n      .input-group.no-border{\n          .form-control,\n          .form-control + .input-group-prepend .input-group-text,\n          .form-control + .input-group-append .input-group-text{\n\n              background-color: lighten($black,1%);\n              &:focus,\n              &:active,\n              &:active{\n                  background-color: lighten($black,2%);\n              }\n          }\n\n          .form-control{\n              &:focus{\n                  & + .input-group-prepend .input-group-text,\n                  & + .input-group-append .input-group-text{\n                      background-color: lighten($black,2%);\n                  }\n              }\n          }\n\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text{\n              background-color: lighten($black,1%);;\n\n          }\n      }\n\n      .input-group-append .input-group-text,\n      .input-group-prepend .input-group-text {\n          border: 1px solid lighten($black,5%);\n          border-right: none;\n          color: $white;\n    }\n\n    .input-group-focus{\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text,\n      .form-control{\n        border-color: $primary;\n      }\n    }\n\n    .form-control{\n      color: $white;\n    }\n\n    label{\n      color: $opacity-6;\n    }\n  }\n}\n\n\n  .card:not(.card-white){\n    // background: $white;\n    background-color: #ffffff;\n    box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.05);\n    .card-header{\n      color: $black;\n      a[data-toggle=\"collapse\"]{\n        color: $black;\n      }\n    }\n    .card-header .card-title, .card-body .card-title{\n      color: $black-states;\n    }\n\n    .card-body{\n      .card-category, .card-description{\n        color: $black-states;\n      }\n    }\n\n\n    label:not(.btn){\n      color: $default;\n    }\n\n     .pagination .page-item:not(.active) .page-link{\n       color: $black-states;\n        &:hover{\n          background: rgba($dark-gray,0.1);\n        }\n     }\n\n     &:not(.card-wizard).nav-pills .nav-item .nav-link {\n        color: $nav-gray;\n        background-color: hsla(0,0%,87%,.3);\n        &:not(.active):hover{\n          background: hsla(0,0%,87%,.5);\n        }\n        &.active{\n          color: $white;\n\n        }\n    }\n\n    .tab-content .tab-pane {\n        color: $nav-gray;\n    }\n\n\n    .card{\n      box-shadow: none;\n    }\n\n    .card-collapse{\n      .card{\n        .card-body{\n          color: $dark-gray;\n        }\n      }\n    }\n\n    &.card-contributions{\n      span{\n        color: $dark-gray;\n      }\n      .bootstrap-switch-container{\n        span{\n          color: $white;\n        }\n      }\n    }\n    &.card-plain{\n      background: $transparent-bg;\n      box-shadow: none;\n    }\n\n    &.card-tasks{\n      .card-body{\n        i{\n          color: rgba(34,42,66,0.7);\n          &:hover{\n            color: $black;\n          }\n        }\n      }\n    }\n  }\n\n  .table{\n\n      > tbody > tr > td {\n        color: rgba($black, 0.7) !important;\n\n    }\n\n    > thead > tr > th,\n    > tbody > tr > th,\n    > tfoot > tr > th,\n    > thead > tr > td,\n    > tbody > tr > td,\n    > tfoot > tr > td{\n        border-color: rgba($black, 0.2);\n        padding: 12px 7px;\n        vertical-align: middle;\n        border:solid 1px  rgba($black, 0.2);\n    }\n    > thead > tr:hover,  > tbody > tr:hover {background-color: #ddd;}\n\n    > thead > tr > th, button.btn-neutral.btn-link{\n      color: rgba($black, 0.7);\n    }\n  }\n\n  .footer ul li a{\n    color: $black-states;\n  }\n\n  .footer .copyright{\n    color: $black-states;\n  }\n\n  .progress-container, .progress-container.progress.sm{\n      .progress{\n        background: rgba($black,0.1);\n        box-shadow: 0 0 0 3px rgba($black,0.1);\n        .progress-value{\n          color: $default;\n        }\n      }\n\n      .progress-badge{\n        color: $black-states;\n      }\n  }\n\n  .bootstrap-select button.dropdown-toggle{\n    border-color: rgba($black-states,0.5);\n    .filter-option{\n      color: $black-states;\n    }\n\n    &:after{\n      color: $black-states;\n    }\n\n  }\n\n  //style for calendar\n\n  .fc-basic-view .fc-day-number, .fc-basic-view .fc-week-number {\n      padding: 2px;\n      color: $default;\n  }\n\n  .fc-unthemed .fc-today{\n    background: darken($light-bg,10%);\n  }\n\n  .fc-unthemed .fc-content, .fc-unthemed .fc-divider, .fc-unthemed .fc-list-heading td, .fc-unthemed .fc-list-view, .fc-unthemed .fc-popover, .fc-unthemed .fc-row, .fc-unthemed tbody, .fc-unthemed td, .fc-unthemed th, .fc-unthemed thead {\n        border-color: $calendar-gray;\n    }\n\n   .fc-prev-button, .fc-next-button{\n     color: $default;\n     &:hover{\n       color: $default;\n     }\n   }\n\n   .fc button.btn-primary:not([data-action]):hover, .fc button:not([data-action]):hover {\n     box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\n   }\n\n   .full-page{\n     background: $light-bg;\n\n     h1, h2, h3, h4, h5, h6, p, ol li, ul li, pre {\n       color: $black-states;\n     }\n\n     .description{\n       color: $dark-gray;\n     }\n\n     .footer ul li a{\n       color: $black-states;\n     }\n\n     .footer .copyright{\n       color: $black-states;\n     }\n   }\n\n   .nav-pills .nav-item .nav-link:not(.active){\n     background: darken($light-bg,10%);\n     color: $black-states;\n     &:hover{\n       background: darken($white,20%);\n\n     }\n   }\n\n   .card-pricing:not(.card-white){\n     ul li {\n        color: $white;\n     }\n   }\n\n   .card:not(.card-pricing){\n\n     &.card-wizard{\n       .card-body{\n         background: $white;\n       }\n       .card-footer{\n         background-color: $white !important;\n       }\n\n       .nav-pills .nav-item .nav-link p{\n         color: $black-states;\n       }\n     }\n\n     &.card-stats {\n       hr{\n         border-color: rgba($black-states,0.1);\n       }\n       .card-title{\n         color: $black-states;\n       }\n       .card-category, .stats{\n         color: $card-stats-gray;\n       }\n\n     }\n\n   }\n\n   .card-timeline .timeline>li.timeline-inverted>.timeline-panel{\n     background: $white;\n     .timeline-body p{\n       color: $black-states;\n     }\n\n     &:after, &:before{\n       border-right-color: $white;\n       border-left-color: $white;\n     }\n   }\n\n   .card-timeline .timeline:before{\n     background-color: $light-gray;\n   }\n\n\n}\n",".card{\n    background: $card-black-background;\n    border: 0;\n    position: relative;\n    width: 100%;\n    margin-bottom: 30px;\n    box-shadow: $box-shadow;\n\n    label{\n      color: rgba($white, 0.6);\n    }\n\n    .card-title {\n      margin-bottom: .75rem;\n    }\n\n    .card-body{\n      padding: 15px;\n\n      &.table-full-width{\n        padding-left: 0;\n        padding-right: 0;\n      }\n\n      .card-title{\n        color: $white;\n        text-transform: inherit;\n        font-weight: $font-weight-light;\n        margin-bottom: .75rem;\n      }\n\n      .card-description, .card-category{\n        color: rgba($white, 0.6);\n      }\n\n    }\n\n    .card-header{\n      &:not([data-background-color]){\n        background-color: transparent;\n      }\n      padding: 15px 15px 0;\n      border: 0;\n      color: rgba($white,0.8);\n\n      .card-title{\n          color: $white;\n          font-weight: 100;\n      }\n\n      .card-category{\n        color: $dark-gray;\n        margin-bottom: 5px;\n        font-weight: 300;\n      }\n    }\n\n    .map{\n        border-radius: $border-radius-sm;\n\n        &.map-big{\n          height: 420px;\n        }\n    }\n\n    &.card-white{\n      background: $white;\n\n      .card-title{\n        color: $black;\n      }\n      .card-category, .stats{\n        color: $card-stats-gray;\n      }\n\n      //style for inputs\n\n      @include form-control-placeholder(rgba($black,0.4), 1);\n        .has-danger{\n          .form-control, .input-group-prepend .input-group-text{\n            border-color: $danger-states;\n          }\n        }\n\n        .input-group-prepend .input-group-text{\n          border-color: rgba($black-states,0.2);\n          color: $black-states;\n        }\n\n        .form-control{\n          color: $black;\n          border-color: rgba($black-states,0.2);\n          &:focus{\n            border-color: $primary;\n          }\n        }\n        label:not(.btn){\n          color: $default;\n        }\n\n      .form-group.no-border,\n      .input-group.no-border {\n          .form-control,\n          .form-control + .input-group-prepend .input-group-text,\n          .form-control + .input-group-append .input-group-text,\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text{\n            background-color: $opacity-gray-3;\n              &:focus,\n              &:active,\n              &:active{\n                background-color: $opacity-gray-5;\n              }\n          }\n\n          .form-control {\n              &:focus {\n                  & + .input-group-prepend .input-group-text,\n                  & + .input-group-append .input-group-text{\n                    background-color: $transparent-bg;\n                  }\n              }\n          }\n\n\n      }\n\n      .input-group[disabled]{\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text{\n              background-color: $black;\n          }\n      }\n\n      .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\n        background: $light-gray;\n        border-color: rgba($black-states,0.3);\n      }\n\n      .input-group-focus{\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text,\n          .form-control{\n            background-color: $white;\n            border-color: $primary;\n          }\n\n          &.no-border{\n              .input-group-prepend .input-group-text,\n              .input-group-append .input-group-text{\n\n                  background-color: $opacity-gray-5;\n              }\n          }\n      }\n      .input-group-prepend .input-group-text {\n          border-right: none;\n      }\n\n      .input-group-append .input-group-text {\n          border-left: none;\n      }\n\n      .has-danger .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n        border-color: $danger-states;\n      }\n\n      .has-success .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n        border-color: darken($success, 10%);\n      }\n    }\n\n\n    &.card-plain {\n      background: transparent;\n      box-shadow: none;\n    }\n\n    .image{\n        overflow: hidden;\n        height: 200px;\n        position: relative;\n    }\n\n    .avatar{\n        width: 30px;\n        height: 30px;\n        overflow: hidden;\n        border-radius: 50%;\n        margin-bottom: 15px;\n    }\n\n    label{\n        font-size: $font-size-sm;\n        margin-bottom: 5px;\n\n    }\n\n    .card-footer{\n        background-color: transparent;\n        border: 0;\n        padding: 15px;\n\n\n        .stats{\n            i{\n                margin-right: 5px;\n                position: relative;\n\n            }\n        }\n\n        h6{\n          margin-bottom: 0;\n          padding: 7px 0;\n        }\n    }\n}\n\n.card-body{\n  padding: $card-spacer-y;\n}\n",".card-chart {\n  overflow: hidden;\n  .card-header{\n    .card-title{\n      i{\n        font-size: 16px;\n        margin-right: 5px;\n        margin-bottom: 3px;\n      }\n    }\n    .card-category{\n      margin-bottom: 5px;\n    }\n  }\n    .card-body{\n      padding-left: 5px;\n      padding-right: 5px;\n      .tab-space{\n        padding: 0;\n      }\n    }\n  .table{\n    margin-bottom: 0;\n\n    td{\n      border-top: none;\n      border-bottom: 1px solid rgba($white,0.1);\n    }\n  }\n\n  .card-progress {\n    margin-top: 30px;\n    padding: 0 10px;\n  }\n\n  .chart-area {\n    height: 220px;\n    width: 100%;\n  }\n  .card-footer {\n    margin-top: 15px;\n\n    .stats{\n      color: $dark-gray;\n    }\n  }\n\n  .dropdown{\n    position: absolute;\n    right: 20px;\n    top: 20px;\n\n    .btn{\n      margin: 0;\n    }\n  }\n\n  &.card-chart-pie{\n    .chart-area{\n      padding: 10px 0 25px;\n      height: auto;\n    }\n\n    .card-title{\n      margin-bottom: 10px;\n      i{\n        font-size: 1rem;\n      }\n    }\n\n  }\n\n}\n\n@include media-breakpoint-down(sm) {\n  .card.card-chart {\n    .card-header .btn-group-toggle {\n      .tim-icons {\n        font-size: $font-size-base;\n        top: -1px;\n      }\n    }\n  }\n}\n",".map{\n    height: 500px;\n}\n",".card-user{\n  overflow: hidden;\n    .image{\n        height: 120px;\n    }\n\n    .author{\n        text-align: center;\n        text-transform: none;\n        margin-top: 25px;\n\n        a +  p.description{\n            margin-top: -7px;\n        }\n\n        .block{\n          position: absolute;\n          height: 100px;\n          width: 250px;\n          &.block-one{\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\n            @include nc-rotate(150deg,10);\n            margin-top: -90px;\n            margin-left: -50px;\n          }\n\n          &.block-two{\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\n            @include nc-rotate(30deg,10);\n            margin-top: -40px;\n            margin-left: -100px;\n          }\n\n          &.block-three{\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\n            @include nc-rotate(170deg,10);\n            margin-top: -70px;\n            right: -45px;\n\n          }\n\n          &.block-four{\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\n            @include nc-rotate(150deg,10);\n            margin-top: -25px;\n            right: -45px;\n\n          }\n        }\n    }\n\n    .avatar{\n      width: 124px;\n      height: 124px;\n      border: 5px solid lighten($black,5%);\n      border-bottom-color: $transparent-bg;\n      background-color: $transparent-bg;\n      position: relative;\n    }\n\n    .card-body{\n        min-height: 240px;\n    }\n\n    hr{\n        margin: 5px 15px;\n    }\n\n    .button-container{\n        margin-bottom: 6px;\n        text-align: center;\n    }\n\n    .card-description {\n      margin-top: 30px;\n    }\n}\n",".card-tasks {\n  height: 473px;\n\n  .table-full-width {\n    max-height: 410px;\n    position: relative;\n  }\n\n  .card-header {\n    .title {\n      margin-right: 20px;\n      font-weight: $font-weight-normal;\n    }\n\n    .dropdown {\n      float: right;\n      color: darken($white, 20%);\n    }\n\n  }\n\n  .card-body {\n    i {\n      color: $dark-gray;\n      font-size: 1.4em;\n      &:hover {\n        color: $white;\n      }\n    }\n  }\n}\n","\n.card-animation-on-hover{\n  transition: all .3s cubic-bezier(.34,1.61,.7,1);\n  &:hover{\n    transform: translate3d(0,-5px,0);\n  }\n}\n",".card-collapse{\n    .card{\n        margin-bottom: 0px;\n        background: $transparent-bg;\n        box-shadow: none;\n\n        .card-header{\n            position: relative;\n            padding: 1rem 0.75rem;\n\n            a[data-toggle=\"collapse\"]{\n                display: block;\n                color: rgba($white,0.6);\n\n\n                i{\n                    float: right;\n                    position: relative;\n                    color: $primary;\n                    top: 1px;\n                    @extend .animation-transition-general;\n                }\n            }\n\n            &:after{\n                content: \"\";\n                position: absolute;\n                bottom: 0;\n                left: 0;\n                width: 100%;\n                height: 1px;\n                background: rgba($white,0.1);\n\n            }\n\n\n        }\n\n        .card-body{\n            padding-left: 1.5rem;\n            padding-right: 1.5rem;\n            color: rgba($white,0.5);\n        }\n\n        &:last-child{\n          .card-header:after{\n            content: none;\n          }\n        }\n    }\n}\n",".card-contributions{\n  @extend %card-stats;\n\n  .card-description{\n    max-width: 350px;\n    margin: 0 auto;\n    margin-bottom: 20px;\n  }\n\n  .card-title{\n    padding-top: 35px;\n  }\n\n  .card-stats{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    padding: 11px;\n  }\n\n  .card-footer{\n    [class*=\"col-\"]:not(:first-child):before{\n      content: \"\";\n      position: absolute;\n      left: 0;\n      width: 1px;\n      height: 100%;\n      background-color: rgba(0,0,0,0.1);\n    }\n  }\n\n  .bootstrap-switch{\n    margin: 0;\n  }\n\n  span{\n    padding-left: 15px;\n    text-align: left;\n    max-width: 125px;\n    color: $opacity-6;\n  }\n\n}\n\n\n@include media-breakpoint-down(xs){\n\n  .card-contributions .card-stats {\n    flex-direction: column;\n\n    .bootstrap-switch {\n      margin-bottom: 15px;\n    }\n  }\n}\n",".card-lock{\n    .card-header{\n        img{\n            width: 120px;\n            height: 120px;\n            border-radius: 50%;\n            margin-top: -60px;\n            box-shadow: $box-shadow-raised;\n        }\n    }\n\n}\n\n@include media-breakpoint-up(sm){\n  .card.card-lock {\n    margin-top: 13vh;\n  }\n}\n",".card-pricing {\n    position: relative;\n    z-index: 1;\n    box-shadow: none;\n    min-height: 400px;\n\n    .card-body {\n      overflow: hidden;\n      padding: 0;\n\n    .card-title {\n      position: relative;\n      font-size: 5em;\n      font-weight: 900;\n      color: $black;\n      text-transform: lowercase;\n      margin-left: -5px;\n      z-index: 1;\n\n      &.card-title-right {\n        text-align: right;\n        margin-right: -5px;\n      }\n    }\n\n    img {\n      position: absolute;\n      border-radius: $border-radius-sm;\n      top: 0;\n      left: 0;\n      width: 100%;\n      z-index: 0;\n    }\n\n    .card-prices{\n      .text-on-front{\n        position: relative;\n        z-index: 2;\n        color: rgba($white, 0.9);\n        font-size: 3.6em;\n        font-weight: 900;\n        text-align: center;\n        span{\n\n          font-size: 0.7em;\n        }\n      }\n\n      .text-on-back{\n        position: relative;\n        z-index: 1;\n        font-size: 9.5em;\n        text-align: center;\n        margin-top: -160px;\n        font-weight: 900;\n        color: rgba($default-states,0.1);\n      }\n\n      .plan{\n        font-weight: 600;\n        font-size: 0.8em;\n        margin-top: -80px;\n        text-align: center;\n        color: rgba($white,0.9);\n      }\n    }\n  }\n\n    ul{\n        list-style: none;\n        padding: 0;\n        max-width: 240px;\n        margin: 80px auto 40px;\n\n        li{\n            color: rgba($white, 0.9);\n            background: $transparent-bg;\n            text-align: center;\n            font-size: 1.2em;\n            font-weight: $font-weight-bold;\n            padding: 5px 0;\n            border: none;\n\n        }\n    }\n    &.card-white{\n      background: $white;\n      .card-body{\n        .card-title{\n          color:white;\n        }\n      }\n      .card-body .card-prices{\n        .text-on-front, .plan {\n            color: $default-states;\n            span{\n              color: $default-states;\n            }\n        }\n      }\n\n      ul li{\n\n        color: $default-states;\n      }\n\n      .list-group-item{\n        background: $transparent-bg;\n      }\n    }\n\n    &.card-primary{\n      .card-body .card-prices{\n        .text-on-back{\n          color: rgba($primary,0.1);\n        }\n      }\n    }\n\n    &.card-info{\n      .text-on-back{\n        color: rgba($info,0.1);\n      }\n    }\n\n    &.card-success{\n      .card-body .card-prices{\n        .text-on-back{\n          color: rgba($success,0.1);\n        }\n      }\n    }\n\n    &.card-warning{\n      .card-body .card-prices{\n        .text-on-back{\n          color: rgba($warning,0.1);\n        }\n      }\n    }\n\n    &.card-danger{\n      .card-body .card-prices{\n        .text-on-back{\n          color: rgba($danger,0.1);\n        }\n      }\n    }\n\n    &.card-raised{\n      z-index: 3;\n      box-shadow: 0px 0px 40px 15px rgba($default-states,0.3);\n      padding: 20px 0;\n      margin-top: -20px;\n      border-radius: $border-radius-sm;\n      img{\n        border-radius: $border-radius-sm;\n      }\n    }\n}\n\n@include media-breakpoint-up(md){\n  .pricing-page {\n    [class*=\"col-\"]{\n      &:first-child{\n          padding-right: 0;\n         .card:not(.card-raised){\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n      }\n      &:not(:first-child):not(:last-child) {\n        padding: 0;\n        .card:not(.card-raised){\n          border-radius: 0;\n          img{\n            border-radius: 0;\n          }\n        }\n      }\n      &:last-child {\n        padding-left: 0;\n        .card:not(.card-raised){\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n      }\n    }\n  }\n}\n","%card-profile{\n    margin-top: 30px;\n    text-align: center;\n\n    .card-body .card-title{\n        margin-top: 0;\n    }\n\n     [class*=col-]{\n        .card-description{\n            margin-bottom: 0;\n\n            & + .card-footer{\n                margin-top: 8px;\n            }\n        }\n\n\n     }\n\n    .card-header-avatar{\n        max-width: 130px;\n        max-height: 130px;\n        margin: -60px auto 0;\n\n        img{\n            border-radius: 50% !important;\n        }\n\n        & + .card-body{\n            margin-top: 15px;\n        }\n    }\n\n    &.card-plain{\n        .card-header-avatar{\n            margin-top: 0;\n        }\n    }\n    .card-body{\n        .card-avatar{\n            margin: 0 auto 30px;\n        }\n    }\n}\n\n.card-profile{\n  @extend %card-profile;\n}\n",".card-plain {\n  background: transparent;\n  box-shadow: none;\n\n  .card-header,\n  .card-footer {\n    margin-left: 0;\n    margin-right: 0;\n    background-color: transparent;\n  }\n\n  &:not(.card-subcategories).card-body {\n      padding-left: 0;\n      padding-right: 0;\n  }\n}\n",".card-register {\n  overflow: hidden;\n\n    .header {\n        margin-left: 20px;\n        margin-right: 20px;\n        padding: 30px 0;\n    }\n\n    .text-divider {\n        margin-top: 30px;\n        margin-bottom: 0px;\n        text-align: center;\n    }\n\n    .content {\n        padding: 0px 30px;\n    }\n\n    .form-check {\n        margin-top: 20px;\n        margin-left: 20px;\n\n        label:not(.form-check-label){\n          padding-left: 38px;\n        }\n    }\n\n    .card-header {\n      padding: 0 0 50px;\n      overflow: hidden;\n\n      .card-title {\n        position: relative;\n        font-size: 5em;\n        font-weight: 900;\n        color: $black;\n        text-transform: lowercase;\n        margin-left: -5px;\n        z-index: 1;\n      }\n    }\n\n    .card-img {\n      position: absolute;\n      left: 0;\n      top: -15%;\n      width: 70%;\n    }\n\n    .social-line {\n        margin-top: 20px;\n        text-align: center;\n\n        .btn.btn-icon ,\n        .btn.btn-icon .btn-icon {\n            margin-left: 5px;\n            margin-right: 5px;\n            box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);\n        }\n    }\n\n    .card-footer {\n        margin-bottom: 10px;\n        margin-top: 24px;\n    }\n\n    &.card-white{\n      .card-header .card-title{\n        color: $white;\n      }\n    }\n}\n\n@include media-breakpoint-down(md){\n  .card.card-register .card-img {\n    width: 95%;\n  }\n}\n","%card-stats {\n  hr {\n    margin: 5px 15px;\n  }\n}\n\n.card-stats {\n    @extend %card-stats;\n\n   .info-icon {\n     height: 50px;\n     width: 50px;\n     border-radius: 50%;\n     @include diagonal-gradient($primary,$primary-states);\n\n     i {\n       color: $white;\n       font-size: 1.7em;\n       padding: 14px 13px;\n\n     }\n\n     &.icon-danger {\n       @include diagonal-gradient($danger,$danger-states);\n     }\n\n     &.icon-warning {\n       @include diagonal-gradient($warning,$warning-states);\n     }\n\n     &.icon-success {\n       @include diagonal-gradient($success,$success-states);\n     }\n\n     &.icon-info {\n       @include diagonal-gradient($info,$info-states);\n     }\n\n     &.icon-primary {\n       @include diagonal-gradient($primary,$primary-states);\n     }\n   }\n\n   .numbers{\n     text-align: right;\n     .card-title{\n       margin-top: 0;\n     }\n     .card-category{\n       margin-bottom: 0;\n       color: $dark-gray;\n     }\n   }\n\n   .card-footer{\n     padding: 0;\n   }\n\n   hr{\n     border-color: lighten($black,5%);\n   }\n\n   .stats{\n     color: rgba($white, 0.6);\n     margin: 10px 15px;\n     font-size: 0.9em;\n   }\n\n  &.card-white {\n    hr{\n      border-color: rgba(43, 53, 83, 0.2)\n    }\n  }\n}\n\n@include media-breakpoint-down(sm){\n  .card-stats [class*=\"col-\"] .statistics::after {\n    display: none;\n  }\n}\n",".card-subcategories .card-body{\n    padding-bottom: 30px;\n}\n",".card-testimonial{\n    @extend %card-profile;\n\n    .card-body{\n        padding-top: 25px;\n    }\n\n    .card-description + .card-title{\n        margin-top: 20px;\n    }\n\n    .card-footer{\n        margin-top: 0;\n        margin-bottom: 2.5rem;\n    }\n    .card-description{\n        & + .card-title{\n            margin-top: 30px;\n        }\n    }\n    .icon{\n        i{\n            font-size: 32px;\n        }\n\n        &.icon-primary i{\n            color: $primary;\n        }\n\n        &.icon-info i{\n            color: $info;\n        }\n\n        &.icon-danger i{\n            color: $danger;\n        }\n\n        &.icon-warning i{\n            color: $warning;\n        }\n\n        &.icon-success i{\n            color: $success;\n        }\n    }\n}\n",".card-wizard{\n  .card-header{\n    padding-bottom: 10px;\n  }\n}\n\n@include media-breakpoint-down(xs){\n\n  .card-wizard .card-footer .pull-left {\n    padding-left: 0;\n    float: none;\n    text-align: center;\n  }\n\n  .card-wizard .card-footer .pull-right {\n    padding-right: 0;\n    float: none;\n    text-align: center;\n  }\n\n}\n",".noUi-vertical {\n  width: 1px;\n  height: 100%;\n  .noUi-handle {\n    outline: none;\n    border-radius: 50%;\n    height: 15px;\n    width: 15px;\n    cursor: pointer;\n    left: -7px;\n    top: -10px;\n  }\n}\n",".rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n.rbc-abs-full,\n.rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.rbc-ellipsis,\n.rbc-event-label,\n.rbc-row-segment .rbc-event-content,\n.rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-rtl {\n  direction: rtl;\n}\n.rbc-off-range {\n  color: #333333;\n  opacity: 0.3;\n}\n// .rbc-off-range-bg {\n//   background: #e5e5e5;\n// }\n.rbc-header,\n.rbc-header > a,\n.rbc-header > a:active,\n.rbc-header > a:visited,\n.rbc-header > a:hover,\n.rbc-time-gutter.rbc-time-column {\n  overflow: hidden;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 1em;\n  color: rgba(255, 255, 255, 0.4);\n  box-sizing: content-box;\n  text-align: right;\n  font-weight: bold;\n  line-height: 1.5;\n  text-decoration: none;\n  &:last-child {\n    span {\n      padding-right: 15px;\n    }\n  }\n  .rbc-time-slot {\n    font-weight: 400;\n  }\n}\n\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n  min-height: 173px;\n}\n.rbc-toolbar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 1em;\n  font-size: 16px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  -webkit-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n  margin: 0;\n  font-size: 1.8em;\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 400;\n  font-family: inherit;\n  line-height: 1.2;\n}\n.rbc-toolbar button {\n  border-width: $border-thick;\n  font-weight: $font-weight-normal;\n  font-size: $font-size-sm;\n  line-height: $line-height;\n  margin: 5px 1px;\n  border: none;\n  margin: 10px 1px;\n  border-radius: $border-radius-sm;\n  padding: 8px 20px;\n  cursor: pointer;\n  -webkit-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  outline: none;\n  text-transform: lowercase;\n  &::-moz-focus-inner {\n    border: 0;\n  }\n  @include btn-styles($info, $info-states);\n}\n.rbc-toolbar button:focus {\n  outline: none;\n}\n.rbc-btn-group {\n  display: inline-block;\n  &:last-child {\n    button:not(.rbc-active):not(:hover) {\n      opacity: 0.5;\n    }\n  }\n}\n\n.rbc-btn-group button {\n  margin: 0 0 0 2px;\n}\n@media screen and (max-width: 526px) {\n  .rbc-btn-group button {\n    margin: 2px !important;\n  }\n}\n\n.rbc-btn-group button + button {\n  margin: 0 0 0 2px;\n}\n// .rbc-rtl .rbc-btn-group button + button {\n//   margin-left: 0;\n//   margin-right: -1px;\n// }\n.rbc-btn-group + .rbc-btn-group,\n.rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-slot-selecting .rbc-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-event.rbc-selected {\n  background-color: #265985;\n}\n.rbc-event-label {\n  font-size: 80%;\n}\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-after {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-prior {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-row-segment {\n  padding: 2px 6px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-month-view {\n  position: relative;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n  border-left: none;\n  border-right: none;\n}\n.rbc-month-view {\n  border-top: none;\n}\n.rbc-month-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  // -webkit-flex-basis: 0px;\n  -ms-flex-preferred-size: 0px;\n  // flex-basis: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row {\n  border-style: solid;\n  border-width: 1px;\n  padding: 0;\n  vertical-align: top;\n  border-color: #2b3553;\n  border-bottom: 0;\n  border-right: 0;\n  border-left: 0;\n}\n.rbc-date-cell {\n  flex: 1 1;\n  min-width: 0;\n  padding-right: 3px;\n  padding-top: 1px;\n  text-align: right;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a,\n.rbc-date-cell > a:active,\n.rbc-date-cell > a:visited {\n  color: white;\n  text-decoration: none;\n}\n.rbc-row-bg {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n.rbc-day-bg {\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #2b3553;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #2b3553;\n}\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n.rbc-agenda-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #2b3553;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #2b3553;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #2b3553;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #2b3553;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #2b3553;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n  color: rgba(255, 255, 255, 0.6);\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: \" »\";\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: \"« \";\n}\n.rbc-agenda-date-cell {\n  color: rgba(255, 255, 255, 0.8);\n}\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n.rbc-agenda-event-cell {\n  width: 100%;\n  color: rgba(255, 255, 255, 0.8);\n}\n.rbc-time-column {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  box-sizing: border-box;\n}\n.rbc-timeslot-group {\n  border-bottom: 1px solid #2b3553;\n  min-height: 40px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-flow: column nowrap;\n  -ms-flex-flow: column nowrap;\n  flex-flow: column nowrap;\n}\n.rbc-time-gutter,\n.rbc-header-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-label {\n  padding: 0 5px;\n}\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 10px;\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-flex-flow: column wrap;\n  -ms-flex-flow: column wrap;\n  flex-flow: column wrap;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-event-label {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n  font-weight: bold;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  color: #fff;\n  white-space: nowrap;\n  text-align: end;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -webkit-flex: 1 1 0;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot + .rbc-time-slot {\n  border-top: 1px dotted #2b3553;\n}\n.rbc-time-slot {\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n.rbc-day-header {\n  text-align: center;\n}\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n.rbc-slot-selecting {\n  cursor: move;\n}\n.rbc-time-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  box-sizing: content-box;\n  width: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  box-sizing: border-box;\n  min-height: 20px;\n}\n.rbc-time-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #ddd;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #ddd;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #ddd;\n}\n.rbc-time-header-content {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 0;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-left: 1px solid #2b3553;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #2b3553;\n}\n.rbc-time-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 3px solid $default;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #2b3553;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #2b3553;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n.rbc-event {\n  width: 100%;\n  position: relative; /* for resize handle and other inner positioning */\n  display: block; /* make the <a> tag block */\n  font-size: 0.85em;\n  border-radius: 2px;\n  padding: 0;\n  background-color: $default; /* default BACKGROUND color */\n  // @include shadow-big-color($brand-success);\n  font-weight: normal; /* undo jqui's ui-widget-header bold */\n  text-align: left;\n  border: none;\n  padding-bottom: 1px;\n  line-height: 1.2;\n\n  &.event-azure {\n    background-color: $brand-info;\n  }\n  &.event-green {\n    background-color: darken($brand-success, 10%);\n  }\n  &.event-orange {\n    background-color: $brand-warning;\n  }\n  &.event-red {\n    background-color: $brand-danger;\n  }\n\n  .rbc-event-content {\n    position: relative;\n    z-index: 2;\n    white-space: nowrap;\n    overflow: hidden;\n    color: white;\n    padding: 0 5px;\n    text-align: right;\n  }\n}\n.rbc-day-slot .rbc-event {\n  display: block !important;\n  max-height: unset !important;\n}\n\n.rbc-today {\n  background-color: #252e49;\n}\n@media screen and (max-width: 1373px) {\n  .rbc-toolbar {\n    display: block;\n    .rbc-btn-group {\n      display: block;\n      text-align: center;\n    }\n    .rbc-toolbar-label {\n      display: block;\n      flex-grow: unset;\n      padding: 0;\n    }\n  }\n}\n.rbc-row.rbc-time-header-cell {\n  border-bottom: 1px solid #2b3553;\n}\n.rbc-time-view {\n  .rbc-row-content {\n    min-height: unset;\n  }\n}\n.perfect-scrollbar-on .rbc-calendar .rbc-row-content {\n  min-height: 115px;\n}\n@include media-breakpoint-down(sm) {\n  .rbc-calendar .rbc-row-content {\n    min-height: 45px;\n  }\n}\n@include media-breakpoint-down(md) {\n  .rbc-calendar .rbc-row-content {\n    min-height: 90px;\n  }\n}\n",".sweet-alert {\n  padding: 40px 20px !important;\n  h2,\n  h2 * {\n    color: #595959;\n    font-size: 30px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: none;\n    position: relative;\n    margin: 0 0 0.4em;\n    padding: 0;\n    display: block;\n    word-wrap: break-word;\n  }\n  .lead {\n    font-size: 18px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    float: none;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n    color: #545454 !important;\n    word-wrap: break-word;\n  }\n  input.form-control {\n    color: black;\n  }\n  margin: auto !important;\n}\n","/* ========================================================================\n * bootstrap-switch - v3.3.4\n * http://www.bootstrap-switch.org\n * ========================================================================\n * Copyright 2012-2013 Mattia Larentis\n * http://www.apache.org/licenses/LICENSE-2.0\n */\n\n//* IMPORTANT! Creative Tim Notice: this file has major changes to fit the Black Dashboard 's design. If you want to use the plugin as it was before our changes, please get the old files from http://www.bootstrap-switch.org\n\n.bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 0;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.13);\n  margin-bottom: 10px;\n  line-height: 8px;\n  width: 59px !important;\n  height: 22px;\n  outline: none;\n  z-index: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out 0.15s,\n    box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  background: url(\"https://d2v9y0dukr6mq2.cloudfront.net/video/thumbnail/J9H9WF0/night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png\");\n  background-position: center center;\n  background-size: cover;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-flex;\n  top: 0;\n  height: 22px;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  width: 100px !important;\n}\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block !important;\n  height: 100%;\n  color: #fff;\n  padding: 6px 10px;\n  font-size: 11px;\n  text-indent: -5px;\n  line-height: 15px;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n}\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n  float: left;\n  line-height: 11px;\n  width: 50% !important;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-brown,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-brown {\n  color: #fff;\n  background: $brand-primary;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-blue,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-blue {\n  color: #fff;\n  background: $brand-info;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-green,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-green {\n  color: #fff;\n  background: $brand-success;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-orange,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-orange {\n  background: $brand-warning;\n  color: #fff;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-red,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-red {\n  color: #fff;\n  background: $brand-danger;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n  color: #fff;\n}\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  z-index: 100;\n  color: #333333;\n  background: #ffffff;\n  width: 18px !important;\n  height: 18px !important;\n  margin: 0px -11px;\n  border-radius: 20px;\n  position: absolute;\n  float: left;\n  top: 2px;\n  left: 51%;\n  padding: 0;\n  box-shadow: 0 1px 11px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label {\n  background-color: rgba(156, 156, 156, 0.9);\n  left: 52%;\n}\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n  width: 27px !important;\n  margin-left: -20px;\n}\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n  width: 27px !important;\n  margin-left: -11px;\n}\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-indent: 6px;\n}\n.bootstrap-switch input[type=\"radio\"],\n.bootstrap-switch input[type=\"checkbox\"] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n.bootstrap-switch input[type=\"radio\"].form-control,\n.bootstrap-switch input[type=\"checkbox\"].form-control {\n  height: auto;\n}\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n  padding: 6px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n}\n.bootstrap-switch.bootstrap-switch-disabled,\n.bootstrap-switch.bootstrap-switch-readonly,\n.bootstrap-switch.bootstrap-switch-indeterminate {\n  cursor: default !important;\n}\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n.bootstrap-switch.bootstrap-switch-focused {\n  // border-color: #66afe9;\n  // outline: 0;\n  // -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\n  // box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n// .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label,\n// .bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-off .bootstrap-switch-label {\n//   border-bottom-right-radius: 3px;\n//   border-top-right-radius: 3px;\n// }\n// .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label,\n// .bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-on .bootstrap-switch-label {\n//   border-bottom-left-radius: 3px;\n//   border-top-left-radius: 3px;\n// }\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n  margin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n  margin-left: -39px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label {\n  &:before {\n    background-color: #ffffff;\n  }\n}\n\n.bootstrap-switch.bootstrap-switch-on\n  .bootstrap-switch-red\n  ~ .bootstrap-switch-default {\n  background-color: $brand-danger;\n}\n\n.bootstrap-switch.bootstrap-switch-on\n  .bootstrap-switch-orange\n  ~ .bootstrap-switch-default {\n  background-color: $brand-warning;\n}\n\n.bootstrap-switch.bootstrap-switch-on\n  .bootstrap-switch-green\n  ~ .bootstrap-switch-default {\n  background-color: $brand-success;\n}\n\n.bootstrap-switch.bootstrap-switch-on\n  .bootstrap-switch-brown\n  ~ .bootstrap-switch-default {\n  background-color: $brand-primary;\n}\n\n.bootstrap-switch.bootstrap-switch-on\n  .bootstrap-switch-blue\n  ~ .bootstrap-switch-default {\n  background-color: $brand-info;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-red,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-brown,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-blue,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-orange,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-green {\n  background-color: $light-gray;\n}\n\n.bootstrap-switch-on .bootstrap-switch-handle-off,\n.bootstrap-switch-off .bootstrap-switch-handle-on {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.bootstrap-switch-off:before {\n  position: absolute;\n  content: \"\";\n  height: 100%;\n  width: 100%;\n  top: 0;\n  right: 0;\n  background: rgba(16, 16, 16, 0.7);\n}\n\n.bootstrap-switch.wrapper {\n  height: unset;\n}\n",".card-wizard {\n  min-height: 410px;\n  background: transparent !important;\n  box-shadow: none !important;\n  opacity: 0;\n  @include transition($general-transition-time, $transition-linear);\n\n  &.active {\n    opacity: 1;\n  }\n\n  @include set-wizard-color($primary);\n\n  .card-header {\n    background-color: unset;\n  }\n  .input-group.has-danger .error {\n    display: block;\n    width: 100%;\n    margin-top: 3px;\n  }\n\n  &[data-color=\"primary\"] {\n    @include set-wizard-color($primary);\n  }\n\n  &[data-color=\"green\"] {\n    @include set-wizard-color(darken($success, 10%));\n  }\n\n  &[data-color=\"blue\"] {\n    @include set-wizard-color($info);\n  }\n\n  &[data-color=\"red\"] {\n    @include set-wizard-color($danger);\n  }\n\n  &[data-color=\"orange\"] {\n    @include set-wizard-color($warning);\n  }\n\n  .nav-pills .nav-item {\n    position: relative;\n    .nav-link {\n      height: 45px;\n      width: 45px;\n      min-width: 45px;\n      border-radius: 50% !important;\n      position: absolute;\n      left: 50%;\n      top: -20px;\n      transform: translate(-50%);\n      background-color: white;\n      p {\n        position: absolute;\n        top: 110%;\n        left: 50%;\n        transform: translate(-50%);\n        font-weight: $font-weight-normal;\n        color: $white;\n      }\n\n      &:hover,\n      &:focus {\n        background-color: white;\n      }\n    }\n  }\n\n  .nav-pills .nav-item .nav-link.active,\n  .nav-pills .nav-item .nav-link:hover,\n  .nav-pills .nav-item .nav-link:focus,\n  .nav-pills .nav-item .nav-link.active:focus,\n  .nav-pills .nav-item .nav-link.active:hover {\n    box-shadow: none;\n  }\n\n  .picture-container {\n    position: relative;\n    cursor: pointer;\n    text-align: center;\n  }\n\n  .card-body {\n    background: $black;\n    border-top-left-radius: $border-radius-lg;\n    border-top-right-radius: $border-radius-lg;\n    margin-top: 20px;\n  }\n\n  .card-footer {\n    background-color: $black !important;\n    border-bottom-left-radius: $border-radius-lg;\n    border-bottom-right-radius: $border-radius-lg;\n\n    div:first-child {\n      padding-right: 80px;\n    }\n    div:nth-child(2) {\n      padding-left: 80px;\n    }\n  }\n\n  .wizard-navigation {\n    position: relative;\n    margin: 80px auto 60px;\n\n    .nav-link {\n      display: flex;\n      align-items: center;\n      -ms-flex-pack: center;\n      justify-content: center;\n      cursor: pointer;\n    }\n\n    .progress-with-circle {\n      position: relative;\n      top: 5px;\n      height: 5px;\n      border-radius: $border-radius-lg;\n\n      .progress-bar {\n        height: 100%;\n        border-radius: $border-radius-lg;\n        box-shadow: none;\n        -webkit-transition: width 0.3s ease;\n        -o-transition: width 0.3s ease;\n        transition: width 0.3s ease;\n      }\n    }\n  }\n\n  .wizard-navigation .nav-link i,\n  .moving-tab i {\n    display: inline-block;\n    font-size: 19px;\n    line-height: initial;\n    padding: 0;\n    vertical-align: bottom;\n  }\n\n  .picture {\n    width: 106px;\n    height: 106px;\n    background-color: #999999;\n    border: 1px solid $light-gray;\n    color: #ffffff;\n    border-radius: 50%;\n    margin: 5px auto;\n    overflow: hidden;\n    transition: all 0.2s;\n    -webkit-transition: all 0.2s;\n\n    &:hover {\n      border-color: #2ca8ff;\n    }\n  }\n\n  .picture input[type=\"file\"] {\n    cursor: pointer;\n    display: block;\n    height: 100%;\n    left: 0;\n    opacity: 0 !important;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  .picture-src {\n    width: 100%;\n  }\n\n  .tab-content {\n    padding: 20px 0;\n  }\n\n  .wizard-footer {\n    padding: 0 15px;\n\n    .checkbox {\n      margin-top: 16px;\n    }\n  }\n\n  .disabled {\n    display: none;\n  }\n\n  .wizard-header {\n    text-align: center;\n    padding: 25px 0 35px;\n\n    h5 {\n      margin: 5px 0 0;\n    }\n  }\n\n  .nav-pills > li {\n    text-align: center;\n  }\n\n  .btn {\n    text-transform: uppercase;\n  }\n\n  .info-text {\n    text-align: center;\n    font-weight: 300;\n    margin: 10px 0 30px;\n  }\n\n  .choice {\n    text-align: center;\n    cursor: pointer;\n    margin-top: 20px;\n\n    &[disabled] {\n      pointer-events: none;\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n\n    .icon {\n      text-align: center;\n      vertical-align: middle;\n      height: 116px;\n      width: 116px;\n      border-radius: 50%;\n      color: $default;\n      margin: 0 auto 20px;\n      border: 1px solid $light-gray;\n      transition: all 0.2s;\n      -webkit-transition: all 0.2s;\n    }\n\n    i {\n      font-size: 30px;\n      line-height: 116px;\n      position: absolute;\n      left: 0;\n      right: 0;\n    }\n\n    &:hover,\n    &.active {\n      .icon {\n        border-color: #2ca8ff;\n      }\n    }\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      left: -10000px;\n      z-index: -1;\n    }\n  }\n\n  .btn-finish {\n    display: none;\n  }\n\n  .card-title + .description {\n    font-size: 17px;\n    margin-bottom: 32px;\n  }\n\n  .wizard-title {\n    margin: 0;\n  }\n\n  .nav-pills {\n    background-color: $white;\n    border-radius: $border-radius-lg;\n    height: 5px;\n\n    > li + li {\n      margin-left: 0;\n    }\n\n    > li > a {\n      border: 0 !important;\n      border-radius: 0;\n      line-height: 18px;\n      text-transform: uppercase;\n      font-size: 12px;\n      font-weight: 500;\n      min-width: 100px;\n      text-align: center;\n      color: #555555;\n    }\n\n    > li.active > a,\n    > li.active > a:hover,\n    > li.active > a:focus,\n    > li > a:hover,\n    > li > a:focus {\n      background-color: inherit;\n      box-shadow: none;\n    }\n\n    > li i {\n      display: block;\n      font-size: 30px;\n      padding: 15px 0;\n    }\n  }\n}\n","/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n  position: relative;\n  .rdtPicker {\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    margin-top: -20px;\n    visibility: hidden;\n    display: block;\n    opacity: 0;\n  }\n  &.rdtOpen {\n    .rdtPicker {\n      opacity: 1;\n      visibility: visible;\n      margin-top: 0;\n    }\n  }\n}\n.rdtPicker {\n  display: none;\n  position: absolute;\n  width: 260px;\n  padding: 4px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border-radius: 0.125rem;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n\n  &:before {\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    top: -5px;\n    left: 10px;\n    right: auto;\n    color: #ffffff;\n    border-bottom: 0.4em solid;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n  }\n  &:after {\n    border-bottom: 0.4em solid #ffffff;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: -5px;\n    left: 10px;\n  }\n}\n\n.rdtPicker {\n  display: block;\n  top: 40px;\n}\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 10px;\n  border-radius: 4px;\n  visibility: hidden;\n  position: relative;\n  &:before {\n    visibility: visible;\n    width: 100%;\n    height: 100%;\n    border-radius: 3px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font: normal normal normal 1em/1 \"Nucleo\";\n    font-size: 18px;\n    content: \"\\EA5E\";\n  }\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: $white !important;\n}\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n.rdtPicker td {\n  cursor: pointer;\n}\n.rdtDay {\n  height: 30px;\n  line-height: 33px;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n  &.rdtToday.rdtActive,\n  &.rdtActive,\n  &.rdtActive:hover {\n    background-color: $primary !important;\n    color: $white !important;\n  }\n}\n.rdtDays {\n  tr {\n    .dow {\n      text-align: center;\n      font-size: 12px;\n      font-weight: inherit;\n      padding-bottom: 5px;\n      padding-top: 10px;\n      font-weight: 300;\n      font-size: 14px;\n      width: 20px;\n      height: 20px;\n    }\n    .rdtDay {\n      color: $dark-gray;\n      &.rdtOld,\n      &.rdtNew {\n        color: $default;\n        font-weight: 300;\n      }\n    }\n  }\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover,\n.rdtPicker .rdtTimeToggle:hover:before {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker .dow {\n  width: 14.2857%;\n  border-bottom: none;\n}\n.rdtPicker th.rdtSwitch {\n  width: 50px;\n  padding: 5px;\n  border-radius: 3px;\n  height: 20px;\n  line-height: 20px;\n  font-weight: 300;\n  padding: 5px;\n}\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  border-radius: 50%;\n  height: 27px;\n  width: 27px;\n  display: block;\n  &:before {\n    top: 2px;\n    font-size: 12px;\n    border-radius: 50%;\n    text-align: center;\n    position: relative;\n    display: inline-block;\n    font: normal normal normal 1em/1 \"Nucleo\";\n    vertical-align: middle;\n    speak: none;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n  }\n  span {\n    display: none;\n  }\n}\n\n.rdtPicker {\n  .dow,\n  th.rdtSwitch,\n  th.rdtNext,\n  th.rdtPrev,\n  .rdtTimeToggle {\n    color: $primary;\n  }\n}\n\n.rdtPicker th.rdtNext {\n  &:before {\n    content: \"\\ea35\";\n  }\n}\n\n.rdtPicker th.rdtPrev {\n  &:before {\n    content: \"\\ea34\";\n  }\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters {\n  > div {\n    float: left;\n    width: 40px;\n    font-weight: inherit;\n    margin: 3px;\n    border-radius: 50%;\n  }\n  .rdtCounterSeparator {\n    width: 0;\n    border: 1px solid transparent;\n  }\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n  .rdtCount {\n    padding: 7px;\n    height: 40px;\n    border: 1px solid transparent;\n  }\n}\n.rdtCounters {\n  .rdtCounter:last-child {\n    .rdtCount {\n      color: $primary;\n      border-radius: 50%;\n      border: 1px solid $primary;\n    }\n  }\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: $medium-gray;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n\n  // cursor: pointer;\n  // display: block;\n  // user-select: none;\n  // padding: 0;\n  // border-width: 0;\n  // color: #fff;\n  // background-color: transparent;\n  // cursor: pointer;\n  // @include btn-styles($primary, $primary-states-color);\n  // margin: 2px 0;\n  // transition: 0.3s ease-in-out;\n  // &:hover{\n  //   background-position: bottom left;\n  // }\n  // font-weight: 600;\n  // font-size: 1em;\n  // width: 40px;\n  // height: 40px;\n  // line-height: 40px;\n  // border: none;\n  // position: relative;\n  // overflow: hidden;\n  // border-radius: 0.4285rem;\n  // user-select: none;\n  // display: inline-block;\n  // text-align: center;\n  // white-space: nowrap;\n  // vertical-align: middle;\n}\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n.rdtCounter .rdtCount {\n  font-size: inherit;\n  line-height: 25px;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: inherit;\n  margin-top: 37px;\n}\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n  .rdtMonth,\n  .rdtYear {\n    display: inline-block;\n    width: 56px;\n    height: 56px;\n    line-height: 56px;\n    margin: 3px 3px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n\n    &.rdtActive {\n      background-color: $primary !important;\n      color: $white;\n    }\n  }\n}\n","svg {\n  touch-action: none;\n}\n\n.jvectormap-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  touch-action: none;\n}\n\n.jvectormap-tip {\n  // design changed by www.creative-tim.com\n  position: absolute;\n  display: none;\n  color: $default;\n  line-height: 1.5em;\n  background: $white;\n  border: none;\n  border-radius: $border-radius-xl;\n  padding: 5px 10px;\n  z-index: 1040;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout,\n.jvectormap-goback {\n  position: absolute;\n  left: 10px;\n  border-radius: 3px;\n  background: #292929;\n  padding: 3px;\n  color: white;\n  cursor: pointer;\n  line-height: 10px;\n  text-align: center;\n  box-sizing: content-box;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  width: 10px;\n  height: 10px;\n}\n\n.jvectormap-zoomin {\n  top: 10px;\n}\n\n.jvectormap-zoomout {\n  top: 30px;\n}\n\n.jvectormap-goback {\n  bottom: 10px;\n  z-index: 1000;\n  padding: 6px;\n}\n\n.jvectormap-spinner {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: center no-repeat\n    url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n  font-weight: bold;\n  font-size: 14px;\n  text-align: center;\n}\n\n.jvectormap-legend-cnt {\n  position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n  bottom: 0;\n  right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n  top: 0;\n  right: 0;\n}\n\n.jvectormap-legend {\n  background: black;\n  color: white;\n  border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n  float: left;\n  margin: 0 10px 10px 0;\n  padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n  float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n  margin: 10px 10px 0 0;\n  padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n  width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n  height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n  height: 20px;\n  width: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n  font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n  text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 20px;\n  padding-left: 3px;\n}\n","/**\n* React Select v1.0.0-rc.10\n* ============\n* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/\n* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n* MIT License: https://github.com/JedWatson/react-select\n*/\n\n/*\nThis file was modified entirely by Creative Tim for React-Select v2.0.0\n*/\n\n.react-select {\n  .react-select__menu {\n    top: 105%;\n    max-width: 94%;\n    width: 94%;\n    right: 3%;\n    border-radius: 12px;\n    border: 0;\n    box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);\n    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s,\n      opacity 0.3s ease 0s, height 0s linear 0.35s;\n    background-color: $white;\n    box-sizing: border-box;\n    max-height: 200px;\n    position: absolute;\n    z-index: 2;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 10px;\n    margin-bottom: unset;\n    margin-top: unset;\n    &:before {\n      border-bottom: 11px solid #f1eae0;\n      top: -11px;\n      border-left: 11px solid transparent;\n      border-right: 11px solid transparent;\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      right: 15px;\n    }\n\n    &:after {\n      top: -10px;\n      border-bottom: 11px solid #fffcf5;\n      border-left: 11px solid transparent;\n      border-right: 11px solid transparent;\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      right: 15px;\n    }\n  }\n  .react-select__menu-list {\n    max-height: 198px;\n    overflow-y: auto;\n    padding-bottom: unset;\n    padding-top: unset;\n    position: relative;\n  }\n  .react-select__option {\n    font-size: 0.8571em;\n    padding-top: 0.6rem;\n    padding-bottom: 0.6rem;\n    margin-top: 5px;\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    display: block;\n    outline: none;\n    color: #292b2c;\n  }\n  .react-select__menu {\n    .react-select__option {\n      &,\n      &:active {\n        background-color: transparent;\n      }\n      &.react-select__option--is-selected {\n        &,\n        &.react-select__option--is-focused {\n          &,\n          &:active {\n            background-color: $medium-gray;\n          }\n        }\n      }\n      &.react-select__option--is-focused {\n        &,\n        &:active {\n          background-color: #f5f5f5;\n        }\n      }\n      &.react-select__option--is-disabled {\n        &,\n        &:active {\n          color: #cccccc;\n          cursor: default;\n        }\n      }\n    }\n  }\n  .react-select__control {\n    border-radius: 4px;\n    height: calc(2.25rem + 2px);\n    box-sizing: border-box;\n    border-collapse: separate;\n    display: table;\n    width: 100%;\n    &,\n    &:hover {\n      border: 1px solid lighten($black, 5%);\n      box-shadow: none;\n      background-color: transparent;\n    }\n    &.react-select__control--is-focused {\n      .react-select__dropdown-indicator {\n        &:after {\n          transform: rotate(180deg);\n          top: -4px;\n        }\n      }\n      &,\n      &:hover {\n        border: 1px solid $primary;\n        box-shadow: none;\n      }\n    }\n    .react-select__value-container--has-value {\n      .react-select__multi-value {\n        display: inline-flex;\n        border-radius: 4px;\n        background-color: transparent;\n        & + div:not(.react-select__multi-value) {\n          display: inline-flex;\n        }\n        .react-select__multi-value__label {\n          font-size: 0.9em;\n        }\n      }\n      .react-select__single-value {\n        top: 48%;\n        color: $primary;\n      }\n    }\n    .react-select__placeholder {\n      color: $dark-gray;\n      line-height: normal;\n      font-size: 0.8571em;\n      top: 48%;\n    }\n    .react-select__value-container,\n    .react-select__indicators {\n      display: table-cell;\n    }\n    .react-select__indicators {\n      width: 60px;\n      padding-right: 10px;\n      align-items: flex-end;\n      vertical-align: middle;\n      text-align: right;\n      .react-select__indicator-separator {\n        display: none;\n      }\n      .react-select__indicator {\n        padding: 0;\n        display: inline-block;\n      }\n      .react-select__dropdown-indicator {\n        &:after {\n          transition: all 150ms ease 0s;\n          border-color: #999 transparent transparent;\n          border-style: solid;\n          border-width: 5px 5px 2.5px;\n          display: inline-block;\n          height: 0;\n          width: 0;\n          position: relative;\n          content: \"\";\n        }\n        &:hover:after {\n          border-top-color: $link-disabled;\n        }\n        & > * {\n          display: none;\n        }\n      }\n      .react-select__clear-indicator {\n        &:before {\n          content: \"\\D7\";\n          display: inline-block;\n          font-size: 18px;\n          line-height: 1;\n          top: 2px;\n          position: relative;\n          margin-right: 3px;\n        }\n        & > * {\n          display: none;\n        }\n      }\n    }\n  }\n  &.primary {\n    .react-select__control {\n      &.react-select__control--is-focused {\n        &,\n        &:hover {\n          border-color: $primary;\n        }\n      }\n      .react-select__value-container--has-value {\n        .react-select__single-value,\n        .react-select__multi-value__label {\n          color: $primary;\n        }\n      }\n    }\n    .react-select__multi-value {\n      border: 1px solid $primary;\n      .react-select__multi-value__remove {\n        color: $primary-opacity;\n        border-left: 1px solid $primary-opacity;\n        &:hover {\n          color: $primary;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.success {\n    .react-select__control {\n      &.react-select__control--is-focused {\n        &,\n        &:hover {\n          border-color: $success;\n        }\n      }\n      .react-select__value-container--has-value {\n        .react-select__single-value,\n        .react-select__multi-value__label {\n          color: $success;\n        }\n      }\n    }\n    .react-select__multi-value {\n      border: 1px solid $success;\n      .react-select__multi-value__remove {\n        color: $success-opacity;\n        border-left: 1px solid $success-opacity;\n        &:hover {\n          color: $success;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.info {\n    .react-select__control {\n      &.react-select__control--is-focused {\n        &,\n        &:hover {\n          border-color: $info;\n        }\n      }\n      .react-select__value-container--has-value {\n        .react-select__single-value,\n        .react-select__multi-value__label {\n          color: $info;\n        }\n      }\n    }\n    .react-select__multi-value {\n      border: 1px solid $info;\n      .react-select__multi-value__remove {\n        color: $info-opacity;\n        border-left: 1px solid $info-opacity;\n        &:hover {\n          color: $info;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.warning {\n    .react-select__control {\n      &.react-select__control--is-focused {\n        &,\n        &:hover {\n          border-color: $warning;\n        }\n      }\n      .react-select__value-container--has-value {\n        .react-select__single-value,\n        .react-select__multi-value__label {\n          color: $warning;\n        }\n      }\n    }\n    .react-select__multi-value {\n      border: 1px solid $warning;\n      .react-select__multi-value__remove {\n        color: $warning-opacity;\n        border-left: 1px solid $warning-opacity;\n        &:hover {\n          color: $warning;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.danger {\n    .react-select__control {\n      &.react-select__control--is-focused {\n        &,\n        &:hover {\n          border-color: $danger;\n        }\n      }\n      .react-select__value-container--has-value {\n        .react-select__single-value,\n        .react-select__multi-value__label {\n          color: $danger;\n        }\n      }\n    }\n    .react-select__multi-value {\n      border: 1px solid $danger;\n      .react-select__multi-value__remove {\n        color: $danger-opacity;\n        border-left: 1px solid $danger-opacity;\n        &:hover {\n          color: $danger;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  .react-select__multi-value {\n    border: 1px solid $dark-gray;\n    .react-select__multi-value__remove {\n      position: relative;\n      color: $opacity-gray-8;\n      border-left: 1px solid $opacity-gray-8;\n      &:hover {\n        color: $dark-gray;\n        background-color: transparent;\n      }\n    }\n  }\n  &.react-select--is-disabled {\n    .react-select__multi-value--is-disabled {\n      .react-select__multi-value__remove {\n        display: none;\n      }\n      &.react-select__multi-value {\n        background-color: #fcfcfc;\n        border: 1px solid #e3e3e3;\n      }\n    }\n    .react-select__control--is-disabled {\n      background-color: #f9f9f9;\n    }\n  }\n  .react-select__menu-list {\n    margin: 10px 0;\n    max-height: 180px;\n  }\n}\n.input-group .react-select {\n  flex: 1 1 auto;\n}\n.input-group .input-group-prepend + .react-select {\n  .react-select__control {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-left: 0;\n  }\n}\n.input-group .react-select:not(:last-child) {\n  .react-select__control {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    border-right: 0;\n    right: -1px;\n  }\n}\n",".ReactTable {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: transparent;\n}\n.ReactTable {\n  .actions-right {\n    text-align: right;\n  }\n  .actions-left {\n    text-align: left;\n  }\n  .actions-center {\n    text-align: center;\n  }\n}\n.ReactTable * {\n  box-sizing: border-box;\n}\n.ReactTable .rt-table {\n  -webkit-box-flex: 1;\n  -ms-flex: auto 1;\n  flex: auto 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: auto;\n}\n.ReactTable .rt-thead {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ReactTable .rt-thead.-headerGroups {\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-thead.-filters {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .-pagination input,\n.ReactTable .-pagination select,\n.ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-color: #2b3553;\n  background-color: transparent;\n  border-radius: 0.4285rem;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: normal;\n  font-size: 0.8571em;\n  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  box-shadow: none;\n  margin-left: 0.5em;\n  display: inline-block;\n  width: auto;\n  height: calc(1.8125rem + 2px);\n  padding: 0.25rem 0.5rem;\n  &:focus {\n    border-color: $info;\n    background: transparent;\n    box-shadow: none;\n    outline: 0 !important;\n    color: rgba(255, 255, 255, 0.8);\n  }\n  option {\n    color: $gray-800;\n  }\n}\n.ReactTable .rt-thead .rt-tr {\n  text-align: center;\n}\n.ReactTable .rt-thead .rt-th:last-child {\n  text-align: right;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type {\n  &:after,\n  &:before {\n    position: absolute;\n    display: block;\n    opacity: 0.3;\n  }\n  &:before {\n    right: 1em;\n    content: \"\\2191\";\n  }\n  &:after {\n    right: 0.5em;\n    content: \"\\2193\";\n    top: 0.4em;\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-desc > div:first-of-type {\n  &:after {\n    opacity: 1;\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-asc > div:first-of-type {\n  &:before {\n    opacity: 1;\n  }\n}\n.ReactTable .rt-thead .rt-th,\n.ReactTable .rt-thead .rt-td {\n  font-size: 1.063rem;\n  text-align: left;\n  font-weight: 300;\n  line-height: 2.5em !important;\n  padding: 5px 5px;\n  line-height: normal;\n  position: relative;\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\n  cursor: pointer;\n}\n.ReactTable .rt-thead .rt-th:last-child,\n.ReactTable .rt-thead .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-thead .rt-resizable-header {\n  overflow: visible;\n}\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n  overflow: hidden;\n}\n.ReactTable .rt-thead .rt-resizable-header-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  &:focus {\n    outline: none;\n  }\n}\n.ReactTable .rt-thead .rt-header-pivot {\n  border-right-color: #f7f7f7;\n}\n.ReactTable .rt-thead .rt-header-pivot:after,\n.ReactTable .rt-thead .rt-header-pivot:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.ReactTable .rt-thead .rt-header-pivot:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-left-color: #fff;\n  border-width: 8px;\n  margin-top: -8px;\n}\n.ReactTable .rt-thead .rt-header-pivot:before {\n  border-color: rgba(102, 102, 102, 0);\n  border-left-color: #f7f7f7;\n  border-width: 10px;\n  margin-top: -10px;\n}\n.ReactTable .rt-tbody {\n  -webkit-box-flex: 99999;\n  -ms-flex: 99999 1 auto;\n  flex: 99999 1 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: auto;\n}\n.ReactTable .rt-tbody .rt-tr-group {\n  border-bottom: solid 1px rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 0;\n}\n.ReactTable .rt-tbody .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-tbody .rt-expandable {\n  cursor: pointer;\n}\n.ReactTable .rt-tr-group {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.ReactTable .rt-tr {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: 7px 5px;\n  overflow: hidden;\n  transition: 0.3s ease;\n  transition-property: width, min-width, padding, opacity;\n  margin: auto;\n}\n.ReactTable .rt-tbody .rt-tr,\n.ReactTable .rt-thead.-filters .rt-tr {\n  border-top: 1px solid #dee2e6;\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.ReactTable .rt-td {\n  padding: 12px 7px;\n  vertical-align: middle;\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n.ReactTable .rt-th.-hidden,\n.ReactTable .rt-td.-hidden {\n  width: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  opacity: 0 !important;\n}\n.ReactTable .rt-expander {\n  display: inline-block;\n  position: relative;\n  margin: 0;\n  color: transparent;\n  margin: 0 10px;\n}\n.ReactTable .rt-expander:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%) rotate(-90deg);\n  transform: translate(-50%, -50%) rotate(-90deg);\n  border-left: 5.04px solid transparent;\n  border-right: 5.04px solid transparent;\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n.ReactTable .rt-expander.-open:after {\n  -webkit-transform: translate(-50%, -50%) rotate(0);\n  transform: translate(-50%, -50%) rotate(0);\n}\n.ReactTable .rt-resizer {\n  display: inline-block;\n  position: absolute;\n  width: 36px;\n  top: 0;\n  bottom: 0;\n  right: -18px;\n  cursor: col-resize;\n  z-index: 10;\n}\n.ReactTable .rt-tfoot {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-tfoot .rt-td {\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-tfoot .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable.-striped .rt-tr.-odd {\n  background: rgba(0, 0, 0, 0.03);\n}\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.ReactTable .-pagination {\n  z-index: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 3px;\n}\n.ReactTable .-pagination .-btn {\n  border-width: $border-thick;\n  font-weight: $btn-font-weight;\n  font-size: $btn-font-size-lg;\n  line-height: $line-height;\n  border: none;\n  position: relative;\n  overflow: hidden;\n  margin: 4px 1px;\n  border-radius: $border-radius-lg;\n  padding: $padding-btn-vertical $padding-btn-horizontal;\n  cursor: pointer;\n  @include btn-styles($info, $info-states);\n  width: 100%;\n  outline: none !important;\n}\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  color: #fff;\n}\n.ReactTable .-pagination .-previous,\n.ReactTable .-pagination .-next {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  text-align: center;\n}\n.ReactTable .-pagination .-center {\n  -webkit-box-flex: 1.5;\n  -ms-flex: 1.5;\n  flex: 1.5;\n  text-align: center;\n  margin-bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n.ReactTable .-pagination .-pageInfo {\n  display: inline-block;\n  margin: 3px 10px;\n}\n.ReactTable .-pagination .-pageJump {\n  display: inline-block;\n}\n.ReactTable .-pagination .-pageSizeOptions {\n  margin: 3px 10px;\n}\n.ReactTable .rt-noData {\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: 1;\n  pointer-events: none;\n  padding: 20px;\n  color: rgba(0, 0, 0, 0.5);\n}\n.ReactTable .-loading {\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none;\n}\n.ReactTable .-loading > div {\n  position: absolute;\n  display: block;\n  text-align: center;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.6);\n  -webkit-transform: translateY(-52%);\n  transform: translateY(-52%);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n.ReactTable .-loading.-active {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: all;\n}\n.ReactTable .-loading.-active > div {\n  -webkit-transform: translateY(50%);\n  transform: translateY(50%);\n}\n.ReactTable .rt-resizing .rt-th,\n.ReactTable .rt-resizing .rt-td {\n  transition: none !important;\n  cursor: col-resize;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ReactTable .rt-thead .rt-th:focus {\n  outline: none;\n}\n.ReactTable .rt-thead .rt-th {\n  border-bottom-width: 1px;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 700;\n  border: 0;\n  color: rgba(255, 255, 255, 0.7);\n}\n","// Based on the original react-tagsinput styles\n\n.react-tagsinput {\n  display: inline-block;\n  padding: 4px 6px;\n  max-width: 100%;\n  line-height: 22px;\n}\n\n.react-tagsinput-tag {\n  cursor: pointer;\n  margin: 5px 3px 5px 0;\n  position: relative;\n  padding: 3px 8px;\n  border-radius: 12px;\n  color: #ffffff;\n  font-weight: 500;\n  font-size: 0.75em;\n  text-transform: uppercase;\n  display: inline-block;\n  line-height: 1.5em;\n  padding-left: 0.8em;\n  & + .react-tagsinput-tag {\n    margin-left: 3px;\n  }\n}\n\n.react-tagsinput-remove {\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.react-tagsinput-tag a::before {\n  font-family: \"Nucleo\";\n  content: \"\\ea48\";\n  padding: 0px 2px;\n}\n.react-tagsinput-tag a {\n  cursor: pointer;\n  position: absolute;\n  top: 3px;\n  right: 0px;\n  opacity: 0;\n  background-color: transparent;\n}\n\n.react-tagsinput-input {\n  background: transparent;\n  border: 0;\n  color: #777;\n  font-family: sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  outline: none;\n  padding-left: 5px;\n  width: 80px;\n}\n\n.react-tagsinput {\n  .react-tagsinput-tag {\n    -webkit-transition: all 300ms ease 0s;\n    -moz-transition: all 300ms ease 0s;\n    -o-transition: all 300ms ease 0s;\n    -ms-transition: all 300ms ease 0s;\n    transition: all 300ms ease 0s;\n\n    &:hover {\n      padding-right: 22px;\n\n      a {\n        opacity: 1;\n        padding-right: 4px;\n      }\n    }\n\n    @include badge-variant($default);\n    &.primary {\n      @include badge-variant($primary);\n    }\n    &.info {\n      @include badge-variant($info);\n    }\n    &.success {\n      @include badge-variant($success);\n    }\n    &.warning {\n      @include badge-variant($warning);\n    }\n    &.danger {\n      @include badge-variant($danger);\n    }\n    &.neutral {\n      @include badge-variant($white);\n      color: inherit;\n    }\n  }\n}\n",".rna-container {\n  z-index: 1051;\n  position: fixed;\n}\n.alert {\n  button.close {\n    margin-top: -1px;\n    color: $white;\n    opacity: 0.9;\n    text-shadow: none;\n    line-height: 0;\n    outline: 0;\n    &::after {\n      display: inline-block;\n      font: normal normal normal 1em/1 \"Nucleo\";\n      vertical-align: middle;\n      speak: none;\n      text-transform: none;\n      -webkit-font-smoothing: antialiased;\n      font-size: 1rem;\n      content: \"\\ea48\";\n    }\n    span {\n      display: none !important;\n    }\n  }\n  &.alert-dismissible {\n    padding-right: 1.25rem;\n  }\n}\n",".badge {\n  & + .badge {\n    margin-left: 4px;\n  }\n}\n","/*******************************************************************************\n *              bootstrap-rtl (version 3.3.4)\n *      Author: Morteza Ansarinia (http://github.com/morteza)\n *  Created on: August 13,2015\n *     Project: bootstrap-rtl\n *   Copyright: Unlicensed Public Domain\n *******************************************************************************/\n\n/*******************************************************************************\n  This file was modified by the Creative-Tim team\n  *******************************************************************************/\n\n.rtl-active {\n  &html {\n    direction: rtl;\n  }\n  body {\n    direction: rtl;\n  }\n  .flip.text-left {\n    text-align: right;\n  }\n  .flip.text-right {\n    text-align: left;\n  }\n  .list-unstyled {\n    padding-right: 0;\n    padding-left: initial;\n  }\n  .list-inline {\n    padding-right: 0;\n    padding-left: initial;\n    margin-right: -5px;\n    margin-left: 0;\n  }\n  dd {\n    margin-right: 0;\n    margin-left: initial;\n  }\n  @media (min-width: 768px) {\n    .dl-horizontal dt {\n      float: right;\n      clear: right;\n      text-align: left;\n    }\n    .dl-horizontal dd {\n      margin-right: 180px;\n      margin-left: 0;\n    }\n  }\n  blockquote {\n    border-right: 5px solid #eeeeee;\n    border-left: 0;\n  }\n  .blockquote-reverse,\n  blockquote.pull-left {\n    padding-left: 15px;\n    padding-right: 0;\n    border-left: 5px solid #eeeeee;\n    border-right: 0;\n    text-align: left;\n  }\n  .col-xs-1,\n  .col-sm-1,\n  .col-md-1,\n  .col-lg-1,\n  .col-xs-2,\n  .col-sm-2,\n  .col-md-2,\n  .col-lg-2,\n  .col-xs-3,\n  .col-sm-3,\n  .col-md-3,\n  .col-lg-3,\n  .col-xs-4,\n  .col-sm-4,\n  .col-md-4,\n  .col-lg-4,\n  .col-xs-5,\n  .col-sm-5,\n  .col-md-5,\n  .col-lg-5,\n  .col-xs-6,\n  .col-sm-6,\n  .col-md-6,\n  .col-lg-6,\n  .col-xs-7,\n  .col-sm-7,\n  .col-md-7,\n  .col-lg-7,\n  .col-xs-8,\n  .col-sm-8,\n  .col-md-8,\n  .col-lg-8,\n  .col-xs-9,\n  .col-sm-9,\n  .col-md-9,\n  .col-lg-9,\n  .col-xs-10,\n  .col-sm-10,\n  .col-md-10,\n  .col-lg-10,\n  .col-xs-11,\n  .col-sm-11,\n  .col-md-11,\n  .col-lg-11,\n  .col-xs-12,\n  .col-sm-12,\n  .col-md-12,\n  .col-lg-12 {\n    position: relative;\n    min-height: 1px;\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .col-xs-1,\n  .col-xs-2,\n  .col-xs-3,\n  .col-xs-4,\n  .col-xs-5,\n  .col-xs-6,\n  .col-xs-7,\n  .col-xs-8,\n  .col-xs-9,\n  .col-xs-10,\n  .col-xs-11,\n  .col-xs-12 {\n    float: right;\n  }\n  .col-xs-12 {\n    width: 100%;\n  }\n  .col-xs-11 {\n    width: 91.66666667%;\n  }\n  .col-xs-10 {\n    width: 83.33333333%;\n  }\n  .col-xs-9 {\n    width: 75%;\n  }\n  .col-xs-8 {\n    width: 66.66666667%;\n  }\n  .col-xs-7 {\n    width: 58.33333333%;\n  }\n  .col-xs-6 {\n    width: 50%;\n  }\n  .col-xs-5 {\n    width: 41.66666667%;\n  }\n  .col-xs-4 {\n    width: 33.33333333%;\n  }\n  .col-xs-3 {\n    width: 25%;\n  }\n  .col-xs-2 {\n    width: 16.66666667%;\n  }\n  .col-xs-1 {\n    width: 8.33333333%;\n  }\n  .col-xs-pull-12 {\n    left: 100%;\n    right: auto;\n  }\n  .col-xs-pull-11 {\n    left: 91.66666667%;\n    right: auto;\n  }\n  .col-xs-pull-10 {\n    left: 83.33333333%;\n    right: auto;\n  }\n  .col-xs-pull-9 {\n    left: 75%;\n    right: auto;\n  }\n  .col-xs-pull-8 {\n    left: 66.66666667%;\n    right: auto;\n  }\n  .col-xs-pull-7 {\n    left: 58.33333333%;\n    right: auto;\n  }\n  .col-xs-pull-6 {\n    left: 50%;\n    right: auto;\n  }\n  .col-xs-pull-5 {\n    left: 41.66666667%;\n    right: auto;\n  }\n  .col-xs-pull-4 {\n    left: 33.33333333%;\n    right: auto;\n  }\n  .col-xs-pull-3 {\n    left: 25%;\n    right: auto;\n  }\n  .col-xs-pull-2 {\n    left: 16.66666667%;\n    right: auto;\n  }\n  .col-xs-pull-1 {\n    left: 8.33333333%;\n    right: auto;\n  }\n  .col-xs-pull-0 {\n    left: auto;\n    right: auto;\n  }\n  .col-xs-push-12 {\n    right: 100%;\n    left: 0;\n  }\n  .col-xs-push-11 {\n    right: 91.66666667%;\n    left: 0;\n  }\n  .col-xs-push-10 {\n    right: 83.33333333%;\n    left: 0;\n  }\n  .col-xs-push-9 {\n    right: 75%;\n    left: 0;\n  }\n  .col-xs-push-8 {\n    right: 66.66666667%;\n    left: 0;\n  }\n  .col-xs-push-7 {\n    right: 58.33333333%;\n    left: 0;\n  }\n  .col-xs-push-6 {\n    right: 50%;\n    left: 0;\n  }\n  .col-xs-push-5 {\n    right: 41.66666667%;\n    left: 0;\n  }\n  .col-xs-push-4 {\n    right: 33.33333333%;\n    left: 0;\n  }\n  .col-xs-push-3 {\n    right: 25%;\n    left: 0;\n  }\n  .col-xs-push-2 {\n    right: 16.66666667%;\n    left: 0;\n  }\n  .col-xs-push-1 {\n    right: 8.33333333%;\n    left: 0;\n  }\n  .col-xs-push-0 {\n    right: auto;\n    left: 0;\n  }\n  .col-xs-offset-12 {\n    margin-right: 100%;\n    margin-left: 0;\n  }\n  .col-xs-offset-11 {\n    margin-right: 91.66666667%;\n    margin-left: 0;\n  }\n  .col-xs-offset-10 {\n    margin-right: 83.33333333%;\n    margin-left: 0;\n  }\n  .col-xs-offset-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n  .col-xs-offset-8 {\n    margin-right: 66.66666667%;\n    margin-left: 0;\n  }\n  .col-xs-offset-7 {\n    margin-right: 58.33333333%;\n    margin-left: 0;\n  }\n  .col-xs-offset-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n  .col-xs-offset-5 {\n    margin-right: 41.66666667%;\n    margin-left: 0;\n  }\n  .col-xs-offset-4 {\n    margin-right: 33.33333333%;\n    margin-left: 0;\n  }\n  .col-xs-offset-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n  .col-xs-offset-2 {\n    margin-right: 16.66666667%;\n    margin-left: 0;\n  }\n  .col-xs-offset-1 {\n    margin-right: 8.33333333%;\n    margin-left: 0;\n  }\n  .col-xs-offset-0 {\n    margin-right: 0%;\n    margin-left: 0;\n  }\n  @media (min-width: 768px) {\n    .col-sm-1,\n    .col-sm-2,\n    .col-sm-3,\n    .col-sm-4,\n    .col-sm-5,\n    .col-sm-6,\n    .col-sm-7,\n    .col-sm-8,\n    .col-sm-9,\n    .col-sm-10,\n    .col-sm-11,\n    .col-sm-12 {\n      float: right;\n    }\n    .col-sm-12 {\n      width: 100%;\n    }\n    .col-sm-11 {\n      width: 91.66666667%;\n    }\n    .col-sm-10 {\n      width: 83.33333333%;\n    }\n    .col-sm-9 {\n      width: 75%;\n    }\n    .col-sm-8 {\n      width: 66.66666667%;\n    }\n    .col-sm-7 {\n      width: 58.33333333%;\n    }\n    .col-sm-6 {\n      width: 50%;\n    }\n    .col-sm-5 {\n      width: 41.66666667%;\n    }\n    .col-sm-4 {\n      width: 33.33333333%;\n    }\n    .col-sm-3 {\n      width: 25%;\n    }\n    .col-sm-2 {\n      width: 16.66666667%;\n    }\n    .col-sm-1 {\n      width: 8.33333333%;\n    }\n    .col-sm-pull-12 {\n      left: 100%;\n      right: auto;\n    }\n    .col-sm-pull-11 {\n      left: 91.66666667%;\n      right: auto;\n    }\n    .col-sm-pull-10 {\n      left: 83.33333333%;\n      right: auto;\n    }\n    .col-sm-pull-9 {\n      left: 75%;\n      right: auto;\n    }\n    .col-sm-pull-8 {\n      left: 66.66666667%;\n      right: auto;\n    }\n    .col-sm-pull-7 {\n      left: 58.33333333%;\n      right: auto;\n    }\n    .col-sm-pull-6 {\n      left: 50%;\n      right: auto;\n    }\n    .col-sm-pull-5 {\n      left: 41.66666667%;\n      right: auto;\n    }\n    .col-sm-pull-4 {\n      left: 33.33333333%;\n      right: auto;\n    }\n    .col-sm-pull-3 {\n      left: 25%;\n      right: auto;\n    }\n    .col-sm-pull-2 {\n      left: 16.66666667%;\n      right: auto;\n    }\n    .col-sm-pull-1 {\n      left: 8.33333333%;\n      right: auto;\n    }\n    .col-sm-pull-0 {\n      left: auto;\n      right: auto;\n    }\n    .col-sm-push-12 {\n      right: 100%;\n      left: 0;\n    }\n    .col-sm-push-11 {\n      right: 91.66666667%;\n      left: 0;\n    }\n    .col-sm-push-10 {\n      right: 83.33333333%;\n      left: 0;\n    }\n    .col-sm-push-9 {\n      right: 75%;\n      left: 0;\n    }\n    .col-sm-push-8 {\n      right: 66.66666667%;\n      left: 0;\n    }\n    .col-sm-push-7 {\n      right: 58.33333333%;\n      left: 0;\n    }\n    .col-sm-push-6 {\n      right: 50%;\n      left: 0;\n    }\n    .col-sm-push-5 {\n      right: 41.66666667%;\n      left: 0;\n    }\n    .col-sm-push-4 {\n      right: 33.33333333%;\n      left: 0;\n    }\n    .col-sm-push-3 {\n      right: 25%;\n      left: 0;\n    }\n    .col-sm-push-2 {\n      right: 16.66666667%;\n      left: 0;\n    }\n    .col-sm-push-1 {\n      right: 8.33333333%;\n      left: 0;\n    }\n    .col-sm-push-0 {\n      right: auto;\n      left: 0;\n    }\n    .col-sm-offset-12 {\n      margin-right: 100%;\n      margin-left: 0;\n    }\n    .col-sm-offset-11 {\n      margin-right: 91.66666667%;\n      margin-left: 0;\n    }\n    .col-sm-offset-10 {\n      margin-right: 83.33333333%;\n      margin-left: 0;\n    }\n    .col-sm-offset-9 {\n      margin-right: 75%;\n      margin-left: 0;\n    }\n    .col-sm-offset-8 {\n      margin-right: 66.66666667%;\n      margin-left: 0;\n    }\n    .col-sm-offset-7 {\n      margin-right: 58.33333333%;\n      margin-left: 0;\n    }\n    .col-sm-offset-6 {\n      margin-right: 50%;\n      margin-left: 0;\n    }\n    .col-sm-offset-5 {\n      margin-right: 41.66666667%;\n      margin-left: 0;\n    }\n    .col-sm-offset-4 {\n      margin-right: 33.33333333%;\n      margin-left: 0;\n    }\n    .col-sm-offset-3 {\n      margin-right: 25%;\n      margin-left: 0;\n    }\n    .col-sm-offset-2 {\n      margin-right: 16.66666667%;\n      margin-left: 0;\n    }\n    .col-sm-offset-1 {\n      margin-right: 8.33333333%;\n      margin-left: 0;\n    }\n    .col-sm-offset-0 {\n      margin-right: 0%;\n      margin-left: 0;\n    }\n  }\n  @media (min-width: 992px) {\n    .col-md-1,\n    .col-md-2,\n    .col-md-3,\n    .col-md-4,\n    .col-md-5,\n    .col-md-6,\n    .col-md-7,\n    .col-md-8,\n    .col-md-9,\n    .col-md-10,\n    .col-md-11,\n    .col-md-12 {\n      float: right;\n    }\n    .col-md-12 {\n      width: 100%;\n    }\n    .col-md-11 {\n      width: 91.66666667%;\n    }\n    .col-md-10 {\n      width: 83.33333333%;\n    }\n    .col-md-9 {\n      width: 75%;\n    }\n    .col-md-8 {\n      width: 66.66666667%;\n    }\n    .col-md-7 {\n      width: 58.33333333%;\n    }\n    .col-md-6 {\n      width: 50%;\n    }\n    .col-md-5 {\n      width: 41.66666667%;\n    }\n    .col-md-4 {\n      width: 33.33333333%;\n    }\n    .col-md-3 {\n      width: 25%;\n    }\n    .col-md-2 {\n      width: 16.66666667%;\n    }\n    .col-md-1 {\n      width: 8.33333333%;\n    }\n    .col-md-pull-12 {\n      left: 100%;\n      right: auto;\n    }\n    .col-md-pull-11 {\n      left: 91.66666667%;\n      right: auto;\n    }\n    .col-md-pull-10 {\n      left: 83.33333333%;\n      right: auto;\n    }\n    .col-md-pull-9 {\n      left: 75%;\n      right: auto;\n    }\n    .col-md-pull-8 {\n      left: 66.66666667%;\n      right: auto;\n    }\n    .col-md-pull-7 {\n      left: 58.33333333%;\n      right: auto;\n    }\n    .col-md-pull-6 {\n      left: 50%;\n      right: auto;\n    }\n    .col-md-pull-5 {\n      left: 41.66666667%;\n      right: auto;\n    }\n    .col-md-pull-4 {\n      left: 33.33333333%;\n      right: auto;\n    }\n    .col-md-pull-3 {\n      left: 25%;\n      right: auto;\n    }\n    .col-md-pull-2 {\n      left: 16.66666667%;\n      right: auto;\n    }\n    .col-md-pull-1 {\n      left: 8.33333333%;\n      right: auto;\n    }\n    .col-md-pull-0 {\n      left: auto;\n      right: auto;\n    }\n    .col-md-push-12 {\n      right: 100%;\n      left: 0;\n    }\n    .col-md-push-11 {\n      right: 91.66666667%;\n      left: 0;\n    }\n    .col-md-push-10 {\n      right: 83.33333333%;\n      left: 0;\n    }\n    .col-md-push-9 {\n      right: 75%;\n      left: 0;\n    }\n    .col-md-push-8 {\n      right: 66.66666667%;\n      left: 0;\n    }\n    .col-md-push-7 {\n      right: 58.33333333%;\n      left: 0;\n    }\n    .col-md-push-6 {\n      right: 50%;\n      left: 0;\n    }\n    .col-md-push-5 {\n      right: 41.66666667%;\n      left: 0;\n    }\n    .col-md-push-4 {\n      right: 33.33333333%;\n      left: 0;\n    }\n    .col-md-push-3 {\n      right: 25%;\n      left: 0;\n    }\n    .col-md-push-2 {\n      right: 16.66666667%;\n      left: 0;\n    }\n    .col-md-push-1 {\n      right: 8.33333333%;\n      left: 0;\n    }\n    .col-md-push-0 {\n      right: auto;\n      left: 0;\n    }\n    .col-md-offset-12 {\n      margin-right: 100%;\n      margin-left: 0;\n    }\n    .col-md-offset-11 {\n      margin-right: 91.66666667%;\n      margin-left: 0;\n    }\n    .col-md-offset-10 {\n      margin-right: 83.33333333%;\n      margin-left: 0;\n    }\n    .col-md-offset-9 {\n      margin-right: 75%;\n      margin-left: 0;\n    }\n    .col-md-offset-8 {\n      margin-right: 66.66666667%;\n      margin-left: 0;\n    }\n    .col-md-offset-7 {\n      margin-right: 58.33333333%;\n      margin-left: 0;\n    }\n    .col-md-offset-6 {\n      margin-right: 50%;\n      margin-left: 0;\n    }\n    .col-md-offset-5 {\n      margin-right: 41.66666667%;\n      margin-left: 0;\n    }\n    .col-md-offset-4 {\n      margin-right: 33.33333333%;\n      margin-left: 0;\n    }\n    .col-md-offset-3 {\n      margin-right: 25%;\n      margin-left: 0;\n    }\n    .col-md-offset-2 {\n      margin-right: 16.66666667%;\n      margin-left: 0;\n    }\n    .col-md-offset-1 {\n      margin-right: 8.33333333%;\n      margin-left: 0;\n    }\n    .col-md-offset-0 {\n      margin-right: 0%;\n      margin-left: 0;\n    }\n  }\n  @media (min-width: 1200px) {\n    .col-lg-1,\n    .col-lg-2,\n    .col-lg-3,\n    .col-lg-4,\n    .col-lg-5,\n    .col-lg-6,\n    .col-lg-7,\n    .col-lg-8,\n    .col-lg-9,\n    .col-lg-10,\n    .col-lg-11,\n    .col-lg-12 {\n      float: right;\n    }\n    .col-lg-12 {\n      width: 100%;\n    }\n    .col-lg-11 {\n      width: 91.66666667%;\n    }\n    .col-lg-10 {\n      width: 83.33333333%;\n    }\n    .col-lg-9 {\n      width: 75%;\n    }\n    .col-lg-8 {\n      width: 66.66666667%;\n    }\n    .col-lg-7 {\n      width: 58.33333333%;\n    }\n    .col-lg-6 {\n      width: 50%;\n    }\n    .col-lg-5 {\n      width: 41.66666667%;\n    }\n    .col-lg-4 {\n      width: 33.33333333%;\n    }\n    .col-lg-3 {\n      width: 25%;\n    }\n    .col-lg-2 {\n      width: 16.66666667%;\n    }\n    .col-lg-1 {\n      width: 8.33333333%;\n    }\n    .col-lg-pull-12 {\n      left: 100%;\n      right: auto;\n    }\n    .col-lg-pull-11 {\n      left: 91.66666667%;\n      right: auto;\n    }\n    .col-lg-pull-10 {\n      left: 83.33333333%;\n      right: auto;\n    }\n    .col-lg-pull-9 {\n      left: 75%;\n      right: auto;\n    }\n    .col-lg-pull-8 {\n      left: 66.66666667%;\n      right: auto;\n    }\n    .col-lg-pull-7 {\n      left: 58.33333333%;\n      right: auto;\n    }\n    .col-lg-pull-6 {\n      left: 50%;\n      right: auto;\n    }\n    .col-lg-pull-5 {\n      left: 41.66666667%;\n      right: auto;\n    }\n    .col-lg-pull-4 {\n      left: 33.33333333%;\n      right: auto;\n    }\n    .col-lg-pull-3 {\n      left: 25%;\n      right: auto;\n    }\n    .col-lg-pull-2 {\n      left: 16.66666667%;\n      right: auto;\n    }\n    .col-lg-pull-1 {\n      left: 8.33333333%;\n      right: auto;\n    }\n    .col-lg-pull-0 {\n      left: auto;\n      right: auto;\n    }\n    .col-lg-push-12 {\n      right: 100%;\n      left: 0;\n    }\n    .col-lg-push-11 {\n      right: 91.66666667%;\n      left: 0;\n    }\n    .col-lg-push-10 {\n      right: 83.33333333%;\n      left: 0;\n    }\n    .col-lg-push-9 {\n      right: 75%;\n      left: 0;\n    }\n    .col-lg-push-8 {\n      right: 66.66666667%;\n      left: 0;\n    }\n    .col-lg-push-7 {\n      right: 58.33333333%;\n      left: 0;\n    }\n    .col-lg-push-6 {\n      right: 50%;\n      left: 0;\n    }\n    .col-lg-push-5 {\n      right: 41.66666667%;\n      left: 0;\n    }\n    .col-lg-push-4 {\n      right: 33.33333333%;\n      left: 0;\n    }\n    .col-lg-push-3 {\n      right: 25%;\n      left: 0;\n    }\n    .col-lg-push-2 {\n      right: 16.66666667%;\n      left: 0;\n    }\n    .col-lg-push-1 {\n      right: 8.33333333%;\n      left: 0;\n    }\n    .col-lg-push-0 {\n      right: auto;\n      left: 0;\n    }\n    .col-lg-offset-12 {\n      margin-right: 100%;\n      margin-left: 0;\n    }\n    .col-lg-offset-11 {\n      margin-right: 91.66666667%;\n      margin-left: 0;\n    }\n    .col-lg-offset-10 {\n      margin-right: 83.33333333%;\n      margin-left: 0;\n    }\n    .col-lg-offset-9 {\n      margin-right: 75%;\n      margin-left: 0;\n    }\n    .col-lg-offset-8 {\n      margin-right: 66.66666667%;\n      margin-left: 0;\n    }\n    .col-lg-offset-7 {\n      margin-right: 58.33333333%;\n      margin-left: 0;\n    }\n    .col-lg-offset-6 {\n      margin-right: 50%;\n      margin-left: 0;\n    }\n    .col-lg-offset-5 {\n      margin-right: 41.66666667%;\n      margin-left: 0;\n    }\n    .col-lg-offset-4 {\n      margin-right: 33.33333333%;\n      margin-left: 0;\n    }\n    .col-lg-offset-3 {\n      margin-right: 25%;\n      margin-left: 0;\n    }\n    .col-lg-offset-2 {\n      margin-right: 16.66666667%;\n      margin-left: 0;\n    }\n    .col-lg-offset-1 {\n      margin-right: 8.33333333%;\n      margin-left: 0;\n    }\n    .col-lg-offset-0 {\n      margin-right: 0%;\n      margin-left: 0;\n    }\n  }\n  caption {\n    text-align: right;\n  }\n  th {\n    text-align: right;\n  }\n  @media screen and (max-width: 767px) {\n    .table-responsive > .table-bordered {\n      border: 0;\n    }\n    .table-responsive > .table-bordered > thead > tr > th:first-child,\n    .table-responsive > .table-bordered > tbody > tr > th:first-child,\n    .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n    .table-responsive > .table-bordered > thead > tr > td:first-child,\n    .table-responsive > .table-bordered > tbody > tr > td:first-child,\n    .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n      border-right: 0;\n      border-left: initial;\n    }\n    .table-responsive > .table-bordered > thead > tr > th:last-child,\n    .table-responsive > .table-bordered > tbody > tr > th:last-child,\n    .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n    .table-responsive > .table-bordered > thead > tr > td:last-child,\n    .table-responsive > .table-bordered > tbody > tr > td:last-child,\n    .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n      border-left: 0;\n      border-right: initial;\n    }\n  }\n  .radio label,\n  .checkbox label {\n    padding-right: 20px;\n    padding-left: initial;\n  }\n  .radio input[type=\"radio\"],\n  .radio-inline input[type=\"radio\"],\n  .checkbox input[type=\"checkbox\"],\n  .checkbox-inline input[type=\"checkbox\"] {\n    margin-right: -20px;\n    margin-left: auto;\n  }\n  .radio-inline,\n  .checkbox-inline {\n    padding-right: 20px;\n    padding-left: 0;\n  }\n  .radio-inline + .radio-inline,\n  .checkbox-inline + .checkbox-inline {\n    margin-right: 10px;\n    margin-left: 0;\n  }\n  .has-feedback .form-control {\n    padding-left: 42.5px;\n    padding-right: 12px;\n  }\n  .form-control-feedback {\n    left: 0;\n    right: auto;\n  }\n  @media (min-width: 768px) {\n    .form-inline label {\n      padding-right: 0;\n      padding-left: initial;\n    }\n    .form-inline .radio input[type=\"radio\"],\n    .form-inline .checkbox input[type=\"checkbox\"] {\n      margin-right: 0;\n      margin-left: auto;\n    }\n  }\n  @media (min-width: 768px) {\n    .form-horizontal .control-label {\n      text-align: left;\n    }\n  }\n  .form-horizontal .has-feedback .form-control-feedback {\n    left: 15px;\n    right: auto;\n  }\n  .caret {\n    margin-right: 2px;\n    margin-left: 0;\n  }\n  .dropdown-menu {\n    right: 0;\n    left: auto;\n    float: left;\n    text-align: right;\n  }\n  .dropdown-menu.pull-right {\n    left: 0;\n    right: auto;\n    float: right;\n  }\n  .dropdown-menu-right {\n    left: auto;\n    right: 0;\n  }\n  .dropdown-menu-left {\n    left: 0;\n    right: auto;\n  }\n  @media (min-width: 768px) {\n    .navbar-right .dropdown-menu {\n      left: auto;\n      right: 0;\n    }\n    .navbar-right .dropdown-menu-left {\n      left: 0;\n      right: auto;\n    }\n  }\n  .btn-group > .btn,\n  .btn-group-vertical > .btn {\n    float: right;\n  }\n  .btn-group .btn + .btn,\n  .btn-group .btn + .btn-group,\n  .btn-group .btn-group + .btn,\n  .btn-group .btn-group + .btn-group {\n    margin-right: -1px;\n    margin-left: 0px;\n  }\n  .btn-toolbar {\n    margin-right: -5px;\n    margin-left: 0px;\n  }\n  .btn-toolbar .btn-group,\n  .btn-toolbar .input-group {\n    float: right;\n  }\n  .btn-toolbar > .btn,\n  .btn-toolbar > .btn-group,\n  .btn-toolbar > .input-group {\n    margin-right: 5px;\n    margin-left: 0px;\n  }\n  .btn-group > .btn:first-child {\n    margin-right: 0;\n  }\n  .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n  .btn-group > .btn:last-child:not(:first-child),\n  .btn-group > .dropdown-toggle:not(:first-child) {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .btn-group > .btn-group {\n    float: right;\n  }\n  .btn-group.btn-group-justified > .btn,\n  .btn-group.btn-group-justified > .btn-group {\n    float: none;\n  }\n  .btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n    border-radius: 0;\n  }\n  .btn-group > .btn-group:first-child > .btn:last-child,\n  .btn-group > .btn-group:first-child > .dropdown-toggle {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n  .btn-group > .btn-group:last-child > .btn:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .btn .caret {\n    margin-right: 0;\n  }\n  .btn-group-vertical > .btn + .btn,\n  .btn-group-vertical > .btn + .btn-group,\n  .btn-group-vertical > .btn-group + .btn,\n  .btn-group-vertical > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-right: 0;\n  }\n  .input-group .form-control {\n    float: right;\n  }\n  .input-group .form-control:first-child,\n  .input-group-addon:first-child,\n  .input-group-btn:first-child > .btn,\n  .input-group-btn:first-child > .btn-group > .btn,\n  .input-group-btn:first-child > .dropdown-toggle,\n  .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n  .input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n    border-bottom-right-radius: 4px;\n    border-top-right-radius: 4px;\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n  .input-group-addon:first-child {\n    border-left: 0px;\n    border-right: 1px solid;\n  }\n  .input-group .form-control:last-child,\n  .input-group-addon:last-child,\n  .input-group-btn:last-child > .btn,\n  .input-group-btn:last-child > .btn-group > .btn,\n  .input-group-btn:last-child > .dropdown-toggle,\n  .input-group-btn:first-child > .btn:not(:first-child),\n  .input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n    border-bottom-left-radius: 4px;\n    border-top-left-radius: 4px;\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .input-group-addon:last-child {\n    border-left-width: 1px;\n    border-left-style: solid;\n    border-right: 0px;\n  }\n  .input-group-btn > .btn + .btn {\n    margin-right: -1px;\n    margin-left: auto;\n  }\n  .input-group-btn:first-child > .btn,\n  .input-group-btn:first-child > .btn-group {\n    margin-left: -1px;\n    margin-right: auto;\n  }\n  .input-group-btn:last-child > .btn,\n  .input-group-btn:last-child > .btn-group {\n    margin-right: -1px;\n    margin-left: auto;\n  }\n  .nav {\n    padding-right: 0;\n    padding-left: initial;\n  }\n  .nav-tabs > li {\n    float: right;\n  }\n  .nav-tabs > li > a {\n    margin-left: auto;\n    margin-right: -2px;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-pills > li {\n    float: right;\n  }\n  .nav-pills > li > a {\n    border-radius: 4px;\n  }\n  .nav-pills > li + li {\n    margin-right: 2px;\n    margin-left: auto;\n  }\n  .nav-stacked > li {\n    float: none;\n  }\n  .nav-stacked > li + li {\n    margin-right: 0;\n    margin-left: auto;\n  }\n  .nav-justified > .dropdown .dropdown-menu {\n    right: auto;\n  }\n  .nav-tabs-justified > li > a {\n    margin-left: 0;\n    margin-right: auto;\n  }\n  @media (min-width: 768px) {\n    .nav-tabs-justified > li > a {\n      border-radius: 4px 4px 0 0;\n    }\n  }\n  @media (min-width: 768px) {\n    .navbar-header {\n      float: right;\n    }\n  }\n  .navbar-collapse {\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n  .navbar-brand {\n    float: right;\n  }\n  @media (min-width: 768px) {\n    .navbar > .container .navbar-brand,\n    .navbar > .container-fluid .navbar-brand {\n      margin-right: -15px;\n      margin-left: auto;\n    }\n  }\n  .navbar-toggle {\n    float: left;\n    margin-left: 15px;\n    margin-right: auto;\n  }\n  @media (max-width: 767px) {\n    .navbar-nav .open .dropdown-menu > li > a,\n    .navbar-nav .open .dropdown-menu .dropdown-header {\n      padding: 5px 25px 5px 15px;\n    }\n  }\n  @media (min-width: 768px) {\n    .navbar-nav {\n      float: right;\n    }\n    .navbar-nav > li {\n      float: right;\n    }\n  }\n  @media (min-width: 768px) {\n    .navbar-left.flip {\n      float: right !important;\n    }\n    .navbar-right:last-child {\n      margin-left: -15px;\n      margin-right: auto;\n    }\n    .navbar-right.flip {\n      float: left !important;\n      margin-left: -15px;\n      margin-right: auto;\n    }\n    .navbar-right .dropdown-menu {\n      left: 0;\n      right: auto;\n    }\n  }\n  @media (min-width: 768px) {\n    .navbar-text {\n      float: right;\n    }\n    .navbar-text.navbar-right:last-child {\n      margin-left: 0;\n      margin-right: auto;\n    }\n  }\n  .pagination {\n    padding-right: 0;\n  }\n  .pagination > li > a,\n  .pagination > li > span {\n    float: right;\n    margin-right: -1px;\n    margin-left: 0px;\n  }\n  .pagination > li:first-child > a,\n  .pagination > li:first-child > span {\n    margin-left: 0;\n    border-bottom-right-radius: 4px;\n    border-top-right-radius: 4px;\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n  .pagination > li:last-child > a,\n  .pagination > li:last-child > span {\n    margin-right: -1px;\n    border-bottom-left-radius: 4px;\n    border-top-left-radius: 4px;\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .pager {\n    padding-right: 0;\n    padding-left: initial;\n  }\n  .pager .next > a,\n  .pager .next > span {\n    float: left;\n  }\n  .pager .previous > a,\n  .pager .previous > span {\n    float: right;\n  }\n  .nav-pills > li > a > .badge {\n    margin-left: 0px;\n    margin-right: 3px;\n  }\n  .list-group-item > .badge {\n    float: left;\n  }\n  .list-group-item > .badge + .badge {\n    margin-left: 5px;\n    margin-right: auto;\n  }\n  .alert-dismissable,\n  .alert-dismissible {\n    padding-left: 35px;\n    padding-right: 15px;\n  }\n  .alert-dismissable .close,\n  .alert-dismissible .close {\n    right: auto;\n    left: -21px;\n  }\n  .progress-bar {\n    float: right;\n  }\n  .media > .pull-left {\n    margin-right: 10px;\n  }\n  .media > .pull-left.flip {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n  .media > .pull-right {\n    margin-left: 10px;\n  }\n  .media > .pull-right.flip {\n    margin-left: 0;\n    margin-right: 10px;\n  }\n  .media-right,\n  .media > .pull-right {\n    padding-right: 10px;\n    padding-left: initial;\n  }\n  .media-left,\n  .media > .pull-left {\n    padding-left: 10px;\n    padding-right: initial;\n  }\n  .media-list {\n    padding-right: 0;\n    padding-left: initial;\n    list-style: none;\n  }\n  .list-group {\n    padding-right: 0;\n    padding-left: initial;\n  }\n  .panel\n    > .table:first-child\n    > thead:first-child\n    > tr:first-child\n    td:first-child,\n  .panel\n    > .table-responsive:first-child\n    > .table:first-child\n    > thead:first-child\n    > tr:first-child\n    td:first-child,\n  .panel\n    > .table:first-child\n    > tbody:first-child\n    > tr:first-child\n    td:first-child,\n  .panel\n    > .table-responsive:first-child\n    > .table:first-child\n    > tbody:first-child\n    > tr:first-child\n    td:first-child,\n  .panel\n    > .table:first-child\n    > thead:first-child\n    > tr:first-child\n    th:first-child,\n  .panel\n    > .table-responsive:first-child\n    > .table:first-child\n    > thead:first-child\n    > tr:first-child\n    th:first-child,\n  .panel\n    > .table:first-child\n    > tbody:first-child\n    > tr:first-child\n    th:first-child,\n  .panel\n    > .table-responsive:first-child\n    > .table:first-child\n    > tbody:first-child\n    > tr:first-child\n    th:first-child {\n    border-top-right-radius: 3px;\n    border-top-left-radius: 0;\n  }\n  .panel\n    > .table:first-child\n    > thead:first-child\n    > tr:first-child\n    td:last-child,\n  .panel\n    > .table-responsive:first-child\n    > .table:first-child\n    > thead:first-child\n    > tr:first-child\n    td:last-child,\n  .panel\n    > .table:first-child\n    > tbody:first-child\n    > tr:first-child\n    td:last-child,\n  .panel\n    > .table-responsive:first-child\n    > .table:first-child\n    > tbody:first-child\n    > tr:first-child\n    td:last-child,\n  .panel\n    > .table:first-child\n    > thead:first-child\n    > tr:first-child\n    th:last-child,\n  .panel\n    > .table-responsive:first-child\n    > .table:first-child\n    > thead:first-child\n    > tr:first-child\n    th:last-child,\n  .panel\n    > .table:first-child\n    > tbody:first-child\n    > tr:first-child\n    th:last-child,\n  .panel\n    > .table-responsive:first-child\n    > .table:first-child\n    > tbody:first-child\n    > tr:first-child\n    th:last-child {\n    border-top-left-radius: 3px;\n    border-top-right-radius: 0;\n  }\n  .panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n  .panel\n    > .table-responsive:last-child\n    > .table:last-child\n    > tbody:last-child\n    > tr:last-child\n    td:first-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n  .panel\n    > .table-responsive:last-child\n    > .table:last-child\n    > tfoot:last-child\n    > tr:last-child\n    td:first-child,\n  .panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n  .panel\n    > .table-responsive:last-child\n    > .table:last-child\n    > tbody:last-child\n    > tr:last-child\n    th:first-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n  .panel\n    > .table-responsive:last-child\n    > .table:last-child\n    > tfoot:last-child\n    > tr:last-child\n    th:first-child {\n    border-bottom-left-radius: 3px;\n    border-top-right-radius: 0;\n  }\n  .panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n  .panel\n    > .table-responsive:last-child\n    > .table:last-child\n    > tbody:last-child\n    > tr:last-child\n    td:last-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n  .panel\n    > .table-responsive:last-child\n    > .table:last-child\n    > tfoot:last-child\n    > tr:last-child\n    td:last-child,\n  .panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n  .panel\n    > .table-responsive:last-child\n    > .table:last-child\n    > tbody:last-child\n    > tr:last-child\n    th:last-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n  .panel\n    > .table-responsive:last-child\n    > .table:last-child\n    > tfoot:last-child\n    > tr:last-child\n    th:last-child {\n    border-bottom-right-radius: 3px;\n    border-top-left-radius: 0;\n  }\n  .panel > .table-bordered > thead > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\n  .panel > .table-bordered > tbody > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n  .panel > .table-bordered > tfoot > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n  .panel > .table-bordered > thead > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\n  .panel > .table-bordered > tbody > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n  .panel > .table-bordered > tfoot > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n    border-right: 0;\n    border-left: none;\n  }\n  .panel > .table-bordered > thead > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\n  .panel > .table-bordered > tbody > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n  .panel > .table-bordered > tfoot > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n  .panel > .table-bordered > thead > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\n  .panel > .table-bordered > tbody > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n  .panel > .table-bordered > tfoot > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n    border-right: none;\n    border-left: 0;\n  }\n  .embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object {\n    right: 0;\n    left: auto;\n  }\n  .close {\n    float: left;\n  }\n  .modal-footer {\n    text-align: left;\n  }\n  .modal-footer.flip {\n    text-align: right;\n  }\n  .modal-footer .btn + .btn {\n    margin-left: auto;\n    margin-right: 5px;\n  }\n  .modal-footer .btn-group .btn + .btn {\n    margin-right: -1px;\n    margin-left: auto;\n  }\n  .modal-footer .btn-block + .btn-block {\n    margin-right: 0;\n    margin-left: auto;\n  }\n  .popover {\n    left: auto;\n    text-align: right;\n  }\n  .popover.top > .arrow {\n    right: 50%;\n    left: auto;\n    margin-right: -11px;\n    margin-left: auto;\n  }\n  .popover.top > .arrow:after {\n    margin-right: -10px;\n    margin-left: auto;\n  }\n  .popover.bottom > .arrow {\n    right: 50%;\n    left: auto;\n    margin-right: -11px;\n    margin-left: auto;\n  }\n  .popover.bottom > .arrow:after {\n    margin-right: -10px;\n    margin-left: auto;\n  }\n  .carousel-control {\n    right: 0;\n    bottom: 0;\n  }\n  .carousel-control.left {\n    right: auto;\n    left: 0;\n    background-image: -webkit-linear-gradient(\n      left,\n      color-stop(rgba(0, 0, 0, 0.5) 0%),\n      color-stop(rgba(0, 0, 0, 0.0001) 100%)\n    );\n    background-image: -o-linear-gradient(\n      left,\n      rgba(0, 0, 0, 0.5) 0%,\n      rgba(0, 0, 0, 0.0001) 100%\n    );\n    background-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 0.5) 0%,\n      rgba(0, 0, 0, 0.0001) 100%\n    );\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(\n        startColorstr=\"#80000000\",\n        endColorstr=\"#00000000\",\n        GradientType=1\n      );\n  }\n  .carousel-control.right {\n    left: auto;\n    right: 0;\n    background-image: -webkit-linear-gradient(\n      left,\n      color-stop(rgba(0, 0, 0, 0.0001) 0%),\n      color-stop(rgba(0, 0, 0, 0.5) 100%)\n    );\n    background-image: -o-linear-gradient(\n      left,\n      rgba(0, 0, 0, 0.0001) 0%,\n      rgba(0, 0, 0, 0.5) 100%\n    );\n    background-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 0.0001) 0%,\n      rgba(0, 0, 0, 0.5) 100%\n    );\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(\n        startColorstr=\"#00000000\",\n        endColorstr=\"#80000000\",\n        GradientType=1\n      );\n  }\n  .carousel-control .icon-prev,\n  .carousel-control .glyphicon-chevron-left {\n    left: 50%;\n    right: auto;\n    margin-right: -10px;\n  }\n  .carousel-control .icon-next,\n  .carousel-control .glyphicon-chevron-right {\n    right: 50%;\n    left: auto;\n    margin-left: -10px;\n  }\n  .carousel-indicators {\n    right: 50%;\n    left: 0;\n    margin-right: -30%;\n    margin-left: 0;\n    padding-left: 0;\n  }\n  @media screen and (min-width: 768px) {\n    .carousel-control .glyphicon-chevron-left,\n    .carousel-control .icon-prev {\n      margin-left: 0;\n      margin-right: -15px;\n    }\n    .carousel-control .glyphicon-chevron-right,\n    .carousel-control .icon-next {\n      margin-left: 0;\n      margin-right: -15px;\n    }\n    .carousel-caption {\n      left: 20%;\n      right: 20%;\n      padding-bottom: 30px;\n    }\n  }\n  .pull-right.flip {\n    float: left !important;\n  }\n  .pull-left.flip {\n    float: right !important;\n  }\n  /*# sourceMappingURL=bootstrap-rtl.css.map */\n}\n",".btn {\n  & + .btn {\n    margin-left: 4px;\n  }\n}\n.btn-group + .btn-group {\n  margin-left: 4px;\n}\n",".card-tasks .card-header .title {\n  margin-right: 24px;\n}\n",".form-check.form-check-inline + .form-check.form-check-inline {\n  margin-left: 4px;\n}\n",".custom-switch {\n  .custom-control-label {\n    margin-bottom: 0px;\n    line-height: 22px;\n    vertical-align: middle;\n    &::before {\n      height: 22px;\n      width: 45px;\n      border: none;\n      background-image: url(\"../../../img/darken-night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png\");\n      background-position: center center;\n      background-size: cover;\n    }\n    &::after {\n      height: 18px;\n      width: 18px;\n      background-color: rgba(156, 156, 156, 0.9);\n      transition: all 0.25s ease-out;\n    }\n  }\n  .custom-control-input:checked {\n    ~ .custom-control-label::before {\n      background-image: url(\"../../../img/night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png\");\n    }\n    ~ .custom-control-label::after {\n      background-color: $white;\n      transform: translateX(23px);\n    }\n  }\n  &:hover {\n    .custom-control-label::after {\n      width: 23px;\n    }\n    .custom-control-input:checked ~ .custom-control-label::after {\n      margin-left: -5px;\n    }\n  }\n}\n",".dropdown-menu .dropdown-header:not([href]) {\n  color: hsla(0, 0%, 71%, 0.6);\n  font-size: 0.62475rem;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n",".fileinput > input[type=\"file\"] {\n  display: none;\n}\n",".fixed-plugin {\n  li.adjustments-line {\n    height: auto;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    .togglebutton {\n      .label-switch:last-child {\n        left: unset;\n        right: -10px;\n      }\n    }\n  }\n  li.header-title {\n    height: auto;\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n  li.button-container {\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n}\n",".footer {\n  .footer-nav {\n    ul {\n      li + li {\n        margin-left: 4px;\n      }\n    }\n  }\n}\n","*,\n.login-page,\n.card-login.card-white {\n  textarea.form-control {\n    border: 1px solid lighten($black, 5%);\n    border-radius: $border-radius-lg;\n    &:focus,\n    &:active {\n      border: 1px solid lighten($primary, 5%);\n    }\n  }\n  .form-group:not(.has-danger):not(.has-success),\n  .input-group-focus:not(.has-danger):not(.has-success) {\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      border-color: $info;\n    }\n    .form-control {\n      &:focus {\n        border-color: $info;\n        & + .input-group-append .input-group-text,\n        & ~ .input-group-append .input-group-text,\n        & + .input-group-prepend .input-group-text,\n        & ~ .input-group-prepend .input-group-text {\n          border: 1px solid $info;\n        }\n      }\n    }\n  }\n  .input-group-focus:not(.has-danger):not(.has-success) {\n    .form-control {\n      border-color: $info;\n      & + .input-group-append .input-group-text,\n      & ~ .input-group-append .input-group-text,\n      & + .input-group-prepend .input-group-text,\n      & ~ .input-group-prepend .input-group-text {\n        border: 1px solid $info;\n      }\n    }\n  }\n}\n.sweet-alert input.form-control:focus {\n  border-color: $info;\n  & + .input-group-append .input-group-text,\n  & ~ .input-group-append .input-group-text,\n  & + .input-group-prepend .input-group-text,\n  & ~ .input-group-prepend .input-group-text {\n    border: 1px solid $info;\n  }\n}\n.form-group .input-group-append .input-group-text,\n.input-group .input-group-append .input-group-text {\n  padding: 10px 18px 10px 0;\n}\n.input-group-text {\n  line-height: 1;\n}\n.form-control + .input-group-append .input-group-text,\n.form-control + .input-group-prepend .input-group-text {\n  background-color: transparent;\n}\n.input-group-append,\n.input-group-prepend {\n  border: 0;\n}\n.input-group-append:last-child {\n  .input-group-text {\n    border-left: 0 !important;\n  }\n}\n.input-group .form-control:not(:first-child):not(:last-child),\n.input-group-btn:not(:first-child):not(:last-child) {\n  border-right: none;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n",".modal {\n  &.fade .modal-dialog {\n    animation-duration: unset;\n    animation-fill-mode: unset;\n    animation-name: unset;\n  }\n  &.show.modal-long .modal-dialog {\n    transform: translateY(10%);\n  }\n}\n.modal-content .modal-body+.modal-footer{\n  padding: 24px 24px 16px;\n}\n","@include media-breakpoint-down(md) {\n  .navbar .dropdown.show .dropdown-menu {\n    position: static !important;\n  }\n  .navbar:not(.bg-white) {\n    .dropdown.show .dropdown-menu .dropdown-item {\n      color: $opacity-8;\n    }\n    .navbar-nav .btn span {\n      color: $opacity-8 !important;\n    }\n  }\n  nav.navbar {\n    top: 0px;\n  }\n}\n@include media-breakpoint-down(sm) {\n  .navbar .navbar-wrapper {\n    .navbar-toggle {\n      transition: all 1s;\n    }\n  }\n  .navbar .navbar-wrapper {\n    .navbar-toggle.toggled {\n      left: -20px;\n      position: relative;\n      right: unset;\n      transition: all 1s;\n    }\n  }\n  .rtl {\n    .navbar .navbar-wrapper {\n      .navbar-toggle.toggled {\n        right: -35px;\n        position: relative;\n        left: unset;\n        transition: all 1s;\n      }\n    }\n  }\n}\n.nav-link:hover {\n  color: $info;\n}\n",".rtl {\n  .sidebar .nav li.active > a[data-toggle=\"collapse\"]:before,\n  .sidebar\n    .nav\n    li.active\n    > a[data-toggle=\"collapse\"]\n    + div\n    .nav\n    .active\n    a:before {\n    right: -4px;\n    left: auto;\n  }\n  .sidebar .logo a.logo-mini {\n    margin-right: 15px;\n    margin-left: 15px;\n  }\n  .fixed-plugin {\n    border-radius: 0 8px 8px 0;\n    left: 0;\n    right: unset;\n    .dropdown-menu {\n      left: 80px !important;\n      right: auto !important;\n      &:before,\n      &:after {\n        left: 10px;\n        margin-right: auto;\n        right: auto;\n      }\n      &:before {\n        right: unset;\n        left: -16px;\n        border-left: unset;\n        border-right: 0.4em solid rgba(0, 0, 0, 0.2);\n      }\n      &:after {\n        right: unset;\n        left: -16px;\n        border-left: unset;\n        border-right: 0.4em solid $black;\n      }\n    }\n  }\n  .card-tasks .card-header .title {\n    margin-right: 0;\n    margin-left: 24px;\n  }\n  .main-panel {\n    overflow-y: scroll; /* has to be scroll, not auto */\n    -webkit-overflow-scrolling: touch;\n  }\n}\n",".sidebar .logo .logo-mini .logo-img img {\n  border-radius: 50%;\n  width: 30px;\n}\n.perfect-scrollbar-on {\n  .sidebar {\n    height: 84%;\n  }\n}\n@include media-breakpoint-down(sm) {\n  .sidebar {\n    height: 100%;\n  }\n}\n@include media-breakpoint-down(md) {\n  .perfect-scrollbar-on {\n    .sidebar {\n      height: 100%;\n    }\n  }\n  html.nav-open body {\n    position: relative;\n    overflow-x: hidden;\n  }\n  html.nav-open .main-panel {\n    overflow: auto;\n    min-height: unset;\n  }\n  html.nav-open .wrapper {\n    overflow: hidden;\n  }\n}\n\n.sidebar .nav li.active > a[data-toggle=\"collapse\"] + div .nav li:not(.active) a{\n  .sidebar-normal {\n    color: rgba($white,0.8);\n  }\n  &::before {\n    display: none;\n  }\n}\n","$spinner-width: 2rem !default;\n$spinner-height: $spinner-width !default;\n$spinner-border-width: 0.25em !default;\n\n$spinner-width-sm: 1rem !default;\n$spinner-height-sm: $spinner-width-sm !default;\n$spinner-border-width-sm: 0.2em !default;\n\n//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 50%;\n  animation: spinner-border 0.75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow 0.75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n",".white-content {\n  .ReactTable .-pagination input,\n  .ReactTable .-pagination select,\n  .ReactTable .rt-thead.-filters input,\n  .ReactTable .rt-thead.-filters select {\n    color: $black;\n  }\n  .ReactTable .rt-td,\n  .ReactTable .rt-thead .rt-th {\n    color: rgba(34, 42, 66, 0.7) !important;\n  }\n  .ReactTable .rt-tbody .rt-tr,\n  .ReactTable .rt-thead.-filters .rt-tr {\n    border-color: rgba(34, 42, 66, 0.2);\n  }\n  .ReactTable.-striped .rt-tr.-odd {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n  .rbc-today {\n    background: darken($light-bg, 10%);\n  }\n  .rbc-day-bg + .rbc-day-bg,\n  .rbc-month-row,\n  .rbc-time-content > * + * > *,\n  .rbc-timeslot-group,\n  .rbc-row.rbc-time-header-cell,\n  .rbc-time-header-content,\n  .rbc-day-slot .rbc-time-slot + .rbc-time-slot,\n  .rbc-agenda-view table.rbc-agenda-table,\n  .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td,\n  .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr,\n  .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n    border-color: #9499a7;\n  }\n  .rbc-agenda-time-cell,\n  .rbc-agenda-date-cell,\n  .rbc-date-cell > a,\n  .rbc-date-cell > a:active,\n  .rbc-date-cell > a:visited,\n  .rbc-agenda-event-cell {\n    color: $black;\n  }\n  .rbc-toolbar .rbc-toolbar-label {\n    color: $black-states;\n  }\n  .rbc-header,\n  .rbc-header > a,\n  .rbc-header > a:active,\n  .rbc-header > a:visited,\n  .rbc-header > a:hover,\n  .rbc-time-gutter.rbc-time-column {\n    color: $default;\n  }\n  .card {\n    .map-title {\n      color: $black-states;\n    }\n  }\n  .nav-pills .nav-item .nav-link:not(.active) {\n    background: #d3d7e9;\n    color: #1d253b;\n  }\n  .form-group:not(.has-danger):not(.has-success),\n  .input-group-focus:not(.has-danger):not(.has-success) {\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      border-color: $info;\n    }\n    .form-control {\n      &:focus {\n        border-color: $info;\n        & + .input-group-append .input-group-text,\n        & ~ .input-group-append .input-group-text,\n        & + .input-group-prepend .input-group-text,\n        & ~ .input-group-prepend .input-group-text {\n          border: 1px solid $info;\n        }\n      }\n    }\n  }\n  .form-group.has-danger,\n  .input-group-focus.has-danger {\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      border-color: $danger;\n    }\n    .form-control {\n      &:focus {\n        border-color: $danger;\n        & + .input-group-append .input-group-text,\n        & ~ .input-group-append .input-group-text,\n        & + .input-group-prepend .input-group-text,\n        & ~ .input-group-prepend .input-group-text {\n          border: 1px solid $danger;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
